import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from 'react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(client: GraphQLClient, query: string, variables?: TVariables, headers?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers);
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type ActiveProductIds = {
  __typename?: 'ActiveProductIds';
  activeProducts: Array<Scalars['String']>;
  completedEvalIds: Array<Scalars['String']>;
  pendingEvalIds: Array<Scalars['String']>;
  skippedEvalIds: Array<Scalars['String']>;
};

export type AcuityAppointmentDto = {
  __typename?: 'AcuityAppointmentDto';
  appointmentTypeID?: Maybe<Scalars['Float']>;
  bookedAt?: Maybe<Scalars['DateTime']>;
  calendar?: Maybe<Scalars['String']>;
  calendarID?: Maybe<Scalars['Float']>;
  calendarJP?: Maybe<Scalars['String']>;
  canceled?: Maybe<Scalars['Boolean']>;
  confirmationPage?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  datetime?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorDto>;
  duration?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  isFollowUpConsult?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  noShow?: Maybe<Scalars['Boolean']>;
  orders?: Maybe<Array<Maybe<OrderDto>>>;
  phone?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AcuityAppointmentFilterInput = {
  appointmentTypeID?: InputMaybe<Scalars['String']>;
  patientSysId?: InputMaybe<Scalars['String']>;
};

export type AcuityAppointmentModel = {
  __typename?: 'AcuityAppointmentModel';
  appointmentTypeID?: Maybe<Scalars['Float']>;
  calendar?: Maybe<Scalars['String']>;
  calendarID?: Maybe<Scalars['Float']>;
  calendarJP?: Maybe<Scalars['String']>;
  canceled?: Maybe<Scalars['Boolean']>;
  confirmationPage?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  datetime?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<Scalars['JSON']>;
  duration?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  isFollowUpConsult?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  noShow?: Maybe<Scalars['Boolean']>;
  orders?: Maybe<Array<Maybe<OrderModel>>>;
  phone?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AddCashbackReturnModel = {
  __typename?: 'AddCashbackReturnModel';
  errorCustomers?: Maybe<Array<Maybe<Scalars['String']>>>;
  notFoundCustomers?: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Scalars['Boolean'];
};

export type AddCashbackToCustomerInput = {
  addingAmount: Scalars['Float'];
  currency: StripeCurrency;
  customerEmails: Array<Scalars['String']>;
};

export type AddCashbackToCustomersInput = {
  currency: StripeCurrency;
  customers: Array<CustomerInput>;
};

export type AddressDto = {
  __typename?: 'AddressDto';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<RegionType>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  region?: Maybe<LocalRegionType>;
  sameAsBilling?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  type?: Maybe<AddressType>;
  unit?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<RegionType>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postal?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<LocalRegionType>;
  sameAsBilling?: InputMaybe<Scalars['Boolean']>;
  shouldSave?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AddressType>;
  unit?: InputMaybe<Scalars['String']>;
};

export type AddressModel = {
  __typename?: 'AddressModel';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<RegionType>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  region?: Maybe<LocalRegionType>;
  sameAsBilling?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  type?: Maybe<AddressType>;
  unit?: Maybe<Scalars['String']>;
};

export enum AddressType {
  Billing = 'Billing',
  Delivery = 'Delivery'
}

export type AdminAffiliateCoupon = {
  __typename?: 'AdminAffiliateCoupon';
  affiliate?: Maybe<Affiliate>;
  affiliateProduct?: Maybe<AffiliateProduct>;
  affiliateProductSysId: Scalars['String'];
  affiliateSysId: Scalars['String'];
  /** Amount Stripe collected for the purchase, in the smallest unit of amountCollectedCurrency (yen for JPY). Null when unknown. */
  amountCollected?: Maybe<Scalars['Int']>;
  /** Stripe currency code of amountCollected, e.g. jpy. */
  amountCollectedCurrency?: Maybe<Scalars['String']>;
  anonymousId: Scalars['String'];
  /** True once a doctor approved the bound order (approve_at set), evaluated in SQL; stays true if the order is later cancelled. False for an unbound coupon. */
  converted: Scalars['Boolean'];
  couponId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customerEmail?: Maybe<Scalars['String']>;
  customerUserId?: Maybe<Scalars['String']>;
  /** status_transitions.paid_at of the order's purchase invoice in Stripe (¥0 invoices included). Null when Stripe has no paid purchase invoice or the lookup failed. */
  invoiceSettledAt?: Maybe<Scalars['DateTime']>;
  opsNote?: Maybe<Scalars['String']>;
  /** Order # (order.short_id), the number CS uses. */
  orderShortId?: Maybe<Scalars['Int']>;
  orderStatus?: Maybe<OrderStatus>;
  orderSysId?: Maybe<Scalars['String']>;
  status: AffiliateCouponStatus;
  /** Stripe customer id (cus_…) of the order's patient. */
  stripeCustomerId?: Maybe<Scalars['String']>;
  sysId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedByUserSysId?: Maybe<Scalars['String']>;
};

export type AdminDto = {
  __typename?: 'AdminDto';
  crossSellRecords?: Maybe<Array<CrossSellOrderLinkDto>>;
  order?: Maybe<OrderDto>;
  orders?: Maybe<PaginatedOrders>;
  patient?: Maybe<PatientDto>;
};


export type AdminDtoCrossSellRecordsArgs = {
  input?: InputMaybe<CrossSellRecordQueryInput>;
};


export type AdminDtoOrderArgs = {
  orderId?: InputMaybe<Scalars['String']>;
};


export type AdminDtoOrdersArgs = {
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
};


export type AdminDtoPatientArgs = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type Affiliate = {
  __typename?: 'Affiliate';
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  formFieldMap?: Maybe<Scalars['JSON']>;
  formSubmitUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationChannel: AffiliateNotificationChannel;
  notificationEmail?: Maybe<Scalars['String']>;
  portalUrl: Scalars['String'];
  region: RegionType;
  slug: Scalars['String'];
  sysId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type AffiliateCoupon = {
  __typename?: 'AffiliateCoupon';
  affiliate?: Maybe<PublicAffiliate>;
  affiliateProduct?: Maybe<AffiliateProduct>;
  affiliateProductSysId: Scalars['String'];
  affiliateSysId: Scalars['String'];
  anonymousId: Scalars['String'];
  couponId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  opsNote?: Maybe<Scalars['String']>;
  orderSysId?: Maybe<Scalars['String']>;
  status: AffiliateCouponStatus;
  sysId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedByUserSysId?: Maybe<Scalars['String']>;
};

export type AffiliateCouponNotAppliedDto = {
  __typename?: 'AffiliateCouponNotAppliedDto';
  affiliateProductDisplayName: Scalars['String'];
  reason: Scalars['String'];
};

export type AffiliateCouponOpsStats = {
  __typename?: 'AffiliateCouponOpsStats';
  monthOrders: Scalars['Int'];
  monthSubmissions: Scalars['Int'];
  weekOrders: Scalars['Int'];
  weekSubmissions: Scalars['Int'];
};

export enum AffiliateCouponStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Verified = 'Verified'
}

export type AffiliateCouponsForOpsFilterInput = {
  affiliateSysId?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AffiliateCouponStatus>;
};

export type AffiliateEligibleStripeProduct = {
  __typename?: 'AffiliateEligibleStripeProduct';
  /** Stripe product display name — pre-fills the affiliate-product slug + displayName on the ops form. */
  name?: Maybe<Scalars['String']>;
  /** Active prices under this product. */
  prices: Array<AffiliateStripePrice>;
  /** Stripe product id (prod_…). */
  stripeProductId: Scalars['String'];
};

export type AffiliateFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<RegionType>;
};

export type AffiliateGoogleFormField = {
  __typename?: 'AffiliateGoogleFormField';
  /** The `entry.<NNN>` token to POST this field against. */
  entryId: Scalars['String'];
  /** Human-readable question label from the form. */
  label: Scalars['String'];
};

export type AffiliateGoogleFormParseResult = {
  __typename?: 'AffiliateGoogleFormParseResult';
  /** All parsed form fields (entry id + label). */
  fields: Array<AffiliateGoogleFormField>;
  /**
   * Best-effort auto-mapping of known payload keys → { entryToken, source } by
   * label heuristic (Round-9 Item 3). Ops can override.
   */
  suggestedMap: Scalars['JSON'];
};

export enum AffiliateNotificationChannel {
  Email = 'Email',
  GoogleForm = 'GoogleForm'
}

export type AffiliateProduct = {
  __typename?: 'AffiliateProduct';
  affiliate?: Maybe<PublicAffiliate>;
  affiliateSysId: Scalars['String'];
  /**
   * Full per-affiliate patient coupon landing link
   * (<patientBase>/coupon/<affiliateSlug>/<stripePriceId>), resolved at query
   * time. Ops copies this for the affiliate.
   */
  couponLandingUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /**
   * Percentage discount (1–100), minted as the Stripe coupon's percent_off. After
   * an updateAffiliateProduct change this LOCAL value may diverge from the
   * percentage actually applied at checkout (Stripe percent_off is immutable). The
   * re-mint flow is a future iteration.
   */
  discountPercentage: Scalars['Int'];
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  /** Eval-flow identifier resolved from Stripe product metadata (Stripe-side source of truth). */
  evalFlow?: Maybe<Scalars['String']>;
  /** Affiliate's per-product external portal / deal link (e.g. kumapon.jp/deals/…), supplied asynchronously and editable. */
  externalPortalUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  stripePriceId: Scalars['String'];
  stripeProductId: Scalars['String'];
  /** Human-readable Stripe promotion code string (the code a patient enters), resolved from Stripe at query time. */
  stripePromotionCode?: Maybe<Scalars['String']>;
  stripePromotionCodeId: Scalars['String'];
  sysId: Scalars['String'];
  /**
   * The pinned Stripe price's original unit amount (cents; whole yen for JPY),
   * resolved at query time. Ops computes after-discount from this +
   * discountPercentage.
   */
  unitAmount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type AffiliateStripePrice = {
  __typename?: 'AffiliateStripePrice';
  /** Recurring billing interval (month/year/…); null for one-time prices. */
  interval?: Maybe<Scalars['String']>;
  /** Stripe price nickname / plan label. */
  nickname?: Maybe<Scalars['String']>;
  /** Stripe price id (price_…) — the canonical lookup key an affiliate landing URL pins. */
  stripePriceId: Scalars['String'];
  /** Stripe price type (recurring / one_time). */
  type?: Maybe<Scalars['String']>;
  /** Price in the Stripe minor unit (cents; whole yen for JPY). The FE formats per region. */
  unitAmount?: Maybe<Scalars['Int']>;
};

export type AfterVideoConsultRedirectingDto = {
  __typename?: 'AfterVideoConsultRedirectingDto';
  baseUrl?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type AnswerDto = {
  __typename?: 'AnswerDto';
  childrenAnswers?: Maybe<Array<Maybe<AnswerDto>>>;
  deselectAll?: Maybe<Scalars['Boolean']>;
  mandatory?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Float']>;
  placeholder?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  textKey?: Maybe<Scalars['String']>;
  type?: Maybe<QuestionType>;
};

export type AnswerModel = {
  __typename?: 'AnswerModel';
  childrenAnswers?: Maybe<Array<Maybe<AnswerModel>>>;
  deselectAll: Scalars['Boolean'];
  mandatory?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  parentAnswer?: Maybe<AnswerModel>;
  placeholder?: Maybe<Scalars['String']>;
  productUrl?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  textKey: Scalars['String'];
  type?: Maybe<QuestionType>;
};

export type AppSettingsDto = {
  __typename?: 'AppSettingsDto';
  stripeCurrencyRatio?: Maybe<Scalars['Float']>;
  systemPromotion?: Maybe<SystemPromotionDto>;
};

export type AppleLoginInput = {
  authorizationCode: Scalars['String'];
  identityToken?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<PatientName>;
  platform?: InputMaybe<PlatformType>;
};

export type ApplyPromotionCodeForAnonymousInput = {
  code: Scalars['String'];
  item?: InputMaybe<Scalars['JSON']>;
  platform?: InputMaybe<PlatformType>;
};

export type ApplyPromotionCodeForCartInput = {
  cart?: InputMaybe<Scalars['JSON']>;
  code: Scalars['String'];
  platform?: InputMaybe<PlatformType>;
  previousCode?: InputMaybe<Scalars['String']>;
};

export type ApplyPromotionFromBannerInput = {
  cart: Scalars['JSON'];
  code: Scalars['String'];
  isInserting: Scalars['Boolean'];
  item: Scalars['JSON'];
};

export type ApprovePrescriptionOrderInput = {
  endTime?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  prescriptionDays: Scalars['Float'];
  prices: Array<ApprovePrescriptionPricesInput>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type ApprovePrescriptionPricesInput = {
  chargePatient?: InputMaybe<Scalars['Boolean']>;
  priceId: Scalars['String'];
};

export type ApproverModel = {
  __typename?: 'ApproverModel';
  name?: Maybe<Scalars['String']>;
  role: UserRole;
};

export type ArchivePriceInput = {
  active: Scalars['Boolean'];
  priceId: Scalars['String'];
};

export type ArchiveProductInput = {
  active: Scalars['Boolean'];
  productId: Scalars['String'];
};

export type AtomePaymentDto = {
  __typename?: 'AtomePaymentDto';
  amount?: Maybe<Scalars['Float']>;
  paymentUrl?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  status?: Maybe<AtomePaymentStatus>;
  summary?: Maybe<PrescriptionOrderCalculationDto>;
  sysId?: Maybe<Scalars['String']>;
};

export enum AtomePaymentStatus {
  Cancelled = 'cancelled',
  Failed = 'failed',
  Paid = 'paid',
  Processing = 'processing',
  Refunded = 'refunded'
}

export type AttachPaymentIntentInput = {
  amount: Scalars['Float'];
  cartId?: InputMaybe<Scalars['String']>;
  hasFutureUsage?: InputMaybe<Scalars['Boolean']>;
  paymentIntentSummary?: InputMaybe<Scalars['JSON']>;
  priceId?: InputMaybe<Scalars['String']>;
  promotionCode?: InputMaybe<Scalars['String']>;
};

export type AttachPaymentMethodWithIntentForAnonymousInput = {
  amount: Scalars['Float'];
  anonymousId?: InputMaybe<Scalars['String']>;
  cart?: InputMaybe<Scalars['JSON']>;
  paymentIntentSummary?: InputMaybe<Scalars['JSON']>;
  promotionCode?: InputMaybe<Scalars['String']>;
  stripeCustomerId: Scalars['String'];
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type AuditDoctorNoteInput = {
  doctor?: InputMaybe<Scalars['JSON']>;
  note?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type AuditDoctorNoteModel = {
  __typename?: 'AuditDoctorNoteModel';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedBy?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  order?: Maybe<OrderModel>;
  sysId?: Maybe<Scalars['String']>;
};

export type AuditHistoryDto = {
  __typename?: 'AuditHistoryDto';
  action?: Maybe<AuditingAction>;
  changeLog?: Maybe<Array<Maybe<AuditInfoDto>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  schemaType?: Maybe<AuditingSchema>;
  sysId?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type AuditHistoryPagingDto = {
  __typename?: 'AuditHistoryPagingDto';
  count?: Maybe<Scalars['Float']>;
  items?: Maybe<Array<Maybe<AuditHistoryDto>>>;
};

export type AuditInfoDto = {
  __typename?: 'AuditInfoDto';
  columnName?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['JSON']>;
  oldValue?: Maybe<Scalars['JSON']>;
};

export enum AuditingAction {
  Create = 'Create',
  Delete = 'Delete',
  Update = 'Update'
}

export enum AuditingSchema {
  AuditDoctorNote = 'AuditDoctorNote',
  Order = 'Order',
  Patient = 'Patient'
}

export type AvailableOrderOfPatientInput = {
  orderId: Scalars['String'];
  patientId: Scalars['String'];
  productId: Scalars['String'];
};

export type AvailableOrdersOfPatientInputs = {
  items: Array<AvailableOrderOfPatientInput>;
};

export type AvailableSlotModel = {
  __typename?: 'AvailableSlotModel';
  date?: Maybe<Scalars['String']>;
  times?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AvailableSlotsForDeliveryInput = {
  country?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['Float']>;
};

export type AvailableSlotsInput = {
  appointmentTypeId: Scalars['String'];
  calendarId?: InputMaybe<Scalars['Float']>;
  fromDate: Scalars['String'];
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['JSON']>;
};

export type BalanceTransactionDto = {
  __typename?: 'BalanceTransactionDto';
  amount?: Maybe<Scalars['Float']>;
  cashbackType?: Maybe<CashbackType>;
  created?: Maybe<Scalars['Float']>;
  credit_note?: Maybe<Scalars['JSON']>;
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  ending_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<Scalars['JSON']>;
  livemode?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSON']>;
  object?: Maybe<Scalars['String']>;
  savingsToDate?: Maybe<Scalars['Float']>;
  type?: Maybe<CustomerBalanceTransactionType>;
};

export type BalanceTransactionModel = {
  __typename?: 'BalanceTransactionModel';
  amount?: Maybe<Scalars['Float']>;
  cashbackType?: Maybe<CashbackType>;
  created?: Maybe<Scalars['Float']>;
  credit_note?: Maybe<Scalars['JSON']>;
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  ending_balance?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  invoice?: Maybe<Scalars['JSON']>;
  livemode?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSON']>;
  object?: Maybe<Scalars['String']>;
  savingsToDate?: Maybe<Scalars['Float']>;
  type?: Maybe<CustomerBalanceTransactionType>;
};

export type BillingAddressInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: RegionType;
  name: Scalars['String'];
  postal: Scalars['String'];
  region: LocalRegionType;
  state: Scalars['String'];
  unit: Scalars['String'];
};

export type BloodDrawConfirmationDto = {
  __typename?: 'BloodDrawConfirmationDto';
  confirmedAt?: Maybe<Scalars['DateTime']>;
  drawType: TrtDrawType;
  orderSysId: Scalars['String'];
  sysId: Scalars['String'];
};

export type BookAppointmentAndDeliveryInput = {
  bookingSlot?: InputMaybe<Scalars['String']>;
  cartId?: InputMaybe<Scalars['String']>;
  deliverySlot?: InputMaybe<Scalars['String']>;
  doctorSysId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
};

export type BookAppointmentAndDeliveryModel = {
  __typename?: 'BookAppointmentAndDeliveryModel';
  checkoutCartId?: Maybe<Scalars['String']>;
  consultationSession?: Maybe<ConsultationSessionModel>;
  isFertilityCoach: Scalars['Boolean'];
  order?: Maybe<OrderModel>;
  success: Scalars['Boolean'];
};

export type BookHumansaConsultation = {
  consultTime: Scalars['String'];
  email: Scalars['String'];
};

export type BookPrescriptionReviewAppointmentInput = {
  consultTime: Scalars['String'];
  consultationId: Scalars['String'];
};

export type BookingListModel = {
  __typename?: 'BookingListModel';
  data?: Maybe<Array<Maybe<BookingModel>>>;
};

export type BookingModel = {
  __typename?: 'BookingModel';
  date?: Maybe<Scalars['String']>;
  times?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BookingResultInput = {
  cartId: Scalars['String'];
};

export type BookingResultModel = {
  __typename?: 'BookingResultModel';
  bookedOrders: Array<OrderModel>;
  cart: CheckoutCartModel;
  needsBookingOrderIds: Array<Scalars['String']>;
};

export type CalculateOrderInput = {
  cartItems: Scalars['JSON'];
  platform?: InputMaybe<PlatformType>;
  promotionCode?: InputMaybe<Scalars['JSON']>;
};

export type CalculateOrderSummaryInput = {
  cashbackEarnRate?: InputMaybe<Scalars['Int']>;
  cashbackEarned?: InputMaybe<Scalars['Int']>;
  cashbackRedeemed?: InputMaybe<Scalars['Int']>;
  discountAmountLater?: InputMaybe<Scalars['Int']>;
  discountAmountNow?: InputMaybe<Scalars['Int']>;
  itemList?: InputMaybe<Array<PaymentItemInfoInput>>;
  minimalAmountPayment?: InputMaybe<Scalars['Int']>;
  paymentIntentAmount?: InputMaybe<Scalars['Int']>;
  paymentIntentSummary?: InputMaybe<Scalars['JSON']>;
  promotionCode?: InputMaybe<Scalars['String']>;
  shippingFee?: InputMaybe<Scalars['Int']>;
  subTotal?: InputMaybe<Scalars['Int']>;
  subTotalLater?: InputMaybe<Scalars['Int']>;
  subTotalNow?: InputMaybe<Scalars['Int']>;
  taxes?: InputMaybe<Scalars['Int']>;
  teleConsultFee?: InputMaybe<Scalars['Int']>;
  total?: InputMaybe<Scalars['Int']>;
  totalLater?: InputMaybe<Scalars['Int']>;
  totalNow?: InputMaybe<Scalars['Int']>;
  totalNowAfterCashback?: InputMaybe<Scalars['Int']>;
};

export type CalculateOrderSummaryModel = {
  __typename?: 'CalculateOrderSummaryModel';
  cashbackEarnRate?: Maybe<Scalars['Int']>;
  cashbackEarned?: Maybe<Scalars['Int']>;
  cashbackRedeemed?: Maybe<Scalars['Int']>;
  discountAmountLater?: Maybe<Scalars['Int']>;
  discountAmountNow?: Maybe<Scalars['Int']>;
  itemList?: Maybe<Array<Maybe<PaymentItemInfoModel>>>;
  minimalAmountPayment?: Maybe<Scalars['Int']>;
  paymentIntentAmount?: Maybe<Scalars['Int']>;
  paymentIntentAmountBeforeTax?: Maybe<Scalars['Int']>;
  paymentIntentSummary?: Maybe<Scalars['JSON']>;
  promotionCode?: Maybe<Scalars['String']>;
  shippingFee?: Maybe<Scalars['Int']>;
  subTotal?: Maybe<Scalars['Int']>;
  subTotalLater?: Maybe<Scalars['Int']>;
  subTotalNow?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  taxesLater?: Maybe<Scalars['Int']>;
  taxesNow?: Maybe<Scalars['Int']>;
  teleConsultFee?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  totalLater?: Maybe<Scalars['Int']>;
  totalNow?: Maybe<Scalars['Int']>;
  totalNowAfterCashback?: Maybe<Scalars['Int']>;
  totalTaxes?: Maybe<Scalars['Int']>;
};

export type CalendarDateDto = {
  __typename?: 'CalendarDateDto';
  date?: Maybe<Scalars['String']>;
};

export type CalendarTimeDto = {
  __typename?: 'CalendarTimeDto';
  time?: Maybe<Scalars['String']>;
};

export type CancelAppointmentInput = {
  id: Scalars['String'];
};

export type CancelOrderInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  cancelSurvey?: InputMaybe<SurveyInput>;
  orderId: Scalars['String'];
  reason?: InputMaybe<CancelSubscriptionReasons>;
  reasonOther?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type CancelSubscriptionByOrderIdInput = {
  cancelSurvey?: InputMaybe<SurveyInput>;
  orderId: Scalars['String'];
  reason?: InputMaybe<CancelSubscriptionReasons>;
  reasonOther?: InputMaybe<Scalars['String']>;
};

export type CancelSubscriptionByOrderIdModel = {
  __typename?: 'CancelSubscriptionByOrderIdModel';
  status: Scalars['String'];
};

export enum CancelSubscriptionReasons {
  DoNotNeed = 'do_not_need',
  FoundSomewhereCheaper = 'found_somewhere_cheaper',
  Ineffective = 'ineffective',
  Other = 'other',
  SideEffects = 'side_effects',
  TooExpensive = 'too_expensive'
}

export type CartCalculationModel = {
  __typename?: 'CartCalculationModel';
  billingAddress?: Maybe<AddressModel>;
  calculateOrderSummary?: Maybe<Scalars['JSON']>;
  calculation?: Maybe<Scalars['JSON']>;
  cart?: Maybe<Scalars['JSON']>;
  cartItems?: Maybe<Scalars['JSON']>;
  deliveryAddress?: Maybe<AddressModel>;
  errorCode?: Maybe<Scalars['String']>;
  paidCompletedEvaluationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  platform?: Maybe<PlatformType>;
  promotionCode?: Maybe<Scalars['JSON']>;
  status?: Maybe<CartStatus>;
  sysId?: Maybe<Scalars['String']>;
};

export type CartDto = {
  __typename?: 'CartDto';
  billingAddress?: Maybe<AddressDto>;
  cartItems?: Maybe<Array<CartItemDto>>;
  deliveryAddress?: Maybe<AddressDto>;
  orderSummary?: Maybe<OrderSummaryDto>;
  paidCompletedEvaluationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  platform?: Maybe<PlatformType>;
  promotionCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
};

export type CartItemDto = {
  __typename?: 'CartItemDto';
  cart?: Maybe<CartDto>;
  completedEval?: Maybe<Scalars['JSON']>;
  consultationSessionType?: Maybe<ConsultationSessionType>;
  isAutoRenewal?: Maybe<Scalars['Boolean']>;
  isSkipMedSelecting?: Maybe<Scalars['Boolean']>;
  isSubscriptionPrice?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Scalars['String']>;
  patientNote?: Maybe<Scalars['String']>;
  price?: Maybe<StripePriceDto>;
  product?: Maybe<StripeProductDto>;
  quantity?: Maybe<Scalars['Float']>;
  teleConsultForSkipEval?: Maybe<EvalIds>;
  type?: Maybe<CartItemType>;
};

export enum CartItemType {
  Both = 'BOTH',
  OneTime = 'ONE_TIME',
  Subscription = 'SUBSCRIPTION'
}

export type CartModel = {
  __typename?: 'CartModel';
  billingAddress?: Maybe<AddressModel>;
  calculateOrderSummary?: Maybe<Scalars['JSON']>;
  calculation?: Maybe<Scalars['JSON']>;
  cartItems?: Maybe<Scalars['JSON']>;
  deliveryAddress?: Maybe<AddressModel>;
  paidCompletedEvaluationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientId?: Maybe<Scalars['String']>;
  patientInfo?: Maybe<Scalars['JSON']>;
  platform?: Maybe<PlatformType>;
  promotionCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
};

export enum CartStatus {
  Initial = 'INITIAL',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type CashbackDashboardModel = {
  __typename?: 'CashbackDashboardModel';
  availableBalance?: Maybe<Scalars['Float']>;
  recentTransactions?: Maybe<Array<Maybe<BalanceTransactionModel>>>;
  savingsToDateThisYear?: Maybe<Array<Maybe<BalanceTransactionModel>>>;
};

export type CashbackDto = {
  __typename?: 'CashbackDto';
  availableBalance?: Maybe<Scalars['Float']>;
  recentTransactions?: Maybe<Array<Maybe<BalanceTransactionDto>>>;
  savingsToDateThisYear?: Maybe<Array<Maybe<BalanceTransactionDto>>>;
};

export enum CashbackObjectType {
  AtomePayment = 'AtomePayment',
  Charge = 'Charge',
  Coupon = 'Coupon',
  Gift = 'Gift',
  Invoice = 'Invoice',
  PaymentIntent = 'PaymentIntent'
}

export enum CashbackType {
  Earned = 'Earned',
  Reset = 'Reset',
  Returned = 'Returned',
  Spent = 'Spent'
}

export type ChangeAutoRenewalModeInput = {
  /** For Atome order only, set false for others. */
  isAtomeAutoRenewal?: InputMaybe<Scalars['Boolean']>;
  /** Set false for Atome order. */
  isAutoRenewal?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
};

export type ChangeDeliveryStatusInput = {
  deliveryStatus?: InputMaybe<DeliveryStatus>;
  orderSysIds: Array<Scalars['String']>;
  status?: InputMaybe<OrderStatus>;
};

export type ChangeDeliveryWindowInput = {
  lang?: InputMaybe<Language>;
  orderId: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type ChangeNewPriceOrderInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  cancelSurvey?: InputMaybe<SurveyInput>;
  newPriceId: Scalars['String'];
  orderId: Scalars['String'];
  reason?: InputMaybe<CancelSubscriptionReasons>;
  reasonOther?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
  variantEdit?: InputMaybe<Scalars['String']>;
};

export type ChangeNewPriceOrderModel = {
  __typename?: 'ChangeNewPriceOrderModel';
  oldStripePrescriptionId: Scalars['String'];
  orderPrescriptionPriceId: Scalars['String'];
};

export type ChangePasswordInput = {
  oldPassword: Scalars['String'];
  password: Scalars['String'];
};

export type ChangeRoInOpsInput = {
  day?: InputMaybe<Scalars['Float']>;
  now?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type ChangeRenewalDateInput = {
  day: Scalars['Float'];
  orderId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type CheckSupportCodDto = {
  __typename?: 'CheckSupportCodDto';
  support: Scalars['Boolean'];
};

export type CheckValidAtomePaymentLinkInput = {
  referenceId: Scalars['String'];
};

export type CheckValidConversationsForDoctorInput = {
  conversations: Array<PatientDialog>;
};

export type CheckValidConversationsForPatientInput = {
  conversations: Array<DoctorDialog>;
};

export type CheckoutAnonymousInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  anonymousTrackingId?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<AddressInput>;
  calculation?: InputMaybe<Scalars['JSON']>;
  deliveryAddress: AddressInput;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  isUsingWallet?: InputMaybe<Scalars['Boolean']>;
  item: Scalars['JSON'];
  patientSysId: Scalars['String'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentProvider?: InputMaybe<PaymentProvider>;
  pickupLocation?: InputMaybe<PickupLocationInput>;
  promotionCode?: InputMaybe<Scalars['String']>;
  stripeCustomer: Scalars['JSON'];
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type CheckoutAnonymousModel = {
  __typename?: 'CheckoutAnonymousModel';
  orderSysId: Scalars['String'];
  patientSysId: Scalars['String'];
  success: Scalars['Boolean'];
  totalAfterCashback?: Maybe<Scalars['Float']>;
};

export type CheckoutCalculationDto = {
  __typename?: 'CheckoutCalculationDto';
  affiliateCouponNotApplied?: Maybe<AffiliateCouponNotAppliedDto>;
  isAffiliateLocked?: Maybe<Scalars['Boolean']>;
  otcCalculationSummary?: Maybe<OtcCalculationSummaryDto>;
  promotionCodeError?: Maybe<PromotionCodeError>;
  rxCalculationSummary?: Maybe<RxCalculationSummaryDto>;
  stripePromotionCode?: Maybe<Scalars['JSON']>;
};

export type CheckoutCartInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<AddressInput>;
  clientId?: InputMaybe<Scalars['String']>;
  deliveryAddress: ExtraDeliveryAddressInput;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  fbc?: InputMaybe<Scalars['String']>;
  fbp?: InputMaybe<Scalars['String']>;
  isUsingWallet?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  pickupLocation?: InputMaybe<PickupLocationInput>;
  platformType?: InputMaybe<PlatformType>;
  promotionCode?: InputMaybe<Scalars['String']>;
  stripeCustomer: Scalars['JSON'];
  sysId?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
  walletOrderId?: InputMaybe<Scalars['String']>;
};

export type CheckoutCartModel = {
  __typename?: 'CheckoutCartModel';
  billingAddress?: Maybe<AddressModel>;
  calculateOrderSummary?: Maybe<CalculateOrderSummaryModel>;
  cartItems?: Maybe<Scalars['JSON']>;
  deliveryAddress?: Maybe<AddressModel>;
  paidCompletedEvaluationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  patient?: Maybe<PatientModel>;
  platform?: Maybe<PlatformType>;
  promotionCode?: Maybe<Scalars['String']>;
  sysId: Scalars['String'];
};

export type CheckoutCartMuationModel = {
  __typename?: 'CheckoutCartMuationModel';
  cartId: Scalars['String'];
  orderIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalAfterCashback?: Maybe<Scalars['Float']>;
};

export type CheckoutSessionDto = {
  __typename?: 'CheckoutSessionDto';
  checkoutData?: Maybe<Scalars['JSON']>;
  evaluationId?: Maybe<Scalars['String']>;
  order?: Maybe<OrderDto>;
  patient?: Maybe<PatientDto>;
  status?: Maybe<CheckoutSessionStatus>;
  sysId?: Maybe<Scalars['String']>;
};

export type CheckoutSessionFilterInput = {
  evaluationId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CheckoutSessionStatus>;
};

export enum CheckoutSessionStatus {
  Complete = 'complete',
  Deleted = 'deleted',
  Incomplete = 'incomplete'
}

export enum ClientType {
  NoahAndroid = 'NOAH_ANDROID',
  NoahIos = 'NOAH_IOS',
  NoahWeb = 'NOAH_WEB',
  Unknown = 'UNKNOWN',
  ZoeyAndroid = 'ZOEY_ANDROID',
  ZoeyIos = 'ZOEY_IOS',
  ZoeyWeb = 'ZOEY_WEB'
}

export enum CollectionMethod {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice'
}

export type CompletedEvalModel = {
  __typename?: 'CompletedEvalModel';
  completed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  evaluationFormLastUpdated?: Maybe<Scalars['DateTime']>;
  evaluationId?: Maybe<Scalars['String']>;
  formQandA?: Maybe<Array<Scalars['JSON']>>;
  jumpToSectionIndex?: Maybe<Array<Maybe<Scalars['Float']>>>;
  oldPatientId?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['JSON']>;
  patientSnapshot?: Maybe<PatientModel>;
  patientdoctorNotes?: Maybe<Scalars['String']>;
  questionTotal?: Maybe<Scalars['Float']>;
  sectionHistory?: Maybe<Array<Maybe<Scalars['Float']>>>;
  sectionIndex?: Maybe<Scalars['Float']>;
  sectionTotal?: Maybe<Scalars['Float']>;
  sysId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type CompletedEvaluationModel = {
  __typename?: 'CompletedEvaluationModel';
  conditionEvaluations?: Maybe<Array<Maybe<ConditionEvaluationType>>>;
  consultType?: Maybe<ConsultationSessionType>;
  evaluationBlocks?: Maybe<Array<Maybe<EvaluationBlockModel>>>;
  evaluationQuestions?: Maybe<Array<Maybe<EvaluationQuestionModel>>>;
  learnMore?: Maybe<EvaluationLearnMoreModel>;
  name?: Maybe<Scalars['String']>;
  patientEvaluations?: Maybe<Array<Maybe<PatientEvaluationModel>>>;
  platform?: Maybe<PlatformType>;
  status?: Maybe<EvaluationStatus>;
  sysId?: Maybe<Scalars['String']>;
  type?: Maybe<EvalIds>;
  validatePatientQuestionAnswer?: Maybe<Array<Maybe<ValidatePatientQuestionAnswerModel>>>;
};

export enum ConditionEvaluationType {
  IsOnlyShowEd = 'IsOnlyShowEd',
  IsShowClindoxyl = 'IsShowClindoxyl',
  IsShowDifferin = 'IsShowDifferin',
  IsShowEdFirst = 'IsShowEdFirst',
  IsShowFinMinox = 'IsShowFinMinox',
  IsShowFinasteride = 'IsShowFinasteride',
  IsShowMinox2 = 'IsShowMinox2',
  IsShowMinox5 = 'IsShowMinox5',
  IsShowPeFirst = 'IsShowPeFirst',
  IsShowSupergrowpack = 'IsShowSupergrowpack'
}

export type ConfigEnvironmentModel = {
  __typename?: 'ConfigEnvironmentModel';
  consultType?: Maybe<ConsultType>;
  country: Scalars['String'];
  crossPlatformError?: Maybe<CrossPlatformLogInError>;
  deliveryAmount: Scalars['Float'];
  evalIds?: Maybe<EvalIds>;
  evalsToShow?: Maybe<Array<Maybe<Scalars['String']>>>;
  metadataCountry: Scalars['String'];
  pharmacistEmail?: Maybe<Scalars['String']>;
  platform?: Maybe<PlatformType>;
  pmetadataCountry: Scalars['String'];
  pregnancyEvalQuestionIds?: Maybe<Scalars['JSON']>;
  productGroupIdsByEvaluationId?: Maybe<Scalars['JSON']>;
  referralProgram?: Maybe<ReferralProgram>;
  skipEvalAppointment: Scalars['JSON'];
  stripeCurrencyRatio?: Maybe<Scalars['Float']>;
  stripePriceType?: Maybe<StripePriceType>;
  stripeProduct?: Maybe<Scalars['JSON']>;
  successPage?: Maybe<Scalars['JSON']>;
};

export type ConfirmBloodDrawInput = {
  drawType: TrtDrawType;
  orderSysId: Scalars['String'];
};

export type ConfirmChangePrescriptionModel = {
  __typename?: 'ConfirmChangePrescriptionModel';
  success: Scalars['Boolean'];
};

export type ConfirmCodDto = {
  __typename?: 'ConfirmCodDto';
  isSuccess: Scalars['Boolean'];
};

export type ConfirmKonbiniOrderInput = {
  orderId: Scalars['String'];
  priceId: Scalars['String'];
};

export enum ConsultType {
  All = 'all',
  FertilityCoach = 'fertility_coach',
  Gp = 'gp',
  Obgyn = 'obgyn',
  Therapist = 'therapist'
}

export type ConsultationAuditDto = {
  __typename?: 'ConsultationAuditDto';
  consultTime?: Maybe<Scalars['DateTime']>;
  consultType?: Maybe<ConsultationType>;
  createdBy?: Maybe<Scalars['String']>;
  doctor?: Maybe<DoctorDto>;
  evaluationId?: Maybe<EvalIds>;
  order?: Maybe<OrderDto>;
  patient?: Maybe<PatientDto>;
  sessionType?: Maybe<ConsultationSessionType>;
  status?: Maybe<PrescriptionStatus>;
  sysId?: Maybe<Scalars['String']>;
};

export type ConsultationAuditFilterInput = {
  consultTimeFrom?: InputMaybe<Scalars['DateTime']>;
  consultTimeTo?: InputMaybe<Scalars['DateTime']>;
  consultType?: InputMaybe<ConsultationType>;
  doctorId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<EvalIds>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sessionType?: InputMaybe<ConsultationSessionType>;
  shortId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PrescriptionStatus>;
};

export type ConsultationByOrdersModel = {
  __typename?: 'ConsultationByOrdersModel';
  consultationSessions?: Maybe<Array<Maybe<ConsultationSessionModel>>>;
  order?: Maybe<OrderModel>;
};

export type ConsultationDto = {
  __typename?: 'ConsultationDto';
  consultationAudit?: Maybe<ConsultationAuditDto>;
  consultationMessages?: Maybe<PaginatedUserMessageDto>;
  consultationTitle?: Maybe<TranslationDto>;
  countReminder?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorDto>;
  doctorChatToken?: Maybe<Scalars['String']>;
  doctorSysId?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  gmeetLink?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isRead?: Maybe<Scalars['Boolean']>;
  isVideoConsultRescheduled?: Maybe<Scalars['Boolean']>;
  lastMsgSysId?: Maybe<Scalars['String']>;
  lastMsgUserId?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<UserMessageDto>>;
  order?: Maybe<OrderDto>;
  orderSysId?: Maybe<Scalars['String']>;
  participants?: Maybe<Array<ParticipantModel>>;
  participantsV2?: Maybe<Array<UserDto>>;
  patientChatToken?: Maybe<Scalars['String']>;
  patientEmail?: Maybe<Scalars['String']>;
  prescribedAt?: Maybe<Scalars['DateTime']>;
  previewVideoLink?: Maybe<Scalars['String']>;
  progressStatus?: Maybe<ConsultationSessionProgressStatus>;
  readAt?: Maybe<Scalars['DateTime']>;
  reviewDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<ConsultationSessionStatus>;
  sysId?: Maybe<Scalars['String']>;
  textConsultStatus?: Maybe<TextConsultStatus>;
  textConversationId?: Maybe<Scalars['String']>;
  type?: Maybe<ConsultationSessionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  videoChannelId?: Maybe<Scalars['String']>;
  videoLink?: Maybe<Scalars['String']>;
};


export type ConsultationDtoConsultationMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};

export type ConsultationListInput = {
  email?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type ConsultationMessagesInput = {
  consultationSysId: Scalars['String'];
};

export type ConsultationSessionByFilterModel = {
  __typename?: 'ConsultationSessionByFilterModel';
  consultationSessions?: Maybe<Array<ConsultationSessionModel>>;
  order?: Maybe<OrderModel>;
  participants?: Maybe<Array<ParticipantModel>>;
  stripeProductPrice?: Maybe<StripeProductPriceModel>;
  token?: Maybe<Scalars['String']>;
};

export type ConsultationSessionModel = {
  __typename?: 'ConsultationSessionModel';
  countReminder?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<DoctorModel>;
  doctorChatToken?: Maybe<Scalars['String']>;
  friendlyName?: Maybe<Scalars['String']>;
  gmeetLink?: Maybe<Scalars['String']>;
  order?: Maybe<OrderModel>;
  patientChatToken?: Maybe<Scalars['String']>;
  status?: Maybe<ConsultationSessionStatus>;
  sysId?: Maybe<Scalars['String']>;
  textConversationId?: Maybe<Scalars['String']>;
  type?: Maybe<ConsultationSessionType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  videoChannelId?: Maybe<Scalars['String']>;
  videoLink?: Maybe<Scalars['String']>;
};

export enum ConsultationSessionProgressStatus {
  Finished = 'Finished',
  InProgress = 'InProgress',
  PendingAppointment = 'PendingAppointment'
}

export enum ConsultationSessionStatus {
  Active = 'Active',
  Disable = 'Disable',
  Inactive = 'Inactive'
}

export enum ConsultationSessionType {
  Text = 'Text',
  Video = 'Video'
}

export enum ConsultationType {
  CheckIn = 'CheckIn',
  FollowUp = 'FollowUp',
  New = 'New',
  NewPrescription = 'NewPrescription',
  PrescriptionReview = 'PrescriptionReview',
  TrtReview = 'TrtReview'
}

export type ContentBaseDto = {
  __typename?: 'ContentBaseDto';
  description?: Maybe<Scalars['String']>;
  descriptionTextKey?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleTextKey?: Maybe<Scalars['String']>;
};

export type ContentBaseEvaluationQuestion = {
  __typename?: 'ContentBaseEvaluationQuestion';
  description?: Maybe<Scalars['String']>;
  descriptionTextKey?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleTextKey?: Maybe<Scalars['String']>;
};

export type ContentEvaluationQuestionModel = {
  __typename?: 'ContentEvaluationQuestionModel';
  body?: Maybe<ContentBaseEvaluationQuestion>;
  footer?: Maybe<ContentBaseEvaluationQuestion>;
  header?: Maybe<ContentBaseEvaluationQuestion>;
};

export type ContentQuestionDto = {
  __typename?: 'ContentQuestionDto';
  body?: Maybe<ContentBaseDto>;
  footer?: Maybe<ContentBaseDto>;
  header?: Maybe<ContentBaseDto>;
};

export type ContinueTrialOrderDataModel = {
  __typename?: 'ContinueTrialOrderDataModel';
  order?: Maybe<OrderModel>;
  price?: Maybe<StripePriceModel>;
  product?: Maybe<StripeProductModel>;
};

export type ContinueTrialOrderInput = {
  orderSysId?: InputMaybe<Scalars['String']>;
};

export type ConvertPromoCodeToCashBackModel = {
  __typename?: 'ConvertPromoCodeToCashBackModel';
  errorPromoCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum ConvertedFilter {
  All = 'all',
  Converted = 'converted',
  NotConverted = 'notConverted'
}

export enum ConvertedOrdersDateBasis {
  Converted = 'converted',
  Placed = 'placed'
}

export type CountOrderingOfAnEvalProductsInput = {
  evalId: EvalIds;
  platform?: InputMaybe<PlatformType>;
};

export type CountOrderingOfAnEvalProductsModel = {
  __typename?: 'CountOrderingOfAnEvalProductsModel';
  count: Scalars['Float'];
  priceIds: Array<Scalars['String']>;
};

export enum CouponDuration {
  Forever = 'forever',
  Once = 'once',
  Repeating = 'repeating'
}

export enum CouponType {
  FixedAmountDiscount = 'fixedAmountDiscount',
  PercentageDiscount = 'percentageDiscount'
}

export enum CourierName {
  Lalamove = 'Lalamove',
  NinjaVan = 'NinjaVan',
  SfExpress = 'SFExpress'
}

export type CovidOrderInput = {
  orderId: Scalars['String'];
  prescriptionDays: Scalars['Float'];
  prices: Array<Scalars['String']>;
};

export type CreateAffiliateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  formFieldMap?: InputMaybe<Scalars['JSON']>;
  formSubmitUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notificationChannel: AffiliateNotificationChannel;
  notificationEmail?: InputMaybe<Scalars['String']>;
  portalUrl: Scalars['String'];
  region: RegionType;
  slug: Scalars['String'];
};

export type CreateAffiliateProductInput = {
  affiliateSysId: Scalars['String'];
  /** Percentage discount 1–100 (default 100 = fully comped). Minted as the Stripe coupon's percent_off. */
  discountPercentage?: InputMaybe<Scalars['Int']>;
  displayName: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Affiliate's per-product external portal / deal link (e.g. kumapon.jp/deals/…). Optional at create; editable later. */
  externalPortalUrl?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  stripePriceId: Scalars['String'];
  stripeProductId: Scalars['String'];
};

export type CreateAnonymousPatientModel = {
  __typename?: 'CreateAnonymousPatientModel';
  stripeCustomerId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  sysId?: Maybe<Scalars['String']>;
};

export type CreateCheckoutSessionInput = {
  checkoutData?: InputMaybe<Scalars['JSON']>;
  evaluationId?: InputMaybe<EvalIds>;
};

export type CreateCompletedEvalInput = {
  completed?: InputMaybe<Scalars['Boolean']>;
  evaluationFormLastUpdated?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<Scalars['String']>;
  formQandA?: InputMaybe<Scalars['JSON']>;
  goal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jumpToSectionIndex?: InputMaybe<Array<Scalars['Float']>>;
  oldPatientId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  patientdoctorNotes?: InputMaybe<Scalars['String']>;
  questionTotal?: InputMaybe<Scalars['Float']>;
  sectionHistory?: InputMaybe<Array<Scalars['Float']>>;
  sectionIndex?: InputMaybe<Scalars['Float']>;
  sectionTotal?: InputMaybe<Scalars['Float']>;
  valid?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCompletedEvalInputForGuest = {
  completed?: InputMaybe<Scalars['Boolean']>;
  evaluationFormLastUpdated?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<Scalars['String']>;
  formQandA?: InputMaybe<Scalars['JSON']>;
  goal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jumpToSectionIndex?: InputMaybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  oldPatientId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  patientdoctorNotes?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PlatformType>;
  questionTotal?: InputMaybe<Scalars['Float']>;
  sectionHistory?: InputMaybe<Array<Scalars['Float']>>;
  sectionIndex?: InputMaybe<Scalars['Float']>;
  sectionTotal?: InputMaybe<Scalars['Float']>;
  targetEmail: Scalars['String'];
  valid?: InputMaybe<Scalars['Boolean']>;
};

export type CreateEvaluationQuestionInput = {
  answers?: InputMaybe<Array<Scalars['JSON']>>;
  evaluationId?: InputMaybe<Scalars['String']>;
  evaluationQuestion?: InputMaybe<Scalars['JSON']>;
  question?: InputMaybe<Scalars['JSON']>;
};

export type CreateGiveawayInput = {
  answer: Scalars['String'];
  cartSysId?: InputMaybe<Scalars['String']>;
  choice: Scalars['String'];
  eventType?: InputMaybe<EventType>;
  moneySpent: Scalars['Float'];
  orderSysId?: InputMaybe<Scalars['String']>;
  patientSysId?: InputMaybe<Scalars['String']>;
};

export type CreateGuestEvaluationInput = {
  name: Scalars['String'];
  patientEvaluation: UpdatePatientEvaluationInput;
  patientId: Scalars['String'];
  patientQuestionAnswers?: InputMaybe<Array<UpdatePatientQuestionAnswerInput>>;
  platform?: InputMaybe<PlatformType>;
  targetEmail: Scalars['String'];
  url: Scalars['String'];
};

export type CreateInvoiceInput = {
  collectionMethod?: InputMaybe<CollectionMethod>;
  dueDate?: InputMaybe<Scalars['Float']>;
  priceIds?: InputMaybe<Array<Scalars['String']>>;
  stripeCustomer: Scalars['JSON'];
};

export type CreateNewSurveyInput = {
  answers?: InputMaybe<Array<SurveyAnswers>>;
  isSkipped?: InputMaybe<Scalars['Boolean']>;
  otherAnswer?: InputMaybe<Scalars['JSON']>;
};

export type CreateOtcWalletOrderInput = {
  billingAddress?: InputMaybe<AddressInput>;
  deliveryAddress: ExtraDeliveryAddressInput;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  giveaway?: InputMaybe<Scalars['JSON']>;
  locale?: InputMaybe<Scalars['String']>;
  pickupLocation?: InputMaybe<PickupLocationInput>;
  platform?: InputMaybe<PlatformType>;
  platformType: Scalars['String'];
  promotionCode?: InputMaybe<Scalars['String']>;
  stripeCustomer: Scalars['JSON'];
  sysId?: InputMaybe<Scalars['String']>;
};

export type CreateOtcWalletOrderModel = {
  __typename?: 'CreateOTCWalletOrderModel';
  otcWalletOrderId: Scalars['String'];
};

export type CreateOrderInput = {
  address?: InputMaybe<OrderAddressInput>;
  completedEvaluation?: InputMaybe<Scalars['JSON']>;
  country?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<Scalars['String']>;
  expiredAt?: InputMaybe<Scalars['Float']>;
  isAutoRenewal?: InputMaybe<Scalars['Boolean']>;
  isFixedOrder?: InputMaybe<Scalars['Boolean']>;
  isOrderRenew?: InputMaybe<Scalars['Boolean']>;
  isPendingFollowUpConsult?: InputMaybe<Scalars['Boolean']>;
  isSubscriptionPaused?: InputMaybe<Scalars['Boolean']>;
  nextReviewDate?: InputMaybe<Scalars['DateTime']>;
  orderPrescriptionPriceId?: InputMaybe<Scalars['String']>;
  orderPriceId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  patientOrderNotes?: InputMaybe<Array<Scalars['String']>>;
  paymentProvider?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platformType?: InputMaybe<PlatformType>;
  productGroupData?: InputMaybe<Scalars['JSON']>;
  productQuantity?: InputMaybe<Scalars['Float']>;
  promotionCode?: InputMaybe<Scalars['String']>;
  reorderStatus?: InputMaybe<Scalars['Boolean']>;
  shortId?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
};

export type CreateOrderNoteInput = {
  content: Scalars['String'];
  orderSysId: Scalars['String'];
};

export type CreatePartnerConsultation = {
  consultTime: Scalars['String'];
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};

export type CreatePartnerTrtOrder = {
  patientSysId: Scalars['String'];
  urls: Array<Scalars['String']>;
};

export type CreatePatientDocumentInput = {
  type: UserDocumentType;
  urls: Array<Scalars['String']>;
  userSysId: Scalars['String'];
};

export type CreatePatientFromOpsInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  anonymousPatientId?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<AddressInput>;
  bloodPressure?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<RegionType>;
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fbc?: InputMaybe<Scalars['String']>;
  fbp?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  fromPlatformEnv?: InputMaybe<PlatformType>;
  height?: InputMaybe<Scalars['Float']>;
  lastName: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  provider?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  registerAt?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<AddressInput>;
  socialProviderType?: InputMaybe<SocialProviderTypes>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  user?: InputMaybe<Scalars['JSON']>;
  utm?: InputMaybe<UtmTypeInput>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type CreatePreblockInput = {
  anonymousId: Scalars['String'];
  dateTime: Scalars['String'];
  evaluationId: EvalIds;
  region: RegionType;
};

export type CreateProductInput = {
  acuitySchedulingAppType?: InputMaybe<Scalars['String']>;
  amountToFreeIncludedPrice?: InputMaybe<Scalars['Float']>;
  chargeNowProduct?: InputMaybe<Array<Scalars['String']>>;
  country: Scalars['String'];
  crossEvaluation?: InputMaybe<Scalars['JSON']>;
  emailOnCompleteName?: InputMaybe<Scalars['String']>;
  emailTemplate?: InputMaybe<Scalars['String']>;
  evaluationFormId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  includedPriceIds?: InputMaybe<Array<Scalars['String']>>;
  overwriteCalendarHeaderTitleInfo?: InputMaybe<Scalars['String']>;
  overwriteProductSubtitleInfo?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PlatformType>;
  productGroups?: InputMaybe<Scalars['JSON']>;
  requiresDelivery?: InputMaybe<Scalars['Boolean']>;
  requiresEvaluation?: InputMaybe<Scalars['Boolean']>;
  requiresPrescription?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateReferralDocumentInput = {
  referralSysId: Scalars['String'];
  urls: Array<Scalars['String']>;
};

export type CreateShipmentGroupInput = {
  bookingNo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateShipperInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};

export type CreateStripeCouponInput = {
  amountOff?: InputMaybe<Scalars['Float']>;
  appliesTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  couponType?: InputMaybe<CouponType>;
  currency?: InputMaybe<StripeCurrency>;
  duration?: InputMaybe<CouponDuration>;
  durationInMonths?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  percentOff?: InputMaybe<Scalars['Float']>;
};

export type CreateStripePriceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billingScheme?: InputMaybe<StripePriceBillingScheme>;
  currency: Scalars['String'];
  expand?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  recurring?: InputMaybe<StripePriceRecurringInput>;
  unitAmount?: InputMaybe<Scalars['Float']>;
};

export type CreateStripeProductInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  expand?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Language>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  prices?: InputMaybe<Array<CreateStripePriceInput>>;
  statementDescriptor?: InputMaybe<Scalars['String']>;
  unitLabel?: InputMaybe<Scalars['String']>;
};

export type CreateStripePromotionCodeInput = {
  code?: InputMaybe<Scalars['String']>;
  coupon: Scalars['String'];
  customer?: InputMaybe<Scalars['String']>;
  expiredAt?: InputMaybe<Scalars['DateTime']>;
  firstTimeTransaction?: InputMaybe<Scalars['Boolean']>;
  maxRedemptions?: InputMaybe<Scalars['Float']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  minimumAmount?: InputMaybe<Scalars['Float']>;
  minimumAmountCurrency?: InputMaybe<Scalars['String']>;
};

export type CreateSurveyInput = {
  answers?: InputMaybe<Scalars['JSON']>;
  isSkipped?: InputMaybe<Scalars['Boolean']>;
  type: SurveyType;
};

export type CronjobInput = {
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type CronjobModel = {
  __typename?: 'CronjobModel';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type CrossPlatformLogInError = {
  __typename?: 'CrossPlatformLogInError';
  code?: Maybe<ErrorCode>;
  currentPlatform?: Maybe<PlatformType>;
  message?: Maybe<Scalars['String']>;
  userPlatform?: Maybe<PlatformType>;
};

export type CrossSellOrderLinkDto = {
  __typename?: 'CrossSellOrderLinkDto';
  childOrder: OrderDto;
  childOrderId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  creator: UserDto;
  parentOrder: OrderDto;
  parentOrderId: Scalars['String'];
  priceId?: Maybe<Scalars['String']>;
  selectedBy?: Maybe<Scalars['String']>;
  stripeProductPrice?: Maybe<StripeProductPriceDto>;
  sysId: Scalars['String'];
};

export type CrossSellRecordQueryInput = {
  createdBy?: InputMaybe<UserRole>;
};

export type CustomEvaluationQuestionModel = {
  __typename?: 'CustomEvaluationQuestionModel';
  content?: Maybe<ContentEvaluationQuestionModel>;
  dependentEvaluationQuestions?: Maybe<Array<Maybe<DependentEvaluationQuestionModel>>>;
  displayPage: Scalars['Float'];
  evaluation?: Maybe<Scalars['JSON']>;
  guestOnly: Scalars['Boolean'];
  order: Scalars['Float'];
  question: Scalars['JSON'];
  sysId?: Maybe<Scalars['String']>;
  validation?: Maybe<ValidationEvaluationQuestionModel>;
};

export type CustomerBalance = {
  email: Scalars['String'];
  finalBalance: Scalars['Float'];
};

export enum CustomerBalanceTransactionType {
  Adjustment = 'adjustment',
  AppliedToInvoice = 'applied_to_invoice',
  CreditNote = 'credit_note',
  Initial = 'initial',
  InvoiceTooLarge = 'invoice_too_large',
  InvoiceTooSmall = 'invoice_too_small',
  Migration = 'migration',
  UnappliedFromInvoice = 'unapplied_from_invoice',
  UnspentReceiverCredit = 'unspent_receiver_credit'
}

export type CustomerInput = {
  addingAmount: Scalars['Float'];
  email: Scalars['String'];
};

export type DeleteCartItemByIdInput = {
  cartItemId: Scalars['String'];
  promotionCode?: InputMaybe<Scalars['JSON']>;
  shouldReturnCalculation?: InputMaybe<Scalars['Boolean']>;
  sysId: Scalars['String'];
};

export type DeleteOrderInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  cancelSurvey?: InputMaybe<SurveyInput>;
  orderId: Scalars['String'];
  reason?: InputMaybe<CancelSubscriptionReasons>;
  reasonOther?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type DeletePatientQuestionAnswerInput = {
  questionIds: Array<Scalars['String']>;
};

export type DeletePriceInput = {
  priceId: Scalars['String'];
};

export type DeleteProductInput = {
  productId: Scalars['String'];
};

export type DeliveryAddressInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: RegionType;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  postal: Scalars['String'];
  region: LocalRegionType;
  sameAsBilling?: InputMaybe<Scalars['Boolean']>;
  state: Scalars['String'];
  unit: Scalars['String'];
};

export type DeliveryConfigInput = {
  address?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export enum DeliveryMethod {
  DeliveryToAddress = 'DeliveryToAddress',
  Pickup = 'Pickup',
  SelfCollect = 'SelfCollect'
}

export type DeliveryOrderFilterInput = {
  deliveryStatus?: InputMaybe<DeliveryStatus>;
  email?: InputMaybe<Scalars['String']>;
  fromDeliveryTime?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrderStatus>;
  toDeliveryTime?: InputMaybe<Scalars['String']>;
};

export enum DeliveryStatus {
  Completed = 'completed',
  Failed = 'failed',
  FollowUpRequired = 'follow_up_required',
  Kiv = 'kiv',
  OutForDelivery = 'out_for_delivery',
  Pending = 'pending',
  Processing = 'processing'
}

export type DependentEvaluationQuestionModel = {
  __typename?: 'DependentEvaluationQuestionModel';
  dependentQuestionAnswer: QuestionAnswerModel;
  evaluationQuestion: EvaluationQuestionModel;
  skipPage: Scalars['Boolean'];
  skipQuestionCount: Scalars['Float'];
  sysId?: Maybe<Scalars['String']>;
};

export type DependentQuestionDto = {
  __typename?: 'DependentQuestionDto';
  answer?: Maybe<AnswerDto>;
  skipPage?: Maybe<Scalars['Boolean']>;
  skipQuestionCount?: Maybe<Scalars['Float']>;
  sysId?: Maybe<Scalars['String']>;
};

export type DispatchJobFilterInput = {
  orderId?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type DispatchJobModel = {
  __typename?: 'DispatchJobModel';
  collectionSnapshot?: Maybe<Scalars['JSON']>;
  deliverySnapshot?: Maybe<Scalars['JSON']>;
  orderId?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
};

export type DocPatientSuggestionByDoctorInput = {
  limit?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
};

export type DoctorDashboardOrdersByFilterModel = {
  __typename?: 'DoctorDashboardOrdersByFilterModel';
  consultationSessions?: Maybe<Array<Maybe<ConsultationSessionModel>>>;
  orders?: Maybe<Scalars['JSON']>;
};

export enum DoctorDesignation {
  Officer = 'Officer',
  Specialist = 'Specialist'
}

export type DoctorDialog = {
  channelUrl: Scalars['String'];
  doctorEmail?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['String']>;
};

export type DoctorDto = {
  __typename?: 'DoctorDto';
  active?: Maybe<Scalars['Boolean']>;
  bio?: Maybe<TranslationDto>;
  calendarId?: Maybe<Scalars['Float']>;
  consultation?: Maybe<VideoConsultationDto>;
  country?: Maybe<RegionType>;
  designation?: Maybe<DoctorDesignation>;
  duration?: Maybe<Scalars['JSON']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  patient: PatientDto;
  sysId?: Maybe<Scalars['String']>;
  textConsultPostalCodes?: Maybe<Array<Scalars['String']>>;
  trtEligible?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserDto>;
};


export type DoctorDtoConsultationArgs = {
  videoLink: Scalars['String'];
};


export type DoctorDtoPatientArgs = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type DoctorModel = {
  __typename?: 'DoctorModel';
  active?: Maybe<Scalars['Boolean']>;
  calendarId?: Maybe<Scalars['Float']>;
  country?: Maybe<RegionType>;
  duration?: Maybe<Scalars['JSON']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  textConsultPostalCodes?: Maybe<Array<Scalars['String']>>;
  trtEligible?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
};

export type DoctorNoteModel = {
  __typename?: 'DoctorNoteModel';
  approved?: Maybe<Scalars['String']>;
  approver?: Maybe<ApproverModel>;
  condition?: Maybe<Scalars['String']>;
  doctor?: Maybe<DoctorModel>;
  dosage?: Maybe<Scalars['JSON']>;
  evaluationId?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<AuditDoctorNoteModel>>>;
  orderSysId: Scalars['String'];
  stripePrices: Array<StripePriceModel>;
};

export enum DoctorTabState {
  Past = 'Past',
  Today = 'Today',
  Upcoming = 'Upcoming'
}

export type DoctorsWithAppointmentTypeInput = {
  appointmentTypeId: Scalars['Float'];
};

export enum DosageDurationUnit {
  Dose = 'dose',
  Month = 'month'
}

export enum DosageFrequencyOptions {
  EveryOtherDay = 'everyOtherDay',
  EveryThreeDay = 'everyThreeDay',
  EveryThreeDays = 'everyThreeDays',
  Immediately = 'immediately',
  OnceADay = 'onceADay',
  OnceADayMayAdd1Or2TabsBeforeSex = 'onceADayMayAdd1Or2TabsBeforeSex',
  OnceAWeek = 'onceAWeek',
  OnceAWeekForThreeWeekForllowByOnePatch = 'onceAWeekForThreeWeekForllowByOnePatch',
  OnceDayForThreeWeekFollowByOnePatch = 'onceDayForThreeWeekFollowByOnePatch',
  OnceDayForThreeWeekFollowByOnePill = 'onceDayForThreeWeekFollowByOnePill',
  OneTabImmediatelyOneTab12hLater = 'oneTabImmediatelyOneTab12hLater',
  Other = 'other',
  TwiceADay = 'twiceADay'
}

export enum DosageQuantityUnit {
  Bottle = 'bottle',
  Box = 'box',
  Dose = 'dose',
  Pack = 'pack',
  Pens = 'pens'
}

export enum DosageUnit {
  Application = 'application',
  Cap = 'cap',
  Dose = 'dose',
  Film = 'film',
  Mg = 'mg',
  Ml = 'ml',
  Month = 'month',
  Patch = 'patch',
  Spray = 'spray',
  Tab = 'tab'
}

export type DoseStartDto = {
  __typename?: 'DoseStartDto';
  doseStartedAt?: Maybe<Scalars['DateTime']>;
  orderSysId: Scalars['String'];
};

export type DrDosageFrequencyDto = {
  __typename?: 'DrDosageFrequencyDto';
  alternativeDosage?: Maybe<Array<Scalars['String']>>;
  alternativeDosageUnit?: Maybe<DosageUnit>;
  asNeeded?: Maybe<Scalars['Boolean']>;
  dosage?: Maybe<Array<Scalars['String']>>;
  dosageUnit?: Maybe<DosageUnit>;
  duration?: Maybe<Array<Scalars['String']>>;
  durationUnit?: Maybe<DosageDurationUnit>;
  frequency?: Maybe<Array<Scalars['String']>>;
  productId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  quantityUnit?: Maybe<DosageQuantityUnit>;
};

export type DuplicateStripePriceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billingScheme?: InputMaybe<StripePriceBillingScheme>;
  currency: Scalars['String'];
  expand?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  recurring?: InputMaybe<StripePriceRecurringInput>;
  unitAmount?: InputMaybe<Scalars['Float']>;
};

export type EditDeliveryTimeModel = {
  __typename?: 'EditDeliveryTimeModel';
  canEdit?: Maybe<Scalars['Boolean']>;
  isEditWithin2Hours?: Maybe<Scalars['Boolean']>;
};

export enum ErrorCode {
  AcuityAppointmentNotFound = 'AcuityAppointmentNotFound',
  AcuityRequestError = 'AcuityRequestError',
  AddCashbackToTheCustomerError = 'AddCashbackToTheCustomerError',
  AddPermissionsToRoleError = 'AddPermissionsToRoleError',
  AddRolesToUserError = 'AddRolesToUserError',
  ApplyPromotionCodeForAnonymousError = 'ApplyPromotionCodeForAnonymousError',
  ApplyPromotionCodeForCartError = 'ApplyPromotionCodeForCartError',
  ApplyPromotionFromBannerError = 'ApplyPromotionFromBannerError',
  ApproveErrorCannotPrescribeTrialProduct = 'ApproveErrorCannotPrescribeTrialProduct',
  ApproveErrorProductNotEligible = 'ApproveErrorProductNotEligible',
  ApprovePrescriptionOrderError = 'ApprovePrescriptionOrderError',
  ArchiveStripePrice = 'ArchiveStripePrice',
  ArchiveStripeProduct = 'ArchiveStripeProduct',
  AttachPaymentIntentError = 'AttachPaymentIntentError',
  AttachPaymentMethodError = 'AttachPaymentMethodError',
  AttachPaymentMethodWithIntentForAnonymousError = 'AttachPaymentMethodWithIntentForAnonymousError',
  AuthenticateError = 'AuthenticateError',
  BookAppointmentForOrderError = 'BookAppointmentForOrderError',
  BookFuAppointment = 'BookFUAppointment',
  BookPrescriptionReviewAppointmentError = 'BookPrescriptionReviewAppointmentError',
  CodInvoiceNotFound = 'CODInvoiceNotFound',
  CalculateCartError = 'CalculateCartError',
  CanEditDeliveryTimeError = 'CanEditDeliveryTimeError',
  CancelAppointmentError = 'CancelAppointmentError',
  CancelCheckIn = 'CancelCheckIn',
  CancelOrderError = 'CancelOrderError',
  CancelPaymentIntentError = 'CancelPaymentIntentError',
  CancelSubscriptionByOrderIdError = 'CancelSubscriptionByOrderIdError',
  CannotCreatePaymentIntentOrSubscriptionError = 'CannotCreatePaymentIntentOrSubscriptionError',
  CannotCreatePromotionCodeError = 'CannotCreatePromotionCodeError',
  CannotDeliveryError = 'CannotDeliveryError',
  CannotDetectSelectableProductsError = 'CannotDetectSelectableProductsError',
  CannotSwitchNewPriceTypeError = 'CannotSwitchNewPriceTypeError',
  CartItemAlreadyExist = 'CartItemAlreadyExist',
  CartItemNotFoundError = 'CartItemNotFoundError',
  CartItemsNotFoundError = 'CartItemsNotFoundError',
  CartNotFoundError = 'CartNotFoundError',
  CartStatusUnavailableError = 'CartStatusUnavailableError',
  CartsNotFoundError = 'CartsNotFoundError',
  ChangeAutoRenewalModeOrderError = 'ChangeAutoRenewalModeOrderError',
  ChangeDeliveryStatusError = 'ChangeDeliveryStatusError',
  ChangeDeliveryWindowError = 'ChangeDeliveryWindowError',
  ChangeNewPriceOrderError = 'ChangeNewPriceOrderError',
  ChangePasswordError = 'ChangePasswordError',
  ChangePriceKonbiniOrder = 'ChangePriceKonbiniOrder',
  ChangeRoInOpsError = 'ChangeROInOpsError',
  ChargeConsultFeeKonbiniOrder = 'ChargeConsultFeeKonbiniOrder',
  CheckAvailableSupportCod = 'CheckAvailableSupportCod',
  CheckFreeSessionAvailableError = 'CheckFreeSessionAvailableError',
  CheckProductsExistingOrdersForPatientError = 'CheckProductsExistingOrdersForPatientError',
  CheckValidAtomePaymentLinkError = 'CheckValidAtomePaymentLinkError',
  CheckValidConversationsForDoctorError = 'CheckValidConversationsForDoctorError',
  CheckValidConversationsForPatientError = 'CheckValidConversationsForPatientError',
  CheckoutAnonymousError = 'CheckoutAnonymousError',
  CheckoutCartError = 'CheckoutCartError',
  CheckoutCartNotFound = 'CheckoutCartNotFound',
  CheckoutCoachError = 'CheckoutCoachError',
  CleanMissingPatientPaidEvalIdsError = 'CleanMissingPatientPaidEvalIdsError',
  CompleteFollowUpConsult = 'CompleteFollowUpConsult',
  ConfirmChangePrescriptionError = 'ConfirmChangePrescriptionError',
  ConfirmChargeCovidPrescriptionOrderError = 'ConfirmChargeCovidPrescriptionOrderError',
  ConfirmCodOrder = 'ConfirmCodOrder',
  ConfirmKonbiniOrder = 'ConfirmKonbiniOrder',
  ConsultTypeNotAvailable = 'ConsultTypeNotAvailable',
  ConsultationNotFound = 'ConsultationNotFound',
  ContinueLaterTokenNotFoundError = 'ContinueLaterTokenNotFoundError',
  ConvertReferralPromoCodeValueToCashbackError = 'ConvertReferralPromoCodeValueToCashbackError',
  CountOrderingOfAnEvalProductsError = 'CountOrderingOfAnEvalProductsError',
  CreateCompletedEvalError = 'CreateCompletedEvalError',
  CreateCompletedEvalForGuestsError = 'CreateCompletedEvalForGuestsError',
  CreateCronjobError = 'CreateCronjobError',
  CreateEvaluationQuestionError = 'CreateEvaluationQuestionError',
  CreateGiveawayRecordError = 'CreateGiveawayRecordError',
  CreateGroupChatError = 'CreateGroupChatError',
  CreateGuestEvaluationError = 'CreateGuestEvaluationError',
  CreateInvoiceError = 'CreateInvoiceError',
  CreateNewSurveyError = 'CreateNewSurveyError',
  CreateOtcWalletOrderError = 'CreateOTCWalletOrderError',
  CreateOrderError = 'CreateOrderError',
  CreateOrderWithoutChargeError = 'CreateOrderWithoutChargeError',
  CreateOrdersAfterTeleConsultError = 'CreateOrdersAfterTeleConsultError',
  CreatePatientFromOpsError = 'CreatePatientFromOpsError',
  CreatePermissionError = 'CreatePermissionError',
  CreateProductError = 'CreateProductError',
  CreateResourceError = 'CreateResourceError',
  CreateRoleError = 'CreateRoleError',
  CreateScopeError = 'CreateScopeError',
  CreateSendGridTemplateError = 'CreateSendGridTemplateError',
  CreateSetupIntent = 'CreateSetupIntent',
  CreateStripeCoupon = 'CreateStripeCoupon',
  CreateStripePrice = 'CreateStripePrice',
  CreateStripeProduct = 'CreateStripeProduct',
  CreateStripeProductPrice = 'CreateStripeProductPrice',
  CreateStripePromotionCode = 'CreateStripePromotionCode',
  CreateUserError = 'CreateUserError',
  CrossPlatformLogIn = 'CrossPlatformLogIn',
  CurrentPriceNotFoundError = 'CurrentPriceNotFoundError',
  DeleteAuditDoctorNoteError = 'DeleteAuditDoctorNoteError',
  DeleteCartItemByIdError = 'DeleteCartItemByIdError',
  DeleteCompletedEvalError = 'DeleteCompletedEvalError',
  DeleteOrderError = 'DeleteOrderError',
  DeleteOrderPermanentError = 'DeleteOrderPermanentError',
  DeletePatientQuestionAnswerError = 'DeletePatientQuestionAnswerError',
  DeletePermissionError = 'DeletePermissionError',
  DeleteResourceError = 'DeleteResourceError',
  DeleteRoleError = 'DeleteRoleError',
  DeleteScopeError = 'DeleteScopeError',
  DeleteStripeCoupon = 'DeleteStripeCoupon',
  DeleteStripePrice = 'DeleteStripePrice',
  DeleteStripeProduct = 'DeleteStripeProduct',
  DeleteStripeProductPrice = 'DeleteStripeProductPrice',
  DeleteUserError = 'DeleteUserError',
  DeliveryChargeError = 'DeliveryChargeError',
  DetrackRequestError = 'DetrackRequestError',
  DisableProductError = 'DisableProductError',
  DoctorNotFoundError = 'DoctorNotFoundError',
  DuplicateStripePrice = 'DuplicateStripePrice',
  EmailAlreadyUsedError = 'EmailAlreadyUsedError',
  EmailPermissionError = 'EmailPermissionError',
  ExistEmailError = 'ExistEmailError',
  FbTrackingCompleteEvalError = 'FbTrackingCompleteEvalError',
  FbTrackingPageViewError = 'FbTrackingPageViewError',
  FbTrackingStartEvalError = 'FbTrackingStartEvalError',
  FcmRegistrationError = 'FcmRegistrationError',
  GetActiveProductsError = 'GetActiveProductsError',
  GetAcuityAppointmentError = 'GetAcuityAppointmentError',
  GetAcuityIdsError = 'GetAcuityIdsError',
  GetAddressesError = 'GetAddressesError',
  GetAllEvaluationFormsError = 'GetAllEvaluationFormsError',
  GetAllPrescriptionsError = 'GetAllPrescriptionsError',
  GetAllStripeProductsError = 'GetAllStripeProductsError',
  GetAppointmentTypeByOrder = 'GetAppointmentTypeByOrder',
  GetAuditDoctorNotesError = 'GetAuditDoctorNotesError',
  GetAvailableSlotsError = 'GetAvailableSlotsError',
  GetAvailableSlotsForDeliveryError = 'GetAvailableSlotsForDeliveryError',
  GetBookingResultError = 'GetBookingResultError',
  GetCartByIdError = 'GetCartByIdError',
  GetCartError = 'GetCartError',
  GetCartsByFilterError = 'GetCartsByFilterError',
  GetCashbackAvailableBalanceError = 'GetCashbackAvailableBalanceError',
  GetCashbackDashboardError = 'GetCashbackDashboardError',
  GetCheckoutCartByIdError = 'GetCheckoutCartByIdError',
  GetCheckoutCartByOrderIdError = 'GetCheckoutCartByOrderIdError',
  GetCompletedEvalByContinueTokenError = 'GetCompletedEvalByContinueTokenError',
  GetCompletedEvalByFilterError = 'GetCompletedEvalByFilterError',
  GetCompletedEvaluationError = 'GetCompletedEvaluationError',
  GetConfigEnvironmentError = 'GetConfigEnvironmentError',
  GetConsultTextData = 'GetConsultTextData',
  GetConsultationSessionByFilter = 'GetConsultationSessionByFilter',
  GetConsultationSessionByOrders = 'GetConsultationSessionByOrders',
  GetContinueTrialOrderDataError = 'GetContinueTrialOrderDataError',
  GetCovidStripeProductError = 'GetCovidStripeProductError',
  GetCronjobsByFilterError = 'GetCronjobsByFilterError',
  GetCurrentPatientOnboardingError = 'GetCurrentPatientOnboardingError',
  GetDashboardForCategoryBoostError = 'GetDashboardForCategoryBoostError',
  GetDashboardForCategoryCheckError = 'GetDashboardForCategoryCheckError',
  GetDashboardForCategoryMonitorError = 'GetDashboardForCategoryMonitorError',
  GetDashboardForCategoryOptimiseError = 'GetDashboardForCategoryOptimiseError',
  GetDashboardForCategoryTrackError = 'GetDashboardForCategoryTrackError',
  GetDeliveryOrderByFilterError = 'GetDeliveryOrderByFilterError',
  GetDispatchJobByFilterError = 'GetDispatchJobByFilterError',
  GetDoctorBioError = 'GetDoctorBioError',
  GetDoctorDashboardOrdersByFilterError = 'GetDoctorDashboardOrdersByFilterError',
  GetDoctorInAuthError = 'GetDoctorInAuthError',
  GetDoctorOrdersError = 'GetDoctorOrdersError',
  GetDoctorsByFilterError = 'GetDoctorsByFilterError',
  GetDoctorsWithAppointmentTypeError = 'GetDoctorsWithAppointmentTypeError',
  GetEvaluationByFilter = 'GetEvaluationByFilter',
  GetEvaluationByOrdersError = 'GetEvaluationByOrdersError',
  GetEvaluationDashboardError = 'GetEvaluationDashboardError',
  GetEvaluationFormByFilterError = 'GetEvaluationFormByFilterError',
  GetExcludedEvalIdsForShowingTreatmentError = 'GetExcludedEvalIdsForShowingTreatmentError',
  GetExcludedEvaluationIdsError = 'GetExcludedEvaluationIdsError',
  GetExtraInfoForEditingOrderError = 'GetExtraInfoForEditingOrderError',
  GetExtraProductPriceInfoByEvaluation = 'GetExtraProductPriceInfoByEvaluation',
  GetGiveAwayByFilterError = 'GetGiveAwayByFilterError',
  GetImagesByFilterError = 'GetImagesByFilterError',
  GetInsightsDataError = 'GetInsightsDataError',
  GetInvoicesBySubscriptionIdError = 'GetInvoicesBySubscriptionIdError',
  GetLabelFromDetrackError = 'GetLabelFromDetrackError',
  GetLastInvoiceDateError = 'GetLastInvoiceDateError',
  GetLastTreatmentOrderError = 'GetLastTreatmentOrderError',
  GetListAcuityAppointmentByFilterError = 'GetListAcuityAppointmentByFilterError',
  GetListOrderConsultationByFilterError = 'GetListOrderConsultationByFilterError',
  GetOpsDashboardOrdersListByFilterError = 'GetOpsDashboardOrdersListByFilterError',
  GetOpsDoctorUsersError = 'GetOpsDoctorUsersError',
  GetOpsOrderDetail = 'GetOpsOrderDetail',
  GetOrderByFilterError = 'GetOrderByFilterError',
  GetOrderByIdError = 'GetOrderByIdError',
  GetOrderByIdWithDisplayIdError = 'GetOrderByIdWithDisplayIdError',
  GetOrderByProductError = 'GetOrderByProductError',
  GetOrderDetailWithPatientError = 'GetOrderDetailWithPatientError',
  GetPatientBookingInfoError = 'GetPatientBookingInfoError',
  GetPatientByFilterError = 'GetPatientByFilterError',
  GetPatientByIdError = 'GetPatientByIdError',
  GetPatientByIdsError = 'GetPatientByIdsError',
  GetPatientByReferralCodeError = 'GetPatientByReferralCodeError',
  GetPatientDataError = 'GetPatientDataError',
  GetPatientInfoError = 'GetPatientInfoError',
  GetPatientListForDoctorError = 'GetPatientListForDoctorError',
  GetPatientPlanDetailDataError = 'GetPatientPlanDetailDataError',
  GetPatientPlansDataError = 'GetPatientPlansDataError',
  GetPatientProfileForPregnancyChecklistError = 'GetPatientProfileForPregnancyChecklistError',
  GetPatientPromotionCodesError = 'GetPatientPromotionCodesError',
  GetPlansError = 'GetPlansError',
  GetPrescriptionByFilterError = 'GetPrescriptionByFilterError',
  GetPrescriptionByIdError = 'GetPrescriptionByIdError',
  GetPrescriptionOrderBookingResult = 'GetPrescriptionOrderBookingResult',
  GetPrescriptionOrderCalculation = 'GetPrescriptionOrderCalculation',
  GetPriceByIntentIdError = 'GetPriceByIntentIdError',
  GetPriceInfobyIdsError = 'GetPriceInfobyIdsError',
  GetPriceTranslatedTextError = 'GetPriceTranslatedTextError',
  GetPricesByProductIdsError = 'GetPricesByProductIdsError',
  GetProductByFilterError = 'GetProductByFilterError',
  GetProductInfoError = 'GetProductInfoError',
  GetProductTranslatedTextError = 'GetProductTranslatedTextError',
  GetReferralCouponError = 'GetReferralCouponError',
  GetReferralDataError = 'GetReferralDataError',
  GetShopInfoError = 'GetShopInfoError',
  GetStripeCouponByIdError = 'GetStripeCouponByIdError',
  GetStripePriceByIdError = 'GetStripePriceByIdError',
  GetStripePricesByFilterError = 'GetStripePricesByFilterError',
  GetStripeProductByFilterError = 'GetStripeProductByFilterError',
  GetStripeProductById = 'GetStripeProductById',
  GetStripeProductByIdError = 'GetStripeProductByIdError',
  GetStripeProductByIdsError = 'GetStripeProductByIdsError',
  GetStripeProductByUniqNamesError = 'GetStripeProductByUniqNamesError',
  GetStripeProductPricesByFilterError = 'GetStripeProductPricesByFilterError',
  GetStripePromotionCodeByIdError = 'GetStripePromotionCodeByIdError',
  GetSubscriptionByIdError = 'GetSubscriptionByIdError',
  GetSuggestionsError = 'GetSuggestionsError',
  GetSurveyListError = 'GetSurveyListError',
  GetTaskListError = 'GetTaskListError',
  GetTeleConsultOrdersError = 'GetTeleConsultOrdersError',
  GetTextConversationFromOps = 'GetTextConversationFromOps',
  GetThankyouDataError = 'GetThankyouDataError',
  GetTwilioVideoConsultDataFromDoctorError = 'GetTwilioVideoConsultDataFromDoctorError',
  GetTwilioVideoConsultDataFromPatientError = 'GetTwilioVideoConsultDataFromPatientError',
  GetUpcomingInvoiceDateError = 'GetUpcomingInvoiceDateError',
  GetUsersByRoleError = 'GetUsersByRoleError',
  ImpersonateError = 'ImpersonateError',
  ImportProductWithoutPrice = 'ImportProductWithoutPrice',
  ImportProductsAndPricesError = 'ImportProductsAndPricesError',
  InitiateCheckoutTrackingError = 'InitiateCheckoutTrackingError',
  InsertCartItemByIdError = 'InsertCartItemByIdError',
  InternalError = 'InternalError',
  InternalServerError = 'InternalServerError',
  InvalidApi = 'InvalidAPI',
  InvalidCronjobName = 'InvalidCronjobName',
  InvalidDoctorToAssignDoctorNote = 'InvalidDoctorToAssignDoctorNote',
  InvalidOrderError = 'InvalidOrderError',
  InvalidOrderStatusError = 'InvalidOrderStatusError',
  InvalidPaymentProviderError = 'InvalidPaymentProviderError',
  InvalidPriceError = 'InvalidPriceError',
  InvalidRequestQty = 'InvalidRequestQty',
  InvalidStatusForChangingAtomeRenewalError = 'InvalidStatusForChangingAtomeRenewalError',
  InvalidStatusMovement = 'InvalidStatusMovement',
  InvestigateSyncingConversationForExistingRxOrdersError = 'InvestigateSyncingConversationForExistingRxOrdersError',
  IsAutoRenewalSubError = 'IsAutoRenewalSubError',
  IsNoahMigrationValidError = 'IsNoahMigrationValidError',
  LineNotRegisterWithEMailError = 'LineNotRegisterWithEMailError',
  LogInError = 'LogInError',
  LogInFacebookError = 'LogInFacebookError',
  LogInGoogleError = 'LogInGoogleError',
  LogInLineError = 'LogInLineError',
  LogInYahooError = 'LogInYahooError',
  LogOutError = 'LogOutError',
  MigrateArchivePricesError = 'MigrateArchivePricesError',
  MigratePausedToActiveError = 'MigratePausedToActiveError',
  MigrateProductIncludedError = 'MigrateProductIncludedError',
  MissingDoctorWhenCreateAuditDoctorNote = 'MissingDoctorWhenCreateAuditDoctorNote',
  MissingImplementation = 'MissingImplementation',
  MissingParcelId = 'MissingParcelId',
  MissingShipmentSysId = 'MissingShipmentSysId',
  NewPriceNotFoundError = 'NewPriceNotFoundError',
  NotCompletedEvaluationError = 'NotCompletedEvaluationError',
  NotFoundCurrentEvaluationError = 'NotFoundCurrentEvaluationError',
  NotFoundEvaluationBlockError = 'NotFoundEvaluationBlockError',
  NotFoundEvaluationError = 'NotFoundEvaluationError',
  NotFoundEvaluationQuestionError = 'NotFoundEvaluationQuestionError',
  NotFoundLatestInvoiceError = 'NotFoundLatestInvoiceError',
  NotFoundListQuestionAnswerError = 'NotFoundListQuestionAnswerError',
  NotFoundPatientError = 'NotFoundPatientError',
  NotFoundQuestionError = 'NotFoundQuestionError',
  NotFoundQuestionsError = 'NotFoundQuestionsError',
  NotFoundTrackingAdsError = 'NotFoundTrackingAdsError',
  NotHaveOtcError = 'NotHaveOtcError',
  NotMinError = 'NotMinError',
  NotSupportEvaluationError = 'NotSupportEvaluationError',
  NotSupportPaymentProvider = 'NotSupportPaymentProvider',
  OpsChargeOtcOrderError = 'OPSChargeOtcOrderError',
  OldGetDoctorOrdersError = 'OldGetDoctorOrdersError',
  OpsChangeDeliveryWindowError = 'OpsChangeDeliveryWindowError',
  OrderIsNotAtomePaymentError = 'OrderIsNotAtomePaymentError',
  OrderIsPausedError = 'OrderIsPausedError',
  OrderNotFoundError = 'OrderNotFoundError',
  OrderNotValidError = 'OrderNotValidError',
  OrderStatusInvalidError = 'OrderStatusInvalidError',
  OrdersError = 'OrdersError',
  OrdersNotFoundError = 'OrdersNotFoundError',
  PatientIdIsRequiredError = 'PatientIdIsRequiredError',
  PatientNotFoundError = 'PatientNotFoundError',
  PatientPaymentMethodsNotFoundError = 'PatientPaymentMethodsNotFoundError',
  PatientWithThatEmailAlreadyExistsError = 'PatientWithThatEmailAlreadyExistsError',
  PauseAndResumeSubscriptionError = 'PauseAndResumeSubscriptionError',
  PaymentMethodNotFoundError = 'PaymentMethodNotFoundError',
  PermissionsError = 'PermissionsError',
  PrescriptionCheckout = 'PrescriptionCheckout',
  PriceNotFoundError = 'PriceNotFoundError',
  ProcessCartByOtcWalletError = 'ProcessCartByOTCWalletError',
  ProductNotFoundError = 'ProductNotFoundError',
  ProductOfPriceNotFoundError = 'ProductOfPriceNotFoundError',
  PromotionCodeFirstOrderOnly = 'PromotionCodeFirstOrderOnly',
  PromotionCodeNewOnly = 'PromotionCodeNewOnly',
  PromotionCodeRenewOnly = 'PromotionCodeRenewOnly',
  PromotionCodeUnavailableError = 'PromotionCodeUnavailableError',
  PromotionCodeWrongError = 'PromotionCodeWrongError',
  ReAssignDoctorForNoteError = 'ReAssignDoctorForNoteError',
  ReAssignTextConsultationDoctor = 'ReAssignTextConsultationDoctor',
  ReactivateCanceledOrder = 'ReactivateCanceledOrder',
  ReferralNotFound = 'ReferralNotFound',
  RefreshAccessTokenError = 'RefreshAccessTokenError',
  RefreshTokenInvalidError = 'RefreshTokenInvalidError',
  RefundChargedForAdminError = 'RefundChargedForAdminError',
  RefundInvoiceForAdminError = 'RefundInvoiceForAdminError',
  RefundOtcWalletPayOrderError = 'RefundOTCWalletPayOrderError',
  RefundPaymentIntentError = 'RefundPaymentIntentError',
  RefundPaymentIntentForAdminError = 'RefundPaymentIntentForAdminError',
  RefundPaymentIntentForAnonymousError = 'RefundPaymentIntentForAnonymousError',
  RegisterAndEvaluation = 'RegisterAndEvaluation',
  RegisterDoctorError = 'RegisterDoctorError',
  RegisterError = 'RegisterError',
  RegisterPatientError = 'RegisterPatientError',
  RejectPrescriptionOrderError = 'RejectPrescriptionOrderError',
  RemoveCardDetailPatientError = 'RemoveCardDetailPatientError',
  RemovePermissionsToRoleError = 'RemovePermissionsToRoleError',
  RemoveRolesToUserError = 'RemoveRolesToUserError',
  RenewCodOrder = 'RenewCodOrder',
  RenewKonbiniOrder = 'RenewKonbiniOrder',
  RenewOrderByOpsError = 'RenewOrderByOpsError',
  RenewOrderByPatientError = 'RenewOrderByPatientError',
  RenewOrderError = 'RenewOrderError',
  RequestFollowUpConsult = 'RequestFollowUpConsult',
  RescheduleAppointment = 'RescheduleAppointment',
  ResetPasswordError = 'ResetPasswordError',
  ResetPasswordWithTokenError = 'ResetPasswordWithTokenError',
  ResourceNotFoundError = 'ResourceNotFoundError',
  ResourcesError = 'ResourcesError',
  ResponseAppointmentError = 'ResponseAppointmentError',
  RolesError = 'RolesError',
  ScopesError = 'ScopesError',
  SearchTrackingError = 'SearchTrackingError',
  SelectedPriceNotFoundError = 'SelectedPriceNotFoundError',
  SendFirstDefaultAutomatedMessage = 'SendFirstDefaultAutomatedMessage',
  SendForgotPasswordError = 'SendForgotPasswordError',
  SendMailForgotPasswordError = 'SendMailForgotPasswordError',
  SendReminderUnreadDrMessage = 'SendReminderUnreadDrMessage',
  SendResetPasswordEmailError = 'SendResetPasswordEmailError',
  SendToDetrackAndProcessingDeliveryError = 'SendToDetrackAndProcessingDeliveryError',
  SendTwilioMessageError = 'SendTwilioMessageError',
  SendTwilioMessageInvalidPhoneNumber = 'SendTwilioMessageInvalidPhoneNumber',
  ShipmentItemNotFound = 'ShipmentItemNotFound',
  ShipmentNotFound = 'ShipmentNotFound',
  SignInAnonymousUserError = 'SignInAnonymousUserError',
  SkipSurveyError = 'SkipSurveyError',
  SkipSurveyForCartError = 'SkipSurveyForCartError',
  StartCronJobError = 'StartCronJobError',
  StatusOtcWalletOrderUnavailableError = 'StatusOTCWalletOrderUnavailableError',
  StopCronJobError = 'StopCronJobError',
  StripeCustomerNotFoundError = 'StripeCustomerNotFoundError',
  StripeCustomerWasDeleted = 'StripeCustomerWasDeleted',
  StripeCustomerWithThatEmailAlreadyExistsError = 'StripeCustomerWithThatEmailAlreadyExistsError',
  StripeIdIsAlreadyUsedError = 'StripeIdIsAlreadyUsedError',
  StripeProductNotFoundError = 'StripeProductNotFoundError',
  SubscriptionNotAuthorError = 'SubscriptionNotAuthorError',
  SubscriptionNotFoundError = 'SubscriptionNotFoundError',
  SwitchConsultationSessionByOrder = 'SwitchConsultationSessionByOrder',
  SyncConversationForExistingOrdersError = 'SyncConversationForExistingOrdersError',
  SyncMissingLatestInvoiceForSubscriptionOrdersError = 'SyncMissingLatestInvoiceForSubscriptionOrdersError',
  SyncStripeProductsError = 'SyncStripeProductsError',
  TemplateNotFoundError = 'TemplateNotFoundError',
  TextConsultNotFound = 'TextConsultNotFound',
  TheStatusIsInvalidError = 'TheStatusIsInvalidError',
  TimeSlotNotValidError = 'TimeSlotNotValidError',
  TriggerCronFuBooking24hrReminderError = 'TriggerCronFuBooking24hrReminderError',
  TriggerCronJobCompleteConsultReminderError = 'TriggerCronJobCompleteConsultReminderError',
  TriggerCronJobConsultReminderError = 'TriggerCronJobConsultReminderError',
  TriggerCronJobReminderVideoConsultError = 'TriggerCronJobReminderVideoConsultError',
  TriggerCronJobSubPeriodEndReminderError = 'TriggerCronJobSubPeriodEndReminderError',
  TriggerEdTrialEmailReminderError = 'TriggerEDTrialEmailReminderError',
  TriggerSubPeriodEndReminder = 'TriggerSubPeriodEndReminder',
  TriggerSubRenewalEmailReminderError = 'TriggerSubRenewalEmailReminderError',
  TrtTriageDisqualified = 'TrtTriageDisqualified',
  TrySecondOpinion = 'TrySecondOpinion',
  UpdateCartCalculateOrderSummaryError = 'UpdateCartCalculateOrderSummaryError',
  UpdateCartItemByIdError = 'UpdateCartItemByIdError',
  UpdateChecklistTrackingError = 'UpdateChecklistTrackingError',
  UpdateCompletedEvalError = 'UpdateCompletedEvalError',
  UpdateCompletedEvalForGuestsError = 'UpdateCompletedEvalForGuestsError',
  UpdateCustomerBalanceTransactionError = 'UpdateCustomerBalanceTransactionError',
  UpdateDoctorError = 'UpdateDoctorError',
  UpdateEvaluationProgressError = 'UpdateEvaluationProgressError',
  UpdateOrderError = 'UpdateOrderError',
  UpdateOtherInterestedEvalIdsError = 'UpdateOtherInterestedEvalIdsError',
  UpdatePatientInfoError = 'UpdatePatientInfoError',
  UpdatePatientSubscriptionsPaymentMethod = 'UpdatePatientSubscriptionsPaymentMethod',
  UpdatePaymentStatusForCodOrderError = 'UpdatePaymentStatusForCodOrderError',
  UpdatePermissionError = 'UpdatePermissionError',
  UpdateProductImageUrls = 'UpdateProductImageUrls',
  UpdateResourceError = 'UpdateResourceError',
  UpdateRoleError = 'UpdateRoleError',
  UpdateScopeError = 'UpdateScopeError',
  UpdateStripeCoupon = 'UpdateStripeCoupon',
  UpdateStripeCouponMetadataError = 'UpdateStripeCouponMetadataError',
  UpdateStripePrice = 'UpdateStripePrice',
  UpdateStripePriceLocaleError = 'UpdateStripePriceLocaleError',
  UpdateStripePriceMetadata = 'UpdateStripePriceMetadata',
  UpdateStripeProduct = 'UpdateStripeProduct',
  UpdateStripeProductLocaleError = 'UpdateStripeProductLocaleError',
  UpdateStripeProductMetadata = 'UpdateStripeProductMetadata',
  UpdateStripeProductPrice = 'UpdateStripeProductPrice',
  UpdateStripePromotionCode = 'UpdateStripePromotionCode',
  UpdateStripePromotionCodeMetadataError = 'UpdateStripePromotionCodeMetadataError',
  UpdateUserError = 'UpdateUserError',
  UpdateVoidInvoice = 'UpdateVoidInvoice',
  UploadFileError = 'UploadFileError',
  UploadPublicFileError = 'UploadPublicFileError',
  UpsertPatientTourViewingError = 'UpsertPatientTourViewingError',
  UserError = 'UserError',
  UserNotAuthError = 'UserNotAuthError',
  UserNotAuthorError = 'UserNotAuthorError',
  UserNotFoundError = 'UserNotFoundError',
  UserWithThatEmailAlreadyExistsError = 'UserWithThatEmailAlreadyExistsError',
  UserWithThisEmailDoesNotExistError = 'UserWithThisEmailDoesNotExistError',
  UserWithThisRequestDoesNotExistError = 'UserWithThisRequestDoesNotExistError',
  UsersError = 'UsersError',
  VerifyForgotPasswordError = 'VerifyForgotPasswordError',
  WrongCredentialsProvidedError = 'WrongCredentialsProvidedError'
}

export enum EvalIds {
  Acne = 'acne',
  AcneZoey = 'acne_zoey',
  BirthControl = 'birth_control',
  BloodTest = 'blood_test',
  CovidTeleconsult = 'covid_teleconsult',
  Ed = 'ed',
  EdGeneral = 'ed_general',
  EmergencyContraception = 'emergency_contraception',
  Hairloss = 'hairloss',
  HairlossGeneral = 'hairloss_general',
  HairlossHk = 'hairloss_hk',
  HairlossZoey = 'hairloss_zoey',
  Mhp = 'mhp',
  Nutritionist = 'nutritionist',
  Pe = 'pe',
  PeGeneral = 'pe_general',
  PregnancyChecklist = 'pregnancy_checklist',
  SexTherapy = 'sex_therapy',
  SexTherapyZoey = 'sex_therapy_zoey',
  SmokingCessation = 'smoking_cessation',
  SmokingCessationZoey = 'smoking_cessation_zoey',
  Therapy = 'therapy',
  TherapyZoey = 'therapy_zoey',
  Trt = 'trt',
  VigourNoah = 'vigour_noah',
  WeightLoss = 'weight_loss',
  WeightLossGeneral = 'weight_loss_general',
  WeightLossSg = 'weight_loss_sg',
  WeightLossZoey = 'weight_loss_zoey'
}

export type EvalResultInput = {
  answerId?: InputMaybe<Scalars['String']>;
  questionId: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type EvaluationBlockContentDto = {
  __typename?: 'EvaluationBlockContentDto';
  description?: Maybe<Scalars['String']>;
  descriptionTextKey?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleTextKey?: Maybe<Scalars['String']>;
};

export type EvaluationBlockContentModel = {
  __typename?: 'EvaluationBlockContentModel';
  description?: Maybe<Scalars['String']>;
  descriptionTextKey?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  titleTextKey: Scalars['String'];
};

export type EvaluationBlockDto = {
  __typename?: 'EvaluationBlockDto';
  blockAnswer?: Maybe<AnswerDto>;
  content?: Maybe<EvaluationBlockContentDto>;
  sysId?: Maybe<Scalars['String']>;
};

export type EvaluationBlockModel = {
  __typename?: 'EvaluationBlockModel';
  blockByQuestion?: Maybe<QuestionModel>;
  content?: Maybe<EvaluationBlockContentModel>;
  evaluation: EvaluationModel;
  patientEvaluations?: Maybe<Array<Maybe<PatientEvaluationModel>>>;
  questionAnswer: QuestionAnswerModel;
  sysId?: Maybe<Scalars['String']>;
};

export type EvaluationDashboardModel = {
  __typename?: 'EvaluationDashboardModel';
  currentPatientEvaluation?: Maybe<PatientEvaluationModel>;
  evaluation: EvaluationModel;
  evaluationQuestions: Array<EvaluationQuestionAnswerModel>;
  patientEvaluations?: Maybe<Array<Scalars['JSON']>>;
  patientQuestionAnswers?: Maybe<Array<Scalars['JSON']>>;
};

export type EvaluationData = {
  answers: Array<EvaluationField>;
  question: EvaluationField;
};

export type EvaluationDto = {
  __typename?: 'EvaluationDto';
  isCompleted?: Maybe<Scalars['Boolean']>;
  isSkipped?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  patientAnswers?: Maybe<Array<Maybe<PatientEvaluationAnswersDto>>>;
  patientNote?: Maybe<Scalars['String']>;
  platform?: Maybe<PlatformType>;
  questions?: Maybe<Array<Maybe<QuestionDto>>>;
  status?: Maybe<EvaluationStatus>;
  sysId?: Maybe<Scalars['String']>;
  type?: Maybe<EvalIds>;
};

export type EvaluationField = {
  text: Scalars['String'];
  textKey: Scalars['String'];
};

export type EvaluationFormInput = {
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  onCompleteRedirect?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type EvaluationFormModel = {
  __typename?: 'EvaluationFormModel';
  createdAt: Scalars['DateTime'];
  customFields?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  formSections?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  learnMoreLink?: Maybe<Scalars['JSON']>;
  onCompleteRedirect?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
  version?: Maybe<Scalars['String']>;
};

export type EvaluationInput = {
  learnMore?: InputMaybe<EvaluationLearnMoreInput>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PlatformType>;
  status?: InputMaybe<EvaluationStatus>;
  type?: InputMaybe<EvalIds>;
};

export type EvaluationLearnMoreInput = {
  link?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type EvaluationLearnMoreModel = {
  __typename?: 'EvaluationLearnMoreModel';
  link?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EvaluationModel = {
  __typename?: 'EvaluationModel';
  evaluationBlocks?: Maybe<Array<Maybe<EvaluationBlockModel>>>;
  evaluationQuestions?: Maybe<Array<Maybe<EvaluationQuestionModel>>>;
  learnMore?: Maybe<EvaluationLearnMoreModel>;
  name?: Maybe<Scalars['String']>;
  patientEvaluations?: Maybe<Array<Maybe<PatientEvaluationModel>>>;
  platform?: Maybe<PlatformType>;
  status?: Maybe<EvaluationStatus>;
  sysId?: Maybe<Scalars['String']>;
  type?: Maybe<EvalIds>;
};

export type EvaluationQuestionAnswerModel = {
  __typename?: 'EvaluationQuestionAnswerModel';
  answers?: Maybe<Array<Scalars['JSON']>>;
  content?: Maybe<Scalars['JSON']>;
  dependentEvaluationQuestions?: Maybe<Array<Scalars['JSON']>>;
  displayPage: Scalars['Float'];
  evaluationBlocks?: Maybe<Array<Scalars['JSON']>>;
  guestOnly: Scalars['Boolean'];
  order: Scalars['Float'];
  question: Scalars['JSON'];
  sysId?: Maybe<Scalars['String']>;
  validation?: Maybe<Scalars['JSON']>;
};

export type EvaluationQuestionModel = {
  __typename?: 'EvaluationQuestionModel';
  content?: Maybe<ContentEvaluationQuestionModel>;
  dependentEvaluationQuestions?: Maybe<Array<Maybe<DependentEvaluationQuestionModel>>>;
  displayPage: Scalars['Float'];
  evaluation: EvaluationModel;
  guestOnly: Scalars['Boolean'];
  order: Scalars['Float'];
  question: QuestionModel;
  sysId?: Maybe<Scalars['String']>;
  validation?: Maybe<ValidationEvaluationQuestionModel>;
};

export type EvaluationResultsInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  evaluationType: EvalIds;
  results?: InputMaybe<Array<InputMaybe<EvalResultInput>>>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export enum EvaluationStatus {
  Active = 'active',
  Disable = 'disable'
}

export enum EvaluationValidation {
  BloodPressure = 'BloodPressure',
  Dob = 'DOB',
  Height = 'Height',
  MaxDateCurrent = 'MaxDateCurrent',
  Weight = 'Weight'
}

export enum EvaluationValidationPreselect {
  Dosage = 'dosage'
}

export enum EventType {
  Christmas = 'Christmas',
  NoahBirthday = 'NoahBirthday',
  November2022Promo = 'November2022Promo'
}

export type ExcludedEvalInput = {
  platform?: InputMaybe<PlatformType>;
};

export type ExcludedEvaluationIdsInput = {
  platform: PlatformType;
};

export type ExportLableInput = {
  doNumbers: Array<Scalars['String']>;
};

export type ExtraDeliveryAddressInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<RegionType>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postal?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<LocalRegionType>;
  sameAsBilling?: InputMaybe<Scalars['Boolean']>;
  shouldSave?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AddressType>;
  unit?: InputMaybe<Scalars['String']>;
};

export type ExtraInfoForOrderModel = {
  __typename?: 'ExtraInfoForOrderModel';
  availableProductSelectableList?: Maybe<Array<Maybe<ProductListModel>>>;
  checkProductsExistingOrdersForPatient?: Maybe<Array<Maybe<OrderModel>>>;
  consultationSession?: Maybe<ConsultationSessionModel>;
  doctorNotes?: Maybe<Array<Maybe<DoctorNoteModel>>>;
  evalPatientQuestionAnswers?: Maybe<Array<Scalars['JSON']>>;
  evaluation?: Maybe<EvaluationFormModel>;
  evaluationQuestions?: Maybe<Array<Maybe<CustomEvaluationQuestionModel>>>;
  orderProduct?: Maybe<StripeProductModel>;
  patientProduct?: Maybe<StripeProductModel>;
  prescription?: Maybe<PrescriptionModel>;
  prices?: Maybe<PricesListModel>;
  stripeProducts?: Maybe<Array<Maybe<StripeProductModel>>>;
};

export type ExtraOrderInfoModel = {
  __typename?: 'ExtraOrderInfoModel';
  acuityAppointmentSnapshot?: Maybe<AcuityAppointmentModel>;
  acuityAppointments?: Maybe<Array<Maybe<AcuityAppointmentModel>>>;
  address?: Maybe<Scalars['JSON']>;
  affiliateCoupon?: Maybe<AffiliateCoupon>;
  approveAt?: Maybe<Scalars['DateTime']>;
  atomePaymentAmount?: Maybe<Scalars['Float']>;
  auditDoctorNotes?: Maybe<Array<Maybe<AuditDoctorNoteModel>>>;
  canEditDeliveryTime?: Maybe<EditDeliveryTimeModel>;
  completedEvaluation?: Maybe<Scalars['JSON']>;
  consultationSessions?: Maybe<Scalars['JSON']>;
  continueTrial?: Maybe<Scalars['Boolean']>;
  countTrialReminder?: Maybe<Scalars['Float']>;
  country?: Maybe<RegionType>;
  createFromSkipOrderId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  delivery?: Maybe<Scalars['JSON']>;
  deliveryAddress?: Maybe<AddressModel>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliverySnapshot?: Maybe<Scalars['JSON']>;
  doctorNotes?: Maybe<Scalars['String']>;
  doctorPrescriptionPriceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  dosage?: Maybe<Scalars['JSON']>;
  evaluationId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['Float']>;
  intakeInstructions?: Maybe<Scalars['String']>;
  isAutoRenewal?: Maybe<Scalars['Boolean']>;
  isConsultOnly?: Maybe<Scalars['Boolean']>;
  isEDTrial?: Maybe<Scalars['Boolean']>;
  isOrderRenew?: Maybe<Scalars['Boolean']>;
  isPendingFollowUpConsult?: Maybe<Scalars['Boolean']>;
  isSkipMedOrder?: Maybe<Scalars['Boolean']>;
  isSkippedEval?: Maybe<Scalars['Boolean']>;
  isSubscriptionPastDue?: Maybe<Scalars['Boolean']>;
  isSubscriptionPaused?: Maybe<Scalars['Boolean']>;
  isTestOrder?: Maybe<Scalars['Boolean']>;
  latestInvoice?: Maybe<Scalars['JSON']>;
  nextReviewDate?: Maybe<Scalars['DateTime']>;
  oldOrder?: Maybe<OldOrderModel>;
  oldPrice?: Maybe<Scalars['JSON']>;
  ops?: Maybe<Scalars['String']>;
  opsComment?: Maybe<Scalars['String']>;
  orderPrescriptionPriceId?: Maybe<Scalars['String']>;
  orderPriceId?: Maybe<Scalars['String']>;
  otherIntestedEvalIds?: Maybe<Array<Scalars['String']>>;
  patientId?: Maybe<Scalars['String']>;
  patientOrderNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientSnapshot?: Maybe<PatientModel>;
  paymentProvider?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pickupLocation?: Maybe<PickupLocationDto>;
  platformType?: Maybe<PlatformType>;
  prescribeAfterTeleConsult?: Maybe<Scalars['Boolean']>;
  prescribedAfterTrialOrder?: Maybe<OrderModel>;
  prescription?: Maybe<PrescriptionModel>;
  prescriptionDisplayPriceId?: Maybe<Scalars['String']>;
  prescriptionId?: Maybe<Scalars['String']>;
  prescriptionOrderCalculation?: Maybe<Scalars['JSON']>;
  priceDisplayId?: Maybe<Scalars['String']>;
  priceInfo?: Maybe<Scalars['JSON']>;
  productGroupData?: Maybe<ProductModel>;
  productInfo?: Maybe<StripeProductModel>;
  productQuantity?: Maybe<Scalars['Float']>;
  promotionCode?: Maybe<Scalars['String']>;
  rejectAt?: Maybe<Scalars['DateTime']>;
  reorderStatus?: Maybe<Scalars['Boolean']>;
  shortId?: Maybe<Scalars['Float']>;
  status?: Maybe<OrderStatus>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  teleConsultProduct?: Maybe<Scalars['Boolean']>;
  twilioMessageHistories?: Maybe<Array<Maybe<TwilioMessageHistoryModel>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ExtraStripeProductModel = {
  __typename?: 'ExtraStripeProductModel';
  active?: Maybe<Scalars['Boolean']>;
  childrenIncludedProduct?: Maybe<Array<Maybe<StripeProductModel>>>;
  childrenSecondIncludedProduct?: Maybe<Array<Maybe<StripeProductModel>>>;
  country?: Maybe<RegionType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['String']>;
  dosageAnswer?: Maybe<Scalars['Float']>;
  evaluationId?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageModel>;
  includedProduct?: Maybe<StripeProductModel>;
  isConsultOnly: Scalars['Boolean'];
  isFixedDose: Scalars['Boolean'];
  isRxOneTime: Scalars['Boolean'];
  isShowOnShop?: Maybe<Scalars['JSON']>;
  isSkipMedProduct: Scalars['Boolean'];
  isTextConsult: Scalars['Boolean'];
  livemode?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['JSON']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  popularPriceId: Scalars['String'];
  prices?: Maybe<Scalars['JSON']>;
  secondIncludedProduct?: Maybe<StripeProductModel>;
  shopProductGroupIds?: Maybe<Array<ShopProductGroupIds>>;
  shouldChargeNow: Scalars['Boolean'];
  shouldHideEditFreq: Scalars['Boolean'];
  shouldShowConsultFee: Scalars['Boolean'];
  statementDescriptor?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uniqName?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FcmTokenInput = {
  deviceType: Scalars['String'];
  fcmToken: Scalars['String'];
};

export type FilterByContinueLaterTokenInput = {
  continueLaterToken: Scalars['String'];
};

export type FilterByIdInput = {
  id: Scalars['String'];
};

export type FilterDoctorInput = {
  calendarId?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<RegionType>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  userSysId?: InputMaybe<Scalars['String']>;
};

export type FilterInput = {
  id?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PlatformType>;
  promotionCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type ForgotPasswordUserInput = {
  email: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export enum Gender {
  Female = 'Female',
  Male = 'Male'
}

export type GenerateSmartMatchResultsInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  evaluationData: Array<EvaluationData>;
  evaluationId: EvalIds;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserType>;
};

export type GetByOrderSysId = {
  orderSysId: Scalars['String'];
};

export type GetCartInput = {
  platform?: InputMaybe<PlatformType>;
  promotionCode?: InputMaybe<Scalars['JSON']>;
  shouldReturnCalculation?: InputMaybe<Scalars['Boolean']>;
};

export type GetCompletedEvalByFilterInput = {
  evaluationId?: InputMaybe<EvalIds>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type GetCompletedEvalByFilterModel = {
  __typename?: 'GetCompletedEvalByFilterModel';
  evaluation?: Maybe<EvaluationModel>;
  patient?: Maybe<PatientModel>;
  patientNote?: Maybe<Scalars['String']>;
};

export type GetConsultTextDataInput = {
  conversationId: Scalars['String'];
};

export type GetConsultVideoInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  videoSessionId: Scalars['String'];
};

export type GetConsultationByFilterInput = {
  orderId?: InputMaybe<Scalars['String']>;
  textConversationId?: InputMaybe<Scalars['String']>;
};

export type GetConsultationByOrdersInput = {
  includeToken?: InputMaybe<Scalars['Boolean']>;
  orderIds: Array<Scalars['String']>;
};

export type GetCronjobInput = {
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GetCurrentPatientOnboardingInput = {
  tourName: Scalars['String'];
};

export type GetEvaluationByOrderInput = {
  patientOrders: Array<PatientOrderInput>;
};

export type GetEvaluationByOrderModel = {
  __typename?: 'GetEvaluationByOrderModel';
  orderId?: Maybe<Scalars['String']>;
  patientNote?: Maybe<Scalars['String']>;
  patientQuestionAnswers?: Maybe<Array<Scalars['JSON']>>;
};

export type GetEvaluationDashboardInput = {
  consultationSessionType?: InputMaybe<ConsultationSessionType>;
  evaluationId?: InputMaybe<Scalars['String']>;
  evaluationType?: InputMaybe<EvalIds>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type GetExtraInfoOrderDetailInput = {
  orderId: Scalars['String'];
};

export type GetExtraProductPriceByEvaluationModel = {
  __typename?: 'GetExtraProductPriceByEvaluationModel';
  stripeProductPrices?: Maybe<Array<ExtraStripeProductModel>>;
  suggestTreatments?: Maybe<Array<EvalIds>>;
};

export type GetExtraProductPriceInfoByEvaluationInput = {
  consultType: ConsultationSessionType;
  evaluationId: EvalIds;
  isConfirmPrice?: InputMaybe<Scalars['Boolean']>;
  locale: Language;
};

export type GetOrderWithPatientDetail = {
  orderId: Scalars['String'];
};

export type GetPartnerInput = {
  sysId: Scalars['String'];
};

export type GetPatientDocumentInput = {
  sysId: Scalars['String'];
};

export type GetPatientInput = {
  email?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  userSysId?: InputMaybe<Scalars['String']>;
};

export type GetPlansModel = {
  __typename?: 'GetPlansModel';
  acuityAppointments?: Maybe<Array<Maybe<AcuityAppointmentModel>>>;
  continueTrial?: Maybe<Scalars['Boolean']>;
  countTrialReminder?: Maybe<Scalars['Float']>;
  evaluationId?: Maybe<Scalars['String']>;
  evaluationTitle?: Maybe<Scalars['String']>;
  isAutoRenewal?: Maybe<Scalars['Boolean']>;
  isEDTrial?: Maybe<Scalars['Boolean']>;
  isSkippedEval?: Maybe<Scalars['Boolean']>;
  isSubscriptionPastDue?: Maybe<Scalars['Boolean']>;
  isSubscriptionPaused?: Maybe<Scalars['Boolean']>;
  isSubscriptionPrice?: Maybe<Scalars['Boolean']>;
  isSubscriptionTrial?: Maybe<Scalars['Boolean']>;
  oldPriceInfo?: Maybe<Scalars['JSON']>;
  oldProductInfo?: Maybe<Scalars['JSON']>;
  orderPriceId?: Maybe<Scalars['String']>;
  paymentProvider?: Maybe<Scalars['String']>;
  prescribeAfterTeleConsult?: Maybe<Scalars['Boolean']>;
  prescribedAfterTrialOrder?: Maybe<OrderModel>;
  priceInfo?: Maybe<Scalars['JSON']>;
  productInfo?: Maybe<Scalars['JSON']>;
  shortId?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
};

export type GetPrescriptionOrderBookingResultInput = {
  orderId: Scalars['String'];
};

export type GetPrescriptionOrderBookingResultModel = {
  __typename?: 'GetPrescriptionOrderBookingResultModel';
  isBooked: Scalars['Boolean'];
  order: OrderModel;
  stripeProductPrice: StripeProductPriceModel;
};

export type GetPrescriptionOrderCalculationInput = {
  evaluationId: EvalIds;
  orderId?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  promotionCode?: InputMaybe<Scalars['String']>;
};

export type GetPriceByIntentIdInput = {
  id: Scalars['String'];
};

export type GetReferralModel = {
  __typename?: 'GetReferralModel';
  info: Scalars['JSON'];
};

export type GetRenewalOrderInfoInput = {
  subscriptionId: Scalars['String'];
};

export type GetSmartMatchAiResponseInput = {
  evaluationData: Scalars['String'];
};

export type GetSmartMatchMetaInput = {
  evalId: EvalIds;
};

export type GetSmartMatchResultsInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  smartMatchId: Scalars['String'];
};

export type GetSuggestionsInput = {
  platform?: InputMaybe<PlatformType>;
};

export type GetTextConversationFromOpsInput = {
  orderId: Scalars['String'];
};

export type GetThankyouDataInput = {
  cartId: Scalars['String'];
};

export type GetUsersByRoleInput = {
  roles: Array<UserRole>;
};

export type GetUsersInput = {
  sysId?: InputMaybe<Scalars['String']>;
  userTypes?: InputMaybe<Array<UserRole>>;
};

export type GiveAwayFilterInput = {
  address?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<Scalars['String']>;
  cartId?: InputMaybe<Scalars['String']>;
  choice?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventPeriod?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventType>;
  moneySpent?: InputMaybe<Scalars['Float']>;
  orderId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type GiveawayModel = {
  __typename?: 'GiveawayModel';
  address?: Maybe<Scalars['String']>;
  answer: Scalars['String'];
  cartId?: Maybe<Scalars['String']>;
  choice: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  eventPeriod: Scalars['String'];
  moneySpent: Scalars['Float'];
  orderId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type GuestCompletedEvalModel = {
  __typename?: 'GuestCompletedEvalModel';
  completed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  evaluationFormLastUpdated?: Maybe<Scalars['DateTime']>;
  evaluationId?: Maybe<Scalars['String']>;
  formQandA?: Maybe<Array<Scalars['JSON']>>;
  jumpToSectionIndex?: Maybe<Array<Maybe<Scalars['Float']>>>;
  oldPatientId?: Maybe<Scalars['String']>;
  patient?: Maybe<Scalars['JSON']>;
  patientId?: Maybe<Scalars['String']>;
  patientSnapshot?: Maybe<PatientModel>;
  patientdoctorNotes?: Maybe<Scalars['String']>;
  questionTotal?: Maybe<Scalars['Float']>;
  sectionHistory?: Maybe<Array<Maybe<Scalars['Float']>>>;
  sectionIndex?: Maybe<Scalars['Float']>;
  sectionTotal?: Maybe<Scalars['Float']>;
  sysId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type GuestRegisterAndEvalResultInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  consultationSessionType?: InputMaybe<ConsultationSessionType>;
  evaluationType: EvalIds;
  registerInfo: RegisterInfoInput;
  results?: InputMaybe<Array<InputMaybe<EvalResultInput>>>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type HosAchievedMilestone = {
  __typename?: 'HosAchievedMilestone';
  achievedAt: Scalars['DateTime'];
  /** When the patient dismissed the reached card; null while it is still on the page. */
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  /** The pool row's acknowledgement copy key (D25). */
  acknowledgementKey?: Maybe<Scalars['String']>;
  /** hos_patient_milestone row id. */
  id: Scalars['ID'];
  milestoneId: Scalars['String'];
  /** The score whose recompute confirmed it. */
  scoreId?: Maybe<Scalars['ID']>;
  titleKey: Scalars['String'];
};

/** One action in the published library, with the most overall-score points it could add for this patient. Staff only (M3); the patient sees it on the card in M4. */
export type HosActionEstimate = {
  __typename?: 'HosActionEstimate';
  actionId: Scalars['String'];
  basis: HosEstimateBasis;
  /** The claim whose citation sits beneath the number: the entry that contributed the most points. */
  citationClaimKey?: Maybe<Scalars['String']>;
  /** clinical_corpus document behind that claim. */
  citationDocId?: Maybe<Scalars['String']>;
  /** The action row's own `helps` sub-score. The estimate itself follows the evidence entries' signals, which may span more sub-scores. */
  helps: HosSubscoreKey;
  /** One entry per sub-score the action's evidence points at, largest contribution first. */
  parts: Array<HosActionEstimatePart>;
  /** The unrounded sum, so a reviewer can see a 0.4 that rounds away. */
  rawPoints: Scalars['Float'];
  /** False when the estimate rounds below the registry's min_points_to_show: the card shows no number and no empty slot. */
  shown: Scalars['Boolean'];
  /** Sub-score of the largest contribution; null when nothing contributed. */
  subscore?: Maybe<HosSubscoreKey>;
  /** The 'up to +N' the card shows, rounded. 0 when nothing contributed. */
  upToPoints: Scalars['Int'];
};

/** What one sub-score contributed to an action's estimate, and the arithmetic behind it. Staff only. */
export type HosActionEstimatePart = {
  __typename?: 'HosActionEstimatePart';
  basis: HosEstimateBasis;
  /** True when the room left, not the evidence, set this contribution. */
  cappedByRoomLeft: Scalars['Boolean'];
  /** patient_copy key of the claim this contribution rests on. */
  claimKey: Scalars['String'];
  /** The patient's current value of this sub-score, 0-100. */
  currentSubScore: Scalars['Int'];
  /** clinical_corpus document the claim came from. */
  docId: Scalars['String'];
  /** Participants in the source. */
  n?: Maybe<Scalars['Int']>;
  /** Overall-score points credited, after the cap at the room left. */
  points: Scalars['Float'];
  /** (100 - current) x stage weight / 100, in overall-score points: the most this sub-score could ever add. */
  roomLeft: Scalars['Float'];
  /** The registry signal this entry says the action moves. */
  signal: Scalars['String'];
  /** The signal's points after the effect; null on the fixed-fraction path. */
  signalPointsAfter?: Maybe<Scalars['Float']>;
  /** The signal's points before the effect; null on the fixed-fraction path. */
  signalPointsBefore?: Maybe<Scalars['Float']>;
  /** This sub-score's weight for the patient's stage, as a percent of the overall score. */
  stageWeightPercent: Scalars['Int'];
  subscore: HosSubscoreKey;
  /** The source's rank, T1 to T3. */
  tier?: Maybe<Scalars['String']>;
};

export type HosActionEstimateSummary = {
  __typename?: 'HosActionEstimateSummary';
  basis: HosEstimateBasis;
  /** Copy key of the line. The client renders it with { n: upToPoints }. */
  copyKey: Scalars['String'];
  /** Sub-score of the largest contribution — the one the citation belongs to. */
  subscore: HosSubscoreKey;
  /** The "up to +N" the card renders through copy key hos.patient_copy.card.estimate. */
  upToPoints: Scalars['Int'];
};

export type HosActionInstance = {
  __typename?: 'HosActionInstance';
  actionId: Scalars['String'];
  /** action_library type (improvement | dose_change | see_doctor); preset_action for the seeded guide. */
  actionType: Scalars['String'];
  closedAt?: Maybe<Scalars['DateTime']>;
  /** hos_signal written by the closing check-in answer; null while the action carries no check-in. */
  closingSignalId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  dueAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  startedAt?: Maybe<Scalars['DateTime']>;
  state: HosActionState;
  triggerActiveSince?: Maybe<Scalars['DateTime']>;
  triggerId?: Maybe<Scalars['String']>;
};

export type HosActionReminderInput = {
  /** Patient-local hour 0-23. */
  hourLocal: Scalars['Int'];
  /** ISO weekdays 1-7; empty or omitted = daily within the timeframe. */
  weekdays?: InputMaybe<Array<Scalars['Int']>>;
};

/** M3 uses in_progress (opened by the serve) and done (hosCompleteAction); the rest arrive with the escalation and daily-tick lanes. */
export enum HosActionState {
  Declined = 'declined',
  Done = 'done',
  Expired = 'expired',
  InProgress = 'in_progress',
  Offered = 'offered'
}

export type HosAdminLoginResult = {
  __typename?: 'HosAdminLoginResult';
  /** Magic-link JWT to hand to the existing magic-link sign-in exchange. */
  token: Scalars['String'];
};

export type HosAiCall = {
  __typename?: 'HosAiCall';
  costUsd?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  /** Failure reason for a non-ok status, so an incident does not need the application log. */
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** sha256 over the exact input. The input text itself is never stored (MG-8). */
  inputHash: Scalars['String'];
  inputTokens?: Maybe<Scalars['Int']>;
  latencyMs: Scalars['Int'];
  modelId: Scalars['String'];
  outputTokens?: Maybe<Scalars['Int']>;
  /** Always true: the raw prompt and the raw output are withheld from the audit read (MG-8, spec 06 ops portal). */
  outputWithheld: Scalars['Boolean'];
  /** sha256 over the canonical model parameters. */
  paramsHash: Scalars['String'];
  /** <prompts section version>:<prompt row key> — what a replay re-runs with. */
  promptPin: Scalars['String'];
  /** Closed list: classifier | extraction | chat | … (hos-ai-purpose.ts). */
  purpose: Scalars['String'];
  /** Always null on this read — see outputWithheld. Kept in the schema because the contract names it. */
  rawOutput?: Maybe<Scalars['JSON']>;
  /** ok | failed | timeout | capped | breaker_open | unparseable. */
  status: Scalars['String'];
};

export type HosAnswerCheckinInput = {
  answers: Array<HosCheckinAnswerInput>;
  checkinId: Scalars['ID'];
  /** Client UUID. A retry returns the prior result: no new model call and no second signal. */
  clientRequestId: Scalars['ID'];
};

/** The patient's saved answer for one step, so the client re-renders it on resume (DoD §3.10). */
export type HosBaselineAnswer = {
  __typename?: 'HosBaselineAnswer';
  answeredAt: Scalars['DateTime'];
  /** date_time steps: the reminder time the patient picked. */
  dateTime?: Maybe<Scalars['DateTime']>;
  /** Step 0's weight in kg. */
  numericValue?: Maybe<Scalars['Float']>;
  optionId?: Maybe<Scalars['String']>;
  /** Red-flag scan outcome of a free-text answer: `clear` or `flagged` (R16, MG-5). Null means there was nothing to scan. No answer can exist with unscanned text — the scan runs before the row is written. */
  safetyScanStatus?: Maybe<Scalars['String']>;
  stepId: Scalars['String'];
  /** free_text steps, trimmed. An empty string is a real answer — the patient skipped the question. */
  text?: Maybe<Scalars['String']>;
};

/** One step's answer; exactly the field for the step's inputKind is read, the rest are ignored. */
export type HosBaselineAnswerValueInput = {
  /** date_time steps: an ISO-8601 instant (e.g. 2026-09-16T20:00:00+08:00). A String, not the DateTime scalar, so an unparseable value returns HOS_INVALID_ANSWER rather than a generic coercion error. Optional when `schedule` is sent; sent alone, it sets a reminder on that one day and hour. */
  dateTime?: InputMaybe<Scalars['String']>;
  /** numeric steps: step 0's weight in kg, one decimal place. */
  numericValue?: InputMaybe<Scalars['Float']>;
  /** single_choice steps: an option id from the step's served options. */
  optionId?: InputMaybe<Scalars['String']>;
  /** date_time steps: the reminder days and hour, written to hos_patient_schedule in the same transaction as the answer, so the reminder is not asked for again after the questionnaire (R12.10). */
  schedule?: InputMaybe<HosBaselineScheduleInput>;
  /** free_text steps: the patient's answer, trimmed, at most 1000 characters. An EMPTY string is accepted — it is the 'skipped' answer that lets the patient move on. */
  text?: InputMaybe<Scalars['String']>;
};

/** Baseline questionnaire progress, so the client resumes at the saved step (shell-screen DoD §3.10). */
export type HosBaselineProgress = {
  __typename?: 'HosBaselineProgress';
  /** Saved answers among the served steps. */
  answeredSteps: Scalars['Int'];
  /** The first step with no saved answer — where the resume card continues. Null once every step is answered. */
  nextStepId?: Maybe<Scalars['String']>;
  /** Steps served, derived from the published registry rows (11 for weight_loss, 10 once the reminder is set in the hub); never a constant. */
  totalSteps: Scalars['Int'];
};

/** The baseline questionnaire the patient is answering (API contracts §2.1; DoD §3.9). */
export type HosBaselineQuestionnaire = {
  __typename?: 'HosBaselineQuestionnaire';
  pins: HosPins;
  /** Where the patient left off (DoD §3.10). */
  progress: HosBaselineProgress;
  /** baseline_questionnaire version rendered; echoed on every answer and on submit. */
  registryVersion: Scalars['Int'];
  /** Every served step in `step` order: the published steps, less the intake step once the reminder is set in the hub (OQ-01-20). */
  steps: Array<HosQuestionnaireStep>;
  /** Steps served, derived from the published registry rows (11 for weight_loss, 10 once the reminder is set in the hub); the client counts its kicker against this, never a constant. */
  totalSteps: Scalars['Int'];
};

/** The reminder the date_time step (bq.step_intake_time) sets: the same day set and hour hosUpdatePatientSchedule takes, validated the same way. */
export type HosBaselineScheduleInput = {
  /** Patient-local hour 0-23 (hour granularity, MG-16). */
  hour: Scalars['Int'];
  /** ISO weekdays 1-7, non-empty, no repeats. A weekly dose is one day picked (owner 2026-09-17). */
  weekdays: Array<Scalars['Int']>;
};

/** Brand a HealthOS content row applies to. Clinical sections are always all; content sections default noah in API inputs. */
export enum HosBrand {
  All = 'all',
  Noah = 'noah',
  Zoey = 'zoey'
}

export type HosCard = {
  __typename?: 'HosCard';
  /** The patient's instance of this action. Its state is where the hub row status and the checklist counter come from, so both survive a reopen (brief §3.1 acceptance C12). Null on a check-in card, and on an improvement card not yet started. */
  actionInstance?: Maybe<HosActionInstance>;
  benefitCopyKey?: Maybe<Scalars['String']>;
  /** Params for benefitCopyKey's {tokens}, same shape as titleParams; null when there is nothing to fill. */
  benefitParams?: Maybe<Scalars['JSON']>;
  cardId: Scalars['String'];
  /** Set on a check-in card: the FIRST open ask, with its question copy keys and quick replies (R35.7). */
  checkin?: Maybe<HosCheckin>;
  /** Every open ask this ONE check-in card stands for, oldest first (§3.6 C17): a weekly and a post-step ask due together are one card, and its CTA carries both into one conversation. `checkin` is the first of them. Empty on every other kind. */
  checkinAsks: Array<HosCheckin>;
  /** The kinds folded into this card, de-duplicated, in served order — what the card's eyebrow, title and CTA copy are chosen by. */
  checkinKinds: Array<HosCheckinKind>;
  /** R9: the approved claims behind the card. Null on check-in cards. */
  evidence?: Maybe<HosEvidenceBlock>;
  /** Held behind an open safety card (R17.8). A held card is NOT in HosCardsPage.cards — the page carries heldCount; this stays for the staff read of a held row. */
  held: Scalars['Boolean'];
  /** Set on improvement cards (kind improvement / preset_action); null on a check-in card. */
  improvement?: Maybe<HosImprovementCardBody>;
  kind: Scalars['String'];
  /** In-progress card that kept its slot across the recompute (MG-19). */
  pinned: Scalars['Boolean'];
  /** The copy is the seeded placeholder: action_library has published no preset row yet. */
  placeholder: Scalars['Boolean'];
  rank: Scalars['Int'];
  /** Set on a safety card: the open flag that holds the page, with its instruction copy key and required action (R17, §3.9). Null on every other kind. */
  safety?: Maybe<HosSafetyFlag>;
  /** Per-SERVE id (hos_card_serve.id). The card's own identity is cardId (OQ-API-36). */
  serveId: Scalars['ID'];
  snapshot: HosServedSnapshot;
  /** The guide's steps, in render order. Superseded by `steps`; kept while the app migrates. */
  stepCopyKeys: Array<Scalars['String']>;
  /** The guide's steps with their own title, body and tip keys — the structure the flat stepCopyKeys list lost (design-vs-build audit item 8). */
  steps: Array<HosCardStep>;
  titleCopyKey: Scalars['String'];
  /** Params that fill titleCopyKey's {tokens} when the action row declares title slots; null when there is nothing to fill. Keyed by token name. A value is a number (already rounded), { copyKeys: [patient_copy keys] } to resolve and join per locale, or { isoWeekday: 1-7 } to name per locale. */
  titleParams?: Maybe<Scalars['JSON']>;
  /** hos_trigger_state.active_since — the episode this card belongs to (MG-19). */
  triggerActiveSince?: Maybe<Scalars['DateTime']>;
  /** clinical_thresholds trigger row that ranked this card's sub-score up; null when headroom alone did. */
  triggerId?: Maybe<Scalars['String']>;
  /** R7.8. Null on check-in cards. */
  whyThis?: Maybe<HosWhyThis>;
};

export type HosCardActionResult = {
  __typename?: 'HosCardActionResult';
  actionInstance?: Maybe<HosActionInstance>;
  /** The card this acted on, re-served. */
  card?: Maybe<HosCard>;
  /** The flag this acted on, in its new state — cleared on a confirm_read acknowledgement, acknowledged-and-still-open on a book_consult one. [landed 2026-09-22] */
  flag?: Maybe<HosSafetyFlag>;
  page: HosCardsPage;
  /** Set when the answer carried free text (MG-5); null otherwise. */
  safety?: Maybe<HosSafetyScan>;
};

/** Which part of a served card was viewed (R30.5). */
export enum HosCardSeenElement {
  Card = 'card',
  EvidenceBlock = 'evidence_block',
  Milestone = 'milestone',
  WhyThis = 'why_this'
}

export type HosCardSeenEventInput = {
  /** Client copy-bundle version at view time, so OTA drift against the served fingerprint is recorded. */
  bundleCopyVersion?: InputMaybe<Scalars['Int']>;
  /** The card's own id (HosCard.cardId). */
  cardId: Scalars['ID'];
  element: HosCardSeenElement;
  /** Client UUID for this view. Carried in the record so a duplicate can be traced to the buffer that sent it; it is not the dedupe key. */
  eventId: Scalars['ID'];
  /** When the patient saw it, not when the buffer flushed. */
  seenAt: Scalars['DateTime'];
  /** The serve the view belongs to (HosCard.serveId). The same card seen after a recompute is a NEW view: it was served again. */
  serveId: Scalars['ID'];
  surface: HosSurface;
};

export type HosCardSeenResult = {
  __typename?: 'HosCardSeenResult';
  /** Views written into this batch's record event. */
  accepted: Scalars['Int'];
  /** Views already recorded for that (serve, card, element), or repeated inside the batch. */
  duplicates: Scalars['Int'];
};

export type HosCardStep = {
  __typename?: 'HosCardStep';
  /** hos.action_library.<action id>.step_<n>.body */
  bodyCopyKey: Scalars['String'];
  /** 1-based position in render order. */
  index: Scalars['Int'];
  /** hos.action_library.<action id>.step_<n>.tip */
  tipCopyKey: Scalars['String'];
  /** hos.action_library.<action id>.step_<n>.title */
  titleCopyKey: Scalars['String'];
};

export type HosCardsPage = {
  __typename?: 'HosCardsPage';
  /** The "Milestones reached" strip, newest first (R10.7). Empty while safetyActive holds the page. */
  achievedMilestones: Array<HosAchievedMilestone>;
  /** What is on the page, in rank order. While safetyActive, ONLY the safety cards: the rest are held and counted in heldCount. */
  cards: Array<HosCard>;
  /** A recompute is queued or running: the set on screen may change (MG-4). The client reads this here rather than from HosScore. */
  computing: Scalars['Boolean'];
  /** Cards the hold kept off the page. Zero unless safetyActive; equals the hos_card_serve rows written with held = true for this score. */
  heldCount: Scalars['Int'];
  /** The one milestone under the orb (R10.1, R10.12): the next one the patient is working towards, or a reached one they have not dismissed yet. Null when no pool row fits, and while safetyActive holds the page. */
  milestone?: Maybe<HosMilestone>;
  pins: HosPins;
  /** An open safety flag holds the page (R17.8, §3.9): only safety cards serve, and hosStartAction / hosCompleteAction are refused. */
  safetyActive: Scalars['Boolean'];
  /** The score the set was ranked against. Null on the pre-activation hub. */
  scoreId?: Maybe<Scalars['ID']>;
  servedAt?: Maybe<Scalars['DateTime']>;
  surface: HosSurface;
};

/** A prescribable weight-loss GLP-1 product for a dose_change row (C-12). No price amount — price resolves at serve time. */
export type HosCatalogProduct = {
  __typename?: 'HosCatalogProduct';
  active: Scalars['Boolean'];
  currency: Scalars['String'];
  /** Dose in `unit`, derived from the product definition (name/metadata), NOT price_metadata.dosage (an index). */
  dose?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  /** stripe_product_price.product_uniq_name — stable across live/test. */
  productRef: Scalars['String'];
  /** Dose unit, e.g. mg. Null when the product carries no per-strength dose (a plan or a titration pen). */
  unit?: Maybe<Scalars['String']>;
};

/** What opened the chat (API contracts §2.6). Every card CTA opens with the card as context (R8.16, RL54). */
export enum HosChatContextKind {
  Card = 'card',
  Checkin = 'checkin',
  DoseReminder = 'dose_reminder',
  FirstInjection = 'first_injection',
  Free = 'free',
  Safety = 'safety'
}

export type HosChatContextRefInput = {
  kind: HosChatContextKind;
  ref?: InputMaybe<Scalars['ID']>;
};

export type HosChatControl = {
  __typename?: 'HosChatControl';
  /** Patient or region spend cap hit: AI replies replaced by copyKey + handoff offer; classifier still runs (MG-23). */
  capReached: Scalars['Boolean'];
  /** Reset time derived from the cap window; null when not capped. */
  capResetsAt?: Maybe<Scalars['DateTime']>;
  handedOff: Scalars['Boolean'];
  /** Client refetches hosCards after every chat turn and on push receipt; no socket Phase 1 (MG-2). */
  refetchCards: Scalars['Boolean'];
};

export type HosChatConversation = {
  __typename?: 'HosChatConversation';
  contextKind: HosChatContextKind;
  contextRef?: Maybe<Scalars['ID']>;
  /** Present while handed off; resolution arrives from the Freshchat webhook (MG-21). */
  handoffId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  openedAt: Scalars['DateTime'];
  state: HosChatConversationState;
};

/** The HOS chat conversation lifecycle state (API contracts §2.6). */
export enum HosChatConversationState {
  Active = 'active',
  Closed = 'closed',
  HandedOff = 'handed_off'
}

export type HosChatHandoffInput = {
  /** Client UUID; idempotent on (conversation) while a handoff is open, dedupes the reason message. */
  clientRequestId: Scalars['ID'];
  conversationId: Scalars['ID'];
  /** Patient-typed reason; scanned like any text. */
  reason?: InputMaybe<Scalars['String']>;
};

export type HosChatMessage = {
  __typename?: 'HosChatMessage';
  /** clinical_corpus doc_ids cited by an Ask Noah answer, after the grounding post-check (MG-23, D20). */
  citations: Array<Scalars['String']>;
  /** Echo of the client message id (MG-22); null for server-originated messages. */
  clientMessageId?: Maybe<Scalars['ID']>;
  conversationId: Scalars['ID'];
  /** Static copy (openers, cap notice, handoff notice, safety instruction). */
  copyKey?: Maybe<Scalars['String']>;
  copyParams?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  /** Templated fallback replaced a model answer (breaker, timeout, cap) (MG-23). */
  fallback: Scalars['Boolean'];
  id: Scalars['ID'];
  quickReplies: Array<HosChatQuickReply>;
  role: HosChatRole;
  /** Patient message the classifier flagged; the served reply is the safety instruction (MG-5). */
  safetyFlagged: Scalars['Boolean'];
  source: HosChatMessageSource;
  /** Patient, AI or human text. Null when the message is static copy. */
  text?: Maybe<Scalars['String']>;
};

/** template = registry copy (fallback or opener); human = Freshchat agent relay (MG-21, MG-23). */
export enum HosChatMessageSource {
  Human = 'human',
  Model = 'model',
  Patient = 'patient',
  Template = 'template'
}

export type HosChatOpenInput = {
  /** Client UUID; a repeat returns the same conversation and opener (MG-22). */
  clientRequestId: Scalars['ID'];
  context: HosChatContextRefInput;
};

export type HosChatQuickReply = {
  __typename?: 'HosChatQuickReply';
  /** Proposed values expire 24 h after extraction (MG-22). */
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  kind: HosQuickReplyKind;
  /** Static label: key + params (checkin_config, patient_copy). Exactly one of labelKey / labelText is set. */
  labelKey?: Maybe<Scalars['String']>;
  labelParams?: Maybe<Scalars['JSON']>;
  /** AI-composed label only when no key applies (extracted-value confirm, 'Log 74.2 kg?'). */
  labelText?: Maybe<Scalars['String']>;
  /** Proposed hos_signal id, hos_checkin id, action instance id, escalation id or safety flag id this reply resolves. */
  targetRef?: Maybe<Scalars['ID']>;
};

export type HosChatReply = {
  __typename?: 'HosChatReply';
  control: HosChatControl;
  conversation: HosChatConversation;
  /** The stored patient message; null when the scan blocked it. */
  patientMessage?: Maybe<HosChatMessage>;
  /** Zero or more server messages: AI answer, generated follow-up, templated fallback, safety instruction. */
  replies: Array<HosChatMessage>;
  safety: HosSafetyScan;
};

/** Who a HOS chat message is from (API contracts §2.6). */
export enum HosChatRole {
  Assistant = 'assistant',
  Human = 'human',
  Patient = 'patient',
  System = 'system'
}

export type HosChatSendInput = {
  /** Client UUID, unique per conversation. A duplicate returns the prior HosChatReply, no new model call (MG-22). */
  clientMessageId: Scalars['ID'];
  conversationId: Scalars['ID'];
  quickReplyId?: InputMaybe<Scalars['ID']>;
  /** Exactly one of text / quickReplyId. */
  text?: InputMaybe<Scalars['String']>;
};

export type HosCheckin = {
  __typename?: 'HosCheckin';
  answeredAt?: Maybe<Scalars['DateTime']>;
  /** Patient-local date the ask is keyed on (YYYY-MM-DD). */
  dueDate: Scalars['String'];
  id: Scalars['ID'];
  kind: HosCheckinKind;
  /** Set by the 24 h rule: confidence only, the card stays (RL33). */
  missedAt?: Maybe<Scalars['DateTime']>;
  questions: Array<HosCheckinQuestion>;
  skippedAt?: Maybe<Scalars['DateTime']>;
  /** post_step: the dose step it follows. action_checkin: the action instance (MG-19). */
  sourceRef?: Maybe<Scalars['ID']>;
  status: HosCheckinStatus;
};

export type HosCheckinAnswerInput = {
  /** Free text. Scanned before anything is stored (MG-5). */
  freeText?: InputMaybe<Scalars['String']>;
  /** A quick-reply option id. */
  optionId?: InputMaybe<Scalars['String']>;
  questionId: Scalars['String'];
  /** symptom_days questions: one line per symptom reported. */
  symptomDays?: InputMaybe<Array<HosSymptomDaysInput>>;
  /** Numeric / rating / confirm value when no option id applies — a body-weight ask sends the kilograms here. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type HosCheckinAnswerResult = {
  __typename?: 'HosCheckinAnswerResult';
  checkin: HosCheckin;
  outcome: HosIngestOutcome;
  /** A recompute was enqueued. False before activation: the activation recompute reads signals stored before it (OQ-API-32). */
  recomputeEnqueued: Scalars['Boolean'];
  safety: HosSafetyScan;
  /** Signals written in the same transaction. */
  signalIds: Array<Scalars['ID']>;
};

export type HosCheckinInbox = {
  __typename?: 'HosCheckinInbox';
  /** Today's dose_reminder row, any status, so the plan view shows confirmed or pending. */
  doseReminderToday?: Maybe<HosCheckin>;
  /** Asks in due / held / sent, oldest first. */
  openCheckins: Array<HosCheckin>;
  schedule: HosPatientSchedule;
};

/** M3 creates first_dose_comfort and dose_reminder; the cadence kinds arrive with their lanes. */
export enum HosCheckinKind {
  ActionCheckin = 'action_checkin',
  Adhoc = 'adhoc',
  DoseReminder = 'dose_reminder',
  FirstDoseComfort = 'first_dose_comfort',
  PostStep = 'post_step',
  Ratings = 'ratings',
  Stale = 'stale',
  Weekly = 'weekly'
}

export type HosCheckinQuestion = {
  __typename?: 'HosCheckinQuestion';
  /** single_choice | multi_select | numeric | rating_1_5 | symptom_days | free_text | confirm. */
  inputKind: Scalars['String'];
  options: Array<HosCheckinQuickReply>;
  questionCopyKey: Scalars['String'];
  questionId: Scalars['String'];
  /** Free text on this question passes the red-flag scan before anything is stored (MG-5). */
  safetyScan: Scalars['Boolean'];
  /** The hos_signal key this answer becomes. */
  signalKey: Scalars['String'];
  /** symptom_days questions: the vocabulary to tap through, one line per symptom. */
  symptoms: Array<HosCheckinSymptom>;
};

export type HosCheckinQuickReply = {
  __typename?: 'HosCheckinQuickReply';
  copyKey: Scalars['String'];
  id: Scalars['String'];
  /** The registry value this option contributes to the signal — what the score reads, not the option id. */
  value?: Maybe<Scalars['JSON']>;
};

export enum HosCheckinStatus {
  Answered = 'answered',
  Due = 'due',
  Expired = 'expired',
  Held = 'held',
  Missed = 'missed',
  Sent = 'sent',
  Skipped = 'skipped'
}

export type HosCheckinSymptom = {
  __typename?: 'HosCheckinSymptom';
  copyKey: Scalars['String'];
  /** true on the 'something else' entry: it accepts free text, which is safety-scanned. */
  freeText: Scalars['Boolean'];
  id: Scalars['String'];
};

/** frozen: virtual now stays put until advanced. offset: it moves with real time by a constant. */
export enum HosClockMode {
  Frozen = 'frozen',
  Offset = 'offset'
}

export type HosCompleteActionInput = {
  actionInstanceId: Scalars['ID'];
  /** The closing check-in answer, when the action carries one. */
  answer?: InputMaybe<HosCheckinAnswerInput>;
  /** Client UUID. A retry returns the current instance: no second record event and no second signal. */
  clientRequestId: Scalars['ID'];
};

/** Internal confidence (R3). Resolved by role: null for a patient principal. */
export type HosConfidence = {
  __typename?: 'HosConfidence';
  grade: HosConfidenceGrade;
  gradedAt: Scalars['DateTime'];
  /** Below scoring.confidence stale_threshold: the stale ask fires (R3, MG-15). */
  stale: Scalars['Boolean'];
  value: Scalars['Int'];
};

/** Internal confidence grade (R3.3); never served to a patient principal. */
export enum HosConfidenceGrade {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type HosConfirmDoseInput = {
  /** The dose_reminder row when tapped from the reminder; null from the hub or the guide. */
  checkinId?: InputMaybe<Scalars['ID']>;
  clientRequestId: Scalars['ID'];
  taken: Scalars['Boolean'];
};

/** Consent screen content from the registry; version is the explicit consent_version, served as text (the one static-copy exception to keys, MG-7). */
export type HosConsentCopy = {
  __typename?: 'HosConsentCopy';
  bodyText: Scalars['String'];
  checkboxText: Scalars['String'];
  continueText: Scalars['String'];
  policyLinks: Array<Scalars['String']>;
  titleText: Scalars['String'];
  version: Scalars['String'];
};

/** The patient's consent state and the current version served from the registry (MG-7). */
export type HosConsentState = {
  __typename?: 'HosConsentState';
  copy: HosConsentCopy;
  /** The current published consent version; hosGrantConsent.copyVersion must equal this. */
  currentCopyVersion: Scalars['String'];
  granted: Scalars['Boolean'];
  grantedAt?: Maybe<Scalars['DateTime']>;
  grantedCopyVersion?: Maybe<Scalars['String']>;
  /** true when grantedCopyVersion != currentCopyVersion: stage returns to consent until the new version is granted. */
  reconsentRequired: Scalars['Boolean'];
};

/** A registry option the client renders from its bundle: id echoed back, copy key rendered (API contracts §3.1). */
export type HosCopyOption = {
  __typename?: 'HosCopyOption';
  copyKey: Scalars['String'];
  id: Scalars['String'];
  value?: Maybe<Scalars['JSON']>;
};

/** A retrievable chunk of an approved corpus document's stored text (curator plan §7): what the curator verifies verbatim quotes against. */
export type HosCorpusChunk = {
  __typename?: 'HosCorpusChunk';
  docId: Scalars['String'];
  /** abstract or full, derived from the locator. */
  kind: HosCorpusChunkKind;
  /** Chunk locator, e.g. `full` or `abstract`. A curator quote locator is `<locator>#<start>-<end>`. */
  locator: Scalars['String'];
  ordinal: Scalars['Int'];
  text: Scalars['String'];
};

/** Whether a corpus chunk holds the document abstract or its full text. */
export enum HosCorpusChunkKind {
  Abstract = 'abstract',
  Full = 'full'
}

/** A document in this region's corpus store, listed for the admin corpus dashboard (corpus C12). */
export type HosCorpusDocument = {
  __typename?: 'HosCorpusDocument';
  abstract?: Maybe<Scalars['String']>;
  /** PDF §2 acquisition outcome: full_text | abstract_only | manual. */
  access?: Maybe<Scalars['String']>;
  approvalStatus: Scalars['String'];
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  /** Every author the source lists, "Surname Initials"; a label or guideline carries its issuing body. */
  authors: Array<Scalars['String']>;
  /** Rendered citation: authors (first ten, then et al.), journal, year. */
  citation?: Maybe<Scalars['String']>;
  conditionTags: Array<Scalars['String']>;
  /** PDF Appendix A design: trial | observational | review | guideline | consensus | qualitative. */
  design?: Maybe<Scalars['String']>;
  docId: Scalars['String'];
  docType?: Maybe<Scalars['String']>;
  docVersion: Scalars['Int'];
  doi?: Maybe<Scalars['String']>;
  /** PDF §7 domain_tags: the six-domain coverage with measured/recommended status and quotes. */
  domainTags: Array<HosCorpusDomainTag>;
  /** PDF §7: the source reports a null/negative/harmful finding for a candidate action. */
  evidenceAgainst: Scalars['Boolean'];
  evidenceCategory: Scalars['Int'];
  /** Whether this region's corpus document store holds the full text. */
  fullTextAvailable: Scalars['Boolean'];
  /** Journal or issuing body. */
  journal?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  /** PDF §3 layer: A (within our drugs) | B (the signal beyond them) | cross. */
  layer?: Maybe<Scalars['String']>;
  licence?: Maybe<Scalars['String']>;
  /** PDF §7 lifecycle_tags: initiation | titration | maintenance | discontinuation | resumption. */
  lifecycleTags: Array<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  marketBasis?: Maybe<Scalars['String']>;
  pmid?: Maybe<Scalars['String']>;
  /** §7 population {n, sex, age_range, countries, baseline_severity}. */
  population?: Maybe<HosCorpusPopulation>;
  publicationDate?: Maybe<Scalars['DateTime']>;
  /** The clinical_corpus registry version this doc_id was last published in. */
  registryVersion?: Maybe<Scalars['Int']>;
  /** The query ids (from _queries) that surfaced this document. */
  retrievalQueryId: Array<Scalars['String']>;
  /** PDF §7 review_status: unreviewed | clinician_reviewed | rejected. */
  reviewStatus?: Maybe<Scalars['String']>;
  /** PDF §7 signal_tags (controlled vocabulary). */
  signalTags: Array<Scalars['String']>;
  /** The journal or issuing body (kept for compatibility; `journal` is the same value). */
  source: Scalars['String'];
  sourceClass: Scalars['String'];
  /** PDF §7 source_type: label | guideline | sr_ma | rct | observational | consensus | qualitative | prom_validation. */
  sourceType?: Maybe<Scalars['String']>;
  /** Trial-registry id set shared by every report of one trial. */
  studyGroupId?: Maybe<Scalars['String']>;
  /** PDF §2 tier: T1 | T2 | T3 | T4 | Ref. */
  tier?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  /** Publication year; for a regulator's label with no stated year, the year of the capture. */
  year?: Maybe<Scalars['Int']>;
};

/** A §7 domain tag on a corpus document: which of the six domains the source measures or recommends for, with a verbatim quote. */
export type HosCorpusDomainTag = {
  __typename?: 'HosCorpusDomainTag';
  /** clinical | adherence | tolerability | satisfaction | qol | ease. */
  domain: Scalars['String'];
  /** A verbatim quote from the source; required for a measured tag (CX11). */
  quote: Scalars['String'];
  /** measured (the source reports a number) or recommended (the source explicitly recommends for it). */
  status: Scalars['String'];
};

/** A resolved reference the caller can review before proposing it into the corpus (on-demand add). */
export type HosCorpusLookup = {
  __typename?: 'HosCorpusLookup';
  abstract?: Maybe<Scalars['String']>;
  /** True when a row with this pmid or doi is already in the latest clinical_corpus snapshot (C8). */
  alreadyInRegistry: Scalars['Boolean'];
  authors: Array<Scalars['String']>;
  doi?: Maybe<Scalars['String']>;
  /** evidence_category values the caller must pick from (from the clinical_corpus schema). */
  evidenceCategoryOptions: Array<Scalars['Int']>;
  /** The doc_id already holding this pmid/doi, when alreadyInRegistry is true. */
  existingDocId?: Maybe<Scalars['String']>;
  /** Whether a PubMed Central open-access full text exists for the record. */
  fullTextAvailable: Scalars['Boolean'];
  /** Journal or publisher. */
  journal?: Maybe<Scalars['String']>;
  /** Licence when the source states one, else null. Null means a proposed row is placeholder and cannot be approved until set. */
  licence?: Maybe<Scalars['String']>;
  pmcid?: Maybe<Scalars['String']>;
  pmid?: Maybe<Scalars['String']>;
  /** The reference as resolved, e.g. pmid:33567185. */
  ref: Scalars['String'];
  /** Which upstream resolved it: pubmed or crossref. */
  resolvedFrom: Scalars['String'];
  /** source_class values the caller must pick from (from the clinical_corpus schema). */
  sourceClassOptions: Array<Scalars['String']>;
  /** Next free C-number in the latest clinical_corpus snapshot; the doc_id a proposal would use. */
  suggestedDocId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  /** Canonical URL for the record. */
  url?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** §7 population sub-fields; each null when the source does not state it. */
export type HosCorpusPopulation = {
  __typename?: 'HosCorpusPopulation';
  ageRange?: Maybe<Scalars['String']>;
  baselineSeverity?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Scalars['String']>>;
  n?: Maybe<Scalars['Int']>;
  sex?: Maybe<Scalars['String']>;
};

/** One section x one condition x this region (D3). The rows payload is the complete section content, not a delta. */
export type HosCreateRegistryProposalInput = {
  /** Must equal the section's current version or the proposal is rejected and must re-base (design §3). 0 for the bootstrap. */
  baseVersion: Scalars['Int'];
  /** Companion patient_copy rows (add/change keys) this non-copy proposal ships (owner 2026-09-16). An array in the patient_copy row schema. Validators resolve the section's copy keys against published ∪ companion; approving publishes these merged onto the current copy version as a new patient_copy version before the section version. */
  companionCopyRows?: InputMaybe<Scalars['JSON']>;
  condition: Scalars['String'];
  /** Curator principal ONLY: the curator run that drafted this proposal (owner 2026-09-17). Any other caller passing it is refused. Approving a proposal that carries one is what queues the run's follow-on. */
  curatorRunId?: InputMaybe<Scalars['ID']>;
  /** CGO only: publishes on CGO approval and queues an admin retro review (D18). */
  emergency?: InputMaybe<Scalars['Boolean']>;
  /** Author's impact text; the system adds the diff stats. */
  impactText?: InputMaybe<Scalars['String']>;
  /** Complete section payload. Validated against schema/<section>.schema.json. */
  rows: Scalars['JSON'];
  /** Section schema version the payload was authored against. Defaults to the current one. */
  schemaVersion?: InputMaybe<Scalars['Int']>;
  section: HosRegistrySection;
};

/** Corpus rendering for a curator run: full (every stored chunk) or abstracts (metadata + abstract only). */
export enum HosCuratorContextMode {
  Abstracts = 'abstracts',
  Full = 'full'
}

/** One AI-curator run: one section × condition × brand. Created by hosRunCurator, updated by the curator through hosReportCuratorRun. */
export type HosCuratorRun = {
  __typename?: 'HosCuratorRun';
  braintrustRun?: Maybe<Scalars['String']>;
  brand: HosBrand;
  condition: Scalars['String'];
  corpusVersion?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  dependencyVersions?: Maybe<Scalars['JSON']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  /** The run this one continues (curator plan §3 follow-on); null for a first run. */
  followOnOf?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  inputsHash?: Maybe<Scalars['String']>;
  kind: HosCuratorRunKind;
  model?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  /** Corpus-rendering options this run was triggered with; null when it used every default. */
  options?: Maybe<HosCuratorRunOptions>;
  promptPins?: Maybe<Scalars['JSON']>;
  proposalIds: Array<Scalars['ID']>;
  report?: Maybe<Scalars['JSON']>;
  section: HosRegistrySection;
  sectionVersion?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: HosCuratorRunStatus;
  trigger: HosCuratorRunTrigger;
  triggeredBy: Scalars['String'];
};

export type HosCuratorRunFilterInput = {
  brand?: InputMaybe<HosBrand>;
  condition?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<HosCuratorRunKind>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  section?: InputMaybe<HosRegistrySection>;
  status?: InputMaybe<Array<HosCuratorRunStatus>>;
};

/** What a curator run drafts: a single section (default), or the actions+milestones bundle (section forced to action_library, brand all). */
export enum HosCuratorRunKind {
  ActionsMilestones = 'actions_milestones',
  Section = 'section'
}

/** Corpus-rendering options a curator run was triggered with. An absent field means the curator package's default. */
export type HosCuratorRunOptions = {
  __typename?: 'HosCuratorRunOptions';
  /** Estimated-prompt-token ceiling above which the run refuses to call the model. */
  budgetTokens?: Maybe<Scalars['Int']>;
  /** full (every stored chunk) or abstracts (metadata + abstract only). */
  contextMode?: Maybe<HosCuratorContextMode>;
  /** Bundle runs only: milestones and actions drafted in separate calls. */
  split?: Maybe<Scalars['Boolean']>;
  /** Corpus tiers rendered; null = every tier. */
  tiers?: Maybe<Array<Scalars['String']>>;
};

export enum HosCuratorRunStatus {
  Failed = 'failed',
  NoOp = 'no_op',
  Proposed = 'proposed',
  Queued = 'queued',
  Running = 'running'
}

export enum HosCuratorRunTrigger {
  Cli = 'cli',
  Dashboard = 'dashboard',
  FollowOn = 'follow_on',
  Schedule = 'schedule'
}

export type HosDayRange = {
  __typename?: 'HosDayRange';
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type HosDoseConfirmResult = {
  __typename?: 'HosDoseConfirmResult';
  /** The reminder ask this answered, when there was one. */
  checkin?: Maybe<HosCheckin>;
  /** The after-dose check-in this confirmation opened (R36.3). */
  comfortAsk: HosCheckin;
  /** True when this confirmation was the patient's FIRST dose and stamped first_dose_confirmed_at. */
  firstDose: Scalars['Boolean'];
  recomputeEnqueued: Scalars['Boolean'];
};

export type HosDurationInput = {
  days?: InputMaybe<Scalars['Int']>;
  hours?: InputMaybe<Scalars['Int']>;
  minutes?: InputMaybe<Scalars['Int']>;
};

/** An education item rendered under the empty orb (SD6 sub); evidence doc ids from hos_education_evidence. */
export type HosEducationItem = {
  __typename?: 'HosEducationItem';
  /** patient_copy key of the body. */
  copyKey: Scalars['String'];
  evidenceDocIds: Array<Scalars['String']>;
  id: Scalars['String'];
  order: Scalars['Int'];
  /** Lowest stage the entry shows in; null when the row names none. The contract's scalar (API contracts §2.1). */
  stage?: Maybe<Scalars['Int']>;
  /** Every stage the entry shows in — a card may appear in several (education.schema.json authors `stage` as an array) [PROPOSED 2026-09-17, education stage array]. */
  stages: Array<Scalars['Int']>;
  /** patient_copy key of the heading, from the row's title_key. The accordion has no other source for it. */
  titleCopyKey: Scalars['String'];
};

/** Derived eligibility for HealthOS (SD6, OQ-API-17). */
export type HosEligibility = {
  __typename?: 'HosEligibility';
  /** Condition of the eligible prescription. Phase 1: weight_loss. */
  condition?: Maybe<Scalars['String']>;
  eligible: Scalars['Boolean'];
  evaluatedAt: Scalars['DateTime'];
  /** patient_copy key hos.patient_copy.glimpse.<reason>; null when eligible. */
  glimpseCopyKey?: Maybe<Scalars['String']>;
  reasons: Array<HosIneligibilityReason>;
};

/** Evidence rung behind an estimate's largest contribution. measured = a study compared doing the action against not doing it, mapped through the signal's anchors; recommended / association / mechanism each take a fixed fraction of the room left; none = no evidence entry carried a usable effect. */
export enum HosEstimateBasis {
  Association = 'association',
  Measured = 'measured',
  Mechanism = 'mechanism',
  None = 'none',
  Recommended = 'recommended'
}

export type HosEvidenceBlock = {
  __typename?: 'HosEvidenceBlock';
  /** Null when the patient has reported nothing behind this sub-score yet — the app omits the panel rather than rendering it empty (R9.4). */
  personal?: Maybe<HosPersonalEvidence>;
  population: Array<HosEvidenceClaim>;
};

export type HosEvidenceCitation = {
  __typename?: 'HosEvidenceCitation';
  /** Rendered by the shared formatter: first ten, then 'et al.'. */
  authors: Array<Scalars['String']>;
  evidenceCategory: Scalars['Int'];
  journal?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  /** Null on every published row today; `year` carries the date. */
  publicationDate?: Maybe<Scalars['DateTime']>;
  source: Scalars['String'];
  title: Scalars['String'];
  year?: Maybe<Scalars['Int']>;
};

export type HosEvidenceClaim = {
  __typename?: 'HosEvidenceClaim';
  /** Null when the pinned clinical_corpus version no longer carries the document. */
  citation?: Maybe<HosEvidenceCitation>;
  /** patient_copy key of the approved claim. */
  claimKey: Scalars['String'];
  /** clinical_corpus row id. */
  docId: Scalars['String'];
  locator?: Maybe<Scalars['String']>;
};

/** When the first dose was taken (HOME-GATE-when); back-dates first_dose_confirmed_at (contracts §2.1). */
export enum HosFirstDoseBucket {
  Earlier = 'earlier',
  LastWeek = 'last_week',
  Today = 'today'
}

/** The first-dose gate row plus this patient's answers (API contracts §2.1). */
export type HosFirstDoseGate = {
  __typename?: 'HosFirstDoseGate';
  /** Set once by the gate row's unlocks_on_option_id (Yes); never overwritten. */
  confirmedAt?: Maybe<Scalars['DateTime']>;
  lastAnswerOptionId?: Maybe<Scalars['String']>;
  lastAnsweredAt?: Maybe<Scalars['DateTime']>;
  options: Array<HosCopyOption>;
  questionCopyKey: Scalars['String'];
  /** The option id that unlocks the gate (Yes); the client opens the when-step on this, not a per-option flag (API contracts §2.1). */
  unlocksOnOptionId: Scalars['String'];
};

/** The upcoming consult behind the `booked` glimpse card (HOME-GLM-booked, shell-screen DoD §3.12). */
export type HosGlimpseConsult = {
  __typename?: 'HosGlimpseConsult';
  /** Scheduled start of the soonest upcoming, non-cancelled consult; the card's date pill. */
  scheduledAt: Scalars['DateTime'];
};

/** Which glimpse card a not-eligible patient sees (HOME-GLM-eval/book/booked/done, shell-screen DoD §3.12). */
export enum HosGlimpseState {
  Book = 'book',
  Booked = 'booked',
  Done = 'done',
  Eval = 'eval'
}

export type HosHarnessAdvanceResult = {
  __typename?: 'HosHarnessAdvanceResult';
  clock: HosHarnessClock;
  /** HOS jobs delivered inline because their fire time fell inside the jump. */
  jobsDelivered: Array<HosHarnessDeliveredJob>;
  shell: HosShellState;
  /** One per virtual local day crossed, in order (YYYY-MM-DD). */
  ticksRun: Array<Scalars['String']>;
};

export type HosHarnessClock = {
  __typename?: 'HosHarnessClock';
  /** Env HOS_CLOCK_TTL_MS, default 7 days: a forgotten clock reverts to real time. */
  expiresAt?: Maybe<Scalars['DateTime']>;
  mode: HosClockMode;
  /** virtual now minus real now, in seconds; constant in offset mode, shrinking in frozen mode. */
  offsetSeconds: Scalars['Int'];
  patientSysId: Scalars['ID'];
  setAt: Scalars['DateTime'];
  setBy?: Maybe<Scalars['ID']>;
  virtualNow: Scalars['DateTime'];
};

export type HosHarnessDeliveredJob = {
  __typename?: 'HosHarnessDeliveredJob';
  /** The patient's local day the job fired for (YYYY-MM-DD). */
  fireAt: Scalars['String'];
  jobId: Scalars['ID'];
  kind: Scalars['String'];
};

export type HosHarnessJobResult = {
  __typename?: 'HosHarnessJobResult';
  accepted: Scalars['Boolean'];
  jobId: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
};

export type HosHarnessPatient = {
  __typename?: 'HosHarnessPatient';
  /** The HOS condition when eligible (weight_loss in Phase 1); null when not eligible. */
  condition?: Maybe<Scalars['String']>;
  /** Shell eligibility from HosEligibilityService (SD6, OQ-API-17). */
  eligible: Scalars['Boolean'];
  isTestPatient: Scalars['Boolean'];
  label: Scalars['String'];
  lastActedAsAt?: Maybe<Scalars['DateTime']>;
  patientSysId: Scalars['ID'];
  /** Why the patient is not eligible; empty when eligible. */
  reasons: Array<HosIneligibilityReason>;
};

/** What state hosHarnessSeed puts a harness patient into (API contracts §2.7, OQ-11-2): the shell ladder, the M4 card states, and the stale score. Seeded through the product's own services. */
export enum HosHarnessScenario {
  Active = 'active',
  ClosingQuestionPending = 'closing_question_pending',
  DoseDay = 'dose_day',
  EligibleNoConsent = 'eligible_no_consent',
  EligibleNoQuestionnaire = 'eligible_no_questionnaire',
  FirstDoseNo = 'first_dose_no',
  HeldPushReleased = 'held_push_released',
  MilestoneReached = 'milestone_reached',
  NotEligible = 'not_eligible',
  SafetyCardActive = 'safety_card_active',
  Stage_1 = 'stage_1',
  Stage_2 = 'stage_2',
  Stage_3 = 'stage_3',
  Stage_4 = 'stage_4',
  StaleScore = 'stale_score'
}

export type HosHarnessSeedInput = {
  /** Back-dates the rows the seed derives (a milestone's reading series, the baseline's date-time answer) so the recompute derives the state rather than being told it. The prod-safe path; staging and local also have the per-patient virtual clock. */
  asOf?: InputMaybe<Scalars['DateTime']>;
  /** Idempotency key with the patient: a retry of the same request re-reads the shell instead of seeding twice. */
  clientRequestId: Scalars['ID'];
  patientSysId: Scalars['ID'];
  scenario: HosHarnessScenario;
};

export type HosHarnessSession = {
  __typename?: 'HosHarnessSession';
  actAsId: Scalars['ID'];
  internalUserSysId: Scalars['ID'];
  patientSysId: Scalars['ID'];
  startedAt: Scalars['DateTime'];
};

export type HosImprovementCardBody = {
  __typename?: 'HosImprovementCardBody';
  actionId: Scalars['String'];
  /** Null until Start This creates the instance. */
  actionInstanceId?: Maybe<Scalars['ID']>;
  /** Worded benefit, 'estimated, not guaranteed', no number (R7.5). */
  benefitKey: Scalars['String'];
  checkinQuestionKey?: Maybe<Scalars['String']>;
  /** Signal key the closing answer feeds (action row checkin_signal). */
  checkinSignal?: Maybe<Scalars['String']>;
  /** The ask 'I've done this' answers, resolved from checkin_config: its question id and its option ids are what makes a valid HosCheckinAnswerInput (§3.2 C17). questionCopyKey is the action's own wording when its row carries one. Null when no published question closes this action — the card then has no closing ask. */
  closingQuestion?: Maybe<HosCheckinQuestion>;
  dueAt?: Maybe<Scalars['DateTime']>;
  /** The most overall-score points this action could add for this patient. Null when the number rounds below the registry's min_points_to_show or no evidence entry carries an effect — the card then shows no number and no empty slot. */
  estimate?: Maybe<HosActionEstimateSummary>;
  /** (100 - sub-score) x stage weight / 100: the ranking measure. Staff and harness reading, never rendered to a patient. */
  headroom: Scalars['Float'];
  /** The sub-score this action targets. */
  helps: HosSubscoreKey;
  /** Non-score-driven first-injection guide (R8.4). */
  preset: Scalars['Boolean'];
  startedAt?: Maybe<Scalars['DateTime']>;
  state: HosActionState;
  /** 1 = a guidance trigger ranked this sub-score up; 2 = ranked on headroom alone. */
  tier: Scalars['Int'];
  timeframeDays?: Maybe<HosDayRange>;
  titleKey: Scalars['String'];
};

/** Why a patient is not eligible for HealthOS (OQ-API-17). */
export enum HosIneligibilityReason {
  NoPaidSubscription = 'no_paid_subscription',
  NoPrescription = 'no_prescription',
  OtherCondition = 'other_condition'
}

/** Result of an ingest carrying free text (MG-5). A scan that could not run is the error HOS_SCAN_UNAVAILABLE, never an outcome. */
export enum HosIngestOutcome {
  BlockedSafety = 'blocked_safety',
  Stored = 'stored'
}

export type HosMilestone = {
  __typename?: 'HosMilestone';
  /** The pool row's acknowledgement copy key (registry design D25), templated from progress. Null while state = next. */
  acknowledgementKey?: Maybe<Scalars['String']>;
  /** The pool row's approved claims (R26), joined to their clinical_corpus citations where published. */
  evidence: Array<HosEvidenceClaim>;
  /** 'This is guidance, not a doctor' (R10.5/R10.9). One key for the whole pool. */
  guidanceNoteKey: Scalars['String'];
  /** milestone_pool row id. */
  milestoneId: Scalars['String'];
  /** hos_patient_milestone row id — what hosAcknowledgeMilestone acts on. Null while state = next. */
  patientMilestoneId?: Maybe<Scalars['ID']>;
  /** Null on a milestone whose pool row defines no numeric target (a first dose, a stage move). */
  progress?: Maybe<HosMilestoneProgress>;
  /** hos_patient_milestone.achieved_at; null while state = next. */
  reachedAt?: Maybe<Scalars['DateTime']>;
  /** Stages this milestone fits. Empty = every stage. */
  stageFit: Array<Scalars['Int']>;
  state: HosMilestoneState;
  /** Static patient_copy key hos.milestone_pool.<id>.time_to_reach; null while that row is unpublished. */
  timeToReachKey?: Maybe<Scalars['String']>;
  titleKey: Scalars['String'];
  whyItMattersKey: Scalars['String'];
};

export type HosMilestoneProgress = {
  __typename?: 'HosMilestoneProgress';
  /** Real value so far — kg lost, not a percentage. Null until the patient has reported the reading it needs. */
  currentValue?: Maybe<Scalars['Float']>;
  /** 0-1, for the progress bar. Null when there is no reading to place on it. */
  fractionComplete?: Maybe<Scalars['Float']>;
  /** When the reading behind currentValue was taken. */
  observedAt?: Maybe<Scalars['DateTime']>;
  /** The signal the target is measured on (body_weight for a weight threshold). */
  signalKey: Scalars['String'];
  /** The target in the same unit — 5% of the starting weight, in kg. */
  targetValue?: Maybe<Scalars['Float']>;
  /** Unit of both values (kg). */
  unit?: Maybe<Scalars['String']>;
};

/** next = the milestone the patient is working towards; reached = confirmed, shown until the patient dismisses it (owner ruling 21 Sep: tap to dismiss, no timers). */
export enum HosMilestoneState {
  Next = 'next',
  Reached = 'reached'
}

/** Delivery channel of one attempt (API contracts §2.6). */
export enum HosNotificationChannel {
  Email = 'email',
  Freshchat = 'freshchat',
  InApp = 'in_app',
  Push = 'push',
  Slack = 'slack',
  Sms = 'sms'
}

/** What the notification is for; several due on one local day fold into one push_due row (MG-1). */
export enum HosNotificationKind {
  ActionReminder = 'action_reminder',
  CheckinDue = 'checkin_due',
  DoseReminder = 'dose_reminder',
  Education = 'education',
  Milestone = 'milestone',
  NextBestAction = 'next_best_action',
  OpsAlert = 'ops_alert',
  PostStepCheck = 'post_step_check',
  PushDue = 'push_due',
  SafetyAlert = 'safety_alert',
  StaleScore = 'stale_score'
}

/** safety | campaign. The safety lane bypasses the fold, the cap and the hold (MG-2). */
export enum HosNotificationLane {
  Campaign = 'campaign',
  Safety = 'safety'
}

/** One HealthOS delivery attempt on one channel (API contracts §2.6). Internal/admin only. */
export type HosNotificationLogEntry = {
  __typename?: 'HosNotificationLogEntry';
  /** The `hos_ops_alert` this attempt delivered; null on the campaign lane. */
  alertId?: Maybe<Scalars['ID']>;
  channel: HosNotificationChannel;
  /** Customer.io transactional event name when CIO-delivered. */
  cioEventName?: Maybe<Scalars['String']>;
  /** Customer.io message/delivery id — the dedupe key on their side. */
  cioMessageId?: Maybe<Scalars['String']>;
  /** The pinned patient_copy version that rendered templateVars; null on a lane that renders no registry copy. [landed 2026-09-22] */
  copyVersion?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  /** Patient-local day the ledger keyed on (MG-1). */
  cycleDate?: Maybe<Scalars['String']>;
  /** Where a tap on this notification lands — `hosOpenChat` with its context. [landed 2026-09-22] */
  deepLink?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  /** The kinds this one push stood in for (MG-1). Empty on an unfolded send. */
  foldedKinds: Array<HosNotificationKind>;
  id: Scalars['ID'];
  kind: HosNotificationKind;
  lane: HosNotificationLane;
  /** The `hos_push_ledger` row this attempt belongs to; null on the safety lane. [landed 2026-09-22] */
  ledgerId?: Maybe<Scalars['ID']>;
  patientSysId?: Maybe<Scalars['ID']>;
  /** The provider's own id for the attempt: the CIO delivery id, the Slack message ts, the Freshchat conversation id. [landed 2026-09-22] */
  providerId?: Maybe<Scalars['String']>;
  /** held: an active safety card; suppressed: ineligible, Excellent band, gate off; folded: the day was already sent. */
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  status: HosNotificationStatus;
  /** The strings that were sent, rendered server-side from the pinned patient_copy snapshot (MG-8). */
  templateVars?: Maybe<Scalars['JSON']>;
};

/** queued | sent | failed | held | suppressed | folded (API contracts §2.6). */
export enum HosNotificationStatus {
  Failed = 'failed',
  Folded = 'folded',
  Held = 'held',
  Queued = 'queued',
  Sent = 'sent',
  Suppressed = 'suppressed'
}

export type HosOpsAlert = {
  __typename?: 'HosOpsAlert';
  ackedAt?: Maybe<Scalars['DateTime']>;
  ackedBy?: Maybe<Scalars['String']>;
  /** The same ops actions, typed. */
  actionEntries: Array<HosOpsAlertActionEntry>;
  /** Ops actions in order: { action, note, actor, at }. */
  actions: Scalars['JSON'];
  /** The classifier's rationale from the flag. Never the patient's words. */
  classifierRationale?: Maybe<Scalars['String']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  /** Every delivery attempt for this alert, oldest first. */
  deliveries: Array<HosOpsAlertDelivery>;
  firedAt: Scalars['DateTime'];
  flagId?: Maybe<Scalars['ID']>;
  /** The linked flag is still open or acknowledged, whatever the alert's status: a closed alert can carry a live flag. */
  flagLive: Scalars['Boolean'];
  /** The linked flag is live and ops may clear it (hosOpsAlertClearFlag): its required action is ops_resolution or book_consult, not the patient's read. */
  flagOpsClearable: Scalars['Boolean'];
  /** The linked flag's state now. Null when the alert has no flag. */
  flagState?: Maybe<HosSafetyFlagState>;
  /** The Freshchat conversation ops continue in. */
  freshchatConversationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** patient_copy key of the safety card instruction the patient was shown. */
  instructionCopyKey?: Maybe<Scalars['String']>;
  kind: HosOpsAlertKind;
  lastSeenAt: Scalars['DateTime'];
  /** Ops-facing channels the rule routes to. */
  opsChannels: Array<Scalars['String']>;
  /** When the patient acknowledged the safety card. */
  patientAcknowledgedAt?: Maybe<Scalars['DateTime']>;
  /** Patient-facing channels the rule routes to. */
  patientChannels: Array<Scalars['String']>;
  /** Masked display label: initials, age band and a short reference (OQ-API-52). Never a name or an email. */
  patientLabel: Scalars['String'];
  /** Opaque per-region patient reference, never PII (MG-8). */
  patientRef: Scalars['ID'];
  /** Ops playbook steps for this rule, as published. Empty while safety_rules is empty. */
  playbook: Scalars['JSON'];
  /** Copy keys of the playbook steps that carry one (R17.6). Empty when every step is written out. */
  playbookCopyKeys: Array<Scalars['String']>;
  /** The playbook steps typed and in order. */
  playbookSteps: Array<HosOpsAlertPlaybookStep>;
  recurrenceCount: Scalars['Int'];
  /** safety_rules row id, or classifier.<category> while that section is empty. */
  ruleId?: Maybe<Scalars['String']>;
  severity: HosSafetySeverity;
  /** A Slack post exists for this alert. */
  slackPosted: Scalars['Boolean'];
  source: HosSafetySource;
  /** Step id (titration_failure) or escalation id (booking_failed); null for safety. */
  sourceRef?: Maybe<Scalars['ID']>;
  status: HosOpsAlertStatus;
  /** Masked one-liner for the queue; never the raw message. */
  summary?: Maybe<Scalars['String']>;
};

/** What an operator did with an alert. ack and closed move the lifecycle; the other two are log entries. */
export enum HosOpsAlertAction {
  Ack = 'ack',
  Closed = 'closed',
  Contacted = 'contacted',
  Escalated = 'escalated'
}

export type HosOpsAlertActionEntry = {
  __typename?: 'HosOpsAlertActionEntry';
  action: HosOpsAlertAction;
  actor: Scalars['String'];
  at: Scalars['DateTime'];
  note?: Maybe<Scalars['String']>;
};

export type HosOpsAlertDelivery = {
  __typename?: 'HosOpsAlertDelivery';
  attemptedAt: Scalars['DateTime'];
  channel: HosNotificationChannel;
  /** The provider's own id: Slack ts, push or SMS delivery id, Freshchat conversation. */
  providerId?: Maybe<Scalars['String']>;
  /** Why the attempt was held, suppressed or failed. */
  reason?: Maybe<Scalars['String']>;
  status: HosNotificationStatus;
};

export enum HosOpsAlertKind {
  BookingFailed = 'booking_failed',
  Safety = 'safety',
  TitrationFailure = 'titration_failure'
}

export type HosOpsAlertPlaybookStep = {
  __typename?: 'HosOpsAlertPlaybookStep';
  copyKey?: Maybe<Scalars['String']>;
  instruction?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['String']>;
  slaMinutes?: Maybe<Scalars['Int']>;
};

export type HosOpsAlertReveal = {
  __typename?: 'HosOpsAlertReveal';
  alertId: Scalars['ID'];
  revealedAt: Scalars['DateTime'];
  /** The patient's words the flag was raised on. Null when the flag has no text (a critical-range hit). */
  sourceText?: Maybe<Scalars['String']>;
};

export enum HosOpsAlertStatus {
  Acked = 'acked',
  Closed = 'closed',
  Open = 'open'
}

/** Why an operator cleared a safety flag: reached the patient and no danger remains, handed to a doctor, sent to emergency care, the flag was a misread, or another live flag covers it. */
export enum HosOpsFlagClearReason {
  Duplicate = 'duplicate',
  EmergencyCareAdvised = 'emergency_care_advised',
  EscalatedToDoctor = 'escalated_to_doctor',
  FalsePositive = 'false_positive',
  PatientSafe = 'patient_safe'
}

export type HosPatientOverview = {
  __typename?: 'HosPatientOverview';
  /** Flags in open or acknowledged. The text a flag was raised on is never served here (MG-8). */
  openSafetyFlags: Array<HosSafetyFlag>;
  patientSysId: Scalars['ID'];
  /** Reminder settings; region defaults until the patient sets them (MG-16). */
  schedule: HosPatientSchedule;
  /** Latest stored score with its sub-scores. Staff read: `confidence` is populated. Null before the first compute. */
  score?: Maybe<HosScore>;
  /** Stage, eligibility, consent and the state timestamps (activated, baseline, intro). */
  shell: HosShellState;
  /** The trigger machine's state per rule (R4, MG-18). A patient never sees a trigger. */
  triggerStates: Array<HosTriggerStateView>;
};

export type HosPatientSchedule = {
  __typename?: 'HosPatientSchedule';
  /** Derived from the first picked day; the dose period anchors on it. */
  doseWeekday?: Maybe<Scalars['Int']>;
  reminderEnabled: Scalars['Boolean'];
  /** Patient-local hour 0-23 (hour granularity, MG-16). */
  reminderHour?: Maybe<Scalars['Int']>;
  /** ISO weekdays 1-7, sorted. Empty until the patient sets a reminder. */
  reminderWeekdays: Array<Scalars['Int']>;
  timezone: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HosPersonalEvidence = {
  __typename?: 'HosPersonalEvidence';
  /** hos.patient_copy.card.your_data, or .no_value when the leading reading carries no number. */
  copyKey: Scalars['String'];
  /** Template params: { subscore, subscoreCopyKey, signal, signalCopyKey, value, observed_at } — the names the copy row's own variables use. */
  params: Scalars['JSON'];
  /** Every reading behind the panel, heaviest signal first. */
  signals: Array<HosPersonalEvidenceSignal>;
  /** The sub-score the card targets: the panel is that sub-score's own inputs. */
  subscore: HosSubscoreKey;
};

export type HosPersonalEvidenceSignal = {
  __typename?: 'HosPersonalEvidenceSignal';
  observedAt: Scalars['DateTime'];
  /** hos_signal row id — where the number came from, so a reader can trace it. */
  signalId: Scalars['ID'];
  signalKey: Scalars['String'];
  /** checkin | reminder | chat | self_log | eval | consult. */
  source: Scalars['String'];
  /** Null for a reading with no number of its own, such as a symptom-days report. */
  value?: Maybe<Scalars['Float']>;
};

/** Per-section registry version tuple + language in force, stamped on every served payload (RL147, MG-12). */
export type HosPins = {
  __typename?: 'HosPins';
  language: Scalars['String'];
  versions: Array<HosRegistryPin>;
};

export type HosPrincipal = {
  __typename?: 'HosPrincipal';
  actAs?: Maybe<HosHarnessSession>;
  effectivePatientSysId?: Maybe<Scalars['ID']>;
  principalId: Scalars['String'];
  roles: Array<HosRole>;
};

/** Propose one resolved paper into clinical_corpus; re-resolved and submitted through the normal flow. */
export type HosProposeCorpusDocumentInput = {
  /** Idempotency key: the same value returns the same proposal instead of creating a duplicate. */
  clientRequestId: Scalars['String'];
  condition: Scalars['String'];
  /** evidence_category pick from HosCorpusLookup.evidenceCategoryOptions. */
  evidenceCategory: Scalars['Int'];
  /** Author's impact text; the system adds the diff stats. */
  impactText?: InputMaybe<Scalars['String']>;
  /** A PMID, DOI, or PubMed / DOI / PMC URL. */
  ref: Scalars['String'];
  /** source_class pick from HosCorpusLookup.sourceClassOptions. */
  sourceClass: Scalars['String'];
};

/** How one baseline questionnaire step is answered (API contracts §2.1). */
export enum HosQuestionnaireInputKind {
  DateTime = 'date_time',
  FreeText = 'free_text',
  MultiSelect = 'multi_select',
  Numeric = 'numeric',
  SingleChoice = 'single_choice'
}

/** One baseline questionnaire step from the published registry snapshot (API contracts §2.1). */
export type HosQuestionnaireStep = {
  __typename?: 'HosQuestionnaireStep';
  /** This patient's saved answer, or null. */
  answer?: Maybe<HosBaselineAnswer>;
  /** The registry row id, e.g. bq.step0_weight; passed back as hosAnswerBaselineStep.stepId. */
  id: Scalars['String'];
  inputKind: HosQuestionnaireInputKind;
  /** Copy keys only: option points never leave the server (R12.3, R6.3). */
  options: Array<HosCopyOption>;
  /** Step 0: { weightKg } from the patient's completed evaluation, or null when there is none. */
  prefill?: Maybe<Scalars['JSON']>;
  /** Where a pre-filled value comes from: `eval` on step 0 (RL69). */
  prefillSource?: Maybe<Scalars['String']>;
  questionCopyKey: Scalars['String'];
  /** This step's free text needs a red-flag scan before anything downstream may read it (R12.14, MG-5). M2 stores it UNSCANNED behind a stub — the client shows its 'not reviewed yet' copy note on these steps; the saved answer's safetyScanStatus carries the state. */
  safetyScan: Scalars['Boolean'];
  /** Whether the answer carries sub-score points (steps 0 and 4 are non-scoring). */
  scoring: Scalars['Boolean'];
  step: Scalars['Int'];
  /** Structured field the answer is stored to (baseline_weight_kg, six_month_target). */
  stores?: Maybe<Scalars['String']>;
  /** The sub-score this step baselines; null on a non-scoring step. */
  subscore?: Maybe<Scalars['String']>;
};

/** Quick-reply kinds; the server resolves by id, never by label (MG-22). */
export enum HosQuickReplyKind {
  Acknowledge = 'acknowledge',
  BookConsult = 'book_consult',
  CardAction = 'card_action',
  CheckinAnswer = 'checkin_answer',
  ConfirmSignal = 'confirm_signal',
  Handoff = 'handoff',
  RejectSignal = 'reject_signal'
}

/** What caused a recompute (DB schema §2.3, plus `scheduled` for the daily tick). */
export enum HosRecomputeCause {
  ActionCheckin = 'action_checkin',
  Baseline = 'baseline',
  Manual = 'manual',
  Scheduled = 'scheduled',
  Signal = 'signal',
  StageTransition = 'stage_transition'
}

export type HosRecordActor = {
  __typename?: 'HosRecordActor';
  /** The acting user or patient sysId; null for a system writer with no principal. */
  id?: Maybe<Scalars['String']>;
  /** A HosRole value (patient | doctor | cgo | admin | internal | seed | curator) or `system` for a job. */
  type: Scalars['String'];
};

/** clinical events are written in the state change's own transaction; behavioural events (views, taps) are buffered (MG-14). */
export enum HosRecordClass {
  Behavioural = 'behavioural',
  Clinical = 'clinical'
}

export type HosRecordEvent = {
  __typename?: 'HosRecordEvent';
  actor: HosRecordActor;
  /** hos_ai_call ids behind this event (MG-23); resolve one with hosAiCall. */
  aiCallIds: Array<Scalars['ID']>;
  class: HosRecordClass;
  /** dose_change_id or other chain id; the patient id is the journey id (RL138). */
  correlationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The patient's clock at the state change — virtual under harness time travel. */
  occurredAt: Scalars['DateTime'];
  /** Null for a system event with no patient (a registry publish). */
  patientSysId?: Maybe<Scalars['ID']>;
  /** Inputs, recommendation, evidence cited, guardrail checked, patient action, doctor decision (R29.2). Free-text and PII fields are served as `[withheld]` (MG-8). */
  payload: Scalars['JSON'];
  /** The registry versions in force at the write. Empty versions when the writer stamped none. */
  pins: HosPins;
  /** Monotonic per region; the audit dashboard orders by it and pages on it. */
  seq: Scalars['Int'];
  /** Fingerprint of the exact text served (R28.2) — the identity of a withheld field. */
  textFingerprint?: Maybe<Scalars['String']>;
  /** Dotted <module>.<entity>.<verb>; closed list, API contracts §3.4. */
  type: Scalars['String'];
};

export type HosRecordEventFilterInput = {
  class?: InputMaybe<HosRecordClass>;
  correlationId?: InputMaybe<Scalars['String']>;
  /** Opaque; from HosRecordEventPage.nextCursor. A cursor, not an offset: the table is append-only and large. */
  cursor?: InputMaybe<Scalars['String']>;
  /** occurred_at >= from. */
  from?: InputMaybe<Scalars['DateTime']>;
  /** Page size, capped at 200. */
  limit?: InputMaybe<Scalars['Int']>;
  /** One patient's story. Omit for the whole region's record (R29.5). */
  patientSysId?: InputMaybe<Scalars['ID']>;
  /** occurred_at <= to. */
  to?: InputMaybe<Scalars['DateTime']>;
  /** Event types to include, from the closed list (§3.4). Omit for all. */
  types?: InputMaybe<Array<Scalars['String']>>;
};

export type HosRecordEventPage = {
  __typename?: 'HosRecordEventPage';
  events: Array<HosRecordEvent>;
  /** Pass back as `filter.cursor` for the next (older) page. Null on the last page. */
  nextCursor?: Maybe<Scalars['String']>;
};

export enum HosRegistryApproverRole {
  Admin = 'admin',
  Cgo = 'cgo'
}

export enum HosRegistryAuthorType {
  Admin = 'admin',
  Cgo = 'cgo',
  Curator = 'curator',
  Seed = 'seed'
}

/** Rows of another section the cross-section validators should resolve against IN ADDITION to the published snapshot (e.g. the companion patient_copy payload). */
export type HosRegistryCompanionPayloadInput = {
  /** Complete rows payload for `section`, same shape as a snapshot's rows. */
  rows: Scalars['JSON'];
  section: HosRegistrySection;
};

/** Source of a proposal's resolved copy key: companion (the proposal's own rows), published (the current patient_copy snapshot), or missing. */
export enum HosRegistryCopySource {
  Companion = 'companion',
  Missing = 'missing',
  Published = 'published'
}

export type HosRegistryDiff = {
  __typename?: 'HosRegistryDiff';
  added: Array<HosRegistryDiffRow>;
  changed: Array<HosRegistryDiffRow>;
  removed: Array<HosRegistryDiffRow>;
  stats: HosRegistryDiffStats;
};

export enum HosRegistryDiffChange {
  Added = 'added',
  Changed = 'changed',
  Removed = 'removed'
}

export type HosRegistryDiffRow = {
  __typename?: 'HosRegistryDiffRow';
  /** Row as the proposal would publish it. Null on a removed row. */
  after?: Maybe<Scalars['JSON']>;
  /** Row as it is in the base snapshot. Null on an added row. */
  before?: Maybe<Scalars['JSON']>;
  change: HosRegistryDiffChange;
  clinical: Scalars['Boolean'];
  /** Sub-collection the row belongs to, for sections whose payload is an object of collections (scoring). Null for array sections. */
  collection?: Maybe<Scalars['String']>;
  placeholder: Scalars['Boolean'];
  rowId: Scalars['String'];
};

export type HosRegistryDiffStats = {
  __typename?: 'HosRegistryDiffStats';
  added: Scalars['Int'];
  changed: Scalars['Int'];
  /** Rows touched by this proposal that carry clinical = true. Drives requiredApproverRole. */
  clinicalRowsTouched: Scalars['Int'];
  placeholderRowsAfter: Scalars['Int'];
  removed: Scalars['Int'];
};

/** Dry-run preview (D14). Recomputes a patient sample on the proposed snapshot and shows score deltas. */
export type HosRegistryDryRun = {
  __typename?: 'HosRegistryDryRun';
  message?: Maybe<Scalars['String']>;
  sampleSize: Scalars['Int'];
  scoreDeltas: Array<HosRegistryScoreDelta>;
  status: HosRegistryDryRunStatus;
  validatorErrors: Array<HosRegistryValidatorError>;
};

export enum HosRegistryDryRunStatus {
  Failed = 'failed',
  Ok = 'ok',
  Unavailable = 'unavailable'
}

/** Author text plus system-computed diff stats (design §3). */
export type HosRegistryImpact = {
  __typename?: 'HosRegistryImpact';
  authorText?: Maybe<Scalars['String']>;
  stats: HosRegistryDiffStats;
};

/** One published registry section version (API contracts §3.1). */
export type HosRegistryPin = {
  __typename?: 'HosRegistryPin';
  section: HosRegistrySection;
  version: Scalars['Int'];
};

/** The caller as the registry sees it. Roles are re-checked server-side on every action (design §1). */
export type HosRegistryPrincipal = {
  __typename?: 'HosRegistryPrincipal';
  canApproveClinical: Scalars['Boolean'];
  canApproveNonClinical: Scalars['Boolean'];
  principalId: Scalars['String'];
  principalType: HosRegistryPrincipalType;
  roles: Array<HosRegistryRole>;
};

export enum HosRegistryPrincipalType {
  Service = 'service',
  User = 'user'
}

export type HosRegistryProposal = {
  __typename?: 'HosRegistryProposal';
  authorId: Scalars['String'];
  authorType: HosRegistryAuthorType;
  /** Null when baseVersion is 0. */
  baseSnapshot?: Maybe<HosRegistrySnapshotRef>;
  /** Version the diff is computed against. 0 for the bootstrap, where no version exists yet (D22). */
  baseVersion: Scalars['Int'];
  /** Companion patient_copy rows (add/change keys) this proposal ships. Null for a proposal with no companion copy (owner 2026-09-16). */
  companionCopyRows?: Maybe<Scalars['JSON']>;
  condition: Scalars['String'];
  containsClinicalRows: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  /** The curator run that drafted this proposal (owner 2026-09-17). Null for proposals people, scripts or the seed created. */
  curatorRunId?: Maybe<Scalars['ID']>;
  decidedAt?: Maybe<Scalars['DateTime']>;
  decidedBy?: Maybe<Scalars['String']>;
  decidedRole?: Maybe<HosRegistryApproverRole>;
  decisionNote?: Maybe<Scalars['String']>;
  diff: HosRegistryDiff;
  /** CGO-flagged emergency: publishes on CGO approval and is queued for admin retro review (D18). */
  emergency: Scalars['Boolean'];
  id: Scalars['ID'];
  impact: HosRegistryImpact;
  proposedSnapshot: HosRegistryProposedSnapshot;
  /** patient_copy version this proposal's companion rows published on approval. Null when it shipped no companion copy (owner 2026-09-16). */
  publishedCopyVersion?: Maybe<Scalars['Int']>;
  /** Version published by approving this proposal. Null until approved. */
  publishedVersion?: Maybe<Scalars['Int']>;
  /** Strictest row wins: any clinical row present -> cgo (or admin); none -> admin (design §3). */
  requiredApproverRole: HosRegistryApproverRole;
  /** Every copy key the proposal's rows reference, with its text filled from the companion rows first, then published patient_copy, else missing — so the dashboard needs no second query (owner 2026-09-16). */
  resolvedCopy: Array<HosRegistryResolvedCopy>;
  /** True while an emergency publish is waiting for admin retro review (D18). */
  retroReviewRequired: Scalars['Boolean'];
  retroReviewedAt?: Maybe<Scalars['DateTime']>;
  retroReviewedBy?: Maybe<Scalars['String']>;
  section: HosRegistrySection;
  status: HosRegistryProposalStatus;
  validatorErrors: Array<HosRegistryValidatorError>;
};

export type HosRegistryProposalFilterInput = {
  /** True returns only proposals touching at least one clinical row: the doctor dashboard's CGO queue. */
  clinicalOnly?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  section?: InputMaybe<HosRegistrySection>;
  status?: InputMaybe<Array<HosRegistryProposalStatus>>;
};

export enum HosRegistryProposalStatus {
  Approved = 'approved',
  Draft = 'draft',
  Rejected = 'rejected',
  Submitted = 'submitted'
}

/** The snapshot a proposal would publish. Has no version until it is approved. */
export type HosRegistryProposedSnapshot = {
  __typename?: 'HosRegistryProposedSnapshot';
  rows: Scalars['JSON'];
  schemaVersion: Scalars['Int'];
};

/** One resolved copy key referenced by a proposal's rows: the text under it, filled from the proposal's companion rows first, then the published patient_copy snapshot, else missing (owner 2026-09-16). */
export type HosRegistryResolvedCopy = {
  __typename?: 'HosRegistryResolvedCopy';
  key: Scalars['String'];
  source: HosRegistryCopySource;
  /** The copy text (locale en). Null when source is missing. */
  text?: Maybe<Scalars['String']>;
};

export enum HosRegistryRole {
  Admin = 'admin',
  Cgo = 'cgo',
  Curator = 'curator',
  Internal = 'internal',
  Seed = 'seed'
}

export type HosRegistryScoreDelta = {
  __typename?: 'HosRegistryScoreDelta';
  after?: Maybe<Scalars['Float']>;
  bandAfter?: Maybe<Scalars['String']>;
  bandBefore?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  /** Opaque reference to a sampled patient. Never PII. */
  patientRef: Scalars['String'];
};

/** The twelve registry sections. Each is independently versioned and approved. */
export enum HosRegistrySection {
  ActionLibrary = 'action_library',
  BaselineQuestionnaire = 'baseline_questionnaire',
  CheckinConfig = 'checkin_config',
  ClinicalCorpus = 'clinical_corpus',
  ClinicalThresholds = 'clinical_thresholds',
  DoseLadders = 'dose_ladders',
  Education = 'education',
  MilestonePool = 'milestone_pool',
  PatientCopy = 'patient_copy',
  Prompts = 'prompts',
  SafetyRules = 'safety_rules',
  Scoring = 'scoring'
}

/** One row per (section, condition) for the admin dashboard's section list. */
export type HosRegistrySectionSummary = {
  __typename?: 'HosRegistrySectionSummary';
  clinicalRowCount: Scalars['Int'];
  condition: Scalars['String'];
  /** The section's default approver (design §1 table). The role actually required is per proposal: see HosRegistryProposal.requiredApproverRole. */
  defaultApproverRole: HosRegistryApproverRole;
  latestPublishedAt?: Maybe<Scalars['DateTime']>;
  /** Null when nothing has been published for this section and condition yet (pre-bootstrap). */
  latestVersion?: Maybe<Scalars['Int']>;
  /** Proposals in draft or submitted for this section and condition. */
  openProposalCount: Scalars['Int'];
  /** Rows flagged placeholder in the latest snapshot. Must be zero at the dev-complete gate. */
  placeholderCount: Scalars['Int'];
  /** Rows in the latest snapshot, across every sub-collection. */
  rowCount: Scalars['Int'];
  /** Schema version of the latest published snapshot. */
  schemaVersion?: Maybe<Scalars['Int']>;
  section: HosRegistrySection;
};

/** An immutable snapshot. `rows` is byte-identical to the seed file's rows for the same content, so file-vs-snapshot diffs are direct. */
export type HosRegistrySnapshot = {
  __typename?: 'HosRegistrySnapshot';
  condition: Scalars['String'];
  placeholderCount: Scalars['Int'];
  publishedAt: Scalars['DateTime'];
  /** Every copy key this snapshot's rows reference, with its text from the published patient_copy snapshot of the same condition, else missing. Computed only when selected (owner 2026-09-17). */
  resolvedCopy: Array<HosRegistryResolvedCopy>;
  /** Section payload: an array of rows, or an object of named sub-collections for `scoring`. */
  rows: Scalars['JSON'];
  schemaVersion: Scalars['Int'];
  section: HosRegistrySection;
  version: Scalars['Int'];
};

/** Pointer to a published snapshot, without its payload. */
export type HosRegistrySnapshotRef = {
  __typename?: 'HosRegistrySnapshotRef';
  condition: Scalars['String'];
  publishedAt: Scalars['DateTime'];
  schemaVersion: Scalars['Int'];
  section: HosRegistrySection;
  version: Scalars['Int'];
};

/** The result of validating a complete section payload without writing anything (curator plan §7, C-6): the validator report plus the diff it would produce against the latest snapshot. */
export type HosRegistryValidationReport = {
  __typename?: 'HosRegistryValidationReport';
  /** Version the payload was compared against (latest; 0 for a bootstrap). */
  baseVersion: Scalars['Int'];
  condition: Scalars['String'];
  errors: Array<HosRegistryValidatorError>;
  /** The role a real proposal from this payload would require to approve. */
  requiredApproverRole: HosRegistryApproverRole;
  schemaVersion: Scalars['Int'];
  section: HosRegistrySection;
  stats: HosRegistryDiffStats;
  /** True when the diff against the latest snapshot is empty (create would refuse HOS_EMPTY_PROPOSAL). */
  wouldBeEmpty: Scalars['Boolean'];
};

export type HosRegistryValidatorError = {
  __typename?: 'HosRegistryValidatorError';
  /** Validator id from schema/README.md, e.g. SC1, CT4, A2. */
  code: Scalars['String'];
  message: Scalars['String'];
  /** JSON pointer into rows, where the failure is locatable. */
  path?: Maybe<Scalars['String']>;
};

/** An immutable published version. Rollback republishes an older snapshot as a NEW version; nothing is ever deleted (D8). */
export type HosRegistryVersion = {
  __typename?: 'HosRegistryVersion';
  condition: Scalars['String'];
  placeholderCount: Scalars['Int'];
  /** The proposal that published this version. */
  proposalId?: Maybe<Scalars['ID']>;
  publishedAt: Scalars['DateTime'];
  publishedBy?: Maybe<Scalars['String']>;
  publishedByRole?: Maybe<HosRegistryRole>;
  /** Set when this version was produced by a rollback: the version whose snapshot was republished. */
  rolledBackFromVersion?: Maybe<Scalars['Int']>;
  rowCount: Scalars['Int'];
  schemaVersion: Scalars['Int'];
  section: HosRegistrySection;
  version: Scalars['Int'];
};

export type HosReplay = {
  __typename?: 'HosReplay';
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Field-by-field difference; empty when the replay reproduced the original. */
  diff?: Maybe<Scalars['JSON']>;
  /** The outcome of rerunning the engine over the event's own recorded inputs. */
  fresh?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  identical?: Maybe<Scalars['Boolean']>;
  kind: HosReplayKind;
  message?: Maybe<Scalars['String']>;
  /** The stored outcome of the event being replayed. */
  original?: Maybe<Scalars['JSON']>;
  /** The registry versions the original ran under — the replay loads exactly these. */
  pins?: Maybe<Scalars['JSON']>;
  requestedAt: Scalars['DateTime'];
  requestedBy: Scalars['String'];
  status: HosReplayStatus;
  targetEventId: Scalars['ID'];
};

/** score and card rerun from stored inputs + pins; classifier and extraction rerun the pinned prompt. */
export enum HosReplayKind {
  Card = 'card',
  Classifier = 'classifier',
  Extraction = 'extraction',
  Score = 'score'
}

export enum HosReplayStatus {
  Done = 'done',
  Failed = 'failed',
  Queued = 'queued',
  Running = 'running'
}

/** Written only by the curator principal. Terminal statuses are write-once. */
export type HosReportCuratorRunInput = {
  braintrustRun?: InputMaybe<Scalars['String']>;
  corpusVersion?: InputMaybe<Scalars['Int']>;
  dependencyVersions?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
  inputsHash?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  promptPins?: InputMaybe<Scalars['JSON']>;
  proposalIds?: InputMaybe<Array<Scalars['ID']>>;
  report?: InputMaybe<Scalars['JSON']>;
  sectionVersion?: InputMaybe<Scalars['Int']>;
  status: HosCuratorRunStatus;
};

export enum HosRole {
  Admin = 'admin',
  Cgo = 'cgo',
  Curator = 'curator',
  Doctor = 'doctor',
  Internal = 'internal',
  Patient = 'patient',
  Seed = 'seed'
}

export type HosRoleGrant = {
  __typename?: 'HosRoleGrant';
  email: Scalars['String'];
  grantedAt?: Maybe<Scalars['DateTime']>;
  grantedBy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  roles: Array<HosRegistryRole>;
  userSysId: Scalars['ID'];
};

/** Trigger one curator run: one section × condition × brand. An open run for the same key is returned instead of a new one. */
export type HosRunCuratorInput = {
  /** Content sections only; clinical sections force `all` server-side. */
  brand?: InputMaybe<HosBrand>;
  /** Estimated-prompt-token ceiling above which the run refuses to call the model. Absent = the package default. The CLI's --budget-tokens. */
  budgetTokens?: InputMaybe<Scalars['Int']>;
  condition: Scalars['String'];
  /** Corpus rendering. Absent = full, today's behaviour. The CLI's --context. */
  contextMode?: InputMaybe<HosCuratorContextMode>;
  /** CLI only (curator principal): create the record as running without enqueueing; the caller runs the pipeline and reports. */
  inline?: InputMaybe<Scalars['Boolean']>;
  /** actions_milestones forces section action_library + brand all server-side and drafts actions, milestones and copy together. */
  kind?: InputMaybe<HosCuratorRunKind>;
  /** Reviewer guidance for this run; the dashboard pre-fills a rejected proposal's decision note. Part of the inputs hash. */
  note?: InputMaybe<Scalars['String']>;
  section: HosRegistrySection;
  /** Bundle runs only: draft milestones and actions in separate calls. Absent = one call. The CLI's --split. */
  split?: InputMaybe<Scalars['Boolean']>;
  /** Corpus tiers to render (T1/T2/T3/T4/Ref). Absent = every tier. The CLI's --tiers. */
  tiers?: InputMaybe<Array<Scalars['String']>>;
};

export enum HosSafetyClearedBy {
  Acknowledged = 'acknowledged',
  ConsultBooked = 'consult_booked',
  OpsResolved = 'ops_resolved'
}

export type HosSafetyFlag = {
  __typename?: 'HosSafetyFlag';
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  clearedAt?: Maybe<Scalars['DateTime']>;
  clearedBy?: Maybe<HosSafetyClearedBy>;
  /** The classifier's category (`detection.category`) — never the patient's words. */
  detectionCategory?: Maybe<Scalars['String']>;
  firstAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** patient_copy key of the safety card instruction (R17.2). The card itself is M4. */
  instructionCopyKey?: Maybe<Scalars['String']>;
  lastSeenAt: Scalars['DateTime'];
  recurrenceCount: Scalars['Int'];
  requiredAction: HosSafetyRequiredAction;
  /** safety_rules row id, or `classifier.<category>` while that section is empty. */
  ruleId: Scalars['String'];
  severity: HosSafetySeverity;
  /** Where the scanned input came from. The input itself is never served. */
  source: HosSafetySource;
  state: HosSafetyFlagState;
};

export enum HosSafetyFlagState {
  Acknowledged = 'acknowledged',
  Cleared = 'cleared',
  Open = 'open'
}

/** Which patient action clears the card (RL85); per safety_rules row. */
export enum HosSafetyRequiredAction {
  BookConsult = 'book_consult',
  ConfirmRead = 'confirm_read',
  OpsResolution = 'ops_resolution'
}

export type HosSafetyScan = {
  __typename?: 'HosSafetyScan';
  /** hos_ai_call id of the classifier call (OQ-09-4). Null for a deterministic critical-range hit. */
  aiCallId?: Maybe<Scalars['ID']>;
  /** The raised flag, when the verdict is flagged. The patient-facing card is M4 (R17). */
  flagId?: Maybe<Scalars['ID']>;
  verdict: HosSafetyScanVerdict;
};

/** Outcome of the red-flag scan that runs before any patient free text is stored (R16, MG-5). */
export enum HosSafetyScanVerdict {
  Clear = 'clear',
  Flagged = 'flagged'
}

/** safety_rules severity; SMS is the critical tier only (SR4). */
export enum HosSafetySeverity {
  Critical = 'critical',
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

/** Where the scanned input came from. Consult notes and transcripts are profile-only (MG-24) and are not listed. */
export enum HosSafetySource {
  ChatMessage = 'chat_message',
  CheckinAnswer = 'checkin_answer',
  QuestionnaireFreeText = 'questionnaire_free_text',
  StructuredValue = 'structured_value'
}

/** Who wrote hos_patient_schedule (MG-16). */
export enum HosScheduleWriteSource {
  ActionCta = 'action_cta',
  Baseline = 'baseline',
  Settings = 'settings'
}

/** Orb + breakdown in one read (API contracts §2.3). */
export type HosScore = {
  __typename?: 'HosScore';
  /** `scoring.bands` row id. The care tier behind it is internal and is never a field here (R2). */
  bandId: Scalars['String'];
  /** patient_copy key for the band label. */
  bandLabelCopyKey: Scalars['String'];
  cause: HosRecomputeCause;
  computedAt: Scalars['DateTime'];
  /** A recompute is queued or running; this row is the last stored score (MG-4). Poll every 2 s, at most 30 s. */
  computing: Scalars['Boolean'];
  /** Internal Phase 1 (R3.3): populated for internal/admin callers and harness act-as, null for patients. */
  confidence?: Maybe<HosConfidence>;
  /** `scoring.orb_levels` level (0 = empty). */
  orbLevel: Scalars['Int'];
  /** 0-100, rounded once at compute; null when no sub-score has a value. */
  overall?: Maybe<Scalars['Int']>;
  pins: HosPins;
  /** A registry section this score reads moved since the previous one (MG-12): the client shows `score.pins_changed`. */
  pinsChanged: Scalars['Boolean'];
  scoreId: Scalars['ID'];
  stage: Scalars['Int'];
  subScores: Array<HosSubScore>;
  /** Null for a brand-new patient (R5.4). */
  trend?: Maybe<HosScoreTrend>;
};

/** Score history for the breakdown charts (R6.2). */
export type HosScoreHistory = {
  __typename?: 'HosScoreHistory';
  /** Milestones reached inside the range, newest first — the chart's reached markers (R10.7). */
  achievedMilestones: Array<HosAchievedMilestone>;
  /** Inclusive start, YYYY-MM-DD in the region's zone. */
  from: Scalars['String'];
  /** Scores exist before `from`, so the chart can page back. */
  hasEarlier: Scalars['Boolean'];
  points: Array<HosScoreHistoryPoint>;
  /** Confirmed readings in the range, oldest first — the chart's dose-change pills read these (R6.2). */
  signals: Array<HosSignalPoint>;
  /** Inclusive end, YYYY-MM-DD in the region's zone. */
  to: Scalars['String'];
  view: HosScoreHistoryView;
};

/** Score history range: a view and the day it is anchored on. */
export type HosScoreHistoryInput = {
  /** YYYY-MM-DD in the region's zone; defaults to the patient's today. */
  anchor?: InputMaybe<Scalars['String']>;
  view: HosScoreHistoryView;
};

/** One stored score in the history (lossless: one point per row; bucketing is client-side). */
export type HosScoreHistoryPoint = {
  __typename?: 'HosScoreHistoryPoint';
  cause: HosRecomputeCause;
  computedAt: Scalars['DateTime'];
  overall?: Maybe<Scalars['Int']>;
  pinsChanged: Scalars['Boolean'];
  scoreId: Scalars['ID'];
  subScores: Array<HosSubScoreValue>;
};

/** week = every recompute inside the 7 days ending at anchor; month = one point per day for anchor's calendar month. */
export enum HosScoreHistoryView {
  Month = 'month',
  Week = 'week'
}

/** Trend pill: delta vs the previous compute (R5.4). */
export type HosScoreTrend = {
  __typename?: 'HosScoreTrend';
  delta: Scalars['Int'];
  direction: HosTrendDirection;
  previousComputedAt: Scalars['DateTime'];
  previousScoreId: Scalars['ID'];
};

export type HosServedSnapshot = {
  __typename?: 'HosServedSnapshot';
  language: Scalars['String'];
  pins: HosPins;
  servedAt: Scalars['DateTime'];
  surface: HosSurface;
  /** sha256 over the copy keys in render order, the pinned versions and the language. */
  textFingerprint: Scalars['String'];
};

/** The patient's stored score, served on the shell state once computed (shell-screen DoD §3.11, PROPOSED wave 2). */
export type HosShellScore = {
  __typename?: 'HosShellScore';
  /** `scoring.bands` row id. The band's LABEL key is not served here: the reveal renders fixed copy, and the care tier behind the band is internal (R2). */
  bandId: Scalars['String'];
  computedAt: Scalars['DateTime'];
  /** Internal confidence grade, low | medium | high (R3.3): served to internal/admin callers and harness act-as sessions, null for patient principals. Fixed `low` while the first score is a mock — no confidence formula runs until M3 (R3). */
  confidenceGrade?: Maybe<Scalars['String']>;
  /** `scoring.orb_levels` level (0 = empty). */
  orbLevel: Scalars['Int'];
  /** 0-100 overall (spec 03 §1). M2 serves a MOCK number [OWNER 2026-09-15]; the registry-driven engine lands in M3 (R2). Nullable for that engine's no-data case. */
  overall?: Maybe<Scalars['Int']>;
  /** Patient stage this score was computed for (1 = first score). */
  stage: Scalars['Int'];
  subscores: Array<HosShellSubScore>;
};

/** The derived shell stage for one patient (API contracts §2.1). */
export enum HosShellStage {
  Active = 'active',
  Consent = 'consent',
  Disabled = 'disabled',
  FirstDoseGate = 'first_dose_gate',
  Glimpse = 'glimpse',
  Intro = 'intro',
  Questionnaire = 'questionnaire'
}

/** One read per app open decides which screen the patient sees (API contracts §2.1). */
export type HosShellState = {
  __typename?: 'HosShellState';
  activatedAt?: Maybe<Scalars['DateTime']>;
  baselineCompletedAt?: Maybe<Scalars['DateTime']>;
  /** Null while the gate is off; otherwise the resume position for the baseline questionnaire. */
  baselineProgress?: Maybe<HosBaselineProgress>;
  condition?: Maybe<Scalars['String']>;
  consent?: Maybe<HosConsentState>;
  /** Empty once active. */
  education: Array<HosEducationItem>;
  eligibility?: Maybe<HosEligibility>;
  enabled: Scalars['Boolean'];
  firstDoseGate?: Maybe<HosFirstDoseGate>;
  /** The upcoming consult; non-null only on `glimpseState: booked`. */
  glimpseConsult?: Maybe<HosGlimpseConsult>;
  /** Which glimpse card to render (HOME-GLM-eval/book/booked/done). Set for every patient — `done` when eligible; null only when HealthOS is switched off. */
  glimpseState?: Maybe<HosGlimpseState>;
  introCompletedAt?: Maybe<Scalars['DateTime']>;
  pins: HosPins;
  /** Active patient currently ineligible: asks, sends and cards suppressed, state retained (MG-6). */
  previouslyActive: Scalars['Boolean'];
  /** The patient's stored score once one exists (shell-screen DoD §3.11 reveal); null before the first compute. */
  score?: Maybe<HosShellScore>;
  stage: HosShellStage;
};

/** A sub-score on the shell score summary (shell-screen DoD §3.11). */
export type HosShellSubScore = {
  __typename?: 'HosShellSubScore';
  /** Sub-score key: effectiveness | consistency | comfort | satisfaction | wellbeing | ease. */
  id: Scalars['String'];
  /** 0-100, rounded once at compute. */
  score: Scalars['Int'];
  /** The stage weight this sub-score carried into the overall (spec 03 §4). */
  weightPercent: Scalars['Int'];
};

/** One confirmed signal reading in the range (R6.2). Closed signal list only. */
export type HosSignalPoint = {
  __typename?: 'HosSignalPoint';
  observedAt: Scalars['DateTime'];
  /** `scoring.signals` row key: body_weight, dose_adherence, ... */
  signalKey: Scalars['String'];
  /** The `scoring.signals` row's unit (kg). Null on a signal whose row names none — a ratio or a rating. */
  unit?: Maybe<Scalars['String']>;
  /** The reading in the unit its registry mapping expects (kg, a 0-1 ratio, a 1-5 rating). */
  value: Scalars['Float'];
};

export type HosStartActionInput = {
  /** The served card's id (the action_library row id on an improvement card). */
  cardId: Scalars['ID'];
  /** Client UUID. A retry returns the current instance: no second record event. */
  clientRequestId: Scalars['ID'];
  reminder?: InputMaybe<HosActionReminderInput>;
};

/** One sub-score on the breakdown (R6). `weightPercent` is internal: the patient breakdown shows names, never weights (spec 03 §3). */
export type HosSubScore = {
  __typename?: 'HosSubScore';
  /** driving or focus (R6.3); null on a sub-score with no value — the dash row is in neither list. */
  group?: Maybe<HosSubScoreGroup>;
  /** hos.patient_copy.subscore_insight.<subscore>. Null while that row is unpublished — the app omits the line rather than rendering a blank one. */
  insight?: Maybe<HosTemplatedText>;
  lastSignalAt?: Maybe<Scalars['DateTime']>;
  /** The same sub-score at the previous compute. */
  previousValue?: Maybe<Scalars['Int']>;
  /** Where the value came from: signal | baseline | carried_forward | none. */
  source: Scalars['String'];
  /** Carried forward: no reading arrived inside the scoring window (spec 03 §11). */
  stale: Scalars['Boolean'];
  subscore: HosSubscoreKey;
  /** hos.patient_copy.subscore_tip.<subscore>. Null while that row is unpublished. */
  tip?: Maybe<HosTemplatedText>;
  /** 0-100; null when nothing fed it (spec 03 §11). */
  value?: Maybe<Scalars['Int']>;
  /** The stage weight it carried into the overall. Internal: for the harness panel and replay. */
  weightPercent: Scalars['Int'];
};

/** driving = the sub-scores holding today's overall up; focus = where the room is. A slice of one ranking, so never both (R6.3). */
export enum HosSubScoreGroup {
  Driving = 'driving',
  Focus = 'focus'
}

/** One sub-score value in a history point. */
export type HosSubScoreValue = {
  __typename?: 'HosSubScoreValue';
  stale: Scalars['Boolean'];
  subscore: HosSubscoreKey;
  value?: Maybe<Scalars['Int']>;
};

/** The six sub-scores (spec 03 §3); patient-facing names come from copy keys. */
export enum HosSubscoreKey {
  Comfort = 'comfort',
  Consistency = 'consistency',
  Ease = 'ease',
  Effectiveness = 'effectiveness',
  Satisfaction = 'satisfaction',
  Wellbeing = 'wellbeing'
}

/** Where a card is served. M3 serves the preset guide on the hub. */
export enum HosSurface {
  Chat = 'chat',
  Hub = 'hub',
  ScorePage = 'score_page'
}

export type HosSymptomDaysInput = {
  /** Days in the week, 0-7. */
  days: Scalars['Int'];
  /** Only for the free-text symptom. Scanned before store, kept as a label on that entry (R29.2). */
  freeText?: InputMaybe<Scalars['String']>;
  symptomId: Scalars['String'];
};

/** A published patient_copy key and the params its row templates from — never rendered text. */
export type HosTemplatedText = {
  __typename?: 'HosTemplatedText';
  copyKey: Scalars['String'];
  /** Template params, by the names the copy row's own variables use. Empty when the row carries no variables. */
  params: Scalars['JSON'];
};

/** Trend pill direction: delta vs the previous compute (R5.4). */
export enum HosTrendDirection {
  Down = 'down',
  Flat = 'flat',
  Up = 'up'
}

/** Trigger state: inactive or active (MG-18). */
export enum HosTriggerStateName {
  Active = 'active',
  Inactive = 'inactive'
}

/** One trigger's stored state for a patient (MG-18). Staff only — a patient never sees a trigger (R4). */
export type HosTriggerStateView = {
  __typename?: 'HosTriggerStateView';
  /** When the current episode began; null while inactive. */
  activeSince?: Maybe<Scalars['DateTime']>;
  /** Consecutive true evaluations so far. */
  consecutiveTrue: Scalars['Int'];
  lastEvaluatedAt?: Maybe<Scalars['DateTime']>;
  /** The score whose recompute last evaluated this rule. */
  lastScoreId?: Maybe<Scalars['ID']>;
  lastTrueAt?: Maybe<Scalars['DateTime']>;
  state: HosTriggerStateName;
  /** `clinical_thresholds` trigger row id. */
  triggerId: Scalars['String'];
};

export type HosUpdatePatientScheduleInput = {
  reminderEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Patient-local hour 0-23. */
  reminderHour?: InputMaybe<Scalars['Int']>;
  /** ISO weekdays 1-7, non-empty when sent. The patient always picks days [OWNER 2026-09-17]. */
  reminderWeekdays?: InputMaybe<Array<Scalars['Int']>>;
  source: HosScheduleWriteSource;
  /** IANA zone; the region default until set. */
  timezone?: InputMaybe<Scalars['String']>;
};

export type HosWhyThis = {
  __typename?: 'HosWhyThis';
  /** The approved claims the sentence rests on (R26); the same objects the evidence block carries. */
  claims: Array<HosEvidenceClaim>;
  copyKey: Scalars['String'];
  /** Template params: { subscore, subscoreCopyKey, value }. */
  params: Scalars['JSON'];
  source: HosWhyThisSource;
};

/** template = the registry copy template of the ranking facts; ai = model wording of the same facts. M4 serves template only (spec 09: no model call at serve time). */
export enum HosWhyThisSource {
  Ai = 'ai',
  Template = 'template'
}

export type IdentityDocumentField = {
  __typename?: 'IdentityDocumentField';
  type: Scalars['String'];
  value: Scalars['String'];
};

export type ImageDto = {
  __typename?: 'ImageDto';
  noahVertical?: Maybe<Scalars['String']>;
  noahWide?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  zoeyVertical?: Maybe<Scalars['String']>;
  zoeyWide?: Maybe<Scalars['String']>;
};

export type ImageInput = {
  noahVertical?: InputMaybe<Scalars['String']>;
  noahWide?: InputMaybe<Scalars['String']>;
  zoeyVertical?: InputMaybe<Scalars['String']>;
  zoeyWide?: InputMaybe<Scalars['String']>;
};

export type ImageModel = {
  __typename?: 'ImageModel';
  noahVertical?: Maybe<Scalars['String']>;
  noahWide?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  zoeyVertical?: Maybe<Scalars['String']>;
  zoeyWide?: Maybe<Scalars['String']>;
};

export type ImpersonateInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type ImportProductPricesErrorDto = {
  __typename?: 'ImportProductPricesErrorDto';
  error?: Maybe<Scalars['JSON']>;
  importPriceId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export type ImportProductsPricesDto = {
  __typename?: 'ImportProductsPricesDto';
  importErrors?: Maybe<Array<ImportProductPricesErrorDto>>;
};

export type InsertCartItemByIdInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  completedEval?: InputMaybe<Scalars['JSON']>;
  consultationSessionType?: InputMaybe<ConsultationSessionType>;
  fbc?: InputMaybe<Scalars['String']>;
  fbp?: InputMaybe<Scalars['String']>;
  isSkipMedSelecting?: InputMaybe<Scalars['Boolean']>;
  oldOrder?: InputMaybe<Scalars['JSON']>;
  patientNote?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  promotionCode?: InputMaybe<Scalars['JSON']>;
  selectedPriceId: Scalars['String'];
  shouldReturnCalculation?: InputMaybe<Scalars['Boolean']>;
  sysId?: InputMaybe<Scalars['String']>;
  teleConsultForSkipEval?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export enum InvoiceStatus {
  Deleted = 'deleted',
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export type IsAutoRenewalSubInput = {
  isAutoRenewal: Scalars['Boolean'];
  orderId: Scalars['String'];
  subscriptionId?: InputMaybe<Scalars['String']>;
};

export type KeyValuePriceLocaleInput = {
  key?: InputMaybe<StripePriceLocaleKeys>;
  value?: InputMaybe<Scalars['String']>;
};

export type KeyValuePriceLocaleModel = {
  __typename?: 'KeyValuePriceLocaleModel';
  key?: Maybe<StripePriceLocaleKeys>;
  value?: Maybe<Scalars['String']>;
};

export type KeyValueProductLocaleInput = {
  key?: InputMaybe<StripeProductLocaleKeys>;
  value?: InputMaybe<Scalars['String']>;
};

export type KeyValueProductLocaleModel = {
  __typename?: 'KeyValueProductLocaleModel';
  key?: Maybe<StripeProductLocaleKeys>;
  value?: Maybe<Scalars['String']>;
};

export enum Language {
  En = 'en',
  Ja = 'ja',
  Zh = 'zh'
}

export type LastTreatmentOrder = {
  __typename?: 'LastTreatmentOrder';
  order?: Maybe<OrderModel>;
};

export type LastTreatmentOrderInput = {
  patientEmail?: InputMaybe<Scalars['String']>;
  patientSysId?: InputMaybe<Scalars['String']>;
};

export enum LocalRegionType {
  Central = 'central',
  East = 'east',
  EastNortheast = 'east_northeast',
  North = 'north',
  NorthCentral = 'north_central',
  Northeast = 'northeast',
  NortheastNorth = 'northeast_north',
  SouthCentral = 'south_central',
  West = 'west',
  WestCentral = 'west_central'
}

export type LogOutUserSessionInput = {
  clientType: ClientType;
};

export type LoginInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type LoginSocialInput = {
  accessToken: Scalars['String'];
  anonymousId?: InputMaybe<Scalars['String']>;
  idToken?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  provider: SocialProviderTypes;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type MarkNoShowInput = {
  consultAuditSysId: Scalars['String'];
  orderId: Scalars['String'];
};

export type MarkRetentionPromoRedeemedInput = {
  code: Scalars['String'];
  orderSysId: Scalars['String'];
};

export type MasterDto = {
  __typename?: 'MasterDto';
  auditHistories?: Maybe<AuditHistoryPagingDto>;
  consultationAudits?: Maybe<PaginatedConsultationAuditDto>;
  doctors?: Maybe<Array<Maybe<DoctorDto>>>;
  pickupLocations?: Maybe<PaginatedPickupLocationDto>;
  regionAreas?: Maybe<Array<Maybe<RegionAreaDto>>>;
};


export type MasterDtoAuditHistoriesArgs = {
  input: V2PaginationInput;
};


export type MasterDtoConsultationAuditsArgs = {
  input: ConsultationAuditFilterInput;
  paging: V2PaginationInput;
};


export type MasterDtoPickupLocationsArgs = {
  input: V2PickupLocationInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};

export enum MedicationCategory {
  All = 'All',
  AsNeeded = 'AsNeeded',
  Daily = 'Daily',
  FastestOnset = 'FastestOnset',
  LongestEffectiveness = 'LongestEffectiveness',
  ReducedSideEffects = 'ReducedSideEffects'
}

export type Mutation = {
  __typename?: 'Mutation';
  addCashbackToMultipleCustomers: AddCashbackReturnModel;
  addCashbackToTheCustomer: AddCashbackReturnModel;
  addNewPickupLocations: Scalars['Boolean'];
  appleLogin?: Maybe<TokenModel>;
  applyPromotionCodeForAnonymous: CartCalculationModel;
  applyPromotionCodeForCart: CartCalculationModel;
  applyPromotionFromBanner: CartCalculationModel;
  approvePrescriptionOrder: Scalars['Boolean'];
  archiveStripePrice: Scalars['Boolean'];
  archiveStripeProduct: Scalars['Boolean'];
  attachPaymentIntent: Scalars['String'];
  attachPaymentMethod: Scalars['Boolean'];
  attachPaymentMethod2?: Maybe<PatientDto>;
  attachPaymentMethodWithIntentForAnonymous: Scalars['String'];
  bookAppointmentAndDelivery: BookAppointmentAndDeliveryModel;
  bookAppointmentAndDeliveryV2?: Maybe<OrderDto>;
  bookFUAppointment?: Maybe<OrderDto>;
  bookHumansaConsultation?: Maybe<ConsultationDto>;
  bookPrescriptionReviewAppointment?: Maybe<OrderDto>;
  bulkUpdateShipment?: Maybe<Scalars['Boolean']>;
  calculateCart: CalculateOrderSummaryModel;
  cancelAppointment: Scalars['Boolean'];
  cancelCheckIn?: Maybe<Scalars['Boolean']>;
  cancelMounjaroTrial: Scalars['Boolean'];
  cancelOrder: Scalars['Boolean'];
  cancelPaymentIntent: Scalars['Boolean'];
  cancelSubscription?: Maybe<OrderDto>;
  cancelSubscriptionByOrderId: CancelSubscriptionByOrderIdModel;
  changeAutoRenewalMode: OrderDto;
  changeDeliveryStatus: Scalars['Boolean'];
  changeDeliveryWindow: Scalars['Boolean'];
  changeDeliveryWindowV2?: Maybe<OrderDto>;
  changeNewPriceOrder: ChangeNewPriceOrderModel;
  changeOrderRenewalDate?: Maybe<OrderDto>;
  changePassword: Scalars['Boolean'];
  changePrescriptionPrice?: Maybe<OrderDto>;
  changePriceKonbiniOrder?: Maybe<OrderDto>;
  changeROInOps: Scalars['Boolean'];
  chargeConsultFeeKonbiniOrder?: Maybe<OrderDto>;
  checkAvailableSupportCod?: Maybe<CheckSupportCodDto>;
  checkValidAtomePaymentLink?: Maybe<AtomePaymentDto>;
  checkoutAnonymous: CheckoutAnonymousModel;
  checkoutCart: CheckoutCartMuationModel;
  checkoutViaReceptionist?: Maybe<PatientDto>;
  claimSubscriptionRetention?: Maybe<Scalars['Boolean']>;
  cleanMissingPatientPaidEvalIds: Scalars['Boolean'];
  completeFollowUpConsult: Scalars['Boolean'];
  confirmAtomeOrder?: Maybe<OrderDto>;
  confirmBloodDraw: BloodDrawConfirmationDto;
  confirmChangePrescription?: Maybe<OrderDto>;
  confirmChargeCovidPrescriptionOrder: Scalars['Boolean'];
  confirmCodOrder?: Maybe<ConfirmCodDto>;
  confirmCodOrder2?: Maybe<OrderDto>;
  confirmKonbiniOrder?: Maybe<OrderDto>;
  createAffiliate: Affiliate;
  createAffiliateProduct: AffiliateProduct;
  createAnonymousPatient: CreateAnonymousPatientModel;
  createAtomePayment?: Maybe<AtomePaymentDto>;
  createCheckoutSession?: Maybe<CheckoutSessionDto>;
  createCompletedEval: CompletedEvalModel;
  createCompletedEvalForGuests: CompletedEvalModel;
  createDoctor: DoctorDto;
  createEvaluationQuestion: Scalars['Boolean'];
  createGiveawayRecord: Scalars['Boolean'];
  createGuestEvaluation: Scalars['Boolean'];
  createInvoice: Scalars['Boolean'];
  createJob: CronjobModel;
  createNewSurvey: Scalars['Boolean'];
  createOTCWalletOrder: CreateOtcWalletOrderModel;
  createOrder: OrderModel;
  createOrderNote?: Maybe<Scalars['Boolean']>;
  createOrdersAfterTeleConsult: Array<OrderModel>;
  createPartnerTRTOrder?: Maybe<Scalars['Boolean']>;
  createPatientDocument?: Maybe<Array<UserDocumentDto>>;
  createPatientFromOps: PatientModel;
  createPreblock: PreblockDto;
  createProduct: ProductModel;
  createReferralDocuments: Scalars['Boolean'];
  createSetupIntent: Scalars['String'];
  createShipmentGroup?: Maybe<OrderShipmentGroupDto>;
  createShipper?: Maybe<UserDto>;
  createStripeCoupon: StripeCouponModel;
  createStripePrice: Scalars['String'];
  createStripeProduct: Scalars['String'];
  createStripePromotionCode: StripePromotionCodeModel;
  createSurvey: Scalars['Boolean'];
  deleteAuditDoctorNote: Scalars['Boolean'];
  deleteCartItemById: CartCalculationModel;
  deleteCompletedEval: Scalars['Boolean'];
  deleteOrder: Scalars['Boolean'];
  deleteOrderPermanent: Scalars['Boolean'];
  deletePatient: Scalars['Boolean'];
  deletePatientQuestionAnswer: Scalars['Boolean'];
  deleteStripeCoupon: Scalars['Boolean'];
  deleteStripePrice: Scalars['Boolean'];
  deleteStripeProduct: Scalars['Boolean'];
  deleteTrtDocument: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  deliveryCharge?: Maybe<Scalars['Boolean']>;
  deliveryChargeV2?: Maybe<OrderDto>;
  destroyFCMtoken: Scalars['String'];
  disableProduct: Scalars['Boolean'];
  duplicateStripePrice: Scalars['String'];
  generateSmartMatchResults: SmartMatchDto;
  getLastInvoiceDate?: Maybe<StripeInvoiceModel>;
  getUpcomingInvoiceDate?: Maybe<StripeInvoiceModel>;
  guestFirstCheckout?: Maybe<PatientDto>;
  /** Dismiss a reached milestone card. Writes guidance.milestone.acknowledged once; a second tap returns the same row and writes nothing. The conversation line is the chat lane's, which reads this event. */
  hosAcknowledgeMilestone: HosAchievedMilestone;
  /** Acknowledge the safety card. confirm_read clears the flag, lifts the hold and releases the day's held push; book_consult and ops_resolution keep the card. */
  hosAcknowledgeSafetyCard: HosCardActionResult;
  /** Log in with an admin / internal email + password. Returns the magic-link token the existing sign-in exchange consumes. */
  hosAdminLogin: HosAdminLoginResult;
  /** Save one step's answer so the questionnaire resumes where the patient left off; idempotent on clientRequestId. */
  hosAnswerBaselineStep: HosShellState;
  /** Answer an ask. One transaction: scan any free text, store the signals, close the ask, record. dose_reminder rows are refused — use hosConfirmDose. */
  hosAnswerCheckin: HosCheckinAnswerResult;
  /** Answer the first-dose gate; Yes sets first_dose_confirmed_at once (back-dated by firstDoseBucket when given), No leaves the client in the getting-started hub (R12.2, R36.2). */
  hosAnswerFirstDoseGate: HosShellState;
  /** Approve and publish: version + 1 and an immutable snapshot. The role is re-checked against requiredApproverRole. */
  hosApproveRegistryProposal: HosRegistryProposal;
  /** Batched card views → the behavioural buffer. Idempotent per (serve, card, element): a re-sent batch is counted as duplicates and writes nothing. */
  hosCardSeen: HosCardSeenResult;
  /** Close an action instance: in_progress → done once, with guidance.action.completed in the same transaction. A repeat returns the current instance and writes nothing. */
  hosCompleteAction: HosCardActionResult;
  /** Mark the HealthOS intro completed (R11); idempotent. */
  hosCompleteIntro: HosShellState;
  /** The reminder's 'I've taken it'. Stamps the first dose when it is the first, stores the adherence signal and opens the after-dose check-in (R20, R36.3). */
  hosConfirmDose: HosDoseConfirmResult;
  /** Create a draft proposal: the system computes the diff against baseVersion and runs the validators. */
  hosCreateRegistryProposal: HosRegistryProposal;
  /** Recompute a patient sample on the proposed snapshot. Returns status `unavailable` until the score engine exists. */
  hosDryRunRegistryProposal: HosRegistryDryRun;
  /** Grant consent for copyVersion (must equal currentCopyVersion). Replay returns the existing state (MG-7). */
  hosGrantConsent: HosShellState;
  /** Admin only. role ∈ {cgo, internal}. Unknown email → HOS_USER_NOT_FOUND; an existing grant is idempotent. */
  hosGrantRole: HosRoleGrant;
  /** Internal only: act as a patient. Replaces the caller's open session; records the start. */
  hosHarnessActAs: HosHarnessSession;
  /** Forward only, at most 90 days: runs each crossed virtual local day's daily tick in order, then delivers due jobs inline. */
  hosHarnessAdvanceClock: HosHarnessAdvanceResult;
  /** Back to real time. Virtual-dated rows stay, so a reset is recommended after. */
  hosHarnessClearClock: Scalars['Boolean'];
  /** Internal only: end the caller's open act-as session. Returns whether one was open. */
  hosHarnessEndActAs: Scalars['Boolean'];
  /** Enqueue the keyed per-patient recompute (MG-4); a no-op when one is queued. */
  hosHarnessRecompute: HosHarnessJobResult;
  /** Internal only: clear one patient's mutable HOS state and write an admin.patient.reset event (record rows are kept, append-only). */
  hosHarnessReset: Scalars['Boolean'];
  /** Run the patient's daily tick now, for their current (possibly virtual) local day. Keyed (patient, day), so a repeat is safe (MG-17). */
  hosHarnessRunDailyTick: HosHarnessJobResult;
  /** Internal only: put a harness patient into a named scenario through the product's own services, then return their shell state. */
  hosHarnessSeed: HosShellState;
  /** Staging/local only: set the patient's virtual clock. Never runs a job. Earlier than their last record event -> HOS_CLOCK_BACKWARDS. */
  hosHarnessSetClock: HosHarnessClock;
  /** Open or fold: attaches the context to the patient's single active conversation, creating one only when none is active; the opener is a template message, no model call (RL54). Refused HOS_CONSENT_REQUIRED before intro (MG-7). */
  hosOpenChat: HosChatReply;
  /** Record an ops action on an alert. ack and closed move the lifecycle; contacted and escalated are log entries. Staff only; every action is a record event (MG-3). */
  hosOpsAlertAction: HosOpsAlert;
  /** Ops resolution of an alert's safety flag, also when the alert is already closed (admin only, OQ-API-53). Clears an ops_resolution or book_consult flag (cleared_by ops_resolved), closes the alert if open, and keeps a closed alert closed. A cleared flag is a no-op. The note is reference-only, at most 500 characters. */
  hosOpsAlertClearFlag: HosOpsAlert;
  /** Reveal the text an alert's flag was raised on (OQ-API-52). Staff only; every call writes safety.alert.revealed before the text is returned, and the event never carries the text. */
  hosOpsAlertReveal: HosOpsAlertReveal;
  /** Re-resolve the ref, append one clinical_corpus row to the latest snapshot and submit it through the normal flow. Idempotent on clientRequestId; refuses a duplicate pmid/doi. */
  hosProposeCorpusDocument: HosRegistryProposal;
  /** Re-base a draft or submitted proposal onto the current version: its own added, changed and removed rows are re-applied to the current snapshot and the diff and validators recomputed. A no-op when the base is current. Refused with extensions.code HOS_REGISTRY_REBASE_CONFLICT (extensions.rows) when a row it touches changed since its base. Admin/CGO. */
  hosRebaseRegistryProposal: HosRegistryProposal;
  /** Reject with a decision note (design §3 requires the note). */
  hosRejectRegistryProposal: HosRegistryProposal;
  /** Curator principal only: status, hashes, proposal ids, report. Terminal statuses are write-once. */
  hosReportCuratorRun: HosCuratorRun;
  /** Explicit 'talk to a person'; opens the handoff and relays to a human (Freshchat relay is a later PR). Refused HOS_CONSENT_REQUIRED before intro (MG-7). */
  hosRequestChatHandoff: HosChatReply;
  /** Admin/internal: replay a recorded event. `score` reruns the engine inline over the event's own inputs and pins. */
  hosRequestReplay: HosReplay;
  /** Admin only. Removing the last grant leaves the user as a plain doctor/staff account. */
  hosRevokeRole: HosRoleGrant;
  /** Republish an older snapshot as a new version. Nothing is deleted or rewritten (D8/D16). */
  hosRollbackRegistrySection: HosRegistryVersion;
  /** Create a run record and enqueue one Bull job (jobId curator:<section>:<condition>:<brand>). An open run for the same key is returned instead of a new one. */
  hosRunCurator: HosCuratorRun;
  /** Classifier first (blocking) → store → reply. Scanner down → HOS_SCAN_UNAVAILABLE, nothing stored (MG-5). PR 1 replies with a templated fallback; the model reply is PR 2. Refused HOS_CONSENT_REQUIRED before intro (MG-7). */
  hosSendChatMessage: HosChatReply;
  /** Admin only. Set or rotate the HealthOS password of an existing admin / internal account by email. */
  hosSetAdminPassword: Scalars['Boolean'];
  /** Skip an ask (R35.4). A skip is a response: the ask leaves the inbox, nothing is stored and the score never moves. Idempotent on the ask id. */
  hosSkipCheckin: HosCheckin;
  /** Start an improvement action: creates or returns the in_progress instance for (patient, action, trigger episode), with guidance.action.started in the same transaction. */
  hosStartAction: HosCardActionResult;
  /** Submit the baseline: writes the baseline signals, activates the patient and records the events in one transaction. Every served step must be answered. */
  hosSubmitBaselineQuestionnaire: HosShellState;
  /** Move a draft to submitted, where an approver can see it. */
  hosSubmitRegistryProposal: HosRegistryProposal;
  /** The one schedule write (MG-16): days of the week, hour, timezone, on/off. PUT by value — identical values write no event. */
  hosUpdatePatientSchedule: HosPatientSchedule;
  impersonate: TokenModel;
  importProductsAndPrices?: Maybe<ImportProductsPricesDto>;
  insertCartItemById: CartCalculationModel;
  isAutoRenewalSub: Scalars['Boolean'];
  logIn: TokenModel;
  logInGoogle: TokenModel;
  logInLine: TokenModel;
  logOutUserSession: Scalars['Boolean'];
  markNoShow: Scalars['Boolean'];
  markRetentionPromoRedeemed?: Maybe<Scalars['Boolean']>;
  massUpdateCustomerBalance: AddCashbackReturnModel;
  migrateArchivePrices?: Maybe<Scalars['Boolean']>;
  migrateDoctorToTwilioUser: Scalars['Boolean'];
  migratePausedToActive: Scalars['Boolean'];
  migrateProductIncluded?: Maybe<Scalars['Boolean']>;
  migrateUserToTwilioUser: Scalars['Boolean'];
  opsChangeDeliveryWindow: Scalars['Boolean'];
  opsChargeOTCOrder: Scalars['Boolean'];
  partnerBookConsultation?: Maybe<ConsultationDto>;
  pauseAndResumeSubscription: Scalars['Boolean'];
  pendingOrder?: Maybe<Scalars['Boolean']>;
  portEmail: Scalars['Boolean'];
  prescriptionCheckout: PrescriptionCheckoutModel;
  prescriptionCheckoutV2?: Maybe<OrderDto>;
  processCartByOTCWallet: ProcessCartByOtcWalletModel;
  reAssignDoctorForNote: Scalars['Boolean'];
  reAssignTextConsultationDoctor: Scalars['Boolean'];
  reactivate?: Maybe<OrderDto>;
  reactivateCanceledOrderV2: OrderDto;
  recordBloodPressure: PatientVitalDto;
  recordDoseStart: DoseStartDto;
  recreateAtomePaymentLink?: Maybe<Scalars['String']>;
  refreshAccessToken: TokenModel;
  refundChargedForAdmin: Scalars['Boolean'];
  refundInvoiceForAdmin: Scalars['Boolean'];
  refundOTCWalletOrder: RefundOtcWalletPayOrderModel;
  refundPaymentIntent: Scalars['Boolean'];
  refundPaymentIntentForAdmin: Scalars['Boolean'];
  refundPaymentIntentForAnonymous: RefundPaymentIntentForAnonymousModel;
  registerDoctor: DoctorModel;
  registerFCMtoken: Scalars['String'];
  registerPatient: PatientModel;
  registerUserSession: UserSessionDto;
  rejectPrescriptionOrder: Scalars['Boolean'];
  releasePreblock: Scalars['Boolean'];
  removeCardDetailPatient: Scalars['Boolean'];
  renew?: Maybe<OrderDto>;
  renewAtomeOrder?: Maybe<OrderDto>;
  renewCodOrder?: Maybe<OrderDto>;
  renewCodOrders?: Maybe<RenewMultipleOrdersResponse>;
  renewKonbiniOrder?: Maybe<OrderDto>;
  renewOrderByOps: Scalars['Boolean'];
  renewOrderByPatient: Scalars['Boolean'];
  requestEmailOTP: Scalars['Boolean'];
  requestFollowUpConsult: Scalars['Boolean'];
  requestFollowUpConsultV2?: Maybe<OrderDto>;
  requestMagicLink: Scalars['Boolean'];
  requestUpgradeSettingsLink?: Maybe<Scalars['String']>;
  rescheduleAppointment: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  resetPasswordWithToken: Scalars['Boolean'];
  resubscribeCanceledOTCOrder: OrderDto;
  saveTranslation: TranslationDto;
  sendAutomatedMessage: Scalars['Boolean'];
  sendEmailAboutNewMessage: Scalars['Boolean'];
  sendReminderUnreadDrMessage: Scalars['Boolean'];
  sendResetPasswordEmail: Scalars['Boolean'];
  sendShipmentSMS: Array<OrderShipmentDto>;
  sendToDetrackAndProcessingDelivery: Scalars['Boolean'];
  setDoctorTrtEligible: Scalars['Boolean'];
  setTrtOrderStatus: TrtOrderDto;
  signInAnonymousUser: SignInUserModel;
  signInWithMagicLink: TokenModel;
  skipSurvey: Scalars['Boolean'];
  skipSurveyForCart: Scalars['Boolean'];
  splitShipment?: Maybe<OrderShipmentDto>;
  startCronJob: Scalars['Boolean'];
  stopCronJob: Scalars['Boolean'];
  submitAffiliateCoupon: PublicAffiliateCoupon;
  submitEvaluation?: Maybe<OrderDto>;
  submitVideoCallRating: SubmitVideoCallRatingModel;
  syncMissingLatestInvoiceForSubscriptionOrders: Scalars['String'];
  syncProductPriceLocaleFiles: Scalars['Boolean'];
  syncStripe: Scalars['Boolean'];
  test_generateSmartMatchResults: Test_SmartMatchDto;
  translateRawText: TranslateRawTextDto;
  triggerOnPaidAtomePayment?: Maybe<Scalars['Boolean']>;
  trySecondOpinionV2: OrderDto;
  updateAddress?: Maybe<AddressDto>;
  updateAffiliate: Affiliate;
  updateAffiliateCouponVerification: AffiliateCoupon;
  updateAffiliateProduct: AffiliateProduct;
  updateAtomePayment?: Maybe<AtomePaymentDto>;
  updateCartCalculateOrderSummary: Scalars['Boolean'];
  updateCartItemById: CartCalculationModel;
  updateCheckoutSession?: Maybe<CheckoutSessionDto>;
  updateCompletedEval: CompletedEvalModel;
  updateCompletedEvalForGuests: CompletedEvalModel;
  updateCustomerBalanceTransaction: Scalars['Boolean'];
  updateEvaluationProgress: Scalars['Boolean'];
  updateEvaluationQuestion: Scalars['Boolean'];
  updateMhpOrderDosage?: Maybe<Scalars['Boolean']>;
  updateOrder: OrderModel;
  updateOrderByOpsV2?: Maybe<OrderDto>;
  updateOrderNote?: Maybe<Scalars['Boolean']>;
  updateOtherInterestedEvalIds?: Maybe<OrderDto>;
  updatePatient: PatientDto;
  updatePatientDocument?: Maybe<Scalars['Boolean']>;
  updatePatientInfo: PatientModel;
  updatePatientSubscriptionsPaymentMethod: Scalars['Boolean'];
  updatePaymentStatusForCodOrder?: Maybe<UpdatePaymentStatusForCodDto>;
  updatePickupLocation?: Maybe<Scalars['Boolean']>;
  updateProductImageUrls: Scalars['Boolean'];
  updateShipmentGroup?: Maybe<Scalars['Boolean']>;
  updateShipper?: Maybe<UserDto>;
  updateShippingOrderShipment?: Maybe<Scalars['Boolean']>;
  updateStripeCoupon: StripeCouponModel;
  updateStripeCouponMetadata: Scalars['Boolean'];
  updateStripePrice: Scalars['Boolean'];
  updateStripePriceLocale: Scalars['Boolean'];
  updateStripePriceMetadata: Scalars['Boolean'];
  updateStripeProduct: Scalars['Boolean'];
  updateStripeProductLocale: Scalars['Boolean'];
  updateStripeProductMetadata: Scalars['Boolean'];
  updateStripePromotionCode: StripePromotionCodeModel;
  updateStripePromotionCodeMetadata: Scalars['Boolean'];
  updateUser?: Maybe<UserDto>;
  updateVoidInvoiceOrder: Scalars['String'];
  updateVoidInvoiceOrderV2?: Maybe<Scalars['Boolean']>;
  uploadFile: SignS3Model;
  uploadFileDirect?: Maybe<SignS3Dto>;
  uploadFileV2?: Maybe<SignS3Dto>;
  uploadPublicFile: SignS3Model;
  uploadPublicFileV2?: Maybe<PublicSignS3Dto>;
  uploadTrtDocument: UserDocumentDto;
  upsertPatientTourViewing: Scalars['String'];
  upsertRecommendedProducts?: Maybe<Array<RecommendedProductsDto>>;
  validateEmailOTP: Scalars['Boolean'];
  verifyForgotPassword: Scalars['Boolean'];
  verifyOrder?: Maybe<Array<OrderShipmentDto>>;
};


export type MutationAddCashbackToMultipleCustomersArgs = {
  input: AddCashbackToCustomersInput;
};


export type MutationAddCashbackToTheCustomerArgs = {
  input: AddCashbackToCustomerInput;
};


export type MutationAddNewPickupLocationsArgs = {
  input: NewPickupLocationsInput;
};


export type MutationAppleLoginArgs = {
  input: AppleLoginInput;
};


export type MutationApplyPromotionCodeForAnonymousArgs = {
  input: ApplyPromotionCodeForAnonymousInput;
};


export type MutationApplyPromotionCodeForCartArgs = {
  input: ApplyPromotionCodeForCartInput;
};


export type MutationApplyPromotionFromBannerArgs = {
  input: ApplyPromotionFromBannerInput;
};


export type MutationApprovePrescriptionOrderArgs = {
  input: ApprovePrescriptionOrderInput;
};


export type MutationArchiveStripePriceArgs = {
  input: ArchivePriceInput;
};


export type MutationArchiveStripeProductArgs = {
  input: ArchiveProductInput;
};


export type MutationAttachPaymentIntentArgs = {
  input: AttachPaymentIntentInput;
};


export type MutationAttachPaymentMethodArgs = {
  paymentMethodId: Scalars['String'];
};


export type MutationAttachPaymentMethod2Args = {
  paymentMethodInput: V2UpdatePaymentMethod;
};


export type MutationAttachPaymentMethodWithIntentForAnonymousArgs = {
  input: AttachPaymentMethodWithIntentForAnonymousInput;
};


export type MutationBookAppointmentAndDeliveryArgs = {
  input: BookAppointmentAndDeliveryInput;
};


export type MutationBookAppointmentAndDeliveryV2Args = {
  bookConsultInput: V2BookAppointmentAndDeliveryInput;
};


export type MutationBookFuAppointmentArgs = {
  input: V2BookFuAppointmentInput;
};


export type MutationBookHumansaConsultationArgs = {
  input: BookHumansaConsultation;
};


export type MutationBookPrescriptionReviewAppointmentArgs = {
  input: BookPrescriptionReviewAppointmentInput;
};


export type MutationBulkUpdateShipmentArgs = {
  input: Array<UpdateOrderShipmentInput>;
};


export type MutationCalculateCartArgs = {
  input: CalculateOrderInput;
};


export type MutationCancelAppointmentArgs = {
  input: CancelAppointmentInput;
};


export type MutationCancelCheckInArgs = {
  cancelCheckInInput: MarkNoShowInput;
};


export type MutationCancelMounjaroTrialArgs = {
  reason: Scalars['String'];
  trialFunnelSysId: Scalars['String'];
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationCancelPaymentIntentArgs = {
  id: Scalars['String'];
};


export type MutationCancelSubscriptionArgs = {
  cancelSubscriptionInput: V2CancelSubscriptionInput;
};


export type MutationCancelSubscriptionByOrderIdArgs = {
  input: CancelSubscriptionByOrderIdInput;
};


export type MutationChangeAutoRenewalModeArgs = {
  input: ChangeAutoRenewalModeInput;
};


export type MutationChangeDeliveryStatusArgs = {
  input: ChangeDeliveryStatusInput;
};


export type MutationChangeDeliveryWindowArgs = {
  input: ChangeDeliveryWindowInput;
};


export type MutationChangeDeliveryWindowV2Args = {
  changeDeliveryWindow: V2ChangeDeliveryWindowInput;
};


export type MutationChangeNewPriceOrderArgs = {
  input: ChangeNewPriceOrderInput;
};


export type MutationChangeOrderRenewalDateArgs = {
  changeRenewalDateInput: ChangeRenewalDateInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangePrescriptionPriceArgs = {
  changePrescriptionPriceInput: V2ChangeOrderPrice;
};


export type MutationChangePriceKonbiniOrderArgs = {
  input: V2ChangePriceKonbiniOrderInput;
};


export type MutationChangeRoInOpsArgs = {
  input: ChangeRoInOpsInput;
};


export type MutationChargeConsultFeeKonbiniOrderArgs = {
  input: V2ChargeConsultFeeKonbiniOrder;
};


export type MutationCheckAvailableSupportCodArgs = {
  input: V2CheckAvailableSupportCod;
};


export type MutationCheckValidAtomePaymentLinkArgs = {
  checkAtomeInput: CheckValidAtomePaymentLinkInput;
};


export type MutationCheckoutAnonymousArgs = {
  input: CheckoutAnonymousInput;
};


export type MutationCheckoutCartArgs = {
  input: CheckoutCartInput;
};


export type MutationCheckoutViaReceptionistArgs = {
  input?: InputMaybe<V2PresCheckoutViaReceptionistInput>;
};


export type MutationClaimSubscriptionRetentionArgs = {
  input: V2ClaimSubscriptionRetentionInput;
};


export type MutationCompleteFollowUpConsultArgs = {
  input: TriggerFollowUpConsultInput;
};


export type MutationConfirmAtomeOrderArgs = {
  input: V2ConfirmAtomePaymentInput;
};


export type MutationConfirmBloodDrawArgs = {
  input: ConfirmBloodDrawInput;
};


export type MutationConfirmChangePrescriptionArgs = {
  confirmPrescriptionInput: V2ConfirmChangePrescriptionInput;
};


export type MutationConfirmChargeCovidPrescriptionOrderArgs = {
  input: CovidOrderInput;
};


export type MutationConfirmCodOrderArgs = {
  input: V2ConfirmCodOrderInput;
};


export type MutationConfirmCodOrder2Args = {
  confirmCodOrderInput: V2ConfirmCodOrderInput;
};


export type MutationConfirmKonbiniOrderArgs = {
  input: ConfirmKonbiniOrderInput;
};


export type MutationCreateAffiliateArgs = {
  input: CreateAffiliateInput;
};


export type MutationCreateAffiliateProductArgs = {
  input: CreateAffiliateProductInput;
};


export type MutationCreateAnonymousPatientArgs = {
  input: SignupAnonymousPatientInput;
};


export type MutationCreateAtomePaymentArgs = {
  input: V2CreateAtomePaymentInput;
};


export type MutationCreateCheckoutSessionArgs = {
  createCheckoutSessionInput: CreateCheckoutSessionInput;
};


export type MutationCreateCompletedEvalArgs = {
  input: CreateCompletedEvalInput;
};


export type MutationCreateCompletedEvalForGuestsArgs = {
  input: CreateCompletedEvalInputForGuest;
};


export type MutationCreateDoctorArgs = {
  input: V2CreateDoctor;
};


export type MutationCreateEvaluationQuestionArgs = {
  input: CreateEvaluationQuestionInput;
};


export type MutationCreateGiveawayRecordArgs = {
  input: CreateGiveawayInput;
};


export type MutationCreateGuestEvaluationArgs = {
  input: CreateGuestEvaluationInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateJobArgs = {
  input: CronjobInput;
};


export type MutationCreateNewSurveyArgs = {
  input: CreateNewSurveyInput;
};


export type MutationCreateOtcWalletOrderArgs = {
  input: CreateOtcWalletOrderInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreateOrderNoteArgs = {
  input: CreateOrderNoteInput;
};


export type MutationCreateOrdersAfterTeleConsultArgs = {
  input: TeleConsultOrdersInput;
};


export type MutationCreatePartnerTrtOrderArgs = {
  input: CreatePartnerTrtOrder;
};


export type MutationCreatePatientDocumentArgs = {
  input?: InputMaybe<CreatePatientDocumentInput>;
};


export type MutationCreatePatientFromOpsArgs = {
  input: CreatePatientFromOpsInput;
};


export type MutationCreatePreblockArgs = {
  input: CreatePreblockInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateReferralDocumentsArgs = {
  input?: InputMaybe<CreateReferralDocumentInput>;
};


export type MutationCreateShipmentGroupArgs = {
  input: CreateShipmentGroupInput;
};


export type MutationCreateShipperArgs = {
  input?: InputMaybe<CreateShipperInput>;
};


export type MutationCreateStripeCouponArgs = {
  input: CreateStripeCouponInput;
};


export type MutationCreateStripePriceArgs = {
  input: CreateStripePriceInput;
};


export type MutationCreateStripeProductArgs = {
  input: CreateStripeProductInput;
};


export type MutationCreateStripePromotionCodeArgs = {
  input: CreateStripePromotionCodeInput;
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


export type MutationDeleteAuditDoctorNoteArgs = {
  sysId: Scalars['String'];
};


export type MutationDeleteCartItemByIdArgs = {
  input: DeleteCartItemByIdInput;
};


export type MutationDeleteCompletedEvalArgs = {
  input: Scalars['String'];
};


export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};


export type MutationDeleteOrderPermanentArgs = {
  orderId: Scalars['String'];
};


export type MutationDeletePatientArgs = {
  email: Scalars['String'];
};


export type MutationDeletePatientQuestionAnswerArgs = {
  input: DeletePatientQuestionAnswerInput;
};


export type MutationDeleteStripeCouponArgs = {
  id: Scalars['String'];
};


export type MutationDeleteStripePriceArgs = {
  input: DeletePriceInput;
};


export type MutationDeleteStripeProductArgs = {
  input: DeleteProductInput;
};


export type MutationDeleteTrtDocumentArgs = {
  documentSysId: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  input: Scalars['String'];
};


export type MutationDeliveryChargeArgs = {
  input?: InputMaybe<PatientIdInput>;
};


export type MutationDeliveryChargeV2Args = {
  deliveryChargeV2: V2DeliveryCharge;
};


export type MutationDestroyFcMtokenArgs = {
  input: FcmTokenInput;
};


export type MutationDisableProductArgs = {
  productName: Scalars['String'];
};


export type MutationDuplicateStripePriceArgs = {
  input: DuplicateStripePriceInput;
};


export type MutationGenerateSmartMatchResultsArgs = {
  input: GenerateSmartMatchResultsInput;
};


export type MutationGetLastInvoiceDateArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationGetUpcomingInvoiceDateArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationGuestFirstCheckoutArgs = {
  input: GuestRegisterAndEvalResultInput;
};


export type MutationHosAcknowledgeMilestoneArgs = {
  id: Scalars['ID'];
};


export type MutationHosAcknowledgeSafetyCardArgs = {
  flagId: Scalars['ID'];
};


export type MutationHosAdminLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationHosAnswerBaselineStepArgs = {
  clientRequestId: Scalars['ID'];
  stepId: Scalars['String'];
  value: HosBaselineAnswerValueInput;
};


export type MutationHosAnswerCheckinArgs = {
  input: HosAnswerCheckinInput;
};


export type MutationHosAnswerFirstDoseGateArgs = {
  clientRequestId: Scalars['ID'];
  firstDoseBucket?: InputMaybe<HosFirstDoseBucket>;
  optionId: Scalars['String'];
};


export type MutationHosApproveRegistryProposalArgs = {
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationHosCardSeenArgs = {
  events: Array<HosCardSeenEventInput>;
};


export type MutationHosCompleteActionArgs = {
  input: HosCompleteActionInput;
};


export type MutationHosCompleteIntroArgs = {
  clientRequestId: Scalars['ID'];
};


export type MutationHosConfirmDoseArgs = {
  input: HosConfirmDoseInput;
};


export type MutationHosCreateRegistryProposalArgs = {
  input: HosCreateRegistryProposalInput;
};


export type MutationHosDryRunRegistryProposalArgs = {
  id: Scalars['ID'];
};


export type MutationHosGrantConsentArgs = {
  clientRequestId: Scalars['ID'];
  copyVersion: Scalars['String'];
};


export type MutationHosGrantRoleArgs = {
  email: Scalars['String'];
  role: HosRegistryRole;
};


export type MutationHosHarnessActAsArgs = {
  patientSysId: Scalars['ID'];
};


export type MutationHosHarnessAdvanceClockArgs = {
  by: HosDurationInput;
  patientSysId: Scalars['ID'];
};


export type MutationHosHarnessClearClockArgs = {
  patientSysId: Scalars['ID'];
};


export type MutationHosHarnessRecomputeArgs = {
  patientSysId: Scalars['ID'];
};


export type MutationHosHarnessResetArgs = {
  clientRequestId: Scalars['ID'];
  patientSysId: Scalars['ID'];
};


export type MutationHosHarnessRunDailyTickArgs = {
  patientSysId: Scalars['ID'];
};


export type MutationHosHarnessSeedArgs = {
  input: HosHarnessSeedInput;
};


export type MutationHosHarnessSetClockArgs = {
  mode?: InputMaybe<HosClockMode>;
  now: Scalars['DateTime'];
  patientSysId: Scalars['ID'];
};


export type MutationHosOpenChatArgs = {
  input: HosChatOpenInput;
};


export type MutationHosOpsAlertActionArgs = {
  action: HosOpsAlertAction;
  alertId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationHosOpsAlertClearFlagArgs = {
  alertId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  reason: HosOpsFlagClearReason;
};


export type MutationHosOpsAlertRevealArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationHosProposeCorpusDocumentArgs = {
  input: HosProposeCorpusDocumentInput;
};


export type MutationHosRebaseRegistryProposalArgs = {
  id: Scalars['ID'];
};


export type MutationHosRejectRegistryProposalArgs = {
  id: Scalars['ID'];
  note: Scalars['String'];
};


export type MutationHosReportCuratorRunArgs = {
  input: HosReportCuratorRunInput;
};


export type MutationHosRequestChatHandoffArgs = {
  input: HosChatHandoffInput;
};


export type MutationHosRequestReplayArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  kind: HosReplayKind;
  targetEventId: Scalars['ID'];
};


export type MutationHosRevokeRoleArgs = {
  role: HosRegistryRole;
  userSysId: Scalars['ID'];
};


export type MutationHosRollbackRegistrySectionArgs = {
  condition: Scalars['String'];
  section: HosRegistrySection;
  toVersion: Scalars['Int'];
};


export type MutationHosRunCuratorArgs = {
  input: HosRunCuratorInput;
};


export type MutationHosSendChatMessageArgs = {
  input: HosChatSendInput;
};


export type MutationHosSetAdminPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationHosSkipCheckinArgs = {
  checkinId: Scalars['ID'];
};


export type MutationHosStartActionArgs = {
  input: HosStartActionInput;
};


export type MutationHosSubmitBaselineQuestionnaireArgs = {
  clientRequestId: Scalars['ID'];
};


export type MutationHosSubmitRegistryProposalArgs = {
  id: Scalars['ID'];
};


export type MutationHosUpdatePatientScheduleArgs = {
  input: HosUpdatePatientScheduleInput;
};


export type MutationImpersonateArgs = {
  input: ImpersonateInput;
};


export type MutationImportProductsAndPricesArgs = {
  input: V2ImportProductPricesInput;
};


export type MutationInsertCartItemByIdArgs = {
  input: InsertCartItemByIdInput;
};


export type MutationIsAutoRenewalSubArgs = {
  input: IsAutoRenewalSubInput;
};


export type MutationLogInArgs = {
  input: LoginInput;
};


export type MutationLogInGoogleArgs = {
  input: LoginSocialInput;
};


export type MutationLogInLineArgs = {
  input: LoginSocialInput;
};


export type MutationLogOutUserSessionArgs = {
  input: LogOutUserSessionInput;
};


export type MutationMarkNoShowArgs = {
  input: MarkNoShowInput;
};


export type MutationMarkRetentionPromoRedeemedArgs = {
  input: MarkRetentionPromoRedeemedInput;
};


export type MutationMassUpdateCustomerBalanceArgs = {
  input: UpdateCustomerBalanceInput;
};


export type MutationMigrateProductIncludedArgs = {
  input: Scalars['String'];
};


export type MutationOpsChangeDeliveryWindowArgs = {
  input: OpsChangeDeliveryWindowInput;
};


export type MutationOpsChargeOtcOrderArgs = {
  input: OpsChargeOtcOrderInput;
};


export type MutationPartnerBookConsultationArgs = {
  input: CreatePartnerConsultation;
};


export type MutationPauseAndResumeSubscriptionArgs = {
  input: PauseAndResumeSubscriptionInput;
};


export type MutationPendingOrderArgs = {
  input: PendingOrderInput;
};


export type MutationPortEmailArgs = {
  input: PortEmailInput;
};


export type MutationPrescriptionCheckoutArgs = {
  input: PrescriptionCheckoutInput;
};


export type MutationPrescriptionCheckoutV2Args = {
  input?: InputMaybe<V2PresCheckoutInput>;
};


export type MutationProcessCartByOtcWalletArgs = {
  input: ProcessCartByOtCwalletInput;
};


export type MutationReAssignDoctorForNoteArgs = {
  input: UpdateDoctorForAuditDoctorNoteInput;
};


export type MutationReAssignTextConsultationDoctorArgs = {
  input: ReAssignTextConsultationDoctorInput;
};


export type MutationReactivateArgs = {
  reactivateInput: V2ReactivateOrderInput;
};


export type MutationReactivateCanceledOrderV2Args = {
  input: ReactivateCanceledOrderInputV2;
};


export type MutationRecordBloodPressureArgs = {
  input: RecordBloodPressureInput;
};


export type MutationRecordDoseStartArgs = {
  input: RecordDoseStartInput;
};


export type MutationRecreateAtomePaymentLinkArgs = {
  recreateAtomeInput: RenewAtomePaymentLinkInput;
};


export type MutationRefreshAccessTokenArgs = {
  input: RefreshAccessTokenInput;
};


export type MutationRefundChargedForAdminArgs = {
  input: PaymentRefundInput;
};


export type MutationRefundInvoiceForAdminArgs = {
  input: PaymentRefundInput;
};


export type MutationRefundOtcWalletOrderArgs = {
  input: RefundOtcWalletOrderInput;
};


export type MutationRefundPaymentIntentArgs = {
  id: Scalars['String'];
};


export type MutationRefundPaymentIntentForAdminArgs = {
  input: PaymentRefundInput;
};


export type MutationRefundPaymentIntentForAnonymousArgs = {
  id: Scalars['String'];
};


export type MutationRegisterDoctorArgs = {
  input: RegisterDoctorInput;
};


export type MutationRegisterFcMtokenArgs = {
  input: FcmTokenInput;
};


export type MutationRegisterPatientArgs = {
  input: RegisterPatientInput;
};


export type MutationRegisterUserSessionArgs = {
  input: RegisterUserSessionInput;
};


export type MutationRejectPrescriptionOrderArgs = {
  input: RejectOrderInput;
};


export type MutationReleasePreblockArgs = {
  input: ReleasePreblockInput;
};


export type MutationRemoveCardDetailPatientArgs = {
  email: Scalars['String'];
};


export type MutationRenewArgs = {
  renewInput: V2RenewCodOrderInput;
};


export type MutationRenewAtomeOrderArgs = {
  input: V2RenewAtomeOrder;
};


export type MutationRenewCodOrderArgs = {
  input?: InputMaybe<V2RenewCodOrderInput>;
};


export type MutationRenewCodOrdersArgs = {
  input: V2RenewMultipleCodOrdersInput;
};


export type MutationRenewKonbiniOrderArgs = {
  input: V2RenewKonbiniOrderInput;
};


export type MutationRenewOrderByOpsArgs = {
  input: RenewOrderByOpsInput;
};


export type MutationRenewOrderByPatientArgs = {
  input: RenewOrderByPatientInput;
};


export type MutationRequestEmailOtpArgs = {
  email: Scalars['String'];
};


export type MutationRequestFollowUpConsultArgs = {
  input: TriggerFollowUpConsultInput;
};


export type MutationRequestFollowUpConsultV2Args = {
  requestFollowUpConsultInput: RequestFollowUpConsultInput;
};


export type MutationRequestMagicLinkArgs = {
  input: RequestMagicLinkInput;
};


export type MutationRequestUpgradeSettingsLinkArgs = {
  input: RequestUpgradeSettingsLinkInput;
};


export type MutationRescheduleAppointmentArgs = {
  input: RescheduleAppointmentInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordUserInput;
};


export type MutationResetPasswordWithTokenArgs = {
  input: ResetPasswordWithTokenInput;
};


export type MutationResubscribeCanceledOtcOrderArgs = {
  input: ReactivateCanceledOtcOrderInputV2;
};


export type MutationSaveTranslationArgs = {
  input: SaveTranslationInput;
};


export type MutationSendEmailAboutNewMessageArgs = {
  input: SendEmailAboutNewMessageInput;
};


export type MutationSendReminderUnreadDrMessageArgs = {
  input: SendReminderUnreadDrMessageInput;
};


export type MutationSendResetPasswordEmailArgs = {
  input: ForgotPasswordUserInput;
};


export type MutationSendShipmentSmsArgs = {
  input: SendShipmentSmsInput;
};


export type MutationSendToDetrackAndProcessingDeliveryArgs = {
  input: SendToDetrackInput;
};


export type MutationSetDoctorTrtEligibleArgs = {
  doctorSysId: Scalars['String'];
  trtEligible: Scalars['Boolean'];
};


export type MutationSetTrtOrderStatusArgs = {
  input: SetTrtOrderStatusInput;
};


export type MutationSignInWithMagicLinkArgs = {
  input: SignInWithMagicLinkInput;
};


export type MutationSkipSurveyForCartArgs = {
  input: SkipSurveyForCartInput;
};


export type MutationSplitShipmentArgs = {
  input: SplitShipmentInput;
};


export type MutationStartCronJobArgs = {
  jobName: Scalars['String'];
};


export type MutationStopCronJobArgs = {
  jobName: Scalars['String'];
};


export type MutationSubmitAffiliateCouponArgs = {
  input: SubmitAffiliateCouponInput;
};


export type MutationSubmitEvaluationArgs = {
  evaluationDataInput: PatientSubmitEvaluationInput;
};


export type MutationSubmitVideoCallRatingArgs = {
  input: SubmitVideoCallRatingInput;
};


export type MutationTest_GenerateSmartMatchResultsArgs = {
  input: Test_GenerateSmartMatchResultsInput;
};


export type MutationTranslateRawTextArgs = {
  input: TranslateRawTextInput;
};


export type MutationTriggerOnPaidAtomePaymentArgs = {
  referenceId: Scalars['String'];
};


export type MutationTrySecondOpinionV2Args = {
  input: TrySecondOpinionInputV2;
};


export type MutationUpdateAddressArgs = {
  updateDeliveryInput: V2AddressInput;
};


export type MutationUpdateAffiliateArgs = {
  input: UpdateAffiliateInput;
  sysId: Scalars['String'];
};


export type MutationUpdateAffiliateCouponVerificationArgs = {
  opsNote?: InputMaybe<Scalars['String']>;
  status: AffiliateCouponStatus;
  sysId: Scalars['String'];
};


export type MutationUpdateAffiliateProductArgs = {
  input: UpdateAffiliateProductInput;
  sysId: Scalars['String'];
};


export type MutationUpdateAtomePaymentArgs = {
  input: V2UpdateAtomePaymentInput;
};


export type MutationUpdateCartCalculateOrderSummaryArgs = {
  input: UpdateCartCalculateOrderSummaryInput;
};


export type MutationUpdateCartItemByIdArgs = {
  input: UpdateCartItemByIdInput;
};


export type MutationUpdateCheckoutSessionArgs = {
  updateCheckoutSessionInput: UpdateCheckoutSessionInput;
};


export type MutationUpdateCompletedEvalArgs = {
  input: UpdateCompletedEvalInput;
};


export type MutationUpdateCompletedEvalForGuestsArgs = {
  input: UpdateCompletedEvalInputForGuest;
};


export type MutationUpdateCustomerBalanceTransactionArgs = {
  input: UpdateCustomerBalanceTransactionInput;
};


export type MutationUpdateEvaluationProgressArgs = {
  input: UpdateProcessEvaluationInput;
};


export type MutationUpdateEvaluationQuestionArgs = {
  input: UpdateEvaluationQuestionInput;
};


export type MutationUpdateMhpOrderDosageArgs = {
  updateOrderDosageInput: UpdateMhpOrderDosageInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdateOrderByOpsV2Args = {
  updateOrderInput: V2UpdateOrderInput;
};


export type MutationUpdateOrderNoteArgs = {
  input: UpdateOrderNoteInput;
};


export type MutationUpdateOtherInterestedEvalIdsArgs = {
  interestedEvalIdInput?: InputMaybe<V2UpdateOtherInterestedEvalIdsInput>;
};


export type MutationUpdatePatientArgs = {
  input: V2UpdatePatientInput;
};


export type MutationUpdatePatientDocumentArgs = {
  input?: InputMaybe<UpdatePatientDocumentInput>;
};


export type MutationUpdatePatientInfoArgs = {
  input: UpdatePatientInput;
};


export type MutationUpdatePatientSubscriptionsPaymentMethodArgs = {
  paymentMethodId: Scalars['String'];
};


export type MutationUpdatePaymentStatusForCodOrderArgs = {
  input: V2UpdatePaymentStatusCodOrderInput;
};


export type MutationUpdatePickupLocationArgs = {
  input: PickupLocationInput;
};


export type MutationUpdateProductImageUrlsArgs = {
  input: UpdateStripeProductImageUrlsInput;
};


export type MutationUpdateShipmentGroupArgs = {
  input: UpdateShipmentGroupInput;
};


export type MutationUpdateShipperArgs = {
  input?: InputMaybe<UpdateShipperInput>;
};


export type MutationUpdateShippingOrderShipmentArgs = {
  input: UpdateShippingOrderShipment;
};


export type MutationUpdateStripeCouponArgs = {
  input: UpdateStripeCouponInput;
};


export type MutationUpdateStripeCouponMetadataArgs = {
  input: UpdateStripeCouponInput;
};


export type MutationUpdateStripePriceArgs = {
  input: UpdateStripePriceInput;
};


export type MutationUpdateStripePriceLocaleArgs = {
  input: UpdatePriceLocaleInput;
};


export type MutationUpdateStripePriceMetadataArgs = {
  input: UpdatePriceMetadataInput;
};


export type MutationUpdateStripeProductArgs = {
  input: UpdateStripeProductInput;
};


export type MutationUpdateStripeProductLocaleArgs = {
  input: UpdateProductLocaleInput;
};


export type MutationUpdateStripeProductMetadataArgs = {
  input: UpdateProductMetadataInput;
};


export type MutationUpdateStripePromotionCodeArgs = {
  input: UpdateStripePromotionCodeInput;
};


export type MutationUpdateStripePromotionCodeMetadataArgs = {
  input: UpdateStripePromotionCodeInput;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<V2UserInput>;
};


export type MutationUpdateVoidInvoiceOrderArgs = {
  orderId: Scalars['String'];
};


export type MutationUpdateVoidInvoiceOrderV2Args = {
  orderId: Scalars['String'];
};


export type MutationUploadFileArgs = {
  input: SignS3Input;
};


export type MutationUploadFileDirectArgs = {
  file: Scalars['String'];
  input: UploadIdInput;
};


export type MutationUploadFileV2Args = {
  input: SignS3Input;
};


export type MutationUploadPublicFileArgs = {
  input: SignS3Input;
};


export type MutationUploadPublicFileV2Args = {
  input: SignS3Input;
};


export type MutationUploadTrtDocumentArgs = {
  input: UploadTrtDocumentInput;
};


export type MutationUpsertPatientTourViewingArgs = {
  input: UpsertPatientOnboardingInput;
};


export type MutationUpsertRecommendedProductsArgs = {
  input: UpsertRecommendedProductsInput;
};


export type MutationValidateEmailOtpArgs = {
  email: Scalars['String'];
  otp: Scalars['String'];
};


export type MutationVerifyForgotPasswordArgs = {
  input: VerifyForgotPasswordUserInput;
};


export type MutationVerifyOrderArgs = {
  input: VerifyOrderInput;
};

export type NewPickupLocationInput = {
  address?: InputMaybe<Scalars['String']>;
  area?: InputMaybe<Scalars['JSON']>;
  areaName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  officeName?: InputMaybe<Scalars['String']>;
  officeNumber?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PickupLocationType>;
  unit?: InputMaybe<Scalars['String']>;
};

export type NewPickupLocationsInput = {
  pickupLocations?: InputMaybe<Array<InputMaybe<NewPickupLocationInput>>>;
};

export type NextSteps = {
  __typename?: 'NextSteps';
  evidence: Scalars['String'];
  text: Scalars['String'];
};

export enum NinjaServiceLevel {
  Nextday = 'Nextday',
  Sameday = 'Sameday',
  Standard = 'Standard'
}

export type OpsChargeOtcOrderInput = {
  orderId: Scalars['String'];
  priceId: Scalars['String'];
};

export type OtcCalculationSummaryDto = {
  __typename?: 'OTCCalculationSummaryDTO';
  otcOrdersCalculation?: Maybe<Array<OtcOrderCalculationDto>>;
  totalBasePrice?: Maybe<Scalars['Float']>;
  totalCashbackEarned?: Maybe<Scalars['Float']>;
  totalCashbackRedeemed?: Maybe<Scalars['Float']>;
  totalPaymentIntentAmount?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
  totalTransactionFee?: Maybe<Scalars['Float']>;
};

export type OtcOrderCalculationDto = {
  __typename?: 'OTCOrderCalculationDto';
  basePrice?: Maybe<Scalars['Float']>;
  cashbackEarnRate?: Maybe<Scalars['Float']>;
  cashbackEarned?: Maybe<Scalars['Float']>;
  cashbackRedeemed?: Maybe<Scalars['Float']>;
  discountAmount?: Maybe<Scalars['Float']>;
  paymentIntentAmount?: Maybe<Scalars['Float']>;
  paymentIntentAmountAfterCashback?: Maybe<Scalars['Float']>;
  paymentIntentSummary?: Maybe<Scalars['JSON']>;
  priceId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productPriceAmount?: Maybe<Scalars['Float']>;
  productPriceAmountAfterDiscount?: Maybe<Scalars['Float']>;
  promotionCode?: Maybe<Scalars['String']>;
  stripePromotionCode?: Maybe<Scalars['JSON']>;
  tax?: Maybe<Scalars['Float']>;
  transactionFee?: Maybe<Scalars['Float']>;
};

export type OldOrderModel = {
  __typename?: 'OldOrderModel';
  id?: Maybe<Scalars['String']>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  priceId?: Maybe<Scalars['String']>;
  status?: Maybe<OrderStatus>;
  subId?: Maybe<Scalars['String']>;
};

export enum OnboardingStatus {
  Completed = 'Completed',
  NotOpen = 'NotOpen',
  Opened = 'Opened'
}

export type OpsChangeDeliveryWindowInput = {
  lang?: InputMaybe<Language>;
  orderId: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type OpsConvertedOrderRow = {
  __typename?: 'OpsConvertedOrderRow';
  approveAt?: Maybe<Scalars['DateTime']>;
  converted: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  initialTotal?: Maybe<Scalars['Float']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  shortId?: Maybe<Scalars['Int']>;
  status: OrderStatus;
  sysId: Scalars['String'];
  utmCampaign?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
};

export type OpsConvertedOrdersFilterInput = {
  converted?: InputMaybe<ConvertedFilter>;
  dateBasis: ConvertedOrdersDateBasis;
  fromDate?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<OrderStatus>>;
  toDate?: InputMaybe<Scalars['String']>;
  utmSources?: InputMaybe<Array<Scalars['String']>>;
};

export type OpsConvertedOrdersResult = {
  __typename?: 'OpsConvertedOrdersResult';
  convertedCount: Scalars['Int'];
  items: Array<OpsConvertedOrderRow>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type OpsOrderDetailModel = {
  __typename?: 'OpsOrderDetailModel';
  appointmentTypeID?: Maybe<Scalars['Float']>;
  atomePayment?: Maybe<AtomePaymentDto>;
  doctorNotes?: Maybe<Array<Maybe<DoctorNoteModel>>>;
  doctors?: Maybe<Array<Maybe<DoctorModel>>>;
  invoices?: Maybe<Array<StripeInvoiceModel>>;
  needFollowUpConsultAfterRenewing?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['JSON']>;
  orderStripeProductPrice?: Maybe<StripeProductPriceModel>;
  patient?: Maybe<PatientModel>;
  prescriptionPrices?: Maybe<PricesListModel>;
  prescriptionProduct?: Maybe<StripeProductModel>;
  prices?: Maybe<Array<StripeProductPriceModel>>;
  productGroup?: Maybe<ProductModel>;
  retentionPromo?: Maybe<RetentionPromoTagDto>;
  stripeProducts?: Maybe<Array<Maybe<StripeProductModel>>>;
  subscription?: Maybe<StripeSubscriptionModel>;
};

export type OpsPaginatedOrderModel = {
  __typename?: 'OpsPaginatedOrderModel';
  count: Scalars['Int'];
  items?: Maybe<Array<PaginatedOpsDashBoardOrderModel>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type OrderAddressInput = {
  billing: BillingAddressInput;
  shipping: DeliveryAddressInput;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderDto = {
  __typename?: 'OrderDto';
  ableToBookConsultSchedule?: Maybe<Scalars['Boolean']>;
  ableToBookDeliverySchedule?: Maybe<Scalars['Boolean']>;
  ableToChangeDeliverySchedule?: Maybe<Scalars['Boolean']>;
  activeConsultation?: Maybe<ConsultationDto>;
  acuityAppointment?: Maybe<AcuityAppointmentDto>;
  acuityAppointments?: Maybe<Array<Maybe<AcuityAppointmentDto>>>;
  additionalPrices?: Maybe<Array<Maybe<StripePriceDto>>>;
  afterVideoConsultRedirecting?: Maybe<AfterVideoConsultRedirectingDto>;
  approveAt?: Maybe<Scalars['DateTime']>;
  atomeNextSendingInvoiceDate?: Maybe<Scalars['DateTime']>;
  atomePayments?: Maybe<Array<Maybe<AtomePaymentDto>>>;
  checkoutSession?: Maybe<CheckoutSessionDto>;
  childrenOrders?: Maybe<Array<OrderDto>>;
  claimedRetentionOffer?: Maybe<Scalars['Boolean']>;
  consultationAudits?: Maybe<Array<Maybe<ConsultationAuditDto>>>;
  consultations?: Maybe<Array<ConsultationDto>>;
  continueTrial?: Maybe<Scalars['Boolean']>;
  countTrialReminder?: Maybe<Scalars['Float']>;
  country?: Maybe<RegionType>;
  createFromSkipOrderId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  delivery?: Maybe<Scalars['JSON']>;
  deliveryAddress?: Maybe<AddressDto>;
  deliveryAddressSysId?: Maybe<Scalars['String']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliverySnapshot?: Maybe<Scalars['JSON']>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  deliveryTimestamp?: Maybe<Scalars['DateTime']>;
  doctorNotes?: Maybe<Scalars['String']>;
  doctorPrescriptionPriceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  dosage?: Maybe<Scalars['JSON']>;
  doseStartedAt?: Maybe<Scalars['DateTime']>;
  evaluation?: Maybe<EvaluationDto>;
  evaluationId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['Float']>;
  intakeInstructions?: Maybe<Scalars['String']>;
  isAtomeAutoRenewal?: Maybe<Scalars['Boolean']>;
  isAutoRenewal?: Maybe<Scalars['Boolean']>;
  isConsultOnly?: Maybe<Scalars['Boolean']>;
  isEDTrial?: Maybe<Scalars['Boolean']>;
  isEditingDeliveryWithin2Hours?: Maybe<Scalars['Boolean']>;
  isOrderRenew?: Maybe<Scalars['Boolean']>;
  isPacked?: Maybe<Scalars['Boolean']>;
  isPendingFollowUpConsult?: Maybe<Scalars['Boolean']>;
  isPrescriptionValid?: Maybe<Scalars['Boolean']>;
  isSkipMedOrder?: Maybe<Scalars['Boolean']>;
  isSkippedEval?: Maybe<Scalars['Boolean']>;
  isSubscriptionPastDue?: Maybe<Scalars['Boolean']>;
  isSubscriptionPaused?: Maybe<Scalars['Boolean']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  lastShipmentDate?: Maybe<Scalars['DateTime']>;
  latestAtomePayment?: Maybe<AtomePaymentDto>;
  latestInvoice?: Maybe<StripeInvoiceDto>;
  latestNote?: Maybe<OrderNoteDto>;
  nextReviewDate?: Maybe<Scalars['DateTime']>;
  oldPrice?: Maybe<Scalars['JSON']>;
  oldPriceInfo?: Maybe<StripePriceDto>;
  oldStripePrescriptionId?: Maybe<Scalars['String']>;
  ops?: Maybe<Scalars['String']>;
  opsComment?: Maybe<Scalars['String']>;
  orderPrescriptionPriceId?: Maybe<Scalars['String']>;
  orderPriceId?: Maybe<Scalars['String']>;
  otherIntestedEvalIds?: Maybe<Array<Scalars['String']>>;
  partnerSysId?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientDto>;
  patientId?: Maybe<Scalars['String']>;
  patientOrderNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentIntentUrl?: Maybe<Scalars['String']>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<PaymentStatus>;
  phoneNumber?: Maybe<Scalars['String']>;
  pickupLocation?: Maybe<PickupLocationDto>;
  planStatus?: Maybe<PlanStatus>;
  platformType?: Maybe<PlatformType>;
  prescribeAfterTeleConsult?: Maybe<Scalars['Boolean']>;
  prescribedAfterTrialOrder?: Maybe<OrderDto>;
  prescribed_after_trial_order_sys_id?: Maybe<Scalars['String']>;
  prescription?: Maybe<PrescriptionDto>;
  prescriptionDisplayPriceId?: Maybe<Scalars['String']>;
  prescriptionId?: Maybe<Scalars['String']>;
  prescriptionOrderCalculation?: Maybe<PrescriptionOrderCalculationDto>;
  price?: Maybe<StripePriceDto>;
  priceDisplayId?: Maybe<Scalars['String']>;
  priceInfo?: Maybe<StripePriceDto>;
  productInfo?: Maybe<StripeProductDto>;
  productQuantity?: Maybe<Scalars['Float']>;
  promotionCode?: Maybe<Scalars['String']>;
  rejectAt?: Maybe<Scalars['DateTime']>;
  reorderStatus?: Maybe<Scalars['Boolean']>;
  shortId?: Maybe<Scalars['Float']>;
  showInCurrentPlans?: Maybe<Scalars['Boolean']>;
  showInNotifications?: Maybe<Scalars['Boolean']>;
  showInPastPlans?: Maybe<Scalars['Boolean']>;
  siblingCrossSellOrders?: Maybe<Array<OrderDto>>;
  status?: Maybe<OrderStatus>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscription?: Maybe<StripeSubscriptionDto>;
  sysId?: Maybe<Scalars['String']>;
  teleConsultProduct?: Maybe<Scalars['Boolean']>;
  upcomingInvoice?: Maybe<StripeInvoiceDto>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type OrderDtoConsultationAuditsArgs = {
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
};


export type OrderDtoConsultationsArgs = {
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
};

export type OrderFilterForDoctorDashboardInput = {
  consultationSessionType?: InputMaybe<ConsultationSessionType>;
  email?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  tabState?: InputMaybe<DoctorTabState>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type OrderFilterForOpsConsultationsInput = {
  consultationSessionType?: InputMaybe<ConsultationSessionType>;
  dateSearch?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['String']>;
};

export type OrderFilterForOpsDashboardInput = {
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  isOneTime?: InputMaybe<Scalars['Boolean']>;
  isPendingDelivery?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<PaymentProvider>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pickupLocationType?: InputMaybe<PickupLocationType>;
  shortId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrderStatus>;
};

export type OrderFilterInput = {
  approveAt?: InputMaybe<Scalars['DateTime']>;
  country?: InputMaybe<RegionType>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<Scalars['String']>;
  expiredAt?: InputMaybe<Scalars['Float']>;
  isAutoRenewal?: InputMaybe<Scalars['Boolean']>;
  isEDTrial?: InputMaybe<Scalars['Boolean']>;
  isFixedOrder?: InputMaybe<Scalars['Boolean']>;
  isOrderRenew?: InputMaybe<Scalars['Boolean']>;
  isPendingFollowUpConsult?: InputMaybe<Scalars['Boolean']>;
  isSkippedEval?: InputMaybe<Scalars['Boolean']>;
  isSubscriptionPastDue?: InputMaybe<Scalars['Boolean']>;
  isSubscriptionPaused?: InputMaybe<Scalars['Boolean']>;
  nextReviewDate?: InputMaybe<Scalars['DateTime']>;
  patientId?: InputMaybe<Scalars['String']>;
  paymentProvider?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  platformType?: InputMaybe<PlatformType>;
  prescribeAfterTeleConsult?: InputMaybe<Scalars['Boolean']>;
  prescriptionId?: InputMaybe<Scalars['String']>;
  prescriptionPriceId?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
  productGroupId?: InputMaybe<Scalars['String']>;
  productQuantity?: InputMaybe<Scalars['Float']>;
  rejectAt?: InputMaybe<Scalars['DateTime']>;
  reorderStatus?: InputMaybe<Scalars['Boolean']>;
  shortId?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<OrderStatus>;
  statuses?: InputMaybe<Array<OrderStatus>>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type OrderInput = {
  deliveryMethods?: InputMaybe<Array<DeliveryMethod>>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  isRX?: InputMaybe<Scalars['Boolean']>;
  orderShortId?: InputMaybe<Scalars['String']>;
  patientEmail?: InputMaybe<Scalars['String']>;
  patientName?: InputMaybe<Scalars['String']>;
  patientPhone?: InputMaybe<Scalars['String']>;
  paymentProviders?: InputMaybe<Array<PaymentProvider>>;
  statuses?: InputMaybe<Array<OrderStatus>>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type OrderModel = {
  __typename?: 'OrderModel';
  acuityAppointmentSnapshot?: Maybe<AcuityAppointmentModel>;
  acuityAppointments?: Maybe<Array<Maybe<AcuityAppointmentModel>>>;
  address?: Maybe<Scalars['JSON']>;
  affiliateCoupon?: Maybe<AffiliateCoupon>;
  approveAt?: Maybe<Scalars['DateTime']>;
  atomePaymentAmount?: Maybe<Scalars['Float']>;
  auditDoctorNotes?: Maybe<Array<Maybe<AuditDoctorNoteModel>>>;
  completedEvaluation?: Maybe<Scalars['JSON']>;
  consultationSessions?: Maybe<Scalars['JSON']>;
  continueTrial?: Maybe<Scalars['Boolean']>;
  countTrialReminder?: Maybe<Scalars['Float']>;
  country?: Maybe<RegionType>;
  createFromSkipOrderId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  delivery?: Maybe<Scalars['JSON']>;
  deliveryAddress?: Maybe<AddressModel>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliverySnapshot?: Maybe<Scalars['JSON']>;
  doctorNotes?: Maybe<Scalars['String']>;
  doctorPrescriptionPriceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  dosage?: Maybe<Scalars['JSON']>;
  evaluationId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['Float']>;
  intakeInstructions?: Maybe<Scalars['String']>;
  isAutoRenewal?: Maybe<Scalars['Boolean']>;
  isConsultOnly?: Maybe<Scalars['Boolean']>;
  isEDTrial?: Maybe<Scalars['Boolean']>;
  isOrderRenew?: Maybe<Scalars['Boolean']>;
  isPendingFollowUpConsult?: Maybe<Scalars['Boolean']>;
  isSkipMedOrder?: Maybe<Scalars['Boolean']>;
  isSkippedEval?: Maybe<Scalars['Boolean']>;
  isSubscriptionPastDue?: Maybe<Scalars['Boolean']>;
  isSubscriptionPaused?: Maybe<Scalars['Boolean']>;
  isTestOrder?: Maybe<Scalars['Boolean']>;
  latestInvoice?: Maybe<Scalars['JSON']>;
  nextReviewDate?: Maybe<Scalars['DateTime']>;
  oldOrder?: Maybe<OldOrderModel>;
  oldPrice?: Maybe<Scalars['JSON']>;
  ops?: Maybe<Scalars['String']>;
  opsComment?: Maybe<Scalars['String']>;
  orderPrescriptionPriceId?: Maybe<Scalars['String']>;
  orderPriceId?: Maybe<Scalars['String']>;
  otherIntestedEvalIds?: Maybe<Array<Scalars['String']>>;
  patientId?: Maybe<Scalars['String']>;
  patientOrderNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientSnapshot?: Maybe<PatientModel>;
  paymentProvider?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pickupLocation?: Maybe<PickupLocationDto>;
  platformType?: Maybe<PlatformType>;
  prescribeAfterTeleConsult?: Maybe<Scalars['Boolean']>;
  prescribedAfterTrialOrder?: Maybe<OrderModel>;
  prescription?: Maybe<PrescriptionModel>;
  prescriptionDisplayPriceId?: Maybe<Scalars['String']>;
  prescriptionId?: Maybe<Scalars['String']>;
  prescriptionOrderCalculation?: Maybe<Scalars['JSON']>;
  priceDisplayId?: Maybe<Scalars['String']>;
  priceInfo?: Maybe<Scalars['JSON']>;
  productGroupData?: Maybe<ProductModel>;
  productInfo?: Maybe<StripeProductModel>;
  productQuantity?: Maybe<Scalars['Float']>;
  promotionCode?: Maybe<Scalars['String']>;
  rejectAt?: Maybe<Scalars['DateTime']>;
  reorderStatus?: Maybe<Scalars['Boolean']>;
  shortId?: Maybe<Scalars['Float']>;
  status?: Maybe<OrderStatus>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  teleConsultProduct?: Maybe<Scalars['Boolean']>;
  twilioMessageHistories?: Maybe<Array<Maybe<TwilioMessageHistoryModel>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderNoteDto = {
  __typename?: 'OrderNoteDto';
  author?: Maybe<UserDto>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  sysId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderShipmentConfig = {
  ninjaServiceLevel?: InputMaybe<NinjaServiceLevel>;
};

export type OrderShipmentDto = {
  __typename?: 'OrderShipmentDto';
  address: Scalars['JSON'];
  cost: Scalars['Float'];
  courierName?: Maybe<CourierName>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryTimestamp?: Maybe<Scalars['DateTime']>;
  estimatedShipDate?: Maybe<Scalars['DateTime']>;
  group?: Maybe<OrderShipmentGroupDto>;
  items?: Maybe<Array<OrderShipmentItemDto>>;
  note?: Maybe<Scalars['String']>;
  parcelId: Scalars['String'];
  patient?: Maybe<PatientDto>;
  paused: Scalars['Boolean'];
  shipDate?: Maybe<Scalars['DateTime']>;
  shipper?: Maybe<UserDto>;
  status: Scalars['String'];
  sysId: Scalars['String'];
  trackingNo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderShipmentGroupDto = {
  __typename?: 'OrderShipmentGroupDto';
  bookingNo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  sysId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderShipmentInput = {
  deliveryMethods?: InputMaybe<Array<DeliveryMethod>>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  fromDeliveryDate?: InputMaybe<Scalars['DateTime']>;
  groupSysIds?: InputMaybe<Array<Scalars['String']>>;
  note?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderShortId?: InputMaybe<Scalars['String']>;
  patientEmail?: InputMaybe<Scalars['String']>;
  patientName?: InputMaybe<Scalars['String']>;
  patientPhone?: InputMaybe<Scalars['String']>;
  paymentProviders?: InputMaybe<Array<PaymentProvider>>;
  statuses?: InputMaybe<Array<OrderShipmentStatus>>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  toDeliveryDate?: InputMaybe<Scalars['DateTime']>;
};

export type OrderShipmentItemDto = {
  __typename?: 'OrderShipmentItemDto';
  createdAt?: Maybe<Scalars['DateTime']>;
  dosage?: Maybe<Scalars['JSON']>;
  isFirstPurchase: Scalars['Boolean'];
  order?: Maybe<OrderDto>;
  orderNo: Scalars['Float'];
  orderSysId: Scalars['String'];
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentDate?: Maybe<Scalars['DateTime']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentProvider: PaymentProvider;
  price?: Maybe<StripeProductDto>;
  priceId: Scalars['String'];
  product?: Maybe<StripeProductDto>;
  promotionCode?: Maybe<Scalars['String']>;
  qty: Scalars['Float'];
  sysId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum OrderShipmentStatus {
  Cancelled = 'Cancelled',
  Delivered = 'Delivered',
  New = 'New',
  Packed = 'Packed',
  PendingProcessing = 'PendingProcessing',
  Shipped = 'Shipped'
}

export enum OrderStatus {
  Active = 'active',
  Cancel = 'cancel',
  CancelBooking = 'cancel_booking',
  Cancelled = 'cancelled',
  Deleted = 'deleted',
  OnHold = 'on_hold',
  Paused = 'paused',
  Pending = 'pending',
  PendingBooking = 'pending_booking',
  PendingBookingFu = 'pending_booking_fu',
  PendingCheckout = 'pending_checkout',
  PendingDelivery = 'pending_delivery',
  PendingHumansaCheck = 'pending_humansa_check',
  PendingPayment = 'pending_payment',
  PendingPrescription = 'pending_prescription',
  PendingPrescriptionFu = 'pending_prescription_fu',
  PendingProcessing = 'pending_processing',
  PendingResults = 'pending_results',
  PendingSamples = 'pending_samples',
  PendingUploadIc = 'pending_upload_ic',
  PrescriptionChange = 'prescription_change',
  PrescriptionRejected = 'prescription_rejected',
  Refunded = 'refunded',
  ResultsReady = 'results_ready',
  SamplesPickupScheduled = 'samples_pickup_scheduled',
  Verified = 'verified'
}

export type OrderSummaryDto = {
  __typename?: 'OrderSummaryDto';
  cashbackEarnRate?: Maybe<Scalars['Int']>;
  cashbackEarned?: Maybe<Scalars['Int']>;
  cashbackRedeemed?: Maybe<Scalars['Int']>;
  discountAmountLater?: Maybe<Scalars['Int']>;
  discountAmountNow?: Maybe<Scalars['Int']>;
  minimalAmountPayment?: Maybe<Scalars['Int']>;
  paymentIntentAmount?: Maybe<Scalars['Int']>;
  paymentIntentAmountBeforeTax?: Maybe<Scalars['Int']>;
  paymentIntentSummary?: Maybe<Scalars['JSON']>;
  promotionCode?: Maybe<Scalars['String']>;
  shippingFee?: Maybe<Scalars['Int']>;
  subTotal?: Maybe<Scalars['Int']>;
  subTotalLater?: Maybe<Scalars['Int']>;
  subTotalNow?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Int']>;
  taxesLater?: Maybe<Scalars['Int']>;
  taxesNow?: Maybe<Scalars['Int']>;
  teleConsultFee?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  totalLater?: Maybe<Scalars['Int']>;
  totalNow?: Maybe<Scalars['Int']>;
  totalNowAfterCashback?: Maybe<Scalars['Int']>;
  totalTaxes?: Maybe<Scalars['Int']>;
};

export type OrderWithPatientModel = {
  __typename?: 'OrderWithPatientModel';
  affiliateCoupon?: Maybe<AffiliateCoupon>;
  order?: Maybe<OrderModel>;
  patient?: Maybe<PatientModel>;
};

export type PaginatedAdminAffiliateCoupons = {
  __typename?: 'PaginatedAdminAffiliateCoupons';
  count: Scalars['Int'];
  items: Array<AdminAffiliateCoupon>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PaginatedAffiliates = {
  __typename?: 'PaginatedAffiliates';
  count: Scalars['Int'];
  items: Array<Affiliate>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PaginatedConsultationAuditDto = {
  __typename?: 'PaginatedConsultationAuditDto';
  count: Scalars['Int'];
  items?: Maybe<Array<ConsultationAuditDto>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PaginatedCronjobModel = {
  __typename?: 'PaginatedCronjobModel';
  count: Scalars['Int'];
  items?: Maybe<Array<CronjobModel>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PaginatedOpsDashBoardOrderModel = {
  __typename?: 'PaginatedOpsDashBoardOrderModel';
  acuityAppointmentSnapshot?: Maybe<AcuityAppointmentModel>;
  acuityAppointments?: Maybe<Array<Maybe<AcuityAppointmentModel>>>;
  address?: Maybe<Scalars['JSON']>;
  affiliateCoupon?: Maybe<AffiliateCoupon>;
  approveAt?: Maybe<Scalars['DateTime']>;
  atomePaymentAmount?: Maybe<Scalars['Float']>;
  auditDoctorNotes?: Maybe<Array<Maybe<AuditDoctorNoteModel>>>;
  completedEvaluation?: Maybe<Scalars['JSON']>;
  consultationSessions?: Maybe<Scalars['JSON']>;
  continueTrial?: Maybe<Scalars['Boolean']>;
  countTrialReminder?: Maybe<Scalars['Float']>;
  country?: Maybe<RegionType>;
  createFromSkipOrderId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  delivery?: Maybe<Scalars['JSON']>;
  deliveryAddress?: Maybe<AddressModel>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliverySnapshot?: Maybe<Scalars['JSON']>;
  doctorNotes?: Maybe<Scalars['String']>;
  doctorPrescriptionPriceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  dosage?: Maybe<Scalars['JSON']>;
  evaluationId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['Float']>;
  intakeInstructions?: Maybe<Scalars['String']>;
  isAutoRenewal?: Maybe<Scalars['Boolean']>;
  isConsultOnly?: Maybe<Scalars['Boolean']>;
  isEDTrial?: Maybe<Scalars['Boolean']>;
  isOrderRenew?: Maybe<Scalars['Boolean']>;
  isPendingFollowUpConsult?: Maybe<Scalars['Boolean']>;
  isRenewalSubscription: Scalars['Boolean'];
  isSkipMedOrder?: Maybe<Scalars['Boolean']>;
  isSkippedEval?: Maybe<Scalars['Boolean']>;
  isSubscriptionPastDue?: Maybe<Scalars['Boolean']>;
  isSubscriptionPaused?: Maybe<Scalars['Boolean']>;
  isSuitableForWeightLoss?: Maybe<Scalars['Boolean']>;
  isTestOrder?: Maybe<Scalars['Boolean']>;
  latestInvoice?: Maybe<Scalars['JSON']>;
  nextReviewDate?: Maybe<Scalars['DateTime']>;
  oldOrder?: Maybe<OldOrderModel>;
  oldPrice?: Maybe<Scalars['JSON']>;
  ops?: Maybe<Scalars['String']>;
  opsComment?: Maybe<Scalars['String']>;
  orderPrescriptionPriceId?: Maybe<Scalars['String']>;
  orderPriceId?: Maybe<Scalars['String']>;
  otherIntestedEvalIds?: Maybe<Array<Scalars['String']>>;
  parentOrderShortId?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  patientOrderNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientSnapshot?: Maybe<PatientModel>;
  paymentProvider?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<PaymentStatus>;
  phoneNumber?: Maybe<Scalars['String']>;
  pickupLocation?: Maybe<PickupLocationDto>;
  platformType?: Maybe<PlatformType>;
  prescribeAfterTeleConsult?: Maybe<Scalars['Boolean']>;
  prescribedAfterTrialOrder?: Maybe<OrderModel>;
  prescription?: Maybe<PrescriptionModel>;
  prescriptionDisplayPriceId?: Maybe<Scalars['String']>;
  prescriptionId?: Maybe<Scalars['String']>;
  prescriptionOrderCalculation?: Maybe<Scalars['JSON']>;
  price?: Maybe<StripeProductPriceModel>;
  priceDisplayId?: Maybe<Scalars['String']>;
  priceInfo?: Maybe<Scalars['JSON']>;
  productGroupData?: Maybe<ProductModel>;
  productInfo?: Maybe<StripeProductModel>;
  productQuantity?: Maybe<Scalars['Float']>;
  promotionCode?: Maybe<Scalars['String']>;
  rejectAt?: Maybe<Scalars['DateTime']>;
  reorderStatus?: Maybe<Scalars['Boolean']>;
  retentionPromo?: Maybe<RetentionPromoTagDto>;
  shortId?: Maybe<Scalars['Float']>;
  status?: Maybe<OrderStatus>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  subscription?: Maybe<StripeSubscriptionModel>;
  sysId?: Maybe<Scalars['String']>;
  teleConsultProduct?: Maybe<Scalars['Boolean']>;
  twilioMessageHistories?: Maybe<Array<Maybe<TwilioMessageHistoryModel>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PaginatedOrderModel = {
  __typename?: 'PaginatedOrderModel';
  count: Scalars['Int'];
  items?: Maybe<Array<OrderModel>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PaginatedOrders = {
  __typename?: 'PaginatedOrders';
  count: Scalars['Int'];
  items?: Maybe<Array<OrderDto>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PaginatedPickupLocationDto = {
  __typename?: 'PaginatedPickupLocationDto';
  count: Scalars['Int'];
  items?: Maybe<Array<PickupLocationDto>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type PaginatedTrtOrders = {
  __typename?: 'PaginatedTrtOrders';
  count: Scalars['Int'];
  items: Array<TrtOrderDto>;
};

export type PaginatedUserMessageDto = {
  __typename?: 'PaginatedUserMessageDto';
  count: Scalars['Int'];
  items?: Maybe<Array<UserMessageDto>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type ParticipantModel = {
  __typename?: 'ParticipantModel';
  avatar?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  identity?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  role?: Maybe<UserRole>;
  token?: Maybe<Scalars['String']>;
  userSysId?: Maybe<Scalars['String']>;
};

export type PartnerDto = {
  __typename?: 'PartnerDto';
  address?: Maybe<Scalars['String']>;
  consultDates?: Maybe<Array<Maybe<CalendarDateDto>>>;
  consultTimes?: Maybe<Array<Maybe<CalendarTimeDto>>>;
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  partner?: Maybe<UserDto>;
  phoneNumber?: Maybe<Scalars['String']>;
  sysId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  users?: Maybe<PartnerUserDto>;
};

export type PartnerUserDto = {
  __typename?: 'PartnerUserDto';
  partner?: Maybe<UserDto>;
  sysId: Scalars['String'];
  user?: Maybe<UserDto>;
};

export type PatientBookingDataModel = {
  __typename?: 'PatientBookingDataModel';
  bookingOrder: PatientBookingOrderModel;
  cart?: Maybe<CheckoutCartModel>;
  needsBookingOrderIds: Array<Scalars['String']>;
  patient: PatientModel;
  totalBookingOrderIds: Array<Scalars['String']>;
};

export type PatientBookingInput = {
  orderId: Scalars['String'];
};

export type PatientBookingOrderModel = {
  __typename?: 'PatientBookingOrderModel';
  acuityAppointmentSnapshot?: Maybe<AcuityAppointmentModel>;
  acuityAppointments?: Maybe<Array<Maybe<AcuityAppointmentModel>>>;
  address?: Maybe<Scalars['JSON']>;
  affiliateCoupon?: Maybe<AffiliateCoupon>;
  approveAt?: Maybe<Scalars['DateTime']>;
  atomePaymentAmount?: Maybe<Scalars['Float']>;
  auditDoctorNotes?: Maybe<Array<Maybe<AuditDoctorNoteModel>>>;
  availableSlots?: Maybe<Array<Maybe<AvailableSlotModel>>>;
  completedEvaluation?: Maybe<Scalars['JSON']>;
  consultationSession?: Maybe<ConsultationSessionModel>;
  consultationSessions?: Maybe<Scalars['JSON']>;
  continueTrial?: Maybe<Scalars['Boolean']>;
  countTrialReminder?: Maybe<Scalars['Float']>;
  country?: Maybe<RegionType>;
  createFromSkipOrderId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  delivery?: Maybe<Scalars['JSON']>;
  deliveryAddress?: Maybe<AddressModel>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliverySnapshot?: Maybe<Scalars['JSON']>;
  doctorNotes?: Maybe<Scalars['String']>;
  doctorPrescriptionPriceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  dosage?: Maybe<Scalars['JSON']>;
  evaluationId?: Maybe<Scalars['String']>;
  expiredAt?: Maybe<Scalars['Float']>;
  intakeInstructions?: Maybe<Scalars['String']>;
  isAutoRenewal?: Maybe<Scalars['Boolean']>;
  isConsultOnly?: Maybe<Scalars['Boolean']>;
  isEDTrial?: Maybe<Scalars['Boolean']>;
  isOrderFromNewPrescriptionFlow: Scalars['Boolean'];
  isOrderRenew?: Maybe<Scalars['Boolean']>;
  isPendingFollowUpConsult?: Maybe<Scalars['Boolean']>;
  isSkipMedOrder?: Maybe<Scalars['Boolean']>;
  isSkippedEval?: Maybe<Scalars['Boolean']>;
  isSubscriptionPastDue?: Maybe<Scalars['Boolean']>;
  isSubscriptionPaused?: Maybe<Scalars['Boolean']>;
  isTestOrder?: Maybe<Scalars['Boolean']>;
  latestInvoice?: Maybe<Scalars['JSON']>;
  needsBooking: Scalars['Boolean'];
  needsBookingDelivery: Scalars['Boolean'];
  nextReviewDate?: Maybe<Scalars['DateTime']>;
  oldOrder?: Maybe<OldOrderModel>;
  oldPrice?: Maybe<Scalars['JSON']>;
  ops?: Maybe<Scalars['String']>;
  opsComment?: Maybe<Scalars['String']>;
  orderPrescriptionPriceId?: Maybe<Scalars['String']>;
  orderPriceId?: Maybe<Scalars['String']>;
  otherIntestedEvalIds?: Maybe<Array<Scalars['String']>>;
  patientId?: Maybe<Scalars['String']>;
  patientOrderNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  patientSnapshot?: Maybe<PatientModel>;
  paymentProvider?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pickupLocation?: Maybe<PickupLocationDto>;
  platformType?: Maybe<PlatformType>;
  prescribeAfterTeleConsult?: Maybe<Scalars['Boolean']>;
  prescribedAfterTrialOrder?: Maybe<OrderModel>;
  prescription?: Maybe<PrescriptionModel>;
  prescriptionDisplayPriceId?: Maybe<Scalars['String']>;
  prescriptionId?: Maybe<Scalars['String']>;
  prescriptionOrderCalculation?: Maybe<Scalars['JSON']>;
  priceDisplayId?: Maybe<Scalars['String']>;
  priceInfo?: Maybe<Scalars['JSON']>;
  productGroupData?: Maybe<ProductModel>;
  productInfo?: Maybe<StripeProductModel>;
  productQuantity?: Maybe<Scalars['Float']>;
  promotionCode?: Maybe<Scalars['String']>;
  rejectAt?: Maybe<Scalars['DateTime']>;
  reorderStatus?: Maybe<Scalars['Boolean']>;
  shortId?: Maybe<Scalars['Float']>;
  status?: Maybe<OrderStatus>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  teleConsultProduct?: Maybe<Scalars['Boolean']>;
  twilioMessageHistories?: Maybe<Array<Maybe<TwilioMessageHistoryModel>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PatientByReferralCodeInput = {
  referralCode: Scalars['String'];
};

export type PatientBypassLoginTokenDto = {
  __typename?: 'PatientBypassLoginTokenDto';
  expiresAt: Scalars['DateTime'];
  pageName: Scalars['String'];
  token: Scalars['String'];
  type: Scalars['String'];
};

export type PatientDashboardDataModel = {
  __typename?: 'PatientDashboardDataModel';
  activeProductIds: ActiveProductIds;
  bannerProducts: Array<StripeProductModel>;
  cart: CartCalculationModel;
  cashbackDashboard: CashbackDashboardModel;
  completedEvals: Array<GetCompletedEvalByFilterModel>;
  consultationSessions?: Maybe<Scalars['JSON']>;
  notificationOrders: Array<ExtraOrderInfoModel>;
  patientCodeData: Array<StripePromotionCodeModel>;
  shoppingExcludedEvalIds: Array<Scalars['String']>;
  stripeProducts: Array<StripeProductModel>;
  suggestionProducts: Array<StripeProductModel>;
  teleConsultOrders: Array<OrderModel>;
  tour?: Maybe<PatientOnboardingModel>;
  treatmentExcludedEvalIds: Array<Scalars['String']>;
};

export type PatientDashboardInput = {
  platform?: InputMaybe<PlatformType>;
  stripeProductFilter: StripeProductFilterInput;
  tourName?: InputMaybe<Scalars['String']>;
};

export type PatientDialog = {
  channelUrl: Scalars['String'];
  patientEmail?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type PatientDto = {
  __typename?: 'PatientDto';
  atomePayment?: Maybe<AtomePaymentDto>;
  atomePayments?: Maybe<Array<Maybe<AtomePaymentDto>>>;
  billingAddress?: Maybe<AddressModel>;
  bloodPressure?: Maybe<Scalars['String']>;
  bypassLoginTokens?: Maybe<Array<PatientBypassLoginTokenDto>>;
  cart?: Maybe<CartDto>;
  cashback?: Maybe<CashbackDto>;
  checkoutSessions?: Maybe<Array<CheckoutSessionDto>>;
  consultations?: Maybe<Array<ConsultationDto>>;
  country?: Maybe<RegionType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deliveryAddress?: Maybe<AddressModel>;
  dob?: Maybe<Scalars['String']>;
  document?: Maybe<UserDocumentDto>;
  documents?: Maybe<Array<UserDocumentDto>>;
  email?: Maybe<Scalars['String']>;
  evaluations?: Maybe<Array<Maybe<EvaluationDto>>>;
  fbc?: Maybe<Scalars['String']>;
  fbp?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fromPlatformEnv?: Maybe<PlatformType>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  height?: Maybe<Scalars['Float']>;
  icNumber?: Maybe<Scalars['String']>;
  idVerifiedAt?: Maybe<Scalars['DateTime']>;
  identification?: Maybe<Scalars['JSON']>;
  isAlreadyCheckout?: Maybe<Scalars['Boolean']>;
  isReferredBy?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  latestPaymentMethod?: Maybe<StripePaymentMethodDto>;
  legalName?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  mounjaroTrialEligible: Scalars['Boolean'];
  order?: Maybe<OrderDto>;
  orders?: Maybe<Array<Maybe<OrderDto>>>;
  paidCompletedEvaluationIds?: Maybe<Array<Scalars['String']>>;
  phoneNumber?: Maybe<Scalars['String']>;
  prescriptionCalculation?: Maybe<CheckoutCalculationDto>;
  referralCode?: Maybe<Scalars['String']>;
  referrals?: Maybe<Array<ReferralDto>>;
  shopProducts?: Maybe<ShopProducts>;
  smartMatchMeta?: Maybe<SmartMatchMetaDto>;
  stripeCustomer?: Maybe<Scalars['JSON']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  survey?: Maybe<SurveyDto>;
  sysId?: Maybe<Scalars['String']>;
  user?: Maybe<UserDto>;
  userSysId?: Maybe<Scalars['String']>;
  videoConsultation?: Maybe<VideoConsultationDto>;
  videoConsultationPreview?: Maybe<VideoConsultationDto>;
  weight?: Maybe<Scalars['Float']>;
};


export type PatientDtoAtomePaymentArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type PatientDtoCheckoutSessionsArgs = {
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
};


export type PatientDtoConsultationsArgs = {
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
};


export type PatientDtoDocumentArgs = {
  input: GetPatientDocumentInput;
};


export type PatientDtoEvaluationsArgs = {
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
};


export type PatientDtoOrderArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type PatientDtoOrdersArgs = {
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
};


export type PatientDtoPrescriptionCalculationArgs = {
  input?: InputMaybe<PrescriptionCalculationInput>;
};


export type PatientDtoShopProductsArgs = {
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
};


export type PatientDtoSmartMatchMetaArgs = {
  input: GetSmartMatchMetaInput;
};


export type PatientDtoSurveyArgs = {
  input?: InputMaybe<PatientGetSurveyInput>;
};


export type PatientDtoVideoConsultationArgs = {
  videoLink: Scalars['String'];
};


export type PatientDtoVideoConsultationPreviewArgs = {
  previewVideoLink: Scalars['String'];
};

export type PatientEvaluationAnswersDto = {
  __typename?: 'PatientEvaluationAnswersDto';
  answer?: Maybe<AnswerDto>;
  question?: Maybe<QuestionDto>;
  type?: Maybe<PatientQuestionAnswerType>;
  value?: Maybe<Scalars['String']>;
};

export type PatientEvaluationModel = {
  __typename?: 'PatientEvaluationModel';
  consultType?: Maybe<ConsultationSessionType>;
  currentQuestion?: Maybe<QuestionModel>;
  evaluation?: Maybe<EvaluationModel>;
  evaluationBlock?: Maybe<EvaluationBlockModel>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isSkipped?: Maybe<Scalars['Boolean']>;
  patient?: Maybe<PatientModel>;
  patientNote?: Maybe<Scalars['String']>;
};

export type PatientFilterByIdsInput = {
  ids: Array<Scalars['String']>;
};

export type PatientFilterInput = {
  country?: InputMaybe<RegionType>;
  dob?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fromPlatformEnv?: InputMaybe<PlatformType>;
  fullName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type PatientGetSurveyInput = {
  type?: InputMaybe<SurveyType>;
};

export type PatientIdInput = {
  orderId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type PatientModel = {
  __typename?: 'PatientModel';
  billingAddress?: Maybe<AddressModel>;
  bloodPressure?: Maybe<Scalars['String']>;
  country?: Maybe<RegionType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deliveryAddress?: Maybe<AddressModel>;
  dob?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fbc?: Maybe<Scalars['String']>;
  fbp?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fromPlatformEnv?: Maybe<PlatformType>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  height?: Maybe<Scalars['Float']>;
  icNumber?: Maybe<Scalars['String']>;
  identification?: Maybe<Scalars['JSON']>;
  isAlreadyCheckout?: Maybe<Scalars['Boolean']>;
  isReferredBy?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  orders?: Maybe<Array<Maybe<OrderModel>>>;
  paidCompletedEvaluationIds?: Maybe<Array<Scalars['String']>>;
  phoneNumber?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  stripeCustomer?: Maybe<Scalars['JSON']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  weight?: Maybe<Scalars['Float']>;
};

export type PatientName = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type PatientOnboardingModel = {
  __typename?: 'PatientOnboardingModel';
  currentStep?: Maybe<Scalars['Float']>;
  patientId?: Maybe<Scalars['String']>;
  skipGuide?: Maybe<Scalars['Boolean']>;
  status?: Maybe<OnboardingStatus>;
  sysId: Scalars['String'];
  tourName?: Maybe<Scalars['String']>;
};

export type PatientOrderInput = {
  orderId: Scalars['String'];
  patientId: Scalars['String'];
};

export type PatientPlanDetailInput = {
  id: Scalars['String'];
};

export type PatientPlanDetailModel = {
  __typename?: 'PatientPlanDetailModel';
  planData: GetPlansModel;
  refCoupon: GetReferralModel;
};

export type PatientPlanInput = {
  platform?: InputMaybe<PlatformType>;
};

export type PatientPlansDataModel = {
  __typename?: 'PatientPlansDataModel';
  refCoupon: GetReferralModel;
};

export type PatientPrenatalModel = {
  __typename?: 'PatientPrenatalModel';
  age?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  getPreggers?: Maybe<Scalars['String']>;
  hasChildren?: Maybe<Scalars['Boolean']>;
  height?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['String']>;
};

export type PatientQuestionAnswerModel = {
  __typename?: 'PatientQuestionAnswerModel';
  patient?: Maybe<PatientModel>;
  questionAnswer: QuestionAnswerModel;
  type: PatientQuestionAnswerType;
  value?: Maybe<Scalars['String']>;
};

export enum PatientQuestionAnswerType {
  Date = 'Date',
  Number = 'Number',
  Text = 'Text'
}

export type PatientSubmitEvaluationInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  consultationSessionType?: InputMaybe<ConsultationSessionType>;
  evaluationType: EvalIds;
  patientId?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Array<InputMaybe<EvalResultInput>>>;
  tracking?: InputMaybe<TrackingTypeInput>;
  trackingProperties?: InputMaybe<Scalars['JSONObject']>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type PatientVitalDto = {
  __typename?: 'PatientVitalDto';
  diastolic?: Maybe<Scalars['Int']>;
  recordedAt: Scalars['DateTime'];
  source: PatientVitalSource;
  sysId: Scalars['String'];
  systolic?: Maybe<Scalars['Int']>;
  type: PatientVitalType;
};

export enum PatientVitalSource {
  PatientReported = 'PatientReported'
}

export enum PatientVitalType {
  BloodPressure = 'BloodPressure'
}

export type PauseAndResumeSubscriptionInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  subscriptionId: Scalars['String'];
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type PaymentItemInfoInput = {
  consultationSessionType?: InputMaybe<ConsultationSessionType>;
  isEDBundle?: InputMaybe<Scalars['Boolean']>;
  isPayNow?: InputMaybe<Scalars['Boolean']>;
  isRxProduct?: InputMaybe<Scalars['Boolean']>;
  isSkipMedSelecting?: InputMaybe<Scalars['Boolean']>;
  isSubscriptionPrice?: InputMaybe<Scalars['Boolean']>;
  isSubscriptionUpdate?: InputMaybe<Scalars['Boolean']>;
  itemSubTotal?: InputMaybe<Scalars['Float']>;
  itemSubTotalAfterDiscount?: InputMaybe<Scalars['Float']>;
  mainProductId?: InputMaybe<Scalars['String']>;
  mainProductName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
  priceType?: InputMaybe<StripePriceType>;
  productId?: InputMaybe<Scalars['String']>;
  productUniqName?: InputMaybe<ProductNameType>;
  quantity?: InputMaybe<Scalars['Float']>;
  unit_amount?: InputMaybe<Scalars['Float']>;
};

export type PaymentItemInfoModel = {
  __typename?: 'PaymentItemInfoModel';
  consultationSessionType?: Maybe<ConsultationSessionType>;
  isEDBundle?: Maybe<Scalars['Boolean']>;
  isPayNow?: Maybe<Scalars['Boolean']>;
  isRxProduct?: Maybe<Scalars['Boolean']>;
  isSkipMedSelecting?: Maybe<Scalars['Boolean']>;
  isSubscriptionPrice?: Maybe<Scalars['Boolean']>;
  isSubscriptionUpdate?: Maybe<Scalars['Boolean']>;
  itemSubTotal?: Maybe<Scalars['Float']>;
  itemSubTotalAfterDiscount?: Maybe<Scalars['Float']>;
  mainProductId?: Maybe<Scalars['String']>;
  mainProductName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
  priceType?: Maybe<StripePriceType>;
  productId?: Maybe<Scalars['String']>;
  productUniqName?: Maybe<ProductNameType>;
  quantity?: Maybe<Scalars['Float']>;
  unit_amount?: Maybe<Scalars['Float']>;
};

export enum PaymentProvider {
  Atome = 'atome',
  Cod = 'cod',
  Konbini = 'konbini',
  Paypay = 'paypay',
  Stripe = 'stripe'
}

export type PaymentRefundInput = {
  id?: InputMaybe<Scalars['String']>;
  refundAmount?: InputMaybe<Scalars['Float']>;
};

export enum PaymentStatus {
  Fail = 'fail',
  Paid = 'paid',
  Unpaid = 'unpaid'
}

export type PendingOrderInput = {
  orderSysIds: Array<Scalars['String']>;
};

export type PickupLocationDto = {
  __typename?: 'PickupLocationDto';
  address?: Maybe<Scalars['String']>;
  area?: Maybe<RegionAreaDto>;
  city?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  officeName?: Maybe<Scalars['String']>;
  officeNumber?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Scalars['String']>;
  orders?: Maybe<Array<Maybe<OrderDto>>>;
  paymentProviders?: Maybe<Array<PaymentProvider>>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  type?: Maybe<PickupLocationType>;
  unit?: Maybe<Scalars['String']>;
};

export type PickupLocationInput = {
  address?: InputMaybe<Scalars['String']>;
  area?: InputMaybe<Scalars['JSON']>;
  areaName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  officeName?: InputMaybe<Scalars['String']>;
  officeNumber?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PickupLocationType>;
  unit?: InputMaybe<Scalars['String']>;
};

export enum PickupLocationType {
  All = 'All',
  CircleK = 'CircleK',
  JumppointPartnerStores = 'JumppointPartnerStores',
  Lockers = 'Lockers',
  NinjaVan = 'NinjaVan',
  SfExpress = 'SFExpress'
}

export enum PlanStatus {
  Active = 'active',
  Cancel = 'cancel',
  Completed = 'completed',
  Paused = 'paused',
  PendingDelivery = 'pending_delivery',
  PendingPayment = 'pending_payment',
  PendingPrescription = 'pending_prescription',
  PrescriptionRejected = 'prescription_rejected'
}

export type PlatformEnvironmentInput = {
  country?: InputMaybe<RegionType>;
  platform?: InputMaybe<PlatformType>;
};

export enum PlatformType {
  All = 'all',
  Noah = 'noah',
  Zoey = 'zoey'
}

export type PortEmailInput = {
  newEmail: Scalars['String'];
  oldEmail?: InputMaybe<Scalars['String']>;
};

export type PreblockDto = {
  __typename?: 'PreblockDto';
  expiresAt: Scalars['String'];
  heldAppointmentTypeId: Scalars['String'];
  heldDateTime: Scalars['String'];
  preblockId: Scalars['ID'];
  status: PreblockStatus;
};

export type PreblockSlotDto = {
  __typename?: 'PreblockSlotDto';
  slotsAvailable: Scalars['Int'];
  time: Scalars['String'];
};

export type PreblockSlotsInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  evaluationId: EvalIds;
  month: Scalars['String'];
  region: RegionType;
};

export enum PreblockStatus {
  Converted = 'converted',
  Expired = 'expired',
  Released = 'released',
  Reserved = 'reserved'
}

export type PreblockTimesInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  evaluationId: EvalIds;
  region: RegionType;
};

export type PrescribedProductInput = {
  asNeeded?: InputMaybe<Scalars['Boolean']>;
  chargePatient?: InputMaybe<Scalars['Boolean']>;
  dosage?: InputMaybe<Scalars['String']>;
  dosageUnit?: InputMaybe<DosageUnit>;
  duration?: InputMaybe<Scalars['String']>;
  durationUnit?: InputMaybe<DosageDurationUnit>;
  frequency?: InputMaybe<DosageFrequencyOptions>;
  priceId?: InputMaybe<Scalars['String']>;
  quantityUnit?: InputMaybe<DosageQuantityUnit>;
  value?: InputMaybe<Scalars['String']>;
};

export type PrescribedProductModel = {
  __typename?: 'PrescribedProductModel';
  asNeeded?: Maybe<Scalars['Boolean']>;
  chargePatient?: Maybe<Scalars['Boolean']>;
  dosage?: Maybe<Scalars['String']>;
  dosageUnit?: Maybe<DosageUnit>;
  duration?: Maybe<Scalars['String']>;
  durationUnit?: Maybe<DosageDurationUnit>;
  frequency?: Maybe<DosageFrequencyOptions>;
  priceId?: Maybe<Scalars['String']>;
  quantityUnit?: Maybe<DosageQuantityUnit>;
  value?: Maybe<Scalars['String']>;
};

export type PrescriptionCalculationInput = {
  additionalPrescriptionPriceIds?: InputMaybe<Array<Scalars['String']>>;
  anonymousId?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<EvalIds>;
  forRenewal?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  otcPriceIds?: InputMaybe<Array<Scalars['String']>>;
  platform?: InputMaybe<PlatformType>;
  priceId: Scalars['String'];
  promotionCode?: InputMaybe<Scalars['String']>;
};

export type PrescriptionCheckoutInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<AddressInput>;
  consultType: ConsultationSessionType;
  deliveryAddress: ExtraDeliveryAddressInput;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  evaluationId: EvalIds;
  isAutoRenewal: Scalars['Boolean'];
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentType: PaymentProvider;
  pickupLocation?: InputMaybe<PickupLocationInput>;
  priceId: Scalars['String'];
  promotionCode?: InputMaybe<Scalars['String']>;
  stripeCustomer: Scalars['JSON'];
  summary: Scalars['JSON'];
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type PrescriptionCheckoutModel = {
  __typename?: 'PrescriptionCheckoutModel';
  orderId: Scalars['String'];
  textConversationId?: Maybe<Scalars['String']>;
  totalAfterCashback?: Maybe<Scalars['Float']>;
};

export type PrescriptionDto = {
  __typename?: 'PrescriptionDto';
  approver?: Maybe<UserDto>;
  cancelled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  days?: Maybe<Scalars['Float']>;
  doctor?: Maybe<DoctorDto>;
  doctorNotes?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  isFollowUp?: Maybe<Scalars['Boolean']>;
  notedDate?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientDto>;
  priceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<Array<Maybe<StripeProductDto>>>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  treatmentCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionFilterInput = {
  cancelled?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  treatmentCode?: InputMaybe<Scalars['String']>;
};

export type PrescriptionModel = {
  __typename?: 'PrescriptionModel';
  approver?: Maybe<User>;
  cancelled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  days?: Maybe<Scalars['Float']>;
  doctor?: Maybe<DoctorModel>;
  doctorNotes?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  isFollowUp?: Maybe<Scalars['Boolean']>;
  notedDate?: Maybe<Scalars['DateTime']>;
  patient?: Maybe<PatientModel>;
  priceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<Array<Maybe<StripeProductModel>>>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  treatmentCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PrescriptionOrderCalculationDto = {
  __typename?: 'PrescriptionOrderCalculationDto';
  cashbackEarnRate?: Maybe<Scalars['Float']>;
  cashbackEarned?: Maybe<Scalars['Float']>;
  cashbackRedeemed?: Maybe<Scalars['Float']>;
  consultBasePrice?: Maybe<Scalars['Float']>;
  consultFee?: Maybe<Scalars['Float']>;
  consultFeeAfterDiscount?: Maybe<Scalars['Float']>;
  consultTax?: Maybe<Scalars['Float']>;
  consultTransactionFee?: Maybe<Scalars['Float']>;
  discountAmount?: Maybe<Scalars['Float']>;
  isConsult?: Maybe<Scalars['Boolean']>;
  mainBasePrice?: Maybe<Scalars['Float']>;
  mainTax?: Maybe<Scalars['Float']>;
  mainTransactionFee?: Maybe<Scalars['Float']>;
  minimalAmountPayment?: Maybe<Scalars['Float']>;
  paymentIntentAmount?: Maybe<Scalars['Float']>;
  paymentIntentAmountAfterCashback?: Maybe<Scalars['Float']>;
  paymentIntentSummary?: Maybe<Scalars['JSON']>;
  priceId?: Maybe<Scalars['String']>;
  productPriceAmount?: Maybe<Scalars['Float']>;
  productPriceAmountAfterDiscount?: Maybe<Scalars['Float']>;
  promotionCode?: Maybe<Scalars['String']>;
  shouldChargeConsultFee?: Maybe<Scalars['Boolean']>;
  subTotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalAfterCashback?: Maybe<Scalars['Float']>;
};

export type PrescriptionOrderCalculationModel = {
  __typename?: 'PrescriptionOrderCalculationModel';
  cashbackEarnRate: Scalars['Float'];
  cashbackEarned: Scalars['Float'];
  cashbackRedeemed: Scalars['Float'];
  consultFee: Scalars['Float'];
  consultFeeAfterDiscount: Scalars['Float'];
  discountAmount: Scalars['Float'];
  isConsult: Scalars['Boolean'];
  minimalAmountPayment: Scalars['Float'];
  paymentIntentAmount: Scalars['Float'];
  paymentIntentAmountAfterCashback: Scalars['Float'];
  paymentIntentSummary?: Maybe<Scalars['JSON']>;
  priceId?: Maybe<Scalars['String']>;
  productPriceAmount: Scalars['Float'];
  productPriceAmountAfterDiscount: Scalars['Float'];
  promotionCode?: Maybe<Scalars['String']>;
  promotionCodeError?: Maybe<PromotionCodeError>;
  shouldChargeConsultFee?: Maybe<Scalars['Boolean']>;
  stripeProductPrice: StripeProductPriceModel;
  stripePromotionCode?: Maybe<StripePromotionCodeModel>;
  subTotal: Scalars['Float'];
  total: Scalars['Float'];
  totalAfterCashback: Scalars['Float'];
};

export enum PrescriptionStatus {
  Approve = 'Approve',
  Cancel = 'Cancel',
  ChangeConsult = 'ChangeConsult',
  NoShow = 'NoShow',
  Prescribed = 'Prescribed',
  Reject = 'Reject',
  RxChange = 'RxChange'
}

export type PriceInput = {
  active?: InputMaybe<Scalars['String']>;
  actual_price_display?: InputMaybe<Scalars['String']>;
  aggregate_usage?: InputMaybe<Scalars['String']>;
  billing_scheme?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  dosage?: InputMaybe<Scalars['String']>;
  dosage_display?: InputMaybe<Scalars['String']>;
  dosage_popular?: InputMaybe<Scalars['String']>;
  first_month_alternative_price_id?: InputMaybe<Scalars['String']>;
  first_time_alternative_price?: InputMaybe<Scalars['String']>;
  first_time_trying_in_months?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  frequency_actual_price_display?: InputMaybe<Scalars['String']>;
  frequency_display?: InputMaybe<Scalars['String']>;
  frequency_popular?: InputMaybe<Scalars['String']>;
  frequency_price_display?: InputMaybe<Scalars['String']>;
  frequency_quantity_display?: InputMaybe<Scalars['String']>;
  frequency_quantity_display_patient?: InputMaybe<Scalars['String']>;
  frequency_savings_display?: InputMaybe<Scalars['String']>;
  frequency_strikeout_price_display?: InputMaybe<Scalars['String']>;
  import_price_id?: InputMaybe<Scalars['String']>;
  live_product_id?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  metadata_actual_price_display?: InputMaybe<Scalars['String']>;
  metadata_boxes?: InputMaybe<Scalars['String']>;
  metadata_dosage?: InputMaybe<Scalars['String']>;
  metadata_dosage_display?: InputMaybe<Scalars['String']>;
  metadata_dosage_popular?: InputMaybe<Scalars['String']>;
  metadata_frequency?: InputMaybe<Scalars['String']>;
  metadata_frequency_actual_price_display?: InputMaybe<Scalars['String']>;
  metadata_frequency_display?: InputMaybe<Scalars['String']>;
  metadata_frequency_popular?: InputMaybe<Scalars['String']>;
  metadata_frequency_price_display?: InputMaybe<Scalars['String']>;
  metadata_frequency_quantity_display?: InputMaybe<Scalars['String']>;
  metadata_frequency_quantity_display_patient?: InputMaybe<Scalars['String']>;
  metadata_frequency_savings_display?: InputMaybe<Scalars['String']>;
  metadata_frequency_strikeout_price_display?: InputMaybe<Scalars['String']>;
  metadata_price_frequency?: InputMaybe<Scalars['String']>;
  metadata_price_quantity?: InputMaybe<Scalars['String']>;
  metadata_price_show?: InputMaybe<Scalars['String']>;
  metadata_quantity?: InputMaybe<Scalars['String']>;
  metadata_quantity_display?: InputMaybe<Scalars['String']>;
  metadata_strength?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  price_frequency?: InputMaybe<Scalars['String']>;
  price_quantity?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  quantity_display?: InputMaybe<Scalars['String']>;
  recurring?: InputMaybe<Scalars['String']>;
  recurring_interval?: InputMaybe<Scalars['String']>;
  recurring_usage_type_is_metered?: InputMaybe<Scalars['String']>;
  test_product_id?: InputMaybe<Scalars['String']>;
  unit_amount?: InputMaybe<Scalars['String']>;
};

export type PriceLocaleModel = {
  __typename?: 'PriceLocaleModel';
  locales?: Maybe<Array<Maybe<KeyValuePriceLocaleModel>>>;
  priceId?: Maybe<Scalars['String']>;
};

export type PriceModel = {
  __typename?: 'PriceModel';
  active?: Maybe<Scalars['Boolean']>;
  billing_scheme?: Maybe<Scalars['JSON']>;
  created?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  livemode?: Maybe<Scalars['Boolean']>;
  lookup_key?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  nickname?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['JSON']>;
  recurring?: Maybe<Scalars['JSON']>;
  tax_behavior?: Maybe<Scalars['JSON']>;
  tiers?: Maybe<Scalars['JSON']>;
  tiers_mode?: Maybe<Scalars['JSON']>;
  transform_quantity?: Maybe<Scalars['JSON']>;
  type?: Maybe<Scalars['JSON']>;
  unit_amount?: Maybe<Scalars['Float']>;
  unit_amount_decimal?: Maybe<Scalars['String']>;
};

export type PriceTextDto = {
  __typename?: 'PriceTextDto';
  actual_price_display?: Maybe<Scalars['String']>;
  dosage?: Maybe<Scalars['String']>;
  dosage_display?: Maybe<Scalars['String']>;
  dosage_popular?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  frequency_actual_price_display?: Maybe<Scalars['String']>;
  frequency_display?: Maybe<Scalars['String']>;
  frequency_popular?: Maybe<Scalars['String']>;
  frequency_price_display?: Maybe<Scalars['String']>;
  frequency_quantity_display?: Maybe<Scalars['String']>;
  frequency_quantity_display_patient?: Maybe<Scalars['String']>;
  frequency_savings_display?: Maybe<Scalars['String']>;
  frequency_strikeout_price_display?: Maybe<Scalars['String']>;
  price_frequency?: Maybe<Scalars['String']>;
  price_quantity?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  quantity_display?: Maybe<Scalars['String']>;
};

export type PricesByProductIdsInput = {
  productIds: Array<Scalars['String']>;
};

export type PricesListModel = {
  __typename?: 'PricesListModel';
  data?: Maybe<Array<Maybe<PriceModel>>>;
};

export type ProcessCartByOtcWalletModel = {
  __typename?: 'ProcessCartByOTCWalletModel';
  cartId: Scalars['String'];
};

export type ProcessCartByOtCwalletInput = {
  locale?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  platform?: InputMaybe<PlatformType>;
};

export type ProductFilterInput = {
  acuitySchedulingAppType?: InputMaybe<Scalars['String']>;
  amountToFreeIncludedPrice?: InputMaybe<Scalars['Float']>;
  country?: InputMaybe<RegionType>;
  emailOnCompleteName?: InputMaybe<Scalars['String']>;
  emailTemplate?: InputMaybe<Scalars['String']>;
  evaluationFormId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  overwriteCalendarHeaderTitleInfo?: InputMaybe<Scalars['String']>;
  overwriteProductSubtitleInfo?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PlatformType>;
  requiresEvaluation?: InputMaybe<Scalars['Boolean']>;
  requiresPrescription?: InputMaybe<Scalars['Boolean']>;
  sysId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProductIngredientDto = {
  __typename?: 'ProductIngredientDto';
  description?: Maybe<Scalars['String']>;
  imageLink?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  strength?: Maybe<Scalars['String']>;
  uniqueName?: Maybe<Scalars['String']>;
};

export type ProductInput = {
  active?: InputMaybe<Scalars['String']>;
  benefits?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  consultation_fee?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  display_price?: InputMaybe<Scalars['String']>;
  display_price_patient?: InputMaybe<Scalars['String']>;
  dosage_variant_body?: InputMaybe<Scalars['String']>;
  dosage_variant_title?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_alternativeDosage?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_alternativeDosageUnit?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_asNeeded?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_dosage?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_dosageUnit?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_duration?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_durationUnit?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_frequency?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_quantity?: InputMaybe<Scalars['String']>;
  dr_dosage_frequency_quantityUnit?: InputMaybe<Scalars['String']>;
  dr_product_name?: InputMaybe<Scalars['String']>;
  effective_in?: InputMaybe<Scalars['String']>;
  evaluation_id_noah?: InputMaybe<Scalars['String']>;
  evaluation_id_zoey?: InputMaybe<Scalars['String']>;
  for?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  frequency_variant_title?: InputMaybe<Scalars['String']>;
  good_to_know?: InputMaybe<Scalars['String']>;
  how_to_take?: InputMaybe<Scalars['String']>;
  how_to_use?: InputMaybe<Scalars['String']>;
  ingredients?: InputMaybe<Array<Scalars['String']>>;
  is_popular?: InputMaybe<Scalars['String']>;
  is_show_on_shop_noah?: InputMaybe<Scalars['String']>;
  is_show_on_shop_zoey?: InputMaybe<Scalars['String']>;
  last_for?: InputMaybe<Scalars['String']>;
  live_product_id?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  metadata_FirstAcuityId?: InputMaybe<Scalars['String']>;
  metadata_FirstIncludedProductId?: InputMaybe<Scalars['String']>;
  metadata_IsPromoted?: InputMaybe<Scalars['String']>;
  metadata_NoahEvalId?: InputMaybe<Scalars['String']>;
  metadata_RequireNewPrescription?: InputMaybe<Scalars['String']>;
  metadata_ReviewAfterNthBox?: InputMaybe<Scalars['String']>;
  metadata_ReviewPeriod?: InputMaybe<Scalars['String']>;
  metadata_SecondAcuityId?: InputMaybe<Scalars['String']>;
  metadata_SecondIncludedProductId?: InputMaybe<Scalars['String']>;
  metadata_ShopProductGroups?: InputMaybe<Scalars['String']>;
  metadata_ShopShowOn?: InputMaybe<Scalars['String']>;
  metadata_SkipUploadNIC?: InputMaybe<Scalars['String']>;
  metadata_ZoeyEvalId?: InputMaybe<Scalars['String']>;
  metadata_benefits?: InputMaybe<Scalars['String']>;
  metadata_billing_cycle_anchor?: InputMaybe<Scalars['String']>;
  metadata_bundle?: InputMaybe<Scalars['String']>;
  metadata_category?: InputMaybe<Scalars['String']>;
  metadata_charge_now?: InputMaybe<Scalars['String']>;
  metadata_display_price?: InputMaybe<Scalars['String']>;
  metadata_display_price_patient?: InputMaybe<Scalars['String']>;
  metadata_dosage_variant_body?: InputMaybe<Scalars['String']>;
  metadata_dosage_variant_title?: InputMaybe<Scalars['String']>;
  metadata_fasting?: InputMaybe<Scalars['String']>;
  metadata_frequency_variant_title?: InputMaybe<Scalars['String']>;
  metadata_good_to_know?: InputMaybe<Scalars['String']>;
  metadata_group?: InputMaybe<Scalars['String']>;
  metadata_how_to_use?: InputMaybe<Scalars['String']>;
  metadata_ignore_on_plan?: InputMaybe<Scalars['String']>;
  metadata_ignore_sync_db?: InputMaybe<Scalars['String']>;
  metadata_isBundleMultipleProduct?: InputMaybe<Scalars['String']>;
  metadata_is_popular?: InputMaybe<Scalars['String']>;
  metadata_need_create_subscription?: InputMaybe<Scalars['String']>;
  metadata_platform?: InputMaybe<Scalars['String']>;
  metadata_popular?: InputMaybe<Scalars['String']>;
  metadata_priceIds?: InputMaybe<Scalars['String']>;
  metadata_product_description?: InputMaybe<Scalars['String']>;
  metadata_product_name?: InputMaybe<Scalars['String']>;
  metadata_product_short_description?: InputMaybe<Scalars['String']>;
  metadata_quantity_per_unit?: InputMaybe<Scalars['String']>;
  metadata_quantity_variant_title?: InputMaybe<Scalars['String']>;
  metadata_requires_prescription?: InputMaybe<Scalars['String']>;
  metadata_sku?: InputMaybe<Scalars['String']>;
  metadata_strength?: InputMaybe<Scalars['String']>;
  metadata_unit?: InputMaybe<Scalars['String']>;
  metadata_unit_patient?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  product_description?: InputMaybe<Scalars['String']>;
  product_instruction_how_to_use?: InputMaybe<Scalars['String']>;
  product_instruction_important_info?: InputMaybe<Scalars['String']>;
  product_instruction_instruction?: InputMaybe<Scalars['String']>;
  product_instruction_life_effect?: InputMaybe<Scalars['String']>;
  product_instruction_manage_side_effect?: InputMaybe<Scalars['String']>;
  product_name?: InputMaybe<Scalars['String']>;
  product_short_description?: InputMaybe<Scalars['String']>;
  quantity_per_unit?: InputMaybe<Scalars['String']>;
  quantity_variant_title?: InputMaybe<Scalars['String']>;
  requires_prescription?: InputMaybe<Scalars['String']>;
  safety_information?: InputMaybe<Array<Scalars['String']>>;
  shipping_fee?: InputMaybe<Scalars['String']>;
  shop_product_group_ids?: InputMaybe<Scalars['String']>;
  side_effects?: InputMaybe<Array<Scalars['String']>>;
  statement_descriptor?: InputMaybe<Scalars['String']>;
  strength?: InputMaybe<Scalars['String']>;
  taken?: InputMaybe<Scalars['String']>;
  test_product_id?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  unit_label?: InputMaybe<Scalars['String']>;
  unit_patient?: InputMaybe<Scalars['String']>;
  usage?: InputMaybe<Array<Scalars['String']>>;
};

export enum ProductInstructionLocaleKeys {
  HowToUse = 'how_to_use',
  ImportantInfo = 'important_info',
  Instruction = 'instruction',
  LifeEffect = 'life_effect',
  ManageSideEffect = 'manage_side_effect'
}

export type ProductInstructionLocalizationDto = {
  __typename?: 'ProductInstructionLocalizationDto';
  language?: Maybe<Language>;
  localeKey?: Maybe<ProductInstructionLocaleKeys>;
  productId?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  translatedText?: Maybe<Scalars['String']>;
};

export type ProductListModel = {
  __typename?: 'ProductListModel';
  products?: Maybe<Array<Maybe<StripeProductModel>>>;
  title?: Maybe<Scalars['String']>;
};

export type ProductLocaleModel = {
  __typename?: 'ProductLocaleModel';
  locales?: Maybe<Array<Maybe<KeyValueProductLocaleModel>>>;
  productId?: Maybe<Scalars['String']>;
};

export type ProductModel = {
  __typename?: 'ProductModel';
  acuitySchedulingAppType?: Maybe<Scalars['String']>;
  amountToFreeIncludedPrice?: Maybe<Scalars['Float']>;
  chargeNowProduct?: Maybe<Array<Maybe<Scalars['String']>>>;
  country?: Maybe<Scalars['String']>;
  crossEvaluation?: Maybe<Scalars['JSON']>;
  displayId?: Maybe<Scalars['String']>;
  emailOnCompleteName?: Maybe<Scalars['String']>;
  emailTemplate?: Maybe<Scalars['String']>;
  evaluationFormId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  includedPriceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  orders?: Maybe<Array<Maybe<OrderModel>>>;
  overwriteCalendarHeaderTitleInfo?: Maybe<Scalars['String']>;
  overwriteProductSubtitleInfo?: Maybe<Scalars['String']>;
  platform?: Maybe<PlatformType>;
  productGroups?: Maybe<Scalars['JSON']>;
  requiresDelivery?: Maybe<Scalars['Boolean']>;
  requiresEvaluation?: Maybe<Scalars['Boolean']>;
  requiresPrescription?: Maybe<Scalars['Boolean']>;
  sysId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export enum ProductNameType {
  Avanafil = 'Avanafil',
  BookingFee = 'BookingFee',
  Bump = 'Bump',
  Champix = 'Champix',
  Cialis5mg = 'Cialis5mg',
  Cialis20mg = 'Cialis20mg',
  ClindoxylGel = 'ClindoxylGel',
  CompleteBloodCountTest = 'CompleteBloodCountTest',
  ConciergeService = 'ConciergeService',
  CovidTeleconsult = 'CovidTeleconsult',
  Dapoxetine = 'Dapoxetine',
  Diane35 = 'Diane35',
  Differin = 'Differin',
  EdBundleFirstTimeTrial = 'EdBundleFirstTimeTrial',
  EdChristmasBundleFirstTimeTrial = 'EdChristmasBundleFirstTimeTrial',
  Ella = 'Ella',
  EmployeeConsult = 'EmployeeConsult',
  EvraPatch = 'EvraPatch',
  FertilityCoach = 'FertilityCoach',
  FertilityHormoneTestKit = 'FertilityHormoneTestKit',
  FinMinox = 'FinMinox',
  Finasteride = 'Finasteride',
  Finasteride1mg = 'Finasteride1mg',
  FourPillBundle = 'FourPillBundle',
  FreshWipes = 'FreshWipes',
  Glp1Gip2MonthsPlan = 'Glp1Gip2MonthsPlan',
  Glp1Gip4MonthsPlan = 'Glp1Gip4MonthsPlan',
  Glp1Gip5mg = 'Glp1Gip5mg',
  Glp1Gip10mg = 'Glp1Gip10mg',
  Glp1Gip15mg = 'Glp1Gip15mg',
  Glp1Gip75mg = 'Glp1Gip75mg',
  Glp1GipMonthlyPlan = 'Glp1GipMonthlyPlan',
  GoodHeadShampoo = 'GoodHeadShampoo',
  Grow = 'Grow',
  GynaeConsult = 'GynaeConsult',
  GynaeConsultHormoneTest = 'GynaeConsultHormoneTest',
  IndividualTherapy = 'IndividualTherapy',
  Kickstart = 'Kickstart',
  Levitra20mg = 'Levitra20mg',
  LuckyBundle = 'LuckyBundle',
  MenSHealthCheckPlus = 'MenSHealthCheckPlus',
  Mercilon = 'Mercilon',
  Microgynon = 'Microgynon',
  Minoxidil2 = 'Minoxidil2',
  Minoxidil5 = 'Minoxidil5',
  Momentum = 'Momentum',
  Mounjaro2MonthsPlan = 'Mounjaro2MonthsPlan',
  Mounjaro4MonthsPlan = 'Mounjaro4MonthsPlan',
  Mounjaro5mg = 'Mounjaro5mg',
  Mounjaro10mg = 'Mounjaro10mg',
  Mounjaro75mg = 'Mounjaro75mg',
  MounjaroAdvance5m = 'MounjaroAdvance5m',
  MounjaroLaunch3m = 'MounjaroLaunch3m',
  MounjaroMomentum4m = 'MounjaroMomentum4m',
  MounjaroPeak6m = 'MounjaroPeak6m',
  MounjaroSustain10mg3m = 'MounjaroSustain10mg3m',
  MounjaroSustain15mg3m = 'MounjaroSustain15mg3m',
  MounjaroSustain125mg3m = 'MounjaroSustain125mg3m',
  NoahXLeloF1sBundle = 'NoahXLeloF1sBundle',
  NutritionistConsult = 'NutritionistConsult',
  OvulationTestKit = 'OvulationTestKit',
  Panbesy = 'Panbesy',
  PersonalMoisturiser = 'PersonalMoisturiser',
  Postinor2 = 'Postinor2',
  PregOBundle = 'PregOBundle',
  PregnancyTestKit = 'PregnancyTestKit',
  Priligy = 'Priligy',
  ProlongSpray = 'ProlongSpray',
  Saxenda = 'Saxenda',
  SexTherapy = 'SexTherapy',
  ShippingFee = 'ShippingFee',
  SilMints = 'SilMints',
  Sildenafil = 'Sildenafil',
  Sildenafil50mg = 'Sildenafil50mg',
  Sildenafil50mgDapoxetine30mg = 'Sildenafil50mgDapoxetine30mg',
  Sildenafil100mgDapoxetine60mg = 'Sildenafil100mgDapoxetine60mg',
  SleepThins = 'SleepThins',
  SmoothHeadConditioner = 'SmoothHeadConditioner',
  Spedra = 'Spedra',
  Supergrowpack = 'Supergrowpack',
  TadMints = 'TadMints',
  Tadalafil5mg = 'Tadalafil5mg',
  Tadalafil20mg = 'Tadalafil20mg',
  Tadalafil20mgDapoxetine30mg = 'Tadalafil20mgDapoxetine30mg',
  Tadalafil20mgDapoxetine60mg = 'Tadalafil20mgDapoxetine60mg',
  TadalafilOralFilm5mg = 'TadalafilOralFilm5mg',
  TadalafilOralFilm20mg = 'TadalafilOralFilm20mg',
  TeleconsultNoEval = 'TeleconsultNoEval',
  Teleconsultation = 'Teleconsultation',
  TheHeadStarter = 'TheHeadStarter',
  TherapyConsultNoEval = 'TherapyConsultNoEval',
  Vardenafil20mg = 'Vardenafil20mg',
  Viagra = 'Viagra',
  Viagra100mg = 'Viagra100mg',
  ViagraThins50mg = 'ViagraThins50mg',
  Victoza = 'Victoza',
  Vigour = 'Vigour',
  WegovySustain17mg = 'WegovySustain17mg',
  WegovySustain24mg = 'WegovySustain24mg',
  WeightResetProgram17 = 'WeightResetProgram17',
  WeightResetProgram24 = 'WeightResetProgram24',
  Yasmin = 'Yasmin',
  Yaz = 'Yaz',
  ZoeyXLeloSona2Bundle = 'ZoeyXLeloSona2Bundle'
}

export type ProductTextDto = {
  __typename?: 'ProductTextDto';
  benefits?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  display_price?: Maybe<Scalars['String']>;
  display_price_patient?: Maybe<Scalars['String']>;
  dosage_variant_body?: Maybe<Scalars['String']>;
  dosage_variant_title?: Maybe<Scalars['String']>;
  effective_in?: Maybe<Scalars['String']>;
  for?: Maybe<Scalars['String']>;
  frequency_variant_title?: Maybe<Scalars['String']>;
  good_to_know?: Maybe<Scalars['String']>;
  how_to_take?: Maybe<Scalars['String']>;
  how_to_use?: Maybe<Scalars['String']>;
  is_popular?: Maybe<Scalars['String']>;
  lasts_for?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  product_description?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  product_short_description?: Maybe<Scalars['String']>;
  quantity_per_unit?: Maybe<Scalars['String']>;
  quantity_variant_title?: Maybe<Scalars['String']>;
  requires_prescription?: Maybe<Scalars['String']>;
  safety_information?: Maybe<Scalars['String']>;
  side_effects?: Maybe<Scalars['String']>;
  strength?: Maybe<Scalars['String']>;
  taken?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  unit_patient?: Maybe<Scalars['String']>;
};

export enum PromotionCodeError {
  NotFound = 'NOT_FOUND',
  NotHaveOtc = 'NOT_HAVE_OTC',
  NotMin = 'NOT_MIN'
}

export type PublicAffiliate = {
  __typename?: 'PublicAffiliate';
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
  portalUrl: Scalars['String'];
  region: RegionType;
  slug: Scalars['String'];
  sysId: Scalars['ID'];
};

export type PublicAffiliateCoupon = {
  __typename?: 'PublicAffiliateCoupon';
  affiliate?: Maybe<PublicAffiliate>;
  affiliateProduct?: Maybe<PublicAffiliateProduct>;
  affiliateProductSysId: Scalars['String'];
  affiliateSysId: Scalars['String'];
  anonymousId: Scalars['String'];
  couponId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  orderSysId?: Maybe<Scalars['String']>;
  status: AffiliateCouponStatus;
  sysId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PublicAffiliateProduct = {
  __typename?: 'PublicAffiliateProduct';
  affiliate?: Maybe<PublicAffiliate>;
  affiliateSysId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /**
   * Percentage discount (1–100), minted as the Stripe coupon's percent_off. After
   * an updateAffiliateProduct change this LOCAL value may diverge from the
   * percentage actually applied at checkout (Stripe percent_off is immutable). The
   * re-mint flow is a future iteration.
   */
  discountPercentage: Scalars['Int'];
  displayName: Scalars['String'];
  enabled: Scalars['Boolean'];
  /** Eval-flow identifier resolved from Stripe product metadata (Stripe-side source of truth). */
  evalFlow?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  stripePriceId: Scalars['String'];
  stripeProductId: Scalars['String'];
  sysId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PublicSignS3Dto = {
  __typename?: 'PublicSignS3Dto';
  ref: Scalars['String'];
  signedRequest: Scalars['String'];
  url: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  affiliate?: Maybe<Affiliate>;
  affiliateCouponStatsForOps: AffiliateCouponOpsStats;
  affiliateCouponsForOps: PaginatedAdminAffiliateCoupons;
  affiliateEligibleStripeProducts: Array<AffiliateEligibleStripeProduct>;
  affiliateProductByAffiliateSlugAndStripePriceId?: Maybe<PublicAffiliateProduct>;
  affiliateProductByStripePriceId?: Maybe<PublicAffiliateProduct>;
  affiliateProducts: Array<AffiliateProduct>;
  affiliates: PaginatedAffiliates;
  authenticate: User;
  bloodDrawConfirmations: Array<BloodDrawConfirmationDto>;
  canEditDeliveryTime: EditDeliveryTimeModel;
  checkProductsExistingOrdersForPatient: Array<Maybe<OrderModel>>;
  checkValidConversationsForDoctor: Array<Scalars['String']>;
  checkValidConversationsForPatient: Array<Scalars['String']>;
  convertReferralPromoCodeValueToCashback: ConvertPromoCodeToCashBackModel;
  countOrderingOfAnEvalProducts: CountOrderingOfAnEvalProductsModel;
  doseStart?: Maybe<DoseStartDto>;
  getActiveProducts: ActiveProductIds;
  getAcuityAppointmentByFilter: Array<AcuityAppointmentModel>;
  getAddressesByFilter: Array<AddressModel>;
  getAllDispatchJobs: Array<DispatchJobModel>;
  getAllEvaluationForms: Array<EvaluationFormModel>;
  getAllPrescriptions: Array<PrescriptionModel>;
  getAuditDoctorNotesByFilter: Array<AuditDoctorNoteModel>;
  getAvailableSlots: BookingListModel;
  getAvailableSlotsForDelivery: BookingListModel;
  getBookingResult: BookingResultModel;
  getByTextConversationId: ConsultationDto;
  getCart: CartCalculationModel;
  getCartById: CartCalculationModel;
  getCartsByFilter: Array<CartModel>;
  getCashbackAvailableBalance: Scalars['Float'];
  getCashbackDashboard: CashbackDashboardModel;
  getCheckoutCartByOrderId?: Maybe<CheckoutCartModel>;
  getCompletedEvalByContinueToken: GuestCompletedEvalModel;
  getCompletedEvalByFilter: Array<GetCompletedEvalByFilterModel>;
  getCompletedEvaluation: Array<CompletedEvaluationModel>;
  getConfigEnvironment: ConfigEnvironmentModel;
  getConsultTextData: TextConsultationSessionModel;
  getConsultationSessionByFilter: ConsultationSessionByFilterModel;
  getConsultationSessionByOrders: Array<ConsultationByOrdersModel>;
  getConsultationVideoByOrderId: ConsultationSessionModel;
  getContinueTrialOrderData: ContinueTrialOrderDataModel;
  getCronjobsByFilter: PaginatedCronjobModel;
  getCurrentPatientOnboarding: PatientOnboardingModel;
  getDeliveryOrderByFilter: PaginatedOrderModel;
  getDispatchJobByFilter: Array<DispatchJobModel>;
  getDoctorDashboardOrdersByFilter: DoctorDashboardOrdersByFilterModel;
  getDoctorInAuth: DoctorModel;
  getDoctorOrders: Array<OrderModel>;
  getDoctorsByFilter: Array<DoctorModel>;
  getDoctorsWithAppointmentType: Array<DoctorModel>;
  getEvaluationByFilter: Array<EvaluationModel>;
  getEvaluationByOrders: Array<GetEvaluationByOrderModel>;
  getEvaluationDashboard: EvaluationDashboardModel;
  getEvaluationFormByFilter: Array<EvaluationFormModel>;
  getExcludedEvalIdsForShowingTreatment: Array<Scalars['String']>;
  getExcludedEvaluationIds: Array<Scalars['String']>;
  getExtraInfoForEditingOrder: ExtraInfoForOrderModel;
  getExtraProductPriceInfoByEvaluation: GetExtraProductPriceByEvaluationModel;
  getGiveAwayByFilter: Array<GiveawayModel>;
  getImagesByFilter: Array<ImageModel>;
  getInvoicesBySubscriptionId: StripeInvoiceListModel;
  getLabelFromDetrack: Scalars['String'];
  getLastTreatmentOrder: LastTreatmentOrder;
  getListOrderConsultationByFilter: PaginatedOrderModel;
  getListPatientSuggestionByDoctor: Array<PatientModel>;
  getOpsConvertedOrders: OpsConvertedOrdersResult;
  getOpsConvertedOrdersUtmSources: Array<Scalars['String']>;
  getOpsDashboardOrderListByFilterV2: OpsPaginatedOrderModel;
  getOpsOrderDetail: OpsOrderDetailModel;
  getOrderByFilter: Array<OrderModel>;
  getOrderById: OrderModel;
  getOrderByIdWithDisplayId: OrderModel;
  getOrderByProduct: Array<OrderModel>;
  getOrderDetailWithPatient: OrderWithPatientModel;
  getPatientBookingInfo: PatientBookingDataModel;
  getPatientByFilter: Array<PatientModel>;
  getPatientById: PatientModel;
  getPatientByIds: Array<PatientModel>;
  getPatientByReferralCode: PatientModel;
  getPatientData: PatientDashboardDataModel;
  getPatientInfo?: Maybe<PatientModel>;
  getPatientListForDoctor: Array<PatientModel>;
  getPatientPlanDetailData: PatientPlanDetailModel;
  getPatientPlansData: PatientPlansDataModel;
  getPatientProfileForPregnancyChecklist: PatientPrenatalModel;
  getPatientPromotionCodes: Array<StripePromotionCodeModel>;
  getPlans: Array<GetPlansModel>;
  getPreblockForGuest?: Maybe<PreblockDto>;
  getPrescriptionByFilter: Array<PrescriptionModel>;
  getPrescriptionById: PrescriptionModel;
  getPrescriptionOrderBookingResult: GetPrescriptionOrderBookingResultModel;
  getPrescriptionOrderCalculation: PrescriptionOrderCalculationModel;
  getPriceByIntentId: StripePriceModel;
  getPriceTranslatedText: Array<PriceLocaleModel>;
  getPricesByProductIds: PricesListModel;
  getProductByFilter: Array<ProductModel>;
  getProductInfo: StripeProductModel;
  getProductTranslatedText: Array<ProductLocaleModel>;
  getReferralCoupon: GetReferralModel;
  getRenewalOrderInfo: RenewOrderInfoModel;
  getShopInfo: ShopDataModel;
  getStripeCouponByFilter: Array<StripeCouponModel>;
  getStripeCouponById: StripeCouponModel;
  getStripePriceById: StripePriceModel;
  getStripeProductByFilter: Array<StripeProductModel>;
  getStripeProductById: StripeProductModel;
  getStripeProductByIds: Array<StripeProductModel>;
  getStripeProductByUniqNames: Array<StripeProductModel>;
  getStripeProductPricesByFilter: Array<StripeProductPriceModel>;
  getStripePromotionCodeById: StripePromotionCodeModel;
  getSubscriptionById: StripeSubscriptionModel;
  getSuggestions: Array<StripeProductModel>;
  getSurveyList: Array<SurveyModel>;
  getTeleConsultOrders: Array<OrderModel>;
  getTestMagicLink: Scalars['String'];
  getTextConversationFromOps: Array<TextConsultationSessionModel>;
  getThankyouData: ThankYouDataModel;
  getTrtAcuityCalendarIds: Array<Scalars['Int']>;
  getTrtDocumentUrl: Scalars['String'];
  getTrtIdentificationUrl?: Maybe<Scalars['String']>;
  getTwilioVideoConsultDataFromDoctor: TwilioVideoConsultModel;
  getTwilioVideoConsultDataFromPatient: TwilioVideoConsultModel;
  getUsersByRole: Array<User>;
  /** Staff only: the estimated score impact of every active action in the published library for one patient, computed from that patient's latest score. Empty before the first score. Not filtered by stage fit or exclusions — eligibility and ranking belong to the served set. */
  hosActionEstimates: Array<HosActionEstimate>;
  /** Staff only: one model call behind a record event. The raw prompt and raw output are withheld (MG-8). */
  hosAiCall?: Maybe<HosAiCall>;
  /** Every served step from the published baseline_questionnaire snapshot (the intake step is left out once the reminder is set in the hub), with saved answers and step 0's pre-fill; stage must be questionnaire. */
  hosBaselineQuestionnaire: HosBaselineQuestionnaire;
  /** Cards for the patient. score_page serves the due check-in asks then the ranked improvement set; hub serves the preset first-injection guide. Each new card is a serve with its own hos_card_serve row and record event. */
  hosCards: HosCardsPage;
  /** Region catalog for dose_change rows: active weight-loss GLP-1 products (C-12). No price amounts; price resolves at serve time. */
  hosCatalogProducts: Array<HosCatalogProduct>;
  /** Open asks, today's dose reminder and the reminder settings, in one read (R35.7, MG-15). */
  hosCheckinInbox: HosCheckinInbox;
  /** Stored text chunks of an approved corpus document, in ordinal order — the curator's verbatim-quote source. */
  hosCorpusDocumentChunks: Array<HosCorpusChunk>;
  /** Documents in this region's corpus store. */
  hosCorpusDocuments: Array<HosCorpusDocument>;
  /** One curator run with its report (admin + the curator service; not cgo). */
  hosCuratorRun?: Maybe<HosCuratorRun>;
  /** Curator run history (admin + the curator service; not cgo). */
  hosCuratorRuns: Array<HosCuratorRun>;
  /** Internal only: the patient's virtual clock, or null when they are on real time. */
  hosHarnessClock?: Maybe<HosHarnessClock>;
  /** Internal only: patients the harness may act as (staging + local). */
  hosHarnessPatients: Array<HosHarnessPatient>;
  /** Resolve a PMID / DOI / PubMed / DOI / PMC URL to corpus metadata, the doc_id it would take, whether it is already in, and the picks the caller must make. */
  hosLookupCorpusDocument: HosCorpusLookup;
  /** The caller as HOS sees it: roles, act-as session and effective patient. Re-checked on every action. */
  hosMe: HosPrincipal;
  /** Delivery attempts, newest first: the folded daily push, the safety lane's per-channel sends, and every hold or suppression with its reason. Internal/admin only. */
  hosNotificationLog: Array<HosNotificationLogEntry>;
  /** One alert for the ops drawer, or null when this region has no such alert. Staff only; PII-masked (MG-8). */
  hosOpsAlert?: Maybe<HosOpsAlert>;
  /** The ops safety queue, newest first. Staff only; PII-masked (MG-8). */
  hosOpsAlerts: Array<HosOpsAlert>;
  /** Staff only: one coarse read of a patient's HealthOS state (R29.5, MG-18). */
  hosPatientOverview: HosPatientOverview;
  /** The reminder settings. Region defaults until the patient sets them (R20, MG-16). */
  hosPatientSchedule: HosPatientSchedule;
  /** Staff only: one record event by id, same shape as the list. */
  hosRecordEvent?: Maybe<HosRecordEvent>;
  /** Staff only: the record, newest first, cursor-paged. Free-text and PII payload fields are served as `[withheld]` (R29.11, MG-8). */
  hosRecordEvents: HosRecordEventPage;
  /** Roles of the caller, so a dashboard can hide what it may not do. */
  hosRegistryMe: HosRegistryPrincipal;
  /** One proposal with diff rows, impact summary and base + proposed snapshots. */
  hosRegistryProposal?: Maybe<HosRegistryProposal>;
  /** Proposal queue. The doctor CGO queue passes filter.clinicalOnly = true. */
  hosRegistryProposals: Array<HosRegistryProposal>;
  /** Sections with their latest version, placeholder count and default approver. */
  hosRegistrySections: Array<HosRegistrySectionSummary>;
  /** One published snapshot. A null version returns the latest. */
  hosRegistrySnapshot?: Maybe<HosRegistrySnapshot>;
  /** Version history for one section and condition, newest first. */
  hosRegistryVersions: Array<HosRegistryVersion>;
  /** Admin/internal: one replay and its result. */
  hosReplay?: Maybe<HosReplay>;
  /** Admin only: every user holding a HealthOS role in this region. */
  hosRoleGrants: Array<HosRoleGrant>;
  /** Orb + breakdown in one read; null before the first compute. Patient; internal act-as. */
  hosScore?: Maybe<HosScore>;
  /** Score history for the breakdown charts; week or month, paging back through the whole history. */
  hosScoreHistory: HosScoreHistory;
  /** One read per app open: gate, eligibility, consent, gate question, education, score. */
  hosShellState: HosShellState;
  /** Staff only: one patient's trigger states (MG-18, R4). A patient never sees a trigger. */
  hosTriggerStates: Array<HosTriggerStateView>;
  /** Validate a complete section payload (schema + coded validators + diff stats) without creating anything (C-6). Writes nothing. */
  hosValidateRegistryPayload: HosRegistryValidationReport;
  logOut: Scalars['Boolean'];
  myBloodPressureReadings: Array<PatientVitalDto>;
  /** @deprecated References dropped acuity_appointment_snapshot column. Use getDoctorOrders instead. */
  oldGetDoctorOrders: Array<OrderModel>;
  parseAffiliateGoogleForm: AffiliateGoogleFormParseResult;
  preblockAvailableDates: Array<PreblockSlotDto>;
  preblockAvailableTimes: Array<PreblockSlotDto>;
  prescriptions: Array<PrescriptionDto>;
  sendEmailForOldOrders: Scalars['Boolean'];
  syncConversationForExistingOrders: Scalars['Boolean'];
  triggerChargeConsultFeeConsumer?: Maybe<Scalars['Boolean']>;
  trtOrders: PaginatedTrtOrders;
  user: User;
  users: Array<User>;
  viewer: ViewerDto;
};


export type QueryAffiliateArgs = {
  sysId: Scalars['String'];
};


export type QueryAffiliateCouponStatsForOpsArgs = {
  affiliateSysId?: InputMaybe<Scalars['String']>;
};


export type QueryAffiliateCouponsForOpsArgs = {
  filter?: InputMaybe<AffiliateCouponsForOpsFilterInput>;
  pagination?: InputMaybe<V2PaginationInput>;
};


export type QueryAffiliateProductByAffiliateSlugAndStripePriceIdArgs = {
  affiliateSlug: Scalars['String'];
  stripePriceId: Scalars['String'];
};


export type QueryAffiliateProductByStripePriceIdArgs = {
  stripePriceId: Scalars['String'];
};


export type QueryAffiliateProductsArgs = {
  affiliateSysId: Scalars['String'];
};


export type QueryAffiliatesArgs = {
  filter?: InputMaybe<AffiliateFilterInput>;
  pagination?: InputMaybe<V2PaginationInput>;
};


export type QueryBloodDrawConfirmationsArgs = {
  orderSysId: Scalars['String'];
};


export type QueryCanEditDeliveryTimeArgs = {
  orderId: Scalars['String'];
};


export type QueryCheckProductsExistingOrdersForPatientArgs = {
  input: AvailableOrdersOfPatientInputs;
};


export type QueryCheckValidConversationsForDoctorArgs = {
  input: CheckValidConversationsForDoctorInput;
};


export type QueryCheckValidConversationsForPatientArgs = {
  input: CheckValidConversationsForPatientInput;
};


export type QueryCountOrderingOfAnEvalProductsArgs = {
  input: CountOrderingOfAnEvalProductsInput;
};


export type QueryDoseStartArgs = {
  orderSysId: Scalars['String'];
};


export type QueryGetAcuityAppointmentByFilterArgs = {
  input: AcuityAppointmentFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetAddressesByFilterArgs = {
  input: AddressInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetAllDispatchJobsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetAllEvaluationFormsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetAllPrescriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetAuditDoctorNotesByFilterArgs = {
  input: AuditDoctorNoteInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetAvailableSlotsArgs = {
  input: AvailableSlotsInput;
};


export type QueryGetAvailableSlotsForDeliveryArgs = {
  input: AvailableSlotsForDeliveryInput;
};


export type QueryGetBookingResultArgs = {
  input: BookingResultInput;
};


export type QueryGetByTextConversationIdArgs = {
  textConversationId: Scalars['String'];
};


export type QueryGetCartArgs = {
  input: GetCartInput;
};


export type QueryGetCartByIdArgs = {
  input: FilterByIdInput;
};


export type QueryGetCartsByFilterArgs = {
  input: FilterInput;
};


export type QueryGetCheckoutCartByOrderIdArgs = {
  orderId: Scalars['String'];
};


export type QueryGetCompletedEvalByContinueTokenArgs = {
  input: FilterByContinueLaterTokenInput;
};


export type QueryGetCompletedEvalByFilterArgs = {
  input: GetCompletedEvalByFilterInput;
};


export type QueryGetConfigEnvironmentArgs = {
  input: PlatformEnvironmentInput;
};


export type QueryGetConsultTextDataArgs = {
  input: GetConsultTextDataInput;
};


export type QueryGetConsultationSessionByFilterArgs = {
  input: GetConsultationByFilterInput;
};


export type QueryGetConsultationSessionByOrdersArgs = {
  input: GetConsultationByOrdersInput;
};


export type QueryGetConsultationVideoByOrderIdArgs = {
  input: GetByOrderSysId;
};


export type QueryGetContinueTrialOrderDataArgs = {
  input: ContinueTrialOrderInput;
};


export type QueryGetCronjobsByFilterArgs = {
  input: GetCronjobInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetCurrentPatientOnboardingArgs = {
  input: GetCurrentPatientOnboardingInput;
};


export type QueryGetDeliveryOrderByFilterArgs = {
  input: DeliveryOrderFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetDispatchJobByFilterArgs = {
  input: DispatchJobFilterInput;
};


export type QueryGetDoctorDashboardOrdersByFilterArgs = {
  input: OrderFilterForDoctorDashboardInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetDoctorOrdersArgs = {
  country?: InputMaybe<Scalars['String']>;
  dateSearch?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  patientIds?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  today?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetDoctorsByFilterArgs = {
  input: FilterDoctorInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetDoctorsWithAppointmentTypeArgs = {
  input: DoctorsWithAppointmentTypeInput;
};


export type QueryGetEvaluationByFilterArgs = {
  input: EvaluationInput;
};


export type QueryGetEvaluationByOrdersArgs = {
  input: GetEvaluationByOrderInput;
};


export type QueryGetEvaluationDashboardArgs = {
  input: GetEvaluationDashboardInput;
};


export type QueryGetEvaluationFormByFilterArgs = {
  input: EvaluationFormInput;
};


export type QueryGetExcludedEvalIdsForShowingTreatmentArgs = {
  input: ExcludedEvalInput;
};


export type QueryGetExcludedEvaluationIdsArgs = {
  input: ExcludedEvaluationIdsInput;
};


export type QueryGetExtraInfoForEditingOrderArgs = {
  input: GetExtraInfoOrderDetailInput;
};


export type QueryGetExtraProductPriceInfoByEvaluationArgs = {
  input: GetExtraProductPriceInfoByEvaluationInput;
};


export type QueryGetGiveAwayByFilterArgs = {
  input: GiveAwayFilterInput;
};


export type QueryGetImagesByFilterArgs = {
  input: ImageInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetInvoicesBySubscriptionIdArgs = {
  subscriptionId: Scalars['String'];
};


export type QueryGetLabelFromDetrackArgs = {
  input: ExportLableInput;
};


export type QueryGetLastTreatmentOrderArgs = {
  input: LastTreatmentOrderInput;
};


export type QueryGetListOrderConsultationByFilterArgs = {
  input: OrderFilterForOpsConsultationsInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetListPatientSuggestionByDoctorArgs = {
  input: DocPatientSuggestionByDoctorInput;
};


export type QueryGetOpsConvertedOrdersArgs = {
  filter: OpsConvertedOrdersFilterInput;
};


export type QueryGetOpsDashboardOrderListByFilterV2Args = {
  input: OrderFilterForOpsDashboardInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetOpsOrderDetailArgs = {
  orderId: Scalars['String'];
};


export type QueryGetOrderByFilterArgs = {
  input: OrderFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type QueryGetOrderByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetOrderByIdWithDisplayIdArgs = {
  id: Scalars['String'];
};


export type QueryGetOrderByProductArgs = {
  input: StripeProductInput;
};


export type QueryGetOrderDetailWithPatientArgs = {
  input: GetOrderWithPatientDetail;
};


export type QueryGetPatientBookingInfoArgs = {
  input: PatientBookingInput;
};


export type QueryGetPatientByFilterArgs = {
  input: PatientFilterInput;
};


export type QueryGetPatientByIdArgs = {
  input: PatientFilterInput;
};


export type QueryGetPatientByIdsArgs = {
  input: PatientFilterByIdsInput;
};


export type QueryGetPatientByReferralCodeArgs = {
  input: PatientByReferralCodeInput;
};


export type QueryGetPatientDataArgs = {
  input: PatientDashboardInput;
};


export type QueryGetPatientListForDoctorArgs = {
  country: Scalars['String'];
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};


export type QueryGetPatientPlanDetailDataArgs = {
  input: PatientPlanDetailInput;
};


export type QueryGetPatientPlansDataArgs = {
  input: PatientPlanInput;
};


export type QueryGetPreblockForGuestArgs = {
  anonymousId: Scalars['String'];
};


export type QueryGetPrescriptionByFilterArgs = {
  input: PrescriptionFilterInput;
};


export type QueryGetPrescriptionByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetPrescriptionOrderBookingResultArgs = {
  input: GetPrescriptionOrderBookingResultInput;
};


export type QueryGetPrescriptionOrderCalculationArgs = {
  input: GetPrescriptionOrderCalculationInput;
};


export type QueryGetPriceByIntentIdArgs = {
  input: GetPriceByIntentIdInput;
};


export type QueryGetPriceTranslatedTextArgs = {
  input: TranslatedTextPriceQueryInput;
};


export type QueryGetPricesByProductIdsArgs = {
  input: PricesByProductIdsInput;
};


export type QueryGetProductByFilterArgs = {
  input: ProductFilterInput;
};


export type QueryGetProductInfoArgs = {
  orderId: Scalars['String'];
};


export type QueryGetProductTranslatedTextArgs = {
  input: TranslatedTextProductQueryInput;
};


export type QueryGetReferralCouponArgs = {
  input: ReferralProgramFilterInput;
};


export type QueryGetRenewalOrderInfoArgs = {
  input: GetRenewalOrderInfoInput;
};


export type QueryGetShopInfoArgs = {
  input: ShopInput;
};


export type QueryGetStripeCouponByFilterArgs = {
  input: StripeCouponFilterInput;
};


export type QueryGetStripeCouponByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetStripePriceByIdArgs = {
  input: StripePriceFilterInput;
};


export type QueryGetStripeProductByFilterArgs = {
  input: StripeProductFilterInput;
};


export type QueryGetStripeProductByIdArgs = {
  input: StripeProductByIdInput;
};


export type QueryGetStripeProductByIdsArgs = {
  input: StripeProductByIdsInput;
};


export type QueryGetStripeProductByUniqNamesArgs = {
  input: StripeProductByUniqNamesInput;
};


export type QueryGetStripeProductPricesByFilterArgs = {
  input: StripeProductPriceFilterInput;
};


export type QueryGetStripePromotionCodeByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSubscriptionByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSuggestionsArgs = {
  input: GetSuggestionsInput;
};


export type QueryGetSurveyListArgs = {
  input: SurveyFilterInput;
};


export type QueryGetTeleConsultOrdersArgs = {
  input: TeleConsultOrderFilterInput;
};


export type QueryGetTestMagicLinkArgs = {
  email: Scalars['String'];
};


export type QueryGetTextConversationFromOpsArgs = {
  input: GetTextConversationFromOpsInput;
};


export type QueryGetThankyouDataArgs = {
  input: GetThankyouDataInput;
};


export type QueryGetTrtDocumentUrlArgs = {
  documentSysId: Scalars['String'];
};


export type QueryGetTrtIdentificationUrlArgs = {
  orderSysId: Scalars['String'];
};


export type QueryGetTwilioVideoConsultDataFromDoctorArgs = {
  input: VideoSessionInput;
};


export type QueryGetTwilioVideoConsultDataFromPatientArgs = {
  input: GetConsultVideoInput;
};


export type QueryGetUsersByRoleArgs = {
  input: GetUsersByRoleInput;
};


export type QueryHosActionEstimatesArgs = {
  patientSysId: Scalars['ID'];
};


export type QueryHosAiCallArgs = {
  id: Scalars['ID'];
};


export type QueryHosCardsArgs = {
  surface?: InputMaybe<HosSurface>;
};


export type QueryHosCatalogProductsArgs = {
  condition: Scalars['String'];
};


export type QueryHosCorpusDocumentChunksArgs = {
  docId: Scalars['String'];
};


export type QueryHosCorpusDocumentsArgs = {
  condition: Scalars['String'];
};


export type QueryHosCuratorRunArgs = {
  id: Scalars['ID'];
};


export type QueryHosCuratorRunsArgs = {
  filter?: InputMaybe<HosCuratorRunFilterInput>;
};


export type QueryHosHarnessClockArgs = {
  patientSysId: Scalars['ID'];
};


export type QueryHosLookupCorpusDocumentArgs = {
  condition?: InputMaybe<Scalars['String']>;
  ref: Scalars['String'];
};


export type QueryHosNotificationLogArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patientSysId?: InputMaybe<Scalars['ID']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryHosOpsAlertArgs = {
  id: Scalars['ID'];
};


export type QueryHosOpsAlertsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Array<HosSafetySeverity>>;
  status?: InputMaybe<Array<HosOpsAlertStatus>>;
};


export type QueryHosPatientOverviewArgs = {
  patientSysId: Scalars['ID'];
};


export type QueryHosRecordEventArgs = {
  id: Scalars['ID'];
};


export type QueryHosRecordEventsArgs = {
  filter?: InputMaybe<HosRecordEventFilterInput>;
};


export type QueryHosRegistryProposalArgs = {
  id: Scalars['ID'];
};


export type QueryHosRegistryProposalsArgs = {
  filter?: InputMaybe<HosRegistryProposalFilterInput>;
};


export type QueryHosRegistrySectionsArgs = {
  condition?: InputMaybe<Scalars['String']>;
};


export type QueryHosRegistrySnapshotArgs = {
  condition: Scalars['String'];
  section: HosRegistrySection;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryHosRegistryVersionsArgs = {
  condition: Scalars['String'];
  section: HosRegistrySection;
};


export type QueryHosReplayArgs = {
  id: Scalars['ID'];
};


export type QueryHosScoreHistoryArgs = {
  range?: InputMaybe<HosScoreHistoryInput>;
};


export type QueryHosTriggerStatesArgs = {
  patientSysId: Scalars['ID'];
};


export type QueryHosValidateRegistryPayloadArgs = {
  companions?: InputMaybe<Array<HosRegistryCompanionPayloadInput>>;
  condition: Scalars['String'];
  rows: Scalars['JSON'];
  schemaVersion?: InputMaybe<Scalars['Int']>;
  section: HosRegistrySection;
};


export type QueryOldGetDoctorOrdersArgs = {
  country?: InputMaybe<Scalars['String']>;
  dateSearch?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  patientIds?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  today?: InputMaybe<Scalars['Boolean']>;
};


export type QueryParseAffiliateGoogleFormArgs = {
  url: Scalars['String'];
};


export type QueryPreblockAvailableDatesArgs = {
  input: PreblockSlotsInput;
};


export type QueryPreblockAvailableTimesArgs = {
  input: PreblockTimesInput;
};


export type QueryPrescriptionsArgs = {
  input: V2PrescriptionFilterInput;
};


export type QueryTriggerChargeConsultFeeConsumerArgs = {
  jobId: Scalars['String'];
};


export type QueryTrtOrdersArgs = {
  filter?: InputMaybe<TrtOrdersFilterInput>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};

export type QuestionAnswerModel = {
  __typename?: 'QuestionAnswerModel';
  answer?: Maybe<AnswerModel>;
  dependentEvaluationQuestions?: Maybe<Array<Maybe<DependentEvaluationQuestionModel>>>;
  evaluationBlocks?: Maybe<Array<Maybe<EvaluationBlockModel>>>;
  patientQuestionAnswers?: Maybe<Array<Maybe<PatientQuestionAnswerModel>>>;
  question?: Maybe<QuestionModel>;
  sysId?: Maybe<Scalars['String']>;
};

export type QuestionDto = {
  __typename?: 'QuestionDto';
  answers?: Maybe<Array<AnswerDto>>;
  content?: Maybe<ContentQuestionDto>;
  dependentEvaluationQuestions?: Maybe<Array<Maybe<DependentQuestionDto>>>;
  displayPage?: Maybe<Scalars['Float']>;
  evaluationBlocks?: Maybe<Array<Maybe<EvaluationBlockDto>>>;
  guestOnly?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Float']>;
  sysId?: Maybe<Scalars['String']>;
  textKey?: Maybe<Scalars['String']>;
  type?: Maybe<QuestionType>;
  validation?: Maybe<ValidationQuestionDto>;
};

export type QuestionModel = {
  __typename?: 'QuestionModel';
  evaluationQuestions?: Maybe<Array<Maybe<EvaluationQuestionModel>>>;
  name: Scalars['String'];
  sysId?: Maybe<Scalars['String']>;
  textKey: Scalars['String'];
  type: QuestionType;
};

export enum QuestionType {
  Date = 'Date',
  Dropdown = 'Dropdown',
  Info = 'Info',
  MultipleSelection = 'MultipleSelection',
  MultipleSelectionWithOthers = 'MultipleSelectionWithOthers',
  MultipleTextBox = 'MultipleTextBox',
  MultipleUpload = 'MultipleUpload',
  Number = 'Number',
  Rating = 'Rating',
  SingleSelection = 'SingleSelection',
  SingleUpload = 'SingleUpload',
  Slider = 'Slider',
  Text = 'Text',
  YesOrNo = 'YesOrNo'
}

export type RxCalculationSummaryDto = {
  __typename?: 'RXCalculationSummaryDTO';
  rxOrdersCalculation?: Maybe<Array<PrescriptionOrderCalculationDto>>;
  total?: Maybe<Scalars['Float']>;
  totalCashbackEarned?: Maybe<Scalars['Float']>;
  totalCashbackRedeemed?: Maybe<Scalars['Float']>;
  totalDiscountAmount?: Maybe<Scalars['Float']>;
  totalMainBasePrice?: Maybe<Scalars['Float']>;
  totalPaymentIntentAmount?: Maybe<Scalars['Float']>;
  totalPaymentIntentAmountAfterCashback?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
  totalTransactionFee?: Maybe<Scalars['Float']>;
};

export type ReAssignTextConsultationDoctorInput = {
  doctorId: Scalars['String'];
  orderId: Scalars['String'];
};

export type ReactivateCanceledOtcOrderInputV2 = {
  orderSysId: Scalars['String'];
  priceId: Scalars['String'];
};

export type ReactivateCanceledOrderInputV2 = {
  orderSysId: Scalars['String'];
};

export type RecommendedProductsDto = {
  __typename?: 'RecommendedProductsDto';
  priceId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type RecordBloodPressureInput = {
  diastolic: Scalars['Int'];
  systolic: Scalars['Int'];
};

export type RecordDoseStartInput = {
  orderSysId: Scalars['String'];
  startedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReferralDto = {
  __typename?: 'ReferralDto';
  doctor?: Maybe<DoctorDto>;
  doctorId?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<UserDocumentDto>>>;
  items?: Maybe<Array<Maybe<ReferralItemDto>>>;
  sysId?: Maybe<Scalars['String']>;
};

export type ReferralItemDto = {
  __typename?: 'ReferralItemDto';
  order?: Maybe<OrderDto>;
  orderId?: Maybe<Scalars['String']>;
  price?: Maybe<StripePriceDto>;
  priceId?: Maybe<Scalars['String']>;
  referralSysId?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
};

export type ReferralProgram = {
  __typename?: 'ReferralProgram';
  referreeCouponCode?: Maybe<Scalars['String']>;
  referrerCouponCode?: Maybe<Scalars['String']>;
};

export type ReferralProgramFilterInput = {
  code?: InputMaybe<Scalars['String']>;
};

export type RefreshAccessTokenInput = {
  accessToken: Scalars['String'];
  accessTokenExpiredAt: Scalars['Float'];
  refreshToken: Scalars['String'];
  userId: Scalars['String'];
};

export type RefundOtcWalletOrderInput = {
  orderId: Scalars['String'];
  paymentIntentId: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};

export type RefundOtcWalletPayOrderModel = {
  __typename?: 'RefundOTCWalletPayOrderModel';
  success: Scalars['Boolean'];
};

export type RefundPaymentIntentForAnonymousModel = {
  __typename?: 'RefundPaymentIntentForAnonymousModel';
  success: Scalars['Boolean'];
};

export type RegionAreaDto = {
  __typename?: 'RegionAreaDto';
  areaChildren?: Maybe<Array<Maybe<RegionAreaDto>>>;
  areaName?: Maybe<Scalars['String']>;
  areaParent?: Maybe<RegionAreaDto>;
  areaType?: Maybe<RegionAreaType>;
  pickupLocations?: Maybe<Array<Maybe<PickupLocationDto>>>;
  sysId?: Maybe<Scalars['String']>;
};

export enum RegionAreaType {
  Area = 'Area',
  District = 'District'
}

export enum RegionType {
  Hk = 'hk',
  Jp = 'jp',
  Sg = 'sg'
}

export type RegisterDoctorInput = {
  calendarId: Scalars['Float'];
  country?: InputMaybe<RegionType>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type RegisterInfoInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locale: Scalars['String'];
  password: Scalars['String'];
  patientSysId?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  platform?: InputMaybe<PlatformType>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
};

export type RegisterPatientInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  anonymousPatientId?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<AddressInput>;
  bloodPressure?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<RegionType>;
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fbc?: InputMaybe<Scalars['String']>;
  fbp?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fromPlatformEnv?: InputMaybe<PlatformType>;
  height?: InputMaybe<Scalars['Float']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  partnerCode?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  provider?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  registerAt?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<AddressInput>;
  socialProviderType?: InputMaybe<SocialProviderTypes>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  user?: InputMaybe<Scalars['JSON']>;
  utm?: InputMaybe<UtmTypeInput>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type RegisterUserSessionInput = {
  appVersion: Scalars['String'];
  clientType: ClientType;
  deviceId: Scalars['String'];
  deviceNotificationToken: Scalars['String'];
  language: Language;
};

export type RejectOrderInput = {
  endTime: Scalars['String'];
  orderId: Scalars['String'];
  startTime: Scalars['String'];
};

export type ReleasePreblockInput = {
  anonymousId: Scalars['String'];
  preblockId: Scalars['ID'];
};

export type RenewAtomePaymentLinkInput = {
  oldReferenceId: Scalars['String'];
  summary: Scalars['JSON'];
};

export type RenewMultipleOrdersResponse = {
  __typename?: 'RenewMultipleOrdersResponse';
  results: Array<RenewOrderResponse>;
};

export type RenewOrderByOpsInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  patientId: Scalars['String'];
  selectedPriceId: Scalars['String'];
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type RenewOrderByPatientInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type RenewOrderInfoModel = {
  __typename?: 'RenewOrderInfoModel';
  last4: Scalars['String'];
  paymentMethodId: Scalars['String'];
  upcomingAmount: Scalars['Float'];
};

export type RenewOrderResponse = {
  __typename?: 'RenewOrderResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess?: Maybe<Scalars['Boolean']>;
  order?: Maybe<OrderDto>;
  orderId?: Maybe<Scalars['String']>;
};

export type RequestFollowUpConsultInput = {
  orderId: Scalars['String'];
};

export type RequestMagicLinkInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fromPlatformEnv: PlatformType;
  /** Optional post-login path to redirect the user. Relative path only (e.g., '/account'), not a full URL. */
  redirectUrl?: InputMaybe<Scalars['String']>;
};

export type RequestUpgradeSettingsLinkInput = {
  bypassToken: Scalars['String'];
  groupId?: InputMaybe<Scalars['String']>;
  toFreq?: InputMaybe<Scalars['String']>;
};

export type RescheduleAppointmentInput = {
  appointmentTypeId: Scalars['Float'];
  calendarID?: InputMaybe<Scalars['Float']>;
  datetime: Scalars['String'];
  id: Scalars['Float'];
  orderSysId: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
};

export type ResetPasswordUserInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type ResetPasswordWithTokenInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export enum RetentionPromoStatus {
  Eligible = 'eligible',
  Expired = 'expired',
  Redeemed = 'redeemed',
  Revoked = 'revoked'
}

export type RetentionPromoTagDto = {
  __typename?: 'RetentionPromoTagDto';
  code: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  giftDescription?: Maybe<Scalars['String']>;
  redeemedAt?: Maybe<Scalars['DateTime']>;
  region: Scalars['String'];
  status: RetentionPromoStatus;
  sysId: Scalars['String'];
};

export type SaveTranslationInput = {
  remark?: InputMaybe<Scalars['String']>;
  translationKey: Scalars['String'];
  valueEn?: InputMaybe<Scalars['String']>;
  valueJa?: InputMaybe<Scalars['String']>;
  valueZh?: InputMaybe<Scalars['String']>;
};

export type SendEmailAboutNewMessageInput = {
  patientSysId: Scalars['String'];
  textConversationId: Scalars['String'];
};

export type SendReminderUnreadDrMessageInput = {
  patientSysId: Scalars['String'];
  textConversationId: Scalars['String'];
};

export type SendShipmentSmsInput = {
  message: Scalars['String'];
  sysIds: Array<Scalars['String']>;
};

export type SendToDetrackInput = {
  collectionDate: Scalars['String'];
  deliveryConfig: DeliveryConfigInput;
  from: Scalars['String'];
  message: Scalars['String'];
  orderSysId: Scalars['String'];
  shortId: Scalars['Float'];
  to: Scalars['String'];
};

export type SetTrtOrderStatusInput = {
  orderSysId: Scalars['String'];
  status: OrderStatus;
};

export type ShopDataModel = {
  __typename?: 'ShopDataModel';
  activeProductIds: ActiveProductIds;
  acuityAppointments: Array<AcuityAppointmentModel>;
  cartData: CartCalculationModel;
  excludedEvalIds: Array<Scalars['String']>;
  teleConsultOrders: Array<OrderModel>;
};

export type ShopInput = {
  active: Scalars['Boolean'];
  appointmentTypeID?: InputMaybe<Scalars['String']>;
  patientSysId: Scalars['String'];
  platform?: InputMaybe<PlatformType>;
};

export type ShopProductFilterInputV2 = {
  classifications?: InputMaybe<Array<Scalars['String']>>;
  evalIds?: InputMaybe<Array<EvalIds>>;
  format?: InputMaybe<Array<Scalars['String']>>;
  usages?: InputMaybe<Array<Scalars['String']>>;
};

export enum ShopProductGroupIds {
  AcneFreeSkin = 'AcneFreeSkin',
  BirthControl = 'BirthControl',
  BloodTest = 'BloodTest',
  BoostTestosterone = 'BoostTestosterone',
  CovidConsultation = 'CovidConsultation',
  EmergencyContraceptive = 'EmergencyContraceptive',
  EnhancePleasure = 'EnhancePleasure',
  GetHarder = 'GetHarder',
  IndividualTherapy = 'IndividualTherapy',
  LastLonger = 'LastLonger',
  LiverSupport = 'LiverSupport',
  ManageYourWeight = 'ManageYourWeight',
  MenHealthCheck = 'MenHealthCheck',
  Menopause = 'Menopause',
  PostPartum = 'PostPartum',
  Pregnancy = 'Pregnancy',
  RegrowYourHair = 'RegrowYourHair',
  SoundSleep = 'SoundSleep',
  Testosterone = 'Testosterone',
  TryingToConceive = 'TryingToConceive',
  UnderstandYourNutrition = 'UnderstandYourNutrition',
  UnlockIntimacy = 'UnlockIntimacy'
}

export type ShopProductSortInputV2 = {
  sortBy?: InputMaybe<ShopProductSortValue>;
  sortValue?: InputMaybe<Scalars['String']>;
};

export enum ShopProductSortValue {
  BestSelling = 'best_selling',
  Newest = 'newest',
  PriceHighToLow = 'price_high_to_low',
  PriceLowToHigh = 'price_low_to_high'
}

export type ShopProducts = {
  __typename?: 'ShopProducts';
  count: Scalars['Int'];
  items?: Maybe<Array<StripeProductDto>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type SignInUserModel = {
  __typename?: 'SignInUserModel';
  accessToken?: Maybe<Scalars['String']>;
  accessTokenExpiredAt?: Maybe<Scalars['Float']>;
  refreshToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type SignInWithMagicLinkInput = {
  token: Scalars['String'];
};

export type SignS3Dto = {
  __typename?: 'SignS3Dto';
  identityFields?: Maybe<Array<IdentityDocumentField>>;
  ref: Scalars['String'];
  signedRequest?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type SignS3Input = {
  filetype?: InputMaybe<Scalars['String']>;
  ref: Scalars['String'];
};

export type SignS3Model = {
  __typename?: 'SignS3Model';
  ref: Scalars['String'];
  signedRequest: Scalars['String'];
  url: Scalars['String'];
};

export type SignupAnonymousPatientInput = {
  country?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  fromPlatformEnv?: InputMaybe<PlatformType>;
  fullname: Scalars['String'];
  lastName: Scalars['String'];
};

export type SkipSurveyForCartInput = {
  skippedCarts?: InputMaybe<Array<Scalars['String']>>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type SmartMatchDto = {
  __typename?: 'SmartMatchDto';
  evalId: EvalIds;
  smartMatchResults: SmartMatchResult;
  status: SmartMatchStatus;
  sysId: Scalars['String'];
  userId: Scalars['String'];
  userType: UserType;
};

export type SmartMatchMetaDto = {
  __typename?: 'SmartMatchMetaDto';
  evalId: EvalIds;
  status: SmartMatchStatus;
  sysId: Scalars['String'];
  userId: Scalars['String'];
  userType: UserType;
};

export type SmartMatchResponse = {
  __typename?: 'SmartMatchResponse';
  response?: Maybe<Scalars['JSON']>;
};

export type SmartMatchResult = {
  __typename?: 'SmartMatchResult';
  analysis: Array<Scalars['String']>;
  nextSteps: Array<NextSteps>;
  primaryProduct?: Maybe<StripeProductDto>;
  secondaryProducts?: Maybe<Array<StripeProductDto>>;
};

export enum SmartMatchStatus {
  Error = 'error',
  Loading = 'loading',
  Success = 'success'
}

export enum SocialProviderTypes {
  Apple = 'apple',
  Facebook = 'facebook',
  Google = 'google',
  Line = 'line',
  Twitter = 'twitter',
  Yahoo = 'yahoo'
}

export type SplitShipmentInput = {
  deliveryTimestamp: Scalars['Float'];
  items?: InputMaybe<Array<SplitShipmentItemInput>>;
  sysId: Scalars['String'];
};

export type SplitShipmentItemInput = {
  qty: Scalars['Float'];
  sysId: Scalars['String'];
};

export type StripeCardDto = {
  __typename?: 'StripeCardDto';
  brand?: Maybe<Scalars['String']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  last4?: Maybe<Scalars['String']>;
};

export type StripeCouponFilterInput = {
  amountOff?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
  durationInMonths?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  percentOff?: InputMaybe<Scalars['Float']>;
};

export type StripeCouponModel = {
  __typename?: 'StripeCouponModel';
  amount_off?: Maybe<Scalars['Float']>;
  applies_to?: Maybe<Scalars['JSON']>;
  created?: Maybe<Scalars['Float']>;
  currency?: Maybe<StripeCurrency>;
  duration?: Maybe<CouponDuration>;
  duration_in_months?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  livemode?: Maybe<Scalars['Boolean']>;
  max_redemptions?: Maybe<Scalars['Float']>;
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  object: Scalars['JSON'];
  percent_off?: Maybe<Scalars['Float']>;
  promotionCodes?: Maybe<Array<Maybe<StripePromotionCodeModel>>>;
  redeem_by?: Maybe<Scalars['Float']>;
  times_redeemed?: Maybe<Scalars['Float']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export enum StripeCurrency {
  Hkd = 'hkd',
  Jpy = 'jpy',
  Sgd = 'sgd'
}

export type StripeDiscountItem = {
  __typename?: 'StripeDiscountItem';
  amount?: Maybe<Scalars['Float']>;
};

export type StripeInvoiceDto = {
  __typename?: 'StripeInvoiceDto';
  amount_due?: Maybe<Scalars['Float']>;
  hosted_invoice_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lines?: Maybe<StripeInvoiceLineDto>;
  next_payment_attempt?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Boolean']>;
  paymentStatus?: Maybe<PaymentStatus>;
  period_end?: Maybe<Scalars['Float']>;
  starting_balance?: Maybe<Scalars['Float']>;
  status?: Maybe<InvoiceStatus>;
  subtotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  total_discount_amounts?: Maybe<Array<StripeDiscountItem>>;
};

export type StripeInvoiceLineDto = {
  __typename?: 'StripeInvoiceLineDto';
  data?: Maybe<Array<Maybe<StripeInvoiceLineItemDto>>>;
};

export type StripeInvoiceLineItemDto = {
  __typename?: 'StripeInvoiceLineItemDto';
  amount?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['String']>;
  plan?: Maybe<StripePlanDto>;
};

export type StripeInvoiceListModel = {
  __typename?: 'StripeInvoiceListModel';
  data?: Maybe<Array<Maybe<StripeInvoiceModel>>>;
  has_more?: Maybe<Scalars['Boolean']>;
  lastResponse?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
};

export type StripeInvoiceModel = {
  __typename?: 'StripeInvoiceModel';
  auto_advance?: Maybe<Scalars['Boolean']>;
  charge?: Maybe<Scalars['String']>;
  collection_method?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  hosted_invoice_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lines?: Maybe<Scalars['JSON']>;
  metadata?: Maybe<Scalars['JSON']>;
  next_payment_attempt?: Maybe<Scalars['Float']>;
  payment_intent?: Maybe<Scalars['String']>;
  period_end?: Maybe<Scalars['Float']>;
  period_start?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type StripePaymentMethodDto = {
  __typename?: 'StripePaymentMethodDto';
  card?: Maybe<StripeCardDto>;
  id?: Maybe<Scalars['String']>;
};

export type StripePlanDto = {
  __typename?: 'StripePlanDto';
  active?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
};

export enum StripePriceBillingScheme {
  PerUnit = 'per_unit',
  Tiered = 'tiered'
}

export type StripePriceDto = {
  __typename?: 'StripePriceDto';
  active?: Maybe<Scalars['Boolean']>;
  alternativePrice?: Maybe<StripePriceDto>;
  billing_scheme?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['String']>;
  firstTimeAlternativePrice?: Maybe<Scalars['String']>;
  firstTimeTryingInMonths?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  importPriceId?: Maybe<Scalars['String']>;
  isBundle?: Maybe<Scalars['Boolean']>;
  livemode?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['JSON']>;
  metadata?: Maybe<StripePriceMetadataDto>;
  nickname?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productInfo?: Maybe<StripeProductDto>;
  shopDisplay?: Maybe<Scalars['Boolean']>;
  sysId?: Maybe<Scalars['String']>;
  tax_behavior?: Maybe<Scalars['String']>;
  texts?: Maybe<PriceTextDto>;
  type?: Maybe<StripePriceType>;
  unit_amount?: Maybe<Scalars['Float']>;
  unit_amount_decimal?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripePriceFilterInput = {
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Language>;
};

export enum StripePriceLocaleKeys {
  ActualPriceDisplay = 'actual_price_display',
  Dosage = 'dosage',
  DosageDisplay = 'dosage_display',
  DosagePopular = 'dosage_popular',
  Frequency = 'frequency',
  FrequencyActualPriceDisplay = 'frequency_actual_price_display',
  FrequencyDisplay = 'frequency_display',
  FrequencyPopular = 'frequency_popular',
  FrequencyPriceDisplay = 'frequency_price_display',
  FrequencyQuantityDisplay = 'frequency_quantity_display',
  FrequencyQuantityDisplayPatient = 'frequency_quantity_display_patient',
  FrequencySavingsDisplay = 'frequency_savings_display',
  FrequencyStrikeoutPriceDisplay = 'frequency_strikeout_price_display',
  PriceFrequency = 'price_frequency',
  PriceQuantity = 'price_quantity',
  Quantity = 'quantity',
  QuantityDisplay = 'quantity_display'
}

export type StripePriceMetadataDto = {
  __typename?: 'StripePriceMetadataDto';
  actual_price_display?: Maybe<Scalars['String']>;
  boxes?: Maybe<Scalars['String']>;
  dosage?: Maybe<Scalars['String']>;
  dosage_display?: Maybe<Scalars['String']>;
  dosage_popular?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  frequency_actual_price_display?: Maybe<Scalars['String']>;
  frequency_display?: Maybe<Scalars['String']>;
  frequency_popular?: Maybe<Scalars['String']>;
  frequency_price_display?: Maybe<Scalars['String']>;
  frequency_quantity_display?: Maybe<Scalars['String']>;
  frequency_quantity_display_patient?: Maybe<Scalars['String']>;
  frequency_savings_display?: Maybe<Scalars['String']>;
  frequency_strikeout_price_display?: Maybe<Scalars['String']>;
  isArchived?: Maybe<Scalars['String']>;
  isOneTimePrice?: Maybe<Scalars['String']>;
  price_frequency?: Maybe<Scalars['String']>;
  price_quantity?: Maybe<Scalars['String']>;
  price_show?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['String']>;
  quantity_display?: Maybe<Scalars['String']>;
  strength?: Maybe<Scalars['String']>;
};

export type StripePriceModel = {
  __typename?: 'StripePriceModel';
  active?: Maybe<Scalars['Boolean']>;
  billing_scheme?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  livemode?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['JSON']>;
  metadata?: Maybe<Scalars['JSON']>;
  nickname?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  recurring?: Maybe<StripePriceRecurringModel>;
  stripeProduct?: Maybe<Scalars['JSON']>;
  sysId?: Maybe<Scalars['String']>;
  tax_behavior?: Maybe<Scalars['String']>;
  type?: Maybe<StripePriceType>;
  unit_amount?: Maybe<Scalars['Float']>;
  unit_amount_decimal?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum StripePriceRecurringAggregateUsage {
  LastDuringPeriod = 'last_during_period',
  LastEver = 'last_ever',
  Max = 'max',
  Sum = 'sum'
}

export type StripePriceRecurringInput = {
  aggregate_usage?: InputMaybe<StripePriceRecurringAggregateUsage>;
  interval?: InputMaybe<StripePriceRecurringInterval>;
  interval_count?: InputMaybe<Scalars['Float']>;
  trial_period_days?: InputMaybe<Scalars['Float']>;
  usage_type?: InputMaybe<StripePriceRecurringUsageType>;
};

export enum StripePriceRecurringInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type StripePriceRecurringModel = {
  __typename?: 'StripePriceRecurringModel';
  aggregate_usage?: Maybe<StripePriceRecurringAggregateUsage>;
  interval?: Maybe<StripePriceRecurringInterval>;
  interval_count?: Maybe<Scalars['Float']>;
  trial_period_days?: Maybe<Scalars['Float']>;
  usage_type?: Maybe<StripePriceRecurringUsageType>;
};

export enum StripePriceRecurringUsageType {
  Licensed = 'licensed',
  Metered = 'metered'
}

export enum StripePriceType {
  OneTime = 'one_time',
  Recurring = 'recurring'
}

export type StripeProductByIdInput = {
  id: Scalars['String'];
  language?: InputMaybe<Language>;
};

export type StripeProductByIdsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type StripeProductByUniqNamesInput = {
  uniqNames?: InputMaybe<Array<Scalars['String']>>;
};

export type StripeProductDto = {
  __typename?: 'StripeProductDto';
  active?: Maybe<Scalars['Boolean']>;
  country?: Maybe<RegionType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['String']>;
  drDosageFrequency?: Maybe<DrDosageFrequencyDto>;
  evaluationId?: Maybe<Scalars['JSON']>;
  format?: Maybe<Scalars['String']>;
  hasOneDosage?: Maybe<Scalars['Boolean']>;
  hasOneFrequency?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageDto>;
  includedProduct?: Maybe<StripeProductDto>;
  ingredientDetails?: Maybe<Array<ProductIngredientDto>>;
  ingredients?: Maybe<Array<Scalars['String']>>;
  isConsultOnly?: Maybe<Scalars['Boolean']>;
  isPopular?: Maybe<Scalars['Boolean']>;
  isRxOneTime?: Maybe<Scalars['Boolean']>;
  isShowOnShop?: Maybe<Scalars['JSON']>;
  isSkipMedProduct?: Maybe<Scalars['Boolean']>;
  livemode?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  popularPriceId?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<StripePriceDto>>;
  productInstructions?: Maybe<Array<Maybe<ProductInstructionLocalizationDto>>>;
  shopProductGroupIds?: Maybe<Scalars['JSON']>;
  shouldChargeNow?: Maybe<Scalars['Boolean']>;
  statementDescriptor?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  tempPrices?: Maybe<Array<StripePriceDto>>;
  texts?: Maybe<ProductTextDto>;
  type?: Maybe<Scalars['String']>;
  uniqName?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usage?: Maybe<Array<Scalars['String']>>;
};


export type StripeProductDtoIsConsultOnlyArgs = {
  platform?: InputMaybe<Scalars['String']>;
};

export type StripeProductEvaluationIdModel = {
  __typename?: 'StripeProductEvaluationIdModel';
  noah?: Maybe<Array<Scalars['String']>>;
  zoey?: Maybe<Array<Scalars['String']>>;
};

export type StripeProductFilterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<RegionType>;
  description?: InputMaybe<Scalars['String']>;
  displayId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  livemode?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  productNameType?: InputMaybe<ProductNameType>;
  productNameTypes?: InputMaybe<Array<ProductNameType>>;
  type?: InputMaybe<Scalars['String']>;
  uniqName?: InputMaybe<Scalars['String']>;
};

export type StripeProductFilterV2 = {
  evaluationId?: InputMaybe<EvalIds>;
  id?: InputMaybe<Scalars['String']>;
};

export type StripeProductFilterV2Input = {
  filter?: InputMaybe<Array<InputMaybe<V2StripeProductPriceFilterInput>>>;
};

export type StripeProductInput = {
  productNames: Array<ProductNameType>;
};

export type StripeProductIsShowOnShopModel = {
  __typename?: 'StripeProductIsShowOnShopModel';
  noah?: Maybe<Scalars['Boolean']>;
  zoey?: Maybe<Scalars['Boolean']>;
};

export enum StripeProductLocaleKeys {
  Benefits = 'benefits',
  Category = 'category',
  DisplayPrice = 'display_price',
  DisplayPricePatient = 'display_price_patient',
  DosageVariantBody = 'dosage_variant_body',
  DosageVariantTitle = 'dosage_variant_title',
  DrProductName = 'dr_product_name',
  EffectiveIn = 'effective_in',
  For = 'for',
  FrequencyVariantTitle = 'frequency_variant_title',
  GoodToKnow = 'good_to_know',
  HowToTake = 'how_to_take',
  HowToUse = 'how_to_use',
  IsPopular = 'is_popular',
  LastsFor = 'lasts_for',
  Platform = 'platform',
  Precaution = 'precaution',
  ProductDescription = 'product_description',
  ProductName = 'product_name',
  ProductShortDescription = 'product_short_description',
  QuantityPerUnit = 'quantity_per_unit',
  QuantityVariantTitle = 'quantity_variant_title',
  RequiresPrescription = 'requires_prescription',
  SafetyInformation = 'safety_information',
  SideEffects = 'side_effects',
  Strength = 'strength',
  Taken = 'taken',
  Unit = 'unit',
  UnitPatient = 'unit_patient'
}

export type StripeProductModel = {
  __typename?: 'StripeProductModel';
  active?: Maybe<Scalars['Boolean']>;
  childrenIncludedProduct?: Maybe<Array<Maybe<StripeProductModel>>>;
  childrenSecondIncludedProduct?: Maybe<Array<Maybe<StripeProductModel>>>;
  country?: Maybe<RegionType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayId?: Maybe<Scalars['String']>;
  evaluationId?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageModel>;
  includedProduct?: Maybe<StripeProductModel>;
  isShowOnShop?: Maybe<Scalars['JSON']>;
  livemode?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['JSON']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  prices?: Maybe<Scalars['JSON']>;
  secondIncludedProduct?: Maybe<StripeProductModel>;
  shopProductGroupIds?: Maybe<Array<ShopProductGroupIds>>;
  statementDescriptor?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uniqName?: Maybe<Scalars['String']>;
  unitLabel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StripeProductPriceDto = {
  __typename?: 'StripeProductPriceDto';
  importPriceId?: Maybe<Scalars['String']>;
  isBundle?: Maybe<Scalars['Boolean']>;
  priceActive?: Maybe<Scalars['String']>;
  priceBillingScheme?: Maybe<Scalars['String']>;
  priceCreated?: Maybe<Scalars['Float']>;
  priceCurrency?: Maybe<Scalars['String']>;
  priceDisplayId?: Maybe<Scalars['String']>;
  priceFirstTimeAlternativePrice?: Maybe<Scalars['String']>;
  priceFirstTimeTryingInMonths?: Maybe<Scalars['Int']>;
  priceId?: Maybe<Scalars['String']>;
  priceLivemode?: Maybe<Scalars['Boolean']>;
  priceNickname?: Maybe<Scalars['String']>;
  priceProduct?: Maybe<Scalars['String']>;
  priceTaxBehavior?: Maybe<Scalars['String']>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  priceUnitAmountDecimal?: Maybe<Scalars['String']>;
  productActive?: Maybe<Scalars['Boolean']>;
  productDescription?: Maybe<Scalars['String']>;
  productDisplayId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productLivemode?: Maybe<Scalars['Boolean']>;
  productName?: Maybe<Scalars['String']>;
  productStatementDescriptor?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  productUniqName?: Maybe<Scalars['String']>;
  productUnitLabel?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
};

export type StripeProductPriceFilterInput = {
  priceActive?: InputMaybe<Scalars['Boolean']>;
  priceDisplayId?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
  priceLivemode?: InputMaybe<Scalars['Boolean']>;
  priceType?: InputMaybe<StripePriceType>;
  productActive?: InputMaybe<Scalars['Boolean']>;
  productDisplayId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  productLivemode?: InputMaybe<Scalars['Boolean']>;
  productName?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  productUniqName?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type StripeProductPriceModel = {
  __typename?: 'StripeProductPriceModel';
  drDosageFrequency?: Maybe<DrDosageFrequencyDto>;
  importPriceId?: Maybe<Scalars['String']>;
  priceActive?: Maybe<Scalars['String']>;
  priceBillingScheme?: Maybe<Scalars['String']>;
  priceCreated?: Maybe<Scalars['Float']>;
  priceCurrency?: Maybe<Scalars['String']>;
  priceDisplayId?: Maybe<Scalars['String']>;
  priceFirstTimeAlternativePrice?: Maybe<Scalars['String']>;
  priceFirstTimeTryingInMonths?: Maybe<Scalars['Int']>;
  priceId?: Maybe<Scalars['String']>;
  priceLivemode?: Maybe<Scalars['Boolean']>;
  priceMetadata?: Maybe<Scalars['JSON']>;
  priceNickname?: Maybe<Scalars['String']>;
  priceProduct?: Maybe<Scalars['String']>;
  priceRecurring?: Maybe<Scalars['JSON']>;
  priceTaxBehavior?: Maybe<Scalars['String']>;
  priceType?: Maybe<StripePriceType>;
  priceUnitAmount?: Maybe<Scalars['Float']>;
  priceUnitAmountDecimal?: Maybe<Scalars['String']>;
  productActive?: Maybe<Scalars['Boolean']>;
  productCountry?: Maybe<Scalars['String']>;
  productDescription?: Maybe<Scalars['String']>;
  productDisplayId?: Maybe<Scalars['String']>;
  productEvaluationId?: Maybe<StripeProductEvaluationIdModel>;
  productId?: Maybe<Scalars['String']>;
  productImage?: Maybe<Scalars['JSON']>;
  productIncluded?: Maybe<Scalars['JSON']>;
  productIsShowOnShop?: Maybe<StripeProductIsShowOnShopModel>;
  productLivemode?: Maybe<Scalars['Boolean']>;
  productMetadata?: Maybe<Scalars['JSON']>;
  productName?: Maybe<Scalars['String']>;
  productPurchaseds?: Maybe<Scalars['JSON']>;
  productSecondIncluded?: Maybe<Scalars['JSON']>;
  productStatementDescriptor?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  productUniqName?: Maybe<Scalars['String']>;
  productUnitLabel?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
};

export type StripePromotionCodeModel = {
  __typename?: 'StripePromotionCodeModel';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  coupon?: Maybe<StripeCouponModel>;
  created: Scalars['Float'];
  customer?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  livemode: Scalars['Boolean'];
  max_redemptions?: Maybe<Scalars['Float']>;
  metadata?: Maybe<Scalars['JSON']>;
  object: Scalars['JSON'];
  restrictions?: Maybe<Scalars['JSON']>;
  times_redeemed?: Maybe<Scalars['Float']>;
};

export type StripeSubscriptionDto = {
  __typename?: 'StripeSubscriptionDto';
  cancel_at_period_end?: Maybe<Scalars['Boolean']>;
  current_period_end?: Maybe<Scalars['Float']>;
  current_period_start?: Maybe<Scalars['Float']>;
  default_payment_method?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  items?: Maybe<Scalars['JSON']>;
  latestInvoice?: Maybe<StripeInvoiceDto>;
  latest_invoice?: Maybe<Scalars['JSON']>;
  metadata?: Maybe<Scalars['JSON']>;
  pause_collection?: Maybe<Scalars['JSON']>;
  pending_setup_intent?: Maybe<Scalars['JSON']>;
  pending_update?: Maybe<Scalars['JSON']>;
  status?: Maybe<StripeSubscriptionStatus>;
};

export type StripeSubscriptionModel = {
  __typename?: 'StripeSubscriptionModel';
  cancel_at_period_end?: Maybe<Scalars['Boolean']>;
  current_period_end?: Maybe<Scalars['Float']>;
  current_period_start?: Maybe<Scalars['Float']>;
  customer?: Maybe<Scalars['String']>;
  default_payment_method?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  items?: Maybe<Scalars['JSON']>;
  latest_invoice?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  pause_collection?: Maybe<Scalars['JSON']>;
  pending_setup_intent?: Maybe<Scalars['String']>;
  pending_update?: Maybe<Scalars['JSON']>;
  plan?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
};

export enum StripeSubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type SubmitAffiliateCouponInput = {
  affiliateProductSysId: Scalars['String'];
  affiliateSlug?: InputMaybe<Scalars['String']>;
  anonymousId: Scalars['String'];
  couponId: Scalars['String'];
};

export type SubmitVideoCallRatingInput = {
  consultationId: Scalars['String'];
  feedback?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
};

export type SubmitVideoCallRatingModel = {
  __typename?: 'SubmitVideoCallRatingModel';
  success: Scalars['Boolean'];
};

export type Subscription = {
  __typename?: 'Subscription';
  subscribeOrder?: Maybe<OrderDto>;
  subscribeUser?: Maybe<UserDto>;
};


export type SubscriptionSubscribeOrderArgs = {
  input: V2OrderFilterInput;
};


export type SubscriptionSubscribeUserArgs = {
  input: V2UserFilterInput;
};

export enum SurveyAnswers {
  BlogOrPublication = 'BlogOrPublication',
  DoctorClinicRecommendation = 'DoctorClinicRecommendation',
  EmailSms = 'EmailSMS',
  Facebook = 'Facebook',
  FacebookInstagram = 'FacebookInstagram',
  Instagram = 'Instagram',
  Kol = 'KOL',
  Line = 'Line',
  MailInLetterBox = 'MailInLetterBox',
  OnlineForums = 'OnlineForums',
  Other = 'Other',
  OutdoorAdvertisements = 'OutdoorAdvertisements',
  PodcastSpotify = 'PodcastSpotify',
  RecommendedByFriend = 'RecommendedByFriend',
  SearchEngine = 'SearchEngine',
  TvAd = 'TVAd',
  TiktokLiveStream = 'TiktokLiveStream',
  X = 'X',
  Youtube = 'Youtube'
}

export type SurveyDto = {
  __typename?: 'SurveyDto';
  answers?: Maybe<Scalars['JSON']>;
  isSkipped?: Maybe<Scalars['Boolean']>;
  patientSysId?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
  type?: Maybe<SurveyType>;
};

export type SurveyFilterInput = {
  answers?: InputMaybe<Array<SurveyAnswers>>;
  isSkipped?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SurveyType>;
};

export type SurveyInput = {
  answers?: InputMaybe<Scalars['JSON']>;
  isSkipped?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['JSON']>;
  patient?: InputMaybe<Scalars['JSON']>;
  questionAnswers?: InputMaybe<Scalars['JSON']>;
  skippedCarts?: InputMaybe<Array<Scalars['String']>>;
  sysId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<SurveyType>;
};

export type SurveyModel = {
  __typename?: 'SurveyModel';
  answers?: Maybe<Scalars['JSON']>;
  isSkipped?: Maybe<Scalars['Boolean']>;
  order?: Maybe<OrderModel>;
  patient?: Maybe<PatientModel>;
  questionAnswers?: Maybe<Scalars['JSON']>;
  skippedCarts?: Maybe<Array<Maybe<Scalars['String']>>>;
  sysId: Scalars['String'];
  type?: Maybe<SurveyType>;
};

export enum SurveyType {
  Checkout = 'Checkout',
  HearUs = 'HearUs',
  OrderCancel = 'OrderCancel',
  Sextisfaction = 'Sextisfaction'
}

export type SystemPromotionDto = {
  __typename?: 'SystemPromotionDto';
  oneTimePercent?: Maybe<Scalars['Float']>;
  oneTimeValue?: Maybe<Scalars['Float']>;
};

export type TeleConsultOrderFilterInput = {
  patientId?: InputMaybe<Scalars['String']>;
};

export type TeleConsultOrdersInput = {
  orderId: Scalars['String'];
  prescriptionDays: Scalars['Float'];
  prices: Array<ApprovePrescriptionPricesInput>;
};

export type Test_GenerateSmartMatchResultsInput = {
  effort?: InputMaybe<Scalars['String']>;
  evaluationData: Array<EvaluationData>;
  evaluationId: EvalIds;
  model?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserType>;
};

export enum TextConsultStatus {
  Approved = 'Approved',
  InProgress = 'InProgress',
  Null = 'Null',
  Rejected = 'Rejected'
}

export type TextConsultationSessionModel = {
  __typename?: 'TextConsultationSessionModel';
  consultationSession: ConsultationSessionModel;
  participants?: Maybe<Array<ParticipantModel>>;
  token: Scalars['String'];
};

export type ThankYouDataModel = {
  __typename?: 'ThankYouDataModel';
  cart: CheckoutCartModel;
  cartOrders?: Maybe<Array<Maybe<OrderModel>>>;
  consultOrderIds?: Maybe<Array<Scalars['String']>>;
  needsBookingOrderIds: Array<Scalars['String']>;
  newRxOrders?: Maybe<Array<Maybe<OrderModel>>>;
  textConsultOrderIds?: Maybe<Array<Scalars['String']>>;
};

export type TokenModel = {
  __typename?: 'TokenModel';
  accessToken: Scalars['String'];
  accessTokenExpiredAt: Scalars['Float'];
  refreshToken: Scalars['String'];
  user: User;
};

export type TrackingTypeInput = {
  ct?: InputMaybe<Scalars['String']>;
  fbc?: InputMaybe<Scalars['String']>;
  fbp?: InputMaybe<Scalars['String']>;
  gclid?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  sourceTracking?: InputMaybe<Scalars['String']>;
  st?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type TranslateRawTextDto = {
  __typename?: 'TranslateRawTextDto';
  sourceLanguage: Language;
  targetLanguage: Language;
  translatedText: Scalars['String'];
};

export type TranslateRawTextInput = {
  sourceLanguage: Language;
  targetLanguage: Language;
  text: Scalars['String'];
};

export type TranslatedTextPriceQueryInput = {
  language?: InputMaybe<Language>;
  priceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translatedKeys: Array<StripePriceLocaleKeys>;
};

export type TranslatedTextProductQueryInput = {
  language?: InputMaybe<Language>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translatedKeys: Array<StripeProductLocaleKeys>;
};

export type TranslationDto = {
  __typename?: 'TranslationDto';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  remark: Scalars['String'];
  sysId: Scalars['String'];
  translationKey: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  valueEn: Scalars['String'];
  valueJa: Scalars['String'];
  valueZh: Scalars['String'];
};

export type TriggerFollowUpConsultInput = {
  orderSysId: Scalars['String'];
};

export type TrtBloodTestCardDocumentDto = {
  __typename?: 'TrtBloodTestCardDocumentDto';
  cardKind: TrtBloodTestCardKind;
  createdAt?: Maybe<Scalars['DateTime']>;
  ref: Scalars['String'];
  role: TrtBloodTestDocumentRole;
  series: TrtBloodTestSeries;
  sysId: Scalars['ID'];
  type: Scalars['String'];
};

export type TrtBloodTestCardDto = {
  __typename?: 'TrtBloodTestCardDto';
  confirmableDrawType?: Maybe<TrtDrawType>;
  documents: Array<TrtBloodTestCardDocumentDto>;
  drawConfirmedAt?: Maybe<Scalars['DateTime']>;
  isFollowUp: Scalars['Boolean'];
  key: Scalars['ID'];
  kind: TrtBloodTestCardKind;
  orderStatus: OrderStatus;
  orderSysId: Scalars['String'];
  phase: TrtBloodTestCardPhase;
  resultReceivedAt?: Maybe<Scalars['DateTime']>;
  section: TrtBloodTestCardSection;
  sortAt: Scalars['DateTime'];
  sortIndex: Scalars['Int'];
};

export enum TrtBloodTestCardKind {
  BloodTestI = 'bloodTestI',
  BloodTestIi = 'bloodTestII',
  ReviewBloodTest = 'reviewBloodTest'
}

export enum TrtBloodTestCardPhase {
  AwaitingDraw = 'awaitingDraw',
  AwaitingOrderForm = 'awaitingOrderForm',
  AwaitingResults = 'awaitingResults',
  Cancelled = 'cancelled',
  CompleteDetails = 'completeDetails',
  Completed = 'completed',
  IdBeingVerified = 'idBeingVerified',
  Inactive = 'inactive',
  Locked = 'locked',
  ResultsIn = 'resultsIn'
}

export enum TrtBloodTestCardSection {
  Hidden = 'hidden',
  History = 'history',
  Journey = 'journey'
}

export enum TrtBloodTestDocumentRole {
  OrderForm = 'orderForm',
  Result = 'result'
}

export enum TrtBloodTestSeries {
  I = 'i',
  Ii = 'ii',
  Review = 'review',
  Unnumbered = 'unnumbered'
}

export enum TrtDocumentType {
  BloodTestRequisition = 'BloodTestRequisition',
  BloodTestRequisitionI = 'BloodTestRequisitionI',
  BloodTestRequisitionIi = 'BloodTestRequisitionII',
  BloodTestResult = 'BloodTestResult',
  BloodTestResultI = 'BloodTestResultI',
  BloodTestResultIi = 'BloodTestResultII'
}

export enum TrtDrawType {
  BloodTestI = 'bloodTestI',
  BloodTestIi = 'bloodTestII'
}

export type TrtLineageOrderDto = {
  __typename?: 'TrtLineageOrderDto';
  bloodTestCards: Array<TrtBloodTestCardDto>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documents: Array<UserDocumentDto>;
  followUpForOrderShortId?: Maybe<Scalars['Int']>;
  followUpForOrderSysId?: Maybe<Scalars['String']>;
  isCurrent: Scalars['Boolean'];
  isFollowUp: Scalars['Boolean'];
  kind: TrtOrderKind;
  shortId?: Maybe<Scalars['Int']>;
  status: OrderStatus;
  sysId: Scalars['String'];
};

export type TrtOrderDto = {
  __typename?: 'TrtOrderDto';
  bloodTestCards: Array<TrtBloodTestCardDto>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documents: Array<UserDocumentDto>;
  drawConfirmations: Array<BloodDrawConfirmationDto>;
  isFollowUp: Scalars['Boolean'];
  isTestOrder: Scalars['Boolean'];
  latestBloodPressure?: Maybe<PatientVitalDto>;
  orderLineage: Array<TrtLineageOrderDto>;
  paid: Scalars['Boolean'];
  patient?: Maybe<TrtOrderPatientDto>;
  shortId?: Maybe<Scalars['Int']>;
  skus: Array<TrtOrderSkuDto>;
  status: OrderStatus;
  sysId: Scalars['String'];
};

export enum TrtOrderKind {
  BloodTest = 'bloodTest',
  Medication = 'medication'
}

export type TrtOrderPatientDto = {
  __typename?: 'TrtOrderPatientDto';
  dob?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  hasIdentificationImage: Scalars['Boolean'];
  icNumber?: Maybe<Scalars['String']>;
  idVerifiedAt?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  sysId?: Maybe<Scalars['String']>;
};

export type TrtOrderSkuDto = {
  __typename?: 'TrtOrderSkuDto';
  name?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
  slot: Scalars['String'];
};

export type TrtOrdersFilterInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderSysId?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<OrderStatus>>;
};

export type TrySecondOpinionInputV2 = {
  orderSysId: Scalars['String'];
};

export type TwilioMessageHistoryModel = {
  __typename?: 'TwilioMessageHistoryModel';
  address: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  message: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type TwilioVideoConsultModel = {
  __typename?: 'TwilioVideoConsultModel';
  drFullName?: Maybe<Scalars['String']>;
  order?: Maybe<OrderModel>;
  roomName?: Maybe<Scalars['String']>;
  twilioAccessToken?: Maybe<Scalars['String']>;
};

export type UpdateAffiliateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  formFieldMap?: InputMaybe<Scalars['JSON']>;
  formSubmitUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationChannel?: InputMaybe<AffiliateNotificationChannel>;
  notificationEmail?: InputMaybe<Scalars['String']>;
  portalUrl?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<RegionType>;
  slug?: InputMaybe<Scalars['String']>;
};

export type UpdateAffiliateProductInput = {
  /** Percentage discount 1–100. Local-only update (Stripe percent_off is immutable). */
  discountPercentage?: InputMaybe<Scalars['Int']>;
  displayName?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Affiliate's per-product external portal / deal link (e.g. kumapon.jp/deals/…). Settable/editable; pass null to clear. */
  externalPortalUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateCartCalculateOrderSummaryInput = {
  calculation?: InputMaybe<CalculateOrderSummaryInput>;
  cartSysId: Scalars['String'];
};

export type UpdateCartItemByIdInput = {
  cartItem: Scalars['JSON'];
  promotionCode?: InputMaybe<Scalars['JSON']>;
  shouldReturnCalculation?: InputMaybe<Scalars['Boolean']>;
  sysId: Scalars['String'];
};

export type UpdateCheckoutSessionInput = {
  checkoutData?: InputMaybe<Scalars['JSON']>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type UpdateCompletedEvalInput = {
  completed?: InputMaybe<Scalars['Boolean']>;
  evaluationFormLastUpdated?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<Scalars['String']>;
  formQandA?: InputMaybe<Scalars['JSON']>;
  goal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jumpToSectionIndex?: InputMaybe<Array<Scalars['Float']>>;
  oldPatientId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  patientdoctorNotes?: InputMaybe<Scalars['String']>;
  questionTotal?: InputMaybe<Scalars['Float']>;
  sectionHistory?: InputMaybe<Array<Scalars['Float']>>;
  sectionIndex?: InputMaybe<Scalars['Float']>;
  sectionTotal?: InputMaybe<Scalars['Float']>;
  sysId: Scalars['String'];
  valid?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCompletedEvalInputForGuest = {
  completed?: InputMaybe<Scalars['Boolean']>;
  evaluationFormLastUpdated?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<Scalars['String']>;
  formQandA?: InputMaybe<Scalars['JSON']>;
  goal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jumpToSectionIndex?: InputMaybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  oldPatientId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  patientdoctorNotes?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PlatformType>;
  questionTotal?: InputMaybe<Scalars['Float']>;
  sectionHistory?: InputMaybe<Array<Scalars['Float']>>;
  sectionIndex?: InputMaybe<Scalars['Float']>;
  sectionTotal?: InputMaybe<Scalars['Float']>;
  sysId: Scalars['String'];
  targetEmail: Scalars['String'];
  valid?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCustomerBalanceInput = {
  customerBalances: Array<CustomerBalance>;
};

export type UpdateCustomerBalanceTransactionInput = {
  cashbackObjectType?: InputMaybe<CashbackObjectType>;
  cashbackType?: InputMaybe<CashbackType>;
  customerId: Scalars['String'];
  isFirstEarned?: InputMaybe<Scalars['Boolean']>;
  savingsToDate?: InputMaybe<Scalars['Int']>;
  sourceId?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};

export type UpdateDoctorForAuditDoctorNoteInput = {
  doctorSysId: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  sysId: Scalars['String'];
};

export type UpdateEvaluationQuestionInput = {
  evaluationId?: InputMaybe<Scalars['String']>;
  evaluationQuestion?: InputMaybe<Scalars['JSON']>;
  question?: InputMaybe<Scalars['JSON']>;
};

export type UpdateMhpOrderDosageInput = {
  orderId: Scalars['String'];
  selectedEvalProducts?: InputMaybe<Array<PrescribedProductInput>>;
};

export type UpdateOrderInput = {
  acuityAppointmentSnapshot?: InputMaybe<Scalars['JSON']>;
  billingAddress?: InputMaybe<AddressInput>;
  continueTrial?: InputMaybe<Scalars['Boolean']>;
  countTrialReminder?: InputMaybe<Scalars['Float']>;
  createFromSkipOrderId?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  doctorNotes?: InputMaybe<Scalars['String']>;
  doctorPrescriptionPriceIds?: InputMaybe<Array<Scalars['String']>>;
  dosage?: InputMaybe<Scalars['JSON']>;
  evaluationId?: InputMaybe<Scalars['String']>;
  intakeInstructions?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  isPendingFollowUpConsult?: InputMaybe<Scalars['Boolean']>;
  isSkipMedOrder?: InputMaybe<Scalars['Boolean']>;
  lastShipmentDate?: InputMaybe<Scalars['DateTime']>;
  nextReviewDate?: InputMaybe<Scalars['DateTime']>;
  ops?: InputMaybe<Scalars['String']>;
  opsComment?: InputMaybe<Scalars['String']>;
  orderPrescriptionPriceId?: InputMaybe<Scalars['String']>;
  orderPriceId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  patientOrderNotes?: InputMaybe<Array<Scalars['String']>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pickupLocation?: InputMaybe<PickupLocationInput>;
  productQuantity?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<OrderStatus>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  sysId: Scalars['String'];
};

export type UpdateOrderNoteInput = {
  content: Scalars['String'];
  sysId: Scalars['String'];
};

export type UpdateOrderShipmentInput = {
  address?: InputMaybe<AddressInput>;
  config?: InputMaybe<OrderShipmentConfig>;
  deliveryTimestamp?: InputMaybe<Scalars['DateTime']>;
  estimatedShipDate?: InputMaybe<Scalars['DateTime']>;
  note?: InputMaybe<Scalars['String']>;
  paused?: InputMaybe<Scalars['Boolean']>;
  shipmentGroupSysId?: InputMaybe<Scalars['String']>;
  shipperSysId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrderShipmentStatus>;
  sysId: Scalars['String'];
  trackingNo?: InputMaybe<Scalars['String']>;
};

export type UpdatePatientDocumentInput = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  sysId: Scalars['String'];
};

export type UpdatePatientEvaluationInput = {
  consultationSessionType?: InputMaybe<ConsultationSessionType>;
  currentQuestionId?: InputMaybe<Scalars['String']>;
  evaluationBlockId?: InputMaybe<Scalars['String']>;
  evaluationId: Scalars['String'];
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isSkipped?: InputMaybe<Scalars['Boolean']>;
  patientNote?: InputMaybe<Scalars['String']>;
};

export type UpdatePatientInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<AddressInput>;
  bloodPressure?: InputMaybe<Scalars['String']>;
  deliveryAddress?: InputMaybe<AddressInput>;
  dob?: InputMaybe<Scalars['DateTime']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  height?: InputMaybe<Scalars['Float']>;
  icNumber?: InputMaybe<Scalars['String']>;
  identification?: InputMaybe<Scalars['JSON']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  stripeCustomer?: InputMaybe<Scalars['JSON']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type UpdatePatientQuestionAnswerInput = {
  answerId?: InputMaybe<Scalars['String']>;
  questionId: Scalars['String'];
  sysId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentStatusDto = {
  __typename?: 'UpdatePaymentStatusDto';
  errorMessage?: Maybe<Scalars['String']>;
  isSuccess: Scalars['Boolean'];
  orderId?: Maybe<Scalars['String']>;
};

export type UpdatePaymentStatusForCodDto = {
  __typename?: 'UpdatePaymentStatusForCodDto';
  results: Array<UpdatePaymentStatusDto>;
};

export type UpdatePriceLocaleInput = {
  language?: InputMaybe<Language>;
  locale?: InputMaybe<Array<KeyValuePriceLocaleInput>>;
  priceId: Scalars['String'];
};

export type UpdatePriceMetadataInput = {
  locale?: InputMaybe<Language>;
  metadata?: InputMaybe<Scalars['JSON']>;
  priceId: Scalars['String'];
};

export type UpdateProcessEvaluationInput = {
  patientEvaluation: UpdatePatientEvaluationInput;
  patientQuestionAnswers?: InputMaybe<Array<UpdatePatientQuestionAnswerInput>>;
};

export type UpdateProductLocaleInput = {
  language?: InputMaybe<Language>;
  locale?: InputMaybe<Array<KeyValueProductLocaleInput>>;
  productId: Scalars['String'];
};

export type UpdateProductMetadataInput = {
  metadata?: InputMaybe<Scalars['JSON']>;
  productId: Scalars['String'];
};

export type UpdateShipmentGroupInput = {
  bookingNo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sysId: Scalars['String'];
};

export type UpdateShipperInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sysId: Scalars['String'];
};

export type UpdateShippingOrderShipment = {
  status: OrderShipmentStatus;
  sysIds: Array<Scalars['String']>;
};

export type UpdateStripeCouponInput = {
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateStripePriceInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  nickname?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  recurring?: InputMaybe<StripePriceRecurringInput>;
};

export type UpdateStripeProductImageUrlsInput = {
  imageUrl?: InputMaybe<Array<Scalars['String']>>;
  productId: Scalars['String'];
};

export type UpdateStripeProductInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  expand?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  statementDescriptor?: InputMaybe<Scalars['String']>;
  unitLabel?: InputMaybe<Scalars['String']>;
};

export type UpdateStripePromotionCodeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSON']>;
};

export type UploadIdInput = {
  /** File type (e.g., image/jpeg, application/pdf) */
  filetype: Scalars['String'];
  /** Reference key for the uploaded file (e.g., S3 key) */
  ref: Scalars['String'];
};

export type UploadTrtDocumentInput = {
  file: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
  filetype: Scalars['String'];
  orderSysId: Scalars['String'];
  type: TrtDocumentType;
};

export type UpsertPatientOnboardingInput = {
  currentStep?: InputMaybe<Scalars['Float']>;
  skipGuide?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<OnboardingStatus>;
  tourName?: InputMaybe<Scalars['String']>;
};

export type UpsertRecommendedProductInput = {
  priceId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
};

export type UpsertRecommendedProductsInput = {
  anonymousSegmentId?: InputMaybe<Scalars['String']>;
  recommendedProducts: Array<UpsertRecommendedProductInput>;
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPharmacist?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  patient?: Maybe<PatientModel>;
  requireConfirmPolicy?: Maybe<Scalars['Boolean']>;
  socialProviderType?: Maybe<SocialProviderTypes>;
  sysId?: Maybe<Scalars['String']>;
  userType?: Maybe<UserRole>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
};

export type UserDocumentDto = {
  __typename?: 'UserDocumentDto';
  createdAt?: Maybe<Scalars['DateTime']>;
  orderSysId?: Maybe<Scalars['String']>;
  ref: Scalars['String'];
  sysId: Scalars['String'];
  type: UserDocumentType;
  url?: Maybe<Scalars['String']>;
};

export enum UserDocumentType {
  BloodTestFreeAndTotalTestosterone = 'BloodTestFreeAndTotalTestosterone',
  BloodTestReferral = 'BloodTestReferral',
  BloodTestRequisition = 'BloodTestRequisition',
  BloodTestRequisitionI = 'BloodTestRequisitionI',
  BloodTestRequisitionIi = 'BloodTestRequisitionII',
  BloodTestResult = 'BloodTestResult',
  BloodTestResultI = 'BloodTestResultI',
  BloodTestResultIi = 'BloodTestResultII'
}

export type UserDto = {
  __typename?: 'UserDto';
  admin?: Maybe<AdminDto>;
  avatar?: Maybe<Scalars['String']>;
  calendarDates?: Maybe<Array<Maybe<CalendarDateDto>>>;
  calendarTimes?: Maybe<Array<Maybe<CalendarTimeDto>>>;
  consultation?: Maybe<ConsultationDto>;
  consultationMessages?: Maybe<PaginatedUserMessageDto>;
  consultations?: Maybe<Array<Maybe<ConsultationDto>>>;
  doctor?: Maybe<DoctorDto>;
  doctors?: Maybe<Array<DoctorDto>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPharmacist?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  ninjaVanToken?: Maybe<Scalars['String']>;
  orders?: Maybe<Array<Maybe<OrderDto>>>;
  partnerConsultDates?: Maybe<Array<Maybe<CalendarDateDto>>>;
  partnerConsultTimes?: Maybe<Array<Maybe<CalendarTimeDto>>>;
  patient?: Maybe<PatientDto>;
  patientDocuments?: Maybe<Array<Maybe<UserDocumentDto>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  prescriptionCalculation?: Maybe<CheckoutCalculationDto>;
  requireConfirmPolicy?: Maybe<Scalars['Boolean']>;
  socialProviderType?: Maybe<SocialProviderTypes>;
  stripeProducts?: Maybe<Array<StripeProductDto>>;
  sysId?: Maybe<Scalars['String']>;
  /** Used for bypass login token only. use this tempToken to call APIs */
  tempToken?: Maybe<Scalars['String']>;
  /** Used for bypass login token only. use this tempToken to call APIs */
  tempTokenExpired?: Maybe<Scalars['Boolean']>;
  userType?: Maybe<UserRole>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmId?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
};


export type UserDtoCalendarDatesArgs = {
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
};


export type UserDtoCalendarTimesArgs = {
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['Float']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
};


export type UserDtoConsultationArgs = {
  input: V2ConsultationFilterInput;
};


export type UserDtoConsultationMessagesArgs = {
  input: ConsultationMessagesInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type UserDtoConsultationsArgs = {
  input: ConsultationListInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
};


export type UserDtoDoctorArgs = {
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
};


export type UserDtoDoctorsArgs = {
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
};


export type UserDtoOrdersArgs = {
  input: OrderInput;
  pagination: V2PaginationInput;
};


export type UserDtoPartnerConsultDatesArgs = {
  date?: InputMaybe<Scalars['String']>;
};


export type UserDtoPartnerConsultTimesArgs = {
  date?: InputMaybe<Scalars['Float']>;
};


export type UserDtoPatientArgs = {
  input?: InputMaybe<GetPatientInput>;
};


export type UserDtoStripeProductsArgs = {
  input?: InputMaybe<StripeProductFilterV2>;
};

export type UserMessageDto = {
  __typename?: 'UserMessageDto';
  automatedMessage?: Maybe<TranslationDto>;
  consultationSysId: Scalars['String'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  readAt?: Maybe<Scalars['DateTime']>;
  sysId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: UserDto;
};

export enum UserRole {
  Admin = 'admin',
  Doctor = 'doctor',
  Partner = 'partner',
  Patient = 'patient',
  Shipper = 'shipper',
  Supporter = 'supporter',
  TestDoctor = 'test_doctor',
  TestPatient = 'test_patient'
}

export type UserSessionDto = {
  __typename?: 'UserSessionDto';
  appVersion?: Maybe<Scalars['String']>;
  clientType?: Maybe<ClientType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  deviceNotificationToken?: Maybe<Scalars['String']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastLogout?: Maybe<Scalars['DateTime']>;
  sysId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type UserTrackingInput = {
  latestCodClicked?: InputMaybe<Scalars['DateTime']>;
};

export enum UserType {
  Guest = 'guest',
  Patient = 'patient'
}

export type UtmTypeInput = {
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmId?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type V2AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<RegionType>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postal?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<LocalRegionType>;
  sameAsBilling?: InputMaybe<Scalars['Boolean']>;
  shouldSave?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AddressType>;
  unit?: InputMaybe<Scalars['String']>;
};

export type V2BookAppointmentAndDeliveryInput = {
  /** Used for pre created appointment record */
  appointmentSysId?: InputMaybe<Scalars['String']>;
  consultTime?: InputMaybe<Scalars['String']>;
  deliveryTime?: InputMaybe<Scalars['String']>;
  doctorSysId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type V2BookFuAppointmentInput = {
  consultTime?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
};

export type V2CancelSubscriptionInput = {
  cancelSurvey?: InputMaybe<SurveyInput>;
  orderId: Scalars['String'];
  reason?: InputMaybe<CancelSubscriptionReasons>;
  reasonOther?: InputMaybe<Scalars['String']>;
};

export type V2ChangeDeliveryWindowInput = {
  lang?: InputMaybe<Language>;
  orderId: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type V2ChangeOrderPrice = {
  newPriceId: Scalars['String'];
  orderId: Scalars['String'];
};

export type V2ChangePriceKonbiniOrderInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  priceId: Scalars['String'];
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
  variantEdit?: InputMaybe<Scalars['String']>;
};

export type V2ChargeConsultFeeKonbiniOrder = {
  orderId: Scalars['String'];
};

export type V2CheckAvailableSupportCod = {
  deliveryAddress?: InputMaybe<Scalars['String']>;
  deliveryMethod: DeliveryMethod;
  pickupLocationType?: InputMaybe<PickupLocationType>;
  priceId?: InputMaybe<Scalars['String']>;
};

export type V2ClaimSubscriptionRetentionInput = {
  orderId: Scalars['String'];
};

export type V2ConfirmAtomePaymentInput = {
  orderId: Scalars['String'];
  priceId: Scalars['String'];
};

export type V2ConfirmChangePrescriptionInput = {
  calculation?: InputMaybe<Scalars['JSON']>;
  firstMsgConversation?: InputMaybe<Scalars['String']>;
  isAutoRenewal?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  priceId: Scalars['String'];
};

export type V2ConfirmCodOrderInput = {
  orderId: Scalars['String'];
  priceId: Scalars['String'];
};

export type V2ConsultationFilterInput = {
  consultationId?: InputMaybe<Scalars['String']>;
  fromCreatedAt?: InputMaybe<Scalars['DateTime']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderSysIds?: InputMaybe<Array<Scalars['String']>>;
  patientId?: InputMaybe<Scalars['String']>;
  progressStatus?: InputMaybe<ConsultationSessionProgressStatus>;
  status?: InputMaybe<ConsultationSessionStatus>;
  textConsultationId?: InputMaybe<Scalars['String']>;
  toCreatedAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<ConsultationSessionType>;
  videoChannelId?: InputMaybe<Scalars['String']>;
  videoLink?: InputMaybe<Scalars['String']>;
};

export type V2CreateAtomePaymentInput = {
  amount: Scalars['Float'];
  crossSellOtcPriceIds: Array<Scalars['String']>;
  priceId: Scalars['String'];
  referenceId?: InputMaybe<Scalars['String']>;
};

export type V2CreateDoctor = {
  calendarId: Scalars['Float'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type V2DeliveryCharge = {
  orderId: Scalars['String'];
};

export type V2DoctorInputFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  activeForTextConsult?: InputMaybe<Scalars['Boolean']>;
  calendarId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  userSysId?: InputMaybe<Scalars['String']>;
};

export type V2EvaluationInput = {
  type?: InputMaybe<EvalIds>;
};

export type V2GuestVideoConsultationInput = {
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  videoLink?: InputMaybe<Scalars['String']>;
};

export type V2IdentificationInput = {
  image: V2ImageIdentInput;
};

export type V2ImageIdentInput = {
  ref: Scalars['String'];
  url: Scalars['String'];
};

export type V2ImportProductPricesInput = {
  importPrices?: InputMaybe<Array<PriceInput>>;
  importProducts?: InputMaybe<Array<ProductInput>>;
};

export type V2OrderFilterInput = {
  email?: InputMaybe<Scalars['String']>;
  evaluationId?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
  paymentProvider?: InputMaybe<PaymentProvider>;
  shortId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<OrderStatus>>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type V2PaginationInput = {
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderType?: InputMaybe<Scalars['String']>;
};

export type V2PatientEvaluationFilterInput = {
  evaluationId?: InputMaybe<Scalars['String']>;
  evaluationType?: InputMaybe<EvalIds>;
  isCompleted?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type V2PickupLocationInput = {
  area?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PickupLocationType>;
};

export type V2PresCheckoutDosageInput = {
  priceId: Scalars['String'];
};

export type V2PresCheckoutInput = {
  additionalMedPrices?: InputMaybe<Array<InputMaybe<V2PresCheckoutDosageInput>>>;
  anonymousId?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<AddressInput>;
  checkoutSessionSysId?: InputMaybe<Scalars['String']>;
  consultType: ConsultationSessionType;
  deliveryAddress: ExtraDeliveryAddressInput;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  evaluationId: EvalIds;
  isAtomeAutoRenewal?: InputMaybe<Scalars['Boolean']>;
  isAutoRenewal: Scalars['Boolean'];
  otcPriceIds?: InputMaybe<Array<Scalars['String']>>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  paymentType: PaymentProvider;
  pickupLocationSysId?: InputMaybe<Scalars['String']>;
  preblockId?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
  promotionCode?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type V2PresCheckoutViaReceptionistInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<AddressInput>;
  deliveryAddress?: InputMaybe<ExtraDeliveryAddressInput>;
  deliveryMethod?: InputMaybe<DeliveryMethod>;
  orderId: Scalars['String'];
  otcSelectedPriceIds?: InputMaybe<Array<Scalars['String']>>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<PaymentProvider>;
  pickupLocationSysId?: InputMaybe<Scalars['String']>;
  promotionCode?: InputMaybe<Scalars['String']>;
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type V2PrescriptionFilterInput = {
  status?: InputMaybe<PrescriptionStatus>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type V2ReactivateOrderInput = {
  orderId: Scalars['String'];
  priceId?: InputMaybe<Scalars['String']>;
};

export type V2RenewAtomeOrder = {
  orderId: Scalars['String'];
};

export type V2RenewCodOrderInput = {
  orderId: Scalars['String'];
};

export type V2RenewKonbiniOrderInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  tracking?: InputMaybe<TrackingTypeInput>;
  utm?: InputMaybe<UtmTypeInput>;
};

export type V2RenewMultipleCodOrdersInput = {
  items: Array<V2RenewCodOrderInput>;
};

export type V2StripeProductPriceFilterInput = {
  excludingProductUniqNames?: InputMaybe<Array<InputMaybe<ProductNameType>>>;
  medicationCategory?: InputMaybe<MedicationCategory>;
  platform?: InputMaybe<PlatformType>;
  priceActive?: InputMaybe<Scalars['Boolean']>;
  priceId?: InputMaybe<Scalars['String']>;
  priceIds?: InputMaybe<Array<Scalars['String']>>;
  priceShopDisplay?: InputMaybe<Scalars['Boolean']>;
  priceType?: InputMaybe<StripePriceType>;
  productActive?: InputMaybe<Scalars['Boolean']>;
  productEvaluationId?: InputMaybe<EvalIds>;
  productId?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
  productUniqName?: InputMaybe<Scalars['String']>;
  productUniqNames?: InputMaybe<Array<InputMaybe<ProductNameType>>>;
};

export type V2UpdateAtomePaymentInput = {
  crossSellOtcPriceIds?: InputMaybe<Array<Scalars['String']>>;
  priceId?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['String']>;
  sysId: Scalars['String'];
};

export type V2UpdateOrderInput = {
  deliveryStatus?: InputMaybe<DeliveryStatus>;
  isPacked?: InputMaybe<Scalars['Boolean']>;
  sysId: Scalars['String'];
};

export type V2UpdateOtherInterestedEvalIdsInput = {
  orderId: Scalars['String'];
  otherIntestedEvalIds: Array<Scalars['String']>;
};

export type V2UpdatePatientInput = {
  billingAddress?: InputMaybe<V2AddressInput>;
  deliveryAddress?: InputMaybe<V2AddressInput>;
  dob?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fromPlatformEnv?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  icNumber?: InputMaybe<Scalars['String']>;
  identification?: InputMaybe<V2IdentificationInput>;
  lastName?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  updateAddressInOrders?: InputMaybe<Scalars['Boolean']>;
};

export type V2UpdatePaymentMethod = {
  paymentMethodId?: InputMaybe<Scalars['String']>;
};

export type V2UpdatePaymentStatusCodOrder = {
  orderId: Scalars['String'];
  paymentStatus: PaymentStatus;
};

export type V2UpdatePaymentStatusCodOrderInput = {
  items: Array<V2UpdatePaymentStatusCodOrder>;
};

export type V2UserFilterInput = {
  email?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
};

export type V2UserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  /** Short id (used for tracking) */
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
  userTracking?: InputMaybe<UserTrackingInput>;
};

export type ValidatePatientQuestionAnswerModel = {
  __typename?: 'ValidatePatientQuestionAnswerModel';
  patientQuestionAnswer: PatientQuestionAnswerModel;
  validation: ValidationEvaluationQuestionModel;
};

export type ValidationEvaluationQuestionModel = {
  __typename?: 'ValidationEvaluationQuestionModel';
  mandatory?: Maybe<Scalars['Boolean']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  preselect?: Maybe<EvaluationValidationPreselect>;
  type?: Maybe<EvaluationValidation>;
};

export type ValidationQuestionDto = {
  __typename?: 'ValidationQuestionDto';
  bmi?: Maybe<Scalars['JSON']>;
  extra?: Maybe<Scalars['JSON']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  preselect?: Maybe<EvaluationValidationPreselect>;
  type?: Maybe<EvaluationValidation>;
};

export type VerifyForgotPasswordUserInput = {
  email: Scalars['String'];
  otp: Scalars['String'];
};

export type VerifyOrderInput = {
  orderSysIds: Array<Scalars['String']>;
};

export type VideoConsultationDto = {
  __typename?: 'VideoConsultationDto';
  gmeetLink?: Maybe<Scalars['String']>;
  order?: Maybe<OrderDto>;
  previewToken?: Maybe<Scalars['String']>;
  previewVideoLink?: Maybe<Scalars['String']>;
  status?: Maybe<ConsultationSessionStatus>;
  sysId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  videoChannelId?: Maybe<Scalars['String']>;
  videoLink?: Maybe<Scalars['String']>;
  zoomJoinUrl?: Maybe<Scalars['String']>;
};

export type VideoSessionInput = {
  orderSysId: Scalars['String'];
};

export type ViewerDto = {
  __typename?: 'ViewerDto';
  appSettings?: Maybe<AppSettingsDto>;
  evaluations?: Maybe<Array<Maybe<EvaluationDto>>>;
  master?: Maybe<MasterDto>;
  orderAtomePaymentLink?: Maybe<AtomePaymentDto>;
  orderShipments?: Maybe<Array<OrderShipmentDto>>;
  partner?: Maybe<PartnerDto>;
  prescriptionCalculation: CheckoutCalculationDto;
  smartMatch: SmartMatchDto;
  smartMatchResponse: SmartMatchResponse;
  stripeProducts?: Maybe<Array<Maybe<StripeProductDto>>>;
  stripeProducts2?: Maybe<Array<Maybe<StripeProductDto>>>;
  user?: Maybe<UserDto>;
  users: Array<UserDto>;
  videoConsultation?: Maybe<VideoConsultationDto>;
};


export type ViewerDtoEvaluationsArgs = {
  evalInput?: InputMaybe<V2EvaluationInput>;
};


export type ViewerDtoOrderAtomePaymentLinkArgs = {
  orderId: Scalars['String'];
};


export type ViewerDtoOrderShipmentsArgs = {
  input: OrderShipmentInput;
};


export type ViewerDtoPartnerArgs = {
  input: GetPartnerInput;
};


export type ViewerDtoPrescriptionCalculationArgs = {
  input?: InputMaybe<PrescriptionCalculationInput>;
};


export type ViewerDtoSmartMatchArgs = {
  input: GetSmartMatchResultsInput;
};


export type ViewerDtoSmartMatchResponseArgs = {
  input: GetSmartMatchAiResponseInput;
};


export type ViewerDtoStripeProductsArgs = {
  evalResultInput?: InputMaybe<EvaluationResultsInput>;
  input?: InputMaybe<StripeProductFilterV2Input>;
};


export type ViewerDtoUsersArgs = {
  input: GetUsersInput;
};


export type ViewerDtoVideoConsultationArgs = {
  input: V2GuestVideoConsultationInput;
};

export type Test_SmartMatchDto = {
  __typename?: 'test_SmartMatchDto';
  evalId: EvalIds;
  smartMatchResults?: Maybe<Scalars['JSON']>;
  status: SmartMatchStatus;
  sysId: Scalars['String'];
  userId: Scalars['String'];
  userType: UserType;
};

export type AddCashbackToMultipleCustomersMutationVariables = Exact<{
  input: AddCashbackToCustomersInput;
}>;


export type AddCashbackToMultipleCustomersMutation = { __typename?: 'Mutation', addCashbackToMultipleCustomers: { __typename?: 'AddCashbackReturnModel', errorCustomers?: Array<string | null> | null, notFoundCustomers?: Array<string | null> | null, success: boolean } };

export type AddCashbackToTheCustomerMutationVariables = Exact<{
  input: AddCashbackToCustomerInput;
}>;


export type AddCashbackToTheCustomerMutation = { __typename?: 'Mutation', addCashbackToTheCustomer: { __typename?: 'AddCashbackReturnModel', errorCustomers?: Array<string | null> | null, notFoundCustomers?: Array<string | null> | null, success: boolean } };

export type AddNewPickupLocationsMutationVariables = Exact<{
  input: NewPickupLocationsInput;
}>;


export type AddNewPickupLocationsMutation = { __typename?: 'Mutation', addNewPickupLocations: boolean };

export type AppleLoginMutationVariables = Exact<{
  input: AppleLoginInput;
}>;


export type AppleLoginMutation = { __typename?: 'Mutation', appleLogin?: { __typename?: 'TokenModel', accessToken: string, accessTokenExpiredAt: number, refreshToken: string, user: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } } | null };

export type ApplyPromotionCodeForAnonymousMutationVariables = Exact<{
  input: ApplyPromotionCodeForAnonymousInput;
}>;


export type ApplyPromotionCodeForAnonymousMutation = { __typename?: 'Mutation', applyPromotionCodeForAnonymous: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null } };

export type ApplyPromotionCodeForCartMutationVariables = Exact<{
  input: ApplyPromotionCodeForCartInput;
}>;


export type ApplyPromotionCodeForCartMutation = { __typename?: 'Mutation', applyPromotionCodeForCart: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null } };

export type ApplyPromotionFromBannerMutationVariables = Exact<{
  input: ApplyPromotionFromBannerInput;
}>;


export type ApplyPromotionFromBannerMutation = { __typename?: 'Mutation', applyPromotionFromBanner: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null } };

export type ApprovePrescriptionOrderMutationVariables = Exact<{
  input: ApprovePrescriptionOrderInput;
}>;


export type ApprovePrescriptionOrderMutation = { __typename?: 'Mutation', approvePrescriptionOrder: boolean };

export type ArchiveStripePriceMutationVariables = Exact<{
  input: ArchivePriceInput;
}>;


export type ArchiveStripePriceMutation = { __typename?: 'Mutation', archiveStripePrice: boolean };

export type ArchiveStripeProductMutationVariables = Exact<{
  input: ArchiveProductInput;
}>;


export type ArchiveStripeProductMutation = { __typename?: 'Mutation', archiveStripeProduct: boolean };

export type AttachPaymentIntentMutationVariables = Exact<{
  input: AttachPaymentIntentInput;
}>;


export type AttachPaymentIntentMutation = { __typename?: 'Mutation', attachPaymentIntent: string };

export type AttachPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;


export type AttachPaymentMethodMutation = { __typename?: 'Mutation', attachPaymentMethod: boolean };

export type AttachPaymentMethod2MutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  platform1?: InputMaybe<Scalars['String']>;
  platform2?: InputMaybe<Scalars['String']>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  id1?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id2?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  platform14?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform15?: InputMaybe<Scalars['String']>;
  videoLink1: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  input4?: InputMaybe<CrossSellRecordQueryInput>;
  orderId?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId2?: InputMaybe<Scalars['String']>;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date2?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date3?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  input5: V2ConsultationFilterInput;
  input6: ConsultationMessagesInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input7: ConsultationListInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input8: OrderInput;
  pagination: V2PaginationInput;
  date4?: InputMaybe<Scalars['String']>;
  date5?: InputMaybe<Scalars['Float']>;
  input9?: InputMaybe<GetPatientInput>;
  platform16?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<StripeProductFilterV2>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform17?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  checkoutSessionFilterOptions1?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  input17: GetPatientDocumentInput;
  evalFilter1?: InputMaybe<V2PatientEvaluationFilterInput>;
  id3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform18?: InputMaybe<Scalars['String']>;
  inputOrder2?: InputMaybe<V2OrderFilterInput>;
  orderPagination2?: InputMaybe<V2PaginationInput>;
  input18?: InputMaybe<PrescriptionCalculationInput>;
  platform19?: InputMaybe<Scalars['String']>;
  platform20?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<ShopProductFilterInputV2>;
  limit8?: InputMaybe<Scalars['Float']>;
  offset8?: InputMaybe<Scalars['Float']>;
  sort1?: InputMaybe<ShopProductSortInputV2>;
  input19: GetSmartMatchMetaInput;
  input20?: InputMaybe<PatientGetSurveyInput>;
  videoLink3: Scalars['String'];
  previewVideoLink1: Scalars['String'];
  paymentMethodInput: V2UpdatePaymentMethod;
}>;


export type AttachPaymentMethod2Mutation = { __typename?: 'Mutation', attachPaymentMethod2?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null }> | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null> | null } | null, question?: { __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null }> | null, content?: { __typename?: 'ContentQuestionDto', body?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null, blockAnswer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, content?: { __typename?: 'EvaluationBlockContentDto', description?: string | null, descriptionTextKey?: string | null, sysId?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null }> | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null, card?: { __typename?: 'StripeCardDto', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, otcOrdersCalculation?: Array<{ __typename?: 'OTCOrderCalculationDto', basePrice?: number | null, cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmount?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, stripePromotionCode?: any | null, tax?: number | null, transactionFee?: number | null }> | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, rxOrdersCalculation?: Array<{ __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null }> | null } | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, items?: Array<{ __typename?: 'ReferralItemDto', orderId?: string | null, priceId?: string | null, referralSysId?: string | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null } | null> | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null } | null };

export type AttachPaymentMethodWithIntentForAnonymousMutationVariables = Exact<{
  input: AttachPaymentMethodWithIntentForAnonymousInput;
}>;


export type AttachPaymentMethodWithIntentForAnonymousMutation = { __typename?: 'Mutation', attachPaymentMethodWithIntentForAnonymous: string };

export type BookAppointmentAndDeliveryMutationVariables = Exact<{
  input: BookAppointmentAndDeliveryInput;
}>;


export type BookAppointmentAndDeliveryMutation = { __typename?: 'Mutation', bookAppointmentAndDelivery: { __typename?: 'BookAppointmentAndDeliveryModel', checkoutCartId?: string | null, isFertilityCoach: boolean, success: boolean, consultationSession?: { __typename?: 'ConsultationSessionModel', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, friendlyName?: string | null, gmeetLink?: string | null, patientChatToken?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } };

export type BookAppointmentAndDeliveryV2MutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  bookConsultInput: V2BookAppointmentAndDeliveryInput;
}>;


export type BookAppointmentAndDeliveryV2Mutation = { __typename?: 'Mutation', bookAppointmentAndDeliveryV2?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type BookFuAppointmentMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: V2BookFuAppointmentInput;
}>;


export type BookFuAppointmentMutation = { __typename?: 'Mutation', bookFUAppointment?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type BookHumansaConsultationMutationVariables = Exact<{
  platform?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  patientId?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input12: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input13: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input14?: InputMaybe<GetPatientInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input15?: InputMaybe<StripeProductFilterV2>;
  input16: V2ConsultationFilterInput;
  videoLink1: Scalars['String'];
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input17: BookHumansaConsultation;
}>;


export type BookHumansaConsultationMutation = { __typename?: 'Mutation', bookHumansaConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null }> | null } | null } | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null };

export type BookPrescriptionReviewAppointmentMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: BookPrescriptionReviewAppointmentInput;
}>;


export type BookPrescriptionReviewAppointmentMutation = { __typename?: 'Mutation', bookPrescriptionReviewAppointment?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type BulkUpdateShipmentMutationVariables = Exact<{
  input: Array<UpdateOrderShipmentInput> | UpdateOrderShipmentInput;
}>;


export type BulkUpdateShipmentMutation = { __typename?: 'Mutation', bulkUpdateShipment?: boolean | null };

export type CalculateCartMutationVariables = Exact<{
  input: CalculateOrderInput;
}>;


export type CalculateCartMutation = { __typename?: 'Mutation', calculateCart: { __typename?: 'CalculateOrderSummaryModel', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null, itemList?: Array<{ __typename?: 'PaymentItemInfoModel', consultationSessionType?: ConsultationSessionType | null, isEDBundle?: boolean | null, isPayNow?: boolean | null, isRxProduct?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, isSubscriptionUpdate?: boolean | null, itemSubTotal?: number | null, itemSubTotalAfterDiscount?: number | null, mainProductId?: string | null, mainProductName?: string | null, name?: string | null, priceId?: string | null, priceType?: StripePriceType | null, productId?: string | null, productUniqName?: ProductNameType | null, quantity?: number | null, unit_amount?: number | null } | null> | null } };

export type CancelAppointmentMutationVariables = Exact<{
  input: CancelAppointmentInput;
}>;


export type CancelAppointmentMutation = { __typename?: 'Mutation', cancelAppointment: boolean };

export type CancelCheckInMutationVariables = Exact<{
  cancelCheckInInput: MarkNoShowInput;
}>;


export type CancelCheckInMutation = { __typename?: 'Mutation', cancelCheckIn?: boolean | null };

export type CancelMounjaroTrialMutationVariables = Exact<{
  reason: Scalars['String'];
  trialFunnelSysId: Scalars['String'];
}>;


export type CancelMounjaroTrialMutation = { __typename?: 'Mutation', cancelMounjaroTrial: boolean };

export type CancelOrderMutationVariables = Exact<{
  input: CancelOrderInput;
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder: boolean };

export type CancelPaymentIntentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CancelPaymentIntentMutation = { __typename?: 'Mutation', cancelPaymentIntent: boolean };

export type CancelSubscriptionMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  cancelSubscriptionInput: V2CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type CancelSubscriptionByOrderIdMutationVariables = Exact<{
  input: CancelSubscriptionByOrderIdInput;
}>;


export type CancelSubscriptionByOrderIdMutation = { __typename?: 'Mutation', cancelSubscriptionByOrderId: { __typename?: 'CancelSubscriptionByOrderIdModel', status: string } };

export type ChangeAutoRenewalModeMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: ChangeAutoRenewalModeInput;
}>;


export type ChangeAutoRenewalModeMutation = { __typename?: 'Mutation', changeAutoRenewalMode: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } };

export type ChangeDeliveryStatusMutationVariables = Exact<{
  input: ChangeDeliveryStatusInput;
}>;


export type ChangeDeliveryStatusMutation = { __typename?: 'Mutation', changeDeliveryStatus: boolean };

export type ChangeDeliveryWindowMutationVariables = Exact<{
  input: ChangeDeliveryWindowInput;
}>;


export type ChangeDeliveryWindowMutation = { __typename?: 'Mutation', changeDeliveryWindow: boolean };

export type ChangeDeliveryWindowV2MutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  changeDeliveryWindow: V2ChangeDeliveryWindowInput;
}>;


export type ChangeDeliveryWindowV2Mutation = { __typename?: 'Mutation', changeDeliveryWindowV2?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type ChangeNewPriceOrderMutationVariables = Exact<{
  input: ChangeNewPriceOrderInput;
}>;


export type ChangeNewPriceOrderMutation = { __typename?: 'Mutation', changeNewPriceOrder: { __typename?: 'ChangeNewPriceOrderModel', oldStripePrescriptionId: string, orderPrescriptionPriceId: string } };

export type ChangeOrderRenewalDateMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  changeRenewalDateInput: ChangeRenewalDateInput;
}>;


export type ChangeOrderRenewalDateMutation = { __typename?: 'Mutation', changeOrderRenewalDate?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type ChangePrescriptionPriceMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  changePrescriptionPriceInput: V2ChangeOrderPrice;
}>;


export type ChangePrescriptionPriceMutation = { __typename?: 'Mutation', changePrescriptionPrice?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type ChangePriceKonbiniOrderMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: V2ChangePriceKonbiniOrderInput;
}>;


export type ChangePriceKonbiniOrderMutation = { __typename?: 'Mutation', changePriceKonbiniOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type ChangeRoInOpsMutationVariables = Exact<{
  input: ChangeRoInOpsInput;
}>;


export type ChangeRoInOpsMutation = { __typename?: 'Mutation', changeROInOps: boolean };

export type ChargeConsultFeeKonbiniOrderMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: V2ChargeConsultFeeKonbiniOrder;
}>;


export type ChargeConsultFeeKonbiniOrderMutation = { __typename?: 'Mutation', chargeConsultFeeKonbiniOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type CheckAvailableSupportCodMutationVariables = Exact<{
  input: V2CheckAvailableSupportCod;
}>;


export type CheckAvailableSupportCodMutation = { __typename?: 'Mutation', checkAvailableSupportCod?: { __typename?: 'CheckSupportCodDto', support: boolean } | null };

export type CheckValidAtomePaymentLinkMutationVariables = Exact<{
  checkAtomeInput: CheckValidAtomePaymentLinkInput;
}>;


export type CheckValidAtomePaymentLinkMutation = { __typename?: 'Mutation', checkValidAtomePaymentLink?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null };

export type CheckoutAnonymousMutationVariables = Exact<{
  input: CheckoutAnonymousInput;
}>;


export type CheckoutAnonymousMutation = { __typename?: 'Mutation', checkoutAnonymous: { __typename?: 'CheckoutAnonymousModel', orderSysId: string, patientSysId: string, success: boolean, totalAfterCashback?: number | null } };

export type CheckoutCartMutationVariables = Exact<{
  input: CheckoutCartInput;
}>;


export type CheckoutCartMutation = { __typename?: 'Mutation', checkoutCart: { __typename?: 'CheckoutCartMuationModel', cartId: string, orderIds?: Array<string | null> | null, totalAfterCashback?: number | null } };

export type CheckoutViaReceptionistMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  platform1?: InputMaybe<Scalars['String']>;
  platform2?: InputMaybe<Scalars['String']>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  id1?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id2?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  platform14?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform15?: InputMaybe<Scalars['String']>;
  videoLink1: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  input4?: InputMaybe<CrossSellRecordQueryInput>;
  orderId?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId2?: InputMaybe<Scalars['String']>;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date2?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date3?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  input5: V2ConsultationFilterInput;
  input6: ConsultationMessagesInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input7: ConsultationListInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input8: OrderInput;
  pagination: V2PaginationInput;
  date4?: InputMaybe<Scalars['String']>;
  date5?: InputMaybe<Scalars['Float']>;
  input9?: InputMaybe<GetPatientInput>;
  platform16?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<StripeProductFilterV2>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform17?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  checkoutSessionFilterOptions1?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  input17: GetPatientDocumentInput;
  evalFilter1?: InputMaybe<V2PatientEvaluationFilterInput>;
  id3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform18?: InputMaybe<Scalars['String']>;
  inputOrder2?: InputMaybe<V2OrderFilterInput>;
  orderPagination2?: InputMaybe<V2PaginationInput>;
  input18?: InputMaybe<PrescriptionCalculationInput>;
  platform19?: InputMaybe<Scalars['String']>;
  platform20?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<ShopProductFilterInputV2>;
  limit8?: InputMaybe<Scalars['Float']>;
  offset8?: InputMaybe<Scalars['Float']>;
  sort1?: InputMaybe<ShopProductSortInputV2>;
  input19: GetSmartMatchMetaInput;
  input20?: InputMaybe<PatientGetSurveyInput>;
  videoLink3: Scalars['String'];
  previewVideoLink1: Scalars['String'];
  input21?: InputMaybe<V2PresCheckoutViaReceptionistInput>;
}>;


export type CheckoutViaReceptionistMutation = { __typename?: 'Mutation', checkoutViaReceptionist?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null }> | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null> | null } | null, question?: { __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null }> | null, content?: { __typename?: 'ContentQuestionDto', body?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null, blockAnswer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, content?: { __typename?: 'EvaluationBlockContentDto', description?: string | null, descriptionTextKey?: string | null, sysId?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null }> | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null, card?: { __typename?: 'StripeCardDto', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, otcOrdersCalculation?: Array<{ __typename?: 'OTCOrderCalculationDto', basePrice?: number | null, cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmount?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, stripePromotionCode?: any | null, tax?: number | null, transactionFee?: number | null }> | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, rxOrdersCalculation?: Array<{ __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null }> | null } | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, items?: Array<{ __typename?: 'ReferralItemDto', orderId?: string | null, priceId?: string | null, referralSysId?: string | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null } | null> | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null } | null };

export type ClaimSubscriptionRetentionMutationVariables = Exact<{
  input: V2ClaimSubscriptionRetentionInput;
}>;


export type ClaimSubscriptionRetentionMutation = { __typename?: 'Mutation', claimSubscriptionRetention?: boolean | null };

export type CleanMissingPatientPaidEvalIdsMutationVariables = Exact<{ [key: string]: never; }>;


export type CleanMissingPatientPaidEvalIdsMutation = { __typename?: 'Mutation', cleanMissingPatientPaidEvalIds: boolean };

export type CompleteFollowUpConsultMutationVariables = Exact<{
  input: TriggerFollowUpConsultInput;
}>;


export type CompleteFollowUpConsultMutation = { __typename?: 'Mutation', completeFollowUpConsult: boolean };

export type ConfirmAtomeOrderMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: V2ConfirmAtomePaymentInput;
}>;


export type ConfirmAtomeOrderMutation = { __typename?: 'Mutation', confirmAtomeOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type ConfirmBloodDrawMutationVariables = Exact<{
  input: ConfirmBloodDrawInput;
}>;


export type ConfirmBloodDrawMutation = { __typename?: 'Mutation', confirmBloodDraw: { __typename?: 'BloodDrawConfirmationDto', confirmedAt?: any | null, drawType: TrtDrawType, orderSysId: string, sysId: string } };

export type ConfirmChangePrescriptionMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  confirmPrescriptionInput: V2ConfirmChangePrescriptionInput;
}>;


export type ConfirmChangePrescriptionMutation = { __typename?: 'Mutation', confirmChangePrescription?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type ConfirmChargeCovidPrescriptionOrderMutationVariables = Exact<{
  input: CovidOrderInput;
}>;


export type ConfirmChargeCovidPrescriptionOrderMutation = { __typename?: 'Mutation', confirmChargeCovidPrescriptionOrder: boolean };

export type ConfirmCodOrderMutationVariables = Exact<{
  input: V2ConfirmCodOrderInput;
}>;


export type ConfirmCodOrderMutation = { __typename?: 'Mutation', confirmCodOrder?: { __typename?: 'ConfirmCodDto', isSuccess: boolean } | null };

export type ConfirmCodOrder2MutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  confirmCodOrderInput: V2ConfirmCodOrderInput;
}>;


export type ConfirmCodOrder2Mutation = { __typename?: 'Mutation', confirmCodOrder2?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type ConfirmKonbiniOrderMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: ConfirmKonbiniOrderInput;
}>;


export type ConfirmKonbiniOrderMutation = { __typename?: 'Mutation', confirmKonbiniOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type CreateAffiliateMutationVariables = Exact<{
  input: CreateAffiliateInput;
}>;


export type CreateAffiliateMutation = { __typename?: 'Mutation', createAffiliate: { __typename?: 'Affiliate', createdAt: any, enabled: boolean, formFieldMap?: any | null, formSubmitUrl?: string | null, name: string, notificationChannel: AffiliateNotificationChannel, notificationEmail?: string | null, portalUrl: string, region: RegionType, slug: string, sysId: string, updatedAt: any } };

export type CreateAffiliateProductMutationVariables = Exact<{
  input: CreateAffiliateProductInput;
}>;


export type CreateAffiliateProductMutation = { __typename?: 'Mutation', createAffiliateProduct: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } };

export type CreateAnonymousPatientMutationVariables = Exact<{
  input: SignupAnonymousPatientInput;
}>;


export type CreateAnonymousPatientMutation = { __typename?: 'Mutation', createAnonymousPatient: { __typename?: 'CreateAnonymousPatientModel', stripeCustomerId?: string | null, success: boolean, sysId?: string | null } };

export type CreateAtomePaymentMutationVariables = Exact<{
  input: V2CreateAtomePaymentInput;
}>;


export type CreateAtomePaymentMutation = { __typename?: 'Mutation', createAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null };

export type CreateCheckoutSessionMutationVariables = Exact<{
  patientId?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  platform1?: InputMaybe<Scalars['String']>;
  platform2?: InputMaybe<Scalars['String']>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  videoLink1: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit1?: InputMaybe<Scalars['Int']>;
  offset1?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform6?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform7?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform8?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input11: ConsultationMessagesInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  input12: ConsultationListInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input13: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input14?: InputMaybe<GetPatientInput>;
  platform9?: InputMaybe<Scalars['String']>;
  input15?: InputMaybe<StripeProductFilterV2>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input16: V2ConsultationFilterInput;
  input17: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  input18: ConsultationListInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  input19: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input20?: InputMaybe<GetPatientInput>;
  platform10?: InputMaybe<Scalars['String']>;
  platform11?: InputMaybe<Scalars['String']>;
  input21?: InputMaybe<StripeProductFilterV2>;
  input22: V2ConsultationFilterInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  createCheckoutSessionInput: CreateCheckoutSessionInput;
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null };

export type CreateCompletedEvalMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  input: CreateCompletedEvalInput;
}>;


export type CreateCompletedEvalMutation = { __typename?: 'Mutation', createCompletedEval: { __typename?: 'CompletedEvalModel', completed?: boolean | null, createdAt?: any | null, evaluationFormLastUpdated?: any | null, evaluationId?: string | null, formQandA?: Array<any> | null, jumpToSectionIndex?: Array<number | null> | null, oldPatientId?: string | null, patient?: any | null, patientdoctorNotes?: string | null, questionTotal?: number | null, sectionHistory?: Array<number | null> | null, sectionIndex?: number | null, sectionTotal?: number | null, sysId?: string | null, updatedAt?: any | null, valid?: boolean | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null } | null } };

export type CreateCompletedEvalForGuestsMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  input: CreateCompletedEvalInputForGuest;
}>;


export type CreateCompletedEvalForGuestsMutation = { __typename?: 'Mutation', createCompletedEvalForGuests: { __typename?: 'CompletedEvalModel', completed?: boolean | null, createdAt?: any | null, evaluationFormLastUpdated?: any | null, evaluationId?: string | null, formQandA?: Array<any> | null, jumpToSectionIndex?: Array<number | null> | null, oldPatientId?: string | null, patient?: any | null, patientdoctorNotes?: string | null, questionTotal?: number | null, sectionHistory?: Array<number | null> | null, sectionIndex?: number | null, sectionTotal?: number | null, sysId?: string | null, updatedAt?: any | null, valid?: boolean | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null } | null } };

export type CreateDoctorMutationVariables = Exact<{
  videoLink: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink1: Scalars['String'];
  previewVideoLink: Scalars['String'];
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  patientId?: InputMaybe<Scalars['String']>;
  input4?: InputMaybe<CrossSellRecordQueryInput>;
  orderId?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId2?: InputMaybe<Scalars['String']>;
  limit1?: InputMaybe<Scalars['Int']>;
  offset1?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date2?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date3?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  input5: V2ConsultationFilterInput;
  input6: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input7: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input8: OrderInput;
  pagination: V2PaginationInput;
  date4?: InputMaybe<Scalars['String']>;
  date5?: InputMaybe<Scalars['Float']>;
  input9?: InputMaybe<GetPatientInput>;
  platform2?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<StripeProductFilterV2>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform3?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  videoLink3: Scalars['String'];
  patientId3?: InputMaybe<Scalars['String']>;
  input17: V2CreateDoctor;
}>;


export type CreateDoctorMutation = { __typename?: 'Mutation', createDoctor: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null }> | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } };

export type CreateEvaluationQuestionMutationVariables = Exact<{
  input: CreateEvaluationQuestionInput;
}>;


export type CreateEvaluationQuestionMutation = { __typename?: 'Mutation', createEvaluationQuestion: boolean };

export type CreateGiveawayRecordMutationVariables = Exact<{
  input: CreateGiveawayInput;
}>;


export type CreateGiveawayRecordMutation = { __typename?: 'Mutation', createGiveawayRecord: boolean };

export type CreateGuestEvaluationMutationVariables = Exact<{
  input: CreateGuestEvaluationInput;
}>;


export type CreateGuestEvaluationMutation = { __typename?: 'Mutation', createGuestEvaluation: boolean };

export type CreateInvoiceMutationVariables = Exact<{
  input: CreateInvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: boolean };

export type CreateJobMutationVariables = Exact<{
  input: CronjobInput;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'CronjobModel', createdAt?: any | null, createdBy?: string | null, description?: string | null, isActive?: boolean | null, name: string, updatedAt?: any | null, updatedBy?: string | null } };

export type CreateNewSurveyMutationVariables = Exact<{
  input: CreateNewSurveyInput;
}>;


export type CreateNewSurveyMutation = { __typename?: 'Mutation', createNewSurvey: boolean };

export type CreateOtcWalletOrderMutationVariables = Exact<{
  input: CreateOtcWalletOrderInput;
}>;


export type CreateOtcWalletOrderMutation = { __typename?: 'Mutation', createOTCWalletOrder: { __typename?: 'CreateOTCWalletOrderModel', otcWalletOrderId: string } };

export type CreateOrderMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } };

export type CreateOrderNoteMutationVariables = Exact<{
  input: CreateOrderNoteInput;
}>;


export type CreateOrderNoteMutation = { __typename?: 'Mutation', createOrderNote?: boolean | null };

export type CreateOrdersAfterTeleConsultMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: TeleConsultOrdersInput;
}>;


export type CreateOrdersAfterTeleConsultMutation = { __typename?: 'Mutation', createOrdersAfterTeleConsult: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }> };

export type CreatePartnerTrtOrderMutationVariables = Exact<{
  input: CreatePartnerTrtOrder;
}>;


export type CreatePartnerTrtOrderMutation = { __typename?: 'Mutation', createPartnerTRTOrder?: boolean | null };

export type CreatePatientDocumentMutationVariables = Exact<{
  input?: InputMaybe<CreatePatientDocumentInput>;
}>;


export type CreatePatientDocumentMutation = { __typename?: 'Mutation', createPatientDocument?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null };

export type CreatePatientFromOpsMutationVariables = Exact<{
  input: CreatePatientFromOpsInput;
}>;


export type CreatePatientFromOpsMutation = { __typename?: 'Mutation', createPatientFromOps: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } };

export type CreatePreblockMutationVariables = Exact<{
  input: CreatePreblockInput;
}>;


export type CreatePreblockMutation = { __typename?: 'Mutation', createPreblock: { __typename?: 'PreblockDto', expiresAt: string, heldAppointmentTypeId: string, heldDateTime: string, preblockId: string, status: PreblockStatus } };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null } };

export type CreateReferralDocumentsMutationVariables = Exact<{
  input?: InputMaybe<CreateReferralDocumentInput>;
}>;


export type CreateReferralDocumentsMutation = { __typename?: 'Mutation', createReferralDocuments: boolean };

export type CreateSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent: string };

export type CreateShipmentGroupMutationVariables = Exact<{
  input: CreateShipmentGroupInput;
}>;


export type CreateShipmentGroupMutation = { __typename?: 'Mutation', createShipmentGroup?: { __typename?: 'OrderShipmentGroupDto', bookingNo?: string | null, createdAt?: any | null, name: string, sysId: string, updatedAt?: any | null } | null };

export type CreateShipperMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  videoLink: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  platform2?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform3?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  videoLink1: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  orderId2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input10: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input11: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input12: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input13?: InputMaybe<GetPatientInput>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  input14?: InputMaybe<StripeProductFilterV2>;
  input15: V2ConsultationFilterInput;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  platform10?: InputMaybe<Scalars['String']>;
  platform11?: InputMaybe<Scalars['String']>;
  platform12?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input16: V2ConsultationFilterInput;
  input17: ConsultationMessagesInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input18: ConsultationListInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  input19: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input20?: InputMaybe<GetPatientInput>;
  platform13?: InputMaybe<Scalars['String']>;
  input21?: InputMaybe<StripeProductFilterV2>;
  platform14?: InputMaybe<Scalars['String']>;
  platform15?: InputMaybe<Scalars['String']>;
  platform16?: InputMaybe<Scalars['String']>;
  platform17?: InputMaybe<Scalars['String']>;
  platform18?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform19?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform20?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput6?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation7?: InputMaybe<V2ConsultationFilterInput>;
  platform21?: InputMaybe<Scalars['String']>;
  acuityAppointmentId6?: InputMaybe<Scalars['String']>;
  date12?: InputMaybe<Scalars['String']>;
  forDelivery6?: InputMaybe<Scalars['Boolean']>;
  isReschedule6?: InputMaybe<Scalars['Boolean']>;
  orderId7?: InputMaybe<Scalars['String']>;
  acuityAppointmentId7?: InputMaybe<Scalars['String']>;
  consultDate3?: InputMaybe<Scalars['Float']>;
  date13?: InputMaybe<Scalars['Float']>;
  forDelivery7?: InputMaybe<Scalars['Boolean']>;
  isReschedule7?: InputMaybe<Scalars['Boolean']>;
  orderId8?: InputMaybe<Scalars['String']>;
  input22: V2ConsultationFilterInput;
  input23: ConsultationMessagesInput;
  limit10?: InputMaybe<Scalars['Int']>;
  offset10?: InputMaybe<Scalars['Int']>;
  order9?: InputMaybe<Scalars['JSON']>;
  input24: ConsultationListInput;
  limit11?: InputMaybe<Scalars['Int']>;
  offset11?: InputMaybe<Scalars['Int']>;
  order10?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput6?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput7?: InputMaybe<V2DoctorInputFilter>;
  input25: OrderInput;
  pagination3: V2PaginationInput;
  date14?: InputMaybe<Scalars['String']>;
  date15?: InputMaybe<Scalars['Float']>;
  input26?: InputMaybe<GetPatientInput>;
  platform22?: InputMaybe<Scalars['String']>;
  input27?: InputMaybe<StripeProductFilterV2>;
  consultAuditFilterInput7?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation8?: InputMaybe<V2ConsultationFilterInput>;
  platform23?: InputMaybe<Scalars['String']>;
  input28?: InputMaybe<CrossSellRecordQueryInput>;
  acuityAppointmentId8?: InputMaybe<Scalars['String']>;
  date16?: InputMaybe<Scalars['String']>;
  forDelivery8?: InputMaybe<Scalars['Boolean']>;
  isReschedule8?: InputMaybe<Scalars['Boolean']>;
  orderId9?: InputMaybe<Scalars['String']>;
  acuityAppointmentId9?: InputMaybe<Scalars['String']>;
  consultDate4?: InputMaybe<Scalars['Float']>;
  date17?: InputMaybe<Scalars['Float']>;
  forDelivery9?: InputMaybe<Scalars['Boolean']>;
  isReschedule9?: InputMaybe<Scalars['Boolean']>;
  orderId10?: InputMaybe<Scalars['String']>;
  input29: V2ConsultationFilterInput;
  input30: ConsultationMessagesInput;
  limit12?: InputMaybe<Scalars['Int']>;
  offset12?: InputMaybe<Scalars['Int']>;
  order11?: InputMaybe<Scalars['JSON']>;
  input31: ConsultationListInput;
  limit13?: InputMaybe<Scalars['Int']>;
  offset13?: InputMaybe<Scalars['Int']>;
  order12?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput8?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput9?: InputMaybe<V2DoctorInputFilter>;
  input32: OrderInput;
  pagination4: V2PaginationInput;
  date18?: InputMaybe<Scalars['String']>;
  date19?: InputMaybe<Scalars['Float']>;
  input33?: InputMaybe<GetPatientInput>;
  platform24?: InputMaybe<Scalars['String']>;
  input34?: InputMaybe<StripeProductFilterV2>;
  input35?: InputMaybe<CreateShipperInput>;
}>;


export type CreateShipperMutation = { __typename?: 'Mutation', createShipper?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null, card?: { __typename?: 'StripeCardDto', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, items?: Array<{ __typename?: 'ReferralItemDto', orderId?: string | null, priceId?: string | null, referralSysId?: string | null, sysId?: string | null } | null> | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null }> | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, question?: { __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null }> | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null }> | null, content?: { __typename?: 'ContentQuestionDto', body?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null, blockAnswer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null, content?: { __typename?: 'EvaluationBlockContentDto', description?: string | null, descriptionTextKey?: string | null, sysId?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, lines?: { __typename?: 'StripeInvoiceLineDto', data?: Array<{ __typename?: 'StripeInvoiceLineItemDto', amount?: number | null, discount?: string | null, plan?: { __typename?: 'StripePlanDto', active?: boolean | null, id?: string | null, metadata?: any | null } | null } | null> | null } | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null } | null }> | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null };

export type CreateStripeCouponMutationVariables = Exact<{
  input: CreateStripeCouponInput;
}>;


export type CreateStripeCouponMutation = { __typename?: 'Mutation', createStripeCoupon: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null } | null> | null } | null } | null> | null } };

export type CreateStripePriceMutationVariables = Exact<{
  input: CreateStripePriceInput;
}>;


export type CreateStripePriceMutation = { __typename?: 'Mutation', createStripePrice: string };

export type CreateStripeProductMutationVariables = Exact<{
  input: CreateStripeProductInput;
}>;


export type CreateStripeProductMutation = { __typename?: 'Mutation', createStripeProduct: string };

export type CreateStripePromotionCodeMutationVariables = Exact<{
  input: CreateStripePromotionCodeInput;
}>;


export type CreateStripePromotionCodeMutation = { __typename?: 'Mutation', createStripePromotionCode: { __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null } | null } | null> | null } | null } };

export type CreateSurveyMutationVariables = Exact<{
  input: CreateSurveyInput;
}>;


export type CreateSurveyMutation = { __typename?: 'Mutation', createSurvey: boolean };

export type DeleteAuditDoctorNoteMutationVariables = Exact<{
  sysId: Scalars['String'];
}>;


export type DeleteAuditDoctorNoteMutation = { __typename?: 'Mutation', deleteAuditDoctorNote: boolean };

export type DeleteCartItemByIdMutationVariables = Exact<{
  input: DeleteCartItemByIdInput;
}>;


export type DeleteCartItemByIdMutation = { __typename?: 'Mutation', deleteCartItemById: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null } };

export type DeleteCompletedEvalMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteCompletedEvalMutation = { __typename?: 'Mutation', deleteCompletedEval: boolean };

export type DeleteOrderMutationVariables = Exact<{
  input: DeleteOrderInput;
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: boolean };

export type DeleteOrderPermanentMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type DeleteOrderPermanentMutation = { __typename?: 'Mutation', deleteOrderPermanent: boolean };

export type DeletePatientMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type DeletePatientMutation = { __typename?: 'Mutation', deletePatient: boolean };

export type DeletePatientQuestionAnswerMutationVariables = Exact<{
  input: DeletePatientQuestionAnswerInput;
}>;


export type DeletePatientQuestionAnswerMutation = { __typename?: 'Mutation', deletePatientQuestionAnswer: boolean };

export type DeleteStripeCouponMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteStripeCouponMutation = { __typename?: 'Mutation', deleteStripeCoupon: boolean };

export type DeleteStripePriceMutationVariables = Exact<{
  input: DeletePriceInput;
}>;


export type DeleteStripePriceMutation = { __typename?: 'Mutation', deleteStripePrice: boolean };

export type DeleteStripeProductMutationVariables = Exact<{
  input: DeleteProductInput;
}>;


export type DeleteStripeProductMutation = { __typename?: 'Mutation', deleteStripeProduct: boolean };

export type DeleteTrtDocumentMutationVariables = Exact<{
  documentSysId: Scalars['String'];
}>;


export type DeleteTrtDocumentMutation = { __typename?: 'Mutation', deleteTrtDocument: boolean };

export type DeleteUserMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type DeliveryChargeMutationVariables = Exact<{
  input?: InputMaybe<PatientIdInput>;
}>;


export type DeliveryChargeMutation = { __typename?: 'Mutation', deliveryCharge?: boolean | null };

export type DeliveryChargeV2MutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  deliveryChargeV2: V2DeliveryCharge;
}>;


export type DeliveryChargeV2Mutation = { __typename?: 'Mutation', deliveryChargeV2?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type DestroyFcMtokenMutationVariables = Exact<{
  input: FcmTokenInput;
}>;


export type DestroyFcMtokenMutation = { __typename?: 'Mutation', destroyFCMtoken: string };

export type DisableProductMutationVariables = Exact<{
  productName: Scalars['String'];
}>;


export type DisableProductMutation = { __typename?: 'Mutation', disableProduct: boolean };

export type DuplicateStripePriceMutationVariables = Exact<{
  input: DuplicateStripePriceInput;
}>;


export type DuplicateStripePriceMutation = { __typename?: 'Mutation', duplicateStripePrice: string };

export type GenerateSmartMatchResultsMutationVariables = Exact<{
  platform?: InputMaybe<Scalars['String']>;
  platform1?: InputMaybe<Scalars['String']>;
  platform2?: InputMaybe<Scalars['String']>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  input: GenerateSmartMatchResultsInput;
}>;


export type GenerateSmartMatchResultsMutation = { __typename?: 'Mutation', generateSmartMatchResults: { __typename?: 'SmartMatchDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType, smartMatchResults: { __typename?: 'SmartMatchResult', analysis: Array<string>, nextSteps: Array<{ __typename?: 'NextSteps', evidence: string, text: string }>, primaryProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, secondaryProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null } } };

export type GetLastInvoiceDateMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type GetLastInvoiceDateMutation = { __typename?: 'Mutation', getLastInvoiceDate?: { __typename?: 'StripeInvoiceModel', auto_advance?: boolean | null, charge?: string | null, collection_method?: string | null, created?: number | null, currency?: string | null, description?: string | null, hosted_invoice_url?: string | null, id?: string | null, lines?: any | null, metadata?: any | null, next_payment_attempt?: number | null, payment_intent?: string | null, period_end?: number | null, period_start?: number | null, status?: string | null, subscription?: string | null, total?: number | null } | null };

export type GetUpcomingInvoiceDateMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type GetUpcomingInvoiceDateMutation = { __typename?: 'Mutation', getUpcomingInvoiceDate?: { __typename?: 'StripeInvoiceModel', auto_advance?: boolean | null, charge?: string | null, collection_method?: string | null, created?: number | null, currency?: string | null, description?: string | null, hosted_invoice_url?: string | null, id?: string | null, lines?: any | null, metadata?: any | null, next_payment_attempt?: number | null, payment_intent?: string | null, period_end?: number | null, period_start?: number | null, status?: string | null, subscription?: string | null, total?: number | null } | null };

export type GuestFirstCheckoutMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  platform1?: InputMaybe<Scalars['String']>;
  platform2?: InputMaybe<Scalars['String']>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  id1?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id2?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  platform14?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform15?: InputMaybe<Scalars['String']>;
  videoLink1: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  input4?: InputMaybe<CrossSellRecordQueryInput>;
  orderId?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId2?: InputMaybe<Scalars['String']>;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date2?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date3?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  input5: V2ConsultationFilterInput;
  input6: ConsultationMessagesInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input7: ConsultationListInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input8: OrderInput;
  pagination: V2PaginationInput;
  date4?: InputMaybe<Scalars['String']>;
  date5?: InputMaybe<Scalars['Float']>;
  input9?: InputMaybe<GetPatientInput>;
  platform16?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<StripeProductFilterV2>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform17?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  checkoutSessionFilterOptions1?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  input17: GetPatientDocumentInput;
  evalFilter1?: InputMaybe<V2PatientEvaluationFilterInput>;
  id3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform18?: InputMaybe<Scalars['String']>;
  inputOrder2?: InputMaybe<V2OrderFilterInput>;
  orderPagination2?: InputMaybe<V2PaginationInput>;
  input18?: InputMaybe<PrescriptionCalculationInput>;
  platform19?: InputMaybe<Scalars['String']>;
  platform20?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<ShopProductFilterInputV2>;
  limit8?: InputMaybe<Scalars['Float']>;
  offset8?: InputMaybe<Scalars['Float']>;
  sort1?: InputMaybe<ShopProductSortInputV2>;
  input19: GetSmartMatchMetaInput;
  input20?: InputMaybe<PatientGetSurveyInput>;
  videoLink3: Scalars['String'];
  previewVideoLink1: Scalars['String'];
  input21: GuestRegisterAndEvalResultInput;
}>;


export type GuestFirstCheckoutMutation = { __typename?: 'Mutation', guestFirstCheckout?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null }> | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null> | null } | null, question?: { __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null }> | null, content?: { __typename?: 'ContentQuestionDto', body?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null, blockAnswer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, content?: { __typename?: 'EvaluationBlockContentDto', description?: string | null, descriptionTextKey?: string | null, sysId?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null }> | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null, card?: { __typename?: 'StripeCardDto', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, otcOrdersCalculation?: Array<{ __typename?: 'OTCOrderCalculationDto', basePrice?: number | null, cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmount?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, stripePromotionCode?: any | null, tax?: number | null, transactionFee?: number | null }> | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, rxOrdersCalculation?: Array<{ __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null }> | null } | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, items?: Array<{ __typename?: 'ReferralItemDto', orderId?: string | null, priceId?: string | null, referralSysId?: string | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null } | null> | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null } | null };

export type HosOpsAlertActionMutationVariables = Exact<{
  alertId: Scalars['ID'];
  action: HosOpsAlertAction;
  note?: InputMaybe<Scalars['String']>;
}>;


export type HosOpsAlertActionMutation = { __typename?: 'Mutation', hosOpsAlertAction: { __typename?: 'HosOpsAlert', id: string, kind: HosOpsAlertKind, patientLabel: string, flagId?: string | null, flagState?: HosSafetyFlagState | null, flagLive: boolean, flagOpsClearable: boolean, ruleId?: string | null, severity: HosSafetySeverity, source: HosSafetySource, status: HosOpsAlertStatus, summary?: string | null, classifierRationale?: string | null, instructionCopyKey?: string | null, playbookCopyKeys: Array<string>, slackPosted: boolean, freshchatConversationId?: string | null, patientChannels: Array<string>, opsChannels: Array<string>, patientAcknowledgedAt?: any | null, firedAt: any, lastSeenAt: any, recurrenceCount: number, ackedAt?: any | null, ackedBy?: string | null, closedAt?: any | null, playbookSteps: Array<{ __typename?: 'HosOpsAlertPlaybookStep', order?: number | null, instruction?: string | null, owner?: string | null, slaMinutes?: number | null, copyKey?: string | null }>, deliveries: Array<{ __typename?: 'HosOpsAlertDelivery', channel: HosNotificationChannel, status: HosNotificationStatus, providerId?: string | null, attemptedAt: any, reason?: string | null }>, actionEntries: Array<{ __typename?: 'HosOpsAlertActionEntry', action: HosOpsAlertAction, note?: string | null, actor: string, at: any }> } };

export type HosOpsAlertClearFlagMutationVariables = Exact<{
  alertId: Scalars['ID'];
  reason: HosOpsFlagClearReason;
  note?: InputMaybe<Scalars['String']>;
}>;


export type HosOpsAlertClearFlagMutation = { __typename?: 'Mutation', hosOpsAlertClearFlag: { __typename?: 'HosOpsAlert', id: string, kind: HosOpsAlertKind, patientLabel: string, flagId?: string | null, flagState?: HosSafetyFlagState | null, flagLive: boolean, flagOpsClearable: boolean, ruleId?: string | null, severity: HosSafetySeverity, source: HosSafetySource, status: HosOpsAlertStatus, summary?: string | null, classifierRationale?: string | null, instructionCopyKey?: string | null, playbookCopyKeys: Array<string>, slackPosted: boolean, freshchatConversationId?: string | null, patientChannels: Array<string>, opsChannels: Array<string>, patientAcknowledgedAt?: any | null, firedAt: any, lastSeenAt: any, recurrenceCount: number, ackedAt?: any | null, ackedBy?: string | null, closedAt?: any | null, playbookSteps: Array<{ __typename?: 'HosOpsAlertPlaybookStep', order?: number | null, instruction?: string | null, owner?: string | null, slaMinutes?: number | null, copyKey?: string | null }>, deliveries: Array<{ __typename?: 'HosOpsAlertDelivery', channel: HosNotificationChannel, status: HosNotificationStatus, providerId?: string | null, attemptedAt: any, reason?: string | null }>, actionEntries: Array<{ __typename?: 'HosOpsAlertActionEntry', action: HosOpsAlertAction, note?: string | null, actor: string, at: any }> } };

export type HosOpsAlertRevealMutationVariables = Exact<{
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type HosOpsAlertRevealMutation = { __typename?: 'Mutation', hosOpsAlertReveal: { __typename?: 'HosOpsAlertReveal', alertId: string, sourceText?: string | null, revealedAt: any } };

export type ImpersonateMutationVariables = Exact<{
  input: ImpersonateInput;
}>;


export type ImpersonateMutation = { __typename?: 'Mutation', impersonate: { __typename?: 'TokenModel', accessToken: string, accessTokenExpiredAt: number, refreshToken: string, user: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } } };

export type ImportProductsAndPricesMutationVariables = Exact<{
  input: V2ImportProductPricesInput;
}>;


export type ImportProductsAndPricesMutation = { __typename?: 'Mutation', importProductsAndPrices?: { __typename?: 'ImportProductsPricesDto', importErrors?: Array<{ __typename?: 'ImportProductPricesErrorDto', error?: any | null, importPriceId?: string | null, productId?: string | null }> | null } | null };

export type InsertCartItemByIdMutationVariables = Exact<{
  input: InsertCartItemByIdInput;
}>;


export type InsertCartItemByIdMutation = { __typename?: 'Mutation', insertCartItemById: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null } };

export type IsAutoRenewalSubMutationVariables = Exact<{
  input: IsAutoRenewalSubInput;
}>;


export type IsAutoRenewalSubMutation = { __typename?: 'Mutation', isAutoRenewalSub: boolean };

export type LogInMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LogInMutation = { __typename?: 'Mutation', logIn: { __typename?: 'TokenModel', accessToken: string, accessTokenExpiredAt: number, refreshToken: string, user: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } } };

export type LogInGoogleMutationVariables = Exact<{
  input: LoginSocialInput;
}>;


export type LogInGoogleMutation = { __typename?: 'Mutation', logInGoogle: { __typename?: 'TokenModel', accessToken: string, accessTokenExpiredAt: number, refreshToken: string, user: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } } };

export type LogInLineMutationVariables = Exact<{
  input: LoginSocialInput;
}>;


export type LogInLineMutation = { __typename?: 'Mutation', logInLine: { __typename?: 'TokenModel', accessToken: string, accessTokenExpiredAt: number, refreshToken: string, user: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } } };

export type LogOutUserSessionMutationVariables = Exact<{
  input: LogOutUserSessionInput;
}>;


export type LogOutUserSessionMutation = { __typename?: 'Mutation', logOutUserSession: boolean };

export type MarkNoShowMutationVariables = Exact<{
  input: MarkNoShowInput;
}>;


export type MarkNoShowMutation = { __typename?: 'Mutation', markNoShow: boolean };

export type MarkRetentionPromoRedeemedMutationVariables = Exact<{
  input: MarkRetentionPromoRedeemedInput;
}>;


export type MarkRetentionPromoRedeemedMutation = { __typename?: 'Mutation', markRetentionPromoRedeemed?: boolean | null };

export type MassUpdateCustomerBalanceMutationVariables = Exact<{
  input: UpdateCustomerBalanceInput;
}>;


export type MassUpdateCustomerBalanceMutation = { __typename?: 'Mutation', massUpdateCustomerBalance: { __typename?: 'AddCashbackReturnModel', errorCustomers?: Array<string | null> | null, notFoundCustomers?: Array<string | null> | null, success: boolean } };

export type MigrateArchivePricesMutationVariables = Exact<{ [key: string]: never; }>;


export type MigrateArchivePricesMutation = { __typename?: 'Mutation', migrateArchivePrices?: boolean | null };

export type MigrateDoctorToTwilioUserMutationVariables = Exact<{ [key: string]: never; }>;


export type MigrateDoctorToTwilioUserMutation = { __typename?: 'Mutation', migrateDoctorToTwilioUser: boolean };

export type MigratePausedToActiveMutationVariables = Exact<{ [key: string]: never; }>;


export type MigratePausedToActiveMutation = { __typename?: 'Mutation', migratePausedToActive: boolean };

export type MigrateProductIncludedMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type MigrateProductIncludedMutation = { __typename?: 'Mutation', migrateProductIncluded?: boolean | null };

export type MigrateUserToTwilioUserMutationVariables = Exact<{ [key: string]: never; }>;


export type MigrateUserToTwilioUserMutation = { __typename?: 'Mutation', migrateUserToTwilioUser: boolean };

export type OpsChangeDeliveryWindowMutationVariables = Exact<{
  input: OpsChangeDeliveryWindowInput;
}>;


export type OpsChangeDeliveryWindowMutation = { __typename?: 'Mutation', opsChangeDeliveryWindow: boolean };

export type OpsChargeOtcOrderMutationVariables = Exact<{
  input: OpsChargeOtcOrderInput;
}>;


export type OpsChargeOtcOrderMutation = { __typename?: 'Mutation', opsChargeOTCOrder: boolean };

export type PartnerBookConsultationMutationVariables = Exact<{
  platform?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  patientId?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input12: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input13: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input14?: InputMaybe<GetPatientInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input15?: InputMaybe<StripeProductFilterV2>;
  input16: V2ConsultationFilterInput;
  videoLink1: Scalars['String'];
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input17: CreatePartnerConsultation;
}>;


export type PartnerBookConsultationMutation = { __typename?: 'Mutation', partnerBookConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null }> | null } | null } | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null };

export type PauseAndResumeSubscriptionMutationVariables = Exact<{
  input: PauseAndResumeSubscriptionInput;
}>;


export type PauseAndResumeSubscriptionMutation = { __typename?: 'Mutation', pauseAndResumeSubscription: boolean };

export type PendingOrderMutationVariables = Exact<{
  input: PendingOrderInput;
}>;


export type PendingOrderMutation = { __typename?: 'Mutation', pendingOrder?: boolean | null };

export type PortEmailMutationVariables = Exact<{
  input: PortEmailInput;
}>;


export type PortEmailMutation = { __typename?: 'Mutation', portEmail: boolean };

export type PrescriptionCheckoutMutationVariables = Exact<{
  input: PrescriptionCheckoutInput;
}>;


export type PrescriptionCheckoutMutation = { __typename?: 'Mutation', prescriptionCheckout: { __typename?: 'PrescriptionCheckoutModel', orderId: string, textConversationId?: string | null, totalAfterCashback?: number | null } };

export type PrescriptionCheckoutV2MutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17?: InputMaybe<V2PresCheckoutInput>;
}>;


export type PrescriptionCheckoutV2Mutation = { __typename?: 'Mutation', prescriptionCheckoutV2?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type ProcessCartByOtcWalletMutationVariables = Exact<{
  input: ProcessCartByOtCwalletInput;
}>;


export type ProcessCartByOtcWalletMutation = { __typename?: 'Mutation', processCartByOTCWallet: { __typename?: 'ProcessCartByOTCWalletModel', cartId: string } };

export type ReAssignDoctorForNoteMutationVariables = Exact<{
  input: UpdateDoctorForAuditDoctorNoteInput;
}>;


export type ReAssignDoctorForNoteMutation = { __typename?: 'Mutation', reAssignDoctorForNote: boolean };

export type ReAssignTextConsultationDoctorMutationVariables = Exact<{
  input: ReAssignTextConsultationDoctorInput;
}>;


export type ReAssignTextConsultationDoctorMutation = { __typename?: 'Mutation', reAssignTextConsultationDoctor: boolean };

export type ReactivateMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  reactivateInput: V2ReactivateOrderInput;
}>;


export type ReactivateMutation = { __typename?: 'Mutation', reactivate?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type ReactivateCanceledOrderV2MutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: ReactivateCanceledOrderInputV2;
}>;


export type ReactivateCanceledOrderV2Mutation = { __typename?: 'Mutation', reactivateCanceledOrderV2: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } };

export type RecordBloodPressureMutationVariables = Exact<{
  input: RecordBloodPressureInput;
}>;


export type RecordBloodPressureMutation = { __typename?: 'Mutation', recordBloodPressure: { __typename?: 'PatientVitalDto', diastolic?: number | null, recordedAt: any, source: PatientVitalSource, sysId: string, systolic?: number | null, type: PatientVitalType } };

export type RecordDoseStartMutationVariables = Exact<{
  input: RecordDoseStartInput;
}>;


export type RecordDoseStartMutation = { __typename?: 'Mutation', recordDoseStart: { __typename?: 'DoseStartDto', doseStartedAt?: any | null, orderSysId: string } };

export type RecreateAtomePaymentLinkMutationVariables = Exact<{
  recreateAtomeInput: RenewAtomePaymentLinkInput;
}>;


export type RecreateAtomePaymentLinkMutation = { __typename?: 'Mutation', recreateAtomePaymentLink?: string | null };

export type RefreshAccessTokenMutationVariables = Exact<{
  input: RefreshAccessTokenInput;
}>;


export type RefreshAccessTokenMutation = { __typename?: 'Mutation', refreshAccessToken: { __typename?: 'TokenModel', accessToken: string, accessTokenExpiredAt: number, refreshToken: string, user: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } } };

export type RefundChargedForAdminMutationVariables = Exact<{
  input: PaymentRefundInput;
}>;


export type RefundChargedForAdminMutation = { __typename?: 'Mutation', refundChargedForAdmin: boolean };

export type RefundInvoiceForAdminMutationVariables = Exact<{
  input: PaymentRefundInput;
}>;


export type RefundInvoiceForAdminMutation = { __typename?: 'Mutation', refundInvoiceForAdmin: boolean };

export type RefundOtcWalletOrderMutationVariables = Exact<{
  input: RefundOtcWalletOrderInput;
}>;


export type RefundOtcWalletOrderMutation = { __typename?: 'Mutation', refundOTCWalletOrder: { __typename?: 'RefundOTCWalletPayOrderModel', success: boolean } };

export type RefundPaymentIntentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RefundPaymentIntentMutation = { __typename?: 'Mutation', refundPaymentIntent: boolean };

export type RefundPaymentIntentForAdminMutationVariables = Exact<{
  input: PaymentRefundInput;
}>;


export type RefundPaymentIntentForAdminMutation = { __typename?: 'Mutation', refundPaymentIntentForAdmin: boolean };

export type RefundPaymentIntentForAnonymousMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RefundPaymentIntentForAnonymousMutation = { __typename?: 'Mutation', refundPaymentIntentForAnonymous: { __typename?: 'RefundPaymentIntentForAnonymousModel', success: boolean } };

export type RegisterDoctorMutationVariables = Exact<{
  input: RegisterDoctorInput;
}>;


export type RegisterDoctorMutation = { __typename?: 'Mutation', registerDoctor: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } };

export type RegisterFcMtokenMutationVariables = Exact<{
  input: FcmTokenInput;
}>;


export type RegisterFcMtokenMutation = { __typename?: 'Mutation', registerFCMtoken: string };

export type RegisterPatientMutationVariables = Exact<{
  input: RegisterPatientInput;
}>;


export type RegisterPatientMutation = { __typename?: 'Mutation', registerPatient: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } };

export type RegisterUserSessionMutationVariables = Exact<{
  input: RegisterUserSessionInput;
}>;


export type RegisterUserSessionMutation = { __typename?: 'Mutation', registerUserSession: { __typename?: 'UserSessionDto', appVersion?: string | null, clientType?: ClientType | null, createdAt?: any | null, createdBy?: string | null, deviceId?: string | null, deviceNotificationToken?: string | null, lastLogin?: any | null, lastLogout?: any | null, sysId?: string | null, updatedAt?: any | null, updatedBy?: string | null } };

export type RejectPrescriptionOrderMutationVariables = Exact<{
  input: RejectOrderInput;
}>;


export type RejectPrescriptionOrderMutation = { __typename?: 'Mutation', rejectPrescriptionOrder: boolean };

export type ReleasePreblockMutationVariables = Exact<{
  input: ReleasePreblockInput;
}>;


export type ReleasePreblockMutation = { __typename?: 'Mutation', releasePreblock: boolean };

export type RemoveCardDetailPatientMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RemoveCardDetailPatientMutation = { __typename?: 'Mutation', removeCardDetailPatient: boolean };

export type RenewMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  renewInput: V2RenewCodOrderInput;
}>;


export type RenewMutation = { __typename?: 'Mutation', renew?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type RenewAtomeOrderMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: V2RenewAtomeOrder;
}>;


export type RenewAtomeOrderMutation = { __typename?: 'Mutation', renewAtomeOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type RenewCodOrderMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17?: InputMaybe<V2RenewCodOrderInput>;
}>;


export type RenewCodOrderMutation = { __typename?: 'Mutation', renewCodOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type RenewCodOrdersMutationVariables = Exact<{
  platform?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  videoLink1: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  input4?: InputMaybe<CrossSellRecordQueryInput>;
  orderId?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId2?: InputMaybe<Scalars['String']>;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date2?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date3?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  input5: V2ConsultationFilterInput;
  input6: ConsultationMessagesInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input7: ConsultationListInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input8: OrderInput;
  pagination: V2PaginationInput;
  date4?: InputMaybe<Scalars['String']>;
  date5?: InputMaybe<Scalars['Float']>;
  input9?: InputMaybe<GetPatientInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<StripeProductFilterV2>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  input17: V2RenewMultipleCodOrdersInput;
}>;


export type RenewCodOrdersMutation = { __typename?: 'Mutation', renewCodOrders?: { __typename?: 'RenewMultipleOrdersResponse', results: Array<{ __typename?: 'RenewOrderResponse', errorMessage?: string | null, isSuccess?: boolean | null, orderId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null }> } | null };

export type RenewKonbiniOrderMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: V2RenewKonbiniOrderInput;
}>;


export type RenewKonbiniOrderMutation = { __typename?: 'Mutation', renewKonbiniOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type RenewOrderByOpsMutationVariables = Exact<{
  input: RenewOrderByOpsInput;
}>;


export type RenewOrderByOpsMutation = { __typename?: 'Mutation', renewOrderByOps: boolean };

export type RenewOrderByPatientMutationVariables = Exact<{
  input: RenewOrderByPatientInput;
}>;


export type RenewOrderByPatientMutation = { __typename?: 'Mutation', renewOrderByPatient: boolean };

export type RequestEmailOtpMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestEmailOtpMutation = { __typename?: 'Mutation', requestEmailOTP: boolean };

export type RequestFollowUpConsultMutationVariables = Exact<{
  input: TriggerFollowUpConsultInput;
}>;


export type RequestFollowUpConsultMutation = { __typename?: 'Mutation', requestFollowUpConsult: boolean };

export type RequestFollowUpConsultV2MutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  requestFollowUpConsultInput: RequestFollowUpConsultInput;
}>;


export type RequestFollowUpConsultV2Mutation = { __typename?: 'Mutation', requestFollowUpConsultV2?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type RequestMagicLinkMutationVariables = Exact<{
  input: RequestMagicLinkInput;
}>;


export type RequestMagicLinkMutation = { __typename?: 'Mutation', requestMagicLink: boolean };

export type RequestUpgradeSettingsLinkMutationVariables = Exact<{
  input: RequestUpgradeSettingsLinkInput;
}>;


export type RequestUpgradeSettingsLinkMutation = { __typename?: 'Mutation', requestUpgradeSettingsLink?: string | null };

export type RescheduleAppointmentMutationVariables = Exact<{
  input: RescheduleAppointmentInput;
}>;


export type RescheduleAppointmentMutation = { __typename?: 'Mutation', rescheduleAppointment: boolean };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordUserInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type ResetPasswordWithTokenMutationVariables = Exact<{
  input: ResetPasswordWithTokenInput;
}>;


export type ResetPasswordWithTokenMutation = { __typename?: 'Mutation', resetPasswordWithToken: boolean };

export type ResubscribeCanceledOtcOrderMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: ReactivateCanceledOtcOrderInputV2;
}>;


export type ResubscribeCanceledOtcOrderMutation = { __typename?: 'Mutation', resubscribeCanceledOTCOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } };

export type SaveTranslationMutationVariables = Exact<{
  input: SaveTranslationInput;
}>;


export type SaveTranslationMutation = { __typename?: 'Mutation', saveTranslation: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } };

export type SendAutomatedMessageMutationVariables = Exact<{ [key: string]: never; }>;


export type SendAutomatedMessageMutation = { __typename?: 'Mutation', sendAutomatedMessage: boolean };

export type SendEmailAboutNewMessageMutationVariables = Exact<{
  input: SendEmailAboutNewMessageInput;
}>;


export type SendEmailAboutNewMessageMutation = { __typename?: 'Mutation', sendEmailAboutNewMessage: boolean };

export type SendReminderUnreadDrMessageMutationVariables = Exact<{
  input: SendReminderUnreadDrMessageInput;
}>;


export type SendReminderUnreadDrMessageMutation = { __typename?: 'Mutation', sendReminderUnreadDrMessage: boolean };

export type SendResetPasswordEmailMutationVariables = Exact<{
  input: ForgotPasswordUserInput;
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail: boolean };

export type SendShipmentSmsMutationVariables = Exact<{
  platform?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  videoLink1: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  input4?: InputMaybe<CrossSellRecordQueryInput>;
  orderId?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId2?: InputMaybe<Scalars['String']>;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date2?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date3?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  input5: V2ConsultationFilterInput;
  input6: ConsultationMessagesInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input7: ConsultationListInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input8: OrderInput;
  pagination: V2PaginationInput;
  date4?: InputMaybe<Scalars['String']>;
  date5?: InputMaybe<Scalars['Float']>;
  input9?: InputMaybe<GetPatientInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<StripeProductFilterV2>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  platform14?: InputMaybe<Scalars['String']>;
  platform15?: InputMaybe<Scalars['String']>;
  platform16?: InputMaybe<Scalars['String']>;
  platform17?: InputMaybe<Scalars['String']>;
  platform18?: InputMaybe<Scalars['String']>;
  platform19?: InputMaybe<Scalars['String']>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input17: V2ConsultationFilterInput;
  input18: ConsultationMessagesInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input19: ConsultationListInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform20?: InputMaybe<Scalars['String']>;
  input20: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input21?: InputMaybe<GetPatientInput>;
  platform21?: InputMaybe<Scalars['String']>;
  platform22?: InputMaybe<Scalars['String']>;
  input22?: InputMaybe<StripeProductFilterV2>;
  input23: SendShipmentSmsInput;
}>;


export type SendShipmentSmsMutation = { __typename?: 'Mutation', sendShipmentSMS: Array<{ __typename?: 'OrderShipmentDto', address: any, cost: number, courierName?: CourierName | null, createdAt?: any | null, deliveryMethod?: DeliveryMethod | null, deliveryTimestamp?: any | null, estimatedShipDate?: any | null, note?: string | null, parcelId: string, paused: boolean, shipDate?: any | null, status: string, sysId: string, trackingNo?: string | null, updatedAt?: any | null, group?: { __typename?: 'OrderShipmentGroupDto', bookingNo?: string | null, createdAt?: any | null, name: string, sysId: string, updatedAt?: any | null } | null, items?: Array<{ __typename?: 'OrderShipmentItemDto', createdAt?: any | null, dosage?: any | null, isFirstPurchase: boolean, orderNo: number, orderSysId: string, paymentAmount?: number | null, paymentDate?: any | null, paymentIntentId?: string | null, paymentProvider: PaymentProvider, priceId: string, promotionCode?: string | null, qty: number, sysId: string, updatedAt?: any | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null, price?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null }> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, shipper?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, otcOrdersCalculation?: Array<{ __typename?: 'OTCOrderCalculationDto', basePrice?: number | null, cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmount?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, stripePromotionCode?: any | null, tax?: number | null, transactionFee?: number | null }> | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, rxOrdersCalculation?: Array<{ __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null }> | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null } | null }> };

export type SendToDetrackAndProcessingDeliveryMutationVariables = Exact<{
  input: SendToDetrackInput;
}>;


export type SendToDetrackAndProcessingDeliveryMutation = { __typename?: 'Mutation', sendToDetrackAndProcessingDelivery: boolean };

export type SetDoctorTrtEligibleMutationVariables = Exact<{
  doctorSysId: Scalars['String'];
  trtEligible: Scalars['Boolean'];
}>;


export type SetDoctorTrtEligibleMutation = { __typename?: 'Mutation', setDoctorTrtEligible: boolean };

export type SetTrtOrderStatusMutationVariables = Exact<{
  input: SetTrtOrderStatusInput;
}>;


export type SetTrtOrderStatusMutation = { __typename?: 'Mutation', setTrtOrderStatus: { __typename?: 'TrtOrderDto', createdAt?: any | null, isFollowUp: boolean, isTestOrder: boolean, paid: boolean, shortId?: number | null, status: OrderStatus, sysId: string, documents: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }>, drawConfirmations: Array<{ __typename?: 'BloodDrawConfirmationDto', confirmedAt?: any | null, drawType: TrtDrawType, orderSysId: string, sysId: string }>, latestBloodPressure?: { __typename?: 'PatientVitalDto', diastolic?: number | null, recordedAt: any, source: PatientVitalSource, sysId: string, systolic?: number | null, type: PatientVitalType } | null, patient?: { __typename?: 'TrtOrderPatientDto', dob?: string | null, email?: string | null, firstName?: string | null, gender?: Gender | null, hasIdentificationImage: boolean, icNumber?: string | null, idVerifiedAt?: any | null, lastName?: string | null, legalName?: string | null, sysId?: string | null } | null, skus: Array<{ __typename?: 'TrtOrderSkuDto', name?: string | null, priceId?: string | null, slot: string }> } };

export type SignInAnonymousUserMutationVariables = Exact<{ [key: string]: never; }>;


export type SignInAnonymousUserMutation = { __typename?: 'Mutation', signInAnonymousUser: { __typename?: 'SignInUserModel', accessToken?: string | null, accessTokenExpiredAt?: number | null, refreshToken?: string | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } };

export type SignInWithMagicLinkMutationVariables = Exact<{
  input: SignInWithMagicLinkInput;
}>;


export type SignInWithMagicLinkMutation = { __typename?: 'Mutation', signInWithMagicLink: { __typename?: 'TokenModel', accessToken: string, accessTokenExpiredAt: number, refreshToken: string, user: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } } };

export type SkipSurveyMutationVariables = Exact<{ [key: string]: never; }>;


export type SkipSurveyMutation = { __typename?: 'Mutation', skipSurvey: boolean };

export type SkipSurveyForCartMutationVariables = Exact<{
  input: SkipSurveyForCartInput;
}>;


export type SkipSurveyForCartMutation = { __typename?: 'Mutation', skipSurveyForCart: boolean };

export type SplitShipmentMutationVariables = Exact<{
  platform?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  videoLink1: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  input4?: InputMaybe<CrossSellRecordQueryInput>;
  orderId?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId2?: InputMaybe<Scalars['String']>;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date2?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date3?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  input5: V2ConsultationFilterInput;
  input6: ConsultationMessagesInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input7: ConsultationListInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input8: OrderInput;
  pagination: V2PaginationInput;
  date4?: InputMaybe<Scalars['String']>;
  date5?: InputMaybe<Scalars['Float']>;
  input9?: InputMaybe<GetPatientInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<StripeProductFilterV2>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  platform14?: InputMaybe<Scalars['String']>;
  platform15?: InputMaybe<Scalars['String']>;
  platform16?: InputMaybe<Scalars['String']>;
  platform17?: InputMaybe<Scalars['String']>;
  platform18?: InputMaybe<Scalars['String']>;
  platform19?: InputMaybe<Scalars['String']>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input17: V2ConsultationFilterInput;
  input18: ConsultationMessagesInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input19: ConsultationListInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform20?: InputMaybe<Scalars['String']>;
  input20: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input21?: InputMaybe<GetPatientInput>;
  platform21?: InputMaybe<Scalars['String']>;
  platform22?: InputMaybe<Scalars['String']>;
  input22?: InputMaybe<StripeProductFilterV2>;
  input23: SplitShipmentInput;
}>;


export type SplitShipmentMutation = { __typename?: 'Mutation', splitShipment?: { __typename?: 'OrderShipmentDto', address: any, cost: number, courierName?: CourierName | null, createdAt?: any | null, deliveryMethod?: DeliveryMethod | null, deliveryTimestamp?: any | null, estimatedShipDate?: any | null, note?: string | null, parcelId: string, paused: boolean, shipDate?: any | null, status: string, sysId: string, trackingNo?: string | null, updatedAt?: any | null, group?: { __typename?: 'OrderShipmentGroupDto', bookingNo?: string | null, createdAt?: any | null, name: string, sysId: string, updatedAt?: any | null } | null, items?: Array<{ __typename?: 'OrderShipmentItemDto', createdAt?: any | null, dosage?: any | null, isFirstPurchase: boolean, orderNo: number, orderSysId: string, paymentAmount?: number | null, paymentDate?: any | null, paymentIntentId?: string | null, paymentProvider: PaymentProvider, priceId: string, promotionCode?: string | null, qty: number, sysId: string, updatedAt?: any | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null, price?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null }> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, shipper?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, otcOrdersCalculation?: Array<{ __typename?: 'OTCOrderCalculationDto', basePrice?: number | null, cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmount?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, stripePromotionCode?: any | null, tax?: number | null, transactionFee?: number | null }> | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, rxOrdersCalculation?: Array<{ __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null }> | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null } | null } | null };

export type StartCronJobMutationVariables = Exact<{
  jobName: Scalars['String'];
}>;


export type StartCronJobMutation = { __typename?: 'Mutation', startCronJob: boolean };

export type StopCronJobMutationVariables = Exact<{
  jobName: Scalars['String'];
}>;


export type StopCronJobMutation = { __typename?: 'Mutation', stopCronJob: boolean };

export type SubmitAffiliateCouponMutationVariables = Exact<{
  input: SubmitAffiliateCouponInput;
}>;


export type SubmitAffiliateCouponMutation = { __typename?: 'Mutation', submitAffiliateCoupon: { __typename?: 'PublicAffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'PublicAffiliateProduct', affiliateSysId: string, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, slug: string, stripePriceId: string, stripeProductId: string, sysId: string, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } };

export type SubmitEvaluationMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  evaluationDataInput: PatientSubmitEvaluationInput;
}>;


export type SubmitEvaluationMutation = { __typename?: 'Mutation', submitEvaluation?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type SubmitVideoCallRatingMutationVariables = Exact<{
  input: SubmitVideoCallRatingInput;
}>;


export type SubmitVideoCallRatingMutation = { __typename?: 'Mutation', submitVideoCallRating: { __typename?: 'SubmitVideoCallRatingModel', success: boolean } };

export type SyncMissingLatestInvoiceForSubscriptionOrdersMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncMissingLatestInvoiceForSubscriptionOrdersMutation = { __typename?: 'Mutation', syncMissingLatestInvoiceForSubscriptionOrders: string };

export type SyncProductPriceLocaleFilesMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncProductPriceLocaleFilesMutation = { __typename?: 'Mutation', syncProductPriceLocaleFiles: boolean };

export type SyncStripeMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncStripeMutation = { __typename?: 'Mutation', syncStripe: boolean };

export type Test_GenerateSmartMatchResultsMutationVariables = Exact<{
  input: Test_GenerateSmartMatchResultsInput;
}>;


export type Test_GenerateSmartMatchResultsMutation = { __typename?: 'Mutation', test_generateSmartMatchResults: { __typename?: 'test_SmartMatchDto', evalId: EvalIds, smartMatchResults?: any | null, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } };

export type TranslateRawTextMutationVariables = Exact<{
  input: TranslateRawTextInput;
}>;


export type TranslateRawTextMutation = { __typename?: 'Mutation', translateRawText: { __typename?: 'TranslateRawTextDto', sourceLanguage: Language, targetLanguage: Language, translatedText: string } };

export type TriggerOnPaidAtomePaymentMutationVariables = Exact<{
  referenceId: Scalars['String'];
}>;


export type TriggerOnPaidAtomePaymentMutation = { __typename?: 'Mutation', triggerOnPaidAtomePayment?: boolean | null };

export type TrySecondOpinionV2MutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: TrySecondOpinionInputV2;
}>;


export type TrySecondOpinionV2Mutation = { __typename?: 'Mutation', trySecondOpinionV2: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } };

export type UpdateAddressMutationVariables = Exact<{
  updateDeliveryInput: V2AddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null };

export type UpdateAffiliateMutationVariables = Exact<{
  input: UpdateAffiliateInput;
  sysId: Scalars['String'];
}>;


export type UpdateAffiliateMutation = { __typename?: 'Mutation', updateAffiliate: { __typename?: 'Affiliate', createdAt: any, enabled: boolean, formFieldMap?: any | null, formSubmitUrl?: string | null, name: string, notificationChannel: AffiliateNotificationChannel, notificationEmail?: string | null, portalUrl: string, region: RegionType, slug: string, sysId: string, updatedAt: any } };

export type UpdateAffiliateCouponVerificationMutationVariables = Exact<{
  opsNote?: InputMaybe<Scalars['String']>;
  status: AffiliateCouponStatus;
  sysId: Scalars['String'];
}>;


export type UpdateAffiliateCouponVerificationMutation = { __typename?: 'Mutation', updateAffiliateCouponVerification: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } };

export type UpdateAffiliateProductMutationVariables = Exact<{
  input: UpdateAffiliateProductInput;
  sysId: Scalars['String'];
}>;


export type UpdateAffiliateProductMutation = { __typename?: 'Mutation', updateAffiliateProduct: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } };

export type UpdateAtomePaymentMutationVariables = Exact<{
  input: V2UpdateAtomePaymentInput;
}>;


export type UpdateAtomePaymentMutation = { __typename?: 'Mutation', updateAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null };

export type UpdateCartCalculateOrderSummaryMutationVariables = Exact<{
  input: UpdateCartCalculateOrderSummaryInput;
}>;


export type UpdateCartCalculateOrderSummaryMutation = { __typename?: 'Mutation', updateCartCalculateOrderSummary: boolean };

export type UpdateCartItemByIdMutationVariables = Exact<{
  input: UpdateCartItemByIdInput;
}>;


export type UpdateCartItemByIdMutation = { __typename?: 'Mutation', updateCartItemById: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null } };

export type UpdateCheckoutSessionMutationVariables = Exact<{
  patientId?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  platform1?: InputMaybe<Scalars['String']>;
  platform2?: InputMaybe<Scalars['String']>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  videoLink1: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit1?: InputMaybe<Scalars['Int']>;
  offset1?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform6?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform7?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform8?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input11: ConsultationMessagesInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  input12: ConsultationListInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input13: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input14?: InputMaybe<GetPatientInput>;
  platform9?: InputMaybe<Scalars['String']>;
  input15?: InputMaybe<StripeProductFilterV2>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input16: V2ConsultationFilterInput;
  input17: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  input18: ConsultationListInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  input19: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input20?: InputMaybe<GetPatientInput>;
  platform10?: InputMaybe<Scalars['String']>;
  platform11?: InputMaybe<Scalars['String']>;
  input21?: InputMaybe<StripeProductFilterV2>;
  input22: V2ConsultationFilterInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  updateCheckoutSessionInput: UpdateCheckoutSessionInput;
}>;


export type UpdateCheckoutSessionMutation = { __typename?: 'Mutation', updateCheckoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null };

export type UpdateCompletedEvalMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  input: UpdateCompletedEvalInput;
}>;


export type UpdateCompletedEvalMutation = { __typename?: 'Mutation', updateCompletedEval: { __typename?: 'CompletedEvalModel', completed?: boolean | null, createdAt?: any | null, evaluationFormLastUpdated?: any | null, evaluationId?: string | null, formQandA?: Array<any> | null, jumpToSectionIndex?: Array<number | null> | null, oldPatientId?: string | null, patient?: any | null, patientdoctorNotes?: string | null, questionTotal?: number | null, sectionHistory?: Array<number | null> | null, sectionIndex?: number | null, sectionTotal?: number | null, sysId?: string | null, updatedAt?: any | null, valid?: boolean | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null } | null } };

export type UpdateCompletedEvalForGuestsMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  input: UpdateCompletedEvalInputForGuest;
}>;


export type UpdateCompletedEvalForGuestsMutation = { __typename?: 'Mutation', updateCompletedEvalForGuests: { __typename?: 'CompletedEvalModel', completed?: boolean | null, createdAt?: any | null, evaluationFormLastUpdated?: any | null, evaluationId?: string | null, formQandA?: Array<any> | null, jumpToSectionIndex?: Array<number | null> | null, oldPatientId?: string | null, patient?: any | null, patientdoctorNotes?: string | null, questionTotal?: number | null, sectionHistory?: Array<number | null> | null, sectionIndex?: number | null, sectionTotal?: number | null, sysId?: string | null, updatedAt?: any | null, valid?: boolean | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null } | null } };

export type UpdateCustomerBalanceTransactionMutationVariables = Exact<{
  input: UpdateCustomerBalanceTransactionInput;
}>;


export type UpdateCustomerBalanceTransactionMutation = { __typename?: 'Mutation', updateCustomerBalanceTransaction: boolean };

export type UpdateEvaluationProgressMutationVariables = Exact<{
  input: UpdateProcessEvaluationInput;
}>;


export type UpdateEvaluationProgressMutation = { __typename?: 'Mutation', updateEvaluationProgress: boolean };

export type UpdateEvaluationQuestionMutationVariables = Exact<{
  input: UpdateEvaluationQuestionInput;
}>;


export type UpdateEvaluationQuestionMutation = { __typename?: 'Mutation', updateEvaluationQuestion: boolean };

export type UpdateMhpOrderDosageMutationVariables = Exact<{
  updateOrderDosageInput: UpdateMhpOrderDosageInput;
}>;


export type UpdateMhpOrderDosageMutation = { __typename?: 'Mutation', updateMhpOrderDosage?: boolean | null };

export type UpdateOrderMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } };

export type UpdateOrderByOpsV2MutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  updateOrderInput: V2UpdateOrderInput;
}>;


export type UpdateOrderByOpsV2Mutation = { __typename?: 'Mutation', updateOrderByOpsV2?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type UpdateOrderNoteMutationVariables = Exact<{
  input: UpdateOrderNoteInput;
}>;


export type UpdateOrderNoteMutation = { __typename?: 'Mutation', updateOrderNote?: boolean | null };

export type UpdateOtherInterestedEvalIdsMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  interestedEvalIdInput?: InputMaybe<V2UpdateOtherInterestedEvalIdsInput>;
}>;


export type UpdateOtherInterestedEvalIdsMutation = { __typename?: 'Mutation', updateOtherInterestedEvalIds?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type UpdatePatientMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  platform1?: InputMaybe<Scalars['String']>;
  platform2?: InputMaybe<Scalars['String']>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  id1?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id2?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  platform14?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform15?: InputMaybe<Scalars['String']>;
  videoLink1: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  input4?: InputMaybe<CrossSellRecordQueryInput>;
  orderId?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId2?: InputMaybe<Scalars['String']>;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date2?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date3?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  input5: V2ConsultationFilterInput;
  input6: ConsultationMessagesInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input7: ConsultationListInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input8: OrderInput;
  pagination: V2PaginationInput;
  date4?: InputMaybe<Scalars['String']>;
  date5?: InputMaybe<Scalars['Float']>;
  input9?: InputMaybe<GetPatientInput>;
  platform16?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<StripeProductFilterV2>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform17?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  checkoutSessionFilterOptions1?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  input17: GetPatientDocumentInput;
  evalFilter1?: InputMaybe<V2PatientEvaluationFilterInput>;
  id3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform18?: InputMaybe<Scalars['String']>;
  inputOrder2?: InputMaybe<V2OrderFilterInput>;
  orderPagination2?: InputMaybe<V2PaginationInput>;
  input18?: InputMaybe<PrescriptionCalculationInput>;
  platform19?: InputMaybe<Scalars['String']>;
  platform20?: InputMaybe<Scalars['String']>;
  filter1?: InputMaybe<ShopProductFilterInputV2>;
  limit8?: InputMaybe<Scalars['Float']>;
  offset8?: InputMaybe<Scalars['Float']>;
  sort1?: InputMaybe<ShopProductSortInputV2>;
  input19: GetSmartMatchMetaInput;
  input20?: InputMaybe<PatientGetSurveyInput>;
  videoLink3: Scalars['String'];
  previewVideoLink1: Scalars['String'];
  input21: V2UpdatePatientInput;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null }> | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null> | null } | null, question?: { __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null }> | null, content?: { __typename?: 'ContentQuestionDto', body?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null, blockAnswer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, content?: { __typename?: 'EvaluationBlockContentDto', description?: string | null, descriptionTextKey?: string | null, sysId?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null }> | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null, card?: { __typename?: 'StripeCardDto', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, otcOrdersCalculation?: Array<{ __typename?: 'OTCOrderCalculationDto', basePrice?: number | null, cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmount?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, stripePromotionCode?: any | null, tax?: number | null, transactionFee?: number | null }> | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, rxOrdersCalculation?: Array<{ __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null }> | null } | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, items?: Array<{ __typename?: 'ReferralItemDto', orderId?: string | null, priceId?: string | null, referralSysId?: string | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null } | null> | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null } };

export type UpdatePatientDocumentMutationVariables = Exact<{
  input?: InputMaybe<UpdatePatientDocumentInput>;
}>;


export type UpdatePatientDocumentMutation = { __typename?: 'Mutation', updatePatientDocument?: boolean | null };

export type UpdatePatientInfoMutationVariables = Exact<{
  input: UpdatePatientInput;
}>;


export type UpdatePatientInfoMutation = { __typename?: 'Mutation', updatePatientInfo: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } };

export type UpdatePatientSubscriptionsPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;


export type UpdatePatientSubscriptionsPaymentMethodMutation = { __typename?: 'Mutation', updatePatientSubscriptionsPaymentMethod: boolean };

export type UpdatePaymentStatusForCodOrderMutationVariables = Exact<{
  input: V2UpdatePaymentStatusCodOrderInput;
}>;


export type UpdatePaymentStatusForCodOrderMutation = { __typename?: 'Mutation', updatePaymentStatusForCodOrder?: { __typename?: 'UpdatePaymentStatusForCodDto', results: Array<{ __typename?: 'UpdatePaymentStatusDto', errorMessage?: string | null, isSuccess: boolean, orderId?: string | null }> } | null };

export type UpdatePickupLocationMutationVariables = Exact<{
  input: PickupLocationInput;
}>;


export type UpdatePickupLocationMutation = { __typename?: 'Mutation', updatePickupLocation?: boolean | null };

export type UpdateProductImageUrlsMutationVariables = Exact<{
  input: UpdateStripeProductImageUrlsInput;
}>;


export type UpdateProductImageUrlsMutation = { __typename?: 'Mutation', updateProductImageUrls: boolean };

export type UpdateShipmentGroupMutationVariables = Exact<{
  input: UpdateShipmentGroupInput;
}>;


export type UpdateShipmentGroupMutation = { __typename?: 'Mutation', updateShipmentGroup?: boolean | null };

export type UpdateShipperMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  videoLink: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  platform2?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform3?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  videoLink1: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  orderId2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input10: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input11: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input12: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input13?: InputMaybe<GetPatientInput>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  input14?: InputMaybe<StripeProductFilterV2>;
  input15: V2ConsultationFilterInput;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  platform10?: InputMaybe<Scalars['String']>;
  platform11?: InputMaybe<Scalars['String']>;
  platform12?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input16: V2ConsultationFilterInput;
  input17: ConsultationMessagesInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input18: ConsultationListInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  input19: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input20?: InputMaybe<GetPatientInput>;
  platform13?: InputMaybe<Scalars['String']>;
  input21?: InputMaybe<StripeProductFilterV2>;
  platform14?: InputMaybe<Scalars['String']>;
  platform15?: InputMaybe<Scalars['String']>;
  platform16?: InputMaybe<Scalars['String']>;
  platform17?: InputMaybe<Scalars['String']>;
  platform18?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform19?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform20?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput6?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation7?: InputMaybe<V2ConsultationFilterInput>;
  platform21?: InputMaybe<Scalars['String']>;
  acuityAppointmentId6?: InputMaybe<Scalars['String']>;
  date12?: InputMaybe<Scalars['String']>;
  forDelivery6?: InputMaybe<Scalars['Boolean']>;
  isReschedule6?: InputMaybe<Scalars['Boolean']>;
  orderId7?: InputMaybe<Scalars['String']>;
  acuityAppointmentId7?: InputMaybe<Scalars['String']>;
  consultDate3?: InputMaybe<Scalars['Float']>;
  date13?: InputMaybe<Scalars['Float']>;
  forDelivery7?: InputMaybe<Scalars['Boolean']>;
  isReschedule7?: InputMaybe<Scalars['Boolean']>;
  orderId8?: InputMaybe<Scalars['String']>;
  input22: V2ConsultationFilterInput;
  input23: ConsultationMessagesInput;
  limit10?: InputMaybe<Scalars['Int']>;
  offset10?: InputMaybe<Scalars['Int']>;
  order9?: InputMaybe<Scalars['JSON']>;
  input24: ConsultationListInput;
  limit11?: InputMaybe<Scalars['Int']>;
  offset11?: InputMaybe<Scalars['Int']>;
  order10?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput6?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput7?: InputMaybe<V2DoctorInputFilter>;
  input25: OrderInput;
  pagination3: V2PaginationInput;
  date14?: InputMaybe<Scalars['String']>;
  date15?: InputMaybe<Scalars['Float']>;
  input26?: InputMaybe<GetPatientInput>;
  platform22?: InputMaybe<Scalars['String']>;
  input27?: InputMaybe<StripeProductFilterV2>;
  consultAuditFilterInput7?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation8?: InputMaybe<V2ConsultationFilterInput>;
  platform23?: InputMaybe<Scalars['String']>;
  input28?: InputMaybe<CrossSellRecordQueryInput>;
  acuityAppointmentId8?: InputMaybe<Scalars['String']>;
  date16?: InputMaybe<Scalars['String']>;
  forDelivery8?: InputMaybe<Scalars['Boolean']>;
  isReschedule8?: InputMaybe<Scalars['Boolean']>;
  orderId9?: InputMaybe<Scalars['String']>;
  acuityAppointmentId9?: InputMaybe<Scalars['String']>;
  consultDate4?: InputMaybe<Scalars['Float']>;
  date17?: InputMaybe<Scalars['Float']>;
  forDelivery9?: InputMaybe<Scalars['Boolean']>;
  isReschedule9?: InputMaybe<Scalars['Boolean']>;
  orderId10?: InputMaybe<Scalars['String']>;
  input29: V2ConsultationFilterInput;
  input30: ConsultationMessagesInput;
  limit12?: InputMaybe<Scalars['Int']>;
  offset12?: InputMaybe<Scalars['Int']>;
  order11?: InputMaybe<Scalars['JSON']>;
  input31: ConsultationListInput;
  limit13?: InputMaybe<Scalars['Int']>;
  offset13?: InputMaybe<Scalars['Int']>;
  order12?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput8?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput9?: InputMaybe<V2DoctorInputFilter>;
  input32: OrderInput;
  pagination4: V2PaginationInput;
  date18?: InputMaybe<Scalars['String']>;
  date19?: InputMaybe<Scalars['Float']>;
  input33?: InputMaybe<GetPatientInput>;
  platform24?: InputMaybe<Scalars['String']>;
  input34?: InputMaybe<StripeProductFilterV2>;
  input35?: InputMaybe<UpdateShipperInput>;
}>;


export type UpdateShipperMutation = { __typename?: 'Mutation', updateShipper?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null, card?: { __typename?: 'StripeCardDto', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, items?: Array<{ __typename?: 'ReferralItemDto', orderId?: string | null, priceId?: string | null, referralSysId?: string | null, sysId?: string | null } | null> | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null }> | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, question?: { __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null }> | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null }> | null, content?: { __typename?: 'ContentQuestionDto', body?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null, blockAnswer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null, content?: { __typename?: 'EvaluationBlockContentDto', description?: string | null, descriptionTextKey?: string | null, sysId?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, lines?: { __typename?: 'StripeInvoiceLineDto', data?: Array<{ __typename?: 'StripeInvoiceLineItemDto', amount?: number | null, discount?: string | null, plan?: { __typename?: 'StripePlanDto', active?: boolean | null, id?: string | null, metadata?: any | null } | null } | null> | null } | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null } | null }> | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null };

export type UpdateShippingOrderShipmentMutationVariables = Exact<{
  input: UpdateShippingOrderShipment;
}>;


export type UpdateShippingOrderShipmentMutation = { __typename?: 'Mutation', updateShippingOrderShipment?: boolean | null };

export type UpdateStripeCouponMutationVariables = Exact<{
  input: UpdateStripeCouponInput;
}>;


export type UpdateStripeCouponMutation = { __typename?: 'Mutation', updateStripeCoupon: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null } | null> | null } | null } | null> | null } };

export type UpdateStripeCouponMetadataMutationVariables = Exact<{
  input: UpdateStripeCouponInput;
}>;


export type UpdateStripeCouponMetadataMutation = { __typename?: 'Mutation', updateStripeCouponMetadata: boolean };

export type UpdateStripePriceMutationVariables = Exact<{
  input: UpdateStripePriceInput;
}>;


export type UpdateStripePriceMutation = { __typename?: 'Mutation', updateStripePrice: boolean };

export type UpdateStripePriceLocaleMutationVariables = Exact<{
  input: UpdatePriceLocaleInput;
}>;


export type UpdateStripePriceLocaleMutation = { __typename?: 'Mutation', updateStripePriceLocale: boolean };

export type UpdateStripePriceMetadataMutationVariables = Exact<{
  input: UpdatePriceMetadataInput;
}>;


export type UpdateStripePriceMetadataMutation = { __typename?: 'Mutation', updateStripePriceMetadata: boolean };

export type UpdateStripeProductMutationVariables = Exact<{
  input: UpdateStripeProductInput;
}>;


export type UpdateStripeProductMutation = { __typename?: 'Mutation', updateStripeProduct: boolean };

export type UpdateStripeProductLocaleMutationVariables = Exact<{
  input: UpdateProductLocaleInput;
}>;


export type UpdateStripeProductLocaleMutation = { __typename?: 'Mutation', updateStripeProductLocale: boolean };

export type UpdateStripeProductMetadataMutationVariables = Exact<{
  input: UpdateProductMetadataInput;
}>;


export type UpdateStripeProductMetadataMutation = { __typename?: 'Mutation', updateStripeProductMetadata: boolean };

export type UpdateStripePromotionCodeMutationVariables = Exact<{
  input: UpdateStripePromotionCodeInput;
}>;


export type UpdateStripePromotionCodeMutation = { __typename?: 'Mutation', updateStripePromotionCode: { __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null } | null } | null> | null } | null } };

export type UpdateStripePromotionCodeMetadataMutationVariables = Exact<{
  input: UpdateStripePromotionCodeInput;
}>;


export type UpdateStripePromotionCodeMetadataMutation = { __typename?: 'Mutation', updateStripePromotionCodeMetadata: boolean };

export type UpdateUserMutationVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  videoLink: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  platform2?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform3?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  videoLink1: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  orderId2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input10: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input11: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input12: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input13?: InputMaybe<GetPatientInput>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  input14?: InputMaybe<StripeProductFilterV2>;
  input15: V2ConsultationFilterInput;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  platform10?: InputMaybe<Scalars['String']>;
  platform11?: InputMaybe<Scalars['String']>;
  platform12?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input16: V2ConsultationFilterInput;
  input17: ConsultationMessagesInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input18: ConsultationListInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  input19: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input20?: InputMaybe<GetPatientInput>;
  platform13?: InputMaybe<Scalars['String']>;
  input21?: InputMaybe<StripeProductFilterV2>;
  platform14?: InputMaybe<Scalars['String']>;
  platform15?: InputMaybe<Scalars['String']>;
  platform16?: InputMaybe<Scalars['String']>;
  platform17?: InputMaybe<Scalars['String']>;
  platform18?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform19?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform20?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput6?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation7?: InputMaybe<V2ConsultationFilterInput>;
  platform21?: InputMaybe<Scalars['String']>;
  acuityAppointmentId6?: InputMaybe<Scalars['String']>;
  date12?: InputMaybe<Scalars['String']>;
  forDelivery6?: InputMaybe<Scalars['Boolean']>;
  isReschedule6?: InputMaybe<Scalars['Boolean']>;
  orderId7?: InputMaybe<Scalars['String']>;
  acuityAppointmentId7?: InputMaybe<Scalars['String']>;
  consultDate3?: InputMaybe<Scalars['Float']>;
  date13?: InputMaybe<Scalars['Float']>;
  forDelivery7?: InputMaybe<Scalars['Boolean']>;
  isReschedule7?: InputMaybe<Scalars['Boolean']>;
  orderId8?: InputMaybe<Scalars['String']>;
  input22: V2ConsultationFilterInput;
  input23: ConsultationMessagesInput;
  limit10?: InputMaybe<Scalars['Int']>;
  offset10?: InputMaybe<Scalars['Int']>;
  order9?: InputMaybe<Scalars['JSON']>;
  input24: ConsultationListInput;
  limit11?: InputMaybe<Scalars['Int']>;
  offset11?: InputMaybe<Scalars['Int']>;
  order10?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput6?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput7?: InputMaybe<V2DoctorInputFilter>;
  input25: OrderInput;
  pagination3: V2PaginationInput;
  date14?: InputMaybe<Scalars['String']>;
  date15?: InputMaybe<Scalars['Float']>;
  input26?: InputMaybe<GetPatientInput>;
  platform22?: InputMaybe<Scalars['String']>;
  input27?: InputMaybe<StripeProductFilterV2>;
  consultAuditFilterInput7?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation8?: InputMaybe<V2ConsultationFilterInput>;
  platform23?: InputMaybe<Scalars['String']>;
  input28?: InputMaybe<CrossSellRecordQueryInput>;
  acuityAppointmentId8?: InputMaybe<Scalars['String']>;
  date16?: InputMaybe<Scalars['String']>;
  forDelivery8?: InputMaybe<Scalars['Boolean']>;
  isReschedule8?: InputMaybe<Scalars['Boolean']>;
  orderId9?: InputMaybe<Scalars['String']>;
  acuityAppointmentId9?: InputMaybe<Scalars['String']>;
  consultDate4?: InputMaybe<Scalars['Float']>;
  date17?: InputMaybe<Scalars['Float']>;
  forDelivery9?: InputMaybe<Scalars['Boolean']>;
  isReschedule9?: InputMaybe<Scalars['Boolean']>;
  orderId10?: InputMaybe<Scalars['String']>;
  input29: V2ConsultationFilterInput;
  input30: ConsultationMessagesInput;
  limit12?: InputMaybe<Scalars['Int']>;
  offset12?: InputMaybe<Scalars['Int']>;
  order11?: InputMaybe<Scalars['JSON']>;
  input31: ConsultationListInput;
  limit13?: InputMaybe<Scalars['Int']>;
  offset13?: InputMaybe<Scalars['Int']>;
  order12?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput8?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput9?: InputMaybe<V2DoctorInputFilter>;
  input32: OrderInput;
  pagination4: V2PaginationInput;
  date18?: InputMaybe<Scalars['String']>;
  date19?: InputMaybe<Scalars['Float']>;
  input33?: InputMaybe<GetPatientInput>;
  platform24?: InputMaybe<Scalars['String']>;
  input34?: InputMaybe<StripeProductFilterV2>;
  input35?: InputMaybe<V2UserInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null, card?: { __typename?: 'StripeCardDto', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, items?: Array<{ __typename?: 'ReferralItemDto', orderId?: string | null, priceId?: string | null, referralSysId?: string | null, sysId?: string | null } | null> | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null }> | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, question?: { __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null }> | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null }> | null, content?: { __typename?: 'ContentQuestionDto', body?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null, blockAnswer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null, content?: { __typename?: 'EvaluationBlockContentDto', description?: string | null, descriptionTextKey?: string | null, sysId?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, lines?: { __typename?: 'StripeInvoiceLineDto', data?: Array<{ __typename?: 'StripeInvoiceLineItemDto', amount?: number | null, discount?: string | null, plan?: { __typename?: 'StripePlanDto', active?: boolean | null, id?: string | null, metadata?: any | null } | null } | null> | null } | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null } | null }> | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null };

export type UpdateVoidInvoiceOrderMutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type UpdateVoidInvoiceOrderMutation = { __typename?: 'Mutation', updateVoidInvoiceOrder: string };

export type UpdateVoidInvoiceOrderV2MutationVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type UpdateVoidInvoiceOrderV2Mutation = { __typename?: 'Mutation', updateVoidInvoiceOrderV2?: boolean | null };

export type UploadFileMutationVariables = Exact<{
  input: SignS3Input;
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'SignS3Model', ref: string, signedRequest: string, url: string } };

export type UploadFileDirectMutationVariables = Exact<{
  file: Scalars['String'];
  input: UploadIdInput;
}>;


export type UploadFileDirectMutation = { __typename?: 'Mutation', uploadFileDirect?: { __typename?: 'SignS3Dto', ref: string, signedRequest?: string | null, url: string, identityFields?: Array<{ __typename?: 'IdentityDocumentField', type: string, value: string }> | null } | null };

export type UploadFileV2MutationVariables = Exact<{
  input: SignS3Input;
}>;


export type UploadFileV2Mutation = { __typename?: 'Mutation', uploadFileV2?: { __typename?: 'SignS3Dto', ref: string, signedRequest?: string | null, url: string, identityFields?: Array<{ __typename?: 'IdentityDocumentField', type: string, value: string }> | null } | null };

export type UploadPublicFileMutationVariables = Exact<{
  input: SignS3Input;
}>;


export type UploadPublicFileMutation = { __typename?: 'Mutation', uploadPublicFile: { __typename?: 'SignS3Model', ref: string, signedRequest: string, url: string } };

export type UploadPublicFileV2MutationVariables = Exact<{
  input: SignS3Input;
}>;


export type UploadPublicFileV2Mutation = { __typename?: 'Mutation', uploadPublicFileV2?: { __typename?: 'PublicSignS3Dto', ref: string, signedRequest: string, url: string } | null };

export type UploadTrtDocumentMutationVariables = Exact<{
  input: UploadTrtDocumentInput;
}>;


export type UploadTrtDocumentMutation = { __typename?: 'Mutation', uploadTrtDocument: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } };

export type UpsertPatientTourViewingMutationVariables = Exact<{
  input: UpsertPatientOnboardingInput;
}>;


export type UpsertPatientTourViewingMutation = { __typename?: 'Mutation', upsertPatientTourViewing: string };

export type UpsertRecommendedProductsMutationVariables = Exact<{
  input: UpsertRecommendedProductsInput;
}>;


export type UpsertRecommendedProductsMutation = { __typename?: 'Mutation', upsertRecommendedProducts?: Array<{ __typename?: 'RecommendedProductsDto', priceId?: string | null, productId?: string | null, status?: string | null }> | null };

export type ValidateEmailOtpMutationVariables = Exact<{
  email: Scalars['String'];
  otp: Scalars['String'];
}>;


export type ValidateEmailOtpMutation = { __typename?: 'Mutation', validateEmailOTP: boolean };

export type VerifyForgotPasswordMutationVariables = Exact<{
  input: VerifyForgotPasswordUserInput;
}>;


export type VerifyForgotPasswordMutation = { __typename?: 'Mutation', verifyForgotPassword: boolean };

export type VerifyOrderMutationVariables = Exact<{
  platform?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  videoLink1: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  input4?: InputMaybe<CrossSellRecordQueryInput>;
  orderId?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId2?: InputMaybe<Scalars['String']>;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date2?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date3?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  input5: V2ConsultationFilterInput;
  input6: ConsultationMessagesInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  input7: ConsultationListInput;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input8: OrderInput;
  pagination: V2PaginationInput;
  date4?: InputMaybe<Scalars['String']>;
  date5?: InputMaybe<Scalars['Float']>;
  input9?: InputMaybe<GetPatientInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<StripeProductFilterV2>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  platform14?: InputMaybe<Scalars['String']>;
  platform15?: InputMaybe<Scalars['String']>;
  platform16?: InputMaybe<Scalars['String']>;
  platform17?: InputMaybe<Scalars['String']>;
  platform18?: InputMaybe<Scalars['String']>;
  platform19?: InputMaybe<Scalars['String']>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input17: V2ConsultationFilterInput;
  input18: ConsultationMessagesInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input19: ConsultationListInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform20?: InputMaybe<Scalars['String']>;
  input20: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input21?: InputMaybe<GetPatientInput>;
  platform21?: InputMaybe<Scalars['String']>;
  platform22?: InputMaybe<Scalars['String']>;
  input22?: InputMaybe<StripeProductFilterV2>;
  input23: VerifyOrderInput;
}>;


export type VerifyOrderMutation = { __typename?: 'Mutation', verifyOrder?: Array<{ __typename?: 'OrderShipmentDto', address: any, cost: number, courierName?: CourierName | null, createdAt?: any | null, deliveryMethod?: DeliveryMethod | null, deliveryTimestamp?: any | null, estimatedShipDate?: any | null, note?: string | null, parcelId: string, paused: boolean, shipDate?: any | null, status: string, sysId: string, trackingNo?: string | null, updatedAt?: any | null, group?: { __typename?: 'OrderShipmentGroupDto', bookingNo?: string | null, createdAt?: any | null, name: string, sysId: string, updatedAt?: any | null } | null, items?: Array<{ __typename?: 'OrderShipmentItemDto', createdAt?: any | null, dosage?: any | null, isFirstPurchase: boolean, orderNo: number, orderSysId: string, paymentAmount?: number | null, paymentDate?: any | null, paymentIntentId?: string | null, paymentProvider: PaymentProvider, priceId: string, promotionCode?: string | null, qty: number, sysId: string, updatedAt?: any | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null } | null, price?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null }> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, shipper?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, otcOrdersCalculation?: Array<{ __typename?: 'OTCOrderCalculationDto', basePrice?: number | null, cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmount?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, stripePromotionCode?: any | null, tax?: number | null, transactionFee?: number | null }> | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, rxOrdersCalculation?: Array<{ __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null }> | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null } | null }> | null };

export type AffiliateQueryVariables = Exact<{
  sysId: Scalars['String'];
}>;


export type AffiliateQuery = { __typename?: 'Query', affiliate?: { __typename?: 'Affiliate', createdAt: any, enabled: boolean, formFieldMap?: any | null, formSubmitUrl?: string | null, name: string, notificationChannel: AffiliateNotificationChannel, notificationEmail?: string | null, portalUrl: string, region: RegionType, slug: string, sysId: string, updatedAt: any } | null };

export type AffiliateCouponStatsForOpsQueryVariables = Exact<{
  affiliateSysId?: InputMaybe<Scalars['String']>;
}>;


export type AffiliateCouponStatsForOpsQuery = { __typename?: 'Query', affiliateCouponStatsForOps: { __typename?: 'AffiliateCouponOpsStats', monthOrders: number, monthSubmissions: number, weekOrders: number, weekSubmissions: number } };

export type AffiliateCouponsForOpsQueryVariables = Exact<{
  filter?: InputMaybe<AffiliateCouponsForOpsFilterInput>;
  pagination?: InputMaybe<V2PaginationInput>;
}>;


export type AffiliateCouponsForOpsQuery = { __typename?: 'Query', affiliateCouponsForOps: { __typename?: 'PaginatedAdminAffiliateCoupons', count: number, limit?: number | null, offset?: number | null, items: Array<{ __typename?: 'AdminAffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, amountCollected?: number | null, amountCollectedCurrency?: string | null, anonymousId: string, converted: boolean, couponId: string, createdAt: any, customerEmail?: string | null, customerUserId?: string | null, invoiceSettledAt?: any | null, opsNote?: string | null, orderShortId?: number | null, orderStatus?: OrderStatus | null, orderSysId?: string | null, status: AffiliateCouponStatus, stripeCustomerId?: string | null, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'Affiliate', createdAt: any, enabled: boolean, formFieldMap?: any | null, formSubmitUrl?: string | null, name: string, notificationChannel: AffiliateNotificationChannel, notificationEmail?: string | null, portalUrl: string, region: RegionType, slug: string, sysId: string, updatedAt: any } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null }> } };

export type AffiliateEligibleStripeProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type AffiliateEligibleStripeProductsQuery = { __typename?: 'Query', affiliateEligibleStripeProducts: Array<{ __typename?: 'AffiliateEligibleStripeProduct', name?: string | null, stripeProductId: string, prices: Array<{ __typename?: 'AffiliateStripePrice', interval?: string | null, nickname?: string | null, stripePriceId: string, type?: string | null, unitAmount?: number | null }> }> };

export type AffiliateProductByAffiliateSlugAndStripePriceIdQueryVariables = Exact<{
  affiliateSlug: Scalars['String'];
  stripePriceId: Scalars['String'];
}>;


export type AffiliateProductByAffiliateSlugAndStripePriceIdQuery = { __typename?: 'Query', affiliateProductByAffiliateSlugAndStripePriceId?: { __typename?: 'PublicAffiliateProduct', affiliateSysId: string, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, slug: string, stripePriceId: string, stripeProductId: string, sysId: string, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null };

export type AffiliateProductByStripePriceIdQueryVariables = Exact<{
  stripePriceId: Scalars['String'];
}>;


export type AffiliateProductByStripePriceIdQuery = { __typename?: 'Query', affiliateProductByStripePriceId?: { __typename?: 'PublicAffiliateProduct', affiliateSysId: string, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, slug: string, stripePriceId: string, stripeProductId: string, sysId: string, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null };

export type AffiliateProductsQueryVariables = Exact<{
  affiliateSysId: Scalars['String'];
}>;


export type AffiliateProductsQuery = { __typename?: 'Query', affiliateProducts: Array<{ __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null }> };

export type AffiliatesQueryVariables = Exact<{
  filter?: InputMaybe<AffiliateFilterInput>;
  pagination?: InputMaybe<V2PaginationInput>;
}>;


export type AffiliatesQuery = { __typename?: 'Query', affiliates: { __typename?: 'PaginatedAffiliates', count: number, limit?: number | null, offset?: number | null, items: Array<{ __typename?: 'Affiliate', createdAt: any, enabled: boolean, formFieldMap?: any | null, formSubmitUrl?: string | null, name: string, notificationChannel: AffiliateNotificationChannel, notificationEmail?: string | null, portalUrl: string, region: RegionType, slug: string, sysId: string, updatedAt: any }> } };

export type AuthenticateQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthenticateQuery = { __typename?: 'Query', authenticate: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } };

export type BloodDrawConfirmationsQueryVariables = Exact<{
  orderSysId: Scalars['String'];
}>;


export type BloodDrawConfirmationsQuery = { __typename?: 'Query', bloodDrawConfirmations: Array<{ __typename?: 'BloodDrawConfirmationDto', confirmedAt?: any | null, drawType: TrtDrawType, orderSysId: string, sysId: string }> };

export type CanEditDeliveryTimeQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type CanEditDeliveryTimeQuery = { __typename?: 'Query', canEditDeliveryTime: { __typename?: 'EditDeliveryTimeModel', canEdit?: boolean | null, isEditWithin2Hours?: boolean | null } };

export type CheckProductsExistingOrdersForPatientQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: AvailableOrdersOfPatientInputs;
}>;


export type CheckProductsExistingOrdersForPatientQuery = { __typename?: 'Query', checkProductsExistingOrdersForPatient: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> };

export type CheckValidConversationsForDoctorQueryVariables = Exact<{
  input: CheckValidConversationsForDoctorInput;
}>;


export type CheckValidConversationsForDoctorQuery = { __typename?: 'Query', checkValidConversationsForDoctor: Array<string> };

export type CheckValidConversationsForPatientQueryVariables = Exact<{
  input: CheckValidConversationsForPatientInput;
}>;


export type CheckValidConversationsForPatientQuery = { __typename?: 'Query', checkValidConversationsForPatient: Array<string> };

export type ConvertReferralPromoCodeValueToCashbackQueryVariables = Exact<{ [key: string]: never; }>;


export type ConvertReferralPromoCodeValueToCashbackQuery = { __typename?: 'Query', convertReferralPromoCodeValueToCashback: { __typename?: 'ConvertPromoCodeToCashBackModel', errorPromoCodes?: Array<string | null> | null } };

export type CountOrderingOfAnEvalProductsQueryVariables = Exact<{
  input: CountOrderingOfAnEvalProductsInput;
}>;


export type CountOrderingOfAnEvalProductsQuery = { __typename?: 'Query', countOrderingOfAnEvalProducts: { __typename?: 'CountOrderingOfAnEvalProductsModel', count: number, priceIds: Array<string> } };

export type DoseStartQueryVariables = Exact<{
  orderSysId: Scalars['String'];
}>;


export type DoseStartQuery = { __typename?: 'Query', doseStart?: { __typename?: 'DoseStartDto', doseStartedAt?: any | null, orderSysId: string } | null };

export type GetActiveProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveProductsQuery = { __typename?: 'Query', getActiveProducts: { __typename?: 'ActiveProductIds', activeProducts: Array<string>, completedEvalIds: Array<string>, pendingEvalIds: Array<string>, skippedEvalIds: Array<string> } };

export type GetAcuityAppointmentByFilterQueryVariables = Exact<{
  input: AcuityAppointmentFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetAcuityAppointmentByFilterQuery = { __typename?: 'Query', getAcuityAppointmentByFilter: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null }> };

export type GetAddressesByFilterQueryVariables = Exact<{
  input: AddressInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetAddressesByFilterQuery = { __typename?: 'Query', getAddressesByFilter: Array<{ __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null }> };

export type GetAllDispatchJobsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetAllDispatchJobsQuery = { __typename?: 'Query', getAllDispatchJobs: Array<{ __typename?: 'DispatchJobModel', collectionSnapshot?: any | null, deliverySnapshot?: any | null, orderId?: string | null, sysId?: string | null }> };

export type GetAllEvaluationFormsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetAllEvaluationFormsQuery = { __typename?: 'Query', getAllEvaluationForms: Array<{ __typename?: 'EvaluationFormModel', createdAt: any, customFields?: any | null, description?: string | null, disabled?: boolean | null, formSections?: any | null, id?: string | null, learnMoreLink?: any | null, onCompleteRedirect?: string | null, sysId?: string | null, title?: string | null, total?: number | null, updatedAt: any, version?: string | null }> };

export type GetAllPrescriptionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetAllPrescriptionsQuery = { __typename?: 'Query', getAllPrescriptions: Array<{ __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null }> };

export type GetAuditDoctorNotesByFilterQueryVariables = Exact<{
  input: AuditDoctorNoteInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetAuditDoctorNotesByFilterQuery = { __typename?: 'Query', getAuditDoctorNotesByFilter: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null }> };

export type GetAvailableSlotsQueryVariables = Exact<{
  input: AvailableSlotsInput;
}>;


export type GetAvailableSlotsQuery = { __typename?: 'Query', getAvailableSlots: { __typename?: 'BookingListModel', data?: Array<{ __typename?: 'BookingModel', date?: string | null, times?: Array<string | null> | null } | null> | null } };

export type GetAvailableSlotsForDeliveryQueryVariables = Exact<{
  input: AvailableSlotsForDeliveryInput;
}>;


export type GetAvailableSlotsForDeliveryQuery = { __typename?: 'Query', getAvailableSlotsForDelivery: { __typename?: 'BookingListModel', data?: Array<{ __typename?: 'BookingModel', date?: string | null, times?: Array<string | null> | null } | null> | null } };

export type GetBookingResultQueryVariables = Exact<{
  input: BookingResultInput;
}>;


export type GetBookingResultQuery = { __typename?: 'Query', getBookingResult: { __typename?: 'BookingResultModel', needsBookingOrderIds: Array<string>, bookedOrders: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }>, cart: { __typename?: 'CheckoutCartModel', cartItems?: any | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, sysId: string, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, calculateOrderSummary?: { __typename?: 'CalculateOrderSummaryModel', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null, itemList?: Array<{ __typename?: 'PaymentItemInfoModel', consultationSessionType?: ConsultationSessionType | null, isEDBundle?: boolean | null, isPayNow?: boolean | null, isRxProduct?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, isSubscriptionUpdate?: boolean | null, itemSubTotal?: number | null, itemSubTotalAfterDiscount?: number | null, mainProductId?: string | null, mainProductName?: string | null, name?: string | null, priceId?: string | null, priceType?: StripePriceType | null, productId?: string | null, productUniqName?: ProductNameType | null, quantity?: number | null, unit_amount?: number | null } | null> | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } } };

export type GetByTextConversationIdQueryVariables = Exact<{
  platform?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform9?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  patientId?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input12: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input13: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input14?: InputMaybe<GetPatientInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input15?: InputMaybe<StripeProductFilterV2>;
  input16: V2ConsultationFilterInput;
  videoLink1: Scalars['String'];
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  textConversationId: Scalars['String'];
}>;


export type GetByTextConversationIdQuery = { __typename?: 'Query', getByTextConversationId: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null }> | null } | null } | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } };

export type GetCartQueryVariables = Exact<{
  input: GetCartInput;
}>;


export type GetCartQuery = { __typename?: 'Query', getCart: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null } };

export type GetCartByIdQueryVariables = Exact<{
  input: FilterByIdInput;
}>;


export type GetCartByIdQuery = { __typename?: 'Query', getCartById: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null } };

export type GetCartsByFilterQueryVariables = Exact<{
  input: FilterInput;
}>;


export type GetCartsByFilterQuery = { __typename?: 'Query', getCartsByFilter: Array<{ __typename?: 'CartModel', calculateOrderSummary?: any | null, calculation?: any | null, cartItems?: any | null, paidCompletedEvaluationIds?: Array<string | null> | null, patientId?: string | null, patientInfo?: any | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null }> };

export type GetCashbackAvailableBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCashbackAvailableBalanceQuery = { __typename?: 'Query', getCashbackAvailableBalance: number };

export type GetCashbackDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCashbackDashboardQuery = { __typename?: 'Query', getCashbackDashboard: { __typename?: 'CashbackDashboardModel', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionModel', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionModel', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } };

export type GetCheckoutCartByOrderIdQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetCheckoutCartByOrderIdQuery = { __typename?: 'Query', getCheckoutCartByOrderId?: { __typename?: 'CheckoutCartModel', cartItems?: any | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, sysId: string, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, calculateOrderSummary?: { __typename?: 'CalculateOrderSummaryModel', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null, itemList?: Array<{ __typename?: 'PaymentItemInfoModel', consultationSessionType?: ConsultationSessionType | null, isEDBundle?: boolean | null, isPayNow?: boolean | null, isRxProduct?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, isSubscriptionUpdate?: boolean | null, itemSubTotal?: number | null, itemSubTotalAfterDiscount?: number | null, mainProductId?: string | null, mainProductName?: string | null, name?: string | null, priceId?: string | null, priceType?: StripePriceType | null, productId?: string | null, productUniqName?: ProductNameType | null, quantity?: number | null, unit_amount?: number | null } | null> | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null };

export type GetCompletedEvalByContinueTokenQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  input: FilterByContinueLaterTokenInput;
}>;


export type GetCompletedEvalByContinueTokenQuery = { __typename?: 'Query', getCompletedEvalByContinueToken: { __typename?: 'GuestCompletedEvalModel', completed?: boolean | null, createdAt?: any | null, evaluationFormLastUpdated?: any | null, evaluationId?: string | null, formQandA?: Array<any> | null, jumpToSectionIndex?: Array<number | null> | null, oldPatientId?: string | null, patient?: any | null, patientId?: string | null, patientdoctorNotes?: string | null, questionTotal?: number | null, sectionHistory?: Array<number | null> | null, sectionIndex?: number | null, sectionTotal?: number | null, sysId?: string | null, updatedAt?: any | null, userId?: string | null, valid?: boolean | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null } | null } };

export type GetCompletedEvalByFilterQueryVariables = Exact<{
  input: GetCompletedEvalByFilterInput;
}>;


export type GetCompletedEvalByFilterQuery = { __typename?: 'Query', getCompletedEvalByFilter: Array<{ __typename?: 'GetCompletedEvalByFilterModel', patientNote?: string | null, evaluation?: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, content?: { __typename?: 'ContentEvaluationQuestionModel', body?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, dependentQuestionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, evaluationQuestion: { __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null, learnMore?: { __typename?: 'EvaluationLearnMoreModel', link?: string | null, value?: string | null } | null, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null, currentQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null, evaluation?: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, evaluationBlock?: { __typename?: 'EvaluationBlockModel', sysId?: string | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null } } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null } } | null> | null } | null> | null } | null } | null> | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null }> };

export type GetCompletedEvaluationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompletedEvaluationQuery = { __typename?: 'Query', getCompletedEvaluation: Array<{ __typename?: 'CompletedEvaluationModel', conditionEvaluations?: Array<ConditionEvaluationType | null> | null, consultType?: ConsultationSessionType | null, name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, content?: { __typename?: 'ContentEvaluationQuestionModel', body?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, dependentQuestionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null> | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, evaluationQuestion: { __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null } | null> | null, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null, learnMore?: { __typename?: 'EvaluationLearnMoreModel', link?: string | null, value?: string | null } | null, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null, currentQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null } | null, evaluation?: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, evaluationBlock?: { __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null } } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null } } | null> | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null } | null> | null, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null, learnMore?: { __typename?: 'EvaluationLearnMoreModel', link?: string | null, value?: string | null } | null, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null, validatePatientQuestionAnswer?: Array<{ __typename?: 'ValidatePatientQuestionAnswerModel', patientQuestionAnswer: { __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } }, validation: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } } | null> | null }> };

export type GetConfigEnvironmentQueryVariables = Exact<{
  input: PlatformEnvironmentInput;
}>;


export type GetConfigEnvironmentQuery = { __typename?: 'Query', getConfigEnvironment: { __typename?: 'ConfigEnvironmentModel', consultType?: ConsultType | null, country: string, deliveryAmount: number, evalIds?: EvalIds | null, evalsToShow?: Array<string | null> | null, metadataCountry: string, pharmacistEmail?: string | null, platform?: PlatformType | null, pmetadataCountry: string, pregnancyEvalQuestionIds?: any | null, productGroupIdsByEvaluationId?: any | null, skipEvalAppointment: any, stripeCurrencyRatio?: number | null, stripePriceType?: StripePriceType | null, stripeProduct?: any | null, successPage?: any | null, crossPlatformError?: { __typename?: 'CrossPlatformLogInError', code?: ErrorCode | null, currentPlatform?: PlatformType | null, message?: string | null, userPlatform?: PlatformType | null } | null, referralProgram?: { __typename?: 'ReferralProgram', referreeCouponCode?: string | null, referrerCouponCode?: string | null } | null } };

export type GetConsultTextDataQueryVariables = Exact<{
  input: GetConsultTextDataInput;
}>;


export type GetConsultTextDataQuery = { __typename?: 'Query', getConsultTextData: { __typename?: 'TextConsultationSessionModel', token: string, consultationSession: { __typename?: 'ConsultationSessionModel', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, friendlyName?: string | null, gmeetLink?: string | null, patientChatToken?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null }, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null } };

export type GetConsultationSessionByFilterQueryVariables = Exact<{
  input: GetConsultationByFilterInput;
}>;


export type GetConsultationSessionByFilterQuery = { __typename?: 'Query', getConsultationSessionByFilter: { __typename?: 'ConsultationSessionByFilterModel', token?: string | null, consultationSessions?: Array<{ __typename?: 'ConsultationSessionModel', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, friendlyName?: string | null, gmeetLink?: string | null, patientChatToken?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null }> | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, stripeProductPrice?: { __typename?: 'StripeProductPriceModel', importPriceId?: string | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceMetadata?: any | null, priceNickname?: string | null, priceProduct?: string | null, priceRecurring?: any | null, priceTaxBehavior?: string | null, priceType?: StripePriceType | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productCountry?: string | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productImage?: any | null, productIncluded?: any | null, productLivemode?: boolean | null, productMetadata?: any | null, productName?: string | null, productPurchaseds?: any | null, productSecondIncluded?: any | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, productEvaluationId?: { __typename?: 'StripeProductEvaluationIdModel', noah?: Array<string> | null, zoey?: Array<string> | null } | null, productIsShowOnShop?: { __typename?: 'StripeProductIsShowOnShopModel', noah?: boolean | null, zoey?: boolean | null } | null } | null } };

export type GetConsultationSessionByOrdersQueryVariables = Exact<{
  input: GetConsultationByOrdersInput;
}>;


export type GetConsultationSessionByOrdersQuery = { __typename?: 'Query', getConsultationSessionByOrders: Array<{ __typename?: 'ConsultationByOrdersModel', consultationSessions?: Array<{ __typename?: 'ConsultationSessionModel', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, friendlyName?: string | null, gmeetLink?: string | null, patientChatToken?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null }> };

export type GetConsultationVideoByOrderIdQueryVariables = Exact<{
  videoLink: Scalars['String'];
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink1: Scalars['String'];
  previewVideoLink: Scalars['String'];
  limit1?: InputMaybe<Scalars['Int']>;
  offset1?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  platform1?: InputMaybe<Scalars['String']>;
  input8?: InputMaybe<StripeProductFilterV2>;
  input9?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  input10: V2ConsultationFilterInput;
  input11: ConsultationMessagesInput;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input12: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId1?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  input13: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input14?: InputMaybe<GetPatientInput>;
  platform2?: InputMaybe<Scalars['String']>;
  platform3?: InputMaybe<Scalars['String']>;
  input15?: InputMaybe<StripeProductFilterV2>;
  input16: GetByOrderSysId;
}>;


export type GetConsultationVideoByOrderIdQuery = { __typename?: 'Query', getConsultationVideoByOrderId: { __typename?: 'ConsultationSessionModel', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, friendlyName?: string | null, gmeetLink?: string | null, patientChatToken?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null } | null> | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null } };

export type GetContinueTrialOrderDataQueryVariables = Exact<{
  input: ContinueTrialOrderInput;
}>;


export type GetContinueTrialOrderDataQuery = { __typename?: 'Query', getContinueTrialOrderData: { __typename?: 'ContinueTrialOrderDataModel', order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null, price?: { __typename?: 'StripePriceModel', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, id?: string | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, nickname?: string | null, product?: string | null, stripeProduct?: any | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, recurring?: { __typename?: 'StripePriceRecurringModel', aggregate_usage?: StripePriceRecurringAggregateUsage | null, interval?: StripePriceRecurringInterval | null, interval_count?: number | null, trial_period_days?: number | null, usage_type?: StripePriceRecurringUsageType | null } | null } | null, product?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } };

export type GetCronjobsByFilterQueryVariables = Exact<{
  input: GetCronjobInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetCronjobsByFilterQuery = { __typename?: 'Query', getCronjobsByFilter: { __typename?: 'PaginatedCronjobModel', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'CronjobModel', createdAt?: any | null, createdBy?: string | null, description?: string | null, isActive?: boolean | null, name: string, updatedAt?: any | null, updatedBy?: string | null }> | null } };

export type GetCurrentPatientOnboardingQueryVariables = Exact<{
  input: GetCurrentPatientOnboardingInput;
}>;


export type GetCurrentPatientOnboardingQuery = { __typename?: 'Query', getCurrentPatientOnboarding: { __typename?: 'PatientOnboardingModel', currentStep?: number | null, patientId?: string | null, skipGuide?: boolean | null, status?: OnboardingStatus | null, sysId: string, tourName?: string | null } };

export type GetDeliveryOrderByFilterQueryVariables = Exact<{
  input: DeliveryOrderFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetDeliveryOrderByFilterQuery = { __typename?: 'Query', getDeliveryOrderByFilter: { __typename?: 'PaginatedOrderModel', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }> | null } };

export type GetDispatchJobByFilterQueryVariables = Exact<{
  input: DispatchJobFilterInput;
}>;


export type GetDispatchJobByFilterQuery = { __typename?: 'Query', getDispatchJobByFilter: Array<{ __typename?: 'DispatchJobModel', collectionSnapshot?: any | null, deliverySnapshot?: any | null, orderId?: string | null, sysId?: string | null }> };

export type GetDoctorDashboardOrdersByFilterQueryVariables = Exact<{
  input: OrderFilterForDoctorDashboardInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetDoctorDashboardOrdersByFilterQuery = { __typename?: 'Query', getDoctorDashboardOrdersByFilter: { __typename?: 'DoctorDashboardOrdersByFilterModel', orders?: any | null, consultationSessions?: Array<{ __typename?: 'ConsultationSessionModel', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, friendlyName?: string | null, gmeetLink?: string | null, patientChatToken?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } };

export type GetDoctorInAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDoctorInAuthQuery = { __typename?: 'Query', getDoctorInAuth: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } };

export type GetDoctorOrdersQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  country?: InputMaybe<Scalars['String']>;
  dateSearch?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  patientIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  today?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDoctorOrdersQuery = { __typename?: 'Query', getDoctorOrders: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }> };

export type GetDoctorsByFilterQueryVariables = Exact<{
  input: FilterDoctorInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetDoctorsByFilterQuery = { __typename?: 'Query', getDoctorsByFilter: Array<{ __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null }> };

export type GetDoctorsWithAppointmentTypeQueryVariables = Exact<{
  input: DoctorsWithAppointmentTypeInput;
}>;


export type GetDoctorsWithAppointmentTypeQuery = { __typename?: 'Query', getDoctorsWithAppointmentType: Array<{ __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null }> };

export type GetEvaluationByFilterQueryVariables = Exact<{
  input: EvaluationInput;
}>;


export type GetEvaluationByFilterQuery = { __typename?: 'Query', getEvaluationByFilter: Array<{ __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, content?: { __typename?: 'ContentEvaluationQuestionModel', body?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, dependentQuestionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null> | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, evaluationQuestion: { __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null } | null> | null, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null, learnMore?: { __typename?: 'EvaluationLearnMoreModel', link?: string | null, value?: string | null } | null, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null, currentQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null } | null, evaluation?: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, evaluationBlock?: { __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null } } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null } } | null> | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null } | null> | null, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null, learnMore?: { __typename?: 'EvaluationLearnMoreModel', link?: string | null, value?: string | null } | null, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null }> };

export type GetEvaluationByOrdersQueryVariables = Exact<{
  input: GetEvaluationByOrderInput;
}>;


export type GetEvaluationByOrdersQuery = { __typename?: 'Query', getEvaluationByOrders: Array<{ __typename?: 'GetEvaluationByOrderModel', orderId?: string | null, patientNote?: string | null, patientQuestionAnswers?: Array<any> | null }> };

export type GetEvaluationDashboardQueryVariables = Exact<{
  input: GetEvaluationDashboardInput;
}>;


export type GetEvaluationDashboardQuery = { __typename?: 'Query', getEvaluationDashboard: { __typename?: 'EvaluationDashboardModel', patientEvaluations?: Array<any> | null, patientQuestionAnswers?: Array<any> | null, currentPatientEvaluation?: { __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null, currentQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, content?: { __typename?: 'ContentEvaluationQuestionModel', body?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, dependentQuestionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null> | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, evaluationQuestion: { __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null } | null> | null, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null, learnMore?: { __typename?: 'EvaluationLearnMoreModel', link?: string | null, value?: string | null } | null, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null, currentQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null, evaluation?: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, evaluationBlock?: { __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null } } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null } } | null> | null } | null> | null } | null, evaluation?: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, evaluationBlock?: { __typename?: 'EvaluationBlockModel', sysId?: string | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, evaluationQuestions: Array<{ __typename?: 'EvaluationQuestionAnswerModel', answers?: Array<any> | null, content?: any | null, dependentEvaluationQuestions?: Array<any> | null, displayPage: number, evaluationBlocks?: Array<any> | null, guestOnly: boolean, order: number, question: any, sysId?: string | null, validation?: any | null }> } };

export type GetEvaluationFormByFilterQueryVariables = Exact<{
  input: EvaluationFormInput;
}>;


export type GetEvaluationFormByFilterQuery = { __typename?: 'Query', getEvaluationFormByFilter: Array<{ __typename?: 'EvaluationFormModel', createdAt: any, customFields?: any | null, description?: string | null, disabled?: boolean | null, formSections?: any | null, id?: string | null, learnMoreLink?: any | null, onCompleteRedirect?: string | null, sysId?: string | null, title?: string | null, total?: number | null, updatedAt: any, version?: string | null }> };

export type GetExcludedEvalIdsForShowingTreatmentQueryVariables = Exact<{
  input: ExcludedEvalInput;
}>;


export type GetExcludedEvalIdsForShowingTreatmentQuery = { __typename?: 'Query', getExcludedEvalIdsForShowingTreatment: Array<string> };

export type GetExcludedEvaluationIdsQueryVariables = Exact<{
  input: ExcludedEvaluationIdsInput;
}>;


export type GetExcludedEvaluationIdsQuery = { __typename?: 'Query', getExcludedEvaluationIds: Array<string> };

export type GetExtraInfoForEditingOrderQueryVariables = Exact<{
  input: GetExtraInfoOrderDetailInput;
}>;


export type GetExtraInfoForEditingOrderQuery = { __typename?: 'Query', getExtraInfoForEditingOrder: { __typename?: 'ExtraInfoForOrderModel', evalPatientQuestionAnswers?: Array<any> | null, availableProductSelectableList?: Array<{ __typename?: 'ProductListModel', title?: string | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null } | null> | null, checkProductsExistingOrdersForPatient?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, consultationSession?: { __typename?: 'ConsultationSessionModel', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, friendlyName?: string | null, gmeetLink?: string | null, patientChatToken?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, doctorNotes?: Array<{ __typename?: 'DoctorNoteModel', approved?: string | null, condition?: string | null, dosage?: any | null, evaluationId?: string | null, orderSysId: string, approver?: { __typename?: 'ApproverModel', name?: string | null, role: UserRole } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, notes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, stripePrices: Array<{ __typename?: 'StripePriceModel', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, id?: string | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, nickname?: string | null, product?: string | null, stripeProduct?: any | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, recurring?: { __typename?: 'StripePriceRecurringModel', aggregate_usage?: StripePriceRecurringAggregateUsage | null, interval?: StripePriceRecurringInterval | null, interval_count?: number | null, trial_period_days?: number | null, usage_type?: StripePriceRecurringUsageType | null } | null }> } | null> | null, evaluation?: { __typename?: 'EvaluationFormModel', createdAt: any, customFields?: any | null, description?: string | null, disabled?: boolean | null, formSections?: any | null, id?: string | null, learnMoreLink?: any | null, onCompleteRedirect?: string | null, sysId?: string | null, title?: string | null, total?: number | null, updatedAt: any, version?: string | null } | null, evaluationQuestions?: Array<{ __typename?: 'CustomEvaluationQuestionModel', displayPage: number, evaluation?: any | null, guestOnly: boolean, order: number, question: any, sysId?: string | null, content?: { __typename?: 'ContentEvaluationQuestionModel', body?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, dependentQuestionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null } | null> | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, evaluationQuestion: { __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null } | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null, learnMore?: { __typename?: 'EvaluationLearnMoreModel', link?: string | null, value?: string | null } | null, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null, currentQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null, evaluation?: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, evaluationBlock?: { __typename?: 'EvaluationBlockModel', sysId?: string | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null } } | null> | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null } } | null> | null } | null> | null, orderProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, patientProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prices?: { __typename?: 'PricesListModel', data?: Array<{ __typename?: 'PriceModel', active?: boolean | null, billing_scheme?: any | null, created?: number | null, currency?: string | null, id?: string | null, livemode?: boolean | null, lookup_key?: string | null, metadata?: any | null, nickname?: string | null, object?: string | null, product?: any | null, recurring?: any | null, tax_behavior?: any | null, tiers?: any | null, tiers_mode?: any | null, transform_quantity?: any | null, type?: any | null, unit_amount?: number | null, unit_amount_decimal?: string | null } | null> | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } };

export type GetExtraProductPriceInfoByEvaluationQueryVariables = Exact<{
  input: GetExtraProductPriceInfoByEvaluationInput;
}>;


export type GetExtraProductPriceInfoByEvaluationQuery = { __typename?: 'Query', getExtraProductPriceInfoByEvaluation: { __typename?: 'GetExtraProductPriceByEvaluationModel', suggestTreatments?: Array<EvalIds> | null, stripeProductPrices?: Array<{ __typename?: 'ExtraStripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, dosageAnswer?: number | null, evaluationId?: any | null, id?: string | null, isConsultOnly: boolean, isFixedDose: boolean, isRxOneTime: boolean, isShowOnShop?: any | null, isSkipMedProduct: boolean, isTextConsult: boolean, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, popularPriceId: string, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, shouldChargeNow: boolean, shouldHideEditFreq: boolean, shouldShowConsultFee: boolean, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null }> | null } };

export type GetGiveAwayByFilterQueryVariables = Exact<{
  input: GiveAwayFilterInput;
}>;


export type GetGiveAwayByFilterQuery = { __typename?: 'Query', getGiveAwayByFilter: Array<{ __typename?: 'GiveawayModel', address?: string | null, answer: string, cartId?: string | null, choice: string, createdAt?: any | null, email: string, eventPeriod: string, moneySpent: number, orderId?: string | null, patientId?: string | null, phone?: string | null }> };

export type GetImagesByFilterQueryVariables = Exact<{
  input: ImageInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetImagesByFilterQuery = { __typename?: 'Query', getImagesByFilter: Array<{ __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null }> };

export type GetInvoicesBySubscriptionIdQueryVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type GetInvoicesBySubscriptionIdQuery = { __typename?: 'Query', getInvoicesBySubscriptionId: { __typename?: 'StripeInvoiceListModel', has_more?: boolean | null, lastResponse?: any | null, url?: string | null, data?: Array<{ __typename?: 'StripeInvoiceModel', auto_advance?: boolean | null, charge?: string | null, collection_method?: string | null, created?: number | null, currency?: string | null, description?: string | null, hosted_invoice_url?: string | null, id?: string | null, lines?: any | null, metadata?: any | null, next_payment_attempt?: number | null, payment_intent?: string | null, period_end?: number | null, period_start?: number | null, status?: string | null, subscription?: string | null, total?: number | null } | null> | null } };

export type GetLabelFromDetrackQueryVariables = Exact<{
  input: ExportLableInput;
}>;


export type GetLabelFromDetrackQuery = { __typename?: 'Query', getLabelFromDetrack: string };

export type GetLastTreatmentOrderQueryVariables = Exact<{
  input: LastTreatmentOrderInput;
}>;


export type GetLastTreatmentOrderQuery = { __typename?: 'Query', getLastTreatmentOrder: { __typename?: 'LastTreatmentOrder', order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null } };

export type GetListOrderConsultationByFilterQueryVariables = Exact<{
  input: OrderFilterForOpsConsultationsInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetListOrderConsultationByFilterQuery = { __typename?: 'Query', getListOrderConsultationByFilter: { __typename?: 'PaginatedOrderModel', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }> | null } };

export type GetListPatientSuggestionByDoctorQueryVariables = Exact<{
  input: DocPatientSuggestionByDoctorInput;
}>;


export type GetListPatientSuggestionByDoctorQuery = { __typename?: 'Query', getListPatientSuggestionByDoctor: Array<{ __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null }> };

export type GetOpsConvertedOrdersQueryVariables = Exact<{
  filter: OpsConvertedOrdersFilterInput;
}>;


export type GetOpsConvertedOrdersQuery = { __typename?: 'Query', getOpsConvertedOrders: { __typename?: 'OpsConvertedOrdersResult', convertedCount: number, limit?: number | null, offset?: number | null, total: number, items: Array<{ __typename?: 'OpsConvertedOrderRow', approveAt?: any | null, converted: boolean, createdAt?: any | null, currency?: string | null, initialTotal?: number | null, lastPaymentDate?: any | null, shortId?: number | null, status: OrderStatus, sysId: string, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null }> } };

export type GetOpsConvertedOrdersUtmSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpsConvertedOrdersUtmSourcesQuery = { __typename?: 'Query', getOpsConvertedOrdersUtmSources: Array<string> };

export type GetOpsDashboardOrderListByFilterV2QueryVariables = Exact<{
  input: OrderFilterForOpsDashboardInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetOpsDashboardOrderListByFilterV2Query = { __typename?: 'Query', getOpsDashboardOrderListByFilterV2: { __typename?: 'OpsPaginatedOrderModel', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'PaginatedOpsDashBoardOrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isRenewalSubscription: boolean, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isSuitableForWeightLoss?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, parentOrderShortId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, price?: { __typename?: 'StripeProductPriceModel', importPriceId?: string | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceMetadata?: any | null, priceNickname?: string | null, priceProduct?: string | null, priceRecurring?: any | null, priceTaxBehavior?: string | null, priceType?: StripePriceType | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productCountry?: string | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productImage?: any | null, productIncluded?: any | null, productLivemode?: boolean | null, productMetadata?: any | null, productName?: string | null, productPurchaseds?: any | null, productSecondIncluded?: any | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, productEvaluationId?: { __typename?: 'StripeProductEvaluationIdModel', noah?: Array<string> | null, zoey?: Array<string> | null } | null, productIsShowOnShop?: { __typename?: 'StripeProductIsShowOnShopModel', noah?: boolean | null, zoey?: boolean | null } | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, retentionPromo?: { __typename?: 'RetentionPromoTagDto', code: string, expiresAt?: any | null, giftDescription?: string | null, redeemedAt?: any | null, region: string, status: RetentionPromoStatus, sysId: string } | null, subscription?: { __typename?: 'StripeSubscriptionModel', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, customer?: string | null, default_payment_method?: string | null, id: string, items?: any | null, latest_invoice?: string | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: string | null, pending_update?: any | null, plan?: any | null, status?: string | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }> | null } };

export type GetOpsOrderDetailQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetOpsOrderDetailQuery = { __typename?: 'Query', getOpsOrderDetail: { __typename?: 'OpsOrderDetailModel', appointmentTypeID?: number | null, needFollowUpConsultAfterRenewing?: boolean | null, order?: any | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, doctorNotes?: Array<{ __typename?: 'DoctorNoteModel', approved?: string | null, condition?: string | null, dosage?: any | null, evaluationId?: string | null, orderSysId: string, approver?: { __typename?: 'ApproverModel', name?: string | null, role: UserRole } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } | null, notes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, stripePrices: Array<{ __typename?: 'StripePriceModel', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, id?: string | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, nickname?: string | null, product?: string | null, stripeProduct?: any | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, recurring?: { __typename?: 'StripePriceRecurringModel', aggregate_usage?: StripePriceRecurringAggregateUsage | null, interval?: StripePriceRecurringInterval | null, interval_count?: number | null, trial_period_days?: number | null, usage_type?: StripePriceRecurringUsageType | null } | null }> } | null> | null, doctors?: Array<{ __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null> | null, invoices?: Array<{ __typename?: 'StripeInvoiceModel', auto_advance?: boolean | null, charge?: string | null, collection_method?: string | null, created?: number | null, currency?: string | null, description?: string | null, hosted_invoice_url?: string | null, id?: string | null, lines?: any | null, metadata?: any | null, next_payment_attempt?: number | null, payment_intent?: string | null, period_end?: number | null, period_start?: number | null, status?: string | null, subscription?: string | null, total?: number | null }> | null, orderStripeProductPrice?: { __typename?: 'StripeProductPriceModel', importPriceId?: string | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceMetadata?: any | null, priceNickname?: string | null, priceProduct?: string | null, priceRecurring?: any | null, priceTaxBehavior?: string | null, priceType?: StripePriceType | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productCountry?: string | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productImage?: any | null, productIncluded?: any | null, productLivemode?: boolean | null, productMetadata?: any | null, productName?: string | null, productPurchaseds?: any | null, productSecondIncluded?: any | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, productEvaluationId?: { __typename?: 'StripeProductEvaluationIdModel', noah?: Array<string> | null, zoey?: Array<string> | null } | null, productIsShowOnShop?: { __typename?: 'StripeProductIsShowOnShopModel', noah?: boolean | null, zoey?: boolean | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, prescriptionPrices?: { __typename?: 'PricesListModel', data?: Array<{ __typename?: 'PriceModel', active?: boolean | null, billing_scheme?: any | null, created?: number | null, currency?: string | null, id?: string | null, livemode?: boolean | null, lookup_key?: string | null, metadata?: any | null, nickname?: string | null, object?: string | null, product?: any | null, recurring?: any | null, tax_behavior?: any | null, tiers?: any | null, tiers_mode?: any | null, transform_quantity?: any | null, type?: any | null, unit_amount?: number | null, unit_amount_decimal?: string | null } | null> | null } | null, prescriptionProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, prices?: Array<{ __typename?: 'StripeProductPriceModel', importPriceId?: string | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceMetadata?: any | null, priceNickname?: string | null, priceProduct?: string | null, priceRecurring?: any | null, priceTaxBehavior?: string | null, priceType?: StripePriceType | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productCountry?: string | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productImage?: any | null, productIncluded?: any | null, productLivemode?: boolean | null, productMetadata?: any | null, productName?: string | null, productPurchaseds?: any | null, productSecondIncluded?: any | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, productEvaluationId?: { __typename?: 'StripeProductEvaluationIdModel', noah?: Array<string> | null, zoey?: Array<string> | null } | null, productIsShowOnShop?: { __typename?: 'StripeProductIsShowOnShopModel', noah?: boolean | null, zoey?: boolean | null } | null }> | null, productGroup?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, retentionPromo?: { __typename?: 'RetentionPromoTagDto', code: string, expiresAt?: any | null, giftDescription?: string | null, redeemedAt?: any | null, region: string, status: RetentionPromoStatus, sysId: string } | null, stripeProducts?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, subscription?: { __typename?: 'StripeSubscriptionModel', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, customer?: string | null, default_payment_method?: string | null, id: string, items?: any | null, latest_invoice?: string | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: string | null, pending_update?: any | null, plan?: any | null, status?: string | null } | null } };

export type GetOrderByFilterQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: OrderFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type GetOrderByFilterQuery = { __typename?: 'Query', getOrderByFilter: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }> };

export type GetOrderByIdQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  id: Scalars['String'];
}>;


export type GetOrderByIdQuery = { __typename?: 'Query', getOrderById: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } };

export type GetOrderByIdWithDisplayIdQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  id: Scalars['String'];
}>;


export type GetOrderByIdWithDisplayIdQuery = { __typename?: 'Query', getOrderByIdWithDisplayId: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } };

export type GetOrderByProductQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: StripeProductInput;
}>;


export type GetOrderByProductQuery = { __typename?: 'Query', getOrderByProduct: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }> };

export type GetOrderDetailWithPatientQueryVariables = Exact<{
  input: GetOrderWithPatientDetail;
}>;


export type GetOrderDetailWithPatientQuery = { __typename?: 'Query', getOrderDetailWithPatient: { __typename?: 'OrderWithPatientModel', affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } };

export type GetPatientBookingInfoQueryVariables = Exact<{
  input: PatientBookingInput;
}>;


export type GetPatientBookingInfoQuery = { __typename?: 'Query', getPatientBookingInfo: { __typename?: 'PatientBookingDataModel', needsBookingOrderIds: Array<string>, totalBookingOrderIds: Array<string>, bookingOrder: { __typename?: 'PatientBookingOrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderFromNewPrescriptionFlow: boolean, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, needsBooking: boolean, needsBookingDelivery: boolean, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, availableSlots?: Array<{ __typename?: 'AvailableSlotModel', date?: string | null, times?: Array<string | null> | null } | null> | null, consultationSession?: { __typename?: 'ConsultationSessionModel', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, friendlyName?: string | null, gmeetLink?: string | null, patientChatToken?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }, cart?: { __typename?: 'CheckoutCartModel', cartItems?: any | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, sysId: string, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, calculateOrderSummary?: { __typename?: 'CalculateOrderSummaryModel', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null, itemList?: Array<{ __typename?: 'PaymentItemInfoModel', consultationSessionType?: ConsultationSessionType | null, isEDBundle?: boolean | null, isPayNow?: boolean | null, isRxProduct?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, isSubscriptionUpdate?: boolean | null, itemSubTotal?: number | null, itemSubTotalAfterDiscount?: number | null, mainProductId?: string | null, mainProductName?: string | null, name?: string | null, priceId?: string | null, priceType?: StripePriceType | null, productId?: string | null, productUniqName?: ProductNameType | null, quantity?: number | null, unit_amount?: number | null } | null> | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, patient: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } } };

export type GetPatientByFilterQueryVariables = Exact<{
  input: PatientFilterInput;
}>;


export type GetPatientByFilterQuery = { __typename?: 'Query', getPatientByFilter: Array<{ __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null }> };

export type GetPatientByIdQueryVariables = Exact<{
  input: PatientFilterInput;
}>;


export type GetPatientByIdQuery = { __typename?: 'Query', getPatientById: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } };

export type GetPatientByIdsQueryVariables = Exact<{
  input: PatientFilterByIdsInput;
}>;


export type GetPatientByIdsQuery = { __typename?: 'Query', getPatientByIds: Array<{ __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null }> };

export type GetPatientByReferralCodeQueryVariables = Exact<{
  input: PatientByReferralCodeInput;
}>;


export type GetPatientByReferralCodeQuery = { __typename?: 'Query', getPatientByReferralCode: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } };

export type GetPatientDataQueryVariables = Exact<{
  input: PatientDashboardInput;
}>;


export type GetPatientDataQuery = { __typename?: 'Query', getPatientData: { __typename?: 'PatientDashboardDataModel', consultationSessions?: any | null, shoppingExcludedEvalIds: Array<string>, treatmentExcludedEvalIds: Array<string>, activeProductIds: { __typename?: 'ActiveProductIds', activeProducts: Array<string>, completedEvalIds: Array<string>, pendingEvalIds: Array<string>, skippedEvalIds: Array<string> }, bannerProducts: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null }>, cart: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null }, cashbackDashboard: { __typename?: 'CashbackDashboardModel', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionModel', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionModel', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null }, completedEvals: Array<{ __typename?: 'GetCompletedEvalByFilterModel', patientNote?: string | null, evaluation?: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, content?: { __typename?: 'ContentEvaluationQuestionModel', body?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseEvaluationQuestion', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, dependentQuestionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null, answer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null> | null, parentAnswer?: { __typename?: 'AnswerModel', deselectAll: boolean, mandatory?: boolean | null, name: string, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey: string, type?: QuestionType | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentEvaluationQuestionModel', skipPage: boolean, skipQuestionCount: number, sysId?: string | null, evaluationQuestion: { __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockModel', sysId?: string | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null> | null, patientQuestionAnswers?: Array<{ __typename?: 'PatientQuestionAnswerModel', type: PatientQuestionAnswerType, value?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null> | null, question?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null } | null } } | null> | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null, question: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType }, validation?: { __typename?: 'ValidationEvaluationQuestionModel', mandatory?: boolean | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null, learnMore?: { __typename?: 'EvaluationLearnMoreModel', link?: string | null, value?: string | null } | null, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null, currentQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType, evaluationQuestions?: Array<{ __typename?: 'EvaluationQuestionModel', displayPage: number, guestOnly: boolean, order: number, sysId?: string | null } | null> | null } | null, evaluation?: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, evaluationBlock?: { __typename?: 'EvaluationBlockModel', sysId?: string | null, blockByQuestion?: { __typename?: 'QuestionModel', name: string, sysId?: string | null, textKey: string, type: QuestionType } | null, content?: { __typename?: 'EvaluationBlockContentModel', description?: string | null, descriptionTextKey?: string | null, title: string, titleTextKey: string } | null, evaluation: { __typename?: 'EvaluationModel', name?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null }, patientEvaluations?: Array<{ __typename?: 'PatientEvaluationModel', consultType?: ConsultationSessionType | null, isCompleted?: boolean | null, isSkipped?: boolean | null, patientNote?: string | null } | null> | null, questionAnswer: { __typename?: 'QuestionAnswerModel', sysId?: string | null } } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null }>, notificationOrders: Array<{ __typename?: 'ExtraOrderInfoModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, canEditDeliveryTime?: { __typename?: 'EditDeliveryTimeModel', canEdit?: boolean | null, isEditWithin2Hours?: boolean | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }>, patientCodeData: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null } | null } | null> | null } | null }>, stripeProducts: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null }>, suggestionProducts: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null }>, teleConsultOrders: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }>, tour?: { __typename?: 'PatientOnboardingModel', currentStep?: number | null, patientId?: string | null, skipGuide?: boolean | null, status?: OnboardingStatus | null, sysId: string, tourName?: string | null } | null } };

export type GetPatientInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientInfoQuery = { __typename?: 'Query', getPatientInfo?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null };

export type GetPatientListForDoctorQueryVariables = Exact<{
  country: Scalars['String'];
  limit: Scalars['Float'];
  offset: Scalars['Float'];
}>;


export type GetPatientListForDoctorQuery = { __typename?: 'Query', getPatientListForDoctor: Array<{ __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null }> };

export type GetPatientPlanDetailDataQueryVariables = Exact<{
  input: PatientPlanDetailInput;
}>;


export type GetPatientPlanDetailDataQuery = { __typename?: 'Query', getPatientPlanDetailData: { __typename?: 'PatientPlanDetailModel', planData: { __typename?: 'GetPlansModel', continueTrial?: boolean | null, countTrialReminder?: number | null, evaluationId?: string | null, evaluationTitle?: string | null, isAutoRenewal?: boolean | null, isEDTrial?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isSubscriptionPrice?: boolean | null, isSubscriptionTrial?: boolean | null, oldPriceInfo?: any | null, oldProductInfo?: any | null, orderPriceId?: string | null, paymentProvider?: string | null, prescribeAfterTeleConsult?: boolean | null, priceInfo?: any | null, productInfo?: any | null, shortId?: number | null, status?: string | null, stripeSubscriptionId?: string | null, subscriptionId?: string | null, sysId?: string | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null } | null> | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null }, refCoupon: { __typename?: 'GetReferralModel', info: any } } };

export type GetPatientPlansDataQueryVariables = Exact<{
  input: PatientPlanInput;
}>;


export type GetPatientPlansDataQuery = { __typename?: 'Query', getPatientPlansData: { __typename?: 'PatientPlansDataModel', refCoupon: { __typename?: 'GetReferralModel', info: any } } };

export type GetPatientProfileForPregnancyChecklistQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientProfileForPregnancyChecklistQuery = { __typename?: 'Query', getPatientProfileForPregnancyChecklist: { __typename?: 'PatientPrenatalModel', age?: string | null, condition?: string | null, getPreggers?: string | null, hasChildren?: boolean | null, height?: string | null, name?: string | null, weight?: string | null } };

export type GetPatientPromotionCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientPromotionCodesQuery = { __typename?: 'Query', getPatientPromotionCodes: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null } | null } | null> | null } | null }> };

export type GetPlansQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
}>;


export type GetPlansQuery = { __typename?: 'Query', getPlans: Array<{ __typename?: 'GetPlansModel', continueTrial?: boolean | null, countTrialReminder?: number | null, evaluationId?: string | null, evaluationTitle?: string | null, isAutoRenewal?: boolean | null, isEDTrial?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isSubscriptionPrice?: boolean | null, isSubscriptionTrial?: boolean | null, oldPriceInfo?: any | null, oldProductInfo?: any | null, orderPriceId?: string | null, paymentProvider?: string | null, prescribeAfterTeleConsult?: boolean | null, priceInfo?: any | null, productInfo?: any | null, shortId?: number | null, status?: string | null, stripeSubscriptionId?: string | null, subscriptionId?: string | null, sysId?: string | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null } | null> | null } | null> | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null }> };

export type GetPreblockForGuestQueryVariables = Exact<{
  anonymousId: Scalars['String'];
}>;


export type GetPreblockForGuestQuery = { __typename?: 'Query', getPreblockForGuest?: { __typename?: 'PreblockDto', expiresAt: string, heldAppointmentTypeId: string, heldDateTime: string, preblockId: string, status: PreblockStatus } | null };

export type GetPrescriptionByFilterQueryVariables = Exact<{
  input: PrescriptionFilterInput;
}>;


export type GetPrescriptionByFilterQuery = { __typename?: 'Query', getPrescriptionByFilter: Array<{ __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null }> };

export type GetPrescriptionByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPrescriptionByIdQuery = { __typename?: 'Query', getPrescriptionById: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } };

export type GetPrescriptionOrderBookingResultQueryVariables = Exact<{
  input: GetPrescriptionOrderBookingResultInput;
}>;


export type GetPrescriptionOrderBookingResultQuery = { __typename?: 'Query', getPrescriptionOrderBookingResult: { __typename?: 'GetPrescriptionOrderBookingResultModel', isBooked: boolean, order: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null }, stripeProductPrice: { __typename?: 'StripeProductPriceModel', importPriceId?: string | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceMetadata?: any | null, priceNickname?: string | null, priceProduct?: string | null, priceRecurring?: any | null, priceTaxBehavior?: string | null, priceType?: StripePriceType | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productCountry?: string | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productImage?: any | null, productIncluded?: any | null, productLivemode?: boolean | null, productMetadata?: any | null, productName?: string | null, productPurchaseds?: any | null, productSecondIncluded?: any | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, productEvaluationId?: { __typename?: 'StripeProductEvaluationIdModel', noah?: Array<string> | null, zoey?: Array<string> | null } | null, productIsShowOnShop?: { __typename?: 'StripeProductIsShowOnShopModel', noah?: boolean | null, zoey?: boolean | null } | null } } };

export type GetPrescriptionOrderCalculationQueryVariables = Exact<{
  input: GetPrescriptionOrderCalculationInput;
}>;


export type GetPrescriptionOrderCalculationQuery = { __typename?: 'Query', getPrescriptionOrderCalculation: { __typename?: 'PrescriptionOrderCalculationModel', cashbackEarnRate: number, cashbackEarned: number, cashbackRedeemed: number, consultFee: number, consultFeeAfterDiscount: number, discountAmount: number, isConsult: boolean, minimalAmountPayment: number, paymentIntentAmount: number, paymentIntentAmountAfterCashback: number, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount: number, productPriceAmountAfterDiscount: number, promotionCode?: string | null, promotionCodeError?: PromotionCodeError | null, shouldChargeConsultFee?: boolean | null, subTotal: number, total: number, totalAfterCashback: number, stripeProductPrice: { __typename?: 'StripeProductPriceModel', importPriceId?: string | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceMetadata?: any | null, priceNickname?: string | null, priceProduct?: string | null, priceRecurring?: any | null, priceTaxBehavior?: string | null, priceType?: StripePriceType | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productCountry?: string | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productImage?: any | null, productIncluded?: any | null, productLivemode?: boolean | null, productMetadata?: any | null, productName?: string | null, productPurchaseds?: any | null, productSecondIncluded?: any | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, productEvaluationId?: { __typename?: 'StripeProductEvaluationIdModel', noah?: Array<string> | null, zoey?: Array<string> | null } | null, productIsShowOnShop?: { __typename?: 'StripeProductIsShowOnShopModel', noah?: boolean | null, zoey?: boolean | null } | null }, stripePromotionCode?: { __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null } | null } | null> | null } | null } | null } };

export type GetPriceByIntentIdQueryVariables = Exact<{
  input: GetPriceByIntentIdInput;
}>;


export type GetPriceByIntentIdQuery = { __typename?: 'Query', getPriceByIntentId: { __typename?: 'StripePriceModel', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, id?: string | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, nickname?: string | null, product?: string | null, stripeProduct?: any | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, recurring?: { __typename?: 'StripePriceRecurringModel', aggregate_usage?: StripePriceRecurringAggregateUsage | null, interval?: StripePriceRecurringInterval | null, interval_count?: number | null, trial_period_days?: number | null, usage_type?: StripePriceRecurringUsageType | null } | null } };

export type GetPriceTranslatedTextQueryVariables = Exact<{
  input: TranslatedTextPriceQueryInput;
}>;


export type GetPriceTranslatedTextQuery = { __typename?: 'Query', getPriceTranslatedText: Array<{ __typename?: 'PriceLocaleModel', priceId?: string | null, locales?: Array<{ __typename?: 'KeyValuePriceLocaleModel', key?: StripePriceLocaleKeys | null, value?: string | null } | null> | null }> };

export type GetPricesByProductIdsQueryVariables = Exact<{
  input: PricesByProductIdsInput;
}>;


export type GetPricesByProductIdsQuery = { __typename?: 'Query', getPricesByProductIds: { __typename?: 'PricesListModel', data?: Array<{ __typename?: 'PriceModel', active?: boolean | null, billing_scheme?: any | null, created?: number | null, currency?: string | null, id?: string | null, livemode?: boolean | null, lookup_key?: string | null, metadata?: any | null, nickname?: string | null, object?: string | null, product?: any | null, recurring?: any | null, tax_behavior?: any | null, tiers?: any | null, tiers_mode?: any | null, transform_quantity?: any | null, type?: any | null, unit_amount?: number | null, unit_amount_decimal?: string | null } | null> | null } };

export type GetProductByFilterQueryVariables = Exact<{
  input: ProductFilterInput;
}>;


export type GetProductByFilterQuery = { __typename?: 'Query', getProductByFilter: Array<{ __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null }> };

export type GetProductInfoQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetProductInfoQuery = { __typename?: 'Query', getProductInfo: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } };

export type GetProductTranslatedTextQueryVariables = Exact<{
  input: TranslatedTextProductQueryInput;
}>;


export type GetProductTranslatedTextQuery = { __typename?: 'Query', getProductTranslatedText: Array<{ __typename?: 'ProductLocaleModel', productId?: string | null, locales?: Array<{ __typename?: 'KeyValueProductLocaleModel', key?: StripeProductLocaleKeys | null, value?: string | null } | null> | null }> };

export type GetReferralCouponQueryVariables = Exact<{
  input: ReferralProgramFilterInput;
}>;


export type GetReferralCouponQuery = { __typename?: 'Query', getReferralCoupon: { __typename?: 'GetReferralModel', info: any } };

export type GetRenewalOrderInfoQueryVariables = Exact<{
  input: GetRenewalOrderInfoInput;
}>;


export type GetRenewalOrderInfoQuery = { __typename?: 'Query', getRenewalOrderInfo: { __typename?: 'RenewOrderInfoModel', last4: string, paymentMethodId: string, upcomingAmount: number } };

export type GetShopInfoQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: ShopInput;
}>;


export type GetShopInfoQuery = { __typename?: 'Query', getShopInfo: { __typename?: 'ShopDataModel', excludedEvalIds: Array<string>, activeProductIds: { __typename?: 'ActiveProductIds', activeProducts: Array<string>, completedEvalIds: Array<string>, pendingEvalIds: Array<string>, skippedEvalIds: Array<string> }, acuityAppointments: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null } | null> | null }>, cartData: { __typename?: 'CartCalculationModel', calculateOrderSummary?: any | null, calculation?: any | null, cart?: any | null, cartItems?: any | null, errorCode?: string | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: any | null, status?: CartStatus | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null }, teleConsultOrders: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }> } };

export type GetStripeCouponByFilterQueryVariables = Exact<{
  input: StripeCouponFilterInput;
}>;


export type GetStripeCouponByFilterQuery = { __typename?: 'Query', getStripeCouponByFilter: Array<{ __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null } | null> | null } | null } | null> | null }> };

export type GetStripeCouponByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetStripeCouponByIdQuery = { __typename?: 'Query', getStripeCouponById: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null } | null> | null } | null } | null> | null } };

export type GetStripePriceByIdQueryVariables = Exact<{
  input: StripePriceFilterInput;
}>;


export type GetStripePriceByIdQuery = { __typename?: 'Query', getStripePriceById: { __typename?: 'StripePriceModel', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, id?: string | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, nickname?: string | null, product?: string | null, stripeProduct?: any | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, recurring?: { __typename?: 'StripePriceRecurringModel', aggregate_usage?: StripePriceRecurringAggregateUsage | null, interval?: StripePriceRecurringInterval | null, interval_count?: number | null, trial_period_days?: number | null, usage_type?: StripePriceRecurringUsageType | null } | null } };

export type GetStripeProductByFilterQueryVariables = Exact<{
  input: StripeProductFilterInput;
}>;


export type GetStripeProductByFilterQuery = { __typename?: 'Query', getStripeProductByFilter: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null }> };

export type GetStripeProductByIdQueryVariables = Exact<{
  input: StripeProductByIdInput;
}>;


export type GetStripeProductByIdQuery = { __typename?: 'Query', getStripeProductById: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } };

export type GetStripeProductByIdsQueryVariables = Exact<{
  input: StripeProductByIdsInput;
}>;


export type GetStripeProductByIdsQuery = { __typename?: 'Query', getStripeProductByIds: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null }> };

export type GetStripeProductByUniqNamesQueryVariables = Exact<{
  input: StripeProductByUniqNamesInput;
}>;


export type GetStripeProductByUniqNamesQuery = { __typename?: 'Query', getStripeProductByUniqNames: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null }> };

export type GetStripeProductPricesByFilterQueryVariables = Exact<{
  input: StripeProductPriceFilterInput;
}>;


export type GetStripeProductPricesByFilterQuery = { __typename?: 'Query', getStripeProductPricesByFilter: Array<{ __typename?: 'StripeProductPriceModel', importPriceId?: string | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceMetadata?: any | null, priceNickname?: string | null, priceProduct?: string | null, priceRecurring?: any | null, priceTaxBehavior?: string | null, priceType?: StripePriceType | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productCountry?: string | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productImage?: any | null, productIncluded?: any | null, productLivemode?: boolean | null, productMetadata?: any | null, productName?: string | null, productPurchaseds?: any | null, productSecondIncluded?: any | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, productEvaluationId?: { __typename?: 'StripeProductEvaluationIdModel', noah?: Array<string> | null, zoey?: Array<string> | null } | null, productIsShowOnShop?: { __typename?: 'StripeProductIsShowOnShopModel', noah?: boolean | null, zoey?: boolean | null } | null }> };

export type GetStripePromotionCodeByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetStripePromotionCodeByIdQuery = { __typename?: 'Query', getStripePromotionCodeById: { __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null, promotionCodes?: Array<{ __typename?: 'StripePromotionCodeModel', active: boolean, code: string, created: number, customer?: string | null, expires_at?: number | null, id: string, livemode: boolean, max_redemptions?: number | null, metadata?: any | null, object: any, restrictions?: any | null, times_redeemed?: number | null, coupon?: { __typename?: 'StripeCouponModel', amount_off?: number | null, applies_to?: any | null, created?: number | null, currency?: StripeCurrency | null, duration?: CouponDuration | null, duration_in_months?: number | null, id: string, livemode?: boolean | null, max_redemptions?: number | null, metadata?: any | null, name: string, object: any, percent_off?: number | null, redeem_by?: number | null, times_redeemed?: number | null, valid?: boolean | null } | null } | null> | null } | null } };

export type GetSubscriptionByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSubscriptionByIdQuery = { __typename?: 'Query', getSubscriptionById: { __typename?: 'StripeSubscriptionModel', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, customer?: string | null, default_payment_method?: string | null, id: string, items?: any | null, latest_invoice?: string | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: string | null, pending_update?: any | null, plan?: any | null, status?: string | null } };

export type GetSuggestionsQueryVariables = Exact<{
  input: GetSuggestionsInput;
}>;


export type GetSuggestionsQuery = { __typename?: 'Query', getSuggestions: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null }> };

export type GetSurveyListQueryVariables = Exact<{
  input: SurveyFilterInput;
}>;


export type GetSurveyListQuery = { __typename?: 'Query', getSurveyList: Array<{ __typename?: 'SurveyModel', answers?: any | null, isSkipped?: boolean | null, questionAnswers?: any | null, skippedCarts?: Array<string | null> | null, sysId: string, type?: SurveyType | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null }> };

export type GetTeleConsultOrdersQueryVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: TeleConsultOrderFilterInput;
}>;


export type GetTeleConsultOrdersQuery = { __typename?: 'Query', getTeleConsultOrders: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null }> };

export type GetTestMagicLinkQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetTestMagicLinkQuery = { __typename?: 'Query', getTestMagicLink: string };

export type GetTextConversationFromOpsQueryVariables = Exact<{
  input: GetTextConversationFromOpsInput;
}>;


export type GetTextConversationFromOpsQuery = { __typename?: 'Query', getTextConversationFromOps: Array<{ __typename?: 'TextConsultationSessionModel', token: string, consultationSession: { __typename?: 'ConsultationSessionModel', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, friendlyName?: string | null, gmeetLink?: string | null, patientChatToken?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null }, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null }> };

export type GetThankyouDataQueryVariables = Exact<{
  input: GetThankyouDataInput;
}>;


export type GetThankyouDataQuery = { __typename?: 'Query', getThankyouData: { __typename?: 'ThankYouDataModel', consultOrderIds?: Array<string> | null, needsBookingOrderIds: Array<string>, textConsultOrderIds?: Array<string> | null, cart: { __typename?: 'CheckoutCartModel', cartItems?: any | null, paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, sysId: string, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, calculateOrderSummary?: { __typename?: 'CalculateOrderSummaryModel', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null, itemList?: Array<{ __typename?: 'PaymentItemInfoModel', consultationSessionType?: ConsultationSessionType | null, isEDBundle?: boolean | null, isPayNow?: boolean | null, isRxProduct?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, isSubscriptionUpdate?: boolean | null, itemSubTotal?: number | null, itemSubTotalAfterDiscount?: number | null, mainProductId?: string | null, mainProductName?: string | null, name?: string | null, priceId?: string | null, priceType?: StripePriceType | null, productId?: string | null, productUniqName?: ProductNameType | null, quantity?: number | null, unit_amount?: number | null } | null> | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null }, cartOrders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, newRxOrders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } };

export type GetTrtAcuityCalendarIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrtAcuityCalendarIdsQuery = { __typename?: 'Query', getTrtAcuityCalendarIds: Array<number> };

export type GetTrtDocumentUrlQueryVariables = Exact<{
  documentSysId: Scalars['String'];
}>;


export type GetTrtDocumentUrlQuery = { __typename?: 'Query', getTrtDocumentUrl: string };

export type GetTrtIdentificationUrlQueryVariables = Exact<{
  orderSysId: Scalars['String'];
}>;


export type GetTrtIdentificationUrlQuery = { __typename?: 'Query', getTrtIdentificationUrl?: string | null };

export type GetTwilioVideoConsultDataFromDoctorQueryVariables = Exact<{
  input: VideoSessionInput;
}>;


export type GetTwilioVideoConsultDataFromDoctorQuery = { __typename?: 'Query', getTwilioVideoConsultDataFromDoctor: { __typename?: 'TwilioVideoConsultModel', drFullName?: string | null, roomName?: string | null, twilioAccessToken?: string | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null } };

export type GetTwilioVideoConsultDataFromPatientQueryVariables = Exact<{
  input: GetConsultVideoInput;
}>;


export type GetTwilioVideoConsultDataFromPatientQuery = { __typename?: 'Query', getTwilioVideoConsultDataFromPatient: { __typename?: 'TwilioVideoConsultModel', drFullName?: string | null, roomName?: string | null, twilioAccessToken?: string | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorModel', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, childrenIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, childrenSecondIncludedProduct?: Array<{ __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null> | null, image?: { __typename?: 'ImageModel', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, secondIncludedProduct?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null } | null> | null } | null> | null } | null } | null } };

export type GetUsersByRoleQueryVariables = Exact<{
  input: GetUsersByRoleInput;
}>;


export type GetUsersByRoleQuery = { __typename?: 'Query', getUsersByRole: Array<{ __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null }> };

export type HosOpsAlertQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type HosOpsAlertQuery = { __typename?: 'Query', hosOpsAlert?: { __typename?: 'HosOpsAlert', id: string, kind: HosOpsAlertKind, patientLabel: string, flagId?: string | null, flagState?: HosSafetyFlagState | null, flagLive: boolean, flagOpsClearable: boolean, ruleId?: string | null, severity: HosSafetySeverity, source: HosSafetySource, status: HosOpsAlertStatus, summary?: string | null, classifierRationale?: string | null, instructionCopyKey?: string | null, playbookCopyKeys: Array<string>, slackPosted: boolean, freshchatConversationId?: string | null, patientChannels: Array<string>, opsChannels: Array<string>, patientAcknowledgedAt?: any | null, firedAt: any, lastSeenAt: any, recurrenceCount: number, ackedAt?: any | null, ackedBy?: string | null, closedAt?: any | null, playbookSteps: Array<{ __typename?: 'HosOpsAlertPlaybookStep', order?: number | null, instruction?: string | null, owner?: string | null, slaMinutes?: number | null, copyKey?: string | null }>, deliveries: Array<{ __typename?: 'HosOpsAlertDelivery', channel: HosNotificationChannel, status: HosNotificationStatus, providerId?: string | null, attemptedAt: any, reason?: string | null }>, actionEntries: Array<{ __typename?: 'HosOpsAlertActionEntry', action: HosOpsAlertAction, note?: string | null, actor: string, at: any }> } | null };

export type HosOpsAlertsQueryVariables = Exact<{
  status?: InputMaybe<Array<HosOpsAlertStatus> | HosOpsAlertStatus>;
  severity?: InputMaybe<Array<HosSafetySeverity> | HosSafetySeverity>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type HosOpsAlertsQuery = { __typename?: 'Query', hosOpsAlerts: Array<{ __typename?: 'HosOpsAlert', id: string, kind: HosOpsAlertKind, patientLabel: string, ruleId?: string | null, severity: HosSafetySeverity, source: HosSafetySource, status: HosOpsAlertStatus, summary?: string | null, firedAt: any, lastSeenAt: any, recurrenceCount: number }> };

export type LogOutQueryVariables = Exact<{ [key: string]: never; }>;


export type LogOutQuery = { __typename?: 'Query', logOut: boolean };

export type MyBloodPressureReadingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBloodPressureReadingsQuery = { __typename?: 'Query', myBloodPressureReadings: Array<{ __typename?: 'PatientVitalDto', diastolic?: number | null, recordedAt: any, source: PatientVitalSource, sysId: string, systolic?: number | null, type: PatientVitalType }> };

export type ParseAffiliateGoogleFormQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type ParseAffiliateGoogleFormQuery = { __typename?: 'Query', parseAffiliateGoogleForm: { __typename?: 'AffiliateGoogleFormParseResult', suggestedMap: any, fields: Array<{ __typename?: 'AffiliateGoogleFormField', entryId: string, label: string }> } };

export type PreblockAvailableDatesQueryVariables = Exact<{
  input: PreblockSlotsInput;
}>;


export type PreblockAvailableDatesQuery = { __typename?: 'Query', preblockAvailableDates: Array<{ __typename?: 'PreblockSlotDto', slotsAvailable: number, time: string }> };

export type PreblockAvailableTimesQueryVariables = Exact<{
  input: PreblockTimesInput;
}>;


export type PreblockAvailableTimesQuery = { __typename?: 'Query', preblockAvailableTimes: Array<{ __typename?: 'PreblockSlotDto', slotsAvailable: number, time: string }> };

export type PrescriptionsQueryVariables = Exact<{
  videoLink: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit?: InputMaybe<Scalars['Float']>;
  offset?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink1: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit1?: InputMaybe<Scalars['Int']>;
  offset1?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  orderId2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform12?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date6?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date7?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input10: V2ConsultationFilterInput;
  input11: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input12: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput6?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation7?: InputMaybe<V2ConsultationFilterInput>;
  platform13?: InputMaybe<Scalars['String']>;
  input13: OrderInput;
  pagination1: V2PaginationInput;
  date8?: InputMaybe<Scalars['String']>;
  date9?: InputMaybe<Scalars['Float']>;
  input14?: InputMaybe<GetPatientInput>;
  platform14?: InputMaybe<Scalars['String']>;
  platform15?: InputMaybe<Scalars['String']>;
  platform16?: InputMaybe<Scalars['String']>;
  platform17?: InputMaybe<Scalars['String']>;
  platform18?: InputMaybe<Scalars['String']>;
  input15?: InputMaybe<StripeProductFilterV2>;
  input16: V2ConsultationFilterInput;
  input17: ConsultationMessagesInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input18: ConsultationListInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  input19: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input20?: InputMaybe<GetPatientInput>;
  platform19?: InputMaybe<Scalars['String']>;
  input21?: InputMaybe<StripeProductFilterV2>;
  consultAuditFilterInput7?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation8?: InputMaybe<V2ConsultationFilterInput>;
  platform20?: InputMaybe<Scalars['String']>;
  input22?: InputMaybe<CrossSellRecordQueryInput>;
  acuityAppointmentId6?: InputMaybe<Scalars['String']>;
  date12?: InputMaybe<Scalars['String']>;
  forDelivery6?: InputMaybe<Scalars['Boolean']>;
  isReschedule6?: InputMaybe<Scalars['Boolean']>;
  orderId7?: InputMaybe<Scalars['String']>;
  acuityAppointmentId7?: InputMaybe<Scalars['String']>;
  consultDate3?: InputMaybe<Scalars['Float']>;
  date13?: InputMaybe<Scalars['Float']>;
  forDelivery7?: InputMaybe<Scalars['Boolean']>;
  isReschedule7?: InputMaybe<Scalars['Boolean']>;
  orderId8?: InputMaybe<Scalars['String']>;
  input23: V2ConsultationFilterInput;
  input24: ConsultationMessagesInput;
  limit10?: InputMaybe<Scalars['Int']>;
  offset10?: InputMaybe<Scalars['Int']>;
  order9?: InputMaybe<Scalars['JSON']>;
  input25: ConsultationListInput;
  limit11?: InputMaybe<Scalars['Int']>;
  offset11?: InputMaybe<Scalars['Int']>;
  order10?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput6?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput7?: InputMaybe<V2DoctorInputFilter>;
  input26: OrderInput;
  pagination3: V2PaginationInput;
  date14?: InputMaybe<Scalars['String']>;
  date15?: InputMaybe<Scalars['Float']>;
  input27?: InputMaybe<GetPatientInput>;
  platform21?: InputMaybe<Scalars['String']>;
  input28?: InputMaybe<StripeProductFilterV2>;
  platform22?: InputMaybe<Scalars['String']>;
  platform23?: InputMaybe<Scalars['String']>;
  input29: V2PrescriptionFilterInput;
}>;


export type PrescriptionsQuery = { __typename?: 'Query', prescriptions: Array<{ __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, otcOrdersCalculation?: Array<{ __typename?: 'OTCOrderCalculationDto', basePrice?: number | null, cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmount?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, stripePromotionCode?: any | null, tax?: number | null, transactionFee?: number | null }> | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, rxOrdersCalculation?: Array<{ __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null }> | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null> | null }> };

export type SendEmailForOldOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type SendEmailForOldOrdersQuery = { __typename?: 'Query', sendEmailForOldOrders: boolean };

export type SyncConversationForExistingOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type SyncConversationForExistingOrdersQuery = { __typename?: 'Query', syncConversationForExistingOrders: boolean };

export type TriggerChargeConsultFeeConsumerQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type TriggerChargeConsultFeeConsumerQuery = { __typename?: 'Query', triggerChargeConsultFeeConsumer?: boolean | null };

export type TrtOrdersQueryVariables = Exact<{
  filter?: InputMaybe<TrtOrdersFilterInput>;
}>;


export type TrtOrdersQuery = { __typename?: 'Query', trtOrders: { __typename?: 'PaginatedTrtOrders', count: number, items: Array<{ __typename?: 'TrtOrderDto', createdAt?: any | null, bloodTestCards: Array<{ __typename?: 'TrtBloodTestCardDto', drawConfirmedAt?: any | null, key: string, kind: TrtBloodTestCardKind, orderStatus: OrderStatus, phase: TrtBloodTestCardPhase, resultReceivedAt?: any | null, section: TrtBloodTestCardSection, sortAt: any, sortIndex: number, documents: Array<{ __typename?: 'TrtBloodTestCardDocumentDto', cardKind: TrtBloodTestCardKind, createdAt?: any | null, ref: string, role: TrtBloodTestDocumentRole, series: TrtBloodTestSeries, sysId: string, type: string }> }>, isFollowUp: boolean, isTestOrder: boolean, paid: boolean, shortId?: number | null, status: OrderStatus, sysId: string, documents: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }>, drawConfirmations: Array<{ __typename?: 'BloodDrawConfirmationDto', confirmedAt?: any | null, drawType: TrtDrawType, orderSysId: string, sysId: string }>, latestBloodPressure?: { __typename?: 'PatientVitalDto', diastolic?: number | null, recordedAt: any, source: PatientVitalSource, sysId: string, systolic?: number | null, type: PatientVitalType } | null, orderLineage: Array<{ __typename?: 'TrtLineageOrderDto', createdAt?: any | null, followUpForOrderShortId?: number | null, followUpForOrderSysId?: string | null, bloodTestCards: Array<{ __typename?: 'TrtBloodTestCardDto', drawConfirmedAt?: any | null, key: string, kind: TrtBloodTestCardKind, orderStatus: OrderStatus, phase: TrtBloodTestCardPhase, resultReceivedAt?: any | null, section: TrtBloodTestCardSection, sortAt: any, sortIndex: number, documents: Array<{ __typename?: 'TrtBloodTestCardDocumentDto', cardKind: TrtBloodTestCardKind, createdAt?: any | null, ref: string, role: TrtBloodTestDocumentRole, series: TrtBloodTestSeries, sysId: string, type: string }> }>, isCurrent: boolean, isFollowUp: boolean, kind: TrtOrderKind, shortId?: number | null, status: OrderStatus, sysId: string, documents: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> }>, patient?: { __typename?: 'TrtOrderPatientDto', dob?: string | null, email?: string | null, firstName?: string | null, gender?: Gender | null, hasIdentificationImage: boolean, icNumber?: string | null, idVerifiedAt?: any | null, lastName?: string | null, legalName?: string | null, sysId?: string | null } | null, skus: Array<{ __typename?: 'TrtOrderSkuDto', name?: string | null, priceId?: string | null, slot: string }> }> } };

export type UserQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  sysId?: InputMaybe<Scalars['String']>;
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } };

export type UsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null, affiliateProduct?: { __typename?: 'AffiliateProduct', affiliateSysId: string, couponLandingUrl?: string | null, createdAt: any, discountPercentage: number, displayName: string, enabled: boolean, evalFlow?: string | null, externalPortalUrl?: string | null, slug: string, stripePriceId: string, stripeProductId: string, stripePromotionCode?: string | null, stripePromotionCodeId: string, sysId: string, unitAmount?: number | null, updatedAt: any, affiliate?: { __typename?: 'PublicAffiliate', enabled: boolean, name: string, portalUrl: string, region: RegionType, slug: string, sysId: string } | null } | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null, doctor?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null, order?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointmentSnapshot?: { __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentModel', appointmentTypeID?: number | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, doctor?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, affiliateCoupon?: { __typename?: 'AffiliateCoupon', affiliateProductSysId: string, affiliateSysId: string, anonymousId: string, couponId: string, createdAt: any, opsNote?: string | null, orderSysId?: string | null, status: AffiliateCouponStatus, sysId: string, updatedAt: any, verifiedAt?: any | null, verifiedByUserSysId?: string | null } | null, auditDoctorNotes?: Array<{ __typename?: 'AuditDoctorNoteModel', createdAt?: any | null, createdBy?: string | null, deletedBy?: string | null, isDeleted?: boolean | null, note?: string | null, sysId?: string | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null } | null> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, oldOrder?: { __typename?: 'OldOrderModel', id?: string | null, isCancelled?: boolean | null, priceId?: string | null, status?: OrderStatus | null, subId?: string | null } | null, patientSnapshot?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orders?: Array<{ __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderModel', address?: any | null, approveAt?: any | null, atomePaymentAmount?: number | null, completedEvaluation?: any | null, consultationSessions?: any | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isOrderRenew?: boolean | null, isPendingFollowUpConsult?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, isTestOrder?: boolean | null, latestInvoice?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentProvider?: string | null, phoneNumber?: string | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, prescriptionOrderCalculation?: any | null, priceDisplayId?: string | null, priceInfo?: any | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionModel', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, productGroupData?: { __typename?: 'ProductModel', acuitySchedulingAppType?: string | null, amountToFreeIncludedPrice?: number | null, chargeNowProduct?: Array<string | null> | null, country?: string | null, crossEvaluation?: any | null, displayId?: string | null, emailOnCompleteName?: string | null, emailTemplate?: string | null, evaluationFormId?: string | null, id?: string | null, includedPriceIds?: Array<string | null> | null, overwriteCalendarHeaderTitleInfo?: string | null, overwriteProductSubtitleInfo?: string | null, platform?: PlatformType | null, productGroups?: any | null, requiresDelivery?: boolean | null, requiresEvaluation?: boolean | null, requiresPrescription?: boolean | null, sysId: string, title?: string | null } | null, productInfo?: { __typename?: 'StripeProductModel', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, id?: string | null, isShowOnShop?: any | null, livemode?: boolean | null, locale?: any | null, metadata?: any | null, name?: string | null, prices?: any | null, shopProductGroupIds?: Array<ShopProductGroupIds> | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null } | null, twilioMessageHistories?: Array<{ __typename?: 'TwilioMessageHistoryModel', address: string, email: string, fullName: string, message: string, phoneNumber: string } | null> | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null, patient?: { __typename?: 'PatientModel', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, locale?: string | null, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, weight?: number | null } | null } | null } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null, user?: { __typename?: 'User', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, userType?: UserRole | null, utmCampaign?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null }> };

export type ViewerQueryVariables = Exact<{
  evalInput?: InputMaybe<V2EvaluationInput>;
  input: V2PaginationInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  patientId?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input1: V2ConsultationFilterInput;
  input2: ConsultationMessagesInput;
  limit1?: InputMaybe<Scalars['Int']>;
  offset1?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input3: ConsultationListInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input4: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input5?: InputMaybe<GetPatientInput>;
  platform1?: InputMaybe<Scalars['String']>;
  input6?: InputMaybe<StripeProductFilterV2>;
  videoLink: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  platform2?: InputMaybe<Scalars['String']>;
  platform3?: InputMaybe<Scalars['String']>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  input7: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  platform10?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform12?: InputMaybe<Scalars['String']>;
  input8?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit4?: InputMaybe<Scalars['Float']>;
  offset4?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input9: GetSmartMatchMetaInput;
  input10?: InputMaybe<PatientGetSurveyInput>;
  videoLink1: Scalars['String'];
  previewVideoLink: Scalars['String'];
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform13?: InputMaybe<Scalars['String']>;
  platform14?: InputMaybe<Scalars['String']>;
  platform15?: InputMaybe<Scalars['String']>;
  platform16?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform17?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  input11: ConsultationAuditFilterInput;
  paging: V2PaginationInput;
  videoLink2: Scalars['String'];
  patientId1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform18?: InputMaybe<Scalars['String']>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId2?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input12: V2ConsultationFilterInput;
  input13: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input14: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input15: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input16?: InputMaybe<GetPatientInput>;
  platform19?: InputMaybe<Scalars['String']>;
  platform20?: InputMaybe<Scalars['String']>;
  input17?: InputMaybe<StripeProductFilterV2>;
  consultAuditFilterInput6?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation7?: InputMaybe<V2ConsultationFilterInput>;
  platform21?: InputMaybe<Scalars['String']>;
  input18?: InputMaybe<CrossSellRecordQueryInput>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input19: V2ConsultationFilterInput;
  input20: ConsultationMessagesInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input21: ConsultationListInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  input22: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input23?: InputMaybe<GetPatientInput>;
  platform22?: InputMaybe<Scalars['String']>;
  input24?: InputMaybe<StripeProductFilterV2>;
  input25: V2PickupLocationInput;
  limit10?: InputMaybe<Scalars['Int']>;
  offset10?: InputMaybe<Scalars['Int']>;
  order9?: InputMaybe<Scalars['JSON']>;
  orderId7: Scalars['String'];
  platform23?: InputMaybe<Scalars['String']>;
  platform24?: InputMaybe<Scalars['String']>;
  platform25?: InputMaybe<Scalars['String']>;
  acuityAppointmentId6?: InputMaybe<Scalars['String']>;
  date12?: InputMaybe<Scalars['String']>;
  forDelivery6?: InputMaybe<Scalars['Boolean']>;
  isReschedule6?: InputMaybe<Scalars['Boolean']>;
  orderId8?: InputMaybe<Scalars['String']>;
  acuityAppointmentId7?: InputMaybe<Scalars['String']>;
  consultDate3?: InputMaybe<Scalars['Float']>;
  date13?: InputMaybe<Scalars['Float']>;
  forDelivery7?: InputMaybe<Scalars['Boolean']>;
  isReschedule7?: InputMaybe<Scalars['Boolean']>;
  orderId9?: InputMaybe<Scalars['String']>;
  input26: V2ConsultationFilterInput;
  input27: ConsultationMessagesInput;
  limit11?: InputMaybe<Scalars['Int']>;
  offset11?: InputMaybe<Scalars['Int']>;
  order10?: InputMaybe<Scalars['JSON']>;
  input28: ConsultationListInput;
  limit12?: InputMaybe<Scalars['Int']>;
  offset12?: InputMaybe<Scalars['Int']>;
  order11?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput6?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput7?: InputMaybe<V2DoctorInputFilter>;
  input29: OrderInput;
  pagination3: V2PaginationInput;
  date14?: InputMaybe<Scalars['String']>;
  date15?: InputMaybe<Scalars['Float']>;
  input30?: InputMaybe<GetPatientInput>;
  platform26?: InputMaybe<Scalars['String']>;
  input31?: InputMaybe<StripeProductFilterV2>;
  input32: OrderShipmentInput;
  acuityAppointmentId8?: InputMaybe<Scalars['String']>;
  date16?: InputMaybe<Scalars['String']>;
  forDelivery8?: InputMaybe<Scalars['Boolean']>;
  isReschedule8?: InputMaybe<Scalars['Boolean']>;
  orderId10?: InputMaybe<Scalars['String']>;
  acuityAppointmentId9?: InputMaybe<Scalars['String']>;
  consultDate4?: InputMaybe<Scalars['Float']>;
  date17?: InputMaybe<Scalars['Float']>;
  forDelivery9?: InputMaybe<Scalars['Boolean']>;
  isReschedule9?: InputMaybe<Scalars['Boolean']>;
  orderId11?: InputMaybe<Scalars['String']>;
  input33: V2ConsultationFilterInput;
  input34: ConsultationMessagesInput;
  limit13?: InputMaybe<Scalars['Int']>;
  offset13?: InputMaybe<Scalars['Int']>;
  order12?: InputMaybe<Scalars['JSON']>;
  input35: ConsultationListInput;
  limit14?: InputMaybe<Scalars['Int']>;
  offset14?: InputMaybe<Scalars['Int']>;
  order13?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput8?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput9?: InputMaybe<V2DoctorInputFilter>;
  input36: OrderInput;
  pagination4: V2PaginationInput;
  date18?: InputMaybe<Scalars['String']>;
  date19?: InputMaybe<Scalars['Float']>;
  input37?: InputMaybe<GetPatientInput>;
  platform27?: InputMaybe<Scalars['String']>;
  input38?: InputMaybe<StripeProductFilterV2>;
  input39: GetPartnerInput;
  input40?: InputMaybe<PrescriptionCalculationInput>;
  platform28?: InputMaybe<Scalars['String']>;
  platform29?: InputMaybe<Scalars['String']>;
  platform30?: InputMaybe<Scalars['String']>;
  platform31?: InputMaybe<Scalars['String']>;
  input41: GetSmartMatchResultsInput;
  input42: GetSmartMatchAiResponseInput;
  platform32?: InputMaybe<Scalars['String']>;
  evalResultInput?: InputMaybe<EvaluationResultsInput>;
  input43?: InputMaybe<StripeProductFilterV2Input>;
  platform33?: InputMaybe<Scalars['String']>;
  platform34?: InputMaybe<Scalars['String']>;
  acuityAppointmentId10?: InputMaybe<Scalars['String']>;
  date20?: InputMaybe<Scalars['String']>;
  forDelivery10?: InputMaybe<Scalars['Boolean']>;
  isReschedule10?: InputMaybe<Scalars['Boolean']>;
  orderId12?: InputMaybe<Scalars['String']>;
  acuityAppointmentId11?: InputMaybe<Scalars['String']>;
  consultDate5?: InputMaybe<Scalars['Float']>;
  date21?: InputMaybe<Scalars['Float']>;
  forDelivery11?: InputMaybe<Scalars['Boolean']>;
  isReschedule11?: InputMaybe<Scalars['Boolean']>;
  orderId13?: InputMaybe<Scalars['String']>;
  input44: V2ConsultationFilterInput;
  input45: ConsultationMessagesInput;
  limit15?: InputMaybe<Scalars['Int']>;
  offset15?: InputMaybe<Scalars['Int']>;
  order14?: InputMaybe<Scalars['JSON']>;
  input46: ConsultationListInput;
  limit16?: InputMaybe<Scalars['Int']>;
  offset16?: InputMaybe<Scalars['Int']>;
  order15?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput10?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput11?: InputMaybe<V2DoctorInputFilter>;
  input47: OrderInput;
  pagination5: V2PaginationInput;
  date22?: InputMaybe<Scalars['String']>;
  date23?: InputMaybe<Scalars['Float']>;
  input48?: InputMaybe<GetPatientInput>;
  platform35?: InputMaybe<Scalars['String']>;
  input49?: InputMaybe<StripeProductFilterV2>;
  input50: GetUsersInput;
  input51: V2GuestVideoConsultationInput;
}>;


export type ViewerQuery = { __typename?: 'Query', viewer: { __typename?: 'ViewerDto', appSettings?: { __typename?: 'AppSettingsDto', stripeCurrencyRatio?: number | null, systemPromotion?: { __typename?: 'SystemPromotionDto', oneTimePercent?: number | null, oneTimeValue?: number | null } | null } | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null> | null } | null, question?: { __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null }> | null, content?: { __typename?: 'ContentQuestionDto', body?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null, blockAnswer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, content?: { __typename?: 'EvaluationBlockContentDto', description?: string | null, descriptionTextKey?: string | null, sysId?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null }> | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null> | null, master?: { __typename?: 'MasterDto', auditHistories?: { __typename?: 'AuditHistoryPagingDto', count?: number | null, items?: Array<{ __typename?: 'AuditHistoryDto', action?: AuditingAction | null, createdAt?: any | null, schemaType?: AuditingSchema | null, sysId?: string | null, targetId?: string | null, userId?: string | null, changeLog?: Array<{ __typename?: 'AuditInfoDto', columnName?: string | null, newValue?: any | null, oldValue?: any | null } | null> | null } | null> | null } | null, consultationAudits?: { __typename?: 'PaginatedConsultationAuditDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null }> | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null, card?: { __typename?: 'StripeCardDto', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null> | null } | null }> | null } | null }> | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, otcOrdersCalculation?: Array<{ __typename?: 'OTCOrderCalculationDto', basePrice?: number | null, cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmount?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, stripePromotionCode?: any | null, tax?: number | null, transactionFee?: number | null }> | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null, rxOrdersCalculation?: Array<{ __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null }> | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null> | null, pickupLocations?: { __typename?: 'PaginatedPickupLocationDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null } | null } | null> | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null }> | null } | null, regionAreas?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null> | null } | null, orderAtomePaymentLink?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, orderShipments?: Array<{ __typename?: 'OrderShipmentDto', address: any, cost: number, courierName?: CourierName | null, createdAt?: any | null, deliveryMethod?: DeliveryMethod | null, deliveryTimestamp?: any | null, estimatedShipDate?: any | null, note?: string | null, parcelId: string, paused: boolean, shipDate?: any | null, status: string, sysId: string, trackingNo?: string | null, updatedAt?: any | null, group?: { __typename?: 'OrderShipmentGroupDto', bookingNo?: string | null, createdAt?: any | null, name: string, sysId: string, updatedAt?: any | null } | null, items?: Array<{ __typename?: 'OrderShipmentItemDto', createdAt?: any | null, dosage?: any | null, isFirstPurchase: boolean, orderNo: number, orderSysId: string, paymentAmount?: number | null, paymentDate?: any | null, paymentIntentId?: string | null, paymentProvider: PaymentProvider, priceId: string, promotionCode?: string | null, qty: number, sysId: string, updatedAt?: any | null, price?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null } | null, product?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null }> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, shipper?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null }> | null, partner?: { __typename?: 'PartnerDto', address?: string | null, email?: string | null, name: string, phoneNumber?: string | null, sysId: string, type?: string | null, consultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, consultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, partner?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, users?: { __typename?: 'PartnerUserDto', sysId: string, partner?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null } | null, prescriptionCalculation: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null }, smartMatch: { __typename?: 'SmartMatchDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType, smartMatchResults: { __typename?: 'SmartMatchResult', analysis: Array<string>, nextSteps: Array<{ __typename?: 'NextSteps', evidence: string, text: string }>, primaryProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, secondaryProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null } }, smartMatchResponse: { __typename?: 'SmartMatchResponse', response?: any | null }, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null, stripeProducts2?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null> | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, users: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }>, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null } };

export type SubscribeOrderSubscriptionVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  videoLink: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  platform1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  platform2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform3?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  platform10?: InputMaybe<Scalars['String']>;
  input10?: InputMaybe<CrossSellRecordQueryInput>;
  orderId2?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input11: V2ConsultationFilterInput;
  input12: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input13: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink1: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform11?: InputMaybe<Scalars['String']>;
  input14: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input15?: InputMaybe<GetPatientInput>;
  platform12?: InputMaybe<Scalars['String']>;
  platform13?: InputMaybe<Scalars['String']>;
  input16?: InputMaybe<StripeProductFilterV2>;
  videoLink2: Scalars['String'];
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform14?: InputMaybe<Scalars['String']>;
  input17: V2OrderFilterInput;
}>;


export type SubscribeOrderSubscription = { __typename?: 'Subscription', subscribeOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null } | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null };

export type SubscribeUserSubscriptionVariables = Exact<{
  consultAuditFilterInput?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation?: InputMaybe<V2ConsultationFilterInput>;
  platform?: InputMaybe<Scalars['String']>;
  videoLink: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  checkoutSessionFilterOptions?: InputMaybe<CheckoutSessionFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['JSON']>;
  inputConsultation1?: InputMaybe<V2ConsultationFilterInput>;
  input: GetPatientDocumentInput;
  evalFilter?: InputMaybe<V2PatientEvaluationFilterInput>;
  id1?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput1?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation2?: InputMaybe<V2ConsultationFilterInput>;
  platform1?: InputMaybe<Scalars['String']>;
  inputOrder?: InputMaybe<V2OrderFilterInput>;
  orderPagination?: InputMaybe<V2PaginationInput>;
  input1?: InputMaybe<PrescriptionCalculationInput>;
  platform2?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ShopProductFilterInputV2>;
  limit1?: InputMaybe<Scalars['Float']>;
  offset1?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<ShopProductSortInputV2>;
  input2: GetSmartMatchMetaInput;
  input3?: InputMaybe<PatientGetSurveyInput>;
  acuityAppointmentId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  forDelivery?: InputMaybe<Scalars['Boolean']>;
  isReschedule?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['String']>;
  acuityAppointmentId1?: InputMaybe<Scalars['String']>;
  consultDate?: InputMaybe<Scalars['Float']>;
  date1?: InputMaybe<Scalars['Float']>;
  forDelivery1?: InputMaybe<Scalars['Boolean']>;
  isReschedule1?: InputMaybe<Scalars['Boolean']>;
  orderId1?: InputMaybe<Scalars['String']>;
  input4: V2ConsultationFilterInput;
  input5: ConsultationMessagesInput;
  limit2?: InputMaybe<Scalars['Int']>;
  offset2?: InputMaybe<Scalars['Int']>;
  order1?: InputMaybe<Scalars['JSON']>;
  input6: ConsultationListInput;
  limit3?: InputMaybe<Scalars['Int']>;
  offset3?: InputMaybe<Scalars['Int']>;
  order2?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput1?: InputMaybe<V2DoctorInputFilter>;
  input7: OrderInput;
  pagination: V2PaginationInput;
  date2?: InputMaybe<Scalars['String']>;
  date3?: InputMaybe<Scalars['Float']>;
  input8?: InputMaybe<GetPatientInput>;
  platform3?: InputMaybe<Scalars['String']>;
  input9?: InputMaybe<StripeProductFilterV2>;
  videoLink1: Scalars['String'];
  previewVideoLink: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  limit4?: InputMaybe<Scalars['Int']>;
  offset4?: InputMaybe<Scalars['Int']>;
  order3?: InputMaybe<Scalars['JSON']>;
  orderId2?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput2?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation3?: InputMaybe<V2ConsultationFilterInput>;
  platform4?: InputMaybe<Scalars['String']>;
  inputOrder1?: InputMaybe<V2OrderFilterInput>;
  orderPagination1?: InputMaybe<V2PaginationInput>;
  patientId1?: InputMaybe<Scalars['String']>;
  acuityAppointmentId2?: InputMaybe<Scalars['String']>;
  date4?: InputMaybe<Scalars['String']>;
  forDelivery2?: InputMaybe<Scalars['Boolean']>;
  isReschedule2?: InputMaybe<Scalars['Boolean']>;
  orderId3?: InputMaybe<Scalars['String']>;
  acuityAppointmentId3?: InputMaybe<Scalars['String']>;
  consultDate1?: InputMaybe<Scalars['Float']>;
  date5?: InputMaybe<Scalars['Float']>;
  forDelivery3?: InputMaybe<Scalars['Boolean']>;
  isReschedule3?: InputMaybe<Scalars['Boolean']>;
  orderId4?: InputMaybe<Scalars['String']>;
  limit5?: InputMaybe<Scalars['Int']>;
  offset5?: InputMaybe<Scalars['Int']>;
  order4?: InputMaybe<Scalars['JSON']>;
  input10: ConsultationMessagesInput;
  limit6?: InputMaybe<Scalars['Int']>;
  offset6?: InputMaybe<Scalars['Int']>;
  order5?: InputMaybe<Scalars['JSON']>;
  input11: ConsultationListInput;
  limit7?: InputMaybe<Scalars['Int']>;
  offset7?: InputMaybe<Scalars['Int']>;
  order6?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput2?: InputMaybe<V2DoctorInputFilter>;
  videoLink2: Scalars['String'];
  patientId2?: InputMaybe<Scalars['String']>;
  doctorFilterInput3?: InputMaybe<V2DoctorInputFilter>;
  input12: OrderInput;
  pagination1: V2PaginationInput;
  date6?: InputMaybe<Scalars['String']>;
  date7?: InputMaybe<Scalars['Float']>;
  input13?: InputMaybe<GetPatientInput>;
  platform5?: InputMaybe<Scalars['String']>;
  platform6?: InputMaybe<Scalars['String']>;
  input14?: InputMaybe<StripeProductFilterV2>;
  input15: V2ConsultationFilterInput;
  platform7?: InputMaybe<Scalars['String']>;
  platform8?: InputMaybe<Scalars['String']>;
  platform9?: InputMaybe<Scalars['String']>;
  platform10?: InputMaybe<Scalars['String']>;
  platform11?: InputMaybe<Scalars['String']>;
  platform12?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput3?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation4?: InputMaybe<V2ConsultationFilterInput>;
  acuityAppointmentId4?: InputMaybe<Scalars['String']>;
  date8?: InputMaybe<Scalars['String']>;
  forDelivery4?: InputMaybe<Scalars['Boolean']>;
  isReschedule4?: InputMaybe<Scalars['Boolean']>;
  orderId5?: InputMaybe<Scalars['String']>;
  acuityAppointmentId5?: InputMaybe<Scalars['String']>;
  consultDate2?: InputMaybe<Scalars['Float']>;
  date9?: InputMaybe<Scalars['Float']>;
  forDelivery5?: InputMaybe<Scalars['Boolean']>;
  isReschedule5?: InputMaybe<Scalars['Boolean']>;
  orderId6?: InputMaybe<Scalars['String']>;
  input16: V2ConsultationFilterInput;
  input17: ConsultationMessagesInput;
  limit8?: InputMaybe<Scalars['Int']>;
  offset8?: InputMaybe<Scalars['Int']>;
  order7?: InputMaybe<Scalars['JSON']>;
  input18: ConsultationListInput;
  limit9?: InputMaybe<Scalars['Int']>;
  offset9?: InputMaybe<Scalars['Int']>;
  order8?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput4?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput5?: InputMaybe<V2DoctorInputFilter>;
  input19: OrderInput;
  pagination2: V2PaginationInput;
  date10?: InputMaybe<Scalars['String']>;
  date11?: InputMaybe<Scalars['Float']>;
  input20?: InputMaybe<GetPatientInput>;
  platform13?: InputMaybe<Scalars['String']>;
  input21?: InputMaybe<StripeProductFilterV2>;
  platform14?: InputMaybe<Scalars['String']>;
  platform15?: InputMaybe<Scalars['String']>;
  platform16?: InputMaybe<Scalars['String']>;
  platform17?: InputMaybe<Scalars['String']>;
  platform18?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput4?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation5?: InputMaybe<V2ConsultationFilterInput>;
  platform19?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput5?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation6?: InputMaybe<V2ConsultationFilterInput>;
  platform20?: InputMaybe<Scalars['String']>;
  consultAuditFilterInput6?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation7?: InputMaybe<V2ConsultationFilterInput>;
  platform21?: InputMaybe<Scalars['String']>;
  acuityAppointmentId6?: InputMaybe<Scalars['String']>;
  date12?: InputMaybe<Scalars['String']>;
  forDelivery6?: InputMaybe<Scalars['Boolean']>;
  isReschedule6?: InputMaybe<Scalars['Boolean']>;
  orderId7?: InputMaybe<Scalars['String']>;
  acuityAppointmentId7?: InputMaybe<Scalars['String']>;
  consultDate3?: InputMaybe<Scalars['Float']>;
  date13?: InputMaybe<Scalars['Float']>;
  forDelivery7?: InputMaybe<Scalars['Boolean']>;
  isReschedule7?: InputMaybe<Scalars['Boolean']>;
  orderId8?: InputMaybe<Scalars['String']>;
  input22: V2ConsultationFilterInput;
  input23: ConsultationMessagesInput;
  limit10?: InputMaybe<Scalars['Int']>;
  offset10?: InputMaybe<Scalars['Int']>;
  order9?: InputMaybe<Scalars['JSON']>;
  input24: ConsultationListInput;
  limit11?: InputMaybe<Scalars['Int']>;
  offset11?: InputMaybe<Scalars['Int']>;
  order10?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput6?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput7?: InputMaybe<V2DoctorInputFilter>;
  input25: OrderInput;
  pagination3: V2PaginationInput;
  date14?: InputMaybe<Scalars['String']>;
  date15?: InputMaybe<Scalars['Float']>;
  input26?: InputMaybe<GetPatientInput>;
  platform22?: InputMaybe<Scalars['String']>;
  input27?: InputMaybe<StripeProductFilterV2>;
  consultAuditFilterInput7?: InputMaybe<ConsultationAuditFilterInput>;
  inputConsultation8?: InputMaybe<V2ConsultationFilterInput>;
  platform23?: InputMaybe<Scalars['String']>;
  input28?: InputMaybe<CrossSellRecordQueryInput>;
  acuityAppointmentId8?: InputMaybe<Scalars['String']>;
  date16?: InputMaybe<Scalars['String']>;
  forDelivery8?: InputMaybe<Scalars['Boolean']>;
  isReschedule8?: InputMaybe<Scalars['Boolean']>;
  orderId9?: InputMaybe<Scalars['String']>;
  acuityAppointmentId9?: InputMaybe<Scalars['String']>;
  consultDate4?: InputMaybe<Scalars['Float']>;
  date17?: InputMaybe<Scalars['Float']>;
  forDelivery9?: InputMaybe<Scalars['Boolean']>;
  isReschedule9?: InputMaybe<Scalars['Boolean']>;
  orderId10?: InputMaybe<Scalars['String']>;
  input29: V2ConsultationFilterInput;
  input30: ConsultationMessagesInput;
  limit12?: InputMaybe<Scalars['Int']>;
  offset12?: InputMaybe<Scalars['Int']>;
  order11?: InputMaybe<Scalars['JSON']>;
  input31: ConsultationListInput;
  limit13?: InputMaybe<Scalars['Int']>;
  offset13?: InputMaybe<Scalars['Int']>;
  order12?: InputMaybe<Scalars['JSON']>;
  doctorFilterInput8?: InputMaybe<V2DoctorInputFilter>;
  doctorFilterInput9?: InputMaybe<V2DoctorInputFilter>;
  input32: OrderInput;
  pagination4: V2PaginationInput;
  date18?: InputMaybe<Scalars['String']>;
  date19?: InputMaybe<Scalars['Float']>;
  input33?: InputMaybe<GetPatientInput>;
  platform24?: InputMaybe<Scalars['String']>;
  input34?: InputMaybe<StripeProductFilterV2>;
  input35: V2UserFilterInput;
}>;


export type SubscribeUserSubscription = { __typename?: 'Subscription', subscribeUser?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', crossSellRecords?: Array<{ __typename?: 'CrossSellOrderLinkDto', childOrderId: string, createdAt: any, createdBy: string, parentOrderId: string, priceId?: string | null, selectedBy?: string | null, sysId: string, childOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null, atomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null> | null, billingAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, bypassLoginTokens?: Array<{ __typename?: 'PatientBypassLoginTokenDto', expiresAt: any, pageName: string, token: string, type: string }> | null, cart?: { __typename?: 'CartDto', paidCompletedEvaluationIds?: Array<string | null> | null, platform?: PlatformType | null, promotionCode?: string | null, status?: string | null, sysId?: string | null, billingAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, cartItems?: Array<{ __typename?: 'CartItemDto', completedEval?: any | null, consultationSessionType?: ConsultationSessionType | null, isAutoRenewal?: boolean | null, isSkipMedSelecting?: boolean | null, isSubscriptionPrice?: boolean | null, orderId?: string | null, patientNote?: string | null, quantity?: number | null, teleConsultForSkipEval?: EvalIds | null, type?: CartItemType | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, orderSummary?: { __typename?: 'OrderSummaryDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, discountAmountLater?: number | null, discountAmountNow?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountBeforeTax?: number | null, paymentIntentSummary?: any | null, promotionCode?: string | null, shippingFee?: number | null, subTotal?: number | null, subTotalLater?: number | null, subTotalNow?: number | null, taxes?: number | null, taxesLater?: number | null, taxesNow?: number | null, teleConsultFee?: number | null, total?: number | null, totalLater?: number | null, totalNow?: number | null, totalNowAfterCashback?: number | null, totalTaxes?: number | null } | null } | null, cashback?: { __typename?: 'CashbackDto', availableBalance?: number | null, recentTransactions?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null, savingsToDateThisYear?: Array<{ __typename?: 'BalanceTransactionDto', amount?: number | null, cashbackType?: CashbackType | null, created?: number | null, credit_note?: any | null, currency?: string | null, customer?: any | null, description?: string | null, ending_balance?: number | null, id?: string | null, invoice?: any | null, livemode?: boolean | null, metadata?: any | null, object?: string | null, savingsToDate?: number | null, type?: CustomerBalanceTransactionType | null } | null> | null } | null, checkoutSessions?: Array<{ __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null }> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'AddressModel', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, document?: { __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null }> | null, evaluations?: Array<{ __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null> | null, latestPaymentMethod?: { __typename?: 'StripePaymentMethodDto', id?: string | null, card?: { __typename?: 'StripeCardDto', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null, affiliateCouponNotApplied?: { __typename?: 'AffiliateCouponNotAppliedDto', affiliateProductDisplayName: string, reason: string } | null, otcCalculationSummary?: { __typename?: 'OTCCalculationSummaryDTO', totalBasePrice?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalPaymentIntentAmount?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null, rxCalculationSummary?: { __typename?: 'RXCalculationSummaryDTO', total?: number | null, totalCashbackEarned?: number | null, totalCashbackRedeemed?: number | null, totalDiscountAmount?: number | null, totalMainBasePrice?: number | null, totalPaymentIntentAmount?: number | null, totalPaymentIntentAmountAfterCashback?: number | null, totalTax?: number | null, totalTransactionFee?: number | null } | null } | null, referrals?: Array<{ __typename?: 'ReferralDto', doctorId?: string | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, documents?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, items?: Array<{ __typename?: 'ReferralItemDto', orderId?: string | null, priceId?: string | null, referralSysId?: string | null, sysId?: string | null } | null> | null }> | null, shopProducts?: { __typename?: 'ShopProducts', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, smartMatchMeta?: { __typename?: 'SmartMatchMetaDto', evalId: EvalIds, status: SmartMatchStatus, sysId: string, userId: string, userType: UserType } | null, survey?: { __typename?: 'SurveyDto', answers?: any | null, isSkipped?: boolean | null, patientSysId?: string | null, sysId?: string | null, type?: SurveyType | null } | null, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null, videoConsultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null, videoConsultationPreview?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null } | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any, automatedMessage?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, user: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } }> | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, admin?: { __typename?: 'AdminDto', order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, orders?: { __typename?: 'PaginatedOrders', count: number, limit?: number | null, offset?: number | null, items?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null, consultationAudit?: { __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultationTitle?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, messages?: Array<{ __typename?: 'UserMessageDto', consultationSysId: string, content: string, createdAt: any, readAt?: any | null, sysId: string, updatedAt: any }> | null, participants?: Array<{ __typename?: 'ParticipantModel', avatar?: string | null, fullName?: string | null, identity?: string | null, locale?: string | null, role?: UserRole | null, token?: string | null, userSysId?: string | null }> | null, participantsV2?: Array<{ __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null, bio?: { __typename?: 'TranslationDto', createdAt: any, createdBy: string, remark: string, sysId: string, translationKey: string, updatedAt: any, updatedBy: string, valueEn: string, valueJa: string, valueZh: string } | null, consultation?: { __typename?: 'VideoConsultationDto', gmeetLink?: string | null, previewToken?: string | null, previewVideoLink?: string | null, status?: ConsultationSessionStatus | null, sysId?: string | null, token?: string | null, videoChannelId?: string | null, videoLink?: string | null, zoomJoinUrl?: string | null } | null, patient: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null }, user?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null }> | null }> | null } | null }> | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null, drDosageFrequency?: { __typename?: 'DrDosageFrequencyDto', alternativeDosage?: Array<string> | null, alternativeDosageUnit?: DosageUnit | null, asNeeded?: boolean | null, dosage?: Array<string> | null, dosageUnit?: DosageUnit | null, duration?: Array<string> | null, durationUnit?: DosageDurationUnit | null, frequency?: Array<string> | null, productId?: string | null, quantity?: string | null, quantityUnit?: DosageQuantityUnit | null } | null, image?: { __typename?: 'ImageDto', noahVertical?: string | null, noahWide?: string | null, sysId?: string | null, zoeyVertical?: string | null, zoeyWide?: string | null } | null, includedProduct?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, ingredientDetails?: Array<{ __typename?: 'ProductIngredientDto', description?: string | null, imageLink?: string | null, locale?: string | null, name?: string | null, strength?: string | null, uniqueName?: string | null }> | null, prices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, productInstructions?: Array<{ __typename?: 'ProductInstructionLocalizationDto', language?: Language | null, localeKey?: ProductInstructionLocaleKeys | null, productId?: string | null, sysId?: string | null, translatedText?: string | null } | null> | null, tempPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null }> | null, texts?: { __typename?: 'ProductTextDto', benefits?: string | null, category?: string | null, display_price?: string | null, display_price_patient?: string | null, dosage_variant_body?: string | null, dosage_variant_title?: string | null, effective_in?: string | null, for?: string | null, frequency_variant_title?: string | null, good_to_know?: string | null, how_to_take?: string | null, how_to_use?: string | null, is_popular?: string | null, lasts_for?: string | null, platform?: string | null, product_description?: string | null, product_name?: string | null, product_short_description?: string | null, quantity_per_unit?: string | null, quantity_variant_title?: string | null, requires_prescription?: string | null, safety_information?: string | null, side_effects?: string | null, strength?: string | null, taken?: string | null, unit?: string | null, unit_patient?: string | null } | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, order?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null, patientAnswers?: Array<{ __typename?: 'PatientEvaluationAnswersDto', type?: PatientQuestionAnswerType | null, value?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null } | null, question?: { __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null }> | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null } | null> | null, questions?: Array<{ __typename?: 'QuestionDto', displayPage?: number | null, guestOnly?: boolean | null, name?: string | null, order?: number | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, answers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null, childrenAnswers?: Array<{ __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null> | null }> | null, content?: { __typename?: 'ContentQuestionDto', body?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, footer?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null, header?: { __typename?: 'ContentBaseDto', description?: string | null, descriptionTextKey?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null, dependentEvaluationQuestions?: Array<{ __typename?: 'DependentQuestionDto', skipPage?: boolean | null, skipQuestionCount?: number | null, sysId?: string | null, answer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null } | null> | null, evaluationBlocks?: Array<{ __typename?: 'EvaluationBlockDto', sysId?: string | null, blockAnswer?: { __typename?: 'AnswerDto', deselectAll?: boolean | null, mandatory?: boolean | null, name?: string | null, order?: number | null, placeholder?: string | null, productUrl?: string | null, sysId?: string | null, textKey?: string | null, type?: QuestionType | null } | null, content?: { __typename?: 'EvaluationBlockContentDto', description?: string | null, descriptionTextKey?: string | null, sysId?: string | null, title?: string | null, titleTextKey?: string | null } | null } | null> | null, validation?: { __typename?: 'ValidationQuestionDto', bmi?: any | null, extra?: any | null, max?: number | null, min?: number | null, preselect?: EvaluationValidationPreselect | null, type?: EvaluationValidation | null } | null } | null> | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null, summary?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, lines?: { __typename?: 'StripeInvoiceLineDto', data?: Array<{ __typename?: 'StripeInvoiceLineItemDto', amount?: number | null, discount?: string | null, plan?: { __typename?: 'StripePlanDto', active?: boolean | null, id?: string | null, metadata?: any | null } | null } | null> | null } | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null, author?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null, areaChildren?: Array<{ __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null> | null, areaParent?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null> | null } | null, pickupLocations?: Array<{ __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null, area?: { __typename?: 'RegionAreaDto', areaName?: string | null, areaType?: RegionAreaType | null, sysId?: string | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null> | null } | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null, approver?: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null } | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, products?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null> | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null, alternativePrice?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, metadata?: { __typename?: 'StripePriceMetadataDto', actual_price_display?: string | null, boxes?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, isArchived?: string | null, isOneTimePrice?: string | null, price_frequency?: string | null, price_quantity?: string | null, price_show?: string | null, quantity?: string | null, quantity_display?: string | null, strength?: string | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, texts?: { __typename?: 'PriceTextDto', actual_price_display?: string | null, dosage?: string | null, dosage_display?: string | null, dosage_popular?: string | null, frequency?: string | null, frequency_actual_price_display?: string | null, frequency_display?: string | null, frequency_popular?: string | null, frequency_price_display?: string | null, frequency_quantity_display?: string | null, frequency_quantity_display_patient?: string | null, frequency_savings_display?: string | null, frequency_strikeout_price_display?: string | null, price_frequency?: string | null, price_quantity?: string | null, quantity?: string | null, quantity_display?: string | null } | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null, total_discount_amounts?: Array<{ __typename?: 'StripeDiscountItem', amount?: number | null }> | null } | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null } | null } | null }> | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, creator: { __typename?: 'UserDto', avatar?: string | null, email?: string | null, firstName?: string | null, fullName?: string | null, id?: string | null, isPharmacist?: boolean | null, lastName?: string | null, locale?: string | null, ninjaVanToken?: string | null, phoneNumber?: string | null, requireConfirmPolicy?: boolean | null, socialProviderType?: SocialProviderTypes | null, sysId?: string | null, tempToken?: string | null, tempTokenExpired?: boolean | null, userType?: UserRole | null, utmCampaign?: string | null, utmId?: string | null, utmMedium?: string | null, utmSource?: string | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null }, parentOrder: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null, activeConsultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, acuityAppointment?: { __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null, acuityAppointments?: Array<{ __typename?: 'AcuityAppointmentDto', appointmentTypeID?: number | null, bookedAt?: any | null, calendar?: string | null, calendarID?: number | null, calendarJP?: string | null, canceled?: boolean | null, confirmationPage?: string | null, date?: any | null, dateCreated?: any | null, datetime?: any | null, duration?: string | null, email?: string | null, endTime?: string | null, firstName?: string | null, id?: number | null, isFollowUpConsult?: boolean | null, lastName?: string | null, noShow?: boolean | null, phone?: string | null, sysId?: string | null, time?: string | null, timezone?: string | null, type?: string | null } | null> | null, additionalPrices?: Array<{ __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null> | null, afterVideoConsultRedirecting?: { __typename?: 'AfterVideoConsultRedirectingDto', baseUrl?: string | null, path?: string | null } | null, atomePayments?: Array<{ __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null> | null, checkoutSession?: { __typename?: 'CheckoutSessionDto', checkoutData?: any | null, evaluationId?: string | null, status?: CheckoutSessionStatus | null, sysId?: string | null } | null, childrenOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, consultationAudits?: Array<{ __typename?: 'ConsultationAuditDto', consultTime?: any | null, consultType?: ConsultationType | null, createdBy?: string | null, evaluationId?: EvalIds | null, sessionType?: ConsultationSessionType | null, status?: PrescriptionStatus | null, sysId?: string | null } | null> | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null }> | null, deliveryAddress?: { __typename?: 'AddressDto', address?: string | null, city?: string | null, country?: RegionType | null, firstName?: string | null, lastName?: string | null, name?: string | null, note?: string | null, phoneNumber?: string | null, postal?: string | null, region?: LocalRegionType | null, sameAsBilling?: boolean | null, state?: string | null, sysId?: string | null, type?: AddressType | null, unit?: string | null } | null, evaluation?: { __typename?: 'EvaluationDto', isCompleted?: boolean | null, isSkipped?: boolean | null, name?: string | null, patientNote?: string | null, platform?: PlatformType | null, status?: EvaluationStatus | null, sysId?: string | null, type?: EvalIds | null } | null, latestAtomePayment?: { __typename?: 'AtomePaymentDto', amount?: number | null, paymentUrl?: string | null, priceId?: string | null, referenceId?: string | null, status?: AtomePaymentStatus | null, sysId?: string | null } | null, latestInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null, latestNote?: { __typename?: 'OrderNoteDto', content?: string | null, createdAt?: any | null, createdBy?: string | null, sysId: string, updatedAt?: any | null } | null, oldPriceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, pickupLocation?: { __typename?: 'PickupLocationDto', address?: string | null, city?: string | null, isDisabled?: boolean | null, officeName?: string | null, officeNumber?: string | null, openingHours?: string | null, paymentProviders?: Array<PaymentProvider> | null, phone?: string | null, postalCode?: string | null, region?: string | null, state?: string | null, subRegion?: string | null, sysId?: string | null, type?: PickupLocationType | null, unit?: string | null } | null, prescribedAfterTrialOrder?: { __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null, prescription?: { __typename?: 'PrescriptionDto', cancelled?: boolean | null, createdAt?: any | null, days?: number | null, doctorNotes?: string | null, endDate?: any | null, expiresAt?: any | null, isFollowUp?: boolean | null, notedDate?: any | null, priceIds?: Array<string | null> | null, startDate?: any | null, status?: string | null, sysId?: string | null, treatmentCode?: string | null, updatedAt?: any | null } | null, prescriptionOrderCalculation?: { __typename?: 'PrescriptionOrderCalculationDto', cashbackEarnRate?: number | null, cashbackEarned?: number | null, cashbackRedeemed?: number | null, consultBasePrice?: number | null, consultFee?: number | null, consultFeeAfterDiscount?: number | null, consultTax?: number | null, consultTransactionFee?: number | null, discountAmount?: number | null, isConsult?: boolean | null, mainBasePrice?: number | null, mainTax?: number | null, mainTransactionFee?: number | null, minimalAmountPayment?: number | null, paymentIntentAmount?: number | null, paymentIntentAmountAfterCashback?: number | null, paymentIntentSummary?: any | null, priceId?: string | null, productPriceAmount?: number | null, productPriceAmountAfterDiscount?: number | null, promotionCode?: string | null, shouldChargeConsultFee?: boolean | null, subTotal?: number | null, total?: number | null, totalAfterCashback?: number | null } | null, price?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, priceInfo?: { __typename?: 'StripePriceDto', active?: boolean | null, billing_scheme?: string | null, created?: number | null, createdAt?: any | null, currency?: string | null, displayId?: string | null, firstTimeAlternativePrice?: string | null, firstTimeTryingInMonths?: number | null, id?: string | null, importPriceId?: string | null, isBundle?: boolean | null, livemode?: boolean | null, locale?: any | null, nickname?: string | null, product?: string | null, productId?: string | null, shopDisplay?: boolean | null, sysId?: string | null, tax_behavior?: string | null, type?: StripePriceType | null, unit_amount?: number | null, unit_amount_decimal?: string | null, updatedAt?: any | null } | null, productInfo?: { __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null } | null, siblingCrossSellOrders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null }> | null, subscription?: { __typename?: 'StripeSubscriptionDto', cancel_at_period_end?: boolean | null, current_period_end?: number | null, current_period_start?: number | null, default_payment_method?: any | null, id: string, items?: any | null, latest_invoice?: any | null, metadata?: any | null, pause_collection?: any | null, pending_setup_intent?: any | null, pending_update?: any | null, status?: StripeSubscriptionStatus | null } | null, upcomingInvoice?: { __typename?: 'StripeInvoiceDto', amount_due?: number | null, hosted_invoice_url?: string | null, id?: string | null, next_payment_attempt?: number | null, paid?: boolean | null, paymentStatus?: PaymentStatus | null, period_end?: number | null, starting_balance?: number | null, status?: InvoiceStatus | null, subtotal?: number | null, tax?: number | null, total?: number | null } | null }, stripeProductPrice?: { __typename?: 'StripeProductPriceDto', importPriceId?: string | null, isBundle?: boolean | null, priceActive?: string | null, priceBillingScheme?: string | null, priceCreated?: number | null, priceCurrency?: string | null, priceDisplayId?: string | null, priceFirstTimeAlternativePrice?: string | null, priceFirstTimeTryingInMonths?: number | null, priceId?: string | null, priceLivemode?: boolean | null, priceNickname?: string | null, priceProduct?: string | null, priceTaxBehavior?: string | null, priceUnitAmount?: number | null, priceUnitAmountDecimal?: string | null, productActive?: boolean | null, productDescription?: string | null, productDisplayId?: string | null, productId?: string | null, productLivemode?: boolean | null, productName?: string | null, productStatementDescriptor?: string | null, productType?: string | null, productUniqName?: string | null, productUnitLabel?: string | null, sysId?: string | null } | null }> | null } | null, calendarDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, calendarTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, consultation?: { __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null, consultationMessages?: { __typename?: 'PaginatedUserMessageDto', count: number, limit?: number | null, offset?: number | null } | null, consultations?: Array<{ __typename?: 'ConsultationDto', countReminder?: number | null, createdAt?: any | null, doctorChatToken?: string | null, doctorSysId?: string | null, friendlyName?: string | null, gmeetLink?: string | null, isActive?: boolean | null, isRead?: boolean | null, isVideoConsultRescheduled?: boolean | null, lastMsgSysId?: string | null, lastMsgUserId?: string | null, orderSysId?: string | null, patientChatToken?: string | null, patientEmail?: string | null, prescribedAt?: any | null, previewVideoLink?: string | null, progressStatus?: ConsultationSessionProgressStatus | null, readAt?: any | null, reviewDate?: any | null, status?: ConsultationSessionStatus | null, sysId?: string | null, textConsultStatus?: TextConsultStatus | null, textConversationId?: string | null, type?: ConsultationSessionType | null, updatedAt?: any | null, videoChannelId?: string | null, videoLink?: string | null } | null> | null, doctor?: { __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null } | null, doctors?: Array<{ __typename?: 'DoctorDto', active?: boolean | null, calendarId?: number | null, country?: RegionType | null, designation?: DoctorDesignation | null, duration?: any | null, email?: string | null, firstName?: string | null, fullName?: string | null, lastName?: string | null, sysId?: string | null, textConsultPostalCodes?: Array<string> | null, trtEligible?: boolean | null }> | null, orders?: Array<{ __typename?: 'OrderDto', ableToBookConsultSchedule?: boolean | null, ableToBookDeliverySchedule?: boolean | null, ableToChangeDeliverySchedule?: boolean | null, approveAt?: any | null, atomeNextSendingInvoiceDate?: any | null, claimedRetentionOffer?: boolean | null, continueTrial?: boolean | null, countTrialReminder?: number | null, country?: RegionType | null, createFromSkipOrderId?: string | null, createdAt?: any | null, delivery?: any | null, deliveryAddressSysId?: string | null, deliveryMethod?: DeliveryMethod | null, deliverySnapshot?: any | null, deliveryStatus?: DeliveryStatus | null, deliveryTimestamp?: any | null, doctorNotes?: string | null, doctorPrescriptionPriceIds?: Array<string | null> | null, dosage?: any | null, doseStartedAt?: any | null, evaluationId?: string | null, expiredAt?: number | null, intakeInstructions?: string | null, isAtomeAutoRenewal?: boolean | null, isAutoRenewal?: boolean | null, isConsultOnly?: boolean | null, isEDTrial?: boolean | null, isEditingDeliveryWithin2Hours?: boolean | null, isOrderRenew?: boolean | null, isPacked?: boolean | null, isPendingFollowUpConsult?: boolean | null, isPrescriptionValid?: boolean | null, isSkipMedOrder?: boolean | null, isSkippedEval?: boolean | null, isSubscriptionPastDue?: boolean | null, isSubscriptionPaused?: boolean | null, lastPaymentDate?: any | null, lastShipmentDate?: any | null, nextReviewDate?: any | null, oldPrice?: any | null, oldStripePrescriptionId?: string | null, ops?: string | null, opsComment?: string | null, orderPrescriptionPriceId?: string | null, orderPriceId?: string | null, otherIntestedEvalIds?: Array<string> | null, partnerSysId?: string | null, patientId?: string | null, patientOrderNotes?: Array<string | null> | null, paymentIntentUrl?: string | null, paymentProvider?: string | null, paymentStatus?: PaymentStatus | null, phoneNumber?: string | null, planStatus?: PlanStatus | null, platformType?: PlatformType | null, prescribeAfterTeleConsult?: boolean | null, prescribed_after_trial_order_sys_id?: string | null, prescriptionDisplayPriceId?: string | null, prescriptionId?: string | null, priceDisplayId?: string | null, productQuantity?: number | null, promotionCode?: string | null, rejectAt?: any | null, reorderStatus?: boolean | null, shortId?: number | null, showInCurrentPlans?: boolean | null, showInNotifications?: boolean | null, showInPastPlans?: boolean | null, status?: OrderStatus | null, stripePaymentIntentId?: string | null, stripeSubscriptionId?: string | null, sysId?: string | null, teleConsultProduct?: boolean | null, updatedAt?: any | null } | null> | null, partnerConsultDates?: Array<{ __typename?: 'CalendarDateDto', date?: string | null } | null> | null, partnerConsultTimes?: Array<{ __typename?: 'CalendarTimeDto', time?: string | null } | null> | null, patient?: { __typename?: 'PatientDto', bloodPressure?: string | null, country?: RegionType | null, createdAt?: any | null, dob?: string | null, email?: string | null, fbc?: string | null, fbp?: string | null, firstName?: string | null, fromPlatformEnv?: PlatformType | null, fullName?: string | null, gender?: Gender | null, height?: number | null, icNumber?: string | null, idVerifiedAt?: any | null, identification?: any | null, isAlreadyCheckout?: boolean | null, isReferredBy?: string | null, lastName?: string | null, legalName?: string | null, locale?: string | null, mounjaroTrialEligible: boolean, paidCompletedEvaluationIds?: Array<string> | null, phoneNumber?: string | null, referralCode?: string | null, stripeCustomer?: any | null, stripeCustomerId?: string | null, sysId?: string | null, userSysId?: string | null, weight?: number | null } | null, patientDocuments?: Array<{ __typename?: 'UserDocumentDto', createdAt?: any | null, orderSysId?: string | null, ref: string, sysId: string, type: UserDocumentType, url?: string | null } | null> | null, prescriptionCalculation?: { __typename?: 'CheckoutCalculationDto', isAffiliateLocked?: boolean | null, promotionCodeError?: PromotionCodeError | null, stripePromotionCode?: any | null } | null, stripeProducts?: Array<{ __typename?: 'StripeProductDto', active?: boolean | null, country?: RegionType | null, createdAt?: any | null, description?: string | null, displayId?: string | null, evaluationId?: any | null, format?: string | null, hasOneDosage?: boolean | null, hasOneFrequency?: boolean | null, id?: string | null, ingredients?: Array<string> | null, isConsultOnly?: boolean | null, isPopular?: boolean | null, isRxOneTime?: boolean | null, isShowOnShop?: any | null, isSkipMedProduct?: boolean | null, livemode?: boolean | null, metadata?: any | null, name?: string | null, popularPriceId?: string | null, shopProductGroupIds?: any | null, shouldChargeNow?: boolean | null, statementDescriptor?: string | null, sysId?: string | null, type?: string | null, uniqName?: string | null, unitLabel?: string | null, updatedAt?: any | null, usage?: Array<string> | null }> | null } | null };


export const AddCashbackToMultipleCustomersDocument = `
    mutation addCashbackToMultipleCustomers($input: AddCashbackToCustomersInput!) {
  addCashbackToMultipleCustomers(input: $input) {
    errorCustomers
    notFoundCustomers
    success
  }
}
    `;
export const useAddCashbackToMultipleCustomersMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCashbackToMultipleCustomersMutation, TError, AddCashbackToMultipleCustomersMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCashbackToMultipleCustomersMutation, TError, AddCashbackToMultipleCustomersMutationVariables, TContext>(
      ['addCashbackToMultipleCustomers'],
      (variables?: AddCashbackToMultipleCustomersMutationVariables) => fetcher<AddCashbackToMultipleCustomersMutation, AddCashbackToMultipleCustomersMutationVariables>(client, AddCashbackToMultipleCustomersDocument, variables, headers)(),
      options
    );
export const AddCashbackToTheCustomerDocument = `
    mutation addCashbackToTheCustomer($input: AddCashbackToCustomerInput!) {
  addCashbackToTheCustomer(input: $input) {
    errorCustomers
    notFoundCustomers
    success
  }
}
    `;
export const useAddCashbackToTheCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCashbackToTheCustomerMutation, TError, AddCashbackToTheCustomerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCashbackToTheCustomerMutation, TError, AddCashbackToTheCustomerMutationVariables, TContext>(
      ['addCashbackToTheCustomer'],
      (variables?: AddCashbackToTheCustomerMutationVariables) => fetcher<AddCashbackToTheCustomerMutation, AddCashbackToTheCustomerMutationVariables>(client, AddCashbackToTheCustomerDocument, variables, headers)(),
      options
    );
export const AddNewPickupLocationsDocument = `
    mutation addNewPickupLocations($input: NewPickupLocationsInput!) {
  addNewPickupLocations(input: $input)
}
    `;
export const useAddNewPickupLocationsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddNewPickupLocationsMutation, TError, AddNewPickupLocationsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddNewPickupLocationsMutation, TError, AddNewPickupLocationsMutationVariables, TContext>(
      ['addNewPickupLocations'],
      (variables?: AddNewPickupLocationsMutationVariables) => fetcher<AddNewPickupLocationsMutation, AddNewPickupLocationsMutationVariables>(client, AddNewPickupLocationsDocument, variables, headers)(),
      options
    );
export const AppleLoginDocument = `
    mutation appleLogin($input: AppleLoginInput!) {
  appleLogin(input: $input) {
    accessToken
    accessTokenExpiredAt
    refreshToken
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useAppleLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AppleLoginMutation, TError, AppleLoginMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AppleLoginMutation, TError, AppleLoginMutationVariables, TContext>(
      ['appleLogin'],
      (variables?: AppleLoginMutationVariables) => fetcher<AppleLoginMutation, AppleLoginMutationVariables>(client, AppleLoginDocument, variables, headers)(),
      options
    );
export const ApplyPromotionCodeForAnonymousDocument = `
    mutation applyPromotionCodeForAnonymous($input: ApplyPromotionCodeForAnonymousInput!) {
  applyPromotionCodeForAnonymous(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary
    calculation
    cart
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    errorCode
    paidCompletedEvaluationIds
    platform
    promotionCode
    status
    sysId
  }
}
    `;
export const useApplyPromotionCodeForAnonymousMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApplyPromotionCodeForAnonymousMutation, TError, ApplyPromotionCodeForAnonymousMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ApplyPromotionCodeForAnonymousMutation, TError, ApplyPromotionCodeForAnonymousMutationVariables, TContext>(
      ['applyPromotionCodeForAnonymous'],
      (variables?: ApplyPromotionCodeForAnonymousMutationVariables) => fetcher<ApplyPromotionCodeForAnonymousMutation, ApplyPromotionCodeForAnonymousMutationVariables>(client, ApplyPromotionCodeForAnonymousDocument, variables, headers)(),
      options
    );
export const ApplyPromotionCodeForCartDocument = `
    mutation applyPromotionCodeForCart($input: ApplyPromotionCodeForCartInput!) {
  applyPromotionCodeForCart(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary
    calculation
    cart
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    errorCode
    paidCompletedEvaluationIds
    platform
    promotionCode
    status
    sysId
  }
}
    `;
export const useApplyPromotionCodeForCartMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApplyPromotionCodeForCartMutation, TError, ApplyPromotionCodeForCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ApplyPromotionCodeForCartMutation, TError, ApplyPromotionCodeForCartMutationVariables, TContext>(
      ['applyPromotionCodeForCart'],
      (variables?: ApplyPromotionCodeForCartMutationVariables) => fetcher<ApplyPromotionCodeForCartMutation, ApplyPromotionCodeForCartMutationVariables>(client, ApplyPromotionCodeForCartDocument, variables, headers)(),
      options
    );
export const ApplyPromotionFromBannerDocument = `
    mutation applyPromotionFromBanner($input: ApplyPromotionFromBannerInput!) {
  applyPromotionFromBanner(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary
    calculation
    cart
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    errorCode
    paidCompletedEvaluationIds
    platform
    promotionCode
    status
    sysId
  }
}
    `;
export const useApplyPromotionFromBannerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApplyPromotionFromBannerMutation, TError, ApplyPromotionFromBannerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ApplyPromotionFromBannerMutation, TError, ApplyPromotionFromBannerMutationVariables, TContext>(
      ['applyPromotionFromBanner'],
      (variables?: ApplyPromotionFromBannerMutationVariables) => fetcher<ApplyPromotionFromBannerMutation, ApplyPromotionFromBannerMutationVariables>(client, ApplyPromotionFromBannerDocument, variables, headers)(),
      options
    );
export const ApprovePrescriptionOrderDocument = `
    mutation approvePrescriptionOrder($input: ApprovePrescriptionOrderInput!) {
  approvePrescriptionOrder(input: $input)
}
    `;
export const useApprovePrescriptionOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApprovePrescriptionOrderMutation, TError, ApprovePrescriptionOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ApprovePrescriptionOrderMutation, TError, ApprovePrescriptionOrderMutationVariables, TContext>(
      ['approvePrescriptionOrder'],
      (variables?: ApprovePrescriptionOrderMutationVariables) => fetcher<ApprovePrescriptionOrderMutation, ApprovePrescriptionOrderMutationVariables>(client, ApprovePrescriptionOrderDocument, variables, headers)(),
      options
    );
export const ArchiveStripePriceDocument = `
    mutation archiveStripePrice($input: ArchivePriceInput!) {
  archiveStripePrice(input: $input)
}
    `;
export const useArchiveStripePriceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ArchiveStripePriceMutation, TError, ArchiveStripePriceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ArchiveStripePriceMutation, TError, ArchiveStripePriceMutationVariables, TContext>(
      ['archiveStripePrice'],
      (variables?: ArchiveStripePriceMutationVariables) => fetcher<ArchiveStripePriceMutation, ArchiveStripePriceMutationVariables>(client, ArchiveStripePriceDocument, variables, headers)(),
      options
    );
export const ArchiveStripeProductDocument = `
    mutation archiveStripeProduct($input: ArchiveProductInput!) {
  archiveStripeProduct(input: $input)
}
    `;
export const useArchiveStripeProductMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ArchiveStripeProductMutation, TError, ArchiveStripeProductMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ArchiveStripeProductMutation, TError, ArchiveStripeProductMutationVariables, TContext>(
      ['archiveStripeProduct'],
      (variables?: ArchiveStripeProductMutationVariables) => fetcher<ArchiveStripeProductMutation, ArchiveStripeProductMutationVariables>(client, ArchiveStripeProductDocument, variables, headers)(),
      options
    );
export const AttachPaymentIntentDocument = `
    mutation attachPaymentIntent($input: AttachPaymentIntentInput!) {
  attachPaymentIntent(input: $input)
}
    `;
export const useAttachPaymentIntentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AttachPaymentIntentMutation, TError, AttachPaymentIntentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AttachPaymentIntentMutation, TError, AttachPaymentIntentMutationVariables, TContext>(
      ['attachPaymentIntent'],
      (variables?: AttachPaymentIntentMutationVariables) => fetcher<AttachPaymentIntentMutation, AttachPaymentIntentMutationVariables>(client, AttachPaymentIntentDocument, variables, headers)(),
      options
    );
export const AttachPaymentMethodDocument = `
    mutation attachPaymentMethod($paymentMethodId: String!) {
  attachPaymentMethod(paymentMethodId: $paymentMethodId)
}
    `;
export const useAttachPaymentMethodMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AttachPaymentMethodMutation, TError, AttachPaymentMethodMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AttachPaymentMethodMutation, TError, AttachPaymentMethodMutationVariables, TContext>(
      ['attachPaymentMethod'],
      (variables?: AttachPaymentMethodMutationVariables) => fetcher<AttachPaymentMethodMutation, AttachPaymentMethodMutationVariables>(client, AttachPaymentMethodDocument, variables, headers)(),
      options
    );
export const AttachPaymentMethod2Document = `
    mutation attachPaymentMethod2($id: String, $platform: String, $platform1: String, $platform2: String, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform9: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform10: String, $id1: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id2: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform11: String, $platform12: String, $platform13: String, $platform14: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform15: String, $videoLink1: String!, $patientId: String, $input4: CrossSellRecordQueryInput, $orderId: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId1: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId2: String, $limit2: Int, $offset2: Int, $order1: JSON, $acuityAppointmentId2: String, $date2: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date3: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $input5: V2ConsultationFilterInput!, $input6: ConsultationMessagesInput!, $limit3: Int, $offset3: Int, $order2: JSON, $input7: ConsultationListInput!, $limit4: Int, $offset4: Int, $order3: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input8: OrderInput!, $pagination: V2PaginationInput!, $date4: String, $date5: Float, $input9: GetPatientInput, $platform16: String, $input10: StripeProductFilterV2, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit5: Int, $offset5: Int, $order4: JSON, $input13: ConsultationListInput!, $limit6: Int, $offset6: Int, $order5: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform17: String, $input16: StripeProductFilterV2, $doctorFilterInput3: V2DoctorInputFilter, $limit7: Int, $offset7: Int, $order6: JSON, $checkoutSessionFilterOptions1: CheckoutSessionFilterInput, $inputConsultation5: V2ConsultationFilterInput, $input17: GetPatientDocumentInput!, $evalFilter1: V2PatientEvaluationFilterInput, $id3: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform18: String, $inputOrder2: V2OrderFilterInput, $orderPagination2: V2PaginationInput, $input18: PrescriptionCalculationInput, $platform19: String, $platform20: String, $filter1: ShopProductFilterInputV2, $limit8: Float, $offset8: Float, $sort1: ShopProductSortInputV2, $input19: GetSmartMatchMetaInput!, $input20: PatientGetSurveyInput, $videoLink3: String!, $previewVideoLink1: String!, $paymentMethodInput: V2UpdatePaymentMethod!) {
  attachPaymentMethod2(paymentMethodInput: $paymentMethodInput) {
    atomePayment(id: $id) {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    bypassLoginTokens {
      expiresAt
      pageName
      token
      type
    }
    cart {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      cartItems {
        cart {
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          orderSummary {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            discountAmountLater
            discountAmountNow
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountBeforeTax
            paymentIntentSummary
            promotionCode
            shippingFee
            subTotal
            subTotalLater
            subTotalNow
            taxes
            taxesLater
            taxesNow
            teleConsultFee
            total
            totalLater
            totalNow
            totalNowAfterCashback
            totalTaxes
          }
          paidCompletedEvaluationIds
          platform
          promotionCode
          status
          sysId
        }
        completedEval
        consultationSessionType
        isAutoRenewal
        isSkipMedSelecting
        isSubscriptionPrice
        orderId
        patientNote
        price {
          active
          alternativePrice {
            active
            alternativePrice {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                drDosageFrequency {
                  alternativeDosage
                  alternativeDosageUnit
                  asNeeded
                  dosage
                  dosageUnit
                  duration
                  durationUnit
                  frequency
                  productId
                  quantity
                  quantityUnit
                }
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredients
                  isConsultOnly(platform: $platform1)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                ingredientDetails {
                  description
                  imageLink
                  locale
                  name
                  strength
                  uniqueName
                }
                ingredients
                isConsultOnly(platform: $platform2)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                prices {
                  active
                  alternativePrice {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform3)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          metadata {
            actual_price_display
            boxes
            dosage
            dosage_display
            dosage_popular
            frequency
            frequency_actual_price_display
            frequency_display
            frequency_popular
            frequency_price_display
            frequency_quantity_display
            frequency_quantity_display_patient
            frequency_savings_display
            frequency_strikeout_price_display
            isArchived
            isOneTimePrice
            price_frequency
            price_quantity
            price_show
            quantity
            quantity_display
            strength
          }
          nickname
          product
          productId
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform4)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          shopDisplay
          sysId
          tax_behavior
          texts {
            actual_price_display
            dosage
            dosage_display
            dosage_popular
            frequency
            frequency_actual_price_display
            frequency_display
            frequency_popular
            frequency_price_display
            frequency_quantity_display
            frequency_quantity_display_patient
            frequency_savings_display
            frequency_strikeout_price_display
            price_frequency
            price_quantity
            quantity
            quantity_display
          }
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        product {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform5)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredientDetails {
            description
            imageLink
            locale
            name
            strength
            uniqueName
          }
          ingredients
          isConsultOnly(platform: $platform6)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          prices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInstructions {
            language
            localeKey
            productId
            sysId
            translatedText
          }
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          tempPrices {
            active
            alternativePrice {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            metadata {
              actual_price_display
              boxes
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              isArchived
              isOneTimePrice
              price_frequency
              price_quantity
              price_show
              quantity
              quantity_display
              strength
            }
            nickname
            product
            productId
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform7)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            shopDisplay
            sysId
            tax_behavior
            texts {
              actual_price_display
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              price_frequency
              price_quantity
              quantity
              quantity_display
            }
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          texts {
            benefits
            category
            display_price
            display_price_patient
            dosage_variant_body
            dosage_variant_title
            effective_in
            for
            frequency_variant_title
            good_to_know
            how_to_take
            how_to_use
            is_popular
            lasts_for
            platform
            product_description
            product_name
            product_short_description
            quantity_per_unit
            quantity_variant_title
            requires_prescription
            safety_information
            side_effects
            strength
            taken
            unit
            unit_patient
          }
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        quantity
        teleConsultForSkipEval
        type
      }
      paidCompletedEvaluationIds
      platform
      promotionCode
      status
      sysId
    }
    cashback {
      availableBalance
      recentTransactions {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
      savingsToDateThisYear {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
    }
    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions1) {
      checkoutData
      evaluationId
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          consultationAudit {
            consultTime
            consultType
            createdBy
            doctor {
              active
              bio {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              calendarId
              consultation(videoLink: $videoLink1) {
                gmeetLink
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id1) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform13)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform14)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform15)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                previewToken
                previewVideoLink
                status
                sysId
                token
                videoChannelId
                videoLink
                zoomJoinUrl
              }
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              patient(patientId: $patientId) {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sysId
              textConsultPostalCodes
              trtEligible
              user {
                admin {
                  crossSellRecords(input: $input4) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId
                  date: $date
                  forDelivery: $forDelivery
                  isReschedule: $isReschedule
                  orderId: $orderId1
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId1
                  consultDate: $consultDate
                  date: $date1
                  forDelivery: $forDelivery1
                  isReschedule: $isReschedule1
                  orderId: $orderId2
                ) {
                  time
                }
                consultation(input: $input11) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit2, offset: $offset2, order: $order1) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId2
                      date: $date2
                      forDelivery: $forDelivery2
                      isReschedule: $isReschedule2
                      orderId: $orderId3
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId3
                      consultDate: $consultDate1
                      date: $date3
                      forDelivery: $forDelivery3
                      isReschedule: $isReschedule3
                      orderId: $orderId4
                    ) {
                      time
                    }
                    consultation(input: $input5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input6
                      limit: $limit3
                      offset: $offset3
                      order: $order2
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input7, limit: $limit4, offset: $offset4, order: $order3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input8, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date4) {
                      date
                    }
                    partnerConsultTimes(date: $date5) {
                      time
                    }
                    patient(input: $input9) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input10) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform16)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input12
                  limit: $limit5
                  offset: $offset5
                  order: $order4
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input13, limit: $limit6, offset: $offset6, order: $order5) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input14, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input15) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input16) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            evaluationId
            sessionType
            status
            sysId
          }
          consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
            count
            limit
            offset
          }
          consultationTitle {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          countReminder
          createdAt
          doctor {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          messages {
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
          }
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          orderSysId
          participants {
            avatar
            fullName
            identity
            locale
            role
            token
            userSysId
          }
          participantsV2 {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            phoneNumber
            requireConfirmPolicy
            socialProviderType
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation5) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    document(input: $input17) {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    documents {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    email
    evaluations(evalFilter: $evalFilter1) {
      isCompleted
      isSkipped
      name
      patientAnswers {
        answer {
          childrenAnswers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        question {
          answers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          content {
            body {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            footer {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            header {
              description
              descriptionTextKey
              title
              titleTextKey
            }
          }
          dependentEvaluationQuestions {
            answer {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            skipPage
            skipQuestionCount
            sysId
          }
          displayPage
          evaluationBlocks {
            blockAnswer {
              childrenAnswers {
                deselectAll
                mandatory
                name
                order
                placeholder
                productUrl
                sysId
                textKey
                type
              }
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            content {
              description
              descriptionTextKey
              sysId
              title
              titleTextKey
            }
            sysId
          }
          guestOnly
          name
          order
          sysId
          textKey
          type
          validation {
            bmi
            extra
            max
            min
            preselect
            type
          }
        }
        type
        value
      }
      patientNote
      platform
      questions {
        answers {
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        dependentEvaluationQuestions {
          skipPage
          skipQuestionCount
          sysId
        }
        displayPage
        evaluationBlocks {
          sysId
        }
        guestOnly
        name
        order
        sysId
        textKey
        type
        validation {
          bmi
          extra
          max
          min
          preselect
          type
        }
      }
      status
      sysId
      type
    }
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    idVerifiedAt
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    latestPaymentMethod {
      card {
        brand
        exp_month
        exp_year
        last4
      }
      id
    }
    legalName
    locale
    mounjaroTrialEligible
    order(id: $id3) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    orders(inputOrder: $inputOrder2, orderPagination: $orderPagination2) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      activeConsultation {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      acuityAppointment {
        appointmentTypeID
        bookedAt
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        bookedAt
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      additionalPrices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      afterVideoConsultRedirecting {
        baseUrl
        path
      }
      approveAt
      atomeNextSendingInvoiceDate
      atomePayments {
        amount
        paymentUrl
        priceId
        referenceId
        status
        sysId
      }
      checkoutSession {
        checkoutData
        evaluationId
        status
        sysId
      }
      childrenOrders {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      claimedRetentionOffer
      consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
        consultTime
        consultType
        createdBy
        evaluationId
        sessionType
        status
        sysId
      }
      consultations(inputConsultation: $inputConsultation6) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluation {
        isCompleted
        isSkipped
        name
        patientNote
        platform
        status
        sysId
        type
      }
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      latestAtomePayment {
        amount
        paymentUrl
        priceId
        referenceId
        status
        sysId
      }
      latestInvoice {
        amount_due
        hosted_invoice_url
        id
        next_payment_attempt
        paid
        paymentStatus
        period_end
        starting_balance
        status
        subtotal
        tax
        total
      }
      latestNote {
        content
        createdAt
        createdBy
        sysId
        updatedAt
      }
      nextReviewDate
      oldPrice
      oldPriceInfo {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescribed_after_trial_order_sys_id
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      price {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      priceDisplayId
      priceInfo {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        ingredients
        isConsultOnly(platform: $platform18)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      siblingCrossSellOrders {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      status
      stripePaymentIntentId
      stripeSubscriptionId
      subscription {
        cancel_at_period_end
        current_period_end
        current_period_start
        default_payment_method
        id
        items
        latest_invoice
        metadata
        pause_collection
        pending_setup_intent
        pending_update
        status
      }
      sysId
      teleConsultProduct
      upcomingInvoice {
        amount_due
        hosted_invoice_url
        id
        next_payment_attempt
        paid
        paymentStatus
        period_end
        starting_balance
        status
        subtotal
        tax
        total
      }
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    prescriptionCalculation(input: $input18) {
      affiliateCouponNotApplied {
        affiliateProductDisplayName
        reason
      }
      isAffiliateLocked
      otcCalculationSummary {
        otcOrdersCalculation {
          basePrice
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          discountAmount
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          stripePromotionCode
          tax
          transactionFee
        }
        totalBasePrice
        totalCashbackEarned
        totalCashbackRedeemed
        totalPaymentIntentAmount
        totalTax
        totalTransactionFee
      }
      promotionCodeError
      rxCalculationSummary {
        rxOrdersCalculation {
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          consultBasePrice
          consultFee
          consultFeeAfterDiscount
          consultTax
          consultTransactionFee
          discountAmount
          isConsult
          mainBasePrice
          mainTax
          mainTransactionFee
          minimalAmountPayment
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          shouldChargeConsultFee
          subTotal
          total
          totalAfterCashback
        }
        total
        totalCashbackEarned
        totalCashbackRedeemed
        totalDiscountAmount
        totalMainBasePrice
        totalPaymentIntentAmount
        totalPaymentIntentAmountAfterCashback
        totalTax
        totalTransactionFee
      }
      stripePromotionCode
    }
    referralCode
    referrals {
      doctor {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      doctorId
      documents {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      items {
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        orderId
        price {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        priceId
        referralSysId
        sysId
      }
      sysId
    }
    shopProducts(filter: $filter1, limit: $limit8, offset: $offset8, sort: $sort1) {
      count
      items {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform19)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform20)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      limit
      offset
    }
    smartMatchMeta(input: $input19) {
      evalId
      status
      sysId
      userId
      userType
    }
    stripeCustomer
    stripeCustomerId
    survey(input: $input20) {
      answers
      isSkipped
      patientSysId
      sysId
      type
    }
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      phoneNumber
      requireConfirmPolicy
      socialProviderType
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    userSysId
    videoConsultation(videoLink: $videoLink3) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
    videoConsultationPreview(previewVideoLink: $previewVideoLink1) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
    weight
  }
}
    `;
export const useAttachPaymentMethod2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AttachPaymentMethod2Mutation, TError, AttachPaymentMethod2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AttachPaymentMethod2Mutation, TError, AttachPaymentMethod2MutationVariables, TContext>(
      ['attachPaymentMethod2'],
      (variables?: AttachPaymentMethod2MutationVariables) => fetcher<AttachPaymentMethod2Mutation, AttachPaymentMethod2MutationVariables>(client, AttachPaymentMethod2Document, variables, headers)(),
      options
    );
export const AttachPaymentMethodWithIntentForAnonymousDocument = `
    mutation attachPaymentMethodWithIntentForAnonymous($input: AttachPaymentMethodWithIntentForAnonymousInput!) {
  attachPaymentMethodWithIntentForAnonymous(input: $input)
}
    `;
export const useAttachPaymentMethodWithIntentForAnonymousMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AttachPaymentMethodWithIntentForAnonymousMutation, TError, AttachPaymentMethodWithIntentForAnonymousMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AttachPaymentMethodWithIntentForAnonymousMutation, TError, AttachPaymentMethodWithIntentForAnonymousMutationVariables, TContext>(
      ['attachPaymentMethodWithIntentForAnonymous'],
      (variables?: AttachPaymentMethodWithIntentForAnonymousMutationVariables) => fetcher<AttachPaymentMethodWithIntentForAnonymousMutation, AttachPaymentMethodWithIntentForAnonymousMutationVariables>(client, AttachPaymentMethodWithIntentForAnonymousDocument, variables, headers)(),
      options
    );
export const BookAppointmentAndDeliveryDocument = `
    mutation bookAppointmentAndDelivery($input: BookAppointmentAndDeliveryInput!) {
  bookAppointmentAndDelivery(input: $input) {
    checkoutCartId
    consultationSession {
      countReminder
      createdAt
      doctor {
        active
        calendarId
        country
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            billingAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            bloodPressure
            country
            createdAt
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            orders {
              acuityAppointmentSnapshot {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            user {
              avatar
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              requireConfirmPolicy
              socialProviderType
              sysId
              userType
              utmCampaign
              utmMedium
              utmSource
            }
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
      }
      doctorChatToken
      friendlyName
      gmeetLink
      order {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        address
        affiliateCoupon {
          affiliateProductSysId
          affiliateSysId
          anonymousId
          couponId
          createdAt
          opsNote
          orderSysId
          status
          sysId
          updatedAt
          verifiedAt
          verifiedByUserSysId
        }
        approveAt
        atomePaymentAmount
        auditDoctorNotes {
          createdAt
          createdBy
          deletedBy
          isDeleted
          note
          sysId
        }
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldOrder {
          id
          isCancelled
          priceId
          status
          subId
        }
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        patientSnapshot {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          locale
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          weight
        }
        paymentProvider
        phoneNumber
        pickupLocation {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        platformType
        prescribeAfterTeleConsult
        prescribedAfterTrialOrder {
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        prescription {
          cancelled
          createdAt
          days
          doctorNotes
          endDate
          expiresAt
          isFollowUp
          notedDate
          priceIds
          startDate
          status
          sysId
          treatmentCode
          updatedAt
        }
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productGroupData {
          acuitySchedulingAppType
          amountToFreeIncludedPrice
          chargeNowProduct
          country
          crossEvaluation
          displayId
          emailOnCompleteName
          emailTemplate
          evaluationFormId
          id
          includedPriceIds
          overwriteCalendarHeaderTitleInfo
          overwriteProductSubtitleInfo
          platform
          productGroups
          requiresDelivery
          requiresEvaluation
          requiresPrescription
          sysId
          title
        }
        productInfo {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        twilioMessageHistories {
          address
          email
          fullName
          message
          phoneNumber
        }
        updatedAt
      }
      patientChatToken
      status
      sysId
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    isFertilityCoach
    order {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    success
  }
}
    `;
export const useBookAppointmentAndDeliveryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BookAppointmentAndDeliveryMutation, TError, BookAppointmentAndDeliveryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BookAppointmentAndDeliveryMutation, TError, BookAppointmentAndDeliveryMutationVariables, TContext>(
      ['bookAppointmentAndDelivery'],
      (variables?: BookAppointmentAndDeliveryMutationVariables) => fetcher<BookAppointmentAndDeliveryMutation, BookAppointmentAndDeliveryMutationVariables>(client, BookAppointmentAndDeliveryDocument, variables, headers)(),
      options
    );
export const BookAppointmentAndDeliveryV2Document = `
    mutation bookAppointmentAndDeliveryV2($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $bookConsultInput: V2BookAppointmentAndDeliveryInput!) {
  bookAppointmentAndDeliveryV2(bookConsultInput: $bookConsultInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useBookAppointmentAndDeliveryV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BookAppointmentAndDeliveryV2Mutation, TError, BookAppointmentAndDeliveryV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BookAppointmentAndDeliveryV2Mutation, TError, BookAppointmentAndDeliveryV2MutationVariables, TContext>(
      ['bookAppointmentAndDeliveryV2'],
      (variables?: BookAppointmentAndDeliveryV2MutationVariables) => fetcher<BookAppointmentAndDeliveryV2Mutation, BookAppointmentAndDeliveryV2MutationVariables>(client, BookAppointmentAndDeliveryV2Document, variables, headers)(),
      options
    );
export const BookFuAppointmentDocument = `
    mutation bookFUAppointment($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: V2BookFUAppointmentInput!) {
  bookFUAppointment(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useBookFuAppointmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BookFuAppointmentMutation, TError, BookFuAppointmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BookFuAppointmentMutation, TError, BookFuAppointmentMutationVariables, TContext>(
      ['bookFUAppointment'],
      (variables?: BookFuAppointmentMutationVariables) => fetcher<BookFuAppointmentMutation, BookFuAppointmentMutationVariables>(client, BookFuAppointmentDocument, variables, headers)(),
      options
    );
export const BookHumansaConsultationDocument = `
    mutation bookHumansaConsultation($platform: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform9: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform10: String, $input9: StripeProductFilterV2, $limit4: Int, $offset4: Int, $order3: JSON, $patientId: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input12: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $doctorFilterInput3: V2DoctorInputFilter, $input13: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input14: GetPatientInput, $platform11: String, $input15: StripeProductFilterV2, $input16: V2ConsultationFilterInput!, $videoLink1: String!, $limit8: Int, $offset8: Int, $order7: JSON, $input17: BookHumansaConsultation!) {
  bookHumansaConsultation(input: $input17) {
    consultationAudit {
      consultTime
      consultType
      createdBy
      doctor {
        active
        bio {
          createdAt
          createdBy
          remark
          sysId
          translationKey
          updatedAt
          updatedBy
          valueEn
          valueJa
          valueZh
        }
        calendarId
        consultation(videoLink: $videoLink1) {
          gmeetLink
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            activeConsultation {
              consultationAudit {
                consultTime
                consultType
                createdBy
                evaluationId
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sessionType
                status
                sysId
              }
              consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                count
                items {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                limit
                offset
              }
              consultationTitle {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              countReminder
              createdAt
              doctor {
                active
                calendarId
                country
                designation
                duration
                email
                firstName
                fullName
                lastName
                patient(patientId: $patientId) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sysId
                textConsultPostalCodes
                trtEligible
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              messages {
                automatedMessage {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                consultationSysId
                content
                createdAt
                readAt
                sysId
                updatedAt
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              orderSysId
              participants {
                avatar
                fullName
                identity
                locale
                role
                token
                userSysId
              }
              participantsV2 {
                admin {
                  crossSellRecords(input: $input10) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId2
                  date: $date4
                  forDelivery: $forDelivery2
                  isReschedule: $isReschedule2
                  orderId: $orderId3
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId3
                  consultDate: $consultDate1
                  date: $date5
                  forDelivery: $forDelivery3
                  isReschedule: $isReschedule3
                  orderId: $orderId4
                ) {
                  time
                }
                consultation(input: $input16) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                    count
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    consultationMessages(
                      input: $input11
                      limit: $limit6
                      offset: $offset6
                      order: $order5
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input12, limit: $limit7, offset: $offset7, order: $order6) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput2) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput3) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input13, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input14) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input15) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          previewToken
          previewVideoLink
          status
          sysId
          token
          videoChannelId
          videoLink
          zoomJoinUrl
        }
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      evaluationId
      sessionType
      status
      sysId
    }
    consultationMessages(limit: $limit8, offset: $offset8, order: $order7) {
      count
      limit
      offset
    }
    consultationTitle {
      createdAt
      createdBy
      remark
      sysId
      translationKey
      updatedAt
      updatedBy
      valueEn
      valueJa
      valueZh
    }
    countReminder
    createdAt
    doctor {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    doctorChatToken
    doctorSysId
    friendlyName
    gmeetLink
    isActive
    isRead
    isVideoConsultRescheduled
    lastMsgSysId
    lastMsgUserId
    messages {
      consultationSysId
      content
      createdAt
      readAt
      sysId
      updatedAt
    }
    order {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    orderSysId
    participants {
      avatar
      fullName
      identity
      locale
      role
      token
      userSysId
    }
    participantsV2 {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      phoneNumber
      requireConfirmPolicy
      socialProviderType
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    patientChatToken
    patientEmail
    prescribedAt
    previewVideoLink
    progressStatus
    readAt
    reviewDate
    status
    sysId
    textConsultStatus
    textConversationId
    type
    updatedAt
    videoChannelId
    videoLink
  }
}
    `;
export const useBookHumansaConsultationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BookHumansaConsultationMutation, TError, BookHumansaConsultationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BookHumansaConsultationMutation, TError, BookHumansaConsultationMutationVariables, TContext>(
      ['bookHumansaConsultation'],
      (variables?: BookHumansaConsultationMutationVariables) => fetcher<BookHumansaConsultationMutation, BookHumansaConsultationMutationVariables>(client, BookHumansaConsultationDocument, variables, headers)(),
      options
    );
export const BookPrescriptionReviewAppointmentDocument = `
    mutation bookPrescriptionReviewAppointment($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: BookPrescriptionReviewAppointmentInput!) {
  bookPrescriptionReviewAppointment(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useBookPrescriptionReviewAppointmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BookPrescriptionReviewAppointmentMutation, TError, BookPrescriptionReviewAppointmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BookPrescriptionReviewAppointmentMutation, TError, BookPrescriptionReviewAppointmentMutationVariables, TContext>(
      ['bookPrescriptionReviewAppointment'],
      (variables?: BookPrescriptionReviewAppointmentMutationVariables) => fetcher<BookPrescriptionReviewAppointmentMutation, BookPrescriptionReviewAppointmentMutationVariables>(client, BookPrescriptionReviewAppointmentDocument, variables, headers)(),
      options
    );
export const BulkUpdateShipmentDocument = `
    mutation bulkUpdateShipment($input: [UpdateOrderShipmentInput!]!) {
  bulkUpdateShipment(input: $input)
}
    `;
export const useBulkUpdateShipmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<BulkUpdateShipmentMutation, TError, BulkUpdateShipmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<BulkUpdateShipmentMutation, TError, BulkUpdateShipmentMutationVariables, TContext>(
      ['bulkUpdateShipment'],
      (variables?: BulkUpdateShipmentMutationVariables) => fetcher<BulkUpdateShipmentMutation, BulkUpdateShipmentMutationVariables>(client, BulkUpdateShipmentDocument, variables, headers)(),
      options
    );
export const CalculateCartDocument = `
    mutation calculateCart($input: CalculateOrderInput!) {
  calculateCart(input: $input) {
    cashbackEarnRate
    cashbackEarned
    cashbackRedeemed
    discountAmountLater
    discountAmountNow
    itemList {
      consultationSessionType
      isEDBundle
      isPayNow
      isRxProduct
      isSkipMedSelecting
      isSubscriptionPrice
      isSubscriptionUpdate
      itemSubTotal
      itemSubTotalAfterDiscount
      mainProductId
      mainProductName
      name
      priceId
      priceType
      productId
      productUniqName
      quantity
      unit_amount
    }
    minimalAmountPayment
    paymentIntentAmount
    paymentIntentAmountBeforeTax
    paymentIntentSummary
    promotionCode
    shippingFee
    subTotal
    subTotalLater
    subTotalNow
    taxes
    taxesLater
    taxesNow
    teleConsultFee
    total
    totalLater
    totalNow
    totalNowAfterCashback
    totalTaxes
  }
}
    `;
export const useCalculateCartMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CalculateCartMutation, TError, CalculateCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CalculateCartMutation, TError, CalculateCartMutationVariables, TContext>(
      ['calculateCart'],
      (variables?: CalculateCartMutationVariables) => fetcher<CalculateCartMutation, CalculateCartMutationVariables>(client, CalculateCartDocument, variables, headers)(),
      options
    );
export const CancelAppointmentDocument = `
    mutation cancelAppointment($input: CancelAppointmentInput!) {
  cancelAppointment(input: $input)
}
    `;
export const useCancelAppointmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelAppointmentMutation, TError, CancelAppointmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelAppointmentMutation, TError, CancelAppointmentMutationVariables, TContext>(
      ['cancelAppointment'],
      (variables?: CancelAppointmentMutationVariables) => fetcher<CancelAppointmentMutation, CancelAppointmentMutationVariables>(client, CancelAppointmentDocument, variables, headers)(),
      options
    );
export const CancelCheckInDocument = `
    mutation cancelCheckIn($cancelCheckInInput: MarkNoShowInput!) {
  cancelCheckIn(cancelCheckInInput: $cancelCheckInInput)
}
    `;
export const useCancelCheckInMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelCheckInMutation, TError, CancelCheckInMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelCheckInMutation, TError, CancelCheckInMutationVariables, TContext>(
      ['cancelCheckIn'],
      (variables?: CancelCheckInMutationVariables) => fetcher<CancelCheckInMutation, CancelCheckInMutationVariables>(client, CancelCheckInDocument, variables, headers)(),
      options
    );
export const CancelMounjaroTrialDocument = `
    mutation cancelMounjaroTrial($reason: String!, $trialFunnelSysId: String!) {
  cancelMounjaroTrial(reason: $reason, trialFunnelSysId: $trialFunnelSysId)
}
    `;
export const useCancelMounjaroTrialMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelMounjaroTrialMutation, TError, CancelMounjaroTrialMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelMounjaroTrialMutation, TError, CancelMounjaroTrialMutationVariables, TContext>(
      ['cancelMounjaroTrial'],
      (variables?: CancelMounjaroTrialMutationVariables) => fetcher<CancelMounjaroTrialMutation, CancelMounjaroTrialMutationVariables>(client, CancelMounjaroTrialDocument, variables, headers)(),
      options
    );
export const CancelOrderDocument = `
    mutation cancelOrder($input: CancelOrderInput!) {
  cancelOrder(input: $input)
}
    `;
export const useCancelOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelOrderMutation, TError, CancelOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelOrderMutation, TError, CancelOrderMutationVariables, TContext>(
      ['cancelOrder'],
      (variables?: CancelOrderMutationVariables) => fetcher<CancelOrderMutation, CancelOrderMutationVariables>(client, CancelOrderDocument, variables, headers)(),
      options
    );
export const CancelPaymentIntentDocument = `
    mutation cancelPaymentIntent($id: String!) {
  cancelPaymentIntent(id: $id)
}
    `;
export const useCancelPaymentIntentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelPaymentIntentMutation, TError, CancelPaymentIntentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelPaymentIntentMutation, TError, CancelPaymentIntentMutationVariables, TContext>(
      ['cancelPaymentIntent'],
      (variables?: CancelPaymentIntentMutationVariables) => fetcher<CancelPaymentIntentMutation, CancelPaymentIntentMutationVariables>(client, CancelPaymentIntentDocument, variables, headers)(),
      options
    );
export const CancelSubscriptionDocument = `
    mutation cancelSubscription($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $cancelSubscriptionInput: V2CancelSubscriptionInput!) {
  cancelSubscription(cancelSubscriptionInput: $cancelSubscriptionInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useCancelSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelSubscriptionMutation, TError, CancelSubscriptionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelSubscriptionMutation, TError, CancelSubscriptionMutationVariables, TContext>(
      ['cancelSubscription'],
      (variables?: CancelSubscriptionMutationVariables) => fetcher<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(client, CancelSubscriptionDocument, variables, headers)(),
      options
    );
export const CancelSubscriptionByOrderIdDocument = `
    mutation cancelSubscriptionByOrderId($input: CancelSubscriptionByOrderIdInput!) {
  cancelSubscriptionByOrderId(input: $input) {
    status
  }
}
    `;
export const useCancelSubscriptionByOrderIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelSubscriptionByOrderIdMutation, TError, CancelSubscriptionByOrderIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelSubscriptionByOrderIdMutation, TError, CancelSubscriptionByOrderIdMutationVariables, TContext>(
      ['cancelSubscriptionByOrderId'],
      (variables?: CancelSubscriptionByOrderIdMutationVariables) => fetcher<CancelSubscriptionByOrderIdMutation, CancelSubscriptionByOrderIdMutationVariables>(client, CancelSubscriptionByOrderIdDocument, variables, headers)(),
      options
    );
export const ChangeAutoRenewalModeDocument = `
    mutation changeAutoRenewalMode($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: ChangeAutoRenewalModeInput!) {
  changeAutoRenewalMode(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useChangeAutoRenewalModeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeAutoRenewalModeMutation, TError, ChangeAutoRenewalModeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeAutoRenewalModeMutation, TError, ChangeAutoRenewalModeMutationVariables, TContext>(
      ['changeAutoRenewalMode'],
      (variables?: ChangeAutoRenewalModeMutationVariables) => fetcher<ChangeAutoRenewalModeMutation, ChangeAutoRenewalModeMutationVariables>(client, ChangeAutoRenewalModeDocument, variables, headers)(),
      options
    );
export const ChangeDeliveryStatusDocument = `
    mutation changeDeliveryStatus($input: ChangeDeliveryStatusInput!) {
  changeDeliveryStatus(input: $input)
}
    `;
export const useChangeDeliveryStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeDeliveryStatusMutation, TError, ChangeDeliveryStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeDeliveryStatusMutation, TError, ChangeDeliveryStatusMutationVariables, TContext>(
      ['changeDeliveryStatus'],
      (variables?: ChangeDeliveryStatusMutationVariables) => fetcher<ChangeDeliveryStatusMutation, ChangeDeliveryStatusMutationVariables>(client, ChangeDeliveryStatusDocument, variables, headers)(),
      options
    );
export const ChangeDeliveryWindowDocument = `
    mutation changeDeliveryWindow($input: ChangeDeliveryWindowInput!) {
  changeDeliveryWindow(input: $input)
}
    `;
export const useChangeDeliveryWindowMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeDeliveryWindowMutation, TError, ChangeDeliveryWindowMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeDeliveryWindowMutation, TError, ChangeDeliveryWindowMutationVariables, TContext>(
      ['changeDeliveryWindow'],
      (variables?: ChangeDeliveryWindowMutationVariables) => fetcher<ChangeDeliveryWindowMutation, ChangeDeliveryWindowMutationVariables>(client, ChangeDeliveryWindowDocument, variables, headers)(),
      options
    );
export const ChangeDeliveryWindowV2Document = `
    mutation changeDeliveryWindowV2($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $changeDeliveryWindow: V2ChangeDeliveryWindowInput!) {
  changeDeliveryWindowV2(changeDeliveryWindow: $changeDeliveryWindow) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useChangeDeliveryWindowV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeDeliveryWindowV2Mutation, TError, ChangeDeliveryWindowV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeDeliveryWindowV2Mutation, TError, ChangeDeliveryWindowV2MutationVariables, TContext>(
      ['changeDeliveryWindowV2'],
      (variables?: ChangeDeliveryWindowV2MutationVariables) => fetcher<ChangeDeliveryWindowV2Mutation, ChangeDeliveryWindowV2MutationVariables>(client, ChangeDeliveryWindowV2Document, variables, headers)(),
      options
    );
export const ChangeNewPriceOrderDocument = `
    mutation changeNewPriceOrder($input: ChangeNewPriceOrderInput!) {
  changeNewPriceOrder(input: $input) {
    oldStripePrescriptionId
    orderPrescriptionPriceId
  }
}
    `;
export const useChangeNewPriceOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeNewPriceOrderMutation, TError, ChangeNewPriceOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeNewPriceOrderMutation, TError, ChangeNewPriceOrderMutationVariables, TContext>(
      ['changeNewPriceOrder'],
      (variables?: ChangeNewPriceOrderMutationVariables) => fetcher<ChangeNewPriceOrderMutation, ChangeNewPriceOrderMutationVariables>(client, ChangeNewPriceOrderDocument, variables, headers)(),
      options
    );
export const ChangeOrderRenewalDateDocument = `
    mutation changeOrderRenewalDate($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $changeRenewalDateInput: ChangeRenewalDateInput!) {
  changeOrderRenewalDate(changeRenewalDateInput: $changeRenewalDateInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useChangeOrderRenewalDateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeOrderRenewalDateMutation, TError, ChangeOrderRenewalDateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeOrderRenewalDateMutation, TError, ChangeOrderRenewalDateMutationVariables, TContext>(
      ['changeOrderRenewalDate'],
      (variables?: ChangeOrderRenewalDateMutationVariables) => fetcher<ChangeOrderRenewalDateMutation, ChangeOrderRenewalDateMutationVariables>(client, ChangeOrderRenewalDateDocument, variables, headers)(),
      options
    );
export const ChangePasswordDocument = `
    mutation changePassword($input: ChangePasswordInput!) {
  changePassword(input: $input)
}
    `;
export const useChangePasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>(
      ['changePassword'],
      (variables?: ChangePasswordMutationVariables) => fetcher<ChangePasswordMutation, ChangePasswordMutationVariables>(client, ChangePasswordDocument, variables, headers)(),
      options
    );
export const ChangePrescriptionPriceDocument = `
    mutation changePrescriptionPrice($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $changePrescriptionPriceInput: V2ChangeOrderPrice!) {
  changePrescriptionPrice(
    changePrescriptionPriceInput: $changePrescriptionPriceInput
  ) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useChangePrescriptionPriceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangePrescriptionPriceMutation, TError, ChangePrescriptionPriceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangePrescriptionPriceMutation, TError, ChangePrescriptionPriceMutationVariables, TContext>(
      ['changePrescriptionPrice'],
      (variables?: ChangePrescriptionPriceMutationVariables) => fetcher<ChangePrescriptionPriceMutation, ChangePrescriptionPriceMutationVariables>(client, ChangePrescriptionPriceDocument, variables, headers)(),
      options
    );
export const ChangePriceKonbiniOrderDocument = `
    mutation changePriceKonbiniOrder($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: V2ChangePriceKonbiniOrderInput!) {
  changePriceKonbiniOrder(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useChangePriceKonbiniOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangePriceKonbiniOrderMutation, TError, ChangePriceKonbiniOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangePriceKonbiniOrderMutation, TError, ChangePriceKonbiniOrderMutationVariables, TContext>(
      ['changePriceKonbiniOrder'],
      (variables?: ChangePriceKonbiniOrderMutationVariables) => fetcher<ChangePriceKonbiniOrderMutation, ChangePriceKonbiniOrderMutationVariables>(client, ChangePriceKonbiniOrderDocument, variables, headers)(),
      options
    );
export const ChangeRoInOpsDocument = `
    mutation changeROInOps($input: ChangeROInOpsInput!) {
  changeROInOps(input: $input)
}
    `;
export const useChangeRoInOpsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeRoInOpsMutation, TError, ChangeRoInOpsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeRoInOpsMutation, TError, ChangeRoInOpsMutationVariables, TContext>(
      ['changeROInOps'],
      (variables?: ChangeRoInOpsMutationVariables) => fetcher<ChangeRoInOpsMutation, ChangeRoInOpsMutationVariables>(client, ChangeRoInOpsDocument, variables, headers)(),
      options
    );
export const ChargeConsultFeeKonbiniOrderDocument = `
    mutation chargeConsultFeeKonbiniOrder($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: V2ChargeConsultFeeKonbiniOrder!) {
  chargeConsultFeeKonbiniOrder(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useChargeConsultFeeKonbiniOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChargeConsultFeeKonbiniOrderMutation, TError, ChargeConsultFeeKonbiniOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChargeConsultFeeKonbiniOrderMutation, TError, ChargeConsultFeeKonbiniOrderMutationVariables, TContext>(
      ['chargeConsultFeeKonbiniOrder'],
      (variables?: ChargeConsultFeeKonbiniOrderMutationVariables) => fetcher<ChargeConsultFeeKonbiniOrderMutation, ChargeConsultFeeKonbiniOrderMutationVariables>(client, ChargeConsultFeeKonbiniOrderDocument, variables, headers)(),
      options
    );
export const CheckAvailableSupportCodDocument = `
    mutation checkAvailableSupportCod($input: V2CheckAvailableSupportCod!) {
  checkAvailableSupportCod(input: $input) {
    support
  }
}
    `;
export const useCheckAvailableSupportCodMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CheckAvailableSupportCodMutation, TError, CheckAvailableSupportCodMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CheckAvailableSupportCodMutation, TError, CheckAvailableSupportCodMutationVariables, TContext>(
      ['checkAvailableSupportCod'],
      (variables?: CheckAvailableSupportCodMutationVariables) => fetcher<CheckAvailableSupportCodMutation, CheckAvailableSupportCodMutationVariables>(client, CheckAvailableSupportCodDocument, variables, headers)(),
      options
    );
export const CheckValidAtomePaymentLinkDocument = `
    mutation checkValidAtomePaymentLink($checkAtomeInput: CheckValidAtomePaymentLinkInput!) {
  checkValidAtomePaymentLink(checkAtomeInput: $checkAtomeInput) {
    amount
    paymentUrl
    priceId
    referenceId
    status
    summary {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    sysId
  }
}
    `;
export const useCheckValidAtomePaymentLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CheckValidAtomePaymentLinkMutation, TError, CheckValidAtomePaymentLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CheckValidAtomePaymentLinkMutation, TError, CheckValidAtomePaymentLinkMutationVariables, TContext>(
      ['checkValidAtomePaymentLink'],
      (variables?: CheckValidAtomePaymentLinkMutationVariables) => fetcher<CheckValidAtomePaymentLinkMutation, CheckValidAtomePaymentLinkMutationVariables>(client, CheckValidAtomePaymentLinkDocument, variables, headers)(),
      options
    );
export const CheckoutAnonymousDocument = `
    mutation checkoutAnonymous($input: CheckoutAnonymousInput!) {
  checkoutAnonymous(input: $input) {
    orderSysId
    patientSysId
    success
    totalAfterCashback
  }
}
    `;
export const useCheckoutAnonymousMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CheckoutAnonymousMutation, TError, CheckoutAnonymousMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CheckoutAnonymousMutation, TError, CheckoutAnonymousMutationVariables, TContext>(
      ['checkoutAnonymous'],
      (variables?: CheckoutAnonymousMutationVariables) => fetcher<CheckoutAnonymousMutation, CheckoutAnonymousMutationVariables>(client, CheckoutAnonymousDocument, variables, headers)(),
      options
    );
export const CheckoutCartDocument = `
    mutation checkoutCart($input: CheckoutCartInput!) {
  checkoutCart(input: $input) {
    cartId
    orderIds
    totalAfterCashback
  }
}
    `;
export const useCheckoutCartMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CheckoutCartMutation, TError, CheckoutCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CheckoutCartMutation, TError, CheckoutCartMutationVariables, TContext>(
      ['checkoutCart'],
      (variables?: CheckoutCartMutationVariables) => fetcher<CheckoutCartMutation, CheckoutCartMutationVariables>(client, CheckoutCartDocument, variables, headers)(),
      options
    );
export const CheckoutViaReceptionistDocument = `
    mutation checkoutViaReceptionist($id: String, $platform: String, $platform1: String, $platform2: String, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform9: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform10: String, $id1: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id2: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform11: String, $platform12: String, $platform13: String, $platform14: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform15: String, $videoLink1: String!, $patientId: String, $input4: CrossSellRecordQueryInput, $orderId: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId1: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId2: String, $limit2: Int, $offset2: Int, $order1: JSON, $acuityAppointmentId2: String, $date2: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date3: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $input5: V2ConsultationFilterInput!, $input6: ConsultationMessagesInput!, $limit3: Int, $offset3: Int, $order2: JSON, $input7: ConsultationListInput!, $limit4: Int, $offset4: Int, $order3: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input8: OrderInput!, $pagination: V2PaginationInput!, $date4: String, $date5: Float, $input9: GetPatientInput, $platform16: String, $input10: StripeProductFilterV2, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit5: Int, $offset5: Int, $order4: JSON, $input13: ConsultationListInput!, $limit6: Int, $offset6: Int, $order5: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform17: String, $input16: StripeProductFilterV2, $doctorFilterInput3: V2DoctorInputFilter, $limit7: Int, $offset7: Int, $order6: JSON, $checkoutSessionFilterOptions1: CheckoutSessionFilterInput, $inputConsultation5: V2ConsultationFilterInput, $input17: GetPatientDocumentInput!, $evalFilter1: V2PatientEvaluationFilterInput, $id3: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform18: String, $inputOrder2: V2OrderFilterInput, $orderPagination2: V2PaginationInput, $input18: PrescriptionCalculationInput, $platform19: String, $platform20: String, $filter1: ShopProductFilterInputV2, $limit8: Float, $offset8: Float, $sort1: ShopProductSortInputV2, $input19: GetSmartMatchMetaInput!, $input20: PatientGetSurveyInput, $videoLink3: String!, $previewVideoLink1: String!, $input21: V2PresCheckoutViaReceptionistInput) {
  checkoutViaReceptionist(input: $input21) {
    atomePayment(id: $id) {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    bypassLoginTokens {
      expiresAt
      pageName
      token
      type
    }
    cart {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      cartItems {
        cart {
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          orderSummary {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            discountAmountLater
            discountAmountNow
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountBeforeTax
            paymentIntentSummary
            promotionCode
            shippingFee
            subTotal
            subTotalLater
            subTotalNow
            taxes
            taxesLater
            taxesNow
            teleConsultFee
            total
            totalLater
            totalNow
            totalNowAfterCashback
            totalTaxes
          }
          paidCompletedEvaluationIds
          platform
          promotionCode
          status
          sysId
        }
        completedEval
        consultationSessionType
        isAutoRenewal
        isSkipMedSelecting
        isSubscriptionPrice
        orderId
        patientNote
        price {
          active
          alternativePrice {
            active
            alternativePrice {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                drDosageFrequency {
                  alternativeDosage
                  alternativeDosageUnit
                  asNeeded
                  dosage
                  dosageUnit
                  duration
                  durationUnit
                  frequency
                  productId
                  quantity
                  quantityUnit
                }
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredients
                  isConsultOnly(platform: $platform1)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                ingredientDetails {
                  description
                  imageLink
                  locale
                  name
                  strength
                  uniqueName
                }
                ingredients
                isConsultOnly(platform: $platform2)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                prices {
                  active
                  alternativePrice {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform3)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          metadata {
            actual_price_display
            boxes
            dosage
            dosage_display
            dosage_popular
            frequency
            frequency_actual_price_display
            frequency_display
            frequency_popular
            frequency_price_display
            frequency_quantity_display
            frequency_quantity_display_patient
            frequency_savings_display
            frequency_strikeout_price_display
            isArchived
            isOneTimePrice
            price_frequency
            price_quantity
            price_show
            quantity
            quantity_display
            strength
          }
          nickname
          product
          productId
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform4)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          shopDisplay
          sysId
          tax_behavior
          texts {
            actual_price_display
            dosage
            dosage_display
            dosage_popular
            frequency
            frequency_actual_price_display
            frequency_display
            frequency_popular
            frequency_price_display
            frequency_quantity_display
            frequency_quantity_display_patient
            frequency_savings_display
            frequency_strikeout_price_display
            price_frequency
            price_quantity
            quantity
            quantity_display
          }
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        product {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform5)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredientDetails {
            description
            imageLink
            locale
            name
            strength
            uniqueName
          }
          ingredients
          isConsultOnly(platform: $platform6)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          prices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInstructions {
            language
            localeKey
            productId
            sysId
            translatedText
          }
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          tempPrices {
            active
            alternativePrice {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            metadata {
              actual_price_display
              boxes
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              isArchived
              isOneTimePrice
              price_frequency
              price_quantity
              price_show
              quantity
              quantity_display
              strength
            }
            nickname
            product
            productId
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform7)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            shopDisplay
            sysId
            tax_behavior
            texts {
              actual_price_display
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              price_frequency
              price_quantity
              quantity
              quantity_display
            }
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          texts {
            benefits
            category
            display_price
            display_price_patient
            dosage_variant_body
            dosage_variant_title
            effective_in
            for
            frequency_variant_title
            good_to_know
            how_to_take
            how_to_use
            is_popular
            lasts_for
            platform
            product_description
            product_name
            product_short_description
            quantity_per_unit
            quantity_variant_title
            requires_prescription
            safety_information
            side_effects
            strength
            taken
            unit
            unit_patient
          }
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        quantity
        teleConsultForSkipEval
        type
      }
      paidCompletedEvaluationIds
      platform
      promotionCode
      status
      sysId
    }
    cashback {
      availableBalance
      recentTransactions {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
      savingsToDateThisYear {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
    }
    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions1) {
      checkoutData
      evaluationId
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          consultationAudit {
            consultTime
            consultType
            createdBy
            doctor {
              active
              bio {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              calendarId
              consultation(videoLink: $videoLink1) {
                gmeetLink
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id1) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform13)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform14)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform15)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                previewToken
                previewVideoLink
                status
                sysId
                token
                videoChannelId
                videoLink
                zoomJoinUrl
              }
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              patient(patientId: $patientId) {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sysId
              textConsultPostalCodes
              trtEligible
              user {
                admin {
                  crossSellRecords(input: $input4) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId
                  date: $date
                  forDelivery: $forDelivery
                  isReschedule: $isReschedule
                  orderId: $orderId1
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId1
                  consultDate: $consultDate
                  date: $date1
                  forDelivery: $forDelivery1
                  isReschedule: $isReschedule1
                  orderId: $orderId2
                ) {
                  time
                }
                consultation(input: $input11) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit2, offset: $offset2, order: $order1) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId2
                      date: $date2
                      forDelivery: $forDelivery2
                      isReschedule: $isReschedule2
                      orderId: $orderId3
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId3
                      consultDate: $consultDate1
                      date: $date3
                      forDelivery: $forDelivery3
                      isReschedule: $isReschedule3
                      orderId: $orderId4
                    ) {
                      time
                    }
                    consultation(input: $input5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input6
                      limit: $limit3
                      offset: $offset3
                      order: $order2
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input7, limit: $limit4, offset: $offset4, order: $order3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input8, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date4) {
                      date
                    }
                    partnerConsultTimes(date: $date5) {
                      time
                    }
                    patient(input: $input9) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input10) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform16)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input12
                  limit: $limit5
                  offset: $offset5
                  order: $order4
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input13, limit: $limit6, offset: $offset6, order: $order5) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input14, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input15) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input16) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            evaluationId
            sessionType
            status
            sysId
          }
          consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
            count
            limit
            offset
          }
          consultationTitle {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          countReminder
          createdAt
          doctor {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          messages {
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
          }
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          orderSysId
          participants {
            avatar
            fullName
            identity
            locale
            role
            token
            userSysId
          }
          participantsV2 {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            phoneNumber
            requireConfirmPolicy
            socialProviderType
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation5) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    document(input: $input17) {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    documents {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    email
    evaluations(evalFilter: $evalFilter1) {
      isCompleted
      isSkipped
      name
      patientAnswers {
        answer {
          childrenAnswers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        question {
          answers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          content {
            body {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            footer {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            header {
              description
              descriptionTextKey
              title
              titleTextKey
            }
          }
          dependentEvaluationQuestions {
            answer {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            skipPage
            skipQuestionCount
            sysId
          }
          displayPage
          evaluationBlocks {
            blockAnswer {
              childrenAnswers {
                deselectAll
                mandatory
                name
                order
                placeholder
                productUrl
                sysId
                textKey
                type
              }
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            content {
              description
              descriptionTextKey
              sysId
              title
              titleTextKey
            }
            sysId
          }
          guestOnly
          name
          order
          sysId
          textKey
          type
          validation {
            bmi
            extra
            max
            min
            preselect
            type
          }
        }
        type
        value
      }
      patientNote
      platform
      questions {
        answers {
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        dependentEvaluationQuestions {
          skipPage
          skipQuestionCount
          sysId
        }
        displayPage
        evaluationBlocks {
          sysId
        }
        guestOnly
        name
        order
        sysId
        textKey
        type
        validation {
          bmi
          extra
          max
          min
          preselect
          type
        }
      }
      status
      sysId
      type
    }
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    idVerifiedAt
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    latestPaymentMethod {
      card {
        brand
        exp_month
        exp_year
        last4
      }
      id
    }
    legalName
    locale
    mounjaroTrialEligible
    order(id: $id3) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    orders(inputOrder: $inputOrder2, orderPagination: $orderPagination2) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      activeConsultation {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      acuityAppointment {
        appointmentTypeID
        bookedAt
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        bookedAt
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      additionalPrices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      afterVideoConsultRedirecting {
        baseUrl
        path
      }
      approveAt
      atomeNextSendingInvoiceDate
      atomePayments {
        amount
        paymentUrl
        priceId
        referenceId
        status
        sysId
      }
      checkoutSession {
        checkoutData
        evaluationId
        status
        sysId
      }
      childrenOrders {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      claimedRetentionOffer
      consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
        consultTime
        consultType
        createdBy
        evaluationId
        sessionType
        status
        sysId
      }
      consultations(inputConsultation: $inputConsultation6) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluation {
        isCompleted
        isSkipped
        name
        patientNote
        platform
        status
        sysId
        type
      }
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      latestAtomePayment {
        amount
        paymentUrl
        priceId
        referenceId
        status
        sysId
      }
      latestInvoice {
        amount_due
        hosted_invoice_url
        id
        next_payment_attempt
        paid
        paymentStatus
        period_end
        starting_balance
        status
        subtotal
        tax
        total
      }
      latestNote {
        content
        createdAt
        createdBy
        sysId
        updatedAt
      }
      nextReviewDate
      oldPrice
      oldPriceInfo {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescribed_after_trial_order_sys_id
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      price {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      priceDisplayId
      priceInfo {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        ingredients
        isConsultOnly(platform: $platform18)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      siblingCrossSellOrders {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      status
      stripePaymentIntentId
      stripeSubscriptionId
      subscription {
        cancel_at_period_end
        current_period_end
        current_period_start
        default_payment_method
        id
        items
        latest_invoice
        metadata
        pause_collection
        pending_setup_intent
        pending_update
        status
      }
      sysId
      teleConsultProduct
      upcomingInvoice {
        amount_due
        hosted_invoice_url
        id
        next_payment_attempt
        paid
        paymentStatus
        period_end
        starting_balance
        status
        subtotal
        tax
        total
      }
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    prescriptionCalculation(input: $input18) {
      affiliateCouponNotApplied {
        affiliateProductDisplayName
        reason
      }
      isAffiliateLocked
      otcCalculationSummary {
        otcOrdersCalculation {
          basePrice
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          discountAmount
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          stripePromotionCode
          tax
          transactionFee
        }
        totalBasePrice
        totalCashbackEarned
        totalCashbackRedeemed
        totalPaymentIntentAmount
        totalTax
        totalTransactionFee
      }
      promotionCodeError
      rxCalculationSummary {
        rxOrdersCalculation {
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          consultBasePrice
          consultFee
          consultFeeAfterDiscount
          consultTax
          consultTransactionFee
          discountAmount
          isConsult
          mainBasePrice
          mainTax
          mainTransactionFee
          minimalAmountPayment
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          shouldChargeConsultFee
          subTotal
          total
          totalAfterCashback
        }
        total
        totalCashbackEarned
        totalCashbackRedeemed
        totalDiscountAmount
        totalMainBasePrice
        totalPaymentIntentAmount
        totalPaymentIntentAmountAfterCashback
        totalTax
        totalTransactionFee
      }
      stripePromotionCode
    }
    referralCode
    referrals {
      doctor {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      doctorId
      documents {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      items {
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        orderId
        price {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        priceId
        referralSysId
        sysId
      }
      sysId
    }
    shopProducts(filter: $filter1, limit: $limit8, offset: $offset8, sort: $sort1) {
      count
      items {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform19)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform20)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      limit
      offset
    }
    smartMatchMeta(input: $input19) {
      evalId
      status
      sysId
      userId
      userType
    }
    stripeCustomer
    stripeCustomerId
    survey(input: $input20) {
      answers
      isSkipped
      patientSysId
      sysId
      type
    }
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      phoneNumber
      requireConfirmPolicy
      socialProviderType
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    userSysId
    videoConsultation(videoLink: $videoLink3) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
    videoConsultationPreview(previewVideoLink: $previewVideoLink1) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
    weight
  }
}
    `;
export const useCheckoutViaReceptionistMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CheckoutViaReceptionistMutation, TError, CheckoutViaReceptionistMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CheckoutViaReceptionistMutation, TError, CheckoutViaReceptionistMutationVariables, TContext>(
      ['checkoutViaReceptionist'],
      (variables?: CheckoutViaReceptionistMutationVariables) => fetcher<CheckoutViaReceptionistMutation, CheckoutViaReceptionistMutationVariables>(client, CheckoutViaReceptionistDocument, variables, headers)(),
      options
    );
export const ClaimSubscriptionRetentionDocument = `
    mutation claimSubscriptionRetention($input: V2ClaimSubscriptionRetentionInput!) {
  claimSubscriptionRetention(input: $input)
}
    `;
export const useClaimSubscriptionRetentionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ClaimSubscriptionRetentionMutation, TError, ClaimSubscriptionRetentionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ClaimSubscriptionRetentionMutation, TError, ClaimSubscriptionRetentionMutationVariables, TContext>(
      ['claimSubscriptionRetention'],
      (variables?: ClaimSubscriptionRetentionMutationVariables) => fetcher<ClaimSubscriptionRetentionMutation, ClaimSubscriptionRetentionMutationVariables>(client, ClaimSubscriptionRetentionDocument, variables, headers)(),
      options
    );
export const CleanMissingPatientPaidEvalIdsDocument = `
    mutation cleanMissingPatientPaidEvalIds {
  cleanMissingPatientPaidEvalIds
}
    `;
export const useCleanMissingPatientPaidEvalIdsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CleanMissingPatientPaidEvalIdsMutation, TError, CleanMissingPatientPaidEvalIdsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CleanMissingPatientPaidEvalIdsMutation, TError, CleanMissingPatientPaidEvalIdsMutationVariables, TContext>(
      ['cleanMissingPatientPaidEvalIds'],
      (variables?: CleanMissingPatientPaidEvalIdsMutationVariables) => fetcher<CleanMissingPatientPaidEvalIdsMutation, CleanMissingPatientPaidEvalIdsMutationVariables>(client, CleanMissingPatientPaidEvalIdsDocument, variables, headers)(),
      options
    );
export const CompleteFollowUpConsultDocument = `
    mutation completeFollowUpConsult($input: TriggerFollowUpConsultInput!) {
  completeFollowUpConsult(input: $input)
}
    `;
export const useCompleteFollowUpConsultMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CompleteFollowUpConsultMutation, TError, CompleteFollowUpConsultMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CompleteFollowUpConsultMutation, TError, CompleteFollowUpConsultMutationVariables, TContext>(
      ['completeFollowUpConsult'],
      (variables?: CompleteFollowUpConsultMutationVariables) => fetcher<CompleteFollowUpConsultMutation, CompleteFollowUpConsultMutationVariables>(client, CompleteFollowUpConsultDocument, variables, headers)(),
      options
    );
export const ConfirmAtomeOrderDocument = `
    mutation confirmAtomeOrder($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: V2ConfirmAtomePaymentInput!) {
  confirmAtomeOrder(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useConfirmAtomeOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmAtomeOrderMutation, TError, ConfirmAtomeOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmAtomeOrderMutation, TError, ConfirmAtomeOrderMutationVariables, TContext>(
      ['confirmAtomeOrder'],
      (variables?: ConfirmAtomeOrderMutationVariables) => fetcher<ConfirmAtomeOrderMutation, ConfirmAtomeOrderMutationVariables>(client, ConfirmAtomeOrderDocument, variables, headers)(),
      options
    );
export const ConfirmBloodDrawDocument = `
    mutation confirmBloodDraw($input: ConfirmBloodDrawInput!) {
  confirmBloodDraw(input: $input) {
    confirmedAt
    drawType
    orderSysId
    sysId
  }
}
    `;
export const useConfirmBloodDrawMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmBloodDrawMutation, TError, ConfirmBloodDrawMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmBloodDrawMutation, TError, ConfirmBloodDrawMutationVariables, TContext>(
      ['confirmBloodDraw'],
      (variables?: ConfirmBloodDrawMutationVariables) => fetcher<ConfirmBloodDrawMutation, ConfirmBloodDrawMutationVariables>(client, ConfirmBloodDrawDocument, variables, headers)(),
      options
    );
export const ConfirmChangePrescriptionDocument = `
    mutation confirmChangePrescription($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $confirmPrescriptionInput: V2ConfirmChangePrescriptionInput!) {
  confirmChangePrescription(confirmPrescriptionInput: $confirmPrescriptionInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useConfirmChangePrescriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmChangePrescriptionMutation, TError, ConfirmChangePrescriptionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmChangePrescriptionMutation, TError, ConfirmChangePrescriptionMutationVariables, TContext>(
      ['confirmChangePrescription'],
      (variables?: ConfirmChangePrescriptionMutationVariables) => fetcher<ConfirmChangePrescriptionMutation, ConfirmChangePrescriptionMutationVariables>(client, ConfirmChangePrescriptionDocument, variables, headers)(),
      options
    );
export const ConfirmChargeCovidPrescriptionOrderDocument = `
    mutation confirmChargeCovidPrescriptionOrder($input: CovidOrderInput!) {
  confirmChargeCovidPrescriptionOrder(input: $input)
}
    `;
export const useConfirmChargeCovidPrescriptionOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmChargeCovidPrescriptionOrderMutation, TError, ConfirmChargeCovidPrescriptionOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmChargeCovidPrescriptionOrderMutation, TError, ConfirmChargeCovidPrescriptionOrderMutationVariables, TContext>(
      ['confirmChargeCovidPrescriptionOrder'],
      (variables?: ConfirmChargeCovidPrescriptionOrderMutationVariables) => fetcher<ConfirmChargeCovidPrescriptionOrderMutation, ConfirmChargeCovidPrescriptionOrderMutationVariables>(client, ConfirmChargeCovidPrescriptionOrderDocument, variables, headers)(),
      options
    );
export const ConfirmCodOrderDocument = `
    mutation confirmCodOrder($input: V2ConfirmCodOrderInput!) {
  confirmCodOrder(input: $input) {
    isSuccess
  }
}
    `;
export const useConfirmCodOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmCodOrderMutation, TError, ConfirmCodOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmCodOrderMutation, TError, ConfirmCodOrderMutationVariables, TContext>(
      ['confirmCodOrder'],
      (variables?: ConfirmCodOrderMutationVariables) => fetcher<ConfirmCodOrderMutation, ConfirmCodOrderMutationVariables>(client, ConfirmCodOrderDocument, variables, headers)(),
      options
    );
export const ConfirmCodOrder2Document = `
    mutation confirmCodOrder2($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $confirmCodOrderInput: V2ConfirmCodOrderInput!) {
  confirmCodOrder2(confirmCodOrderInput: $confirmCodOrderInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useConfirmCodOrder2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmCodOrder2Mutation, TError, ConfirmCodOrder2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmCodOrder2Mutation, TError, ConfirmCodOrder2MutationVariables, TContext>(
      ['confirmCodOrder2'],
      (variables?: ConfirmCodOrder2MutationVariables) => fetcher<ConfirmCodOrder2Mutation, ConfirmCodOrder2MutationVariables>(client, ConfirmCodOrder2Document, variables, headers)(),
      options
    );
export const ConfirmKonbiniOrderDocument = `
    mutation confirmKonbiniOrder($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: ConfirmKonbiniOrderInput!) {
  confirmKonbiniOrder(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useConfirmKonbiniOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmKonbiniOrderMutation, TError, ConfirmKonbiniOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmKonbiniOrderMutation, TError, ConfirmKonbiniOrderMutationVariables, TContext>(
      ['confirmKonbiniOrder'],
      (variables?: ConfirmKonbiniOrderMutationVariables) => fetcher<ConfirmKonbiniOrderMutation, ConfirmKonbiniOrderMutationVariables>(client, ConfirmKonbiniOrderDocument, variables, headers)(),
      options
    );
export const CreateAffiliateDocument = `
    mutation createAffiliate($input: CreateAffiliateInput!) {
  createAffiliate(input: $input) {
    createdAt
    enabled
    formFieldMap
    formSubmitUrl
    name
    notificationChannel
    notificationEmail
    portalUrl
    region
    slug
    sysId
    updatedAt
  }
}
    `;
export const useCreateAffiliateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAffiliateMutation, TError, CreateAffiliateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateAffiliateMutation, TError, CreateAffiliateMutationVariables, TContext>(
      ['createAffiliate'],
      (variables?: CreateAffiliateMutationVariables) => fetcher<CreateAffiliateMutation, CreateAffiliateMutationVariables>(client, CreateAffiliateDocument, variables, headers)(),
      options
    );
export const CreateAffiliateProductDocument = `
    mutation createAffiliateProduct($input: CreateAffiliateProductInput!) {
  createAffiliateProduct(input: $input) {
    affiliate {
      enabled
      name
      portalUrl
      region
      slug
      sysId
    }
    affiliateSysId
    couponLandingUrl
    createdAt
    discountPercentage
    displayName
    enabled
    evalFlow
    externalPortalUrl
    slug
    stripePriceId
    stripeProductId
    stripePromotionCode
    stripePromotionCodeId
    sysId
    unitAmount
    updatedAt
  }
}
    `;
export const useCreateAffiliateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAffiliateProductMutation, TError, CreateAffiliateProductMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateAffiliateProductMutation, TError, CreateAffiliateProductMutationVariables, TContext>(
      ['createAffiliateProduct'],
      (variables?: CreateAffiliateProductMutationVariables) => fetcher<CreateAffiliateProductMutation, CreateAffiliateProductMutationVariables>(client, CreateAffiliateProductDocument, variables, headers)(),
      options
    );
export const CreateAnonymousPatientDocument = `
    mutation createAnonymousPatient($input: SignupAnonymousPatientInput!) {
  createAnonymousPatient(input: $input) {
    stripeCustomerId
    success
    sysId
  }
}
    `;
export const useCreateAnonymousPatientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAnonymousPatientMutation, TError, CreateAnonymousPatientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateAnonymousPatientMutation, TError, CreateAnonymousPatientMutationVariables, TContext>(
      ['createAnonymousPatient'],
      (variables?: CreateAnonymousPatientMutationVariables) => fetcher<CreateAnonymousPatientMutation, CreateAnonymousPatientMutationVariables>(client, CreateAnonymousPatientDocument, variables, headers)(),
      options
    );
export const CreateAtomePaymentDocument = `
    mutation createAtomePayment($input: V2CreateAtomePaymentInput!) {
  createAtomePayment(input: $input) {
    amount
    paymentUrl
    priceId
    referenceId
    status
    summary {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    sysId
  }
}
    `;
export const useCreateAtomePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAtomePaymentMutation, TError, CreateAtomePaymentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateAtomePaymentMutation, TError, CreateAtomePaymentMutationVariables, TContext>(
      ['createAtomePayment'],
      (variables?: CreateAtomePaymentMutationVariables) => fetcher<CreateAtomePaymentMutation, CreateAtomePaymentMutationVariables>(client, CreateAtomePaymentDocument, variables, headers)(),
      options
    );
export const CreateCheckoutSessionDocument = `
    mutation createCheckoutSession($patientId: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $platform1: String, $platform2: String, $platform3: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform4: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit: Float, $offset: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $videoLink1: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform5: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit1: Int, $offset1: Int, $order: JSON, $input6: ConsultationListInput!, $limit2: Int, $offset2: Int, $order1: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform6: String, $input9: StripeProductFilterV2, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform7: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform8: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit3: Int, $offset3: Int, $order2: JSON, $input11: ConsultationMessagesInput!, $limit4: Int, $offset4: Int, $order3: JSON, $input12: ConsultationListInput!, $limit5: Int, $offset5: Int, $order4: JSON, $doctorFilterInput2: V2DoctorInputFilter, $doctorFilterInput3: V2DoctorInputFilter, $input13: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input14: GetPatientInput, $platform9: String, $input15: StripeProductFilterV2, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input16: V2ConsultationFilterInput!, $input17: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $limit7: Int, $offset7: Int, $order6: JSON, $input18: ConsultationListInput!, $limit8: Int, $offset8: Int, $order7: JSON, $doctorFilterInput4: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $doctorFilterInput5: V2DoctorInputFilter, $input19: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input20: GetPatientInput, $platform10: String, $platform11: String, $input21: StripeProductFilterV2, $input22: V2ConsultationFilterInput!, $limit9: Int, $offset9: Int, $order8: JSON, $createCheckoutSessionInput: CreateCheckoutSessionInput!) {
  createCheckoutSession(createCheckoutSessionInput: $createCheckoutSessionInput) {
    checkoutData
    evaluationId
    order {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      activeConsultation {
        consultationAudit {
          consultTime
          consultType
          createdBy
          doctor {
            active
            bio {
              createdAt
              createdBy
              remark
              sysId
              translationKey
              updatedAt
              updatedBy
              valueEn
              valueJa
              valueZh
            }
            calendarId
            consultation(videoLink: $videoLink1) {
              gmeetLink
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                acuityAppointment {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                additionalPrices {
                  active
                  alternativePrice {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform3)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                afterVideoConsultRedirecting {
                  baseUrl
                  path
                }
                approveAt
                atomeNextSendingInvoiceDate
                atomePayments {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  summary {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  sysId
                }
                checkoutSession {
                  checkoutData
                  evaluationId
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit, offset: $offset, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  status
                  sysId
                }
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              previewToken
              previewVideoLink
              status
              sysId
              token
              videoChannelId
              videoLink
              zoomJoinUrl
            }
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          evaluationId
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          sessionType
          status
          sysId
        }
        consultationMessages(limit: $limit9, offset: $offset9, order: $order8) {
          count
          items {
            automatedMessage {
              createdAt
              createdBy
              remark
              sysId
              translationKey
              updatedAt
              updatedBy
              valueEn
              valueJa
              valueZh
            }
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
            user {
              admin {
                crossSellRecords(input: $input10) {
                  childOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  childOrderId
                  createdAt
                  createdBy
                  creator {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit1
                      offset: $offset1
                      order: $order
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit2, offset: $offset2, order: $order1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  parentOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  parentOrderId
                  priceId
                  selectedBy
                  stripeProductPrice {
                    importPriceId
                    isBundle
                    priceActive
                    priceBillingScheme
                    priceCreated
                    priceCurrency
                    priceDisplayId
                    priceFirstTimeAlternativePrice
                    priceFirstTimeTryingInMonths
                    priceId
                    priceLivemode
                    priceNickname
                    priceProduct
                    priceTaxBehavior
                    priceUnitAmount
                    priceUnitAmountDecimal
                    productActive
                    productDescription
                    productDisplayId
                    productId
                    productLivemode
                    productName
                    productStatementDescriptor
                    productType
                    productUniqName
                    productUnitLabel
                    sysId
                  }
                  sysId
                }
                order(orderId: $orderId2) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                  count
                  items {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  limit
                  offset
                }
                patient(patientId: $patientId1) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
              }
              avatar
              calendarDates(
                acuityAppointmentId: $acuityAppointmentId2
                date: $date4
                forDelivery: $forDelivery2
                isReschedule: $isReschedule2
                orderId: $orderId3
              ) {
                date
              }
              calendarTimes(
                acuityAppointmentId: $acuityAppointmentId3
                consultDate: $consultDate1
                date: $date5
                forDelivery: $forDelivery3
                isReschedule: $isReschedule3
                orderId: $orderId4
              ) {
                time
              }
              consultation(input: $input22) {
                consultationAudit {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultationMessages(limit: $limit3, offset: $offset3, order: $order2) {
                  count
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    consultationMessages(
                      input: $input11
                      limit: $limit4
                      offset: $offset4
                      order: $order3
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input12, limit: $limit5, offset: $offset5, order: $order4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput2) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput3) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input13, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input14) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input15) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId4
                    date: $date8
                    forDelivery: $forDelivery4
                    isReschedule: $isReschedule4
                    orderId: $orderId5
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId5
                    consultDate: $consultDate2
                    date: $date9
                    forDelivery: $forDelivery5
                    isReschedule: $isReschedule5
                    orderId: $orderId6
                  ) {
                    time
                  }
                  consultation(input: $input16) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input17
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input18, limit: $limit8, offset: $offset8, order: $order7) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput4) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput5) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink2) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input19, pagination: $pagination2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date10) {
                    date
                  }
                  partnerConsultTimes(date: $date11) {
                    time
                  }
                  patient(input: $input20) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input21) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform11)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              locale
              ninjaVanToken
              phoneNumber
              requireConfirmPolicy
              socialProviderType
              sysId
              tempToken
              tempTokenExpired
              userType
              utmCampaign
              utmId
              utmMedium
              utmSource
            }
          }
          limit
          offset
        }
        consultationTitle {
          createdAt
          createdBy
          remark
          sysId
          translationKey
          updatedAt
          updatedBy
          valueEn
          valueJa
          valueZh
        }
        countReminder
        createdAt
        doctor {
          active
          calendarId
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        messages {
          consultationSysId
          content
          createdAt
          readAt
          sysId
          updatedAt
        }
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        orderSysId
        participants {
          avatar
          fullName
          identity
          locale
          role
          token
          userSysId
        }
        participantsV2 {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          locale
          ninjaVanToken
          phoneNumber
          requireConfirmPolicy
          socialProviderType
          sysId
          tempToken
          tempTokenExpired
          userType
          utmCampaign
          utmId
          utmMedium
          utmSource
        }
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    status
    sysId
  }
}
    `;
export const useCreateCheckoutSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCheckoutSessionMutation, TError, CreateCheckoutSessionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCheckoutSessionMutation, TError, CreateCheckoutSessionMutationVariables, TContext>(
      ['createCheckoutSession'],
      (variables?: CreateCheckoutSessionMutationVariables) => fetcher<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(client, CreateCheckoutSessionDocument, variables, headers)(),
      options
    );
export const CreateCompletedEvalDocument = `
    mutation createCompletedEval($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $input: CreateCompletedEvalInput!) {
  createCompletedEval(input: $input) {
    completed
    createdAt
    evaluationFormLastUpdated
    evaluationId
    formQandA
    jumpToSectionIndex
    oldPatientId
    patient
    patientSnapshot {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    patientdoctorNotes
    questionTotal
    sectionHistory
    sectionIndex
    sectionTotal
    sysId
    updatedAt
    valid
  }
}
    `;
export const useCreateCompletedEvalMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCompletedEvalMutation, TError, CreateCompletedEvalMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCompletedEvalMutation, TError, CreateCompletedEvalMutationVariables, TContext>(
      ['createCompletedEval'],
      (variables?: CreateCompletedEvalMutationVariables) => fetcher<CreateCompletedEvalMutation, CreateCompletedEvalMutationVariables>(client, CreateCompletedEvalDocument, variables, headers)(),
      options
    );
export const CreateCompletedEvalForGuestsDocument = `
    mutation createCompletedEvalForGuests($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $input: CreateCompletedEvalInputForGuest!) {
  createCompletedEvalForGuests(input: $input) {
    completed
    createdAt
    evaluationFormLastUpdated
    evaluationId
    formQandA
    jumpToSectionIndex
    oldPatientId
    patient
    patientSnapshot {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    patientdoctorNotes
    questionTotal
    sectionHistory
    sectionIndex
    sectionTotal
    sysId
    updatedAt
    valid
  }
}
    `;
export const useCreateCompletedEvalForGuestsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCompletedEvalForGuestsMutation, TError, CreateCompletedEvalForGuestsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCompletedEvalForGuestsMutation, TError, CreateCompletedEvalForGuestsMutationVariables, TContext>(
      ['createCompletedEvalForGuests'],
      (variables?: CreateCompletedEvalForGuestsMutationVariables) => fetcher<CreateCompletedEvalForGuestsMutation, CreateCompletedEvalForGuestsMutationVariables>(client, CreateCompletedEvalForGuestsDocument, variables, headers)(),
      options
    );
export const CreateDoctorDocument = `
    mutation createDoctor($videoLink: String!, $id: String, $platform: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform1: String, $inputConsultation1: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit: Float, $offset: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink1: String!, $previewVideoLink: String!, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $patientId: String, $input4: CrossSellRecordQueryInput, $orderId: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId1: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId2: String, $limit1: Int, $offset1: Int, $order: JSON, $acuityAppointmentId2: String, $date2: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date3: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $input5: V2ConsultationFilterInput!, $input6: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input7: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input8: OrderInput!, $pagination: V2PaginationInput!, $date4: String, $date5: Float, $input9: GetPatientInput, $platform2: String, $input10: StripeProductFilterV2, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit4: Int, $offset4: Int, $order3: JSON, $limit5: Int, $offset5: Int, $order4: JSON, $input13: ConsultationListInput!, $limit6: Int, $offset6: Int, $order5: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform3: String, $input16: StripeProductFilterV2, $doctorFilterInput3: V2DoctorInputFilter, $limit7: Int, $offset7: Int, $order6: JSON, $videoLink3: String!, $patientId3: String, $input17: V2CreateDoctor!) {
  createDoctor(input: $input17) {
    active
    bio {
      createdAt
      createdBy
      remark
      sysId
      translationKey
      updatedAt
      updatedBy
      valueEn
      valueJa
      valueZh
    }
    calendarId
    consultation(videoLink: $videoLink3) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          consultationAudit {
            consultTime
            consultType
            createdBy
            doctor {
              active
              bio {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              calendarId
              consultation(videoLink: $videoLink) {
                gmeetLink
                previewToken
                previewVideoLink
                status
                sysId
                token
                videoChannelId
                videoLink
                zoomJoinUrl
              }
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              patient(patientId: $patientId) {
                atomePayment(id: $id) {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  summary {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  sysId
                }
                atomePayments {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  summary {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  sysId
                }
                billingAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                bloodPressure
                bypassLoginTokens {
                  expiresAt
                  pageName
                  token
                  type
                }
                cart {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  cartItems {
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    completedEval
                    consultationSessionType
                    isAutoRenewal
                    isSkipMedSelecting
                    isSubscriptionPrice
                    orderId
                    patientNote
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    product {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    quantity
                    teleConsultForSkipEval
                    type
                  }
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  orderSummary {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    discountAmountLater
                    discountAmountNow
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountBeforeTax
                    paymentIntentSummary
                    promotionCode
                    shippingFee
                    subTotal
                    subTotalLater
                    subTotalNow
                    taxes
                    taxesLater
                    taxesNow
                    teleConsultFee
                    total
                    totalLater
                    totalNow
                    totalNowAfterCashback
                    totalTaxes
                  }
                  paidCompletedEvaluationIds
                  platform
                  promotionCode
                  status
                  sysId
                }
                cashback {
                  availableBalance
                  recentTransactions {
                    amount
                    cashbackType
                    created
                    credit_note
                    currency
                    customer
                    description
                    ending_balance
                    id
                    invoice
                    livemode
                    metadata
                    object
                    savingsToDate
                    type
                  }
                  savingsToDateThisYear {
                    amount
                    cashbackType
                    created
                    credit_note
                    currency
                    customer
                    description
                    ending_balance
                    id
                    invoice
                    livemode
                    metadata
                    object
                    savingsToDate
                    type
                  }
                }
                checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                  checkoutData
                  evaluationId
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  patient {
                    bloodPressure
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit, offset: $offset, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  status
                  sysId
                }
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sysId
              textConsultPostalCodes
              trtEligible
              user {
                admin {
                  crossSellRecords(input: $input4) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId
                  date: $date
                  forDelivery: $forDelivery
                  isReschedule: $isReschedule
                  orderId: $orderId1
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId1
                  consultDate: $consultDate
                  date: $date1
                  forDelivery: $forDelivery1
                  isReschedule: $isReschedule1
                  orderId: $orderId2
                ) {
                  time
                }
                consultation(input: $input11) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit1, offset: $offset1, order: $order) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId2
                      date: $date2
                      forDelivery: $forDelivery2
                      isReschedule: $isReschedule2
                      orderId: $orderId3
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId3
                      consultDate: $consultDate1
                      date: $date3
                      forDelivery: $forDelivery3
                      isReschedule: $isReschedule3
                      orderId: $orderId4
                    ) {
                      time
                    }
                    consultation(input: $input5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input6
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input7, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input8, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date4) {
                      date
                    }
                    partnerConsultTimes(date: $date5) {
                      time
                    }
                    patient(input: $input9) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input10) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input12
                  limit: $limit4
                  offset: $offset4
                  order: $order3
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input13, limit: $limit6, offset: $offset6, order: $order5) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                    count
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                  }
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input14, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input15) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input16) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            evaluationId
            sessionType
            status
            sysId
          }
          consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
            count
            limit
            offset
          }
          consultationTitle {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          countReminder
          createdAt
          doctor {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          messages {
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
          }
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          orderSysId
          participants {
            avatar
            fullName
            identity
            locale
            role
            token
            userSysId
          }
          participantsV2 {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            phoneNumber
            requireConfirmPolicy
            socialProviderType
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
    country
    designation
    duration
    email
    firstName
    fullName
    lastName
    patient(patientId: $patientId3) {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    sysId
    textConsultPostalCodes
    trtEligible
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      phoneNumber
      requireConfirmPolicy
      socialProviderType
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
  }
}
    `;
export const useCreateDoctorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateDoctorMutation, TError, CreateDoctorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateDoctorMutation, TError, CreateDoctorMutationVariables, TContext>(
      ['createDoctor'],
      (variables?: CreateDoctorMutationVariables) => fetcher<CreateDoctorMutation, CreateDoctorMutationVariables>(client, CreateDoctorDocument, variables, headers)(),
      options
    );
export const CreateEvaluationQuestionDocument = `
    mutation createEvaluationQuestion($input: CreateEvaluationQuestionInput!) {
  createEvaluationQuestion(input: $input)
}
    `;
export const useCreateEvaluationQuestionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateEvaluationQuestionMutation, TError, CreateEvaluationQuestionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateEvaluationQuestionMutation, TError, CreateEvaluationQuestionMutationVariables, TContext>(
      ['createEvaluationQuestion'],
      (variables?: CreateEvaluationQuestionMutationVariables) => fetcher<CreateEvaluationQuestionMutation, CreateEvaluationQuestionMutationVariables>(client, CreateEvaluationQuestionDocument, variables, headers)(),
      options
    );
export const CreateGiveawayRecordDocument = `
    mutation createGiveawayRecord($input: CreateGiveawayInput!) {
  createGiveawayRecord(input: $input)
}
    `;
export const useCreateGiveawayRecordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateGiveawayRecordMutation, TError, CreateGiveawayRecordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateGiveawayRecordMutation, TError, CreateGiveawayRecordMutationVariables, TContext>(
      ['createGiveawayRecord'],
      (variables?: CreateGiveawayRecordMutationVariables) => fetcher<CreateGiveawayRecordMutation, CreateGiveawayRecordMutationVariables>(client, CreateGiveawayRecordDocument, variables, headers)(),
      options
    );
export const CreateGuestEvaluationDocument = `
    mutation createGuestEvaluation($input: CreateGuestEvaluationInput!) {
  createGuestEvaluation(input: $input)
}
    `;
export const useCreateGuestEvaluationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateGuestEvaluationMutation, TError, CreateGuestEvaluationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateGuestEvaluationMutation, TError, CreateGuestEvaluationMutationVariables, TContext>(
      ['createGuestEvaluation'],
      (variables?: CreateGuestEvaluationMutationVariables) => fetcher<CreateGuestEvaluationMutation, CreateGuestEvaluationMutationVariables>(client, CreateGuestEvaluationDocument, variables, headers)(),
      options
    );
export const CreateInvoiceDocument = `
    mutation createInvoice($input: CreateInvoiceInput!) {
  createInvoice(input: $input)
}
    `;
export const useCreateInvoiceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateInvoiceMutation, TError, CreateInvoiceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateInvoiceMutation, TError, CreateInvoiceMutationVariables, TContext>(
      ['createInvoice'],
      (variables?: CreateInvoiceMutationVariables) => fetcher<CreateInvoiceMutation, CreateInvoiceMutationVariables>(client, CreateInvoiceDocument, variables, headers)(),
      options
    );
export const CreateJobDocument = `
    mutation createJob($input: CronjobInput!) {
  createJob(input: $input) {
    createdAt
    createdBy
    description
    isActive
    name
    updatedAt
    updatedBy
  }
}
    `;
export const useCreateJobMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateJobMutation, TError, CreateJobMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateJobMutation, TError, CreateJobMutationVariables, TContext>(
      ['createJob'],
      (variables?: CreateJobMutationVariables) => fetcher<CreateJobMutation, CreateJobMutationVariables>(client, CreateJobDocument, variables, headers)(),
      options
    );
export const CreateNewSurveyDocument = `
    mutation createNewSurvey($input: CreateNewSurveyInput!) {
  createNewSurvey(input: $input)
}
    `;
export const useCreateNewSurveyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateNewSurveyMutation, TError, CreateNewSurveyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateNewSurveyMutation, TError, CreateNewSurveyMutationVariables, TContext>(
      ['createNewSurvey'],
      (variables?: CreateNewSurveyMutationVariables) => fetcher<CreateNewSurveyMutation, CreateNewSurveyMutationVariables>(client, CreateNewSurveyDocument, variables, headers)(),
      options
    );
export const CreateOtcWalletOrderDocument = `
    mutation createOTCWalletOrder($input: CreateOTCWalletOrderInput!) {
  createOTCWalletOrder(input: $input) {
    otcWalletOrderId
  }
}
    `;
export const useCreateOtcWalletOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateOtcWalletOrderMutation, TError, CreateOtcWalletOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateOtcWalletOrderMutation, TError, CreateOtcWalletOrderMutationVariables, TContext>(
      ['createOTCWalletOrder'],
      (variables?: CreateOtcWalletOrderMutationVariables) => fetcher<CreateOtcWalletOrderMutation, CreateOtcWalletOrderMutationVariables>(client, CreateOtcWalletOrderDocument, variables, headers)(),
      options
    );
export const CreateOrderDocument = `
    mutation createOrder($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: CreateOrderInput!) {
  createOrder(input: $input) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useCreateOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateOrderMutation, TError, CreateOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateOrderMutation, TError, CreateOrderMutationVariables, TContext>(
      ['createOrder'],
      (variables?: CreateOrderMutationVariables) => fetcher<CreateOrderMutation, CreateOrderMutationVariables>(client, CreateOrderDocument, variables, headers)(),
      options
    );
export const CreateOrderNoteDocument = `
    mutation createOrderNote($input: CreateOrderNoteInput!) {
  createOrderNote(input: $input)
}
    `;
export const useCreateOrderNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateOrderNoteMutation, TError, CreateOrderNoteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateOrderNoteMutation, TError, CreateOrderNoteMutationVariables, TContext>(
      ['createOrderNote'],
      (variables?: CreateOrderNoteMutationVariables) => fetcher<CreateOrderNoteMutation, CreateOrderNoteMutationVariables>(client, CreateOrderNoteDocument, variables, headers)(),
      options
    );
export const CreateOrdersAfterTeleConsultDocument = `
    mutation createOrdersAfterTeleConsult($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: TeleConsultOrdersInput!) {
  createOrdersAfterTeleConsult(input: $input) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useCreateOrdersAfterTeleConsultMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateOrdersAfterTeleConsultMutation, TError, CreateOrdersAfterTeleConsultMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateOrdersAfterTeleConsultMutation, TError, CreateOrdersAfterTeleConsultMutationVariables, TContext>(
      ['createOrdersAfterTeleConsult'],
      (variables?: CreateOrdersAfterTeleConsultMutationVariables) => fetcher<CreateOrdersAfterTeleConsultMutation, CreateOrdersAfterTeleConsultMutationVariables>(client, CreateOrdersAfterTeleConsultDocument, variables, headers)(),
      options
    );
export const CreatePartnerTrtOrderDocument = `
    mutation createPartnerTRTOrder($input: CreatePartnerTRTOrder!) {
  createPartnerTRTOrder(input: $input)
}
    `;
export const useCreatePartnerTrtOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePartnerTrtOrderMutation, TError, CreatePartnerTrtOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePartnerTrtOrderMutation, TError, CreatePartnerTrtOrderMutationVariables, TContext>(
      ['createPartnerTRTOrder'],
      (variables?: CreatePartnerTrtOrderMutationVariables) => fetcher<CreatePartnerTrtOrderMutation, CreatePartnerTrtOrderMutationVariables>(client, CreatePartnerTrtOrderDocument, variables, headers)(),
      options
    );
export const CreatePatientDocumentDocument = `
    mutation createPatientDocument($input: CreatePatientDocumentInput) {
  createPatientDocument(input: $input) {
    createdAt
    orderSysId
    ref
    sysId
    type
    url
  }
}
    `;
export const useCreatePatientDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePatientDocumentMutation, TError, CreatePatientDocumentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePatientDocumentMutation, TError, CreatePatientDocumentMutationVariables, TContext>(
      ['createPatientDocument'],
      (variables?: CreatePatientDocumentMutationVariables) => fetcher<CreatePatientDocumentMutation, CreatePatientDocumentMutationVariables>(client, CreatePatientDocumentDocument, variables, headers)(),
      options
    );
export const CreatePatientFromOpsDocument = `
    mutation createPatientFromOps($input: CreatePatientFromOpsInput!) {
  createPatientFromOps(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useCreatePatientFromOpsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePatientFromOpsMutation, TError, CreatePatientFromOpsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePatientFromOpsMutation, TError, CreatePatientFromOpsMutationVariables, TContext>(
      ['createPatientFromOps'],
      (variables?: CreatePatientFromOpsMutationVariables) => fetcher<CreatePatientFromOpsMutation, CreatePatientFromOpsMutationVariables>(client, CreatePatientFromOpsDocument, variables, headers)(),
      options
    );
export const CreatePreblockDocument = `
    mutation createPreblock($input: CreatePreblockInput!) {
  createPreblock(input: $input) {
    expiresAt
    heldAppointmentTypeId
    heldDateTime
    preblockId
    status
  }
}
    `;
export const useCreatePreblockMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePreblockMutation, TError, CreatePreblockMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePreblockMutation, TError, CreatePreblockMutationVariables, TContext>(
      ['createPreblock'],
      (variables?: CreatePreblockMutationVariables) => fetcher<CreatePreblockMutation, CreatePreblockMutationVariables>(client, CreatePreblockDocument, variables, headers)(),
      options
    );
export const CreateProductDocument = `
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    acuitySchedulingAppType
    amountToFreeIncludedPrice
    chargeNowProduct
    country
    crossEvaluation
    displayId
    emailOnCompleteName
    emailTemplate
    evaluationFormId
    id
    includedPriceIds
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    overwriteCalendarHeaderTitleInfo
    overwriteProductSubtitleInfo
    platform
    productGroups
    requiresDelivery
    requiresEvaluation
    requiresPrescription
    sysId
    title
  }
}
    `;
export const useCreateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateProductMutation, TError, CreateProductMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateProductMutation, TError, CreateProductMutationVariables, TContext>(
      ['createProduct'],
      (variables?: CreateProductMutationVariables) => fetcher<CreateProductMutation, CreateProductMutationVariables>(client, CreateProductDocument, variables, headers)(),
      options
    );
export const CreateReferralDocumentsDocument = `
    mutation createReferralDocuments($input: CreateReferralDocumentInput) {
  createReferralDocuments(input: $input)
}
    `;
export const useCreateReferralDocumentsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateReferralDocumentsMutation, TError, CreateReferralDocumentsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateReferralDocumentsMutation, TError, CreateReferralDocumentsMutationVariables, TContext>(
      ['createReferralDocuments'],
      (variables?: CreateReferralDocumentsMutationVariables) => fetcher<CreateReferralDocumentsMutation, CreateReferralDocumentsMutationVariables>(client, CreateReferralDocumentsDocument, variables, headers)(),
      options
    );
export const CreateSetupIntentDocument = `
    mutation createSetupIntent {
  createSetupIntent
}
    `;
export const useCreateSetupIntentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateSetupIntentMutation, TError, CreateSetupIntentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateSetupIntentMutation, TError, CreateSetupIntentMutationVariables, TContext>(
      ['createSetupIntent'],
      (variables?: CreateSetupIntentMutationVariables) => fetcher<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(client, CreateSetupIntentDocument, variables, headers)(),
      options
    );
export const CreateShipmentGroupDocument = `
    mutation createShipmentGroup($input: CreateShipmentGroupInput!) {
  createShipmentGroup(input: $input) {
    bookingNo
    createdAt
    name
    sysId
    updatedAt
  }
}
    `;
export const useCreateShipmentGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateShipmentGroupMutation, TError, CreateShipmentGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateShipmentGroupMutation, TError, CreateShipmentGroupMutationVariables, TContext>(
      ['createShipmentGroup'],
      (variables?: CreateShipmentGroupMutationVariables) => fetcher<CreateShipmentGroupMutation, CreateShipmentGroupMutationVariables>(client, CreateShipmentGroupDocument, variables, headers)(),
      options
    );
export const CreateShipperDocument = `
    mutation createShipper($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $videoLink: String!, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $inputConsultation2: V2ConsultationFilterInput, $platform1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $platform2: String, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform3: String, $input9: StripeProductFilterV2, $videoLink1: String!, $previewVideoLink: String!, $patientId: String, $limit4: Int, $offset4: Int, $order3: JSON, $orderId2: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input10: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input11: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $input12: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input13: GetPatientInput, $platform5: String, $platform6: String, $input14: StripeProductFilterV2, $input15: V2ConsultationFilterInput!, $platform7: String, $platform8: String, $platform9: String, $platform10: String, $platform11: String, $platform12: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input16: V2ConsultationFilterInput!, $input17: ConsultationMessagesInput!, $limit8: Int, $offset8: Int, $order7: JSON, $input18: ConsultationListInput!, $limit9: Int, $offset9: Int, $order8: JSON, $doctorFilterInput4: V2DoctorInputFilter, $doctorFilterInput5: V2DoctorInputFilter, $input19: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input20: GetPatientInput, $platform13: String, $input21: StripeProductFilterV2, $platform14: String, $platform15: String, $platform16: String, $platform17: String, $platform18: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform19: String, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform20: String, $consultAuditFilterInput6: ConsultationAuditFilterInput, $inputConsultation7: V2ConsultationFilterInput, $platform21: String, $acuityAppointmentId6: String, $date12: String, $forDelivery6: Boolean, $isReschedule6: Boolean, $orderId7: String, $acuityAppointmentId7: String, $consultDate3: Float, $date13: Float, $forDelivery7: Boolean, $isReschedule7: Boolean, $orderId8: String, $input22: V2ConsultationFilterInput!, $input23: ConsultationMessagesInput!, $limit10: Int, $offset10: Int, $order9: JSON, $input24: ConsultationListInput!, $limit11: Int, $offset11: Int, $order10: JSON, $doctorFilterInput6: V2DoctorInputFilter, $doctorFilterInput7: V2DoctorInputFilter, $input25: OrderInput!, $pagination3: V2PaginationInput!, $date14: String, $date15: Float, $input26: GetPatientInput, $platform22: String, $input27: StripeProductFilterV2, $consultAuditFilterInput7: ConsultationAuditFilterInput, $inputConsultation8: V2ConsultationFilterInput, $platform23: String, $input28: CrossSellRecordQueryInput, $acuityAppointmentId8: String, $date16: String, $forDelivery8: Boolean, $isReschedule8: Boolean, $orderId9: String, $acuityAppointmentId9: String, $consultDate4: Float, $date17: Float, $forDelivery9: Boolean, $isReschedule9: Boolean, $orderId10: String, $input29: V2ConsultationFilterInput!, $input30: ConsultationMessagesInput!, $limit12: Int, $offset12: Int, $order11: JSON, $input31: ConsultationListInput!, $limit13: Int, $offset13: Int, $order12: JSON, $doctorFilterInput8: V2DoctorInputFilter, $doctorFilterInput9: V2DoctorInputFilter, $input32: OrderInput!, $pagination4: V2PaginationInput!, $date18: String, $date19: Float, $input33: GetPatientInput, $platform24: String, $input34: StripeProductFilterV2, $input35: CreateShipperInput) {
  createShipper(input: $input35) {
    admin {
      crossSellRecords(input: $input28) {
        childOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          activeConsultation {
            consultationAudit {
              consultTime
              consultType
              createdBy
              doctor {
                active
                bio {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                calendarId
                consultation(videoLink: $videoLink) {
                  gmeetLink
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  previewToken
                  previewVideoLink
                  status
                  sysId
                  token
                  videoChannelId
                  videoLink
                  zoomJoinUrl
                }
                country
                designation
                duration
                email
                firstName
                fullName
                lastName
                patient(patientId: $patientId) {
                  atomePayment(id: $id) {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  bypassLoginTokens {
                    expiresAt
                    pageName
                    token
                    type
                  }
                  cart {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    cartItems {
                      completedEval
                      consultationSessionType
                      isAutoRenewal
                      isSkipMedSelecting
                      isSubscriptionPrice
                      orderId
                      patientNote
                      quantity
                      teleConsultForSkipEval
                      type
                    }
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    orderSummary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      discountAmountLater
                      discountAmountNow
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountBeforeTax
                      paymentIntentSummary
                      promotionCode
                      shippingFee
                      subTotal
                      subTotalLater
                      subTotalNow
                      taxes
                      taxesLater
                      taxesNow
                      teleConsultFee
                      total
                      totalLater
                      totalNow
                      totalNowAfterCashback
                      totalTaxes
                    }
                    paidCompletedEvaluationIds
                    platform
                    promotionCode
                    status
                    sysId
                  }
                  cashback {
                    availableBalance
                    recentTransactions {
                      amount
                      cashbackType
                      created
                      credit_note
                      currency
                      customer
                      description
                      ending_balance
                      id
                      invoice
                      livemode
                      metadata
                      object
                      savingsToDate
                      type
                    }
                    savingsToDateThisYear {
                      amount
                      cashbackType
                      created
                      credit_note
                      currency
                      customer
                      description
                      ending_balance
                      id
                      invoice
                      livemode
                      metadata
                      object
                      savingsToDate
                      type
                    }
                  }
                  checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  document(input: $input) {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  documents {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  email
                  evaluations(evalFilter: $evalFilter) {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  latestPaymentMethod {
                    card {
                      brand
                      exp_month
                      exp_year
                      last4
                    }
                    id
                  }
                  legalName
                  locale
                  mounjaroTrialEligible
                  order(id: $id1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  prescriptionCalculation(input: $input1) {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  referralCode
                  referrals {
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorId
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    items {
                      orderId
                      priceId
                      referralSysId
                      sysId
                    }
                    sysId
                  }
                  shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                    count
                    items {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    limit
                    offset
                  }
                  smartMatchMeta(input: $input2) {
                    evalId
                    status
                    sysId
                    userId
                    userType
                  }
                  stripeCustomer
                  stripeCustomerId
                  survey(input: $input3) {
                    answers
                    isSkipped
                    patientSysId
                    sysId
                    type
                  }
                  sysId
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  userSysId
                  videoConsultation(videoLink: $videoLink1) {
                    gmeetLink
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                    gmeetLink
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  weight
                }
                sysId
                textConsultPostalCodes
                trtEligible
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              evaluationId
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              patient {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sessionType
              status
              sysId
            }
            consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
              count
              items {
                automatedMessage {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                consultationSysId
                content
                createdAt
                readAt
                sysId
                updatedAt
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              limit
              offset
            }
            consultationTitle {
              createdAt
              createdBy
              remark
              sysId
              translationKey
              updatedAt
              updatedBy
              valueEn
              valueJa
              valueZh
            }
            countReminder
            createdAt
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            messages {
              automatedMessage {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              consultationSysId
              content
              createdAt
              readAt
              sysId
              updatedAt
              user {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            orderSysId
            participants {
              avatar
              fullName
              identity
              locale
              role
              token
              userSysId
            }
            participantsV2 {
              admin {
                order(orderId: $orderId2) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                  count
                  items {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  limit
                  offset
                }
                patient(patientId: $patientId1) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
              }
              avatar
              calendarDates(
                acuityAppointmentId: $acuityAppointmentId2
                date: $date4
                forDelivery: $forDelivery2
                isReschedule: $isReschedule2
                orderId: $orderId3
              ) {
                date
              }
              calendarTimes(
                acuityAppointmentId: $acuityAppointmentId3
                consultDate: $consultDate1
                date: $date5
                forDelivery: $forDelivery3
                isReschedule: $isReschedule3
                orderId: $orderId4
              ) {
                time
              }
              consultation(input: $input15) {
                consultationAudit {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                  count
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  avatar
                  consultationMessages(
                    input: $input10
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input11, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink2) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input12, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input13) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    isAffiliateLocked
                    promotionCodeError
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input14) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform6)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              locale
              ninjaVanToken
              phoneNumber
              requireConfirmPolicy
              socialProviderType
              sysId
              tempToken
              tempTokenExpired
              userType
              utmCampaign
              utmId
              utmMedium
              utmSource
            }
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          acuityAppointment {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          additionalPrices {
            active
            alternativePrice {
              active
              alternativePrice {
                active
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                metadata {
                  actual_price_display
                  boxes
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  isArchived
                  isOneTimePrice
                  price_frequency
                  price_quantity
                  price_show
                  quantity
                  quantity_display
                  strength
                }
                nickname
                product
                productId
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredientDetails {
                    description
                    imageLink
                    locale
                    name
                    strength
                    uniqueName
                  }
                  ingredients
                  isConsultOnly(platform: $platform9)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  prices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInstructions {
                    language
                    localeKey
                    productId
                    sysId
                    translatedText
                  }
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  tempPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  texts {
                    benefits
                    category
                    display_price
                    display_price_patient
                    dosage_variant_body
                    dosage_variant_title
                    effective_in
                    for
                    frequency_variant_title
                    good_to_know
                    how_to_take
                    how_to_use
                    is_popular
                    lasts_for
                    platform
                    product_description
                    product_name
                    product_short_description
                    quantity_per_unit
                    quantity_variant_title
                    requires_prescription
                    safety_information
                    side_effects
                    strength
                    taken
                    unit
                    unit_patient
                  }
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                shopDisplay
                sysId
                tax_behavior
                texts {
                  actual_price_display
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  price_frequency
                  price_quantity
                  quantity
                  quantity_display
                }
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            metadata {
              actual_price_display
              boxes
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              isArchived
              isOneTimePrice
              price_frequency
              price_quantity
              price_show
              quantity
              quantity_display
              strength
            }
            nickname
            product
            productId
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform12)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            shopDisplay
            sysId
            tax_behavior
            texts {
              actual_price_display
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              price_frequency
              price_quantity
              quantity
              quantity_display
            }
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          afterVideoConsultRedirecting {
            baseUrl
            path
          }
          approveAt
          atomeNextSendingInvoiceDate
          atomePayments {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          checkoutSession {
            checkoutData
            evaluationId
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            patient {
              bloodPressure
              country
              createdAt
              dob
              email
              fbc
              fbp
              firstName
              fromPlatformEnv
              fullName
              gender
              height
              icNumber
              idVerifiedAt
              identification
              isAlreadyCheckout
              isReferredBy
              lastName
              legalName
              locale
              mounjaroTrialEligible
              paidCompletedEvaluationIds
              phoneNumber
              referralCode
              stripeCustomer
              stripeCustomerId
              sysId
              userSysId
              weight
            }
            status
            sysId
          }
          childrenOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            activeConsultation {
              countReminder
              createdAt
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              orderSysId
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            acuityAppointment {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            acuityAppointments {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            additionalPrices {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            afterVideoConsultRedirecting {
              baseUrl
              path
            }
            approveAt
            atomeNextSendingInvoiceDate
            atomePayments {
              amount
              paymentUrl
              priceId
              referenceId
              status
              sysId
            }
            checkoutSession {
              checkoutData
              evaluationId
              status
              sysId
            }
            childrenOrders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                consultTime
                consultType
                createdBy
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                evaluationId
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sessionType
                status
                sysId
              }
              consultations(inputConsultation: $inputConsultation4) {
                countReminder
                createdAt
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                orderSysId
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluation {
                isCompleted
                isSkipped
                name
                patientAnswers {
                  answer {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  question {
                    answers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    dependentEvaluationQuestions {
                      skipPage
                      skipQuestionCount
                      sysId
                    }
                    displayPage
                    evaluationBlocks {
                      sysId
                    }
                    guestOnly
                    name
                    order
                    sysId
                    textKey
                    type
                    validation {
                      bmi
                      extra
                      max
                      min
                      preselect
                      type
                    }
                  }
                  type
                  value
                }
                patientNote
                platform
                questions {
                  answers {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  content {
                    body {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    footer {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    header {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                  }
                  dependentEvaluationQuestions {
                    answer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  displayPage
                  evaluationBlocks {
                    blockAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    content {
                      description
                      descriptionTextKey
                      sysId
                      title
                      titleTextKey
                    }
                    sysId
                  }
                  guestOnly
                  name
                  order
                  sysId
                  textKey
                  type
                  validation {
                    bmi
                    extra
                    max
                    min
                    preselect
                    type
                  }
                }
                status
                sysId
                type
              }
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              latestAtomePayment {
                amount
                paymentUrl
                priceId
                referenceId
                status
                summary {
                  cashbackEarnRate
                  cashbackEarned
                  cashbackRedeemed
                  consultBasePrice
                  consultFee
                  consultFeeAfterDiscount
                  consultTax
                  consultTransactionFee
                  discountAmount
                  isConsult
                  mainBasePrice
                  mainTax
                  mainTransactionFee
                  minimalAmountPayment
                  paymentIntentAmount
                  paymentIntentAmountAfterCashback
                  paymentIntentSummary
                  priceId
                  productPriceAmount
                  productPriceAmountAfterDiscount
                  promotionCode
                  shouldChargeConsultFee
                  subTotal
                  total
                  totalAfterCashback
                }
                sysId
              }
              latestInvoice {
                amount_due
                hosted_invoice_url
                id
                lines {
                  data {
                    amount
                    discount
                    plan {
                      active
                      id
                      metadata
                    }
                  }
                }
                next_payment_attempt
                paid
                paymentStatus
                period_end
                starting_balance
                status
                subtotal
                tax
                total
                total_discount_amounts {
                  amount
                }
              }
              latestNote {
                author {
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId4
                    date: $date8
                    forDelivery: $forDelivery4
                    isReschedule: $isReschedule4
                    orderId: $orderId5
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId5
                    consultDate: $consultDate2
                    date: $date9
                    forDelivery: $forDelivery5
                    isReschedule: $isReschedule5
                    orderId: $orderId6
                  ) {
                    time
                  }
                  consultation(input: $input16) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input17
                    limit: $limit8
                    offset: $offset8
                    order: $order7
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input18, limit: $limit9, offset: $offset9, order: $order8) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput4) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput5) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input19, pagination: $pagination2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date10) {
                    date
                  }
                  partnerConsultTimes(date: $date11) {
                    time
                  }
                  patient(input: $input20) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    isAffiliateLocked
                    promotionCodeError
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input21) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                content
                createdAt
                createdBy
                sysId
                updatedAt
              }
              nextReviewDate
              oldPrice
              oldPriceInfo {
                active
                alternativePrice {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                metadata {
                  actual_price_display
                  boxes
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  isArchived
                  isOneTimePrice
                  price_frequency
                  price_quantity
                  price_show
                  quantity
                  quantity_display
                  strength
                }
                nickname
                product
                productId
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  ingredients
                  isConsultOnly(platform: $platform14)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                shopDisplay
                sysId
                tax_behavior
                texts {
                  actual_price_display
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  price_frequency
                  price_quantity
                  quantity
                  quantity_display
                }
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patient {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              pickupLocation {
                address
                area {
                  areaChildren {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaName
                  areaParent {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaType
                  pickupLocations {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  sysId
                }
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                orders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                activeConsultation {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                acuityAppointment {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                additionalPrices {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                afterVideoConsultRedirecting {
                  baseUrl
                  path
                }
                approveAt
                atomeNextSendingInvoiceDate
                atomePayments {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                checkoutSession {
                  checkoutData
                  evaluationId
                  status
                  sysId
                }
                childrenOrders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform15)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform16)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform18)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform19)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                claimedRetentionOffer
                consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultations(inputConsultation: $inputConsultation6) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluation {
                  isCompleted
                  isSkipped
                  name
                  patientNote
                  platform
                  status
                  sysId
                  type
                }
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                latestAtomePayment {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                latestInvoice {
                  amount_due
                  hosted_invoice_url
                  id
                  next_payment_attempt
                  paid
                  paymentStatus
                  period_end
                  starting_balance
                  status
                  subtotal
                  tax
                  total
                }
                latestNote {
                  content
                  createdAt
                  createdBy
                  sysId
                  updatedAt
                }
                nextReviewDate
                oldPrice
                oldPriceInfo {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                pickupLocation {
                  address
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescription {
                    cancelled
                    createdAt
                    days
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    priceIds
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform20)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                  }
                  updatedAt
                }
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          claimedRetentionOffer
          consultationAudits(consultAuditFilterInput: $consultAuditFilterInput6) {
            consultTime
            consultType
            createdBy
            evaluationId
            sessionType
            status
            sysId
          }
          consultations(inputConsultation: $inputConsultation7) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluation {
            isCompleted
            isSkipped
            name
            patientNote
            platform
            status
            sysId
            type
          }
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          latestAtomePayment {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          latestInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          latestNote {
            content
            createdAt
            createdBy
            sysId
            updatedAt
          }
          nextReviewDate
          oldPrice
          oldPriceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          pickupLocation {
            address
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribedAfterTrialOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          prescribed_after_trial_order_sys_id
          prescription {
            cancelled
            createdAt
            days
            doctorNotes
            endDate
            expiresAt
            isFollowUp
            notedDate
            priceIds
            startDate
            status
            sysId
            treatmentCode
            updatedAt
          }
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          price {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          priceDisplayId
          priceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform21)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          siblingCrossSellOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          status
          stripePaymentIntentId
          stripeSubscriptionId
          subscription {
            cancel_at_period_end
            current_period_end
            current_period_start
            default_payment_method
            id
            items
            latest_invoice
            metadata
            pause_collection
            pending_setup_intent
            pending_update
            status
          }
          sysId
          teleConsultProduct
          upcomingInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          updatedAt
        }
        childOrderId
        createdAt
        createdBy
        creator {
          avatar
          calendarDates(
            acuityAppointmentId: $acuityAppointmentId6
            date: $date12
            forDelivery: $forDelivery6
            isReschedule: $isReschedule6
            orderId: $orderId7
          ) {
            date
          }
          calendarTimes(
            acuityAppointmentId: $acuityAppointmentId7
            consultDate: $consultDate3
            date: $date13
            forDelivery: $forDelivery7
            isReschedule: $isReschedule7
            orderId: $orderId8
          ) {
            time
          }
          consultation(input: $input22) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          consultationMessages(
            input: $input23
            limit: $limit10
            offset: $offset10
            order: $order9
          ) {
            count
            limit
            offset
          }
          consultations(
            input: $input24
            limit: $limit11
            offset: $offset11
            order: $order10
          ) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          doctor(doctorFilterInput: $doctorFilterInput6) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctors(doctorFilterInput: $doctorFilterInput7) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          locale
          ninjaVanToken
          orders(input: $input25, pagination: $pagination3) {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          partnerConsultDates(date: $date14) {
            date
          }
          partnerConsultTimes(date: $date15) {
            time
          }
          patient(input: $input26) {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientDocuments {
            createdAt
            orderSysId
            ref
            sysId
            type
            url
          }
          phoneNumber
          prescriptionCalculation {
            isAffiliateLocked
            promotionCodeError
            stripePromotionCode
          }
          requireConfirmPolicy
          socialProviderType
          stripeProducts(input: $input27) {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform22)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          sysId
          tempToken
          tempTokenExpired
          userType
          utmCampaign
          utmId
          utmMedium
          utmSource
        }
        parentOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          activeConsultation {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          acuityAppointment {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          additionalPrices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          afterVideoConsultRedirecting {
            baseUrl
            path
          }
          approveAt
          atomeNextSendingInvoiceDate
          atomePayments {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          checkoutSession {
            checkoutData
            evaluationId
            status
            sysId
          }
          childrenOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          claimedRetentionOffer
          consultationAudits(consultAuditFilterInput: $consultAuditFilterInput7) {
            consultTime
            consultType
            createdBy
            evaluationId
            sessionType
            status
            sysId
          }
          consultations(inputConsultation: $inputConsultation8) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluation {
            isCompleted
            isSkipped
            name
            patientNote
            platform
            status
            sysId
            type
          }
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          latestAtomePayment {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          latestInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          latestNote {
            content
            createdAt
            createdBy
            sysId
            updatedAt
          }
          nextReviewDate
          oldPrice
          oldPriceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          pickupLocation {
            address
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribedAfterTrialOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          prescribed_after_trial_order_sys_id
          prescription {
            cancelled
            createdAt
            days
            doctorNotes
            endDate
            expiresAt
            isFollowUp
            notedDate
            priceIds
            startDate
            status
            sysId
            treatmentCode
            updatedAt
          }
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          price {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          priceDisplayId
          priceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform23)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          siblingCrossSellOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          status
          stripePaymentIntentId
          stripeSubscriptionId
          subscription {
            cancel_at_period_end
            current_period_end
            current_period_start
            default_payment_method
            id
            items
            latest_invoice
            metadata
            pause_collection
            pending_setup_intent
            pending_update
            status
          }
          sysId
          teleConsultProduct
          upcomingInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          updatedAt
        }
        parentOrderId
        priceId
        selectedBy
        stripeProductPrice {
          importPriceId
          isBundle
          priceActive
          priceBillingScheme
          priceCreated
          priceCurrency
          priceDisplayId
          priceFirstTimeAlternativePrice
          priceFirstTimeTryingInMonths
          priceId
          priceLivemode
          priceNickname
          priceProduct
          priceTaxBehavior
          priceUnitAmount
          priceUnitAmountDecimal
          productActive
          productDescription
          productDisplayId
          productId
          productLivemode
          productName
          productStatementDescriptor
          productType
          productUniqName
          productUnitLabel
          sysId
        }
        sysId
      }
    }
    avatar
    calendarDates(
      acuityAppointmentId: $acuityAppointmentId8
      date: $date16
      forDelivery: $forDelivery8
      isReschedule: $isReschedule8
      orderId: $orderId9
    ) {
      date
    }
    calendarTimes(
      acuityAppointmentId: $acuityAppointmentId9
      consultDate: $consultDate4
      date: $date17
      forDelivery: $forDelivery9
      isReschedule: $isReschedule9
      orderId: $orderId10
    ) {
      time
    }
    consultation(input: $input29) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    consultationMessages(
      input: $input30
      limit: $limit12
      offset: $offset12
      order: $order11
    ) {
      count
      limit
      offset
    }
    consultations(
      input: $input31
      limit: $limit13
      offset: $offset13
      order: $order12
    ) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    doctor(doctorFilterInput: $doctorFilterInput8) {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    doctors(doctorFilterInput: $doctorFilterInput9) {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    email
    firstName
    fullName
    id
    isPharmacist
    lastName
    locale
    ninjaVanToken
    orders(input: $input32, pagination: $pagination4) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    partnerConsultDates(date: $date18) {
      date
    }
    partnerConsultTimes(date: $date19) {
      time
    }
    patient(input: $input33) {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientDocuments {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    phoneNumber
    prescriptionCalculation {
      isAffiliateLocked
      promotionCodeError
      stripePromotionCode
    }
    requireConfirmPolicy
    socialProviderType
    stripeProducts(input: $input34) {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform24)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    sysId
    tempToken
    tempTokenExpired
    userType
    utmCampaign
    utmId
    utmMedium
    utmSource
  }
}
    `;
export const useCreateShipperMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateShipperMutation, TError, CreateShipperMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateShipperMutation, TError, CreateShipperMutationVariables, TContext>(
      ['createShipper'],
      (variables?: CreateShipperMutationVariables) => fetcher<CreateShipperMutation, CreateShipperMutationVariables>(client, CreateShipperDocument, variables, headers)(),
      options
    );
export const CreateStripeCouponDocument = `
    mutation createStripeCoupon($input: CreateStripeCouponInput!) {
  createStripeCoupon(input: $input) {
    amount_off
    applies_to
    created
    currency
    duration
    duration_in_months
    id
    livemode
    max_redemptions
    metadata
    name
    object
    percent_off
    promotionCodes {
      active
      code
      coupon {
        amount_off
        applies_to
        created
        currency
        duration
        duration_in_months
        id
        livemode
        max_redemptions
        metadata
        name
        object
        percent_off
        promotionCodes {
          active
          code
          created
          customer
          expires_at
          id
          livemode
          max_redemptions
          metadata
          object
          restrictions
          times_redeemed
        }
        redeem_by
        times_redeemed
        valid
      }
      created
      customer
      expires_at
      id
      livemode
      max_redemptions
      metadata
      object
      restrictions
      times_redeemed
    }
    redeem_by
    times_redeemed
    valid
  }
}
    `;
export const useCreateStripeCouponMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateStripeCouponMutation, TError, CreateStripeCouponMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateStripeCouponMutation, TError, CreateStripeCouponMutationVariables, TContext>(
      ['createStripeCoupon'],
      (variables?: CreateStripeCouponMutationVariables) => fetcher<CreateStripeCouponMutation, CreateStripeCouponMutationVariables>(client, CreateStripeCouponDocument, variables, headers)(),
      options
    );
export const CreateStripePriceDocument = `
    mutation createStripePrice($input: CreateStripePriceInput!) {
  createStripePrice(input: $input)
}
    `;
export const useCreateStripePriceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateStripePriceMutation, TError, CreateStripePriceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateStripePriceMutation, TError, CreateStripePriceMutationVariables, TContext>(
      ['createStripePrice'],
      (variables?: CreateStripePriceMutationVariables) => fetcher<CreateStripePriceMutation, CreateStripePriceMutationVariables>(client, CreateStripePriceDocument, variables, headers)(),
      options
    );
export const CreateStripeProductDocument = `
    mutation createStripeProduct($input: CreateStripeProductInput!) {
  createStripeProduct(input: $input)
}
    `;
export const useCreateStripeProductMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateStripeProductMutation, TError, CreateStripeProductMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateStripeProductMutation, TError, CreateStripeProductMutationVariables, TContext>(
      ['createStripeProduct'],
      (variables?: CreateStripeProductMutationVariables) => fetcher<CreateStripeProductMutation, CreateStripeProductMutationVariables>(client, CreateStripeProductDocument, variables, headers)(),
      options
    );
export const CreateStripePromotionCodeDocument = `
    mutation createStripePromotionCode($input: CreateStripePromotionCodeInput!) {
  createStripePromotionCode(input: $input) {
    active
    code
    coupon {
      amount_off
      applies_to
      created
      currency
      duration
      duration_in_months
      id
      livemode
      max_redemptions
      metadata
      name
      object
      percent_off
      promotionCodes {
        active
        code
        coupon {
          amount_off
          applies_to
          created
          currency
          duration
          duration_in_months
          id
          livemode
          max_redemptions
          metadata
          name
          object
          percent_off
          redeem_by
          times_redeemed
          valid
        }
        created
        customer
        expires_at
        id
        livemode
        max_redemptions
        metadata
        object
        restrictions
        times_redeemed
      }
      redeem_by
      times_redeemed
      valid
    }
    created
    customer
    expires_at
    id
    livemode
    max_redemptions
    metadata
    object
    restrictions
    times_redeemed
  }
}
    `;
export const useCreateStripePromotionCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateStripePromotionCodeMutation, TError, CreateStripePromotionCodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateStripePromotionCodeMutation, TError, CreateStripePromotionCodeMutationVariables, TContext>(
      ['createStripePromotionCode'],
      (variables?: CreateStripePromotionCodeMutationVariables) => fetcher<CreateStripePromotionCodeMutation, CreateStripePromotionCodeMutationVariables>(client, CreateStripePromotionCodeDocument, variables, headers)(),
      options
    );
export const CreateSurveyDocument = `
    mutation createSurvey($input: CreateSurveyInput!) {
  createSurvey(input: $input)
}
    `;
export const useCreateSurveyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateSurveyMutation, TError, CreateSurveyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateSurveyMutation, TError, CreateSurveyMutationVariables, TContext>(
      ['createSurvey'],
      (variables?: CreateSurveyMutationVariables) => fetcher<CreateSurveyMutation, CreateSurveyMutationVariables>(client, CreateSurveyDocument, variables, headers)(),
      options
    );
export const DeleteAuditDoctorNoteDocument = `
    mutation deleteAuditDoctorNote($sysId: String!) {
  deleteAuditDoctorNote(sysId: $sysId)
}
    `;
export const useDeleteAuditDoctorNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAuditDoctorNoteMutation, TError, DeleteAuditDoctorNoteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteAuditDoctorNoteMutation, TError, DeleteAuditDoctorNoteMutationVariables, TContext>(
      ['deleteAuditDoctorNote'],
      (variables?: DeleteAuditDoctorNoteMutationVariables) => fetcher<DeleteAuditDoctorNoteMutation, DeleteAuditDoctorNoteMutationVariables>(client, DeleteAuditDoctorNoteDocument, variables, headers)(),
      options
    );
export const DeleteCartItemByIdDocument = `
    mutation deleteCartItemById($input: DeleteCartItemByIdInput!) {
  deleteCartItemById(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary
    calculation
    cart
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    errorCode
    paidCompletedEvaluationIds
    platform
    promotionCode
    status
    sysId
  }
}
    `;
export const useDeleteCartItemByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCartItemByIdMutation, TError, DeleteCartItemByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCartItemByIdMutation, TError, DeleteCartItemByIdMutationVariables, TContext>(
      ['deleteCartItemById'],
      (variables?: DeleteCartItemByIdMutationVariables) => fetcher<DeleteCartItemByIdMutation, DeleteCartItemByIdMutationVariables>(client, DeleteCartItemByIdDocument, variables, headers)(),
      options
    );
export const DeleteCompletedEvalDocument = `
    mutation deleteCompletedEval($input: String!) {
  deleteCompletedEval(input: $input)
}
    `;
export const useDeleteCompletedEvalMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCompletedEvalMutation, TError, DeleteCompletedEvalMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCompletedEvalMutation, TError, DeleteCompletedEvalMutationVariables, TContext>(
      ['deleteCompletedEval'],
      (variables?: DeleteCompletedEvalMutationVariables) => fetcher<DeleteCompletedEvalMutation, DeleteCompletedEvalMutationVariables>(client, DeleteCompletedEvalDocument, variables, headers)(),
      options
    );
export const DeleteOrderDocument = `
    mutation deleteOrder($input: DeleteOrderInput!) {
  deleteOrder(input: $input)
}
    `;
export const useDeleteOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteOrderMutation, TError, DeleteOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteOrderMutation, TError, DeleteOrderMutationVariables, TContext>(
      ['deleteOrder'],
      (variables?: DeleteOrderMutationVariables) => fetcher<DeleteOrderMutation, DeleteOrderMutationVariables>(client, DeleteOrderDocument, variables, headers)(),
      options
    );
export const DeleteOrderPermanentDocument = `
    mutation deleteOrderPermanent($orderId: String!) {
  deleteOrderPermanent(orderId: $orderId)
}
    `;
export const useDeleteOrderPermanentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteOrderPermanentMutation, TError, DeleteOrderPermanentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteOrderPermanentMutation, TError, DeleteOrderPermanentMutationVariables, TContext>(
      ['deleteOrderPermanent'],
      (variables?: DeleteOrderPermanentMutationVariables) => fetcher<DeleteOrderPermanentMutation, DeleteOrderPermanentMutationVariables>(client, DeleteOrderPermanentDocument, variables, headers)(),
      options
    );
export const DeletePatientDocument = `
    mutation deletePatient($email: String!) {
  deletePatient(email: $email)
}
    `;
export const useDeletePatientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePatientMutation, TError, DeletePatientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePatientMutation, TError, DeletePatientMutationVariables, TContext>(
      ['deletePatient'],
      (variables?: DeletePatientMutationVariables) => fetcher<DeletePatientMutation, DeletePatientMutationVariables>(client, DeletePatientDocument, variables, headers)(),
      options
    );
export const DeletePatientQuestionAnswerDocument = `
    mutation deletePatientQuestionAnswer($input: DeletePatientQuestionAnswerInput!) {
  deletePatientQuestionAnswer(input: $input)
}
    `;
export const useDeletePatientQuestionAnswerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePatientQuestionAnswerMutation, TError, DeletePatientQuestionAnswerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePatientQuestionAnswerMutation, TError, DeletePatientQuestionAnswerMutationVariables, TContext>(
      ['deletePatientQuestionAnswer'],
      (variables?: DeletePatientQuestionAnswerMutationVariables) => fetcher<DeletePatientQuestionAnswerMutation, DeletePatientQuestionAnswerMutationVariables>(client, DeletePatientQuestionAnswerDocument, variables, headers)(),
      options
    );
export const DeleteStripeCouponDocument = `
    mutation deleteStripeCoupon($id: String!) {
  deleteStripeCoupon(id: $id)
}
    `;
export const useDeleteStripeCouponMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteStripeCouponMutation, TError, DeleteStripeCouponMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteStripeCouponMutation, TError, DeleteStripeCouponMutationVariables, TContext>(
      ['deleteStripeCoupon'],
      (variables?: DeleteStripeCouponMutationVariables) => fetcher<DeleteStripeCouponMutation, DeleteStripeCouponMutationVariables>(client, DeleteStripeCouponDocument, variables, headers)(),
      options
    );
export const DeleteStripePriceDocument = `
    mutation deleteStripePrice($input: DeletePriceInput!) {
  deleteStripePrice(input: $input)
}
    `;
export const useDeleteStripePriceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteStripePriceMutation, TError, DeleteStripePriceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteStripePriceMutation, TError, DeleteStripePriceMutationVariables, TContext>(
      ['deleteStripePrice'],
      (variables?: DeleteStripePriceMutationVariables) => fetcher<DeleteStripePriceMutation, DeleteStripePriceMutationVariables>(client, DeleteStripePriceDocument, variables, headers)(),
      options
    );
export const DeleteStripeProductDocument = `
    mutation deleteStripeProduct($input: DeleteProductInput!) {
  deleteStripeProduct(input: $input)
}
    `;
export const useDeleteStripeProductMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteStripeProductMutation, TError, DeleteStripeProductMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteStripeProductMutation, TError, DeleteStripeProductMutationVariables, TContext>(
      ['deleteStripeProduct'],
      (variables?: DeleteStripeProductMutationVariables) => fetcher<DeleteStripeProductMutation, DeleteStripeProductMutationVariables>(client, DeleteStripeProductDocument, variables, headers)(),
      options
    );
export const DeleteTrtDocumentDocument = `
    mutation deleteTrtDocument($documentSysId: String!) {
  deleteTrtDocument(documentSysId: $documentSysId)
}
    `;
export const useDeleteTrtDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteTrtDocumentMutation, TError, DeleteTrtDocumentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteTrtDocumentMutation, TError, DeleteTrtDocumentMutationVariables, TContext>(
      ['deleteTrtDocument'],
      (variables?: DeleteTrtDocumentMutationVariables) => fetcher<DeleteTrtDocumentMutation, DeleteTrtDocumentMutationVariables>(client, DeleteTrtDocumentDocument, variables, headers)(),
      options
    );
export const DeleteUserDocument = `
    mutation deleteUser($input: String!) {
  deleteUser(input: $input)
}
    `;
export const useDeleteUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>(
      ['deleteUser'],
      (variables?: DeleteUserMutationVariables) => fetcher<DeleteUserMutation, DeleteUserMutationVariables>(client, DeleteUserDocument, variables, headers)(),
      options
    );
export const DeliveryChargeDocument = `
    mutation deliveryCharge($input: PatientIdInput) {
  deliveryCharge(input: $input)
}
    `;
export const useDeliveryChargeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeliveryChargeMutation, TError, DeliveryChargeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeliveryChargeMutation, TError, DeliveryChargeMutationVariables, TContext>(
      ['deliveryCharge'],
      (variables?: DeliveryChargeMutationVariables) => fetcher<DeliveryChargeMutation, DeliveryChargeMutationVariables>(client, DeliveryChargeDocument, variables, headers)(),
      options
    );
export const DeliveryChargeV2Document = `
    mutation deliveryChargeV2($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $deliveryChargeV2: V2DeliveryCharge!) {
  deliveryChargeV2(deliveryChargeV2: $deliveryChargeV2) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useDeliveryChargeV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeliveryChargeV2Mutation, TError, DeliveryChargeV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeliveryChargeV2Mutation, TError, DeliveryChargeV2MutationVariables, TContext>(
      ['deliveryChargeV2'],
      (variables?: DeliveryChargeV2MutationVariables) => fetcher<DeliveryChargeV2Mutation, DeliveryChargeV2MutationVariables>(client, DeliveryChargeV2Document, variables, headers)(),
      options
    );
export const DestroyFcMtokenDocument = `
    mutation destroyFCMtoken($input: FcmTokenInput!) {
  destroyFCMtoken(input: $input)
}
    `;
export const useDestroyFcMtokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DestroyFcMtokenMutation, TError, DestroyFcMtokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DestroyFcMtokenMutation, TError, DestroyFcMtokenMutationVariables, TContext>(
      ['destroyFCMtoken'],
      (variables?: DestroyFcMtokenMutationVariables) => fetcher<DestroyFcMtokenMutation, DestroyFcMtokenMutationVariables>(client, DestroyFcMtokenDocument, variables, headers)(),
      options
    );
export const DisableProductDocument = `
    mutation disableProduct($productName: String!) {
  disableProduct(productName: $productName)
}
    `;
export const useDisableProductMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DisableProductMutation, TError, DisableProductMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DisableProductMutation, TError, DisableProductMutationVariables, TContext>(
      ['disableProduct'],
      (variables?: DisableProductMutationVariables) => fetcher<DisableProductMutation, DisableProductMutationVariables>(client, DisableProductDocument, variables, headers)(),
      options
    );
export const DuplicateStripePriceDocument = `
    mutation duplicateStripePrice($input: DuplicateStripePriceInput!) {
  duplicateStripePrice(input: $input)
}
    `;
export const useDuplicateStripePriceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DuplicateStripePriceMutation, TError, DuplicateStripePriceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DuplicateStripePriceMutation, TError, DuplicateStripePriceMutationVariables, TContext>(
      ['duplicateStripePrice'],
      (variables?: DuplicateStripePriceMutationVariables) => fetcher<DuplicateStripePriceMutation, DuplicateStripePriceMutationVariables>(client, DuplicateStripePriceDocument, variables, headers)(),
      options
    );
export const GenerateSmartMatchResultsDocument = `
    mutation generateSmartMatchResults($platform: String, $platform1: String, $platform2: String, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $input: GenerateSmartMatchResultsInput!) {
  generateSmartMatchResults(input: $input) {
    evalId
    smartMatchResults {
      analysis
      nextSteps {
        evidence
        text
      }
      primaryProduct {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredientDetails {
              description
              imageLink
              locale
              name
              strength
              uniqueName
            }
            ingredients
            isConsultOnly(platform: $platform)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            prices {
              active
              alternativePrice {
                active
                alternativePrice {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform2)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                nickname
                product
                productId
                shopDisplay
                sysId
                tax_behavior
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                ingredients
                isConsultOnly(platform: $platform3)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              texts {
                actual_price_display
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                price_frequency
                price_quantity
                quantity
                quantity_display
              }
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            productInstructions {
              language
              localeKey
              productId
              sysId
              translatedText
            }
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            tempPrices {
              active
              alternativePrice {
                active
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                nickname
                product
                productId
                shopDisplay
                sysId
                tax_behavior
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                ingredients
                isConsultOnly(platform: $platform4)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              texts {
                actual_price_display
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                price_frequency
                price_quantity
                quantity
                quantity_display
              }
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            texts {
              benefits
              category
              display_price
              display_price_patient
              dosage_variant_body
              dosage_variant_title
              effective_in
              for
              frequency_variant_title
              good_to_know
              how_to_take
              how_to_use
              is_popular
              lasts_for
              platform
              product_description
              product_name
              product_short_description
              quantity_per_unit
              quantity_variant_title
              requires_prescription
              safety_information
              side_effects
              strength
              taken
              unit
              unit_patient
            }
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredients
          isConsultOnly(platform: $platform5)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform6)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      secondaryProducts {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform7)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform8)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
    }
    status
    sysId
    userId
    userType
  }
}
    `;
export const useGenerateSmartMatchResultsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GenerateSmartMatchResultsMutation, TError, GenerateSmartMatchResultsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GenerateSmartMatchResultsMutation, TError, GenerateSmartMatchResultsMutationVariables, TContext>(
      ['generateSmartMatchResults'],
      (variables?: GenerateSmartMatchResultsMutationVariables) => fetcher<GenerateSmartMatchResultsMutation, GenerateSmartMatchResultsMutationVariables>(client, GenerateSmartMatchResultsDocument, variables, headers)(),
      options
    );
export const GetLastInvoiceDateDocument = `
    mutation getLastInvoiceDate($subscriptionId: String!) {
  getLastInvoiceDate(subscriptionId: $subscriptionId) {
    auto_advance
    charge
    collection_method
    created
    currency
    description
    hosted_invoice_url
    id
    lines
    metadata
    next_payment_attempt
    payment_intent
    period_end
    period_start
    status
    subscription
    total
  }
}
    `;
export const useGetLastInvoiceDateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GetLastInvoiceDateMutation, TError, GetLastInvoiceDateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GetLastInvoiceDateMutation, TError, GetLastInvoiceDateMutationVariables, TContext>(
      ['getLastInvoiceDate'],
      (variables?: GetLastInvoiceDateMutationVariables) => fetcher<GetLastInvoiceDateMutation, GetLastInvoiceDateMutationVariables>(client, GetLastInvoiceDateDocument, variables, headers)(),
      options
    );
export const GetUpcomingInvoiceDateDocument = `
    mutation getUpcomingInvoiceDate($subscriptionId: String!) {
  getUpcomingInvoiceDate(subscriptionId: $subscriptionId) {
    auto_advance
    charge
    collection_method
    created
    currency
    description
    hosted_invoice_url
    id
    lines
    metadata
    next_payment_attempt
    payment_intent
    period_end
    period_start
    status
    subscription
    total
  }
}
    `;
export const useGetUpcomingInvoiceDateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GetUpcomingInvoiceDateMutation, TError, GetUpcomingInvoiceDateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GetUpcomingInvoiceDateMutation, TError, GetUpcomingInvoiceDateMutationVariables, TContext>(
      ['getUpcomingInvoiceDate'],
      (variables?: GetUpcomingInvoiceDateMutationVariables) => fetcher<GetUpcomingInvoiceDateMutation, GetUpcomingInvoiceDateMutationVariables>(client, GetUpcomingInvoiceDateDocument, variables, headers)(),
      options
    );
export const GuestFirstCheckoutDocument = `
    mutation guestFirstCheckout($id: String, $platform: String, $platform1: String, $platform2: String, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform9: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform10: String, $id1: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id2: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform11: String, $platform12: String, $platform13: String, $platform14: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform15: String, $videoLink1: String!, $patientId: String, $input4: CrossSellRecordQueryInput, $orderId: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId1: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId2: String, $limit2: Int, $offset2: Int, $order1: JSON, $acuityAppointmentId2: String, $date2: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date3: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $input5: V2ConsultationFilterInput!, $input6: ConsultationMessagesInput!, $limit3: Int, $offset3: Int, $order2: JSON, $input7: ConsultationListInput!, $limit4: Int, $offset4: Int, $order3: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input8: OrderInput!, $pagination: V2PaginationInput!, $date4: String, $date5: Float, $input9: GetPatientInput, $platform16: String, $input10: StripeProductFilterV2, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit5: Int, $offset5: Int, $order4: JSON, $input13: ConsultationListInput!, $limit6: Int, $offset6: Int, $order5: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform17: String, $input16: StripeProductFilterV2, $doctorFilterInput3: V2DoctorInputFilter, $limit7: Int, $offset7: Int, $order6: JSON, $checkoutSessionFilterOptions1: CheckoutSessionFilterInput, $inputConsultation5: V2ConsultationFilterInput, $input17: GetPatientDocumentInput!, $evalFilter1: V2PatientEvaluationFilterInput, $id3: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform18: String, $inputOrder2: V2OrderFilterInput, $orderPagination2: V2PaginationInput, $input18: PrescriptionCalculationInput, $platform19: String, $platform20: String, $filter1: ShopProductFilterInputV2, $limit8: Float, $offset8: Float, $sort1: ShopProductSortInputV2, $input19: GetSmartMatchMetaInput!, $input20: PatientGetSurveyInput, $videoLink3: String!, $previewVideoLink1: String!, $input21: GuestRegisterAndEvalResultInput!) {
  guestFirstCheckout(input: $input21) {
    atomePayment(id: $id) {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    bypassLoginTokens {
      expiresAt
      pageName
      token
      type
    }
    cart {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      cartItems {
        cart {
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          orderSummary {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            discountAmountLater
            discountAmountNow
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountBeforeTax
            paymentIntentSummary
            promotionCode
            shippingFee
            subTotal
            subTotalLater
            subTotalNow
            taxes
            taxesLater
            taxesNow
            teleConsultFee
            total
            totalLater
            totalNow
            totalNowAfterCashback
            totalTaxes
          }
          paidCompletedEvaluationIds
          platform
          promotionCode
          status
          sysId
        }
        completedEval
        consultationSessionType
        isAutoRenewal
        isSkipMedSelecting
        isSubscriptionPrice
        orderId
        patientNote
        price {
          active
          alternativePrice {
            active
            alternativePrice {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                drDosageFrequency {
                  alternativeDosage
                  alternativeDosageUnit
                  asNeeded
                  dosage
                  dosageUnit
                  duration
                  durationUnit
                  frequency
                  productId
                  quantity
                  quantityUnit
                }
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredients
                  isConsultOnly(platform: $platform1)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                ingredientDetails {
                  description
                  imageLink
                  locale
                  name
                  strength
                  uniqueName
                }
                ingredients
                isConsultOnly(platform: $platform2)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                prices {
                  active
                  alternativePrice {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform3)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          metadata {
            actual_price_display
            boxes
            dosage
            dosage_display
            dosage_popular
            frequency
            frequency_actual_price_display
            frequency_display
            frequency_popular
            frequency_price_display
            frequency_quantity_display
            frequency_quantity_display_patient
            frequency_savings_display
            frequency_strikeout_price_display
            isArchived
            isOneTimePrice
            price_frequency
            price_quantity
            price_show
            quantity
            quantity_display
            strength
          }
          nickname
          product
          productId
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform4)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          shopDisplay
          sysId
          tax_behavior
          texts {
            actual_price_display
            dosage
            dosage_display
            dosage_popular
            frequency
            frequency_actual_price_display
            frequency_display
            frequency_popular
            frequency_price_display
            frequency_quantity_display
            frequency_quantity_display_patient
            frequency_savings_display
            frequency_strikeout_price_display
            price_frequency
            price_quantity
            quantity
            quantity_display
          }
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        product {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform5)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredientDetails {
            description
            imageLink
            locale
            name
            strength
            uniqueName
          }
          ingredients
          isConsultOnly(platform: $platform6)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          prices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInstructions {
            language
            localeKey
            productId
            sysId
            translatedText
          }
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          tempPrices {
            active
            alternativePrice {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            metadata {
              actual_price_display
              boxes
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              isArchived
              isOneTimePrice
              price_frequency
              price_quantity
              price_show
              quantity
              quantity_display
              strength
            }
            nickname
            product
            productId
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform7)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            shopDisplay
            sysId
            tax_behavior
            texts {
              actual_price_display
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              price_frequency
              price_quantity
              quantity
              quantity_display
            }
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          texts {
            benefits
            category
            display_price
            display_price_patient
            dosage_variant_body
            dosage_variant_title
            effective_in
            for
            frequency_variant_title
            good_to_know
            how_to_take
            how_to_use
            is_popular
            lasts_for
            platform
            product_description
            product_name
            product_short_description
            quantity_per_unit
            quantity_variant_title
            requires_prescription
            safety_information
            side_effects
            strength
            taken
            unit
            unit_patient
          }
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        quantity
        teleConsultForSkipEval
        type
      }
      paidCompletedEvaluationIds
      platform
      promotionCode
      status
      sysId
    }
    cashback {
      availableBalance
      recentTransactions {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
      savingsToDateThisYear {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
    }
    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions1) {
      checkoutData
      evaluationId
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          consultationAudit {
            consultTime
            consultType
            createdBy
            doctor {
              active
              bio {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              calendarId
              consultation(videoLink: $videoLink1) {
                gmeetLink
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id1) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform13)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform14)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform15)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                previewToken
                previewVideoLink
                status
                sysId
                token
                videoChannelId
                videoLink
                zoomJoinUrl
              }
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              patient(patientId: $patientId) {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sysId
              textConsultPostalCodes
              trtEligible
              user {
                admin {
                  crossSellRecords(input: $input4) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId
                  date: $date
                  forDelivery: $forDelivery
                  isReschedule: $isReschedule
                  orderId: $orderId1
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId1
                  consultDate: $consultDate
                  date: $date1
                  forDelivery: $forDelivery1
                  isReschedule: $isReschedule1
                  orderId: $orderId2
                ) {
                  time
                }
                consultation(input: $input11) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit2, offset: $offset2, order: $order1) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId2
                      date: $date2
                      forDelivery: $forDelivery2
                      isReschedule: $isReschedule2
                      orderId: $orderId3
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId3
                      consultDate: $consultDate1
                      date: $date3
                      forDelivery: $forDelivery3
                      isReschedule: $isReschedule3
                      orderId: $orderId4
                    ) {
                      time
                    }
                    consultation(input: $input5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input6
                      limit: $limit3
                      offset: $offset3
                      order: $order2
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input7, limit: $limit4, offset: $offset4, order: $order3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input8, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date4) {
                      date
                    }
                    partnerConsultTimes(date: $date5) {
                      time
                    }
                    patient(input: $input9) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input10) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform16)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input12
                  limit: $limit5
                  offset: $offset5
                  order: $order4
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input13, limit: $limit6, offset: $offset6, order: $order5) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input14, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input15) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input16) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            evaluationId
            sessionType
            status
            sysId
          }
          consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
            count
            limit
            offset
          }
          consultationTitle {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          countReminder
          createdAt
          doctor {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          messages {
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
          }
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          orderSysId
          participants {
            avatar
            fullName
            identity
            locale
            role
            token
            userSysId
          }
          participantsV2 {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            phoneNumber
            requireConfirmPolicy
            socialProviderType
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation5) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    document(input: $input17) {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    documents {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    email
    evaluations(evalFilter: $evalFilter1) {
      isCompleted
      isSkipped
      name
      patientAnswers {
        answer {
          childrenAnswers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        question {
          answers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          content {
            body {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            footer {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            header {
              description
              descriptionTextKey
              title
              titleTextKey
            }
          }
          dependentEvaluationQuestions {
            answer {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            skipPage
            skipQuestionCount
            sysId
          }
          displayPage
          evaluationBlocks {
            blockAnswer {
              childrenAnswers {
                deselectAll
                mandatory
                name
                order
                placeholder
                productUrl
                sysId
                textKey
                type
              }
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            content {
              description
              descriptionTextKey
              sysId
              title
              titleTextKey
            }
            sysId
          }
          guestOnly
          name
          order
          sysId
          textKey
          type
          validation {
            bmi
            extra
            max
            min
            preselect
            type
          }
        }
        type
        value
      }
      patientNote
      platform
      questions {
        answers {
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        dependentEvaluationQuestions {
          skipPage
          skipQuestionCount
          sysId
        }
        displayPage
        evaluationBlocks {
          sysId
        }
        guestOnly
        name
        order
        sysId
        textKey
        type
        validation {
          bmi
          extra
          max
          min
          preselect
          type
        }
      }
      status
      sysId
      type
    }
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    idVerifiedAt
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    latestPaymentMethod {
      card {
        brand
        exp_month
        exp_year
        last4
      }
      id
    }
    legalName
    locale
    mounjaroTrialEligible
    order(id: $id3) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    orders(inputOrder: $inputOrder2, orderPagination: $orderPagination2) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      activeConsultation {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      acuityAppointment {
        appointmentTypeID
        bookedAt
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        bookedAt
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      additionalPrices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      afterVideoConsultRedirecting {
        baseUrl
        path
      }
      approveAt
      atomeNextSendingInvoiceDate
      atomePayments {
        amount
        paymentUrl
        priceId
        referenceId
        status
        sysId
      }
      checkoutSession {
        checkoutData
        evaluationId
        status
        sysId
      }
      childrenOrders {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      claimedRetentionOffer
      consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
        consultTime
        consultType
        createdBy
        evaluationId
        sessionType
        status
        sysId
      }
      consultations(inputConsultation: $inputConsultation6) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluation {
        isCompleted
        isSkipped
        name
        patientNote
        platform
        status
        sysId
        type
      }
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      latestAtomePayment {
        amount
        paymentUrl
        priceId
        referenceId
        status
        sysId
      }
      latestInvoice {
        amount_due
        hosted_invoice_url
        id
        next_payment_attempt
        paid
        paymentStatus
        period_end
        starting_balance
        status
        subtotal
        tax
        total
      }
      latestNote {
        content
        createdAt
        createdBy
        sysId
        updatedAt
      }
      nextReviewDate
      oldPrice
      oldPriceInfo {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescribed_after_trial_order_sys_id
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      price {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      priceDisplayId
      priceInfo {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        ingredients
        isConsultOnly(platform: $platform18)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      siblingCrossSellOrders {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      status
      stripePaymentIntentId
      stripeSubscriptionId
      subscription {
        cancel_at_period_end
        current_period_end
        current_period_start
        default_payment_method
        id
        items
        latest_invoice
        metadata
        pause_collection
        pending_setup_intent
        pending_update
        status
      }
      sysId
      teleConsultProduct
      upcomingInvoice {
        amount_due
        hosted_invoice_url
        id
        next_payment_attempt
        paid
        paymentStatus
        period_end
        starting_balance
        status
        subtotal
        tax
        total
      }
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    prescriptionCalculation(input: $input18) {
      affiliateCouponNotApplied {
        affiliateProductDisplayName
        reason
      }
      isAffiliateLocked
      otcCalculationSummary {
        otcOrdersCalculation {
          basePrice
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          discountAmount
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          stripePromotionCode
          tax
          transactionFee
        }
        totalBasePrice
        totalCashbackEarned
        totalCashbackRedeemed
        totalPaymentIntentAmount
        totalTax
        totalTransactionFee
      }
      promotionCodeError
      rxCalculationSummary {
        rxOrdersCalculation {
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          consultBasePrice
          consultFee
          consultFeeAfterDiscount
          consultTax
          consultTransactionFee
          discountAmount
          isConsult
          mainBasePrice
          mainTax
          mainTransactionFee
          minimalAmountPayment
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          shouldChargeConsultFee
          subTotal
          total
          totalAfterCashback
        }
        total
        totalCashbackEarned
        totalCashbackRedeemed
        totalDiscountAmount
        totalMainBasePrice
        totalPaymentIntentAmount
        totalPaymentIntentAmountAfterCashback
        totalTax
        totalTransactionFee
      }
      stripePromotionCode
    }
    referralCode
    referrals {
      doctor {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      doctorId
      documents {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      items {
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        orderId
        price {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        priceId
        referralSysId
        sysId
      }
      sysId
    }
    shopProducts(filter: $filter1, limit: $limit8, offset: $offset8, sort: $sort1) {
      count
      items {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform19)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform20)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      limit
      offset
    }
    smartMatchMeta(input: $input19) {
      evalId
      status
      sysId
      userId
      userType
    }
    stripeCustomer
    stripeCustomerId
    survey(input: $input20) {
      answers
      isSkipped
      patientSysId
      sysId
      type
    }
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      phoneNumber
      requireConfirmPolicy
      socialProviderType
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    userSysId
    videoConsultation(videoLink: $videoLink3) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
    videoConsultationPreview(previewVideoLink: $previewVideoLink1) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
    weight
  }
}
    `;
export const useGuestFirstCheckoutMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GuestFirstCheckoutMutation, TError, GuestFirstCheckoutMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GuestFirstCheckoutMutation, TError, GuestFirstCheckoutMutationVariables, TContext>(
      ['guestFirstCheckout'],
      (variables?: GuestFirstCheckoutMutationVariables) => fetcher<GuestFirstCheckoutMutation, GuestFirstCheckoutMutationVariables>(client, GuestFirstCheckoutDocument, variables, headers)(),
      options
    );
export const HosOpsAlertActionDocument = `
    mutation hosOpsAlertAction($alertId: ID!, $action: HosOpsAlertAction!, $note: String) {
  hosOpsAlertAction(alertId: $alertId, action: $action, note: $note) {
    id
    kind
    patientLabel
    flagId
    flagState
    flagLive
    flagOpsClearable
    ruleId
    severity
    source
    status
    summary
    classifierRationale
    instructionCopyKey
    playbookCopyKeys
    playbookSteps {
      order
      instruction
      owner
      slaMinutes
      copyKey
    }
    deliveries {
      channel
      status
      providerId
      attemptedAt
      reason
    }
    slackPosted
    freshchatConversationId
    patientChannels
    opsChannels
    patientAcknowledgedAt
    firedAt
    lastSeenAt
    recurrenceCount
    ackedAt
    ackedBy
    closedAt
    actionEntries {
      action
      note
      actor
      at
    }
  }
}
    `;
export const useHosOpsAlertActionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<HosOpsAlertActionMutation, TError, HosOpsAlertActionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<HosOpsAlertActionMutation, TError, HosOpsAlertActionMutationVariables, TContext>(
      ['hosOpsAlertAction'],
      (variables?: HosOpsAlertActionMutationVariables) => fetcher<HosOpsAlertActionMutation, HosOpsAlertActionMutationVariables>(client, HosOpsAlertActionDocument, variables, headers)(),
      options
    );
export const HosOpsAlertClearFlagDocument = `
    mutation hosOpsAlertClearFlag($alertId: ID!, $reason: HosOpsFlagClearReason!, $note: String) {
  hosOpsAlertClearFlag(alertId: $alertId, reason: $reason, note: $note) {
    id
    kind
    patientLabel
    flagId
    flagState
    flagLive
    flagOpsClearable
    ruleId
    severity
    source
    status
    summary
    classifierRationale
    instructionCopyKey
    playbookCopyKeys
    playbookSteps {
      order
      instruction
      owner
      slaMinutes
      copyKey
    }
    deliveries {
      channel
      status
      providerId
      attemptedAt
      reason
    }
    slackPosted
    freshchatConversationId
    patientChannels
    opsChannels
    patientAcknowledgedAt
    firedAt
    lastSeenAt
    recurrenceCount
    ackedAt
    ackedBy
    closedAt
    actionEntries {
      action
      note
      actor
      at
    }
  }
}
    `;
export const useHosOpsAlertClearFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<HosOpsAlertClearFlagMutation, TError, HosOpsAlertClearFlagMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<HosOpsAlertClearFlagMutation, TError, HosOpsAlertClearFlagMutationVariables, TContext>(
      ['hosOpsAlertClearFlag'],
      (variables?: HosOpsAlertClearFlagMutationVariables) => fetcher<HosOpsAlertClearFlagMutation, HosOpsAlertClearFlagMutationVariables>(client, HosOpsAlertClearFlagDocument, variables, headers)(),
      options
    );
export const HosOpsAlertRevealDocument = `
    mutation hosOpsAlertReveal($id: ID!, $reason: String) {
  hosOpsAlertReveal(id: $id, reason: $reason) {
    alertId
    sourceText
    revealedAt
  }
}
    `;
export const useHosOpsAlertRevealMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<HosOpsAlertRevealMutation, TError, HosOpsAlertRevealMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<HosOpsAlertRevealMutation, TError, HosOpsAlertRevealMutationVariables, TContext>(
      ['hosOpsAlertReveal'],
      (variables?: HosOpsAlertRevealMutationVariables) => fetcher<HosOpsAlertRevealMutation, HosOpsAlertRevealMutationVariables>(client, HosOpsAlertRevealDocument, variables, headers)(),
      options
    );
export const ImpersonateDocument = `
    mutation impersonate($input: ImpersonateInput!) {
  impersonate(input: $input) {
    accessToken
    accessTokenExpiredAt
    refreshToken
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useImpersonateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImpersonateMutation, TError, ImpersonateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImpersonateMutation, TError, ImpersonateMutationVariables, TContext>(
      ['impersonate'],
      (variables?: ImpersonateMutationVariables) => fetcher<ImpersonateMutation, ImpersonateMutationVariables>(client, ImpersonateDocument, variables, headers)(),
      options
    );
export const ImportProductsAndPricesDocument = `
    mutation importProductsAndPrices($input: V2ImportProductPricesInput!) {
  importProductsAndPrices(input: $input) {
    importErrors {
      error
      importPriceId
      productId
    }
  }
}
    `;
export const useImportProductsAndPricesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportProductsAndPricesMutation, TError, ImportProductsAndPricesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportProductsAndPricesMutation, TError, ImportProductsAndPricesMutationVariables, TContext>(
      ['importProductsAndPrices'],
      (variables?: ImportProductsAndPricesMutationVariables) => fetcher<ImportProductsAndPricesMutation, ImportProductsAndPricesMutationVariables>(client, ImportProductsAndPricesDocument, variables, headers)(),
      options
    );
export const InsertCartItemByIdDocument = `
    mutation insertCartItemById($input: InsertCartItemByIdInput!) {
  insertCartItemById(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary
    calculation
    cart
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    errorCode
    paidCompletedEvaluationIds
    platform
    promotionCode
    status
    sysId
  }
}
    `;
export const useInsertCartItemByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertCartItemByIdMutation, TError, InsertCartItemByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<InsertCartItemByIdMutation, TError, InsertCartItemByIdMutationVariables, TContext>(
      ['insertCartItemById'],
      (variables?: InsertCartItemByIdMutationVariables) => fetcher<InsertCartItemByIdMutation, InsertCartItemByIdMutationVariables>(client, InsertCartItemByIdDocument, variables, headers)(),
      options
    );
export const IsAutoRenewalSubDocument = `
    mutation isAutoRenewalSub($input: IsAutoRenewalSubInput!) {
  isAutoRenewalSub(input: $input)
}
    `;
export const useIsAutoRenewalSubMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<IsAutoRenewalSubMutation, TError, IsAutoRenewalSubMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<IsAutoRenewalSubMutation, TError, IsAutoRenewalSubMutationVariables, TContext>(
      ['isAutoRenewalSub'],
      (variables?: IsAutoRenewalSubMutationVariables) => fetcher<IsAutoRenewalSubMutation, IsAutoRenewalSubMutationVariables>(client, IsAutoRenewalSubDocument, variables, headers)(),
      options
    );
export const LogInDocument = `
    mutation logIn($input: LoginInput!) {
  logIn(input: $input) {
    accessToken
    accessTokenExpiredAt
    refreshToken
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useLogInMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<LogInMutation, TError, LogInMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<LogInMutation, TError, LogInMutationVariables, TContext>(
      ['logIn'],
      (variables?: LogInMutationVariables) => fetcher<LogInMutation, LogInMutationVariables>(client, LogInDocument, variables, headers)(),
      options
    );
export const LogInGoogleDocument = `
    mutation logInGoogle($input: LoginSocialInput!) {
  logInGoogle(input: $input) {
    accessToken
    accessTokenExpiredAt
    refreshToken
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useLogInGoogleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<LogInGoogleMutation, TError, LogInGoogleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<LogInGoogleMutation, TError, LogInGoogleMutationVariables, TContext>(
      ['logInGoogle'],
      (variables?: LogInGoogleMutationVariables) => fetcher<LogInGoogleMutation, LogInGoogleMutationVariables>(client, LogInGoogleDocument, variables, headers)(),
      options
    );
export const LogInLineDocument = `
    mutation logInLine($input: LoginSocialInput!) {
  logInLine(input: $input) {
    accessToken
    accessTokenExpiredAt
    refreshToken
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useLogInLineMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<LogInLineMutation, TError, LogInLineMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<LogInLineMutation, TError, LogInLineMutationVariables, TContext>(
      ['logInLine'],
      (variables?: LogInLineMutationVariables) => fetcher<LogInLineMutation, LogInLineMutationVariables>(client, LogInLineDocument, variables, headers)(),
      options
    );
export const LogOutUserSessionDocument = `
    mutation logOutUserSession($input: LogOutUserSessionInput!) {
  logOutUserSession(input: $input)
}
    `;
export const useLogOutUserSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<LogOutUserSessionMutation, TError, LogOutUserSessionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<LogOutUserSessionMutation, TError, LogOutUserSessionMutationVariables, TContext>(
      ['logOutUserSession'],
      (variables?: LogOutUserSessionMutationVariables) => fetcher<LogOutUserSessionMutation, LogOutUserSessionMutationVariables>(client, LogOutUserSessionDocument, variables, headers)(),
      options
    );
export const MarkNoShowDocument = `
    mutation markNoShow($input: MarkNoShowInput!) {
  markNoShow(input: $input)
}
    `;
export const useMarkNoShowMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MarkNoShowMutation, TError, MarkNoShowMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MarkNoShowMutation, TError, MarkNoShowMutationVariables, TContext>(
      ['markNoShow'],
      (variables?: MarkNoShowMutationVariables) => fetcher<MarkNoShowMutation, MarkNoShowMutationVariables>(client, MarkNoShowDocument, variables, headers)(),
      options
    );
export const MarkRetentionPromoRedeemedDocument = `
    mutation markRetentionPromoRedeemed($input: MarkRetentionPromoRedeemedInput!) {
  markRetentionPromoRedeemed(input: $input)
}
    `;
export const useMarkRetentionPromoRedeemedMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MarkRetentionPromoRedeemedMutation, TError, MarkRetentionPromoRedeemedMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MarkRetentionPromoRedeemedMutation, TError, MarkRetentionPromoRedeemedMutationVariables, TContext>(
      ['markRetentionPromoRedeemed'],
      (variables?: MarkRetentionPromoRedeemedMutationVariables) => fetcher<MarkRetentionPromoRedeemedMutation, MarkRetentionPromoRedeemedMutationVariables>(client, MarkRetentionPromoRedeemedDocument, variables, headers)(),
      options
    );
export const MassUpdateCustomerBalanceDocument = `
    mutation massUpdateCustomerBalance($input: UpdateCustomerBalanceInput!) {
  massUpdateCustomerBalance(input: $input) {
    errorCustomers
    notFoundCustomers
    success
  }
}
    `;
export const useMassUpdateCustomerBalanceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MassUpdateCustomerBalanceMutation, TError, MassUpdateCustomerBalanceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MassUpdateCustomerBalanceMutation, TError, MassUpdateCustomerBalanceMutationVariables, TContext>(
      ['massUpdateCustomerBalance'],
      (variables?: MassUpdateCustomerBalanceMutationVariables) => fetcher<MassUpdateCustomerBalanceMutation, MassUpdateCustomerBalanceMutationVariables>(client, MassUpdateCustomerBalanceDocument, variables, headers)(),
      options
    );
export const MigrateArchivePricesDocument = `
    mutation migrateArchivePrices {
  migrateArchivePrices
}
    `;
export const useMigrateArchivePricesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MigrateArchivePricesMutation, TError, MigrateArchivePricesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MigrateArchivePricesMutation, TError, MigrateArchivePricesMutationVariables, TContext>(
      ['migrateArchivePrices'],
      (variables?: MigrateArchivePricesMutationVariables) => fetcher<MigrateArchivePricesMutation, MigrateArchivePricesMutationVariables>(client, MigrateArchivePricesDocument, variables, headers)(),
      options
    );
export const MigrateDoctorToTwilioUserDocument = `
    mutation migrateDoctorToTwilioUser {
  migrateDoctorToTwilioUser
}
    `;
export const useMigrateDoctorToTwilioUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MigrateDoctorToTwilioUserMutation, TError, MigrateDoctorToTwilioUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MigrateDoctorToTwilioUserMutation, TError, MigrateDoctorToTwilioUserMutationVariables, TContext>(
      ['migrateDoctorToTwilioUser'],
      (variables?: MigrateDoctorToTwilioUserMutationVariables) => fetcher<MigrateDoctorToTwilioUserMutation, MigrateDoctorToTwilioUserMutationVariables>(client, MigrateDoctorToTwilioUserDocument, variables, headers)(),
      options
    );
export const MigratePausedToActiveDocument = `
    mutation migratePausedToActive {
  migratePausedToActive
}
    `;
export const useMigratePausedToActiveMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MigratePausedToActiveMutation, TError, MigratePausedToActiveMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MigratePausedToActiveMutation, TError, MigratePausedToActiveMutationVariables, TContext>(
      ['migratePausedToActive'],
      (variables?: MigratePausedToActiveMutationVariables) => fetcher<MigratePausedToActiveMutation, MigratePausedToActiveMutationVariables>(client, MigratePausedToActiveDocument, variables, headers)(),
      options
    );
export const MigrateProductIncludedDocument = `
    mutation migrateProductIncluded($input: String!) {
  migrateProductIncluded(input: $input)
}
    `;
export const useMigrateProductIncludedMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MigrateProductIncludedMutation, TError, MigrateProductIncludedMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MigrateProductIncludedMutation, TError, MigrateProductIncludedMutationVariables, TContext>(
      ['migrateProductIncluded'],
      (variables?: MigrateProductIncludedMutationVariables) => fetcher<MigrateProductIncludedMutation, MigrateProductIncludedMutationVariables>(client, MigrateProductIncludedDocument, variables, headers)(),
      options
    );
export const MigrateUserToTwilioUserDocument = `
    mutation migrateUserToTwilioUser {
  migrateUserToTwilioUser
}
    `;
export const useMigrateUserToTwilioUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MigrateUserToTwilioUserMutation, TError, MigrateUserToTwilioUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MigrateUserToTwilioUserMutation, TError, MigrateUserToTwilioUserMutationVariables, TContext>(
      ['migrateUserToTwilioUser'],
      (variables?: MigrateUserToTwilioUserMutationVariables) => fetcher<MigrateUserToTwilioUserMutation, MigrateUserToTwilioUserMutationVariables>(client, MigrateUserToTwilioUserDocument, variables, headers)(),
      options
    );
export const OpsChangeDeliveryWindowDocument = `
    mutation opsChangeDeliveryWindow($input: OpsChangeDeliveryWindowInput!) {
  opsChangeDeliveryWindow(input: $input)
}
    `;
export const useOpsChangeDeliveryWindowMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<OpsChangeDeliveryWindowMutation, TError, OpsChangeDeliveryWindowMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<OpsChangeDeliveryWindowMutation, TError, OpsChangeDeliveryWindowMutationVariables, TContext>(
      ['opsChangeDeliveryWindow'],
      (variables?: OpsChangeDeliveryWindowMutationVariables) => fetcher<OpsChangeDeliveryWindowMutation, OpsChangeDeliveryWindowMutationVariables>(client, OpsChangeDeliveryWindowDocument, variables, headers)(),
      options
    );
export const OpsChargeOtcOrderDocument = `
    mutation opsChargeOTCOrder($input: OPSChargeOTCOrderInput!) {
  opsChargeOTCOrder(input: $input)
}
    `;
export const useOpsChargeOtcOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<OpsChargeOtcOrderMutation, TError, OpsChargeOtcOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<OpsChargeOtcOrderMutation, TError, OpsChargeOtcOrderMutationVariables, TContext>(
      ['opsChargeOTCOrder'],
      (variables?: OpsChargeOtcOrderMutationVariables) => fetcher<OpsChargeOtcOrderMutation, OpsChargeOtcOrderMutationVariables>(client, OpsChargeOtcOrderDocument, variables, headers)(),
      options
    );
export const PartnerBookConsultationDocument = `
    mutation partnerBookConsultation($platform: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform9: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform10: String, $input9: StripeProductFilterV2, $limit4: Int, $offset4: Int, $order3: JSON, $patientId: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input12: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $doctorFilterInput3: V2DoctorInputFilter, $input13: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input14: GetPatientInput, $platform11: String, $input15: StripeProductFilterV2, $input16: V2ConsultationFilterInput!, $videoLink1: String!, $limit8: Int, $offset8: Int, $order7: JSON, $input17: CreatePartnerConsultation!) {
  partnerBookConsultation(input: $input17) {
    consultationAudit {
      consultTime
      consultType
      createdBy
      doctor {
        active
        bio {
          createdAt
          createdBy
          remark
          sysId
          translationKey
          updatedAt
          updatedBy
          valueEn
          valueJa
          valueZh
        }
        calendarId
        consultation(videoLink: $videoLink1) {
          gmeetLink
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            activeConsultation {
              consultationAudit {
                consultTime
                consultType
                createdBy
                evaluationId
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sessionType
                status
                sysId
              }
              consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                count
                items {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                limit
                offset
              }
              consultationTitle {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              countReminder
              createdAt
              doctor {
                active
                calendarId
                country
                designation
                duration
                email
                firstName
                fullName
                lastName
                patient(patientId: $patientId) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sysId
                textConsultPostalCodes
                trtEligible
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              messages {
                automatedMessage {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                consultationSysId
                content
                createdAt
                readAt
                sysId
                updatedAt
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              orderSysId
              participants {
                avatar
                fullName
                identity
                locale
                role
                token
                userSysId
              }
              participantsV2 {
                admin {
                  crossSellRecords(input: $input10) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId2
                  date: $date4
                  forDelivery: $forDelivery2
                  isReschedule: $isReschedule2
                  orderId: $orderId3
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId3
                  consultDate: $consultDate1
                  date: $date5
                  forDelivery: $forDelivery3
                  isReschedule: $isReschedule3
                  orderId: $orderId4
                ) {
                  time
                }
                consultation(input: $input16) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                    count
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    consultationMessages(
                      input: $input11
                      limit: $limit6
                      offset: $offset6
                      order: $order5
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input12, limit: $limit7, offset: $offset7, order: $order6) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput2) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput3) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input13, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input14) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input15) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          previewToken
          previewVideoLink
          status
          sysId
          token
          videoChannelId
          videoLink
          zoomJoinUrl
        }
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      evaluationId
      sessionType
      status
      sysId
    }
    consultationMessages(limit: $limit8, offset: $offset8, order: $order7) {
      count
      limit
      offset
    }
    consultationTitle {
      createdAt
      createdBy
      remark
      sysId
      translationKey
      updatedAt
      updatedBy
      valueEn
      valueJa
      valueZh
    }
    countReminder
    createdAt
    doctor {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    doctorChatToken
    doctorSysId
    friendlyName
    gmeetLink
    isActive
    isRead
    isVideoConsultRescheduled
    lastMsgSysId
    lastMsgUserId
    messages {
      consultationSysId
      content
      createdAt
      readAt
      sysId
      updatedAt
    }
    order {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    orderSysId
    participants {
      avatar
      fullName
      identity
      locale
      role
      token
      userSysId
    }
    participantsV2 {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      phoneNumber
      requireConfirmPolicy
      socialProviderType
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    patientChatToken
    patientEmail
    prescribedAt
    previewVideoLink
    progressStatus
    readAt
    reviewDate
    status
    sysId
    textConsultStatus
    textConversationId
    type
    updatedAt
    videoChannelId
    videoLink
  }
}
    `;
export const usePartnerBookConsultationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PartnerBookConsultationMutation, TError, PartnerBookConsultationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PartnerBookConsultationMutation, TError, PartnerBookConsultationMutationVariables, TContext>(
      ['partnerBookConsultation'],
      (variables?: PartnerBookConsultationMutationVariables) => fetcher<PartnerBookConsultationMutation, PartnerBookConsultationMutationVariables>(client, PartnerBookConsultationDocument, variables, headers)(),
      options
    );
export const PauseAndResumeSubscriptionDocument = `
    mutation pauseAndResumeSubscription($input: PauseAndResumeSubscriptionInput!) {
  pauseAndResumeSubscription(input: $input)
}
    `;
export const usePauseAndResumeSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PauseAndResumeSubscriptionMutation, TError, PauseAndResumeSubscriptionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PauseAndResumeSubscriptionMutation, TError, PauseAndResumeSubscriptionMutationVariables, TContext>(
      ['pauseAndResumeSubscription'],
      (variables?: PauseAndResumeSubscriptionMutationVariables) => fetcher<PauseAndResumeSubscriptionMutation, PauseAndResumeSubscriptionMutationVariables>(client, PauseAndResumeSubscriptionDocument, variables, headers)(),
      options
    );
export const PendingOrderDocument = `
    mutation pendingOrder($input: PendingOrderInput!) {
  pendingOrder(input: $input)
}
    `;
export const usePendingOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PendingOrderMutation, TError, PendingOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PendingOrderMutation, TError, PendingOrderMutationVariables, TContext>(
      ['pendingOrder'],
      (variables?: PendingOrderMutationVariables) => fetcher<PendingOrderMutation, PendingOrderMutationVariables>(client, PendingOrderDocument, variables, headers)(),
      options
    );
export const PortEmailDocument = `
    mutation portEmail($input: PortEmailInput!) {
  portEmail(input: $input)
}
    `;
export const usePortEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PortEmailMutation, TError, PortEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PortEmailMutation, TError, PortEmailMutationVariables, TContext>(
      ['portEmail'],
      (variables?: PortEmailMutationVariables) => fetcher<PortEmailMutation, PortEmailMutationVariables>(client, PortEmailDocument, variables, headers)(),
      options
    );
export const PrescriptionCheckoutDocument = `
    mutation prescriptionCheckout($input: PrescriptionCheckoutInput!) {
  prescriptionCheckout(input: $input) {
    orderId
    textConversationId
    totalAfterCashback
  }
}
    `;
export const usePrescriptionCheckoutMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PrescriptionCheckoutMutation, TError, PrescriptionCheckoutMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PrescriptionCheckoutMutation, TError, PrescriptionCheckoutMutationVariables, TContext>(
      ['prescriptionCheckout'],
      (variables?: PrescriptionCheckoutMutationVariables) => fetcher<PrescriptionCheckoutMutation, PrescriptionCheckoutMutationVariables>(client, PrescriptionCheckoutDocument, variables, headers)(),
      options
    );
export const PrescriptionCheckoutV2Document = `
    mutation prescriptionCheckoutV2($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: V2PresCheckoutInput) {
  prescriptionCheckoutV2(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const usePrescriptionCheckoutV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PrescriptionCheckoutV2Mutation, TError, PrescriptionCheckoutV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PrescriptionCheckoutV2Mutation, TError, PrescriptionCheckoutV2MutationVariables, TContext>(
      ['prescriptionCheckoutV2'],
      (variables?: PrescriptionCheckoutV2MutationVariables) => fetcher<PrescriptionCheckoutV2Mutation, PrescriptionCheckoutV2MutationVariables>(client, PrescriptionCheckoutV2Document, variables, headers)(),
      options
    );
export const ProcessCartByOtcWalletDocument = `
    mutation processCartByOTCWallet($input: ProcessCartByOTCwalletInput!) {
  processCartByOTCWallet(input: $input) {
    cartId
  }
}
    `;
export const useProcessCartByOtcWalletMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ProcessCartByOtcWalletMutation, TError, ProcessCartByOtcWalletMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ProcessCartByOtcWalletMutation, TError, ProcessCartByOtcWalletMutationVariables, TContext>(
      ['processCartByOTCWallet'],
      (variables?: ProcessCartByOtcWalletMutationVariables) => fetcher<ProcessCartByOtcWalletMutation, ProcessCartByOtcWalletMutationVariables>(client, ProcessCartByOtcWalletDocument, variables, headers)(),
      options
    );
export const ReAssignDoctorForNoteDocument = `
    mutation reAssignDoctorForNote($input: UpdateDoctorForAuditDoctorNoteInput!) {
  reAssignDoctorForNote(input: $input)
}
    `;
export const useReAssignDoctorForNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReAssignDoctorForNoteMutation, TError, ReAssignDoctorForNoteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReAssignDoctorForNoteMutation, TError, ReAssignDoctorForNoteMutationVariables, TContext>(
      ['reAssignDoctorForNote'],
      (variables?: ReAssignDoctorForNoteMutationVariables) => fetcher<ReAssignDoctorForNoteMutation, ReAssignDoctorForNoteMutationVariables>(client, ReAssignDoctorForNoteDocument, variables, headers)(),
      options
    );
export const ReAssignTextConsultationDoctorDocument = `
    mutation reAssignTextConsultationDoctor($input: ReAssignTextConsultationDoctorInput!) {
  reAssignTextConsultationDoctor(input: $input)
}
    `;
export const useReAssignTextConsultationDoctorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReAssignTextConsultationDoctorMutation, TError, ReAssignTextConsultationDoctorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReAssignTextConsultationDoctorMutation, TError, ReAssignTextConsultationDoctorMutationVariables, TContext>(
      ['reAssignTextConsultationDoctor'],
      (variables?: ReAssignTextConsultationDoctorMutationVariables) => fetcher<ReAssignTextConsultationDoctorMutation, ReAssignTextConsultationDoctorMutationVariables>(client, ReAssignTextConsultationDoctorDocument, variables, headers)(),
      options
    );
export const ReactivateDocument = `
    mutation reactivate($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $reactivateInput: V2ReactivateOrderInput!) {
  reactivate(reactivateInput: $reactivateInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useReactivateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReactivateMutation, TError, ReactivateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReactivateMutation, TError, ReactivateMutationVariables, TContext>(
      ['reactivate'],
      (variables?: ReactivateMutationVariables) => fetcher<ReactivateMutation, ReactivateMutationVariables>(client, ReactivateDocument, variables, headers)(),
      options
    );
export const ReactivateCanceledOrderV2Document = `
    mutation reactivateCanceledOrderV2($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: ReactivateCanceledOrderInputV2!) {
  reactivateCanceledOrderV2(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useReactivateCanceledOrderV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReactivateCanceledOrderV2Mutation, TError, ReactivateCanceledOrderV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReactivateCanceledOrderV2Mutation, TError, ReactivateCanceledOrderV2MutationVariables, TContext>(
      ['reactivateCanceledOrderV2'],
      (variables?: ReactivateCanceledOrderV2MutationVariables) => fetcher<ReactivateCanceledOrderV2Mutation, ReactivateCanceledOrderV2MutationVariables>(client, ReactivateCanceledOrderV2Document, variables, headers)(),
      options
    );
export const RecordBloodPressureDocument = `
    mutation recordBloodPressure($input: RecordBloodPressureInput!) {
  recordBloodPressure(input: $input) {
    diastolic
    recordedAt
    source
    sysId
    systolic
    type
  }
}
    `;
export const useRecordBloodPressureMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RecordBloodPressureMutation, TError, RecordBloodPressureMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RecordBloodPressureMutation, TError, RecordBloodPressureMutationVariables, TContext>(
      ['recordBloodPressure'],
      (variables?: RecordBloodPressureMutationVariables) => fetcher<RecordBloodPressureMutation, RecordBloodPressureMutationVariables>(client, RecordBloodPressureDocument, variables, headers)(),
      options
    );
export const RecordDoseStartDocument = `
    mutation recordDoseStart($input: RecordDoseStartInput!) {
  recordDoseStart(input: $input) {
    doseStartedAt
    orderSysId
  }
}
    `;
export const useRecordDoseStartMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RecordDoseStartMutation, TError, RecordDoseStartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RecordDoseStartMutation, TError, RecordDoseStartMutationVariables, TContext>(
      ['recordDoseStart'],
      (variables?: RecordDoseStartMutationVariables) => fetcher<RecordDoseStartMutation, RecordDoseStartMutationVariables>(client, RecordDoseStartDocument, variables, headers)(),
      options
    );
export const RecreateAtomePaymentLinkDocument = `
    mutation recreateAtomePaymentLink($recreateAtomeInput: RenewAtomePaymentLinkInput!) {
  recreateAtomePaymentLink(recreateAtomeInput: $recreateAtomeInput)
}
    `;
export const useRecreateAtomePaymentLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RecreateAtomePaymentLinkMutation, TError, RecreateAtomePaymentLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RecreateAtomePaymentLinkMutation, TError, RecreateAtomePaymentLinkMutationVariables, TContext>(
      ['recreateAtomePaymentLink'],
      (variables?: RecreateAtomePaymentLinkMutationVariables) => fetcher<RecreateAtomePaymentLinkMutation, RecreateAtomePaymentLinkMutationVariables>(client, RecreateAtomePaymentLinkDocument, variables, headers)(),
      options
    );
export const RefreshAccessTokenDocument = `
    mutation refreshAccessToken($input: RefreshAccessTokenInput!) {
  refreshAccessToken(input: $input) {
    accessToken
    accessTokenExpiredAt
    refreshToken
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useRefreshAccessTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefreshAccessTokenMutation, TError, RefreshAccessTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefreshAccessTokenMutation, TError, RefreshAccessTokenMutationVariables, TContext>(
      ['refreshAccessToken'],
      (variables?: RefreshAccessTokenMutationVariables) => fetcher<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>(client, RefreshAccessTokenDocument, variables, headers)(),
      options
    );
export const RefundChargedForAdminDocument = `
    mutation refundChargedForAdmin($input: PaymentRefundInput!) {
  refundChargedForAdmin(input: $input)
}
    `;
export const useRefundChargedForAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefundChargedForAdminMutation, TError, RefundChargedForAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefundChargedForAdminMutation, TError, RefundChargedForAdminMutationVariables, TContext>(
      ['refundChargedForAdmin'],
      (variables?: RefundChargedForAdminMutationVariables) => fetcher<RefundChargedForAdminMutation, RefundChargedForAdminMutationVariables>(client, RefundChargedForAdminDocument, variables, headers)(),
      options
    );
export const RefundInvoiceForAdminDocument = `
    mutation refundInvoiceForAdmin($input: PaymentRefundInput!) {
  refundInvoiceForAdmin(input: $input)
}
    `;
export const useRefundInvoiceForAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefundInvoiceForAdminMutation, TError, RefundInvoiceForAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefundInvoiceForAdminMutation, TError, RefundInvoiceForAdminMutationVariables, TContext>(
      ['refundInvoiceForAdmin'],
      (variables?: RefundInvoiceForAdminMutationVariables) => fetcher<RefundInvoiceForAdminMutation, RefundInvoiceForAdminMutationVariables>(client, RefundInvoiceForAdminDocument, variables, headers)(),
      options
    );
export const RefundOtcWalletOrderDocument = `
    mutation refundOTCWalletOrder($input: RefundOTCWalletOrderInput!) {
  refundOTCWalletOrder(input: $input) {
    success
  }
}
    `;
export const useRefundOtcWalletOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefundOtcWalletOrderMutation, TError, RefundOtcWalletOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefundOtcWalletOrderMutation, TError, RefundOtcWalletOrderMutationVariables, TContext>(
      ['refundOTCWalletOrder'],
      (variables?: RefundOtcWalletOrderMutationVariables) => fetcher<RefundOtcWalletOrderMutation, RefundOtcWalletOrderMutationVariables>(client, RefundOtcWalletOrderDocument, variables, headers)(),
      options
    );
export const RefundPaymentIntentDocument = `
    mutation refundPaymentIntent($id: String!) {
  refundPaymentIntent(id: $id)
}
    `;
export const useRefundPaymentIntentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefundPaymentIntentMutation, TError, RefundPaymentIntentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefundPaymentIntentMutation, TError, RefundPaymentIntentMutationVariables, TContext>(
      ['refundPaymentIntent'],
      (variables?: RefundPaymentIntentMutationVariables) => fetcher<RefundPaymentIntentMutation, RefundPaymentIntentMutationVariables>(client, RefundPaymentIntentDocument, variables, headers)(),
      options
    );
export const RefundPaymentIntentForAdminDocument = `
    mutation refundPaymentIntentForAdmin($input: PaymentRefundInput!) {
  refundPaymentIntentForAdmin(input: $input)
}
    `;
export const useRefundPaymentIntentForAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefundPaymentIntentForAdminMutation, TError, RefundPaymentIntentForAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefundPaymentIntentForAdminMutation, TError, RefundPaymentIntentForAdminMutationVariables, TContext>(
      ['refundPaymentIntentForAdmin'],
      (variables?: RefundPaymentIntentForAdminMutationVariables) => fetcher<RefundPaymentIntentForAdminMutation, RefundPaymentIntentForAdminMutationVariables>(client, RefundPaymentIntentForAdminDocument, variables, headers)(),
      options
    );
export const RefundPaymentIntentForAnonymousDocument = `
    mutation refundPaymentIntentForAnonymous($id: String!) {
  refundPaymentIntentForAnonymous(id: $id) {
    success
  }
}
    `;
export const useRefundPaymentIntentForAnonymousMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefundPaymentIntentForAnonymousMutation, TError, RefundPaymentIntentForAnonymousMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefundPaymentIntentForAnonymousMutation, TError, RefundPaymentIntentForAnonymousMutationVariables, TContext>(
      ['refundPaymentIntentForAnonymous'],
      (variables?: RefundPaymentIntentForAnonymousMutationVariables) => fetcher<RefundPaymentIntentForAnonymousMutation, RefundPaymentIntentForAnonymousMutationVariables>(client, RefundPaymentIntentForAnonymousDocument, variables, headers)(),
      options
    );
export const RegisterDoctorDocument = `
    mutation registerDoctor($input: RegisterDoctorInput!) {
  registerDoctor(input: $input) {
    active
    calendarId
    country
    duration
    email
    firstName
    fullName
    lastName
    sysId
    textConsultPostalCodes
    trtEligible
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useRegisterDoctorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RegisterDoctorMutation, TError, RegisterDoctorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RegisterDoctorMutation, TError, RegisterDoctorMutationVariables, TContext>(
      ['registerDoctor'],
      (variables?: RegisterDoctorMutationVariables) => fetcher<RegisterDoctorMutation, RegisterDoctorMutationVariables>(client, RegisterDoctorDocument, variables, headers)(),
      options
    );
export const RegisterFcMtokenDocument = `
    mutation registerFCMtoken($input: FcmTokenInput!) {
  registerFCMtoken(input: $input)
}
    `;
export const useRegisterFcMtokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RegisterFcMtokenMutation, TError, RegisterFcMtokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RegisterFcMtokenMutation, TError, RegisterFcMtokenMutationVariables, TContext>(
      ['registerFCMtoken'],
      (variables?: RegisterFcMtokenMutationVariables) => fetcher<RegisterFcMtokenMutation, RegisterFcMtokenMutationVariables>(client, RegisterFcMtokenDocument, variables, headers)(),
      options
    );
export const RegisterPatientDocument = `
    mutation registerPatient($input: RegisterPatientInput!) {
  registerPatient(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useRegisterPatientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RegisterPatientMutation, TError, RegisterPatientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RegisterPatientMutation, TError, RegisterPatientMutationVariables, TContext>(
      ['registerPatient'],
      (variables?: RegisterPatientMutationVariables) => fetcher<RegisterPatientMutation, RegisterPatientMutationVariables>(client, RegisterPatientDocument, variables, headers)(),
      options
    );
export const RegisterUserSessionDocument = `
    mutation registerUserSession($input: RegisterUserSessionInput!) {
  registerUserSession(input: $input) {
    appVersion
    clientType
    createdAt
    createdBy
    deviceId
    deviceNotificationToken
    lastLogin
    lastLogout
    sysId
    updatedAt
    updatedBy
  }
}
    `;
export const useRegisterUserSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RegisterUserSessionMutation, TError, RegisterUserSessionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RegisterUserSessionMutation, TError, RegisterUserSessionMutationVariables, TContext>(
      ['registerUserSession'],
      (variables?: RegisterUserSessionMutationVariables) => fetcher<RegisterUserSessionMutation, RegisterUserSessionMutationVariables>(client, RegisterUserSessionDocument, variables, headers)(),
      options
    );
export const RejectPrescriptionOrderDocument = `
    mutation rejectPrescriptionOrder($input: RejectOrderInput!) {
  rejectPrescriptionOrder(input: $input)
}
    `;
export const useRejectPrescriptionOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RejectPrescriptionOrderMutation, TError, RejectPrescriptionOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RejectPrescriptionOrderMutation, TError, RejectPrescriptionOrderMutationVariables, TContext>(
      ['rejectPrescriptionOrder'],
      (variables?: RejectPrescriptionOrderMutationVariables) => fetcher<RejectPrescriptionOrderMutation, RejectPrescriptionOrderMutationVariables>(client, RejectPrescriptionOrderDocument, variables, headers)(),
      options
    );
export const ReleasePreblockDocument = `
    mutation releasePreblock($input: ReleasePreblockInput!) {
  releasePreblock(input: $input)
}
    `;
export const useReleasePreblockMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReleasePreblockMutation, TError, ReleasePreblockMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReleasePreblockMutation, TError, ReleasePreblockMutationVariables, TContext>(
      ['releasePreblock'],
      (variables?: ReleasePreblockMutationVariables) => fetcher<ReleasePreblockMutation, ReleasePreblockMutationVariables>(client, ReleasePreblockDocument, variables, headers)(),
      options
    );
export const RemoveCardDetailPatientDocument = `
    mutation removeCardDetailPatient($email: String!) {
  removeCardDetailPatient(email: $email)
}
    `;
export const useRemoveCardDetailPatientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveCardDetailPatientMutation, TError, RemoveCardDetailPatientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveCardDetailPatientMutation, TError, RemoveCardDetailPatientMutationVariables, TContext>(
      ['removeCardDetailPatient'],
      (variables?: RemoveCardDetailPatientMutationVariables) => fetcher<RemoveCardDetailPatientMutation, RemoveCardDetailPatientMutationVariables>(client, RemoveCardDetailPatientDocument, variables, headers)(),
      options
    );
export const RenewDocument = `
    mutation renew($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $renewInput: V2RenewCodOrderInput!) {
  renew(renewInput: $renewInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useRenewMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RenewMutation, TError, RenewMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RenewMutation, TError, RenewMutationVariables, TContext>(
      ['renew'],
      (variables?: RenewMutationVariables) => fetcher<RenewMutation, RenewMutationVariables>(client, RenewDocument, variables, headers)(),
      options
    );
export const RenewAtomeOrderDocument = `
    mutation renewAtomeOrder($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: V2RenewAtomeOrder!) {
  renewAtomeOrder(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useRenewAtomeOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RenewAtomeOrderMutation, TError, RenewAtomeOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RenewAtomeOrderMutation, TError, RenewAtomeOrderMutationVariables, TContext>(
      ['renewAtomeOrder'],
      (variables?: RenewAtomeOrderMutationVariables) => fetcher<RenewAtomeOrderMutation, RenewAtomeOrderMutationVariables>(client, RenewAtomeOrderDocument, variables, headers)(),
      options
    );
export const RenewCodOrderDocument = `
    mutation renewCodOrder($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: V2RenewCodOrderInput) {
  renewCodOrder(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useRenewCodOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RenewCodOrderMutation, TError, RenewCodOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RenewCodOrderMutation, TError, RenewCodOrderMutationVariables, TContext>(
      ['renewCodOrder'],
      (variables?: RenewCodOrderMutationVariables) => fetcher<RenewCodOrderMutation, RenewCodOrderMutationVariables>(client, RenewCodOrderDocument, variables, headers)(),
      options
    );
export const RenewCodOrdersDocument = `
    mutation renewCodOrders($platform: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform9: String, $videoLink1: String!, $patientId: String, $input4: CrossSellRecordQueryInput, $orderId: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId1: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId2: String, $limit2: Int, $offset2: Int, $order1: JSON, $acuityAppointmentId2: String, $date2: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date3: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $input5: V2ConsultationFilterInput!, $input6: ConsultationMessagesInput!, $limit3: Int, $offset3: Int, $order2: JSON, $input7: ConsultationListInput!, $limit4: Int, $offset4: Int, $order3: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input8: OrderInput!, $pagination: V2PaginationInput!, $date4: String, $date5: Float, $input9: GetPatientInput, $platform10: String, $input10: StripeProductFilterV2, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit5: Int, $offset5: Int, $order4: JSON, $input13: ConsultationListInput!, $limit6: Int, $offset6: Int, $order5: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform11: String, $input16: StripeProductFilterV2, $doctorFilterInput3: V2DoctorInputFilter, $limit7: Int, $offset7: Int, $order6: JSON, $input17: V2RenewMultipleCodOrdersInput!) {
  renewCodOrders(input: $input17) {
    results {
      errorMessage
      isSuccess
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          consultationAudit {
            consultTime
            consultType
            createdBy
            doctor {
              active
              bio {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              calendarId
              consultation(videoLink: $videoLink1) {
                gmeetLink
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                previewToken
                previewVideoLink
                status
                sysId
                token
                videoChannelId
                videoLink
                zoomJoinUrl
              }
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              patient(patientId: $patientId) {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sysId
              textConsultPostalCodes
              trtEligible
              user {
                admin {
                  crossSellRecords(input: $input4) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId
                  date: $date
                  forDelivery: $forDelivery
                  isReschedule: $isReschedule
                  orderId: $orderId1
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId1
                  consultDate: $consultDate
                  date: $date1
                  forDelivery: $forDelivery1
                  isReschedule: $isReschedule1
                  orderId: $orderId2
                ) {
                  time
                }
                consultation(input: $input11) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit2, offset: $offset2, order: $order1) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId2
                      date: $date2
                      forDelivery: $forDelivery2
                      isReschedule: $isReschedule2
                      orderId: $orderId3
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId3
                      consultDate: $consultDate1
                      date: $date3
                      forDelivery: $forDelivery3
                      isReschedule: $isReschedule3
                      orderId: $orderId4
                    ) {
                      time
                    }
                    consultation(input: $input5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input6
                      limit: $limit3
                      offset: $offset3
                      order: $order2
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input7, limit: $limit4, offset: $offset4, order: $order3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input8, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date4) {
                      date
                    }
                    partnerConsultTimes(date: $date5) {
                      time
                    }
                    patient(input: $input9) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input10) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input12
                  limit: $limit5
                  offset: $offset5
                  order: $order4
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input13, limit: $limit6, offset: $offset6, order: $order5) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input14, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input15) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input16) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            evaluationId
            sessionType
            status
            sysId
          }
          consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
            count
            limit
            offset
          }
          consultationTitle {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          countReminder
          createdAt
          doctor {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          messages {
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
          }
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          orderSysId
          participants {
            avatar
            fullName
            identity
            locale
            role
            token
            userSysId
          }
          participantsV2 {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            phoneNumber
            requireConfirmPolicy
            socialProviderType
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      orderId
    }
  }
}
    `;
export const useRenewCodOrdersMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RenewCodOrdersMutation, TError, RenewCodOrdersMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RenewCodOrdersMutation, TError, RenewCodOrdersMutationVariables, TContext>(
      ['renewCodOrders'],
      (variables?: RenewCodOrdersMutationVariables) => fetcher<RenewCodOrdersMutation, RenewCodOrdersMutationVariables>(client, RenewCodOrdersDocument, variables, headers)(),
      options
    );
export const RenewKonbiniOrderDocument = `
    mutation renewKonbiniOrder($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: V2RenewKonbiniOrderInput!) {
  renewKonbiniOrder(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useRenewKonbiniOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RenewKonbiniOrderMutation, TError, RenewKonbiniOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RenewKonbiniOrderMutation, TError, RenewKonbiniOrderMutationVariables, TContext>(
      ['renewKonbiniOrder'],
      (variables?: RenewKonbiniOrderMutationVariables) => fetcher<RenewKonbiniOrderMutation, RenewKonbiniOrderMutationVariables>(client, RenewKonbiniOrderDocument, variables, headers)(),
      options
    );
export const RenewOrderByOpsDocument = `
    mutation renewOrderByOps($input: RenewOrderByOpsInput!) {
  renewOrderByOps(input: $input)
}
    `;
export const useRenewOrderByOpsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RenewOrderByOpsMutation, TError, RenewOrderByOpsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RenewOrderByOpsMutation, TError, RenewOrderByOpsMutationVariables, TContext>(
      ['renewOrderByOps'],
      (variables?: RenewOrderByOpsMutationVariables) => fetcher<RenewOrderByOpsMutation, RenewOrderByOpsMutationVariables>(client, RenewOrderByOpsDocument, variables, headers)(),
      options
    );
export const RenewOrderByPatientDocument = `
    mutation renewOrderByPatient($input: RenewOrderByPatientInput!) {
  renewOrderByPatient(input: $input)
}
    `;
export const useRenewOrderByPatientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RenewOrderByPatientMutation, TError, RenewOrderByPatientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RenewOrderByPatientMutation, TError, RenewOrderByPatientMutationVariables, TContext>(
      ['renewOrderByPatient'],
      (variables?: RenewOrderByPatientMutationVariables) => fetcher<RenewOrderByPatientMutation, RenewOrderByPatientMutationVariables>(client, RenewOrderByPatientDocument, variables, headers)(),
      options
    );
export const RequestEmailOtpDocument = `
    mutation requestEmailOTP($email: String!) {
  requestEmailOTP(email: $email)
}
    `;
export const useRequestEmailOtpMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestEmailOtpMutation, TError, RequestEmailOtpMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestEmailOtpMutation, TError, RequestEmailOtpMutationVariables, TContext>(
      ['requestEmailOTP'],
      (variables?: RequestEmailOtpMutationVariables) => fetcher<RequestEmailOtpMutation, RequestEmailOtpMutationVariables>(client, RequestEmailOtpDocument, variables, headers)(),
      options
    );
export const RequestFollowUpConsultDocument = `
    mutation requestFollowUpConsult($input: TriggerFollowUpConsultInput!) {
  requestFollowUpConsult(input: $input)
}
    `;
export const useRequestFollowUpConsultMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestFollowUpConsultMutation, TError, RequestFollowUpConsultMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestFollowUpConsultMutation, TError, RequestFollowUpConsultMutationVariables, TContext>(
      ['requestFollowUpConsult'],
      (variables?: RequestFollowUpConsultMutationVariables) => fetcher<RequestFollowUpConsultMutation, RequestFollowUpConsultMutationVariables>(client, RequestFollowUpConsultDocument, variables, headers)(),
      options
    );
export const RequestFollowUpConsultV2Document = `
    mutation requestFollowUpConsultV2($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $requestFollowUpConsultInput: RequestFollowUpConsultInput!) {
  requestFollowUpConsultV2(
    requestFollowUpConsultInput: $requestFollowUpConsultInput
  ) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useRequestFollowUpConsultV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestFollowUpConsultV2Mutation, TError, RequestFollowUpConsultV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestFollowUpConsultV2Mutation, TError, RequestFollowUpConsultV2MutationVariables, TContext>(
      ['requestFollowUpConsultV2'],
      (variables?: RequestFollowUpConsultV2MutationVariables) => fetcher<RequestFollowUpConsultV2Mutation, RequestFollowUpConsultV2MutationVariables>(client, RequestFollowUpConsultV2Document, variables, headers)(),
      options
    );
export const RequestMagicLinkDocument = `
    mutation requestMagicLink($input: RequestMagicLinkInput!) {
  requestMagicLink(input: $input)
}
    `;
export const useRequestMagicLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestMagicLinkMutation, TError, RequestMagicLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestMagicLinkMutation, TError, RequestMagicLinkMutationVariables, TContext>(
      ['requestMagicLink'],
      (variables?: RequestMagicLinkMutationVariables) => fetcher<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>(client, RequestMagicLinkDocument, variables, headers)(),
      options
    );
export const RequestUpgradeSettingsLinkDocument = `
    mutation requestUpgradeSettingsLink($input: RequestUpgradeSettingsLinkInput!) {
  requestUpgradeSettingsLink(input: $input)
}
    `;
export const useRequestUpgradeSettingsLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RequestUpgradeSettingsLinkMutation, TError, RequestUpgradeSettingsLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RequestUpgradeSettingsLinkMutation, TError, RequestUpgradeSettingsLinkMutationVariables, TContext>(
      ['requestUpgradeSettingsLink'],
      (variables?: RequestUpgradeSettingsLinkMutationVariables) => fetcher<RequestUpgradeSettingsLinkMutation, RequestUpgradeSettingsLinkMutationVariables>(client, RequestUpgradeSettingsLinkDocument, variables, headers)(),
      options
    );
export const RescheduleAppointmentDocument = `
    mutation rescheduleAppointment($input: RescheduleAppointmentInput!) {
  rescheduleAppointment(input: $input)
}
    `;
export const useRescheduleAppointmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RescheduleAppointmentMutation, TError, RescheduleAppointmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RescheduleAppointmentMutation, TError, RescheduleAppointmentMutationVariables, TContext>(
      ['rescheduleAppointment'],
      (variables?: RescheduleAppointmentMutationVariables) => fetcher<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>(client, RescheduleAppointmentDocument, variables, headers)(),
      options
    );
export const ResetPasswordDocument = `
    mutation resetPassword($input: ResetPasswordUserInput!) {
  resetPassword(input: $input)
}
    `;
export const useResetPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      ['resetPassword'],
      (variables?: ResetPasswordMutationVariables) => fetcher<ResetPasswordMutation, ResetPasswordMutationVariables>(client, ResetPasswordDocument, variables, headers)(),
      options
    );
export const ResetPasswordWithTokenDocument = `
    mutation resetPasswordWithToken($input: ResetPasswordWithTokenInput!) {
  resetPasswordWithToken(input: $input)
}
    `;
export const useResetPasswordWithTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResetPasswordWithTokenMutation, TError, ResetPasswordWithTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResetPasswordWithTokenMutation, TError, ResetPasswordWithTokenMutationVariables, TContext>(
      ['resetPasswordWithToken'],
      (variables?: ResetPasswordWithTokenMutationVariables) => fetcher<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>(client, ResetPasswordWithTokenDocument, variables, headers)(),
      options
    );
export const ResubscribeCanceledOtcOrderDocument = `
    mutation resubscribeCanceledOTCOrder($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: ReactivateCanceledOTCOrderInputV2!) {
  resubscribeCanceledOTCOrder(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useResubscribeCanceledOtcOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResubscribeCanceledOtcOrderMutation, TError, ResubscribeCanceledOtcOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResubscribeCanceledOtcOrderMutation, TError, ResubscribeCanceledOtcOrderMutationVariables, TContext>(
      ['resubscribeCanceledOTCOrder'],
      (variables?: ResubscribeCanceledOtcOrderMutationVariables) => fetcher<ResubscribeCanceledOtcOrderMutation, ResubscribeCanceledOtcOrderMutationVariables>(client, ResubscribeCanceledOtcOrderDocument, variables, headers)(),
      options
    );
export const SaveTranslationDocument = `
    mutation saveTranslation($input: SaveTranslationInput!) {
  saveTranslation(input: $input) {
    createdAt
    createdBy
    remark
    sysId
    translationKey
    updatedAt
    updatedBy
    valueEn
    valueJa
    valueZh
  }
}
    `;
export const useSaveTranslationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SaveTranslationMutation, TError, SaveTranslationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SaveTranslationMutation, TError, SaveTranslationMutationVariables, TContext>(
      ['saveTranslation'],
      (variables?: SaveTranslationMutationVariables) => fetcher<SaveTranslationMutation, SaveTranslationMutationVariables>(client, SaveTranslationDocument, variables, headers)(),
      options
    );
export const SendAutomatedMessageDocument = `
    mutation sendAutomatedMessage {
  sendAutomatedMessage
}
    `;
export const useSendAutomatedMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SendAutomatedMessageMutation, TError, SendAutomatedMessageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SendAutomatedMessageMutation, TError, SendAutomatedMessageMutationVariables, TContext>(
      ['sendAutomatedMessage'],
      (variables?: SendAutomatedMessageMutationVariables) => fetcher<SendAutomatedMessageMutation, SendAutomatedMessageMutationVariables>(client, SendAutomatedMessageDocument, variables, headers)(),
      options
    );
export const SendEmailAboutNewMessageDocument = `
    mutation sendEmailAboutNewMessage($input: SendEmailAboutNewMessageInput!) {
  sendEmailAboutNewMessage(input: $input)
}
    `;
export const useSendEmailAboutNewMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SendEmailAboutNewMessageMutation, TError, SendEmailAboutNewMessageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SendEmailAboutNewMessageMutation, TError, SendEmailAboutNewMessageMutationVariables, TContext>(
      ['sendEmailAboutNewMessage'],
      (variables?: SendEmailAboutNewMessageMutationVariables) => fetcher<SendEmailAboutNewMessageMutation, SendEmailAboutNewMessageMutationVariables>(client, SendEmailAboutNewMessageDocument, variables, headers)(),
      options
    );
export const SendReminderUnreadDrMessageDocument = `
    mutation sendReminderUnreadDrMessage($input: SendReminderUnreadDrMessageInput!) {
  sendReminderUnreadDrMessage(input: $input)
}
    `;
export const useSendReminderUnreadDrMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SendReminderUnreadDrMessageMutation, TError, SendReminderUnreadDrMessageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SendReminderUnreadDrMessageMutation, TError, SendReminderUnreadDrMessageMutationVariables, TContext>(
      ['sendReminderUnreadDrMessage'],
      (variables?: SendReminderUnreadDrMessageMutationVariables) => fetcher<SendReminderUnreadDrMessageMutation, SendReminderUnreadDrMessageMutationVariables>(client, SendReminderUnreadDrMessageDocument, variables, headers)(),
      options
    );
export const SendResetPasswordEmailDocument = `
    mutation sendResetPasswordEmail($input: ForgotPasswordUserInput!) {
  sendResetPasswordEmail(input: $input)
}
    `;
export const useSendResetPasswordEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SendResetPasswordEmailMutation, TError, SendResetPasswordEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SendResetPasswordEmailMutation, TError, SendResetPasswordEmailMutationVariables, TContext>(
      ['sendResetPasswordEmail'],
      (variables?: SendResetPasswordEmailMutationVariables) => fetcher<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>(client, SendResetPasswordEmailDocument, variables, headers)(),
      options
    );
export const SendShipmentSmsDocument = `
    mutation sendShipmentSMS($platform: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform9: String, $videoLink1: String!, $patientId: String, $input4: CrossSellRecordQueryInput, $orderId: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId1: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId2: String, $limit2: Int, $offset2: Int, $order1: JSON, $acuityAppointmentId2: String, $date2: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date3: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $input5: V2ConsultationFilterInput!, $input6: ConsultationMessagesInput!, $limit3: Int, $offset3: Int, $order2: JSON, $input7: ConsultationListInput!, $limit4: Int, $offset4: Int, $order3: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input8: OrderInput!, $pagination: V2PaginationInput!, $date4: String, $date5: Float, $input9: GetPatientInput, $platform10: String, $input10: StripeProductFilterV2, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit5: Int, $offset5: Int, $order4: JSON, $input13: ConsultationListInput!, $limit6: Int, $offset6: Int, $order5: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform11: String, $input16: StripeProductFilterV2, $doctorFilterInput3: V2DoctorInputFilter, $limit7: Int, $offset7: Int, $order6: JSON, $platform12: String, $platform13: String, $platform14: String, $platform15: String, $platform16: String, $platform17: String, $platform18: String, $platform19: String, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input17: V2ConsultationFilterInput!, $input18: ConsultationMessagesInput!, $limit8: Int, $offset8: Int, $order7: JSON, $input19: ConsultationListInput!, $limit9: Int, $offset9: Int, $order8: JSON, $doctorFilterInput4: V2DoctorInputFilter, $doctorFilterInput5: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform20: String, $input20: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input21: GetPatientInput, $platform21: String, $platform22: String, $input22: StripeProductFilterV2, $input23: SendShipmentSMSInput!) {
  sendShipmentSMS(input: $input23) {
    address
    cost
    courierName
    createdAt
    deliveryMethod
    deliveryTimestamp
    estimatedShipDate
    group {
      bookingNo
      createdAt
      name
      sysId
      updatedAt
    }
    items {
      createdAt
      dosage
      isFirstPurchase
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          consultationAudit {
            consultTime
            consultType
            createdBy
            doctor {
              active
              bio {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              calendarId
              consultation(videoLink: $videoLink1) {
                gmeetLink
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                previewToken
                previewVideoLink
                status
                sysId
                token
                videoChannelId
                videoLink
                zoomJoinUrl
              }
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              patient(patientId: $patientId) {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sysId
              textConsultPostalCodes
              trtEligible
              user {
                admin {
                  crossSellRecords(input: $input4) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId
                  date: $date
                  forDelivery: $forDelivery
                  isReschedule: $isReschedule
                  orderId: $orderId1
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId1
                  consultDate: $consultDate
                  date: $date1
                  forDelivery: $forDelivery1
                  isReschedule: $isReschedule1
                  orderId: $orderId2
                ) {
                  time
                }
                consultation(input: $input11) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit2, offset: $offset2, order: $order1) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId2
                      date: $date2
                      forDelivery: $forDelivery2
                      isReschedule: $isReschedule2
                      orderId: $orderId3
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId3
                      consultDate: $consultDate1
                      date: $date3
                      forDelivery: $forDelivery3
                      isReschedule: $isReschedule3
                      orderId: $orderId4
                    ) {
                      time
                    }
                    consultation(input: $input5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input6
                      limit: $limit3
                      offset: $offset3
                      order: $order2
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input7, limit: $limit4, offset: $offset4, order: $order3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input8, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date4) {
                      date
                    }
                    partnerConsultTimes(date: $date5) {
                      time
                    }
                    patient(input: $input9) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input10) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input12
                  limit: $limit5
                  offset: $offset5
                  order: $order4
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input13, limit: $limit6, offset: $offset6, order: $order5) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input14, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input15) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input16) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            evaluationId
            sessionType
            status
            sysId
          }
          consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
            count
            limit
            offset
          }
          consultationTitle {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          countReminder
          createdAt
          doctor {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          messages {
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
          }
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          orderSysId
          participants {
            avatar
            fullName
            identity
            locale
            role
            token
            userSysId
          }
          participantsV2 {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            phoneNumber
            requireConfirmPolicy
            socialProviderType
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      orderNo
      orderSysId
      paymentAmount
      paymentDate
      paymentIntentId
      paymentProvider
      price {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredientDetails {
              description
              imageLink
              locale
              name
              strength
              uniqueName
            }
            ingredients
            isConsultOnly(platform: $platform12)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            prices {
              active
              alternativePrice {
                active
                alternativePrice {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                nickname
                product
                productId
                shopDisplay
                sysId
                tax_behavior
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                ingredients
                isConsultOnly(platform: $platform14)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              texts {
                actual_price_display
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                price_frequency
                price_quantity
                quantity
                quantity_display
              }
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            productInstructions {
              language
              localeKey
              productId
              sysId
              translatedText
            }
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            tempPrices {
              active
              alternativePrice {
                active
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                nickname
                product
                productId
                shopDisplay
                sysId
                tax_behavior
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                ingredients
                isConsultOnly(platform: $platform15)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              texts {
                actual_price_display
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                price_frequency
                price_quantity
                quantity
                quantity_display
              }
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            texts {
              benefits
              category
              display_price
              display_price_patient
              dosage_variant_body
              dosage_variant_title
              effective_in
              for
              frequency_variant_title
              good_to_know
              how_to_take
              how_to_use
              is_popular
              lasts_for
              platform
              product_description
              product_name
              product_short_description
              quantity_per_unit
              quantity_variant_title
              requires_prescription
              safety_information
              side_effects
              strength
              taken
              unit
              unit_patient
            }
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredients
          isConsultOnly(platform: $platform16)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform17)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      priceId
      product {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform18)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform19)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      promotionCode
      qty
      sysId
      updatedAt
    }
    note
    parcelId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    paused
    shipDate
    shipper {
      avatar
      calendarDates(
        acuityAppointmentId: $acuityAppointmentId4
        date: $date8
        forDelivery: $forDelivery4
        isReschedule: $isReschedule4
        orderId: $orderId5
      ) {
        date
      }
      calendarTimes(
        acuityAppointmentId: $acuityAppointmentId5
        consultDate: $consultDate2
        date: $date9
        forDelivery: $forDelivery5
        isReschedule: $isReschedule5
        orderId: $orderId6
      ) {
        time
      }
      consultation(input: $input17) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      consultationMessages(
        input: $input18
        limit: $limit8
        offset: $offset8
        order: $order7
      ) {
        count
        limit
        offset
      }
      consultations(input: $input19, limit: $limit9, offset: $offset9, order: $order8) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      doctor(doctorFilterInput: $doctorFilterInput4) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      doctors(doctorFilterInput: $doctorFilterInput5) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      orders(input: $input20, pagination: $pagination2) {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        acuityAppointment {
          appointmentTypeID
          bookedAt
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          bookedAt
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        additionalPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        afterVideoConsultRedirecting {
          baseUrl
          path
        }
        approveAt
        atomeNextSendingInvoiceDate
        atomePayments {
          amount
          paymentUrl
          priceId
          referenceId
          status
          sysId
        }
        checkoutSession {
          checkoutData
          evaluationId
          status
          sysId
        }
        childrenOrders {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        claimedRetentionOffer
        consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
          consultTime
          consultType
          createdBy
          evaluationId
          sessionType
          status
          sysId
        }
        consultations(inputConsultation: $inputConsultation5) {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluation {
          isCompleted
          isSkipped
          name
          patientNote
          platform
          status
          sysId
          type
        }
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        latestAtomePayment {
          amount
          paymentUrl
          priceId
          referenceId
          status
          sysId
        }
        latestInvoice {
          amount_due
          hosted_invoice_url
          id
          next_payment_attempt
          paid
          paymentStatus
          period_end
          starting_balance
          status
          subtotal
          tax
          total
        }
        latestNote {
          content
          createdAt
          createdBy
          sysId
          updatedAt
        }
        nextReviewDate
        oldPrice
        oldPriceInfo {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        pickupLocation {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribedAfterTrialOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        prescribed_after_trial_order_sys_id
        prescription {
          cancelled
          createdAt
          days
          doctorNotes
          endDate
          expiresAt
          isFollowUp
          notedDate
          priceIds
          startDate
          status
          sysId
          treatmentCode
          updatedAt
        }
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation {
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          consultBasePrice
          consultFee
          consultFeeAfterDiscount
          consultTax
          consultTransactionFee
          discountAmount
          isConsult
          mainBasePrice
          mainTax
          mainTransactionFee
          minimalAmountPayment
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          shouldChargeConsultFee
          subTotal
          total
          totalAfterCashback
        }
        price {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        priceDisplayId
        priceInfo {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInfo {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform20)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        siblingCrossSellOrders {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        status
        stripePaymentIntentId
        stripeSubscriptionId
        subscription {
          cancel_at_period_end
          current_period_end
          current_period_start
          default_payment_method
          id
          items
          latest_invoice
          metadata
          pause_collection
          pending_setup_intent
          pending_update
          status
        }
        sysId
        teleConsultProduct
        upcomingInvoice {
          amount_due
          hosted_invoice_url
          id
          next_payment_attempt
          paid
          paymentStatus
          period_end
          starting_balance
          status
          subtotal
          tax
          total
        }
        updatedAt
      }
      partnerConsultDates(date: $date10) {
        date
      }
      partnerConsultTimes(date: $date11) {
        time
      }
      patient(input: $input21) {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      patientDocuments {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      phoneNumber
      prescriptionCalculation {
        affiliateCouponNotApplied {
          affiliateProductDisplayName
          reason
        }
        isAffiliateLocked
        otcCalculationSummary {
          otcOrdersCalculation {
            basePrice
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            discountAmount
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            stripePromotionCode
            tax
            transactionFee
          }
          totalBasePrice
          totalCashbackEarned
          totalCashbackRedeemed
          totalPaymentIntentAmount
          totalTax
          totalTransactionFee
        }
        promotionCodeError
        rxCalculationSummary {
          rxOrdersCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          total
          totalCashbackEarned
          totalCashbackRedeemed
          totalDiscountAmount
          totalMainBasePrice
          totalPaymentIntentAmount
          totalPaymentIntentAmountAfterCashback
          totalTax
          totalTransactionFee
        }
        stripePromotionCode
      }
      requireConfirmPolicy
      socialProviderType
      stripeProducts(input: $input22) {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform21)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform22)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    status
    sysId
    trackingNo
    updatedAt
  }
}
    `;
export const useSendShipmentSmsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SendShipmentSmsMutation, TError, SendShipmentSmsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SendShipmentSmsMutation, TError, SendShipmentSmsMutationVariables, TContext>(
      ['sendShipmentSMS'],
      (variables?: SendShipmentSmsMutationVariables) => fetcher<SendShipmentSmsMutation, SendShipmentSmsMutationVariables>(client, SendShipmentSmsDocument, variables, headers)(),
      options
    );
export const SendToDetrackAndProcessingDeliveryDocument = `
    mutation sendToDetrackAndProcessingDelivery($input: SendToDetrackInput!) {
  sendToDetrackAndProcessingDelivery(input: $input)
}
    `;
export const useSendToDetrackAndProcessingDeliveryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SendToDetrackAndProcessingDeliveryMutation, TError, SendToDetrackAndProcessingDeliveryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SendToDetrackAndProcessingDeliveryMutation, TError, SendToDetrackAndProcessingDeliveryMutationVariables, TContext>(
      ['sendToDetrackAndProcessingDelivery'],
      (variables?: SendToDetrackAndProcessingDeliveryMutationVariables) => fetcher<SendToDetrackAndProcessingDeliveryMutation, SendToDetrackAndProcessingDeliveryMutationVariables>(client, SendToDetrackAndProcessingDeliveryDocument, variables, headers)(),
      options
    );
export const SetDoctorTrtEligibleDocument = `
    mutation setDoctorTrtEligible($doctorSysId: String!, $trtEligible: Boolean!) {
  setDoctorTrtEligible(doctorSysId: $doctorSysId, trtEligible: $trtEligible)
}
    `;
export const useSetDoctorTrtEligibleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetDoctorTrtEligibleMutation, TError, SetDoctorTrtEligibleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetDoctorTrtEligibleMutation, TError, SetDoctorTrtEligibleMutationVariables, TContext>(
      ['setDoctorTrtEligible'],
      (variables?: SetDoctorTrtEligibleMutationVariables) => fetcher<SetDoctorTrtEligibleMutation, SetDoctorTrtEligibleMutationVariables>(client, SetDoctorTrtEligibleDocument, variables, headers)(),
      options
    );
export const SetTrtOrderStatusDocument = `
    mutation setTrtOrderStatus($input: SetTrtOrderStatusInput!) {
  setTrtOrderStatus(input: $input) {
    createdAt
    documents {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    drawConfirmations {
      confirmedAt
      drawType
      orderSysId
      sysId
    }
    isFollowUp
    isTestOrder
    latestBloodPressure {
      diastolic
      recordedAt
      source
      sysId
      systolic
      type
    }
    paid
    patient {
      dob
      email
      firstName
      gender
      hasIdentificationImage
      icNumber
      idVerifiedAt
      lastName
      legalName
      sysId
    }
    shortId
    skus {
      name
      priceId
      slot
    }
    status
    sysId
  }
}
    `;
export const useSetTrtOrderStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetTrtOrderStatusMutation, TError, SetTrtOrderStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetTrtOrderStatusMutation, TError, SetTrtOrderStatusMutationVariables, TContext>(
      ['setTrtOrderStatus'],
      (variables?: SetTrtOrderStatusMutationVariables) => fetcher<SetTrtOrderStatusMutation, SetTrtOrderStatusMutationVariables>(client, SetTrtOrderStatusDocument, variables, headers)(),
      options
    );
export const SignInAnonymousUserDocument = `
    mutation signInAnonymousUser {
  signInAnonymousUser {
    accessToken
    accessTokenExpiredAt
    refreshToken
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useSignInAnonymousUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SignInAnonymousUserMutation, TError, SignInAnonymousUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SignInAnonymousUserMutation, TError, SignInAnonymousUserMutationVariables, TContext>(
      ['signInAnonymousUser'],
      (variables?: SignInAnonymousUserMutationVariables) => fetcher<SignInAnonymousUserMutation, SignInAnonymousUserMutationVariables>(client, SignInAnonymousUserDocument, variables, headers)(),
      options
    );
export const SignInWithMagicLinkDocument = `
    mutation signInWithMagicLink($input: SignInWithMagicLinkInput!) {
  signInWithMagicLink(input: $input) {
    accessToken
    accessTokenExpiredAt
    refreshToken
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useSignInWithMagicLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SignInWithMagicLinkMutation, TError, SignInWithMagicLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SignInWithMagicLinkMutation, TError, SignInWithMagicLinkMutationVariables, TContext>(
      ['signInWithMagicLink'],
      (variables?: SignInWithMagicLinkMutationVariables) => fetcher<SignInWithMagicLinkMutation, SignInWithMagicLinkMutationVariables>(client, SignInWithMagicLinkDocument, variables, headers)(),
      options
    );
export const SkipSurveyDocument = `
    mutation skipSurvey {
  skipSurvey
}
    `;
export const useSkipSurveyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SkipSurveyMutation, TError, SkipSurveyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SkipSurveyMutation, TError, SkipSurveyMutationVariables, TContext>(
      ['skipSurvey'],
      (variables?: SkipSurveyMutationVariables) => fetcher<SkipSurveyMutation, SkipSurveyMutationVariables>(client, SkipSurveyDocument, variables, headers)(),
      options
    );
export const SkipSurveyForCartDocument = `
    mutation skipSurveyForCart($input: SkipSurveyForCartInput!) {
  skipSurveyForCart(input: $input)
}
    `;
export const useSkipSurveyForCartMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SkipSurveyForCartMutation, TError, SkipSurveyForCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SkipSurveyForCartMutation, TError, SkipSurveyForCartMutationVariables, TContext>(
      ['skipSurveyForCart'],
      (variables?: SkipSurveyForCartMutationVariables) => fetcher<SkipSurveyForCartMutation, SkipSurveyForCartMutationVariables>(client, SkipSurveyForCartDocument, variables, headers)(),
      options
    );
export const SplitShipmentDocument = `
    mutation splitShipment($platform: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform9: String, $videoLink1: String!, $patientId: String, $input4: CrossSellRecordQueryInput, $orderId: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId1: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId2: String, $limit2: Int, $offset2: Int, $order1: JSON, $acuityAppointmentId2: String, $date2: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date3: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $input5: V2ConsultationFilterInput!, $input6: ConsultationMessagesInput!, $limit3: Int, $offset3: Int, $order2: JSON, $input7: ConsultationListInput!, $limit4: Int, $offset4: Int, $order3: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input8: OrderInput!, $pagination: V2PaginationInput!, $date4: String, $date5: Float, $input9: GetPatientInput, $platform10: String, $input10: StripeProductFilterV2, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit5: Int, $offset5: Int, $order4: JSON, $input13: ConsultationListInput!, $limit6: Int, $offset6: Int, $order5: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform11: String, $input16: StripeProductFilterV2, $doctorFilterInput3: V2DoctorInputFilter, $limit7: Int, $offset7: Int, $order6: JSON, $platform12: String, $platform13: String, $platform14: String, $platform15: String, $platform16: String, $platform17: String, $platform18: String, $platform19: String, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input17: V2ConsultationFilterInput!, $input18: ConsultationMessagesInput!, $limit8: Int, $offset8: Int, $order7: JSON, $input19: ConsultationListInput!, $limit9: Int, $offset9: Int, $order8: JSON, $doctorFilterInput4: V2DoctorInputFilter, $doctorFilterInput5: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform20: String, $input20: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input21: GetPatientInput, $platform21: String, $platform22: String, $input22: StripeProductFilterV2, $input23: SplitShipmentInput!) {
  splitShipment(input: $input23) {
    address
    cost
    courierName
    createdAt
    deliveryMethod
    deliveryTimestamp
    estimatedShipDate
    group {
      bookingNo
      createdAt
      name
      sysId
      updatedAt
    }
    items {
      createdAt
      dosage
      isFirstPurchase
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          consultationAudit {
            consultTime
            consultType
            createdBy
            doctor {
              active
              bio {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              calendarId
              consultation(videoLink: $videoLink1) {
                gmeetLink
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                previewToken
                previewVideoLink
                status
                sysId
                token
                videoChannelId
                videoLink
                zoomJoinUrl
              }
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              patient(patientId: $patientId) {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sysId
              textConsultPostalCodes
              trtEligible
              user {
                admin {
                  crossSellRecords(input: $input4) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId
                  date: $date
                  forDelivery: $forDelivery
                  isReschedule: $isReschedule
                  orderId: $orderId1
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId1
                  consultDate: $consultDate
                  date: $date1
                  forDelivery: $forDelivery1
                  isReschedule: $isReschedule1
                  orderId: $orderId2
                ) {
                  time
                }
                consultation(input: $input11) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit2, offset: $offset2, order: $order1) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId2
                      date: $date2
                      forDelivery: $forDelivery2
                      isReschedule: $isReschedule2
                      orderId: $orderId3
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId3
                      consultDate: $consultDate1
                      date: $date3
                      forDelivery: $forDelivery3
                      isReschedule: $isReschedule3
                      orderId: $orderId4
                    ) {
                      time
                    }
                    consultation(input: $input5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input6
                      limit: $limit3
                      offset: $offset3
                      order: $order2
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input7, limit: $limit4, offset: $offset4, order: $order3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input8, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date4) {
                      date
                    }
                    partnerConsultTimes(date: $date5) {
                      time
                    }
                    patient(input: $input9) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input10) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input12
                  limit: $limit5
                  offset: $offset5
                  order: $order4
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input13, limit: $limit6, offset: $offset6, order: $order5) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input14, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input15) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input16) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            evaluationId
            sessionType
            status
            sysId
          }
          consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
            count
            limit
            offset
          }
          consultationTitle {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          countReminder
          createdAt
          doctor {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          messages {
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
          }
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          orderSysId
          participants {
            avatar
            fullName
            identity
            locale
            role
            token
            userSysId
          }
          participantsV2 {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            phoneNumber
            requireConfirmPolicy
            socialProviderType
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      orderNo
      orderSysId
      paymentAmount
      paymentDate
      paymentIntentId
      paymentProvider
      price {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredientDetails {
              description
              imageLink
              locale
              name
              strength
              uniqueName
            }
            ingredients
            isConsultOnly(platform: $platform12)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            prices {
              active
              alternativePrice {
                active
                alternativePrice {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                nickname
                product
                productId
                shopDisplay
                sysId
                tax_behavior
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                ingredients
                isConsultOnly(platform: $platform14)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              texts {
                actual_price_display
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                price_frequency
                price_quantity
                quantity
                quantity_display
              }
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            productInstructions {
              language
              localeKey
              productId
              sysId
              translatedText
            }
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            tempPrices {
              active
              alternativePrice {
                active
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                nickname
                product
                productId
                shopDisplay
                sysId
                tax_behavior
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                ingredients
                isConsultOnly(platform: $platform15)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              texts {
                actual_price_display
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                price_frequency
                price_quantity
                quantity
                quantity_display
              }
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            texts {
              benefits
              category
              display_price
              display_price_patient
              dosage_variant_body
              dosage_variant_title
              effective_in
              for
              frequency_variant_title
              good_to_know
              how_to_take
              how_to_use
              is_popular
              lasts_for
              platform
              product_description
              product_name
              product_short_description
              quantity_per_unit
              quantity_variant_title
              requires_prescription
              safety_information
              side_effects
              strength
              taken
              unit
              unit_patient
            }
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredients
          isConsultOnly(platform: $platform16)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform17)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      priceId
      product {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform18)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform19)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      promotionCode
      qty
      sysId
      updatedAt
    }
    note
    parcelId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    paused
    shipDate
    shipper {
      avatar
      calendarDates(
        acuityAppointmentId: $acuityAppointmentId4
        date: $date8
        forDelivery: $forDelivery4
        isReschedule: $isReschedule4
        orderId: $orderId5
      ) {
        date
      }
      calendarTimes(
        acuityAppointmentId: $acuityAppointmentId5
        consultDate: $consultDate2
        date: $date9
        forDelivery: $forDelivery5
        isReschedule: $isReschedule5
        orderId: $orderId6
      ) {
        time
      }
      consultation(input: $input17) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      consultationMessages(
        input: $input18
        limit: $limit8
        offset: $offset8
        order: $order7
      ) {
        count
        limit
        offset
      }
      consultations(input: $input19, limit: $limit9, offset: $offset9, order: $order8) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      doctor(doctorFilterInput: $doctorFilterInput4) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      doctors(doctorFilterInput: $doctorFilterInput5) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      orders(input: $input20, pagination: $pagination2) {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        acuityAppointment {
          appointmentTypeID
          bookedAt
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          bookedAt
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        additionalPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        afterVideoConsultRedirecting {
          baseUrl
          path
        }
        approveAt
        atomeNextSendingInvoiceDate
        atomePayments {
          amount
          paymentUrl
          priceId
          referenceId
          status
          sysId
        }
        checkoutSession {
          checkoutData
          evaluationId
          status
          sysId
        }
        childrenOrders {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        claimedRetentionOffer
        consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
          consultTime
          consultType
          createdBy
          evaluationId
          sessionType
          status
          sysId
        }
        consultations(inputConsultation: $inputConsultation5) {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluation {
          isCompleted
          isSkipped
          name
          patientNote
          platform
          status
          sysId
          type
        }
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        latestAtomePayment {
          amount
          paymentUrl
          priceId
          referenceId
          status
          sysId
        }
        latestInvoice {
          amount_due
          hosted_invoice_url
          id
          next_payment_attempt
          paid
          paymentStatus
          period_end
          starting_balance
          status
          subtotal
          tax
          total
        }
        latestNote {
          content
          createdAt
          createdBy
          sysId
          updatedAt
        }
        nextReviewDate
        oldPrice
        oldPriceInfo {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        pickupLocation {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribedAfterTrialOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        prescribed_after_trial_order_sys_id
        prescription {
          cancelled
          createdAt
          days
          doctorNotes
          endDate
          expiresAt
          isFollowUp
          notedDate
          priceIds
          startDate
          status
          sysId
          treatmentCode
          updatedAt
        }
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation {
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          consultBasePrice
          consultFee
          consultFeeAfterDiscount
          consultTax
          consultTransactionFee
          discountAmount
          isConsult
          mainBasePrice
          mainTax
          mainTransactionFee
          minimalAmountPayment
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          shouldChargeConsultFee
          subTotal
          total
          totalAfterCashback
        }
        price {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        priceDisplayId
        priceInfo {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInfo {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform20)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        siblingCrossSellOrders {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        status
        stripePaymentIntentId
        stripeSubscriptionId
        subscription {
          cancel_at_period_end
          current_period_end
          current_period_start
          default_payment_method
          id
          items
          latest_invoice
          metadata
          pause_collection
          pending_setup_intent
          pending_update
          status
        }
        sysId
        teleConsultProduct
        upcomingInvoice {
          amount_due
          hosted_invoice_url
          id
          next_payment_attempt
          paid
          paymentStatus
          period_end
          starting_balance
          status
          subtotal
          tax
          total
        }
        updatedAt
      }
      partnerConsultDates(date: $date10) {
        date
      }
      partnerConsultTimes(date: $date11) {
        time
      }
      patient(input: $input21) {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      patientDocuments {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      phoneNumber
      prescriptionCalculation {
        affiliateCouponNotApplied {
          affiliateProductDisplayName
          reason
        }
        isAffiliateLocked
        otcCalculationSummary {
          otcOrdersCalculation {
            basePrice
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            discountAmount
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            stripePromotionCode
            tax
            transactionFee
          }
          totalBasePrice
          totalCashbackEarned
          totalCashbackRedeemed
          totalPaymentIntentAmount
          totalTax
          totalTransactionFee
        }
        promotionCodeError
        rxCalculationSummary {
          rxOrdersCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          total
          totalCashbackEarned
          totalCashbackRedeemed
          totalDiscountAmount
          totalMainBasePrice
          totalPaymentIntentAmount
          totalPaymentIntentAmountAfterCashback
          totalTax
          totalTransactionFee
        }
        stripePromotionCode
      }
      requireConfirmPolicy
      socialProviderType
      stripeProducts(input: $input22) {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform21)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform22)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    status
    sysId
    trackingNo
    updatedAt
  }
}
    `;
export const useSplitShipmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SplitShipmentMutation, TError, SplitShipmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SplitShipmentMutation, TError, SplitShipmentMutationVariables, TContext>(
      ['splitShipment'],
      (variables?: SplitShipmentMutationVariables) => fetcher<SplitShipmentMutation, SplitShipmentMutationVariables>(client, SplitShipmentDocument, variables, headers)(),
      options
    );
export const StartCronJobDocument = `
    mutation startCronJob($jobName: String!) {
  startCronJob(jobName: $jobName)
}
    `;
export const useStartCronJobMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<StartCronJobMutation, TError, StartCronJobMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<StartCronJobMutation, TError, StartCronJobMutationVariables, TContext>(
      ['startCronJob'],
      (variables?: StartCronJobMutationVariables) => fetcher<StartCronJobMutation, StartCronJobMutationVariables>(client, StartCronJobDocument, variables, headers)(),
      options
    );
export const StopCronJobDocument = `
    mutation stopCronJob($jobName: String!) {
  stopCronJob(jobName: $jobName)
}
    `;
export const useStopCronJobMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<StopCronJobMutation, TError, StopCronJobMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<StopCronJobMutation, TError, StopCronJobMutationVariables, TContext>(
      ['stopCronJob'],
      (variables?: StopCronJobMutationVariables) => fetcher<StopCronJobMutation, StopCronJobMutationVariables>(client, StopCronJobDocument, variables, headers)(),
      options
    );
export const SubmitAffiliateCouponDocument = `
    mutation submitAffiliateCoupon($input: SubmitAffiliateCouponInput!) {
  submitAffiliateCoupon(input: $input) {
    affiliate {
      enabled
      name
      portalUrl
      region
      slug
      sysId
    }
    affiliateProduct {
      affiliate {
        enabled
        name
        portalUrl
        region
        slug
        sysId
      }
      affiliateSysId
      createdAt
      discountPercentage
      displayName
      enabled
      evalFlow
      slug
      stripePriceId
      stripeProductId
      sysId
      updatedAt
    }
    affiliateProductSysId
    affiliateSysId
    anonymousId
    couponId
    createdAt
    orderSysId
    status
    sysId
    updatedAt
  }
}
    `;
export const useSubmitAffiliateCouponMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SubmitAffiliateCouponMutation, TError, SubmitAffiliateCouponMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SubmitAffiliateCouponMutation, TError, SubmitAffiliateCouponMutationVariables, TContext>(
      ['submitAffiliateCoupon'],
      (variables?: SubmitAffiliateCouponMutationVariables) => fetcher<SubmitAffiliateCouponMutation, SubmitAffiliateCouponMutationVariables>(client, SubmitAffiliateCouponDocument, variables, headers)(),
      options
    );
export const SubmitEvaluationDocument = `
    mutation submitEvaluation($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $evaluationDataInput: PatientSubmitEvaluationInput!) {
  submitEvaluation(evaluationDataInput: $evaluationDataInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useSubmitEvaluationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SubmitEvaluationMutation, TError, SubmitEvaluationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SubmitEvaluationMutation, TError, SubmitEvaluationMutationVariables, TContext>(
      ['submitEvaluation'],
      (variables?: SubmitEvaluationMutationVariables) => fetcher<SubmitEvaluationMutation, SubmitEvaluationMutationVariables>(client, SubmitEvaluationDocument, variables, headers)(),
      options
    );
export const SubmitVideoCallRatingDocument = `
    mutation submitVideoCallRating($input: SubmitVideoCallRatingInput!) {
  submitVideoCallRating(input: $input) {
    success
  }
}
    `;
export const useSubmitVideoCallRatingMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SubmitVideoCallRatingMutation, TError, SubmitVideoCallRatingMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SubmitVideoCallRatingMutation, TError, SubmitVideoCallRatingMutationVariables, TContext>(
      ['submitVideoCallRating'],
      (variables?: SubmitVideoCallRatingMutationVariables) => fetcher<SubmitVideoCallRatingMutation, SubmitVideoCallRatingMutationVariables>(client, SubmitVideoCallRatingDocument, variables, headers)(),
      options
    );
export const SyncMissingLatestInvoiceForSubscriptionOrdersDocument = `
    mutation syncMissingLatestInvoiceForSubscriptionOrders {
  syncMissingLatestInvoiceForSubscriptionOrders
}
    `;
export const useSyncMissingLatestInvoiceForSubscriptionOrdersMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SyncMissingLatestInvoiceForSubscriptionOrdersMutation, TError, SyncMissingLatestInvoiceForSubscriptionOrdersMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SyncMissingLatestInvoiceForSubscriptionOrdersMutation, TError, SyncMissingLatestInvoiceForSubscriptionOrdersMutationVariables, TContext>(
      ['syncMissingLatestInvoiceForSubscriptionOrders'],
      (variables?: SyncMissingLatestInvoiceForSubscriptionOrdersMutationVariables) => fetcher<SyncMissingLatestInvoiceForSubscriptionOrdersMutation, SyncMissingLatestInvoiceForSubscriptionOrdersMutationVariables>(client, SyncMissingLatestInvoiceForSubscriptionOrdersDocument, variables, headers)(),
      options
    );
export const SyncProductPriceLocaleFilesDocument = `
    mutation syncProductPriceLocaleFiles {
  syncProductPriceLocaleFiles
}
    `;
export const useSyncProductPriceLocaleFilesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SyncProductPriceLocaleFilesMutation, TError, SyncProductPriceLocaleFilesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SyncProductPriceLocaleFilesMutation, TError, SyncProductPriceLocaleFilesMutationVariables, TContext>(
      ['syncProductPriceLocaleFiles'],
      (variables?: SyncProductPriceLocaleFilesMutationVariables) => fetcher<SyncProductPriceLocaleFilesMutation, SyncProductPriceLocaleFilesMutationVariables>(client, SyncProductPriceLocaleFilesDocument, variables, headers)(),
      options
    );
export const SyncStripeDocument = `
    mutation syncStripe {
  syncStripe
}
    `;
export const useSyncStripeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SyncStripeMutation, TError, SyncStripeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SyncStripeMutation, TError, SyncStripeMutationVariables, TContext>(
      ['syncStripe'],
      (variables?: SyncStripeMutationVariables) => fetcher<SyncStripeMutation, SyncStripeMutationVariables>(client, SyncStripeDocument, variables, headers)(),
      options
    );
export const Test_GenerateSmartMatchResultsDocument = `
    mutation test_generateSmartMatchResults($input: Test_GenerateSmartMatchResultsInput!) {
  test_generateSmartMatchResults(input: $input) {
    evalId
    smartMatchResults
    status
    sysId
    userId
    userType
  }
}
    `;
export const useTest_GenerateSmartMatchResultsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<Test_GenerateSmartMatchResultsMutation, TError, Test_GenerateSmartMatchResultsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<Test_GenerateSmartMatchResultsMutation, TError, Test_GenerateSmartMatchResultsMutationVariables, TContext>(
      ['test_generateSmartMatchResults'],
      (variables?: Test_GenerateSmartMatchResultsMutationVariables) => fetcher<Test_GenerateSmartMatchResultsMutation, Test_GenerateSmartMatchResultsMutationVariables>(client, Test_GenerateSmartMatchResultsDocument, variables, headers)(),
      options
    );
export const TranslateRawTextDocument = `
    mutation translateRawText($input: TranslateRawTextInput!) {
  translateRawText(input: $input) {
    sourceLanguage
    targetLanguage
    translatedText
  }
}
    `;
export const useTranslateRawTextMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TranslateRawTextMutation, TError, TranslateRawTextMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TranslateRawTextMutation, TError, TranslateRawTextMutationVariables, TContext>(
      ['translateRawText'],
      (variables?: TranslateRawTextMutationVariables) => fetcher<TranslateRawTextMutation, TranslateRawTextMutationVariables>(client, TranslateRawTextDocument, variables, headers)(),
      options
    );
export const TriggerOnPaidAtomePaymentDocument = `
    mutation triggerOnPaidAtomePayment($referenceId: String!) {
  triggerOnPaidAtomePayment(referenceId: $referenceId)
}
    `;
export const useTriggerOnPaidAtomePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TriggerOnPaidAtomePaymentMutation, TError, TriggerOnPaidAtomePaymentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TriggerOnPaidAtomePaymentMutation, TError, TriggerOnPaidAtomePaymentMutationVariables, TContext>(
      ['triggerOnPaidAtomePayment'],
      (variables?: TriggerOnPaidAtomePaymentMutationVariables) => fetcher<TriggerOnPaidAtomePaymentMutation, TriggerOnPaidAtomePaymentMutationVariables>(client, TriggerOnPaidAtomePaymentDocument, variables, headers)(),
      options
    );
export const TrySecondOpinionV2Document = `
    mutation trySecondOpinionV2($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: TrySecondOpinionInputV2!) {
  trySecondOpinionV2(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useTrySecondOpinionV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TrySecondOpinionV2Mutation, TError, TrySecondOpinionV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TrySecondOpinionV2Mutation, TError, TrySecondOpinionV2MutationVariables, TContext>(
      ['trySecondOpinionV2'],
      (variables?: TrySecondOpinionV2MutationVariables) => fetcher<TrySecondOpinionV2Mutation, TrySecondOpinionV2MutationVariables>(client, TrySecondOpinionV2Document, variables, headers)(),
      options
    );
export const UpdateAddressDocument = `
    mutation updateAddress($updateDeliveryInput: V2AddressInput!) {
  updateAddress(updateDeliveryInput: $updateDeliveryInput) {
    address
    city
    country
    firstName
    lastName
    name
    note
    phoneNumber
    postal
    region
    sameAsBilling
    state
    sysId
    type
    unit
  }
}
    `;
export const useUpdateAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAddressMutation, TError, UpdateAddressMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAddressMutation, TError, UpdateAddressMutationVariables, TContext>(
      ['updateAddress'],
      (variables?: UpdateAddressMutationVariables) => fetcher<UpdateAddressMutation, UpdateAddressMutationVariables>(client, UpdateAddressDocument, variables, headers)(),
      options
    );
export const UpdateAffiliateDocument = `
    mutation updateAffiliate($input: UpdateAffiliateInput!, $sysId: String!) {
  updateAffiliate(input: $input, sysId: $sysId) {
    createdAt
    enabled
    formFieldMap
    formSubmitUrl
    name
    notificationChannel
    notificationEmail
    portalUrl
    region
    slug
    sysId
    updatedAt
  }
}
    `;
export const useUpdateAffiliateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAffiliateMutation, TError, UpdateAffiliateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAffiliateMutation, TError, UpdateAffiliateMutationVariables, TContext>(
      ['updateAffiliate'],
      (variables?: UpdateAffiliateMutationVariables) => fetcher<UpdateAffiliateMutation, UpdateAffiliateMutationVariables>(client, UpdateAffiliateDocument, variables, headers)(),
      options
    );
export const UpdateAffiliateCouponVerificationDocument = `
    mutation updateAffiliateCouponVerification($opsNote: String, $status: AffiliateCouponStatus!, $sysId: String!) {
  updateAffiliateCouponVerification(
    opsNote: $opsNote
    status: $status
    sysId: $sysId
  ) {
    affiliate {
      enabled
      name
      portalUrl
      region
      slug
      sysId
    }
    affiliateProduct {
      affiliate {
        enabled
        name
        portalUrl
        region
        slug
        sysId
      }
      affiliateSysId
      couponLandingUrl
      createdAt
      discountPercentage
      displayName
      enabled
      evalFlow
      externalPortalUrl
      slug
      stripePriceId
      stripeProductId
      stripePromotionCode
      stripePromotionCodeId
      sysId
      unitAmount
      updatedAt
    }
    affiliateProductSysId
    affiliateSysId
    anonymousId
    couponId
    createdAt
    opsNote
    orderSysId
    status
    sysId
    updatedAt
    verifiedAt
    verifiedByUserSysId
  }
}
    `;
export const useUpdateAffiliateCouponVerificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAffiliateCouponVerificationMutation, TError, UpdateAffiliateCouponVerificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAffiliateCouponVerificationMutation, TError, UpdateAffiliateCouponVerificationMutationVariables, TContext>(
      ['updateAffiliateCouponVerification'],
      (variables?: UpdateAffiliateCouponVerificationMutationVariables) => fetcher<UpdateAffiliateCouponVerificationMutation, UpdateAffiliateCouponVerificationMutationVariables>(client, UpdateAffiliateCouponVerificationDocument, variables, headers)(),
      options
    );
export const UpdateAffiliateProductDocument = `
    mutation updateAffiliateProduct($input: UpdateAffiliateProductInput!, $sysId: String!) {
  updateAffiliateProduct(input: $input, sysId: $sysId) {
    affiliate {
      enabled
      name
      portalUrl
      region
      slug
      sysId
    }
    affiliateSysId
    couponLandingUrl
    createdAt
    discountPercentage
    displayName
    enabled
    evalFlow
    externalPortalUrl
    slug
    stripePriceId
    stripeProductId
    stripePromotionCode
    stripePromotionCodeId
    sysId
    unitAmount
    updatedAt
  }
}
    `;
export const useUpdateAffiliateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAffiliateProductMutation, TError, UpdateAffiliateProductMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAffiliateProductMutation, TError, UpdateAffiliateProductMutationVariables, TContext>(
      ['updateAffiliateProduct'],
      (variables?: UpdateAffiliateProductMutationVariables) => fetcher<UpdateAffiliateProductMutation, UpdateAffiliateProductMutationVariables>(client, UpdateAffiliateProductDocument, variables, headers)(),
      options
    );
export const UpdateAtomePaymentDocument = `
    mutation updateAtomePayment($input: V2UpdateAtomePaymentInput!) {
  updateAtomePayment(input: $input) {
    amount
    paymentUrl
    priceId
    referenceId
    status
    summary {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    sysId
  }
}
    `;
export const useUpdateAtomePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAtomePaymentMutation, TError, UpdateAtomePaymentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAtomePaymentMutation, TError, UpdateAtomePaymentMutationVariables, TContext>(
      ['updateAtomePayment'],
      (variables?: UpdateAtomePaymentMutationVariables) => fetcher<UpdateAtomePaymentMutation, UpdateAtomePaymentMutationVariables>(client, UpdateAtomePaymentDocument, variables, headers)(),
      options
    );
export const UpdateCartCalculateOrderSummaryDocument = `
    mutation updateCartCalculateOrderSummary($input: UpdateCartCalculateOrderSummaryInput!) {
  updateCartCalculateOrderSummary(input: $input)
}
    `;
export const useUpdateCartCalculateOrderSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCartCalculateOrderSummaryMutation, TError, UpdateCartCalculateOrderSummaryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCartCalculateOrderSummaryMutation, TError, UpdateCartCalculateOrderSummaryMutationVariables, TContext>(
      ['updateCartCalculateOrderSummary'],
      (variables?: UpdateCartCalculateOrderSummaryMutationVariables) => fetcher<UpdateCartCalculateOrderSummaryMutation, UpdateCartCalculateOrderSummaryMutationVariables>(client, UpdateCartCalculateOrderSummaryDocument, variables, headers)(),
      options
    );
export const UpdateCartItemByIdDocument = `
    mutation updateCartItemById($input: UpdateCartItemByIdInput!) {
  updateCartItemById(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary
    calculation
    cart
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    errorCode
    paidCompletedEvaluationIds
    platform
    promotionCode
    status
    sysId
  }
}
    `;
export const useUpdateCartItemByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCartItemByIdMutation, TError, UpdateCartItemByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCartItemByIdMutation, TError, UpdateCartItemByIdMutationVariables, TContext>(
      ['updateCartItemById'],
      (variables?: UpdateCartItemByIdMutationVariables) => fetcher<UpdateCartItemByIdMutation, UpdateCartItemByIdMutationVariables>(client, UpdateCartItemByIdDocument, variables, headers)(),
      options
    );
export const UpdateCheckoutSessionDocument = `
    mutation updateCheckoutSession($patientId: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $platform1: String, $platform2: String, $platform3: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform4: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit: Float, $offset: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $videoLink1: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform5: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit1: Int, $offset1: Int, $order: JSON, $input6: ConsultationListInput!, $limit2: Int, $offset2: Int, $order1: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform6: String, $input9: StripeProductFilterV2, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform7: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform8: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit3: Int, $offset3: Int, $order2: JSON, $input11: ConsultationMessagesInput!, $limit4: Int, $offset4: Int, $order3: JSON, $input12: ConsultationListInput!, $limit5: Int, $offset5: Int, $order4: JSON, $doctorFilterInput2: V2DoctorInputFilter, $doctorFilterInput3: V2DoctorInputFilter, $input13: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input14: GetPatientInput, $platform9: String, $input15: StripeProductFilterV2, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input16: V2ConsultationFilterInput!, $input17: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $limit7: Int, $offset7: Int, $order6: JSON, $input18: ConsultationListInput!, $limit8: Int, $offset8: Int, $order7: JSON, $doctorFilterInput4: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $doctorFilterInput5: V2DoctorInputFilter, $input19: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input20: GetPatientInput, $platform10: String, $platform11: String, $input21: StripeProductFilterV2, $input22: V2ConsultationFilterInput!, $limit9: Int, $offset9: Int, $order8: JSON, $updateCheckoutSessionInput: UpdateCheckoutSessionInput!) {
  updateCheckoutSession(updateCheckoutSessionInput: $updateCheckoutSessionInput) {
    checkoutData
    evaluationId
    order {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      activeConsultation {
        consultationAudit {
          consultTime
          consultType
          createdBy
          doctor {
            active
            bio {
              createdAt
              createdBy
              remark
              sysId
              translationKey
              updatedAt
              updatedBy
              valueEn
              valueJa
              valueZh
            }
            calendarId
            consultation(videoLink: $videoLink1) {
              gmeetLink
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                acuityAppointment {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                additionalPrices {
                  active
                  alternativePrice {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform3)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                afterVideoConsultRedirecting {
                  baseUrl
                  path
                }
                approveAt
                atomeNextSendingInvoiceDate
                atomePayments {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  summary {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  sysId
                }
                checkoutSession {
                  checkoutData
                  evaluationId
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit, offset: $offset, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  status
                  sysId
                }
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              previewToken
              previewVideoLink
              status
              sysId
              token
              videoChannelId
              videoLink
              zoomJoinUrl
            }
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          evaluationId
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          sessionType
          status
          sysId
        }
        consultationMessages(limit: $limit9, offset: $offset9, order: $order8) {
          count
          items {
            automatedMessage {
              createdAt
              createdBy
              remark
              sysId
              translationKey
              updatedAt
              updatedBy
              valueEn
              valueJa
              valueZh
            }
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
            user {
              admin {
                crossSellRecords(input: $input10) {
                  childOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  childOrderId
                  createdAt
                  createdBy
                  creator {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit1
                      offset: $offset1
                      order: $order
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit2, offset: $offset2, order: $order1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  parentOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  parentOrderId
                  priceId
                  selectedBy
                  stripeProductPrice {
                    importPriceId
                    isBundle
                    priceActive
                    priceBillingScheme
                    priceCreated
                    priceCurrency
                    priceDisplayId
                    priceFirstTimeAlternativePrice
                    priceFirstTimeTryingInMonths
                    priceId
                    priceLivemode
                    priceNickname
                    priceProduct
                    priceTaxBehavior
                    priceUnitAmount
                    priceUnitAmountDecimal
                    productActive
                    productDescription
                    productDisplayId
                    productId
                    productLivemode
                    productName
                    productStatementDescriptor
                    productType
                    productUniqName
                    productUnitLabel
                    sysId
                  }
                  sysId
                }
                order(orderId: $orderId2) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                  count
                  items {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  limit
                  offset
                }
                patient(patientId: $patientId1) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
              }
              avatar
              calendarDates(
                acuityAppointmentId: $acuityAppointmentId2
                date: $date4
                forDelivery: $forDelivery2
                isReschedule: $isReschedule2
                orderId: $orderId3
              ) {
                date
              }
              calendarTimes(
                acuityAppointmentId: $acuityAppointmentId3
                consultDate: $consultDate1
                date: $date5
                forDelivery: $forDelivery3
                isReschedule: $isReschedule3
                orderId: $orderId4
              ) {
                time
              }
              consultation(input: $input22) {
                consultationAudit {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultationMessages(limit: $limit3, offset: $offset3, order: $order2) {
                  count
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    consultationMessages(
                      input: $input11
                      limit: $limit4
                      offset: $offset4
                      order: $order3
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input12, limit: $limit5, offset: $offset5, order: $order4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput2) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput3) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input13, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input14) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input15) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId4
                    date: $date8
                    forDelivery: $forDelivery4
                    isReschedule: $isReschedule4
                    orderId: $orderId5
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId5
                    consultDate: $consultDate2
                    date: $date9
                    forDelivery: $forDelivery5
                    isReschedule: $isReschedule5
                    orderId: $orderId6
                  ) {
                    time
                  }
                  consultation(input: $input16) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input17
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input18, limit: $limit8, offset: $offset8, order: $order7) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput4) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput5) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink2) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input19, pagination: $pagination2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date10) {
                    date
                  }
                  partnerConsultTimes(date: $date11) {
                    time
                  }
                  patient(input: $input20) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input21) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform11)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              locale
              ninjaVanToken
              phoneNumber
              requireConfirmPolicy
              socialProviderType
              sysId
              tempToken
              tempTokenExpired
              userType
              utmCampaign
              utmId
              utmMedium
              utmSource
            }
          }
          limit
          offset
        }
        consultationTitle {
          createdAt
          createdBy
          remark
          sysId
          translationKey
          updatedAt
          updatedBy
          valueEn
          valueJa
          valueZh
        }
        countReminder
        createdAt
        doctor {
          active
          calendarId
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        messages {
          consultationSysId
          content
          createdAt
          readAt
          sysId
          updatedAt
        }
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        orderSysId
        participants {
          avatar
          fullName
          identity
          locale
          role
          token
          userSysId
        }
        participantsV2 {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          locale
          ninjaVanToken
          phoneNumber
          requireConfirmPolicy
          socialProviderType
          sysId
          tempToken
          tempTokenExpired
          userType
          utmCampaign
          utmId
          utmMedium
          utmSource
        }
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    status
    sysId
  }
}
    `;
export const useUpdateCheckoutSessionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCheckoutSessionMutation, TError, UpdateCheckoutSessionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCheckoutSessionMutation, TError, UpdateCheckoutSessionMutationVariables, TContext>(
      ['updateCheckoutSession'],
      (variables?: UpdateCheckoutSessionMutationVariables) => fetcher<UpdateCheckoutSessionMutation, UpdateCheckoutSessionMutationVariables>(client, UpdateCheckoutSessionDocument, variables, headers)(),
      options
    );
export const UpdateCompletedEvalDocument = `
    mutation updateCompletedEval($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $input: UpdateCompletedEvalInput!) {
  updateCompletedEval(input: $input) {
    completed
    createdAt
    evaluationFormLastUpdated
    evaluationId
    formQandA
    jumpToSectionIndex
    oldPatientId
    patient
    patientSnapshot {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    patientdoctorNotes
    questionTotal
    sectionHistory
    sectionIndex
    sectionTotal
    sysId
    updatedAt
    valid
  }
}
    `;
export const useUpdateCompletedEvalMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCompletedEvalMutation, TError, UpdateCompletedEvalMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCompletedEvalMutation, TError, UpdateCompletedEvalMutationVariables, TContext>(
      ['updateCompletedEval'],
      (variables?: UpdateCompletedEvalMutationVariables) => fetcher<UpdateCompletedEvalMutation, UpdateCompletedEvalMutationVariables>(client, UpdateCompletedEvalDocument, variables, headers)(),
      options
    );
export const UpdateCompletedEvalForGuestsDocument = `
    mutation updateCompletedEvalForGuests($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $input: UpdateCompletedEvalInputForGuest!) {
  updateCompletedEvalForGuests(input: $input) {
    completed
    createdAt
    evaluationFormLastUpdated
    evaluationId
    formQandA
    jumpToSectionIndex
    oldPatientId
    patient
    patientSnapshot {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    patientdoctorNotes
    questionTotal
    sectionHistory
    sectionIndex
    sectionTotal
    sysId
    updatedAt
    valid
  }
}
    `;
export const useUpdateCompletedEvalForGuestsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCompletedEvalForGuestsMutation, TError, UpdateCompletedEvalForGuestsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCompletedEvalForGuestsMutation, TError, UpdateCompletedEvalForGuestsMutationVariables, TContext>(
      ['updateCompletedEvalForGuests'],
      (variables?: UpdateCompletedEvalForGuestsMutationVariables) => fetcher<UpdateCompletedEvalForGuestsMutation, UpdateCompletedEvalForGuestsMutationVariables>(client, UpdateCompletedEvalForGuestsDocument, variables, headers)(),
      options
    );
export const UpdateCustomerBalanceTransactionDocument = `
    mutation updateCustomerBalanceTransaction($input: UpdateCustomerBalanceTransactionInput!) {
  updateCustomerBalanceTransaction(input: $input)
}
    `;
export const useUpdateCustomerBalanceTransactionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCustomerBalanceTransactionMutation, TError, UpdateCustomerBalanceTransactionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCustomerBalanceTransactionMutation, TError, UpdateCustomerBalanceTransactionMutationVariables, TContext>(
      ['updateCustomerBalanceTransaction'],
      (variables?: UpdateCustomerBalanceTransactionMutationVariables) => fetcher<UpdateCustomerBalanceTransactionMutation, UpdateCustomerBalanceTransactionMutationVariables>(client, UpdateCustomerBalanceTransactionDocument, variables, headers)(),
      options
    );
export const UpdateEvaluationProgressDocument = `
    mutation updateEvaluationProgress($input: UpdateProcessEvaluationInput!) {
  updateEvaluationProgress(input: $input)
}
    `;
export const useUpdateEvaluationProgressMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateEvaluationProgressMutation, TError, UpdateEvaluationProgressMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateEvaluationProgressMutation, TError, UpdateEvaluationProgressMutationVariables, TContext>(
      ['updateEvaluationProgress'],
      (variables?: UpdateEvaluationProgressMutationVariables) => fetcher<UpdateEvaluationProgressMutation, UpdateEvaluationProgressMutationVariables>(client, UpdateEvaluationProgressDocument, variables, headers)(),
      options
    );
export const UpdateEvaluationQuestionDocument = `
    mutation updateEvaluationQuestion($input: UpdateEvaluationQuestionInput!) {
  updateEvaluationQuestion(input: $input)
}
    `;
export const useUpdateEvaluationQuestionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateEvaluationQuestionMutation, TError, UpdateEvaluationQuestionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateEvaluationQuestionMutation, TError, UpdateEvaluationQuestionMutationVariables, TContext>(
      ['updateEvaluationQuestion'],
      (variables?: UpdateEvaluationQuestionMutationVariables) => fetcher<UpdateEvaluationQuestionMutation, UpdateEvaluationQuestionMutationVariables>(client, UpdateEvaluationQuestionDocument, variables, headers)(),
      options
    );
export const UpdateMhpOrderDosageDocument = `
    mutation updateMhpOrderDosage($updateOrderDosageInput: UpdateMhpOrderDosageInput!) {
  updateMhpOrderDosage(updateOrderDosageInput: $updateOrderDosageInput)
}
    `;
export const useUpdateMhpOrderDosageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateMhpOrderDosageMutation, TError, UpdateMhpOrderDosageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateMhpOrderDosageMutation, TError, UpdateMhpOrderDosageMutationVariables, TContext>(
      ['updateMhpOrderDosage'],
      (variables?: UpdateMhpOrderDosageMutationVariables) => fetcher<UpdateMhpOrderDosageMutation, UpdateMhpOrderDosageMutationVariables>(client, UpdateMhpOrderDosageDocument, variables, headers)(),
      options
    );
export const UpdateOrderDocument = `
    mutation updateOrder($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: UpdateOrderInput!) {
  updateOrder(input: $input) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useUpdateOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrderMutation, TError, UpdateOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateOrderMutation, TError, UpdateOrderMutationVariables, TContext>(
      ['updateOrder'],
      (variables?: UpdateOrderMutationVariables) => fetcher<UpdateOrderMutation, UpdateOrderMutationVariables>(client, UpdateOrderDocument, variables, headers)(),
      options
    );
export const UpdateOrderByOpsV2Document = `
    mutation updateOrderByOpsV2($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $updateOrderInput: V2UpdateOrderInput!) {
  updateOrderByOpsV2(updateOrderInput: $updateOrderInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useUpdateOrderByOpsV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrderByOpsV2Mutation, TError, UpdateOrderByOpsV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateOrderByOpsV2Mutation, TError, UpdateOrderByOpsV2MutationVariables, TContext>(
      ['updateOrderByOpsV2'],
      (variables?: UpdateOrderByOpsV2MutationVariables) => fetcher<UpdateOrderByOpsV2Mutation, UpdateOrderByOpsV2MutationVariables>(client, UpdateOrderByOpsV2Document, variables, headers)(),
      options
    );
export const UpdateOrderNoteDocument = `
    mutation updateOrderNote($input: UpdateOrderNoteInput!) {
  updateOrderNote(input: $input)
}
    `;
export const useUpdateOrderNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrderNoteMutation, TError, UpdateOrderNoteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateOrderNoteMutation, TError, UpdateOrderNoteMutationVariables, TContext>(
      ['updateOrderNote'],
      (variables?: UpdateOrderNoteMutationVariables) => fetcher<UpdateOrderNoteMutation, UpdateOrderNoteMutationVariables>(client, UpdateOrderNoteDocument, variables, headers)(),
      options
    );
export const UpdateOtherInterestedEvalIdsDocument = `
    mutation updateOtherInterestedEvalIds($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $interestedEvalIdInput: V2UpdateOtherInterestedEvalIdsInput) {
  updateOtherInterestedEvalIds(interestedEvalIdInput: $interestedEvalIdInput) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const useUpdateOtherInterestedEvalIdsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOtherInterestedEvalIdsMutation, TError, UpdateOtherInterestedEvalIdsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateOtherInterestedEvalIdsMutation, TError, UpdateOtherInterestedEvalIdsMutationVariables, TContext>(
      ['updateOtherInterestedEvalIds'],
      (variables?: UpdateOtherInterestedEvalIdsMutationVariables) => fetcher<UpdateOtherInterestedEvalIdsMutation, UpdateOtherInterestedEvalIdsMutationVariables>(client, UpdateOtherInterestedEvalIdsDocument, variables, headers)(),
      options
    );
export const UpdatePatientDocument = `
    mutation updatePatient($id: String, $platform: String, $platform1: String, $platform2: String, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform9: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform10: String, $id1: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id2: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform11: String, $platform12: String, $platform13: String, $platform14: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform15: String, $videoLink1: String!, $patientId: String, $input4: CrossSellRecordQueryInput, $orderId: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId1: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId2: String, $limit2: Int, $offset2: Int, $order1: JSON, $acuityAppointmentId2: String, $date2: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date3: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $input5: V2ConsultationFilterInput!, $input6: ConsultationMessagesInput!, $limit3: Int, $offset3: Int, $order2: JSON, $input7: ConsultationListInput!, $limit4: Int, $offset4: Int, $order3: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input8: OrderInput!, $pagination: V2PaginationInput!, $date4: String, $date5: Float, $input9: GetPatientInput, $platform16: String, $input10: StripeProductFilterV2, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit5: Int, $offset5: Int, $order4: JSON, $input13: ConsultationListInput!, $limit6: Int, $offset6: Int, $order5: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform17: String, $input16: StripeProductFilterV2, $doctorFilterInput3: V2DoctorInputFilter, $limit7: Int, $offset7: Int, $order6: JSON, $checkoutSessionFilterOptions1: CheckoutSessionFilterInput, $inputConsultation5: V2ConsultationFilterInput, $input17: GetPatientDocumentInput!, $evalFilter1: V2PatientEvaluationFilterInput, $id3: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform18: String, $inputOrder2: V2OrderFilterInput, $orderPagination2: V2PaginationInput, $input18: PrescriptionCalculationInput, $platform19: String, $platform20: String, $filter1: ShopProductFilterInputV2, $limit8: Float, $offset8: Float, $sort1: ShopProductSortInputV2, $input19: GetSmartMatchMetaInput!, $input20: PatientGetSurveyInput, $videoLink3: String!, $previewVideoLink1: String!, $input21: V2UpdatePatientInput!) {
  updatePatient(input: $input21) {
    atomePayment(id: $id) {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    bypassLoginTokens {
      expiresAt
      pageName
      token
      type
    }
    cart {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      cartItems {
        cart {
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          orderSummary {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            discountAmountLater
            discountAmountNow
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountBeforeTax
            paymentIntentSummary
            promotionCode
            shippingFee
            subTotal
            subTotalLater
            subTotalNow
            taxes
            taxesLater
            taxesNow
            teleConsultFee
            total
            totalLater
            totalNow
            totalNowAfterCashback
            totalTaxes
          }
          paidCompletedEvaluationIds
          platform
          promotionCode
          status
          sysId
        }
        completedEval
        consultationSessionType
        isAutoRenewal
        isSkipMedSelecting
        isSubscriptionPrice
        orderId
        patientNote
        price {
          active
          alternativePrice {
            active
            alternativePrice {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                drDosageFrequency {
                  alternativeDosage
                  alternativeDosageUnit
                  asNeeded
                  dosage
                  dosageUnit
                  duration
                  durationUnit
                  frequency
                  productId
                  quantity
                  quantityUnit
                }
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredients
                  isConsultOnly(platform: $platform1)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                ingredientDetails {
                  description
                  imageLink
                  locale
                  name
                  strength
                  uniqueName
                }
                ingredients
                isConsultOnly(platform: $platform2)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                prices {
                  active
                  alternativePrice {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform3)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          metadata {
            actual_price_display
            boxes
            dosage
            dosage_display
            dosage_popular
            frequency
            frequency_actual_price_display
            frequency_display
            frequency_popular
            frequency_price_display
            frequency_quantity_display
            frequency_quantity_display_patient
            frequency_savings_display
            frequency_strikeout_price_display
            isArchived
            isOneTimePrice
            price_frequency
            price_quantity
            price_show
            quantity
            quantity_display
            strength
          }
          nickname
          product
          productId
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform4)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          shopDisplay
          sysId
          tax_behavior
          texts {
            actual_price_display
            dosage
            dosage_display
            dosage_popular
            frequency
            frequency_actual_price_display
            frequency_display
            frequency_popular
            frequency_price_display
            frequency_quantity_display
            frequency_quantity_display_patient
            frequency_savings_display
            frequency_strikeout_price_display
            price_frequency
            price_quantity
            quantity
            quantity_display
          }
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        product {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform5)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredientDetails {
            description
            imageLink
            locale
            name
            strength
            uniqueName
          }
          ingredients
          isConsultOnly(platform: $platform6)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          prices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInstructions {
            language
            localeKey
            productId
            sysId
            translatedText
          }
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          tempPrices {
            active
            alternativePrice {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            metadata {
              actual_price_display
              boxes
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              isArchived
              isOneTimePrice
              price_frequency
              price_quantity
              price_show
              quantity
              quantity_display
              strength
            }
            nickname
            product
            productId
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform7)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            shopDisplay
            sysId
            tax_behavior
            texts {
              actual_price_display
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              price_frequency
              price_quantity
              quantity
              quantity_display
            }
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          texts {
            benefits
            category
            display_price
            display_price_patient
            dosage_variant_body
            dosage_variant_title
            effective_in
            for
            frequency_variant_title
            good_to_know
            how_to_take
            how_to_use
            is_popular
            lasts_for
            platform
            product_description
            product_name
            product_short_description
            quantity_per_unit
            quantity_variant_title
            requires_prescription
            safety_information
            side_effects
            strength
            taken
            unit
            unit_patient
          }
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        quantity
        teleConsultForSkipEval
        type
      }
      paidCompletedEvaluationIds
      platform
      promotionCode
      status
      sysId
    }
    cashback {
      availableBalance
      recentTransactions {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
      savingsToDateThisYear {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
    }
    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions1) {
      checkoutData
      evaluationId
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          consultationAudit {
            consultTime
            consultType
            createdBy
            doctor {
              active
              bio {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              calendarId
              consultation(videoLink: $videoLink1) {
                gmeetLink
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id1) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform13)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform14)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform15)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                previewToken
                previewVideoLink
                status
                sysId
                token
                videoChannelId
                videoLink
                zoomJoinUrl
              }
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              patient(patientId: $patientId) {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sysId
              textConsultPostalCodes
              trtEligible
              user {
                admin {
                  crossSellRecords(input: $input4) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId
                  date: $date
                  forDelivery: $forDelivery
                  isReschedule: $isReschedule
                  orderId: $orderId1
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId1
                  consultDate: $consultDate
                  date: $date1
                  forDelivery: $forDelivery1
                  isReschedule: $isReschedule1
                  orderId: $orderId2
                ) {
                  time
                }
                consultation(input: $input11) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit2, offset: $offset2, order: $order1) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId2
                      date: $date2
                      forDelivery: $forDelivery2
                      isReschedule: $isReschedule2
                      orderId: $orderId3
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId3
                      consultDate: $consultDate1
                      date: $date3
                      forDelivery: $forDelivery3
                      isReschedule: $isReschedule3
                      orderId: $orderId4
                    ) {
                      time
                    }
                    consultation(input: $input5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input6
                      limit: $limit3
                      offset: $offset3
                      order: $order2
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input7, limit: $limit4, offset: $offset4, order: $order3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input8, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date4) {
                      date
                    }
                    partnerConsultTimes(date: $date5) {
                      time
                    }
                    patient(input: $input9) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input10) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform16)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input12
                  limit: $limit5
                  offset: $offset5
                  order: $order4
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input13, limit: $limit6, offset: $offset6, order: $order5) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input14, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input15) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input16) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            evaluationId
            sessionType
            status
            sysId
          }
          consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
            count
            limit
            offset
          }
          consultationTitle {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          countReminder
          createdAt
          doctor {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          messages {
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
          }
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          orderSysId
          participants {
            avatar
            fullName
            identity
            locale
            role
            token
            userSysId
          }
          participantsV2 {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            phoneNumber
            requireConfirmPolicy
            socialProviderType
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation5) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    document(input: $input17) {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    documents {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    email
    evaluations(evalFilter: $evalFilter1) {
      isCompleted
      isSkipped
      name
      patientAnswers {
        answer {
          childrenAnswers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        question {
          answers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          content {
            body {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            footer {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            header {
              description
              descriptionTextKey
              title
              titleTextKey
            }
          }
          dependentEvaluationQuestions {
            answer {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            skipPage
            skipQuestionCount
            sysId
          }
          displayPage
          evaluationBlocks {
            blockAnswer {
              childrenAnswers {
                deselectAll
                mandatory
                name
                order
                placeholder
                productUrl
                sysId
                textKey
                type
              }
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            content {
              description
              descriptionTextKey
              sysId
              title
              titleTextKey
            }
            sysId
          }
          guestOnly
          name
          order
          sysId
          textKey
          type
          validation {
            bmi
            extra
            max
            min
            preselect
            type
          }
        }
        type
        value
      }
      patientNote
      platform
      questions {
        answers {
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        dependentEvaluationQuestions {
          skipPage
          skipQuestionCount
          sysId
        }
        displayPage
        evaluationBlocks {
          sysId
        }
        guestOnly
        name
        order
        sysId
        textKey
        type
        validation {
          bmi
          extra
          max
          min
          preselect
          type
        }
      }
      status
      sysId
      type
    }
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    idVerifiedAt
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    latestPaymentMethod {
      card {
        brand
        exp_month
        exp_year
        last4
      }
      id
    }
    legalName
    locale
    mounjaroTrialEligible
    order(id: $id3) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    orders(inputOrder: $inputOrder2, orderPagination: $orderPagination2) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      activeConsultation {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      acuityAppointment {
        appointmentTypeID
        bookedAt
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        bookedAt
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      additionalPrices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      afterVideoConsultRedirecting {
        baseUrl
        path
      }
      approveAt
      atomeNextSendingInvoiceDate
      atomePayments {
        amount
        paymentUrl
        priceId
        referenceId
        status
        sysId
      }
      checkoutSession {
        checkoutData
        evaluationId
        status
        sysId
      }
      childrenOrders {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      claimedRetentionOffer
      consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
        consultTime
        consultType
        createdBy
        evaluationId
        sessionType
        status
        sysId
      }
      consultations(inputConsultation: $inputConsultation6) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluation {
        isCompleted
        isSkipped
        name
        patientNote
        platform
        status
        sysId
        type
      }
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      latestAtomePayment {
        amount
        paymentUrl
        priceId
        referenceId
        status
        sysId
      }
      latestInvoice {
        amount_due
        hosted_invoice_url
        id
        next_payment_attempt
        paid
        paymentStatus
        period_end
        starting_balance
        status
        subtotal
        tax
        total
      }
      latestNote {
        content
        createdAt
        createdBy
        sysId
        updatedAt
      }
      nextReviewDate
      oldPrice
      oldPriceInfo {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescribed_after_trial_order_sys_id
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      price {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      priceDisplayId
      priceInfo {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        ingredients
        isConsultOnly(platform: $platform18)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      siblingCrossSellOrders {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      status
      stripePaymentIntentId
      stripeSubscriptionId
      subscription {
        cancel_at_period_end
        current_period_end
        current_period_start
        default_payment_method
        id
        items
        latest_invoice
        metadata
        pause_collection
        pending_setup_intent
        pending_update
        status
      }
      sysId
      teleConsultProduct
      upcomingInvoice {
        amount_due
        hosted_invoice_url
        id
        next_payment_attempt
        paid
        paymentStatus
        period_end
        starting_balance
        status
        subtotal
        tax
        total
      }
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    prescriptionCalculation(input: $input18) {
      affiliateCouponNotApplied {
        affiliateProductDisplayName
        reason
      }
      isAffiliateLocked
      otcCalculationSummary {
        otcOrdersCalculation {
          basePrice
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          discountAmount
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          stripePromotionCode
          tax
          transactionFee
        }
        totalBasePrice
        totalCashbackEarned
        totalCashbackRedeemed
        totalPaymentIntentAmount
        totalTax
        totalTransactionFee
      }
      promotionCodeError
      rxCalculationSummary {
        rxOrdersCalculation {
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          consultBasePrice
          consultFee
          consultFeeAfterDiscount
          consultTax
          consultTransactionFee
          discountAmount
          isConsult
          mainBasePrice
          mainTax
          mainTransactionFee
          minimalAmountPayment
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          shouldChargeConsultFee
          subTotal
          total
          totalAfterCashback
        }
        total
        totalCashbackEarned
        totalCashbackRedeemed
        totalDiscountAmount
        totalMainBasePrice
        totalPaymentIntentAmount
        totalPaymentIntentAmountAfterCashback
        totalTax
        totalTransactionFee
      }
      stripePromotionCode
    }
    referralCode
    referrals {
      doctor {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      doctorId
      documents {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      items {
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        orderId
        price {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        priceId
        referralSysId
        sysId
      }
      sysId
    }
    shopProducts(filter: $filter1, limit: $limit8, offset: $offset8, sort: $sort1) {
      count
      items {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform19)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform20)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      limit
      offset
    }
    smartMatchMeta(input: $input19) {
      evalId
      status
      sysId
      userId
      userType
    }
    stripeCustomer
    stripeCustomerId
    survey(input: $input20) {
      answers
      isSkipped
      patientSysId
      sysId
      type
    }
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      phoneNumber
      requireConfirmPolicy
      socialProviderType
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    userSysId
    videoConsultation(videoLink: $videoLink3) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
    videoConsultationPreview(previewVideoLink: $previewVideoLink1) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
    weight
  }
}
    `;
export const useUpdatePatientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePatientMutation, TError, UpdatePatientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePatientMutation, TError, UpdatePatientMutationVariables, TContext>(
      ['updatePatient'],
      (variables?: UpdatePatientMutationVariables) => fetcher<UpdatePatientMutation, UpdatePatientMutationVariables>(client, UpdatePatientDocument, variables, headers)(),
      options
    );
export const UpdatePatientDocumentDocument = `
    mutation updatePatientDocument($input: UpdatePatientDocumentInput) {
  updatePatientDocument(input: $input)
}
    `;
export const useUpdatePatientDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePatientDocumentMutation, TError, UpdatePatientDocumentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePatientDocumentMutation, TError, UpdatePatientDocumentMutationVariables, TContext>(
      ['updatePatientDocument'],
      (variables?: UpdatePatientDocumentMutationVariables) => fetcher<UpdatePatientDocumentMutation, UpdatePatientDocumentMutationVariables>(client, UpdatePatientDocumentDocument, variables, headers)(),
      options
    );
export const UpdatePatientInfoDocument = `
    mutation updatePatientInfo($input: UpdatePatientInput!) {
  updatePatientInfo(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useUpdatePatientInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePatientInfoMutation, TError, UpdatePatientInfoMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePatientInfoMutation, TError, UpdatePatientInfoMutationVariables, TContext>(
      ['updatePatientInfo'],
      (variables?: UpdatePatientInfoMutationVariables) => fetcher<UpdatePatientInfoMutation, UpdatePatientInfoMutationVariables>(client, UpdatePatientInfoDocument, variables, headers)(),
      options
    );
export const UpdatePatientSubscriptionsPaymentMethodDocument = `
    mutation updatePatientSubscriptionsPaymentMethod($paymentMethodId: String!) {
  updatePatientSubscriptionsPaymentMethod(paymentMethodId: $paymentMethodId)
}
    `;
export const useUpdatePatientSubscriptionsPaymentMethodMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePatientSubscriptionsPaymentMethodMutation, TError, UpdatePatientSubscriptionsPaymentMethodMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePatientSubscriptionsPaymentMethodMutation, TError, UpdatePatientSubscriptionsPaymentMethodMutationVariables, TContext>(
      ['updatePatientSubscriptionsPaymentMethod'],
      (variables?: UpdatePatientSubscriptionsPaymentMethodMutationVariables) => fetcher<UpdatePatientSubscriptionsPaymentMethodMutation, UpdatePatientSubscriptionsPaymentMethodMutationVariables>(client, UpdatePatientSubscriptionsPaymentMethodDocument, variables, headers)(),
      options
    );
export const UpdatePaymentStatusForCodOrderDocument = `
    mutation updatePaymentStatusForCodOrder($input: V2UpdatePaymentStatusCodOrderInput!) {
  updatePaymentStatusForCodOrder(input: $input) {
    results {
      errorMessage
      isSuccess
      orderId
    }
  }
}
    `;
export const useUpdatePaymentStatusForCodOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePaymentStatusForCodOrderMutation, TError, UpdatePaymentStatusForCodOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePaymentStatusForCodOrderMutation, TError, UpdatePaymentStatusForCodOrderMutationVariables, TContext>(
      ['updatePaymentStatusForCodOrder'],
      (variables?: UpdatePaymentStatusForCodOrderMutationVariables) => fetcher<UpdatePaymentStatusForCodOrderMutation, UpdatePaymentStatusForCodOrderMutationVariables>(client, UpdatePaymentStatusForCodOrderDocument, variables, headers)(),
      options
    );
export const UpdatePickupLocationDocument = `
    mutation updatePickupLocation($input: PickupLocationInput!) {
  updatePickupLocation(input: $input)
}
    `;
export const useUpdatePickupLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePickupLocationMutation, TError, UpdatePickupLocationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePickupLocationMutation, TError, UpdatePickupLocationMutationVariables, TContext>(
      ['updatePickupLocation'],
      (variables?: UpdatePickupLocationMutationVariables) => fetcher<UpdatePickupLocationMutation, UpdatePickupLocationMutationVariables>(client, UpdatePickupLocationDocument, variables, headers)(),
      options
    );
export const UpdateProductImageUrlsDocument = `
    mutation updateProductImageUrls($input: UpdateStripeProductImageUrlsInput!) {
  updateProductImageUrls(input: $input)
}
    `;
export const useUpdateProductImageUrlsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateProductImageUrlsMutation, TError, UpdateProductImageUrlsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateProductImageUrlsMutation, TError, UpdateProductImageUrlsMutationVariables, TContext>(
      ['updateProductImageUrls'],
      (variables?: UpdateProductImageUrlsMutationVariables) => fetcher<UpdateProductImageUrlsMutation, UpdateProductImageUrlsMutationVariables>(client, UpdateProductImageUrlsDocument, variables, headers)(),
      options
    );
export const UpdateShipmentGroupDocument = `
    mutation updateShipmentGroup($input: UpdateShipmentGroupInput!) {
  updateShipmentGroup(input: $input)
}
    `;
export const useUpdateShipmentGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateShipmentGroupMutation, TError, UpdateShipmentGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateShipmentGroupMutation, TError, UpdateShipmentGroupMutationVariables, TContext>(
      ['updateShipmentGroup'],
      (variables?: UpdateShipmentGroupMutationVariables) => fetcher<UpdateShipmentGroupMutation, UpdateShipmentGroupMutationVariables>(client, UpdateShipmentGroupDocument, variables, headers)(),
      options
    );
export const UpdateShipperDocument = `
    mutation updateShipper($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $videoLink: String!, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $inputConsultation2: V2ConsultationFilterInput, $platform1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $platform2: String, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform3: String, $input9: StripeProductFilterV2, $videoLink1: String!, $previewVideoLink: String!, $patientId: String, $limit4: Int, $offset4: Int, $order3: JSON, $orderId2: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input10: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input11: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $input12: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input13: GetPatientInput, $platform5: String, $platform6: String, $input14: StripeProductFilterV2, $input15: V2ConsultationFilterInput!, $platform7: String, $platform8: String, $platform9: String, $platform10: String, $platform11: String, $platform12: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input16: V2ConsultationFilterInput!, $input17: ConsultationMessagesInput!, $limit8: Int, $offset8: Int, $order7: JSON, $input18: ConsultationListInput!, $limit9: Int, $offset9: Int, $order8: JSON, $doctorFilterInput4: V2DoctorInputFilter, $doctorFilterInput5: V2DoctorInputFilter, $input19: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input20: GetPatientInput, $platform13: String, $input21: StripeProductFilterV2, $platform14: String, $platform15: String, $platform16: String, $platform17: String, $platform18: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform19: String, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform20: String, $consultAuditFilterInput6: ConsultationAuditFilterInput, $inputConsultation7: V2ConsultationFilterInput, $platform21: String, $acuityAppointmentId6: String, $date12: String, $forDelivery6: Boolean, $isReschedule6: Boolean, $orderId7: String, $acuityAppointmentId7: String, $consultDate3: Float, $date13: Float, $forDelivery7: Boolean, $isReschedule7: Boolean, $orderId8: String, $input22: V2ConsultationFilterInput!, $input23: ConsultationMessagesInput!, $limit10: Int, $offset10: Int, $order9: JSON, $input24: ConsultationListInput!, $limit11: Int, $offset11: Int, $order10: JSON, $doctorFilterInput6: V2DoctorInputFilter, $doctorFilterInput7: V2DoctorInputFilter, $input25: OrderInput!, $pagination3: V2PaginationInput!, $date14: String, $date15: Float, $input26: GetPatientInput, $platform22: String, $input27: StripeProductFilterV2, $consultAuditFilterInput7: ConsultationAuditFilterInput, $inputConsultation8: V2ConsultationFilterInput, $platform23: String, $input28: CrossSellRecordQueryInput, $acuityAppointmentId8: String, $date16: String, $forDelivery8: Boolean, $isReschedule8: Boolean, $orderId9: String, $acuityAppointmentId9: String, $consultDate4: Float, $date17: Float, $forDelivery9: Boolean, $isReschedule9: Boolean, $orderId10: String, $input29: V2ConsultationFilterInput!, $input30: ConsultationMessagesInput!, $limit12: Int, $offset12: Int, $order11: JSON, $input31: ConsultationListInput!, $limit13: Int, $offset13: Int, $order12: JSON, $doctorFilterInput8: V2DoctorInputFilter, $doctorFilterInput9: V2DoctorInputFilter, $input32: OrderInput!, $pagination4: V2PaginationInput!, $date18: String, $date19: Float, $input33: GetPatientInput, $platform24: String, $input34: StripeProductFilterV2, $input35: UpdateShipperInput) {
  updateShipper(input: $input35) {
    admin {
      crossSellRecords(input: $input28) {
        childOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          activeConsultation {
            consultationAudit {
              consultTime
              consultType
              createdBy
              doctor {
                active
                bio {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                calendarId
                consultation(videoLink: $videoLink) {
                  gmeetLink
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  previewToken
                  previewVideoLink
                  status
                  sysId
                  token
                  videoChannelId
                  videoLink
                  zoomJoinUrl
                }
                country
                designation
                duration
                email
                firstName
                fullName
                lastName
                patient(patientId: $patientId) {
                  atomePayment(id: $id) {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  bypassLoginTokens {
                    expiresAt
                    pageName
                    token
                    type
                  }
                  cart {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    cartItems {
                      completedEval
                      consultationSessionType
                      isAutoRenewal
                      isSkipMedSelecting
                      isSubscriptionPrice
                      orderId
                      patientNote
                      quantity
                      teleConsultForSkipEval
                      type
                    }
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    orderSummary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      discountAmountLater
                      discountAmountNow
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountBeforeTax
                      paymentIntentSummary
                      promotionCode
                      shippingFee
                      subTotal
                      subTotalLater
                      subTotalNow
                      taxes
                      taxesLater
                      taxesNow
                      teleConsultFee
                      total
                      totalLater
                      totalNow
                      totalNowAfterCashback
                      totalTaxes
                    }
                    paidCompletedEvaluationIds
                    platform
                    promotionCode
                    status
                    sysId
                  }
                  cashback {
                    availableBalance
                    recentTransactions {
                      amount
                      cashbackType
                      created
                      credit_note
                      currency
                      customer
                      description
                      ending_balance
                      id
                      invoice
                      livemode
                      metadata
                      object
                      savingsToDate
                      type
                    }
                    savingsToDateThisYear {
                      amount
                      cashbackType
                      created
                      credit_note
                      currency
                      customer
                      description
                      ending_balance
                      id
                      invoice
                      livemode
                      metadata
                      object
                      savingsToDate
                      type
                    }
                  }
                  checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  document(input: $input) {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  documents {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  email
                  evaluations(evalFilter: $evalFilter) {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  latestPaymentMethod {
                    card {
                      brand
                      exp_month
                      exp_year
                      last4
                    }
                    id
                  }
                  legalName
                  locale
                  mounjaroTrialEligible
                  order(id: $id1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  prescriptionCalculation(input: $input1) {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  referralCode
                  referrals {
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorId
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    items {
                      orderId
                      priceId
                      referralSysId
                      sysId
                    }
                    sysId
                  }
                  shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                    count
                    items {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    limit
                    offset
                  }
                  smartMatchMeta(input: $input2) {
                    evalId
                    status
                    sysId
                    userId
                    userType
                  }
                  stripeCustomer
                  stripeCustomerId
                  survey(input: $input3) {
                    answers
                    isSkipped
                    patientSysId
                    sysId
                    type
                  }
                  sysId
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  userSysId
                  videoConsultation(videoLink: $videoLink1) {
                    gmeetLink
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                    gmeetLink
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  weight
                }
                sysId
                textConsultPostalCodes
                trtEligible
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              evaluationId
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              patient {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sessionType
              status
              sysId
            }
            consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
              count
              items {
                automatedMessage {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                consultationSysId
                content
                createdAt
                readAt
                sysId
                updatedAt
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              limit
              offset
            }
            consultationTitle {
              createdAt
              createdBy
              remark
              sysId
              translationKey
              updatedAt
              updatedBy
              valueEn
              valueJa
              valueZh
            }
            countReminder
            createdAt
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            messages {
              automatedMessage {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              consultationSysId
              content
              createdAt
              readAt
              sysId
              updatedAt
              user {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            orderSysId
            participants {
              avatar
              fullName
              identity
              locale
              role
              token
              userSysId
            }
            participantsV2 {
              admin {
                order(orderId: $orderId2) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                  count
                  items {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  limit
                  offset
                }
                patient(patientId: $patientId1) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
              }
              avatar
              calendarDates(
                acuityAppointmentId: $acuityAppointmentId2
                date: $date4
                forDelivery: $forDelivery2
                isReschedule: $isReschedule2
                orderId: $orderId3
              ) {
                date
              }
              calendarTimes(
                acuityAppointmentId: $acuityAppointmentId3
                consultDate: $consultDate1
                date: $date5
                forDelivery: $forDelivery3
                isReschedule: $isReschedule3
                orderId: $orderId4
              ) {
                time
              }
              consultation(input: $input15) {
                consultationAudit {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                  count
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  avatar
                  consultationMessages(
                    input: $input10
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input11, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink2) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input12, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input13) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    isAffiliateLocked
                    promotionCodeError
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input14) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform6)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              locale
              ninjaVanToken
              phoneNumber
              requireConfirmPolicy
              socialProviderType
              sysId
              tempToken
              tempTokenExpired
              userType
              utmCampaign
              utmId
              utmMedium
              utmSource
            }
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          acuityAppointment {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          additionalPrices {
            active
            alternativePrice {
              active
              alternativePrice {
                active
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                metadata {
                  actual_price_display
                  boxes
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  isArchived
                  isOneTimePrice
                  price_frequency
                  price_quantity
                  price_show
                  quantity
                  quantity_display
                  strength
                }
                nickname
                product
                productId
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredientDetails {
                    description
                    imageLink
                    locale
                    name
                    strength
                    uniqueName
                  }
                  ingredients
                  isConsultOnly(platform: $platform9)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  prices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInstructions {
                    language
                    localeKey
                    productId
                    sysId
                    translatedText
                  }
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  tempPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  texts {
                    benefits
                    category
                    display_price
                    display_price_patient
                    dosage_variant_body
                    dosage_variant_title
                    effective_in
                    for
                    frequency_variant_title
                    good_to_know
                    how_to_take
                    how_to_use
                    is_popular
                    lasts_for
                    platform
                    product_description
                    product_name
                    product_short_description
                    quantity_per_unit
                    quantity_variant_title
                    requires_prescription
                    safety_information
                    side_effects
                    strength
                    taken
                    unit
                    unit_patient
                  }
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                shopDisplay
                sysId
                tax_behavior
                texts {
                  actual_price_display
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  price_frequency
                  price_quantity
                  quantity
                  quantity_display
                }
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            metadata {
              actual_price_display
              boxes
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              isArchived
              isOneTimePrice
              price_frequency
              price_quantity
              price_show
              quantity
              quantity_display
              strength
            }
            nickname
            product
            productId
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform12)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            shopDisplay
            sysId
            tax_behavior
            texts {
              actual_price_display
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              price_frequency
              price_quantity
              quantity
              quantity_display
            }
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          afterVideoConsultRedirecting {
            baseUrl
            path
          }
          approveAt
          atomeNextSendingInvoiceDate
          atomePayments {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          checkoutSession {
            checkoutData
            evaluationId
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            patient {
              bloodPressure
              country
              createdAt
              dob
              email
              fbc
              fbp
              firstName
              fromPlatformEnv
              fullName
              gender
              height
              icNumber
              idVerifiedAt
              identification
              isAlreadyCheckout
              isReferredBy
              lastName
              legalName
              locale
              mounjaroTrialEligible
              paidCompletedEvaluationIds
              phoneNumber
              referralCode
              stripeCustomer
              stripeCustomerId
              sysId
              userSysId
              weight
            }
            status
            sysId
          }
          childrenOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            activeConsultation {
              countReminder
              createdAt
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              orderSysId
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            acuityAppointment {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            acuityAppointments {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            additionalPrices {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            afterVideoConsultRedirecting {
              baseUrl
              path
            }
            approveAt
            atomeNextSendingInvoiceDate
            atomePayments {
              amount
              paymentUrl
              priceId
              referenceId
              status
              sysId
            }
            checkoutSession {
              checkoutData
              evaluationId
              status
              sysId
            }
            childrenOrders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                consultTime
                consultType
                createdBy
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                evaluationId
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sessionType
                status
                sysId
              }
              consultations(inputConsultation: $inputConsultation4) {
                countReminder
                createdAt
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                orderSysId
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluation {
                isCompleted
                isSkipped
                name
                patientAnswers {
                  answer {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  question {
                    answers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    dependentEvaluationQuestions {
                      skipPage
                      skipQuestionCount
                      sysId
                    }
                    displayPage
                    evaluationBlocks {
                      sysId
                    }
                    guestOnly
                    name
                    order
                    sysId
                    textKey
                    type
                    validation {
                      bmi
                      extra
                      max
                      min
                      preselect
                      type
                    }
                  }
                  type
                  value
                }
                patientNote
                platform
                questions {
                  answers {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  content {
                    body {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    footer {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    header {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                  }
                  dependentEvaluationQuestions {
                    answer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  displayPage
                  evaluationBlocks {
                    blockAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    content {
                      description
                      descriptionTextKey
                      sysId
                      title
                      titleTextKey
                    }
                    sysId
                  }
                  guestOnly
                  name
                  order
                  sysId
                  textKey
                  type
                  validation {
                    bmi
                    extra
                    max
                    min
                    preselect
                    type
                  }
                }
                status
                sysId
                type
              }
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              latestAtomePayment {
                amount
                paymentUrl
                priceId
                referenceId
                status
                summary {
                  cashbackEarnRate
                  cashbackEarned
                  cashbackRedeemed
                  consultBasePrice
                  consultFee
                  consultFeeAfterDiscount
                  consultTax
                  consultTransactionFee
                  discountAmount
                  isConsult
                  mainBasePrice
                  mainTax
                  mainTransactionFee
                  minimalAmountPayment
                  paymentIntentAmount
                  paymentIntentAmountAfterCashback
                  paymentIntentSummary
                  priceId
                  productPriceAmount
                  productPriceAmountAfterDiscount
                  promotionCode
                  shouldChargeConsultFee
                  subTotal
                  total
                  totalAfterCashback
                }
                sysId
              }
              latestInvoice {
                amount_due
                hosted_invoice_url
                id
                lines {
                  data {
                    amount
                    discount
                    plan {
                      active
                      id
                      metadata
                    }
                  }
                }
                next_payment_attempt
                paid
                paymentStatus
                period_end
                starting_balance
                status
                subtotal
                tax
                total
                total_discount_amounts {
                  amount
                }
              }
              latestNote {
                author {
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId4
                    date: $date8
                    forDelivery: $forDelivery4
                    isReschedule: $isReschedule4
                    orderId: $orderId5
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId5
                    consultDate: $consultDate2
                    date: $date9
                    forDelivery: $forDelivery5
                    isReschedule: $isReschedule5
                    orderId: $orderId6
                  ) {
                    time
                  }
                  consultation(input: $input16) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input17
                    limit: $limit8
                    offset: $offset8
                    order: $order7
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input18, limit: $limit9, offset: $offset9, order: $order8) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput4) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput5) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input19, pagination: $pagination2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date10) {
                    date
                  }
                  partnerConsultTimes(date: $date11) {
                    time
                  }
                  patient(input: $input20) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    isAffiliateLocked
                    promotionCodeError
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input21) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                content
                createdAt
                createdBy
                sysId
                updatedAt
              }
              nextReviewDate
              oldPrice
              oldPriceInfo {
                active
                alternativePrice {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                metadata {
                  actual_price_display
                  boxes
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  isArchived
                  isOneTimePrice
                  price_frequency
                  price_quantity
                  price_show
                  quantity
                  quantity_display
                  strength
                }
                nickname
                product
                productId
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  ingredients
                  isConsultOnly(platform: $platform14)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                shopDisplay
                sysId
                tax_behavior
                texts {
                  actual_price_display
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  price_frequency
                  price_quantity
                  quantity
                  quantity_display
                }
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patient {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              pickupLocation {
                address
                area {
                  areaChildren {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaName
                  areaParent {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaType
                  pickupLocations {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  sysId
                }
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                orders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                activeConsultation {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                acuityAppointment {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                additionalPrices {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                afterVideoConsultRedirecting {
                  baseUrl
                  path
                }
                approveAt
                atomeNextSendingInvoiceDate
                atomePayments {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                checkoutSession {
                  checkoutData
                  evaluationId
                  status
                  sysId
                }
                childrenOrders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform15)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform16)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform18)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform19)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                claimedRetentionOffer
                consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultations(inputConsultation: $inputConsultation6) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluation {
                  isCompleted
                  isSkipped
                  name
                  patientNote
                  platform
                  status
                  sysId
                  type
                }
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                latestAtomePayment {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                latestInvoice {
                  amount_due
                  hosted_invoice_url
                  id
                  next_payment_attempt
                  paid
                  paymentStatus
                  period_end
                  starting_balance
                  status
                  subtotal
                  tax
                  total
                }
                latestNote {
                  content
                  createdAt
                  createdBy
                  sysId
                  updatedAt
                }
                nextReviewDate
                oldPrice
                oldPriceInfo {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                pickupLocation {
                  address
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescription {
                    cancelled
                    createdAt
                    days
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    priceIds
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform20)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                  }
                  updatedAt
                }
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          claimedRetentionOffer
          consultationAudits(consultAuditFilterInput: $consultAuditFilterInput6) {
            consultTime
            consultType
            createdBy
            evaluationId
            sessionType
            status
            sysId
          }
          consultations(inputConsultation: $inputConsultation7) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluation {
            isCompleted
            isSkipped
            name
            patientNote
            platform
            status
            sysId
            type
          }
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          latestAtomePayment {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          latestInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          latestNote {
            content
            createdAt
            createdBy
            sysId
            updatedAt
          }
          nextReviewDate
          oldPrice
          oldPriceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          pickupLocation {
            address
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribedAfterTrialOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          prescribed_after_trial_order_sys_id
          prescription {
            cancelled
            createdAt
            days
            doctorNotes
            endDate
            expiresAt
            isFollowUp
            notedDate
            priceIds
            startDate
            status
            sysId
            treatmentCode
            updatedAt
          }
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          price {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          priceDisplayId
          priceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform21)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          siblingCrossSellOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          status
          stripePaymentIntentId
          stripeSubscriptionId
          subscription {
            cancel_at_period_end
            current_period_end
            current_period_start
            default_payment_method
            id
            items
            latest_invoice
            metadata
            pause_collection
            pending_setup_intent
            pending_update
            status
          }
          sysId
          teleConsultProduct
          upcomingInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          updatedAt
        }
        childOrderId
        createdAt
        createdBy
        creator {
          avatar
          calendarDates(
            acuityAppointmentId: $acuityAppointmentId6
            date: $date12
            forDelivery: $forDelivery6
            isReschedule: $isReschedule6
            orderId: $orderId7
          ) {
            date
          }
          calendarTimes(
            acuityAppointmentId: $acuityAppointmentId7
            consultDate: $consultDate3
            date: $date13
            forDelivery: $forDelivery7
            isReschedule: $isReschedule7
            orderId: $orderId8
          ) {
            time
          }
          consultation(input: $input22) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          consultationMessages(
            input: $input23
            limit: $limit10
            offset: $offset10
            order: $order9
          ) {
            count
            limit
            offset
          }
          consultations(
            input: $input24
            limit: $limit11
            offset: $offset11
            order: $order10
          ) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          doctor(doctorFilterInput: $doctorFilterInput6) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctors(doctorFilterInput: $doctorFilterInput7) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          locale
          ninjaVanToken
          orders(input: $input25, pagination: $pagination3) {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          partnerConsultDates(date: $date14) {
            date
          }
          partnerConsultTimes(date: $date15) {
            time
          }
          patient(input: $input26) {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientDocuments {
            createdAt
            orderSysId
            ref
            sysId
            type
            url
          }
          phoneNumber
          prescriptionCalculation {
            isAffiliateLocked
            promotionCodeError
            stripePromotionCode
          }
          requireConfirmPolicy
          socialProviderType
          stripeProducts(input: $input27) {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform22)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          sysId
          tempToken
          tempTokenExpired
          userType
          utmCampaign
          utmId
          utmMedium
          utmSource
        }
        parentOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          activeConsultation {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          acuityAppointment {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          additionalPrices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          afterVideoConsultRedirecting {
            baseUrl
            path
          }
          approveAt
          atomeNextSendingInvoiceDate
          atomePayments {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          checkoutSession {
            checkoutData
            evaluationId
            status
            sysId
          }
          childrenOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          claimedRetentionOffer
          consultationAudits(consultAuditFilterInput: $consultAuditFilterInput7) {
            consultTime
            consultType
            createdBy
            evaluationId
            sessionType
            status
            sysId
          }
          consultations(inputConsultation: $inputConsultation8) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluation {
            isCompleted
            isSkipped
            name
            patientNote
            platform
            status
            sysId
            type
          }
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          latestAtomePayment {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          latestInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          latestNote {
            content
            createdAt
            createdBy
            sysId
            updatedAt
          }
          nextReviewDate
          oldPrice
          oldPriceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          pickupLocation {
            address
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribedAfterTrialOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          prescribed_after_trial_order_sys_id
          prescription {
            cancelled
            createdAt
            days
            doctorNotes
            endDate
            expiresAt
            isFollowUp
            notedDate
            priceIds
            startDate
            status
            sysId
            treatmentCode
            updatedAt
          }
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          price {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          priceDisplayId
          priceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform23)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          siblingCrossSellOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          status
          stripePaymentIntentId
          stripeSubscriptionId
          subscription {
            cancel_at_period_end
            current_period_end
            current_period_start
            default_payment_method
            id
            items
            latest_invoice
            metadata
            pause_collection
            pending_setup_intent
            pending_update
            status
          }
          sysId
          teleConsultProduct
          upcomingInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          updatedAt
        }
        parentOrderId
        priceId
        selectedBy
        stripeProductPrice {
          importPriceId
          isBundle
          priceActive
          priceBillingScheme
          priceCreated
          priceCurrency
          priceDisplayId
          priceFirstTimeAlternativePrice
          priceFirstTimeTryingInMonths
          priceId
          priceLivemode
          priceNickname
          priceProduct
          priceTaxBehavior
          priceUnitAmount
          priceUnitAmountDecimal
          productActive
          productDescription
          productDisplayId
          productId
          productLivemode
          productName
          productStatementDescriptor
          productType
          productUniqName
          productUnitLabel
          sysId
        }
        sysId
      }
    }
    avatar
    calendarDates(
      acuityAppointmentId: $acuityAppointmentId8
      date: $date16
      forDelivery: $forDelivery8
      isReschedule: $isReschedule8
      orderId: $orderId9
    ) {
      date
    }
    calendarTimes(
      acuityAppointmentId: $acuityAppointmentId9
      consultDate: $consultDate4
      date: $date17
      forDelivery: $forDelivery9
      isReschedule: $isReschedule9
      orderId: $orderId10
    ) {
      time
    }
    consultation(input: $input29) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    consultationMessages(
      input: $input30
      limit: $limit12
      offset: $offset12
      order: $order11
    ) {
      count
      limit
      offset
    }
    consultations(
      input: $input31
      limit: $limit13
      offset: $offset13
      order: $order12
    ) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    doctor(doctorFilterInput: $doctorFilterInput8) {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    doctors(doctorFilterInput: $doctorFilterInput9) {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    email
    firstName
    fullName
    id
    isPharmacist
    lastName
    locale
    ninjaVanToken
    orders(input: $input32, pagination: $pagination4) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    partnerConsultDates(date: $date18) {
      date
    }
    partnerConsultTimes(date: $date19) {
      time
    }
    patient(input: $input33) {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientDocuments {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    phoneNumber
    prescriptionCalculation {
      isAffiliateLocked
      promotionCodeError
      stripePromotionCode
    }
    requireConfirmPolicy
    socialProviderType
    stripeProducts(input: $input34) {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform24)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    sysId
    tempToken
    tempTokenExpired
    userType
    utmCampaign
    utmId
    utmMedium
    utmSource
  }
}
    `;
export const useUpdateShipperMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateShipperMutation, TError, UpdateShipperMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateShipperMutation, TError, UpdateShipperMutationVariables, TContext>(
      ['updateShipper'],
      (variables?: UpdateShipperMutationVariables) => fetcher<UpdateShipperMutation, UpdateShipperMutationVariables>(client, UpdateShipperDocument, variables, headers)(),
      options
    );
export const UpdateShippingOrderShipmentDocument = `
    mutation updateShippingOrderShipment($input: UpdateShippingOrderShipment!) {
  updateShippingOrderShipment(input: $input)
}
    `;
export const useUpdateShippingOrderShipmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateShippingOrderShipmentMutation, TError, UpdateShippingOrderShipmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateShippingOrderShipmentMutation, TError, UpdateShippingOrderShipmentMutationVariables, TContext>(
      ['updateShippingOrderShipment'],
      (variables?: UpdateShippingOrderShipmentMutationVariables) => fetcher<UpdateShippingOrderShipmentMutation, UpdateShippingOrderShipmentMutationVariables>(client, UpdateShippingOrderShipmentDocument, variables, headers)(),
      options
    );
export const UpdateStripeCouponDocument = `
    mutation updateStripeCoupon($input: UpdateStripeCouponInput!) {
  updateStripeCoupon(input: $input) {
    amount_off
    applies_to
    created
    currency
    duration
    duration_in_months
    id
    livemode
    max_redemptions
    metadata
    name
    object
    percent_off
    promotionCodes {
      active
      code
      coupon {
        amount_off
        applies_to
        created
        currency
        duration
        duration_in_months
        id
        livemode
        max_redemptions
        metadata
        name
        object
        percent_off
        promotionCodes {
          active
          code
          created
          customer
          expires_at
          id
          livemode
          max_redemptions
          metadata
          object
          restrictions
          times_redeemed
        }
        redeem_by
        times_redeemed
        valid
      }
      created
      customer
      expires_at
      id
      livemode
      max_redemptions
      metadata
      object
      restrictions
      times_redeemed
    }
    redeem_by
    times_redeemed
    valid
  }
}
    `;
export const useUpdateStripeCouponMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripeCouponMutation, TError, UpdateStripeCouponMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripeCouponMutation, TError, UpdateStripeCouponMutationVariables, TContext>(
      ['updateStripeCoupon'],
      (variables?: UpdateStripeCouponMutationVariables) => fetcher<UpdateStripeCouponMutation, UpdateStripeCouponMutationVariables>(client, UpdateStripeCouponDocument, variables, headers)(),
      options
    );
export const UpdateStripeCouponMetadataDocument = `
    mutation updateStripeCouponMetadata($input: UpdateStripeCouponInput!) {
  updateStripeCouponMetadata(input: $input)
}
    `;
export const useUpdateStripeCouponMetadataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripeCouponMetadataMutation, TError, UpdateStripeCouponMetadataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripeCouponMetadataMutation, TError, UpdateStripeCouponMetadataMutationVariables, TContext>(
      ['updateStripeCouponMetadata'],
      (variables?: UpdateStripeCouponMetadataMutationVariables) => fetcher<UpdateStripeCouponMetadataMutation, UpdateStripeCouponMetadataMutationVariables>(client, UpdateStripeCouponMetadataDocument, variables, headers)(),
      options
    );
export const UpdateStripePriceDocument = `
    mutation updateStripePrice($input: UpdateStripePriceInput!) {
  updateStripePrice(input: $input)
}
    `;
export const useUpdateStripePriceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripePriceMutation, TError, UpdateStripePriceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripePriceMutation, TError, UpdateStripePriceMutationVariables, TContext>(
      ['updateStripePrice'],
      (variables?: UpdateStripePriceMutationVariables) => fetcher<UpdateStripePriceMutation, UpdateStripePriceMutationVariables>(client, UpdateStripePriceDocument, variables, headers)(),
      options
    );
export const UpdateStripePriceLocaleDocument = `
    mutation updateStripePriceLocale($input: UpdatePriceLocaleInput!) {
  updateStripePriceLocale(input: $input)
}
    `;
export const useUpdateStripePriceLocaleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripePriceLocaleMutation, TError, UpdateStripePriceLocaleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripePriceLocaleMutation, TError, UpdateStripePriceLocaleMutationVariables, TContext>(
      ['updateStripePriceLocale'],
      (variables?: UpdateStripePriceLocaleMutationVariables) => fetcher<UpdateStripePriceLocaleMutation, UpdateStripePriceLocaleMutationVariables>(client, UpdateStripePriceLocaleDocument, variables, headers)(),
      options
    );
export const UpdateStripePriceMetadataDocument = `
    mutation updateStripePriceMetadata($input: UpdatePriceMetadataInput!) {
  updateStripePriceMetadata(input: $input)
}
    `;
export const useUpdateStripePriceMetadataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripePriceMetadataMutation, TError, UpdateStripePriceMetadataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripePriceMetadataMutation, TError, UpdateStripePriceMetadataMutationVariables, TContext>(
      ['updateStripePriceMetadata'],
      (variables?: UpdateStripePriceMetadataMutationVariables) => fetcher<UpdateStripePriceMetadataMutation, UpdateStripePriceMetadataMutationVariables>(client, UpdateStripePriceMetadataDocument, variables, headers)(),
      options
    );
export const UpdateStripeProductDocument = `
    mutation updateStripeProduct($input: UpdateStripeProductInput!) {
  updateStripeProduct(input: $input)
}
    `;
export const useUpdateStripeProductMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripeProductMutation, TError, UpdateStripeProductMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripeProductMutation, TError, UpdateStripeProductMutationVariables, TContext>(
      ['updateStripeProduct'],
      (variables?: UpdateStripeProductMutationVariables) => fetcher<UpdateStripeProductMutation, UpdateStripeProductMutationVariables>(client, UpdateStripeProductDocument, variables, headers)(),
      options
    );
export const UpdateStripeProductLocaleDocument = `
    mutation updateStripeProductLocale($input: UpdateProductLocaleInput!) {
  updateStripeProductLocale(input: $input)
}
    `;
export const useUpdateStripeProductLocaleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripeProductLocaleMutation, TError, UpdateStripeProductLocaleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripeProductLocaleMutation, TError, UpdateStripeProductLocaleMutationVariables, TContext>(
      ['updateStripeProductLocale'],
      (variables?: UpdateStripeProductLocaleMutationVariables) => fetcher<UpdateStripeProductLocaleMutation, UpdateStripeProductLocaleMutationVariables>(client, UpdateStripeProductLocaleDocument, variables, headers)(),
      options
    );
export const UpdateStripeProductMetadataDocument = `
    mutation updateStripeProductMetadata($input: UpdateProductMetadataInput!) {
  updateStripeProductMetadata(input: $input)
}
    `;
export const useUpdateStripeProductMetadataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripeProductMetadataMutation, TError, UpdateStripeProductMetadataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripeProductMetadataMutation, TError, UpdateStripeProductMetadataMutationVariables, TContext>(
      ['updateStripeProductMetadata'],
      (variables?: UpdateStripeProductMetadataMutationVariables) => fetcher<UpdateStripeProductMetadataMutation, UpdateStripeProductMetadataMutationVariables>(client, UpdateStripeProductMetadataDocument, variables, headers)(),
      options
    );
export const UpdateStripePromotionCodeDocument = `
    mutation updateStripePromotionCode($input: UpdateStripePromotionCodeInput!) {
  updateStripePromotionCode(input: $input) {
    active
    code
    coupon {
      amount_off
      applies_to
      created
      currency
      duration
      duration_in_months
      id
      livemode
      max_redemptions
      metadata
      name
      object
      percent_off
      promotionCodes {
        active
        code
        coupon {
          amount_off
          applies_to
          created
          currency
          duration
          duration_in_months
          id
          livemode
          max_redemptions
          metadata
          name
          object
          percent_off
          redeem_by
          times_redeemed
          valid
        }
        created
        customer
        expires_at
        id
        livemode
        max_redemptions
        metadata
        object
        restrictions
        times_redeemed
      }
      redeem_by
      times_redeemed
      valid
    }
    created
    customer
    expires_at
    id
    livemode
    max_redemptions
    metadata
    object
    restrictions
    times_redeemed
  }
}
    `;
export const useUpdateStripePromotionCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripePromotionCodeMutation, TError, UpdateStripePromotionCodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripePromotionCodeMutation, TError, UpdateStripePromotionCodeMutationVariables, TContext>(
      ['updateStripePromotionCode'],
      (variables?: UpdateStripePromotionCodeMutationVariables) => fetcher<UpdateStripePromotionCodeMutation, UpdateStripePromotionCodeMutationVariables>(client, UpdateStripePromotionCodeDocument, variables, headers)(),
      options
    );
export const UpdateStripePromotionCodeMetadataDocument = `
    mutation updateStripePromotionCodeMetadata($input: UpdateStripePromotionCodeInput!) {
  updateStripePromotionCodeMetadata(input: $input)
}
    `;
export const useUpdateStripePromotionCodeMetadataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateStripePromotionCodeMetadataMutation, TError, UpdateStripePromotionCodeMetadataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateStripePromotionCodeMetadataMutation, TError, UpdateStripePromotionCodeMetadataMutationVariables, TContext>(
      ['updateStripePromotionCodeMetadata'],
      (variables?: UpdateStripePromotionCodeMetadataMutationVariables) => fetcher<UpdateStripePromotionCodeMetadataMutation, UpdateStripePromotionCodeMetadataMutationVariables>(client, UpdateStripePromotionCodeMetadataDocument, variables, headers)(),
      options
    );
export const UpdateUserDocument = `
    mutation updateUser($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $videoLink: String!, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $inputConsultation2: V2ConsultationFilterInput, $platform1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $platform2: String, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform3: String, $input9: StripeProductFilterV2, $videoLink1: String!, $previewVideoLink: String!, $patientId: String, $limit4: Int, $offset4: Int, $order3: JSON, $orderId2: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input10: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input11: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $input12: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input13: GetPatientInput, $platform5: String, $platform6: String, $input14: StripeProductFilterV2, $input15: V2ConsultationFilterInput!, $platform7: String, $platform8: String, $platform9: String, $platform10: String, $platform11: String, $platform12: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input16: V2ConsultationFilterInput!, $input17: ConsultationMessagesInput!, $limit8: Int, $offset8: Int, $order7: JSON, $input18: ConsultationListInput!, $limit9: Int, $offset9: Int, $order8: JSON, $doctorFilterInput4: V2DoctorInputFilter, $doctorFilterInput5: V2DoctorInputFilter, $input19: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input20: GetPatientInput, $platform13: String, $input21: StripeProductFilterV2, $platform14: String, $platform15: String, $platform16: String, $platform17: String, $platform18: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform19: String, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform20: String, $consultAuditFilterInput6: ConsultationAuditFilterInput, $inputConsultation7: V2ConsultationFilterInput, $platform21: String, $acuityAppointmentId6: String, $date12: String, $forDelivery6: Boolean, $isReschedule6: Boolean, $orderId7: String, $acuityAppointmentId7: String, $consultDate3: Float, $date13: Float, $forDelivery7: Boolean, $isReschedule7: Boolean, $orderId8: String, $input22: V2ConsultationFilterInput!, $input23: ConsultationMessagesInput!, $limit10: Int, $offset10: Int, $order9: JSON, $input24: ConsultationListInput!, $limit11: Int, $offset11: Int, $order10: JSON, $doctorFilterInput6: V2DoctorInputFilter, $doctorFilterInput7: V2DoctorInputFilter, $input25: OrderInput!, $pagination3: V2PaginationInput!, $date14: String, $date15: Float, $input26: GetPatientInput, $platform22: String, $input27: StripeProductFilterV2, $consultAuditFilterInput7: ConsultationAuditFilterInput, $inputConsultation8: V2ConsultationFilterInput, $platform23: String, $input28: CrossSellRecordQueryInput, $acuityAppointmentId8: String, $date16: String, $forDelivery8: Boolean, $isReschedule8: Boolean, $orderId9: String, $acuityAppointmentId9: String, $consultDate4: Float, $date17: Float, $forDelivery9: Boolean, $isReschedule9: Boolean, $orderId10: String, $input29: V2ConsultationFilterInput!, $input30: ConsultationMessagesInput!, $limit12: Int, $offset12: Int, $order11: JSON, $input31: ConsultationListInput!, $limit13: Int, $offset13: Int, $order12: JSON, $doctorFilterInput8: V2DoctorInputFilter, $doctorFilterInput9: V2DoctorInputFilter, $input32: OrderInput!, $pagination4: V2PaginationInput!, $date18: String, $date19: Float, $input33: GetPatientInput, $platform24: String, $input34: StripeProductFilterV2, $input35: V2UserInput) {
  updateUser(input: $input35) {
    admin {
      crossSellRecords(input: $input28) {
        childOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          activeConsultation {
            consultationAudit {
              consultTime
              consultType
              createdBy
              doctor {
                active
                bio {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                calendarId
                consultation(videoLink: $videoLink) {
                  gmeetLink
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  previewToken
                  previewVideoLink
                  status
                  sysId
                  token
                  videoChannelId
                  videoLink
                  zoomJoinUrl
                }
                country
                designation
                duration
                email
                firstName
                fullName
                lastName
                patient(patientId: $patientId) {
                  atomePayment(id: $id) {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  bypassLoginTokens {
                    expiresAt
                    pageName
                    token
                    type
                  }
                  cart {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    cartItems {
                      completedEval
                      consultationSessionType
                      isAutoRenewal
                      isSkipMedSelecting
                      isSubscriptionPrice
                      orderId
                      patientNote
                      quantity
                      teleConsultForSkipEval
                      type
                    }
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    orderSummary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      discountAmountLater
                      discountAmountNow
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountBeforeTax
                      paymentIntentSummary
                      promotionCode
                      shippingFee
                      subTotal
                      subTotalLater
                      subTotalNow
                      taxes
                      taxesLater
                      taxesNow
                      teleConsultFee
                      total
                      totalLater
                      totalNow
                      totalNowAfterCashback
                      totalTaxes
                    }
                    paidCompletedEvaluationIds
                    platform
                    promotionCode
                    status
                    sysId
                  }
                  cashback {
                    availableBalance
                    recentTransactions {
                      amount
                      cashbackType
                      created
                      credit_note
                      currency
                      customer
                      description
                      ending_balance
                      id
                      invoice
                      livemode
                      metadata
                      object
                      savingsToDate
                      type
                    }
                    savingsToDateThisYear {
                      amount
                      cashbackType
                      created
                      credit_note
                      currency
                      customer
                      description
                      ending_balance
                      id
                      invoice
                      livemode
                      metadata
                      object
                      savingsToDate
                      type
                    }
                  }
                  checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  document(input: $input) {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  documents {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  email
                  evaluations(evalFilter: $evalFilter) {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  latestPaymentMethod {
                    card {
                      brand
                      exp_month
                      exp_year
                      last4
                    }
                    id
                  }
                  legalName
                  locale
                  mounjaroTrialEligible
                  order(id: $id1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  prescriptionCalculation(input: $input1) {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  referralCode
                  referrals {
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorId
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    items {
                      orderId
                      priceId
                      referralSysId
                      sysId
                    }
                    sysId
                  }
                  shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                    count
                    items {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    limit
                    offset
                  }
                  smartMatchMeta(input: $input2) {
                    evalId
                    status
                    sysId
                    userId
                    userType
                  }
                  stripeCustomer
                  stripeCustomerId
                  survey(input: $input3) {
                    answers
                    isSkipped
                    patientSysId
                    sysId
                    type
                  }
                  sysId
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  userSysId
                  videoConsultation(videoLink: $videoLink1) {
                    gmeetLink
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                    gmeetLink
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  weight
                }
                sysId
                textConsultPostalCodes
                trtEligible
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              evaluationId
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              patient {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sessionType
              status
              sysId
            }
            consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
              count
              items {
                automatedMessage {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                consultationSysId
                content
                createdAt
                readAt
                sysId
                updatedAt
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              limit
              offset
            }
            consultationTitle {
              createdAt
              createdBy
              remark
              sysId
              translationKey
              updatedAt
              updatedBy
              valueEn
              valueJa
              valueZh
            }
            countReminder
            createdAt
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            messages {
              automatedMessage {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              consultationSysId
              content
              createdAt
              readAt
              sysId
              updatedAt
              user {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            orderSysId
            participants {
              avatar
              fullName
              identity
              locale
              role
              token
              userSysId
            }
            participantsV2 {
              admin {
                order(orderId: $orderId2) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                  count
                  items {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  limit
                  offset
                }
                patient(patientId: $patientId1) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
              }
              avatar
              calendarDates(
                acuityAppointmentId: $acuityAppointmentId2
                date: $date4
                forDelivery: $forDelivery2
                isReschedule: $isReschedule2
                orderId: $orderId3
              ) {
                date
              }
              calendarTimes(
                acuityAppointmentId: $acuityAppointmentId3
                consultDate: $consultDate1
                date: $date5
                forDelivery: $forDelivery3
                isReschedule: $isReschedule3
                orderId: $orderId4
              ) {
                time
              }
              consultation(input: $input15) {
                consultationAudit {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                  count
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  avatar
                  consultationMessages(
                    input: $input10
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input11, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink2) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input12, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input13) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    isAffiliateLocked
                    promotionCodeError
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input14) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform6)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              locale
              ninjaVanToken
              phoneNumber
              requireConfirmPolicy
              socialProviderType
              sysId
              tempToken
              tempTokenExpired
              userType
              utmCampaign
              utmId
              utmMedium
              utmSource
            }
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          acuityAppointment {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          additionalPrices {
            active
            alternativePrice {
              active
              alternativePrice {
                active
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                metadata {
                  actual_price_display
                  boxes
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  isArchived
                  isOneTimePrice
                  price_frequency
                  price_quantity
                  price_show
                  quantity
                  quantity_display
                  strength
                }
                nickname
                product
                productId
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredientDetails {
                    description
                    imageLink
                    locale
                    name
                    strength
                    uniqueName
                  }
                  ingredients
                  isConsultOnly(platform: $platform9)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  prices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInstructions {
                    language
                    localeKey
                    productId
                    sysId
                    translatedText
                  }
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  tempPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  texts {
                    benefits
                    category
                    display_price
                    display_price_patient
                    dosage_variant_body
                    dosage_variant_title
                    effective_in
                    for
                    frequency_variant_title
                    good_to_know
                    how_to_take
                    how_to_use
                    is_popular
                    lasts_for
                    platform
                    product_description
                    product_name
                    product_short_description
                    quantity_per_unit
                    quantity_variant_title
                    requires_prescription
                    safety_information
                    side_effects
                    strength
                    taken
                    unit
                    unit_patient
                  }
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                shopDisplay
                sysId
                tax_behavior
                texts {
                  actual_price_display
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  price_frequency
                  price_quantity
                  quantity
                  quantity_display
                }
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            metadata {
              actual_price_display
              boxes
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              isArchived
              isOneTimePrice
              price_frequency
              price_quantity
              price_show
              quantity
              quantity_display
              strength
            }
            nickname
            product
            productId
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform12)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            shopDisplay
            sysId
            tax_behavior
            texts {
              actual_price_display
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              price_frequency
              price_quantity
              quantity
              quantity_display
            }
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          afterVideoConsultRedirecting {
            baseUrl
            path
          }
          approveAt
          atomeNextSendingInvoiceDate
          atomePayments {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          checkoutSession {
            checkoutData
            evaluationId
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            patient {
              bloodPressure
              country
              createdAt
              dob
              email
              fbc
              fbp
              firstName
              fromPlatformEnv
              fullName
              gender
              height
              icNumber
              idVerifiedAt
              identification
              isAlreadyCheckout
              isReferredBy
              lastName
              legalName
              locale
              mounjaroTrialEligible
              paidCompletedEvaluationIds
              phoneNumber
              referralCode
              stripeCustomer
              stripeCustomerId
              sysId
              userSysId
              weight
            }
            status
            sysId
          }
          childrenOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            activeConsultation {
              countReminder
              createdAt
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              orderSysId
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            acuityAppointment {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            acuityAppointments {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            additionalPrices {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            afterVideoConsultRedirecting {
              baseUrl
              path
            }
            approveAt
            atomeNextSendingInvoiceDate
            atomePayments {
              amount
              paymentUrl
              priceId
              referenceId
              status
              sysId
            }
            checkoutSession {
              checkoutData
              evaluationId
              status
              sysId
            }
            childrenOrders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                consultTime
                consultType
                createdBy
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                evaluationId
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sessionType
                status
                sysId
              }
              consultations(inputConsultation: $inputConsultation4) {
                countReminder
                createdAt
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                orderSysId
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluation {
                isCompleted
                isSkipped
                name
                patientAnswers {
                  answer {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  question {
                    answers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    dependentEvaluationQuestions {
                      skipPage
                      skipQuestionCount
                      sysId
                    }
                    displayPage
                    evaluationBlocks {
                      sysId
                    }
                    guestOnly
                    name
                    order
                    sysId
                    textKey
                    type
                    validation {
                      bmi
                      extra
                      max
                      min
                      preselect
                      type
                    }
                  }
                  type
                  value
                }
                patientNote
                platform
                questions {
                  answers {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  content {
                    body {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    footer {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    header {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                  }
                  dependentEvaluationQuestions {
                    answer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  displayPage
                  evaluationBlocks {
                    blockAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    content {
                      description
                      descriptionTextKey
                      sysId
                      title
                      titleTextKey
                    }
                    sysId
                  }
                  guestOnly
                  name
                  order
                  sysId
                  textKey
                  type
                  validation {
                    bmi
                    extra
                    max
                    min
                    preselect
                    type
                  }
                }
                status
                sysId
                type
              }
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              latestAtomePayment {
                amount
                paymentUrl
                priceId
                referenceId
                status
                summary {
                  cashbackEarnRate
                  cashbackEarned
                  cashbackRedeemed
                  consultBasePrice
                  consultFee
                  consultFeeAfterDiscount
                  consultTax
                  consultTransactionFee
                  discountAmount
                  isConsult
                  mainBasePrice
                  mainTax
                  mainTransactionFee
                  minimalAmountPayment
                  paymentIntentAmount
                  paymentIntentAmountAfterCashback
                  paymentIntentSummary
                  priceId
                  productPriceAmount
                  productPriceAmountAfterDiscount
                  promotionCode
                  shouldChargeConsultFee
                  subTotal
                  total
                  totalAfterCashback
                }
                sysId
              }
              latestInvoice {
                amount_due
                hosted_invoice_url
                id
                lines {
                  data {
                    amount
                    discount
                    plan {
                      active
                      id
                      metadata
                    }
                  }
                }
                next_payment_attempt
                paid
                paymentStatus
                period_end
                starting_balance
                status
                subtotal
                tax
                total
                total_discount_amounts {
                  amount
                }
              }
              latestNote {
                author {
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId4
                    date: $date8
                    forDelivery: $forDelivery4
                    isReschedule: $isReschedule4
                    orderId: $orderId5
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId5
                    consultDate: $consultDate2
                    date: $date9
                    forDelivery: $forDelivery5
                    isReschedule: $isReschedule5
                    orderId: $orderId6
                  ) {
                    time
                  }
                  consultation(input: $input16) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input17
                    limit: $limit8
                    offset: $offset8
                    order: $order7
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input18, limit: $limit9, offset: $offset9, order: $order8) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput4) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput5) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input19, pagination: $pagination2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date10) {
                    date
                  }
                  partnerConsultTimes(date: $date11) {
                    time
                  }
                  patient(input: $input20) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    isAffiliateLocked
                    promotionCodeError
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input21) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                content
                createdAt
                createdBy
                sysId
                updatedAt
              }
              nextReviewDate
              oldPrice
              oldPriceInfo {
                active
                alternativePrice {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                metadata {
                  actual_price_display
                  boxes
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  isArchived
                  isOneTimePrice
                  price_frequency
                  price_quantity
                  price_show
                  quantity
                  quantity_display
                  strength
                }
                nickname
                product
                productId
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  ingredients
                  isConsultOnly(platform: $platform14)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                shopDisplay
                sysId
                tax_behavior
                texts {
                  actual_price_display
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  price_frequency
                  price_quantity
                  quantity
                  quantity_display
                }
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patient {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              pickupLocation {
                address
                area {
                  areaChildren {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaName
                  areaParent {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaType
                  pickupLocations {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  sysId
                }
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                orders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                activeConsultation {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                acuityAppointment {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                additionalPrices {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                afterVideoConsultRedirecting {
                  baseUrl
                  path
                }
                approveAt
                atomeNextSendingInvoiceDate
                atomePayments {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                checkoutSession {
                  checkoutData
                  evaluationId
                  status
                  sysId
                }
                childrenOrders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform15)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform16)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform18)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform19)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                claimedRetentionOffer
                consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultations(inputConsultation: $inputConsultation6) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluation {
                  isCompleted
                  isSkipped
                  name
                  patientNote
                  platform
                  status
                  sysId
                  type
                }
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                latestAtomePayment {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                latestInvoice {
                  amount_due
                  hosted_invoice_url
                  id
                  next_payment_attempt
                  paid
                  paymentStatus
                  period_end
                  starting_balance
                  status
                  subtotal
                  tax
                  total
                }
                latestNote {
                  content
                  createdAt
                  createdBy
                  sysId
                  updatedAt
                }
                nextReviewDate
                oldPrice
                oldPriceInfo {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                pickupLocation {
                  address
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescription {
                    cancelled
                    createdAt
                    days
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    priceIds
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform20)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                  }
                  updatedAt
                }
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          claimedRetentionOffer
          consultationAudits(consultAuditFilterInput: $consultAuditFilterInput6) {
            consultTime
            consultType
            createdBy
            evaluationId
            sessionType
            status
            sysId
          }
          consultations(inputConsultation: $inputConsultation7) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluation {
            isCompleted
            isSkipped
            name
            patientNote
            platform
            status
            sysId
            type
          }
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          latestAtomePayment {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          latestInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          latestNote {
            content
            createdAt
            createdBy
            sysId
            updatedAt
          }
          nextReviewDate
          oldPrice
          oldPriceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          pickupLocation {
            address
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribedAfterTrialOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          prescribed_after_trial_order_sys_id
          prescription {
            cancelled
            createdAt
            days
            doctorNotes
            endDate
            expiresAt
            isFollowUp
            notedDate
            priceIds
            startDate
            status
            sysId
            treatmentCode
            updatedAt
          }
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          price {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          priceDisplayId
          priceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform21)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          siblingCrossSellOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          status
          stripePaymentIntentId
          stripeSubscriptionId
          subscription {
            cancel_at_period_end
            current_period_end
            current_period_start
            default_payment_method
            id
            items
            latest_invoice
            metadata
            pause_collection
            pending_setup_intent
            pending_update
            status
          }
          sysId
          teleConsultProduct
          upcomingInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          updatedAt
        }
        childOrderId
        createdAt
        createdBy
        creator {
          avatar
          calendarDates(
            acuityAppointmentId: $acuityAppointmentId6
            date: $date12
            forDelivery: $forDelivery6
            isReschedule: $isReschedule6
            orderId: $orderId7
          ) {
            date
          }
          calendarTimes(
            acuityAppointmentId: $acuityAppointmentId7
            consultDate: $consultDate3
            date: $date13
            forDelivery: $forDelivery7
            isReschedule: $isReschedule7
            orderId: $orderId8
          ) {
            time
          }
          consultation(input: $input22) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          consultationMessages(
            input: $input23
            limit: $limit10
            offset: $offset10
            order: $order9
          ) {
            count
            limit
            offset
          }
          consultations(
            input: $input24
            limit: $limit11
            offset: $offset11
            order: $order10
          ) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          doctor(doctorFilterInput: $doctorFilterInput6) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctors(doctorFilterInput: $doctorFilterInput7) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          locale
          ninjaVanToken
          orders(input: $input25, pagination: $pagination3) {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          partnerConsultDates(date: $date14) {
            date
          }
          partnerConsultTimes(date: $date15) {
            time
          }
          patient(input: $input26) {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientDocuments {
            createdAt
            orderSysId
            ref
            sysId
            type
            url
          }
          phoneNumber
          prescriptionCalculation {
            isAffiliateLocked
            promotionCodeError
            stripePromotionCode
          }
          requireConfirmPolicy
          socialProviderType
          stripeProducts(input: $input27) {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform22)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          sysId
          tempToken
          tempTokenExpired
          userType
          utmCampaign
          utmId
          utmMedium
          utmSource
        }
        parentOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          activeConsultation {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          acuityAppointment {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          additionalPrices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          afterVideoConsultRedirecting {
            baseUrl
            path
          }
          approveAt
          atomeNextSendingInvoiceDate
          atomePayments {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          checkoutSession {
            checkoutData
            evaluationId
            status
            sysId
          }
          childrenOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          claimedRetentionOffer
          consultationAudits(consultAuditFilterInput: $consultAuditFilterInput7) {
            consultTime
            consultType
            createdBy
            evaluationId
            sessionType
            status
            sysId
          }
          consultations(inputConsultation: $inputConsultation8) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluation {
            isCompleted
            isSkipped
            name
            patientNote
            platform
            status
            sysId
            type
          }
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          latestAtomePayment {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          latestInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          latestNote {
            content
            createdAt
            createdBy
            sysId
            updatedAt
          }
          nextReviewDate
          oldPrice
          oldPriceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          pickupLocation {
            address
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribedAfterTrialOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          prescribed_after_trial_order_sys_id
          prescription {
            cancelled
            createdAt
            days
            doctorNotes
            endDate
            expiresAt
            isFollowUp
            notedDate
            priceIds
            startDate
            status
            sysId
            treatmentCode
            updatedAt
          }
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          price {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          priceDisplayId
          priceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform23)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          siblingCrossSellOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          status
          stripePaymentIntentId
          stripeSubscriptionId
          subscription {
            cancel_at_period_end
            current_period_end
            current_period_start
            default_payment_method
            id
            items
            latest_invoice
            metadata
            pause_collection
            pending_setup_intent
            pending_update
            status
          }
          sysId
          teleConsultProduct
          upcomingInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          updatedAt
        }
        parentOrderId
        priceId
        selectedBy
        stripeProductPrice {
          importPriceId
          isBundle
          priceActive
          priceBillingScheme
          priceCreated
          priceCurrency
          priceDisplayId
          priceFirstTimeAlternativePrice
          priceFirstTimeTryingInMonths
          priceId
          priceLivemode
          priceNickname
          priceProduct
          priceTaxBehavior
          priceUnitAmount
          priceUnitAmountDecimal
          productActive
          productDescription
          productDisplayId
          productId
          productLivemode
          productName
          productStatementDescriptor
          productType
          productUniqName
          productUnitLabel
          sysId
        }
        sysId
      }
    }
    avatar
    calendarDates(
      acuityAppointmentId: $acuityAppointmentId8
      date: $date16
      forDelivery: $forDelivery8
      isReschedule: $isReschedule8
      orderId: $orderId9
    ) {
      date
    }
    calendarTimes(
      acuityAppointmentId: $acuityAppointmentId9
      consultDate: $consultDate4
      date: $date17
      forDelivery: $forDelivery9
      isReschedule: $isReschedule9
      orderId: $orderId10
    ) {
      time
    }
    consultation(input: $input29) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    consultationMessages(
      input: $input30
      limit: $limit12
      offset: $offset12
      order: $order11
    ) {
      count
      limit
      offset
    }
    consultations(
      input: $input31
      limit: $limit13
      offset: $offset13
      order: $order12
    ) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    doctor(doctorFilterInput: $doctorFilterInput8) {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    doctors(doctorFilterInput: $doctorFilterInput9) {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    email
    firstName
    fullName
    id
    isPharmacist
    lastName
    locale
    ninjaVanToken
    orders(input: $input32, pagination: $pagination4) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    partnerConsultDates(date: $date18) {
      date
    }
    partnerConsultTimes(date: $date19) {
      time
    }
    patient(input: $input33) {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientDocuments {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    phoneNumber
    prescriptionCalculation {
      isAffiliateLocked
      promotionCodeError
      stripePromotionCode
    }
    requireConfirmPolicy
    socialProviderType
    stripeProducts(input: $input34) {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform24)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    sysId
    tempToken
    tempTokenExpired
    userType
    utmCampaign
    utmId
    utmMedium
    utmSource
  }
}
    `;
export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      ['updateUser'],
      (variables?: UpdateUserMutationVariables) => fetcher<UpdateUserMutation, UpdateUserMutationVariables>(client, UpdateUserDocument, variables, headers)(),
      options
    );
export const UpdateVoidInvoiceOrderDocument = `
    mutation updateVoidInvoiceOrder($orderId: String!) {
  updateVoidInvoiceOrder(orderId: $orderId)
}
    `;
export const useUpdateVoidInvoiceOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateVoidInvoiceOrderMutation, TError, UpdateVoidInvoiceOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateVoidInvoiceOrderMutation, TError, UpdateVoidInvoiceOrderMutationVariables, TContext>(
      ['updateVoidInvoiceOrder'],
      (variables?: UpdateVoidInvoiceOrderMutationVariables) => fetcher<UpdateVoidInvoiceOrderMutation, UpdateVoidInvoiceOrderMutationVariables>(client, UpdateVoidInvoiceOrderDocument, variables, headers)(),
      options
    );
export const UpdateVoidInvoiceOrderV2Document = `
    mutation updateVoidInvoiceOrderV2($orderId: String!) {
  updateVoidInvoiceOrderV2(orderId: $orderId)
}
    `;
export const useUpdateVoidInvoiceOrderV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateVoidInvoiceOrderV2Mutation, TError, UpdateVoidInvoiceOrderV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateVoidInvoiceOrderV2Mutation, TError, UpdateVoidInvoiceOrderV2MutationVariables, TContext>(
      ['updateVoidInvoiceOrderV2'],
      (variables?: UpdateVoidInvoiceOrderV2MutationVariables) => fetcher<UpdateVoidInvoiceOrderV2Mutation, UpdateVoidInvoiceOrderV2MutationVariables>(client, UpdateVoidInvoiceOrderV2Document, variables, headers)(),
      options
    );
export const UploadFileDocument = `
    mutation uploadFile($input: SignS3Input!) {
  uploadFile(input: $input) {
    ref
    signedRequest
    url
  }
}
    `;
export const useUploadFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadFileMutation, TError, UploadFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadFileMutation, TError, UploadFileMutationVariables, TContext>(
      ['uploadFile'],
      (variables?: UploadFileMutationVariables) => fetcher<UploadFileMutation, UploadFileMutationVariables>(client, UploadFileDocument, variables, headers)(),
      options
    );
export const UploadFileDirectDocument = `
    mutation uploadFileDirect($file: String!, $input: UploadIdInput!) {
  uploadFileDirect(file: $file, input: $input) {
    identityFields {
      type
      value
    }
    ref
    signedRequest
    url
  }
}
    `;
export const useUploadFileDirectMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadFileDirectMutation, TError, UploadFileDirectMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadFileDirectMutation, TError, UploadFileDirectMutationVariables, TContext>(
      ['uploadFileDirect'],
      (variables?: UploadFileDirectMutationVariables) => fetcher<UploadFileDirectMutation, UploadFileDirectMutationVariables>(client, UploadFileDirectDocument, variables, headers)(),
      options
    );
export const UploadFileV2Document = `
    mutation uploadFileV2($input: SignS3Input!) {
  uploadFileV2(input: $input) {
    identityFields {
      type
      value
    }
    ref
    signedRequest
    url
  }
}
    `;
export const useUploadFileV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadFileV2Mutation, TError, UploadFileV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadFileV2Mutation, TError, UploadFileV2MutationVariables, TContext>(
      ['uploadFileV2'],
      (variables?: UploadFileV2MutationVariables) => fetcher<UploadFileV2Mutation, UploadFileV2MutationVariables>(client, UploadFileV2Document, variables, headers)(),
      options
    );
export const UploadPublicFileDocument = `
    mutation uploadPublicFile($input: SignS3Input!) {
  uploadPublicFile(input: $input) {
    ref
    signedRequest
    url
  }
}
    `;
export const useUploadPublicFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadPublicFileMutation, TError, UploadPublicFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadPublicFileMutation, TError, UploadPublicFileMutationVariables, TContext>(
      ['uploadPublicFile'],
      (variables?: UploadPublicFileMutationVariables) => fetcher<UploadPublicFileMutation, UploadPublicFileMutationVariables>(client, UploadPublicFileDocument, variables, headers)(),
      options
    );
export const UploadPublicFileV2Document = `
    mutation uploadPublicFileV2($input: SignS3Input!) {
  uploadPublicFileV2(input: $input) {
    ref
    signedRequest
    url
  }
}
    `;
export const useUploadPublicFileV2Mutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadPublicFileV2Mutation, TError, UploadPublicFileV2MutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadPublicFileV2Mutation, TError, UploadPublicFileV2MutationVariables, TContext>(
      ['uploadPublicFileV2'],
      (variables?: UploadPublicFileV2MutationVariables) => fetcher<UploadPublicFileV2Mutation, UploadPublicFileV2MutationVariables>(client, UploadPublicFileV2Document, variables, headers)(),
      options
    );
export const UploadTrtDocumentDocument = `
    mutation uploadTrtDocument($input: UploadTrtDocumentInput!) {
  uploadTrtDocument(input: $input) {
    createdAt
    orderSysId
    ref
    sysId
    type
    url
  }
}
    `;
export const useUploadTrtDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadTrtDocumentMutation, TError, UploadTrtDocumentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UploadTrtDocumentMutation, TError, UploadTrtDocumentMutationVariables, TContext>(
      ['uploadTrtDocument'],
      (variables?: UploadTrtDocumentMutationVariables) => fetcher<UploadTrtDocumentMutation, UploadTrtDocumentMutationVariables>(client, UploadTrtDocumentDocument, variables, headers)(),
      options
    );
export const UpsertPatientTourViewingDocument = `
    mutation upsertPatientTourViewing($input: UpsertPatientOnboardingInput!) {
  upsertPatientTourViewing(input: $input)
}
    `;
export const useUpsertPatientTourViewingMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpsertPatientTourViewingMutation, TError, UpsertPatientTourViewingMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpsertPatientTourViewingMutation, TError, UpsertPatientTourViewingMutationVariables, TContext>(
      ['upsertPatientTourViewing'],
      (variables?: UpsertPatientTourViewingMutationVariables) => fetcher<UpsertPatientTourViewingMutation, UpsertPatientTourViewingMutationVariables>(client, UpsertPatientTourViewingDocument, variables, headers)(),
      options
    );
export const UpsertRecommendedProductsDocument = `
    mutation upsertRecommendedProducts($input: UpsertRecommendedProductsInput!) {
  upsertRecommendedProducts(input: $input) {
    priceId
    productId
    status
  }
}
    `;
export const useUpsertRecommendedProductsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpsertRecommendedProductsMutation, TError, UpsertRecommendedProductsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpsertRecommendedProductsMutation, TError, UpsertRecommendedProductsMutationVariables, TContext>(
      ['upsertRecommendedProducts'],
      (variables?: UpsertRecommendedProductsMutationVariables) => fetcher<UpsertRecommendedProductsMutation, UpsertRecommendedProductsMutationVariables>(client, UpsertRecommendedProductsDocument, variables, headers)(),
      options
    );
export const ValidateEmailOtpDocument = `
    mutation validateEmailOTP($email: String!, $otp: String!) {
  validateEmailOTP(email: $email, otp: $otp)
}
    `;
export const useValidateEmailOtpMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ValidateEmailOtpMutation, TError, ValidateEmailOtpMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ValidateEmailOtpMutation, TError, ValidateEmailOtpMutationVariables, TContext>(
      ['validateEmailOTP'],
      (variables?: ValidateEmailOtpMutationVariables) => fetcher<ValidateEmailOtpMutation, ValidateEmailOtpMutationVariables>(client, ValidateEmailOtpDocument, variables, headers)(),
      options
    );
export const VerifyForgotPasswordDocument = `
    mutation verifyForgotPassword($input: VerifyForgotPasswordUserInput!) {
  verifyForgotPassword(input: $input)
}
    `;
export const useVerifyForgotPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<VerifyForgotPasswordMutation, TError, VerifyForgotPasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<VerifyForgotPasswordMutation, TError, VerifyForgotPasswordMutationVariables, TContext>(
      ['verifyForgotPassword'],
      (variables?: VerifyForgotPasswordMutationVariables) => fetcher<VerifyForgotPasswordMutation, VerifyForgotPasswordMutationVariables>(client, VerifyForgotPasswordDocument, variables, headers)(),
      options
    );
export const VerifyOrderDocument = `
    mutation verifyOrder($platform: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform9: String, $videoLink1: String!, $patientId: String, $input4: CrossSellRecordQueryInput, $orderId: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId1: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId2: String, $limit2: Int, $offset2: Int, $order1: JSON, $acuityAppointmentId2: String, $date2: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date3: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $input5: V2ConsultationFilterInput!, $input6: ConsultationMessagesInput!, $limit3: Int, $offset3: Int, $order2: JSON, $input7: ConsultationListInput!, $limit4: Int, $offset4: Int, $order3: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input8: OrderInput!, $pagination: V2PaginationInput!, $date4: String, $date5: Float, $input9: GetPatientInput, $platform10: String, $input10: StripeProductFilterV2, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit5: Int, $offset5: Int, $order4: JSON, $input13: ConsultationListInput!, $limit6: Int, $offset6: Int, $order5: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform11: String, $input16: StripeProductFilterV2, $doctorFilterInput3: V2DoctorInputFilter, $limit7: Int, $offset7: Int, $order6: JSON, $platform12: String, $platform13: String, $platform14: String, $platform15: String, $platform16: String, $platform17: String, $platform18: String, $platform19: String, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input17: V2ConsultationFilterInput!, $input18: ConsultationMessagesInput!, $limit8: Int, $offset8: Int, $order7: JSON, $input19: ConsultationListInput!, $limit9: Int, $offset9: Int, $order8: JSON, $doctorFilterInput4: V2DoctorInputFilter, $doctorFilterInput5: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform20: String, $input20: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input21: GetPatientInput, $platform21: String, $platform22: String, $input22: StripeProductFilterV2, $input23: VerifyOrderInput!) {
  verifyOrder(input: $input23) {
    address
    cost
    courierName
    createdAt
    deliveryMethod
    deliveryTimestamp
    estimatedShipDate
    group {
      bookingNo
      createdAt
      name
      sysId
      updatedAt
    }
    items {
      createdAt
      dosage
      isFirstPurchase
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          consultationAudit {
            consultTime
            consultType
            createdBy
            doctor {
              active
              bio {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              calendarId
              consultation(videoLink: $videoLink1) {
                gmeetLink
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                previewToken
                previewVideoLink
                status
                sysId
                token
                videoChannelId
                videoLink
                zoomJoinUrl
              }
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              patient(patientId: $patientId) {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sysId
              textConsultPostalCodes
              trtEligible
              user {
                admin {
                  crossSellRecords(input: $input4) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId
                  date: $date
                  forDelivery: $forDelivery
                  isReschedule: $isReschedule
                  orderId: $orderId1
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId1
                  consultDate: $consultDate
                  date: $date1
                  forDelivery: $forDelivery1
                  isReschedule: $isReschedule1
                  orderId: $orderId2
                ) {
                  time
                }
                consultation(input: $input11) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit2, offset: $offset2, order: $order1) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId2
                      date: $date2
                      forDelivery: $forDelivery2
                      isReschedule: $isReschedule2
                      orderId: $orderId3
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId3
                      consultDate: $consultDate1
                      date: $date3
                      forDelivery: $forDelivery3
                      isReschedule: $isReschedule3
                      orderId: $orderId4
                    ) {
                      time
                    }
                    consultation(input: $input5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input6
                      limit: $limit3
                      offset: $offset3
                      order: $order2
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input7, limit: $limit4, offset: $offset4, order: $order3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input8, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date4) {
                      date
                    }
                    partnerConsultTimes(date: $date5) {
                      time
                    }
                    patient(input: $input9) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input10) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input12
                  limit: $limit5
                  offset: $offset5
                  order: $order4
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input13, limit: $limit6, offset: $offset6, order: $order5) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input14, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input15) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input16) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            evaluationId
            sessionType
            status
            sysId
          }
          consultationMessages(limit: $limit7, offset: $offset7, order: $order6) {
            count
            limit
            offset
          }
          consultationTitle {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          countReminder
          createdAt
          doctor {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          messages {
            consultationSysId
            content
            createdAt
            readAt
            sysId
            updatedAt
          }
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          orderSysId
          participants {
            avatar
            fullName
            identity
            locale
            role
            token
            userSysId
          }
          participantsV2 {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            phoneNumber
            requireConfirmPolicy
            socialProviderType
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      orderNo
      orderSysId
      paymentAmount
      paymentDate
      paymentIntentId
      paymentProvider
      price {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredientDetails {
              description
              imageLink
              locale
              name
              strength
              uniqueName
            }
            ingredients
            isConsultOnly(platform: $platform12)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            prices {
              active
              alternativePrice {
                active
                alternativePrice {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                nickname
                product
                productId
                shopDisplay
                sysId
                tax_behavior
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                ingredients
                isConsultOnly(platform: $platform14)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              texts {
                actual_price_display
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                price_frequency
                price_quantity
                quantity
                quantity_display
              }
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            productInstructions {
              language
              localeKey
              productId
              sysId
              translatedText
            }
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            tempPrices {
              active
              alternativePrice {
                active
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                nickname
                product
                productId
                shopDisplay
                sysId
                tax_behavior
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              metadata {
                actual_price_display
                boxes
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                isArchived
                isOneTimePrice
                price_frequency
                price_quantity
                price_show
                quantity
                quantity_display
                strength
              }
              nickname
              product
              productId
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                format
                hasOneDosage
                hasOneFrequency
                id
                ingredients
                isConsultOnly(platform: $platform15)
                isPopular
                isRxOneTime
                isShowOnShop
                isSkipMedProduct
                livemode
                metadata
                name
                popularPriceId
                shopProductGroupIds
                shouldChargeNow
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
                usage
              }
              shopDisplay
              sysId
              tax_behavior
              texts {
                actual_price_display
                dosage
                dosage_display
                dosage_popular
                frequency
                frequency_actual_price_display
                frequency_display
                frequency_popular
                frequency_price_display
                frequency_quantity_display
                frequency_quantity_display_patient
                frequency_savings_display
                frequency_strikeout_price_display
                price_frequency
                price_quantity
                quantity
                quantity_display
              }
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            texts {
              benefits
              category
              display_price
              display_price_patient
              dosage_variant_body
              dosage_variant_title
              effective_in
              for
              frequency_variant_title
              good_to_know
              how_to_take
              how_to_use
              is_popular
              lasts_for
              platform
              product_description
              product_name
              product_short_description
              quantity_per_unit
              quantity_variant_title
              requires_prescription
              safety_information
              side_effects
              strength
              taken
              unit
              unit_patient
            }
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredients
          isConsultOnly(platform: $platform16)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform17)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      priceId
      product {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform18)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform19)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      promotionCode
      qty
      sysId
      updatedAt
    }
    note
    parcelId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    paused
    shipDate
    shipper {
      avatar
      calendarDates(
        acuityAppointmentId: $acuityAppointmentId4
        date: $date8
        forDelivery: $forDelivery4
        isReschedule: $isReschedule4
        orderId: $orderId5
      ) {
        date
      }
      calendarTimes(
        acuityAppointmentId: $acuityAppointmentId5
        consultDate: $consultDate2
        date: $date9
        forDelivery: $forDelivery5
        isReschedule: $isReschedule5
        orderId: $orderId6
      ) {
        time
      }
      consultation(input: $input17) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      consultationMessages(
        input: $input18
        limit: $limit8
        offset: $offset8
        order: $order7
      ) {
        count
        limit
        offset
      }
      consultations(input: $input19, limit: $limit9, offset: $offset9, order: $order8) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      doctor(doctorFilterInput: $doctorFilterInput4) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      doctors(doctorFilterInput: $doctorFilterInput5) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      orders(input: $input20, pagination: $pagination2) {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        activeConsultation {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        acuityAppointment {
          appointmentTypeID
          bookedAt
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          bookedAt
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        additionalPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        afterVideoConsultRedirecting {
          baseUrl
          path
        }
        approveAt
        atomeNextSendingInvoiceDate
        atomePayments {
          amount
          paymentUrl
          priceId
          referenceId
          status
          sysId
        }
        checkoutSession {
          checkoutData
          evaluationId
          status
          sysId
        }
        childrenOrders {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        claimedRetentionOffer
        consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
          consultTime
          consultType
          createdBy
          evaluationId
          sessionType
          status
          sysId
        }
        consultations(inputConsultation: $inputConsultation5) {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluation {
          isCompleted
          isSkipped
          name
          patientNote
          platform
          status
          sysId
          type
        }
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        latestAtomePayment {
          amount
          paymentUrl
          priceId
          referenceId
          status
          sysId
        }
        latestInvoice {
          amount_due
          hosted_invoice_url
          id
          next_payment_attempt
          paid
          paymentStatus
          period_end
          starting_balance
          status
          subtotal
          tax
          total
        }
        latestNote {
          content
          createdAt
          createdBy
          sysId
          updatedAt
        }
        nextReviewDate
        oldPrice
        oldPriceInfo {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        pickupLocation {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribedAfterTrialOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        prescribed_after_trial_order_sys_id
        prescription {
          cancelled
          createdAt
          days
          doctorNotes
          endDate
          expiresAt
          isFollowUp
          notedDate
          priceIds
          startDate
          status
          sysId
          treatmentCode
          updatedAt
        }
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation {
          cashbackEarnRate
          cashbackEarned
          cashbackRedeemed
          consultBasePrice
          consultFee
          consultFeeAfterDiscount
          consultTax
          consultTransactionFee
          discountAmount
          isConsult
          mainBasePrice
          mainTax
          mainTransactionFee
          minimalAmountPayment
          paymentIntentAmount
          paymentIntentAmountAfterCashback
          paymentIntentSummary
          priceId
          productPriceAmount
          productPriceAmountAfterDiscount
          promotionCode
          shouldChargeConsultFee
          subTotal
          total
          totalAfterCashback
        }
        price {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        priceDisplayId
        priceInfo {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInfo {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform20)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        siblingCrossSellOrders {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        status
        stripePaymentIntentId
        stripeSubscriptionId
        subscription {
          cancel_at_period_end
          current_period_end
          current_period_start
          default_payment_method
          id
          items
          latest_invoice
          metadata
          pause_collection
          pending_setup_intent
          pending_update
          status
        }
        sysId
        teleConsultProduct
        upcomingInvoice {
          amount_due
          hosted_invoice_url
          id
          next_payment_attempt
          paid
          paymentStatus
          period_end
          starting_balance
          status
          subtotal
          tax
          total
        }
        updatedAt
      }
      partnerConsultDates(date: $date10) {
        date
      }
      partnerConsultTimes(date: $date11) {
        time
      }
      patient(input: $input21) {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      patientDocuments {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      phoneNumber
      prescriptionCalculation {
        affiliateCouponNotApplied {
          affiliateProductDisplayName
          reason
        }
        isAffiliateLocked
        otcCalculationSummary {
          otcOrdersCalculation {
            basePrice
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            discountAmount
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            stripePromotionCode
            tax
            transactionFee
          }
          totalBasePrice
          totalCashbackEarned
          totalCashbackRedeemed
          totalPaymentIntentAmount
          totalTax
          totalTransactionFee
        }
        promotionCodeError
        rxCalculationSummary {
          rxOrdersCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          total
          totalCashbackEarned
          totalCashbackRedeemed
          totalDiscountAmount
          totalMainBasePrice
          totalPaymentIntentAmount
          totalPaymentIntentAmountAfterCashback
          totalTax
          totalTransactionFee
        }
        stripePromotionCode
      }
      requireConfirmPolicy
      socialProviderType
      stripeProducts(input: $input22) {
        active
        country
        createdAt
        description
        displayId
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform21)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        ingredientDetails {
          description
          imageLink
          locale
          name
          strength
          uniqueName
        }
        ingredients
        isConsultOnly(platform: $platform22)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        prices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        productInstructions {
          language
          localeKey
          productId
          sysId
          translatedText
        }
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        tempPrices {
          active
          billing_scheme
          created
          createdAt
          currency
          displayId
          firstTimeAlternativePrice
          firstTimeTryingInMonths
          id
          importPriceId
          isBundle
          livemode
          locale
          nickname
          product
          productId
          shopDisplay
          sysId
          tax_behavior
          type
          unit_amount
          unit_amount_decimal
          updatedAt
        }
        texts {
          benefits
          category
          display_price
          display_price_patient
          dosage_variant_body
          dosage_variant_title
          effective_in
          for
          frequency_variant_title
          good_to_know
          how_to_take
          how_to_use
          is_popular
          lasts_for
          platform
          product_description
          product_name
          product_short_description
          quantity_per_unit
          quantity_variant_title
          requires_prescription
          safety_information
          side_effects
          strength
          taken
          unit
          unit_patient
        }
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    status
    sysId
    trackingNo
    updatedAt
  }
}
    `;
export const useVerifyOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<VerifyOrderMutation, TError, VerifyOrderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<VerifyOrderMutation, TError, VerifyOrderMutationVariables, TContext>(
      ['verifyOrder'],
      (variables?: VerifyOrderMutationVariables) => fetcher<VerifyOrderMutation, VerifyOrderMutationVariables>(client, VerifyOrderDocument, variables, headers)(),
      options
    );
export const AffiliateDocument = `
    query affiliate($sysId: String!) {
  affiliate(sysId: $sysId) {
    createdAt
    enabled
    formFieldMap
    formSubmitUrl
    name
    notificationChannel
    notificationEmail
    portalUrl
    region
    slug
    sysId
    updatedAt
  }
}
    `;
export const useAffiliateQuery = <
      TData = AffiliateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AffiliateQueryVariables,
      options?: UseQueryOptions<AffiliateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AffiliateQuery, TError, TData>(
      ['affiliate', variables],
      fetcher<AffiliateQuery, AffiliateQueryVariables>(client, AffiliateDocument, variables, headers),
      options
    );
export const AffiliateCouponStatsForOpsDocument = `
    query affiliateCouponStatsForOps($affiliateSysId: String) {
  affiliateCouponStatsForOps(affiliateSysId: $affiliateSysId) {
    monthOrders
    monthSubmissions
    weekOrders
    weekSubmissions
  }
}
    `;
export const useAffiliateCouponStatsForOpsQuery = <
      TData = AffiliateCouponStatsForOpsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AffiliateCouponStatsForOpsQueryVariables,
      options?: UseQueryOptions<AffiliateCouponStatsForOpsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AffiliateCouponStatsForOpsQuery, TError, TData>(
      variables === undefined ? ['affiliateCouponStatsForOps'] : ['affiliateCouponStatsForOps', variables],
      fetcher<AffiliateCouponStatsForOpsQuery, AffiliateCouponStatsForOpsQueryVariables>(client, AffiliateCouponStatsForOpsDocument, variables, headers),
      options
    );
export const AffiliateCouponsForOpsDocument = `
    query affiliateCouponsForOps($filter: AffiliateCouponsForOpsFilterInput, $pagination: V2PaginationInput) {
  affiliateCouponsForOps(filter: $filter, pagination: $pagination) {
    count
    items {
      affiliate {
        createdAt
        enabled
        formFieldMap
        formSubmitUrl
        name
        notificationChannel
        notificationEmail
        portalUrl
        region
        slug
        sysId
        updatedAt
      }
      affiliateProduct {
        affiliate {
          enabled
          name
          portalUrl
          region
          slug
          sysId
        }
        affiliateSysId
        couponLandingUrl
        createdAt
        discountPercentage
        displayName
        enabled
        evalFlow
        externalPortalUrl
        slug
        stripePriceId
        stripeProductId
        stripePromotionCode
        stripePromotionCodeId
        sysId
        unitAmount
        updatedAt
      }
      affiliateProductSysId
      affiliateSysId
      amountCollected
      amountCollectedCurrency
      anonymousId
      converted
      couponId
      createdAt
      customerEmail
      customerUserId
      invoiceSettledAt
      opsNote
      orderShortId
      orderStatus
      orderSysId
      status
      stripeCustomerId
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    limit
    offset
  }
}
    `;
export const useAffiliateCouponsForOpsQuery = <
      TData = AffiliateCouponsForOpsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AffiliateCouponsForOpsQueryVariables,
      options?: UseQueryOptions<AffiliateCouponsForOpsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AffiliateCouponsForOpsQuery, TError, TData>(
      variables === undefined ? ['affiliateCouponsForOps'] : ['affiliateCouponsForOps', variables],
      fetcher<AffiliateCouponsForOpsQuery, AffiliateCouponsForOpsQueryVariables>(client, AffiliateCouponsForOpsDocument, variables, headers),
      options
    );
export const AffiliateEligibleStripeProductsDocument = `
    query affiliateEligibleStripeProducts {
  affiliateEligibleStripeProducts {
    name
    prices {
      interval
      nickname
      stripePriceId
      type
      unitAmount
    }
    stripeProductId
  }
}
    `;
export const useAffiliateEligibleStripeProductsQuery = <
      TData = AffiliateEligibleStripeProductsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AffiliateEligibleStripeProductsQueryVariables,
      options?: UseQueryOptions<AffiliateEligibleStripeProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AffiliateEligibleStripeProductsQuery, TError, TData>(
      variables === undefined ? ['affiliateEligibleStripeProducts'] : ['affiliateEligibleStripeProducts', variables],
      fetcher<AffiliateEligibleStripeProductsQuery, AffiliateEligibleStripeProductsQueryVariables>(client, AffiliateEligibleStripeProductsDocument, variables, headers),
      options
    );
export const AffiliateProductByAffiliateSlugAndStripePriceIdDocument = `
    query affiliateProductByAffiliateSlugAndStripePriceId($affiliateSlug: String!, $stripePriceId: String!) {
  affiliateProductByAffiliateSlugAndStripePriceId(
    affiliateSlug: $affiliateSlug
    stripePriceId: $stripePriceId
  ) {
    affiliate {
      enabled
      name
      portalUrl
      region
      slug
      sysId
    }
    affiliateSysId
    createdAt
    discountPercentage
    displayName
    enabled
    evalFlow
    slug
    stripePriceId
    stripeProductId
    sysId
    updatedAt
  }
}
    `;
export const useAffiliateProductByAffiliateSlugAndStripePriceIdQuery = <
      TData = AffiliateProductByAffiliateSlugAndStripePriceIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AffiliateProductByAffiliateSlugAndStripePriceIdQueryVariables,
      options?: UseQueryOptions<AffiliateProductByAffiliateSlugAndStripePriceIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AffiliateProductByAffiliateSlugAndStripePriceIdQuery, TError, TData>(
      ['affiliateProductByAffiliateSlugAndStripePriceId', variables],
      fetcher<AffiliateProductByAffiliateSlugAndStripePriceIdQuery, AffiliateProductByAffiliateSlugAndStripePriceIdQueryVariables>(client, AffiliateProductByAffiliateSlugAndStripePriceIdDocument, variables, headers),
      options
    );
export const AffiliateProductByStripePriceIdDocument = `
    query affiliateProductByStripePriceId($stripePriceId: String!) {
  affiliateProductByStripePriceId(stripePriceId: $stripePriceId) {
    affiliate {
      enabled
      name
      portalUrl
      region
      slug
      sysId
    }
    affiliateSysId
    createdAt
    discountPercentage
    displayName
    enabled
    evalFlow
    slug
    stripePriceId
    stripeProductId
    sysId
    updatedAt
  }
}
    `;
export const useAffiliateProductByStripePriceIdQuery = <
      TData = AffiliateProductByStripePriceIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AffiliateProductByStripePriceIdQueryVariables,
      options?: UseQueryOptions<AffiliateProductByStripePriceIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AffiliateProductByStripePriceIdQuery, TError, TData>(
      ['affiliateProductByStripePriceId', variables],
      fetcher<AffiliateProductByStripePriceIdQuery, AffiliateProductByStripePriceIdQueryVariables>(client, AffiliateProductByStripePriceIdDocument, variables, headers),
      options
    );
export const AffiliateProductsDocument = `
    query affiliateProducts($affiliateSysId: String!) {
  affiliateProducts(affiliateSysId: $affiliateSysId) {
    affiliate {
      enabled
      name
      portalUrl
      region
      slug
      sysId
    }
    affiliateSysId
    couponLandingUrl
    createdAt
    discountPercentage
    displayName
    enabled
    evalFlow
    externalPortalUrl
    slug
    stripePriceId
    stripeProductId
    stripePromotionCode
    stripePromotionCodeId
    sysId
    unitAmount
    updatedAt
  }
}
    `;
export const useAffiliateProductsQuery = <
      TData = AffiliateProductsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AffiliateProductsQueryVariables,
      options?: UseQueryOptions<AffiliateProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AffiliateProductsQuery, TError, TData>(
      ['affiliateProducts', variables],
      fetcher<AffiliateProductsQuery, AffiliateProductsQueryVariables>(client, AffiliateProductsDocument, variables, headers),
      options
    );
export const AffiliatesDocument = `
    query affiliates($filter: AffiliateFilterInput, $pagination: V2PaginationInput) {
  affiliates(filter: $filter, pagination: $pagination) {
    count
    items {
      createdAt
      enabled
      formFieldMap
      formSubmitUrl
      name
      notificationChannel
      notificationEmail
      portalUrl
      region
      slug
      sysId
      updatedAt
    }
    limit
    offset
  }
}
    `;
export const useAffiliatesQuery = <
      TData = AffiliatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AffiliatesQueryVariables,
      options?: UseQueryOptions<AffiliatesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AffiliatesQuery, TError, TData>(
      variables === undefined ? ['affiliates'] : ['affiliates', variables],
      fetcher<AffiliatesQuery, AffiliatesQueryVariables>(client, AffiliatesDocument, variables, headers),
      options
    );
export const AuthenticateDocument = `
    query authenticate {
  authenticate {
    avatar
    email
    firstName
    fullName
    id
    isPharmacist
    lastName
    patient {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
      weight
    }
    requireConfirmPolicy
    socialProviderType
    sysId
    userType
    utmCampaign
    utmMedium
    utmSource
  }
}
    `;
export const useAuthenticateQuery = <
      TData = AuthenticateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AuthenticateQueryVariables,
      options?: UseQueryOptions<AuthenticateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AuthenticateQuery, TError, TData>(
      variables === undefined ? ['authenticate'] : ['authenticate', variables],
      fetcher<AuthenticateQuery, AuthenticateQueryVariables>(client, AuthenticateDocument, variables, headers),
      options
    );
export const BloodDrawConfirmationsDocument = `
    query bloodDrawConfirmations($orderSysId: String!) {
  bloodDrawConfirmations(orderSysId: $orderSysId) {
    confirmedAt
    drawType
    orderSysId
    sysId
  }
}
    `;
export const useBloodDrawConfirmationsQuery = <
      TData = BloodDrawConfirmationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: BloodDrawConfirmationsQueryVariables,
      options?: UseQueryOptions<BloodDrawConfirmationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BloodDrawConfirmationsQuery, TError, TData>(
      ['bloodDrawConfirmations', variables],
      fetcher<BloodDrawConfirmationsQuery, BloodDrawConfirmationsQueryVariables>(client, BloodDrawConfirmationsDocument, variables, headers),
      options
    );
export const CanEditDeliveryTimeDocument = `
    query canEditDeliveryTime($orderId: String!) {
  canEditDeliveryTime(orderId: $orderId) {
    canEdit
    isEditWithin2Hours
  }
}
    `;
export const useCanEditDeliveryTimeQuery = <
      TData = CanEditDeliveryTimeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CanEditDeliveryTimeQueryVariables,
      options?: UseQueryOptions<CanEditDeliveryTimeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CanEditDeliveryTimeQuery, TError, TData>(
      ['canEditDeliveryTime', variables],
      fetcher<CanEditDeliveryTimeQuery, CanEditDeliveryTimeQueryVariables>(client, CanEditDeliveryTimeDocument, variables, headers),
      options
    );
export const CheckProductsExistingOrdersForPatientDocument = `
    query checkProductsExistingOrdersForPatient($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: AvailableOrdersOfPatientInputs!) {
  checkProductsExistingOrdersForPatient(input: $input) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useCheckProductsExistingOrdersForPatientQuery = <
      TData = CheckProductsExistingOrdersForPatientQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckProductsExistingOrdersForPatientQueryVariables,
      options?: UseQueryOptions<CheckProductsExistingOrdersForPatientQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckProductsExistingOrdersForPatientQuery, TError, TData>(
      ['checkProductsExistingOrdersForPatient', variables],
      fetcher<CheckProductsExistingOrdersForPatientQuery, CheckProductsExistingOrdersForPatientQueryVariables>(client, CheckProductsExistingOrdersForPatientDocument, variables, headers),
      options
    );
export const CheckValidConversationsForDoctorDocument = `
    query checkValidConversationsForDoctor($input: CheckValidConversationsForDoctorInput!) {
  checkValidConversationsForDoctor(input: $input)
}
    `;
export const useCheckValidConversationsForDoctorQuery = <
      TData = CheckValidConversationsForDoctorQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckValidConversationsForDoctorQueryVariables,
      options?: UseQueryOptions<CheckValidConversationsForDoctorQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckValidConversationsForDoctorQuery, TError, TData>(
      ['checkValidConversationsForDoctor', variables],
      fetcher<CheckValidConversationsForDoctorQuery, CheckValidConversationsForDoctorQueryVariables>(client, CheckValidConversationsForDoctorDocument, variables, headers),
      options
    );
export const CheckValidConversationsForPatientDocument = `
    query checkValidConversationsForPatient($input: CheckValidConversationsForPatientInput!) {
  checkValidConversationsForPatient(input: $input)
}
    `;
export const useCheckValidConversationsForPatientQuery = <
      TData = CheckValidConversationsForPatientQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckValidConversationsForPatientQueryVariables,
      options?: UseQueryOptions<CheckValidConversationsForPatientQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CheckValidConversationsForPatientQuery, TError, TData>(
      ['checkValidConversationsForPatient', variables],
      fetcher<CheckValidConversationsForPatientQuery, CheckValidConversationsForPatientQueryVariables>(client, CheckValidConversationsForPatientDocument, variables, headers),
      options
    );
export const ConvertReferralPromoCodeValueToCashbackDocument = `
    query convertReferralPromoCodeValueToCashback {
  convertReferralPromoCodeValueToCashback {
    errorPromoCodes
  }
}
    `;
export const useConvertReferralPromoCodeValueToCashbackQuery = <
      TData = ConvertReferralPromoCodeValueToCashbackQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ConvertReferralPromoCodeValueToCashbackQueryVariables,
      options?: UseQueryOptions<ConvertReferralPromoCodeValueToCashbackQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ConvertReferralPromoCodeValueToCashbackQuery, TError, TData>(
      variables === undefined ? ['convertReferralPromoCodeValueToCashback'] : ['convertReferralPromoCodeValueToCashback', variables],
      fetcher<ConvertReferralPromoCodeValueToCashbackQuery, ConvertReferralPromoCodeValueToCashbackQueryVariables>(client, ConvertReferralPromoCodeValueToCashbackDocument, variables, headers),
      options
    );
export const CountOrderingOfAnEvalProductsDocument = `
    query countOrderingOfAnEvalProducts($input: CountOrderingOfAnEvalProductsInput!) {
  countOrderingOfAnEvalProducts(input: $input) {
    count
    priceIds
  }
}
    `;
export const useCountOrderingOfAnEvalProductsQuery = <
      TData = CountOrderingOfAnEvalProductsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CountOrderingOfAnEvalProductsQueryVariables,
      options?: UseQueryOptions<CountOrderingOfAnEvalProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CountOrderingOfAnEvalProductsQuery, TError, TData>(
      ['countOrderingOfAnEvalProducts', variables],
      fetcher<CountOrderingOfAnEvalProductsQuery, CountOrderingOfAnEvalProductsQueryVariables>(client, CountOrderingOfAnEvalProductsDocument, variables, headers),
      options
    );
export const DoseStartDocument = `
    query doseStart($orderSysId: String!) {
  doseStart(orderSysId: $orderSysId) {
    doseStartedAt
    orderSysId
  }
}
    `;
export const useDoseStartQuery = <
      TData = DoseStartQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: DoseStartQueryVariables,
      options?: UseQueryOptions<DoseStartQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<DoseStartQuery, TError, TData>(
      ['doseStart', variables],
      fetcher<DoseStartQuery, DoseStartQueryVariables>(client, DoseStartDocument, variables, headers),
      options
    );
export const GetActiveProductsDocument = `
    query getActiveProducts {
  getActiveProducts {
    activeProducts
    completedEvalIds
    pendingEvalIds
    skippedEvalIds
  }
}
    `;
export const useGetActiveProductsQuery = <
      TData = GetActiveProductsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetActiveProductsQueryVariables,
      options?: UseQueryOptions<GetActiveProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetActiveProductsQuery, TError, TData>(
      variables === undefined ? ['getActiveProducts'] : ['getActiveProducts', variables],
      fetcher<GetActiveProductsQuery, GetActiveProductsQueryVariables>(client, GetActiveProductsDocument, variables, headers),
      options
    );
export const GetAcuityAppointmentByFilterDocument = `
    query getAcuityAppointmentByFilter($input: AcuityAppointmentFilterInput!, $limit: Int, $offset: Int, $order: JSON) {
  getAcuityAppointmentByFilter(
    input: $input
    limit: $limit
    offset: $offset
    order: $order
  ) {
    appointmentTypeID
    calendar
    calendarID
    calendarJP
    canceled
    confirmationPage
    date
    dateCreated
    datetime
    doctor
    duration
    email
    endTime
    firstName
    id
    isFollowUpConsult
    lastName
    noShow
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    phone
    sysId
    time
    timezone
    type
  }
}
    `;
export const useGetAcuityAppointmentByFilterQuery = <
      TData = GetAcuityAppointmentByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAcuityAppointmentByFilterQueryVariables,
      options?: UseQueryOptions<GetAcuityAppointmentByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAcuityAppointmentByFilterQuery, TError, TData>(
      ['getAcuityAppointmentByFilter', variables],
      fetcher<GetAcuityAppointmentByFilterQuery, GetAcuityAppointmentByFilterQueryVariables>(client, GetAcuityAppointmentByFilterDocument, variables, headers),
      options
    );
export const GetAddressesByFilterDocument = `
    query getAddressesByFilter($input: AddressInput!, $limit: Int, $offset: Int, $order: JSON) {
  getAddressesByFilter(
    input: $input
    limit: $limit
    offset: $offset
    order: $order
  ) {
    address
    city
    country
    firstName
    lastName
    name
    note
    phoneNumber
    postal
    region
    sameAsBilling
    state
    sysId
    type
    unit
  }
}
    `;
export const useGetAddressesByFilterQuery = <
      TData = GetAddressesByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAddressesByFilterQueryVariables,
      options?: UseQueryOptions<GetAddressesByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAddressesByFilterQuery, TError, TData>(
      ['getAddressesByFilter', variables],
      fetcher<GetAddressesByFilterQuery, GetAddressesByFilterQueryVariables>(client, GetAddressesByFilterDocument, variables, headers),
      options
    );
export const GetAllDispatchJobsDocument = `
    query getAllDispatchJobs($limit: Int, $offset: Int, $order: JSON) {
  getAllDispatchJobs(limit: $limit, offset: $offset, order: $order) {
    collectionSnapshot
    deliverySnapshot
    orderId
    sysId
  }
}
    `;
export const useGetAllDispatchJobsQuery = <
      TData = GetAllDispatchJobsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllDispatchJobsQueryVariables,
      options?: UseQueryOptions<GetAllDispatchJobsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllDispatchJobsQuery, TError, TData>(
      variables === undefined ? ['getAllDispatchJobs'] : ['getAllDispatchJobs', variables],
      fetcher<GetAllDispatchJobsQuery, GetAllDispatchJobsQueryVariables>(client, GetAllDispatchJobsDocument, variables, headers),
      options
    );
export const GetAllEvaluationFormsDocument = `
    query getAllEvaluationForms($limit: Int, $offset: Int, $order: JSON) {
  getAllEvaluationForms(limit: $limit, offset: $offset, order: $order) {
    createdAt
    customFields
    description
    disabled
    formSections
    id
    learnMoreLink
    onCompleteRedirect
    sysId
    title
    total
    updatedAt
    version
  }
}
    `;
export const useGetAllEvaluationFormsQuery = <
      TData = GetAllEvaluationFormsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllEvaluationFormsQueryVariables,
      options?: UseQueryOptions<GetAllEvaluationFormsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllEvaluationFormsQuery, TError, TData>(
      variables === undefined ? ['getAllEvaluationForms'] : ['getAllEvaluationForms', variables],
      fetcher<GetAllEvaluationFormsQuery, GetAllEvaluationFormsQueryVariables>(client, GetAllEvaluationFormsDocument, variables, headers),
      options
    );
export const GetAllPrescriptionsDocument = `
    query getAllPrescriptions($limit: Int, $offset: Int, $order: JSON) {
  getAllPrescriptions(limit: $limit, offset: $offset, order: $order) {
    approver {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    cancelled
    createdAt
    days
    doctor {
      active
      calendarId
      country
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
    }
    doctorNotes
    endDate
    expiresAt
    isFollowUp
    notedDate
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    priceIds
    products {
      active
      childrenIncludedProduct {
        active
        childrenIncludedProduct {
          active
          childrenSecondIncludedProduct {
            active
            childrenIncludedProduct {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              id
              image {
                noahVertical
                noahWide
                sysId
                zoeyVertical
                zoeyWide
              }
              includedProduct {
                active
                childrenIncludedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                childrenSecondIncludedProduct {
                  active
                  childrenSecondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                country
                createdAt
                description
                displayId
                evaluationId
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    startDate
    status
    sysId
    treatmentCode
    updatedAt
  }
}
    `;
export const useGetAllPrescriptionsQuery = <
      TData = GetAllPrescriptionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllPrescriptionsQueryVariables,
      options?: UseQueryOptions<GetAllPrescriptionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllPrescriptionsQuery, TError, TData>(
      variables === undefined ? ['getAllPrescriptions'] : ['getAllPrescriptions', variables],
      fetcher<GetAllPrescriptionsQuery, GetAllPrescriptionsQueryVariables>(client, GetAllPrescriptionsDocument, variables, headers),
      options
    );
export const GetAuditDoctorNotesByFilterDocument = `
    query getAuditDoctorNotesByFilter($input: AuditDoctorNoteInput!, $limit: Int, $offset: Int, $order: JSON) {
  getAuditDoctorNotesByFilter(
    input: $input
    limit: $limit
    offset: $offset
    order: $order
  ) {
    createdAt
    createdBy
    deletedBy
    doctor {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    isDeleted
    note
    order {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    sysId
  }
}
    `;
export const useGetAuditDoctorNotesByFilterQuery = <
      TData = GetAuditDoctorNotesByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAuditDoctorNotesByFilterQueryVariables,
      options?: UseQueryOptions<GetAuditDoctorNotesByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAuditDoctorNotesByFilterQuery, TError, TData>(
      ['getAuditDoctorNotesByFilter', variables],
      fetcher<GetAuditDoctorNotesByFilterQuery, GetAuditDoctorNotesByFilterQueryVariables>(client, GetAuditDoctorNotesByFilterDocument, variables, headers),
      options
    );
export const GetAvailableSlotsDocument = `
    query getAvailableSlots($input: AvailableSlotsInput!) {
  getAvailableSlots(input: $input) {
    data {
      date
      times
    }
  }
}
    `;
export const useGetAvailableSlotsQuery = <
      TData = GetAvailableSlotsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAvailableSlotsQueryVariables,
      options?: UseQueryOptions<GetAvailableSlotsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAvailableSlotsQuery, TError, TData>(
      ['getAvailableSlots', variables],
      fetcher<GetAvailableSlotsQuery, GetAvailableSlotsQueryVariables>(client, GetAvailableSlotsDocument, variables, headers),
      options
    );
export const GetAvailableSlotsForDeliveryDocument = `
    query getAvailableSlotsForDelivery($input: AvailableSlotsForDeliveryInput!) {
  getAvailableSlotsForDelivery(input: $input) {
    data {
      date
      times
    }
  }
}
    `;
export const useGetAvailableSlotsForDeliveryQuery = <
      TData = GetAvailableSlotsForDeliveryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAvailableSlotsForDeliveryQueryVariables,
      options?: UseQueryOptions<GetAvailableSlotsForDeliveryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAvailableSlotsForDeliveryQuery, TError, TData>(
      ['getAvailableSlotsForDelivery', variables],
      fetcher<GetAvailableSlotsForDeliveryQuery, GetAvailableSlotsForDeliveryQueryVariables>(client, GetAvailableSlotsForDeliveryDocument, variables, headers),
      options
    );
export const GetBookingResultDocument = `
    query getBookingResult($input: BookingResultInput!) {
  getBookingResult(input: $input) {
    bookedOrders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    cart {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      calculateOrderSummary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        discountAmountLater
        discountAmountNow
        itemList {
          consultationSessionType
          isEDBundle
          isPayNow
          isRxProduct
          isSkipMedSelecting
          isSubscriptionPrice
          isSubscriptionUpdate
          itemSubTotal
          itemSubTotalAfterDiscount
          mainProductId
          mainProductName
          name
          priceId
          priceType
          productId
          productUniqName
          quantity
          unit_amount
        }
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountBeforeTax
        paymentIntentSummary
        promotionCode
        shippingFee
        subTotal
        subTotalLater
        subTotalNow
        taxes
        taxesLater
        taxesNow
        teleConsultFee
        total
        totalLater
        totalNow
        totalNowAfterCashback
        totalTaxes
      }
      cartItems
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      paidCompletedEvaluationIds
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      platform
      promotionCode
      sysId
    }
    needsBookingOrderIds
  }
}
    `;
export const useGetBookingResultQuery = <
      TData = GetBookingResultQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetBookingResultQueryVariables,
      options?: UseQueryOptions<GetBookingResultQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetBookingResultQuery, TError, TData>(
      ['getBookingResult', variables],
      fetcher<GetBookingResultQuery, GetBookingResultQueryVariables>(client, GetBookingResultDocument, variables, headers),
      options
    );
export const GetByTextConversationIdDocument = `
    query getByTextConversationId($platform: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform9: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform10: String, $input9: StripeProductFilterV2, $limit4: Int, $offset4: Int, $order3: JSON, $patientId: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input12: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $doctorFilterInput3: V2DoctorInputFilter, $input13: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input14: GetPatientInput, $platform11: String, $input15: StripeProductFilterV2, $input16: V2ConsultationFilterInput!, $videoLink1: String!, $limit8: Int, $offset8: Int, $order7: JSON, $textConversationId: String!) {
  getByTextConversationId(textConversationId: $textConversationId) {
    consultationAudit {
      consultTime
      consultType
      createdBy
      doctor {
        active
        bio {
          createdAt
          createdBy
          remark
          sysId
          translationKey
          updatedAt
          updatedBy
          valueEn
          valueJa
          valueZh
        }
        calendarId
        consultation(videoLink: $videoLink1) {
          gmeetLink
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            activeConsultation {
              consultationAudit {
                consultTime
                consultType
                createdBy
                evaluationId
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sessionType
                status
                sysId
              }
              consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                count
                items {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                limit
                offset
              }
              consultationTitle {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              countReminder
              createdAt
              doctor {
                active
                calendarId
                country
                designation
                duration
                email
                firstName
                fullName
                lastName
                patient(patientId: $patientId) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sysId
                textConsultPostalCodes
                trtEligible
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              messages {
                automatedMessage {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                consultationSysId
                content
                createdAt
                readAt
                sysId
                updatedAt
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              orderSysId
              participants {
                avatar
                fullName
                identity
                locale
                role
                token
                userSysId
              }
              participantsV2 {
                admin {
                  crossSellRecords(input: $input10) {
                    childOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    childOrderId
                    createdAt
                    createdBy
                    creator {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    parentOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    parentOrderId
                    priceId
                    selectedBy
                    stripeProductPrice {
                      importPriceId
                      isBundle
                      priceActive
                      priceBillingScheme
                      priceCreated
                      priceCurrency
                      priceDisplayId
                      priceFirstTimeAlternativePrice
                      priceFirstTimeTryingInMonths
                      priceId
                      priceLivemode
                      priceNickname
                      priceProduct
                      priceTaxBehavior
                      priceUnitAmount
                      priceUnitAmountDecimal
                      productActive
                      productDescription
                      productDisplayId
                      productId
                      productLivemode
                      productName
                      productStatementDescriptor
                      productType
                      productUniqName
                      productUnitLabel
                      sysId
                    }
                    sysId
                  }
                  order(orderId: $orderId2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId1) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId2
                  date: $date4
                  forDelivery: $forDelivery2
                  isReschedule: $isReschedule2
                  orderId: $orderId3
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId3
                  consultDate: $consultDate1
                  date: $date5
                  forDelivery: $forDelivery3
                  isReschedule: $isReschedule3
                  orderId: $orderId4
                ) {
                  time
                }
                consultation(input: $input16) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                    count
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    consultationMessages(
                      input: $input11
                      limit: $limit6
                      offset: $offset6
                      order: $order5
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input12, limit: $limit7, offset: $offset7, order: $order6) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput2) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput3) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input13, pagination: $pagination1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date6) {
                      date
                    }
                    partnerConsultTimes(date: $date7) {
                      time
                    }
                    patient(input: $input14) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input15) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          previewToken
          previewVideoLink
          status
          sysId
          token
          videoChannelId
          videoLink
          zoomJoinUrl
        }
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      evaluationId
      sessionType
      status
      sysId
    }
    consultationMessages(limit: $limit8, offset: $offset8, order: $order7) {
      count
      limit
      offset
    }
    consultationTitle {
      createdAt
      createdBy
      remark
      sysId
      translationKey
      updatedAt
      updatedBy
      valueEn
      valueJa
      valueZh
    }
    countReminder
    createdAt
    doctor {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    doctorChatToken
    doctorSysId
    friendlyName
    gmeetLink
    isActive
    isRead
    isVideoConsultRescheduled
    lastMsgSysId
    lastMsgUserId
    messages {
      consultationSysId
      content
      createdAt
      readAt
      sysId
      updatedAt
    }
    order {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    orderSysId
    participants {
      avatar
      fullName
      identity
      locale
      role
      token
      userSysId
    }
    participantsV2 {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      phoneNumber
      requireConfirmPolicy
      socialProviderType
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    patientChatToken
    patientEmail
    prescribedAt
    previewVideoLink
    progressStatus
    readAt
    reviewDate
    status
    sysId
    textConsultStatus
    textConversationId
    type
    updatedAt
    videoChannelId
    videoLink
  }
}
    `;
export const useGetByTextConversationIdQuery = <
      TData = GetByTextConversationIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetByTextConversationIdQueryVariables,
      options?: UseQueryOptions<GetByTextConversationIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetByTextConversationIdQuery, TError, TData>(
      ['getByTextConversationId', variables],
      fetcher<GetByTextConversationIdQuery, GetByTextConversationIdQueryVariables>(client, GetByTextConversationIdDocument, variables, headers),
      options
    );
export const GetCartDocument = `
    query getCart($input: GetCartInput!) {
  getCart(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary
    calculation
    cart
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    errorCode
    paidCompletedEvaluationIds
    platform
    promotionCode
    status
    sysId
  }
}
    `;
export const useGetCartQuery = <
      TData = GetCartQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCartQueryVariables,
      options?: UseQueryOptions<GetCartQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCartQuery, TError, TData>(
      ['getCart', variables],
      fetcher<GetCartQuery, GetCartQueryVariables>(client, GetCartDocument, variables, headers),
      options
    );
export const GetCartByIdDocument = `
    query getCartById($input: FilterByIdInput!) {
  getCartById(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary
    calculation
    cart
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    errorCode
    paidCompletedEvaluationIds
    platform
    promotionCode
    status
    sysId
  }
}
    `;
export const useGetCartByIdQuery = <
      TData = GetCartByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCartByIdQueryVariables,
      options?: UseQueryOptions<GetCartByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCartByIdQuery, TError, TData>(
      ['getCartById', variables],
      fetcher<GetCartByIdQuery, GetCartByIdQueryVariables>(client, GetCartByIdDocument, variables, headers),
      options
    );
export const GetCartsByFilterDocument = `
    query getCartsByFilter($input: FilterInput!) {
  getCartsByFilter(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary
    calculation
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    paidCompletedEvaluationIds
    patientId
    patientInfo
    platform
    promotionCode
    status
    sysId
  }
}
    `;
export const useGetCartsByFilterQuery = <
      TData = GetCartsByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCartsByFilterQueryVariables,
      options?: UseQueryOptions<GetCartsByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCartsByFilterQuery, TError, TData>(
      ['getCartsByFilter', variables],
      fetcher<GetCartsByFilterQuery, GetCartsByFilterQueryVariables>(client, GetCartsByFilterDocument, variables, headers),
      options
    );
export const GetCashbackAvailableBalanceDocument = `
    query getCashbackAvailableBalance {
  getCashbackAvailableBalance
}
    `;
export const useGetCashbackAvailableBalanceQuery = <
      TData = GetCashbackAvailableBalanceQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCashbackAvailableBalanceQueryVariables,
      options?: UseQueryOptions<GetCashbackAvailableBalanceQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCashbackAvailableBalanceQuery, TError, TData>(
      variables === undefined ? ['getCashbackAvailableBalance'] : ['getCashbackAvailableBalance', variables],
      fetcher<GetCashbackAvailableBalanceQuery, GetCashbackAvailableBalanceQueryVariables>(client, GetCashbackAvailableBalanceDocument, variables, headers),
      options
    );
export const GetCashbackDashboardDocument = `
    query getCashbackDashboard {
  getCashbackDashboard {
    availableBalance
    recentTransactions {
      amount
      cashbackType
      created
      credit_note
      currency
      customer
      description
      ending_balance
      id
      invoice
      livemode
      metadata
      object
      savingsToDate
      type
    }
    savingsToDateThisYear {
      amount
      cashbackType
      created
      credit_note
      currency
      customer
      description
      ending_balance
      id
      invoice
      livemode
      metadata
      object
      savingsToDate
      type
    }
  }
}
    `;
export const useGetCashbackDashboardQuery = <
      TData = GetCashbackDashboardQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCashbackDashboardQueryVariables,
      options?: UseQueryOptions<GetCashbackDashboardQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCashbackDashboardQuery, TError, TData>(
      variables === undefined ? ['getCashbackDashboard'] : ['getCashbackDashboard', variables],
      fetcher<GetCashbackDashboardQuery, GetCashbackDashboardQueryVariables>(client, GetCashbackDashboardDocument, variables, headers),
      options
    );
export const GetCheckoutCartByOrderIdDocument = `
    query getCheckoutCartByOrderId($orderId: String!) {
  getCheckoutCartByOrderId(orderId: $orderId) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    calculateOrderSummary {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      discountAmountLater
      discountAmountNow
      itemList {
        consultationSessionType
        isEDBundle
        isPayNow
        isRxProduct
        isSkipMedSelecting
        isSubscriptionPrice
        isSubscriptionUpdate
        itemSubTotal
        itemSubTotalAfterDiscount
        mainProductId
        mainProductName
        name
        priceId
        priceType
        productId
        productUniqName
        quantity
        unit_amount
      }
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountBeforeTax
      paymentIntentSummary
      promotionCode
      shippingFee
      subTotal
      subTotalLater
      subTotalNow
      taxes
      taxesLater
      taxesNow
      teleConsultFee
      total
      totalLater
      totalNow
      totalNowAfterCashback
      totalTaxes
    }
    cartItems
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    paidCompletedEvaluationIds
    patient {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
      weight
    }
    platform
    promotionCode
    sysId
  }
}
    `;
export const useGetCheckoutCartByOrderIdQuery = <
      TData = GetCheckoutCartByOrderIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCheckoutCartByOrderIdQueryVariables,
      options?: UseQueryOptions<GetCheckoutCartByOrderIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCheckoutCartByOrderIdQuery, TError, TData>(
      ['getCheckoutCartByOrderId', variables],
      fetcher<GetCheckoutCartByOrderIdQuery, GetCheckoutCartByOrderIdQueryVariables>(client, GetCheckoutCartByOrderIdDocument, variables, headers),
      options
    );
export const GetCompletedEvalByContinueTokenDocument = `
    query getCompletedEvalByContinueToken($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $input: FilterByContinueLaterTokenInput!) {
  getCompletedEvalByContinueToken(input: $input) {
    completed
    createdAt
    evaluationFormLastUpdated
    evaluationId
    formQandA
    jumpToSectionIndex
    oldPatientId
    patient
    patientId
    patientSnapshot {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    patientdoctorNotes
    questionTotal
    sectionHistory
    sectionIndex
    sectionTotal
    sysId
    updatedAt
    userId
    valid
  }
}
    `;
export const useGetCompletedEvalByContinueTokenQuery = <
      TData = GetCompletedEvalByContinueTokenQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCompletedEvalByContinueTokenQueryVariables,
      options?: UseQueryOptions<GetCompletedEvalByContinueTokenQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompletedEvalByContinueTokenQuery, TError, TData>(
      ['getCompletedEvalByContinueToken', variables],
      fetcher<GetCompletedEvalByContinueTokenQuery, GetCompletedEvalByContinueTokenQueryVariables>(client, GetCompletedEvalByContinueTokenDocument, variables, headers),
      options
    );
export const GetCompletedEvalByFilterDocument = `
    query getCompletedEvalByFilter($input: GetCompletedEvalByFilterInput!) {
  getCompletedEvalByFilter(input: $input) {
    evaluation {
      evaluationBlocks {
        blockByQuestion {
          evaluationQuestions {
            content {
              body {
                description
                descriptionTextKey
                title
                titleTextKey
              }
              footer {
                description
                descriptionTextKey
                title
                titleTextKey
              }
              header {
                description
                descriptionTextKey
                title
                titleTextKey
              }
            }
            dependentEvaluationQuestions {
              dependentQuestionAnswer {
                answer {
                  childrenAnswers {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    parentAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  deselectAll
                  mandatory
                  name
                  order
                  parentAnswer {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    parentAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  placeholder
                  productUrl
                  sysId
                  textKey
                  type
                }
                dependentEvaluationQuestions {
                  evaluationQuestion {
                    dependentEvaluationQuestions {
                      skipPage
                      skipQuestionCount
                      sysId
                    }
                    displayPage
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    guestOnly
                    order
                    question {
                      name
                      sysId
                      textKey
                      type
                    }
                    sysId
                    validation {
                      mandatory
                      max
                      min
                      preselect
                      type
                    }
                  }
                  skipPage
                  skipQuestionCount
                  sysId
                }
                evaluationBlocks {
                  content {
                    description
                    descriptionTextKey
                    title
                    titleTextKey
                  }
                  evaluation {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    learnMore {
                      link
                      value
                    }
                    name
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    platform
                    status
                    sysId
                    type
                  }
                  patientEvaluations {
                    consultType
                    currentQuestion {
                      name
                      sysId
                      textKey
                      type
                    }
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationBlock {
                      sysId
                    }
                    isCompleted
                    isSkipped
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    patientNote
                  }
                  questionAnswer {
                    answer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    dependentEvaluationQuestions {
                      skipPage
                      skipQuestionCount
                      sysId
                    }
                    evaluationBlocks {
                      sysId
                    }
                    patientQuestionAnswers {
                      type
                      value
                    }
                    question {
                      name
                      sysId
                      textKey
                      type
                    }
                    sysId
                  }
                  sysId
                }
                patientQuestionAnswers {
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  questionAnswer {
                    sysId
                  }
                  type
                  value
                }
                question {
                  evaluationQuestions {
                    displayPage
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    guestOnly
                    order
                    question {
                      name
                      sysId
                      textKey
                      type
                    }
                    sysId
                    validation {
                      mandatory
                      max
                      min
                      preselect
                      type
                    }
                  }
                  name
                  sysId
                  textKey
                  type
                }
                sysId
              }
              skipPage
              skipQuestionCount
              sysId
            }
            displayPage
            guestOnly
            order
            sysId
          }
          name
          sysId
          textKey
          type
        }
        sysId
      }
      name
      platform
      status
      sysId
      type
    }
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    patientNote
  }
}
    `;
export const useGetCompletedEvalByFilterQuery = <
      TData = GetCompletedEvalByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCompletedEvalByFilterQueryVariables,
      options?: UseQueryOptions<GetCompletedEvalByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompletedEvalByFilterQuery, TError, TData>(
      ['getCompletedEvalByFilter', variables],
      fetcher<GetCompletedEvalByFilterQuery, GetCompletedEvalByFilterQueryVariables>(client, GetCompletedEvalByFilterDocument, variables, headers),
      options
    );
export const GetCompletedEvaluationDocument = `
    query getCompletedEvaluation {
  getCompletedEvaluation {
    conditionEvaluations
    consultType
    evaluationBlocks {
      blockByQuestion {
        evaluationQuestions {
          content {
            body {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            footer {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            header {
              description
              descriptionTextKey
              title
              titleTextKey
            }
          }
          dependentEvaluationQuestions {
            dependentQuestionAnswer {
              answer {
                childrenAnswers {
                  childrenAnswers {
                    deselectAll
                    mandatory
                    name
                    order
                    parentAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  deselectAll
                  mandatory
                  name
                  order
                  placeholder
                  productUrl
                  sysId
                  textKey
                  type
                }
                deselectAll
                mandatory
                name
                order
                parentAnswer {
                  childrenAnswers {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  deselectAll
                  mandatory
                  name
                  order
                  parentAnswer {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  placeholder
                  productUrl
                  sysId
                  textKey
                  type
                }
                placeholder
                productUrl
                sysId
                textKey
                type
              }
              dependentEvaluationQuestions {
                evaluationQuestion {
                  dependentEvaluationQuestions {
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  displayPage
                  evaluation {
                    evaluationBlocks {
                      sysId
                    }
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    learnMore {
                      link
                      value
                    }
                    name
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    platform
                    status
                    sysId
                    type
                  }
                  guestOnly
                  order
                  question {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    name
                    sysId
                    textKey
                    type
                  }
                  sysId
                  validation {
                    mandatory
                    max
                    min
                    preselect
                    type
                  }
                }
                skipPage
                skipQuestionCount
                sysId
              }
              evaluationBlocks {
                content {
                  description
                  descriptionTextKey
                  title
                  titleTextKey
                }
                evaluation {
                  name
                  platform
                  status
                  sysId
                  type
                }
                patientEvaluations {
                  consultType
                  currentQuestion {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    name
                    sysId
                    textKey
                    type
                  }
                  evaluation {
                    name
                    platform
                    status
                    sysId
                    type
                  }
                  evaluationBlock {
                    blockByQuestion {
                      name
                      sysId
                      textKey
                      type
                    }
                    content {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    questionAnswer {
                      sysId
                    }
                    sysId
                  }
                  isCompleted
                  isSkipped
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  patientNote
                }
                questionAnswer {
                  answer {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  dependentEvaluationQuestions {
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  evaluationBlocks {
                    sysId
                  }
                  patientQuestionAnswers {
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    questionAnswer {
                      sysId
                    }
                    type
                    value
                  }
                  question {
                    name
                    sysId
                    textKey
                    type
                  }
                  sysId
                }
                sysId
              }
              patientQuestionAnswers {
                type
                value
              }
              question {
                name
                sysId
                textKey
                type
              }
              sysId
            }
            skipPage
            skipQuestionCount
            sysId
          }
          displayPage
          evaluation {
            name
            platform
            status
            sysId
            type
          }
          guestOnly
          order
          question {
            name
            sysId
            textKey
            type
          }
          sysId
          validation {
            mandatory
            max
            min
            preselect
            type
          }
        }
        name
        sysId
        textKey
        type
      }
      sysId
    }
    evaluationQuestions {
      displayPage
      guestOnly
      order
      sysId
    }
    learnMore {
      link
      value
    }
    name
    patientEvaluations {
      consultType
      isCompleted
      isSkipped
      patientNote
    }
    platform
    status
    sysId
    type
    validatePatientQuestionAnswer {
      patientQuestionAnswer {
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          locale
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          weight
        }
        questionAnswer {
          sysId
        }
        type
        value
      }
      validation {
        mandatory
        max
        min
        preselect
        type
      }
    }
  }
}
    `;
export const useGetCompletedEvaluationQuery = <
      TData = GetCompletedEvaluationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCompletedEvaluationQueryVariables,
      options?: UseQueryOptions<GetCompletedEvaluationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCompletedEvaluationQuery, TError, TData>(
      variables === undefined ? ['getCompletedEvaluation'] : ['getCompletedEvaluation', variables],
      fetcher<GetCompletedEvaluationQuery, GetCompletedEvaluationQueryVariables>(client, GetCompletedEvaluationDocument, variables, headers),
      options
    );
export const GetConfigEnvironmentDocument = `
    query getConfigEnvironment($input: PlatformEnvironmentInput!) {
  getConfigEnvironment(input: $input) {
    consultType
    country
    crossPlatformError {
      code
      currentPlatform
      message
      userPlatform
    }
    deliveryAmount
    evalIds
    evalsToShow
    metadataCountry
    pharmacistEmail
    platform
    pmetadataCountry
    pregnancyEvalQuestionIds
    productGroupIdsByEvaluationId
    referralProgram {
      referreeCouponCode
      referrerCouponCode
    }
    skipEvalAppointment
    stripeCurrencyRatio
    stripePriceType
    stripeProduct
    successPage
  }
}
    `;
export const useGetConfigEnvironmentQuery = <
      TData = GetConfigEnvironmentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetConfigEnvironmentQueryVariables,
      options?: UseQueryOptions<GetConfigEnvironmentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetConfigEnvironmentQuery, TError, TData>(
      ['getConfigEnvironment', variables],
      fetcher<GetConfigEnvironmentQuery, GetConfigEnvironmentQueryVariables>(client, GetConfigEnvironmentDocument, variables, headers),
      options
    );
export const GetConsultTextDataDocument = `
    query getConsultTextData($input: GetConsultTextDataInput!) {
  getConsultTextData(input: $input) {
    consultationSession {
      countReminder
      createdAt
      doctor {
        active
        calendarId
        country
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            billingAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            bloodPressure
            country
            createdAt
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            orders {
              acuityAppointmentSnapshot {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            user {
              avatar
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              requireConfirmPolicy
              socialProviderType
              sysId
              userType
              utmCampaign
              utmMedium
              utmSource
            }
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
      }
      doctorChatToken
      friendlyName
      gmeetLink
      order {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        address
        affiliateCoupon {
          affiliateProductSysId
          affiliateSysId
          anonymousId
          couponId
          createdAt
          opsNote
          orderSysId
          status
          sysId
          updatedAt
          verifiedAt
          verifiedByUserSysId
        }
        approveAt
        atomePaymentAmount
        auditDoctorNotes {
          createdAt
          createdBy
          deletedBy
          isDeleted
          note
          sysId
        }
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldOrder {
          id
          isCancelled
          priceId
          status
          subId
        }
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        patientSnapshot {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          locale
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          weight
        }
        paymentProvider
        phoneNumber
        pickupLocation {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        platformType
        prescribeAfterTeleConsult
        prescribedAfterTrialOrder {
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        prescription {
          cancelled
          createdAt
          days
          doctorNotes
          endDate
          expiresAt
          isFollowUp
          notedDate
          priceIds
          startDate
          status
          sysId
          treatmentCode
          updatedAt
        }
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productGroupData {
          acuitySchedulingAppType
          amountToFreeIncludedPrice
          chargeNowProduct
          country
          crossEvaluation
          displayId
          emailOnCompleteName
          emailTemplate
          evaluationFormId
          id
          includedPriceIds
          overwriteCalendarHeaderTitleInfo
          overwriteProductSubtitleInfo
          platform
          productGroups
          requiresDelivery
          requiresEvaluation
          requiresPrescription
          sysId
          title
        }
        productInfo {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        twilioMessageHistories {
          address
          email
          fullName
          message
          phoneNumber
        }
        updatedAt
      }
      patientChatToken
      status
      sysId
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    participants {
      avatar
      fullName
      identity
      locale
      role
      token
      userSysId
    }
    token
  }
}
    `;
export const useGetConsultTextDataQuery = <
      TData = GetConsultTextDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetConsultTextDataQueryVariables,
      options?: UseQueryOptions<GetConsultTextDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetConsultTextDataQuery, TError, TData>(
      ['getConsultTextData', variables],
      fetcher<GetConsultTextDataQuery, GetConsultTextDataQueryVariables>(client, GetConsultTextDataDocument, variables, headers),
      options
    );
export const GetConsultationSessionByFilterDocument = `
    query getConsultationSessionByFilter($input: GetConsultationByFilterInput!) {
  getConsultationSessionByFilter(input: $input) {
    consultationSessions {
      countReminder
      createdAt
      doctor {
        active
        calendarId
        country
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            billingAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            bloodPressure
            country
            createdAt
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            orders {
              acuityAppointmentSnapshot {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            user {
              avatar
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              requireConfirmPolicy
              socialProviderType
              sysId
              userType
              utmCampaign
              utmMedium
              utmSource
            }
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
      }
      doctorChatToken
      friendlyName
      gmeetLink
      order {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        address
        affiliateCoupon {
          affiliateProductSysId
          affiliateSysId
          anonymousId
          couponId
          createdAt
          opsNote
          orderSysId
          status
          sysId
          updatedAt
          verifiedAt
          verifiedByUserSysId
        }
        approveAt
        atomePaymentAmount
        auditDoctorNotes {
          createdAt
          createdBy
          deletedBy
          isDeleted
          note
          sysId
        }
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldOrder {
          id
          isCancelled
          priceId
          status
          subId
        }
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        patientSnapshot {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          locale
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          weight
        }
        paymentProvider
        phoneNumber
        pickupLocation {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        platformType
        prescribeAfterTeleConsult
        prescribedAfterTrialOrder {
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        prescription {
          cancelled
          createdAt
          days
          doctorNotes
          endDate
          expiresAt
          isFollowUp
          notedDate
          priceIds
          startDate
          status
          sysId
          treatmentCode
          updatedAt
        }
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productGroupData {
          acuitySchedulingAppType
          amountToFreeIncludedPrice
          chargeNowProduct
          country
          crossEvaluation
          displayId
          emailOnCompleteName
          emailTemplate
          evaluationFormId
          id
          includedPriceIds
          overwriteCalendarHeaderTitleInfo
          overwriteProductSubtitleInfo
          platform
          productGroups
          requiresDelivery
          requiresEvaluation
          requiresPrescription
          sysId
          title
        }
        productInfo {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        twilioMessageHistories {
          address
          email
          fullName
          message
          phoneNumber
        }
        updatedAt
      }
      patientChatToken
      status
      sysId
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    order {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    participants {
      avatar
      fullName
      identity
      locale
      role
      token
      userSysId
    }
    stripeProductPrice {
      drDosageFrequency {
        alternativeDosage
        alternativeDosageUnit
        asNeeded
        dosage
        dosageUnit
        duration
        durationUnit
        frequency
        productId
        quantity
        quantityUnit
      }
      importPriceId
      priceActive
      priceBillingScheme
      priceCreated
      priceCurrency
      priceDisplayId
      priceFirstTimeAlternativePrice
      priceFirstTimeTryingInMonths
      priceId
      priceLivemode
      priceMetadata
      priceNickname
      priceProduct
      priceRecurring
      priceTaxBehavior
      priceType
      priceUnitAmount
      priceUnitAmountDecimal
      productActive
      productCountry
      productDescription
      productDisplayId
      productEvaluationId {
        noah
        zoey
      }
      productId
      productImage
      productIncluded
      productIsShowOnShop {
        noah
        zoey
      }
      productLivemode
      productMetadata
      productName
      productPurchaseds
      productSecondIncluded
      productStatementDescriptor
      productType
      productUniqName
      productUnitLabel
      sysId
    }
    token
  }
}
    `;
export const useGetConsultationSessionByFilterQuery = <
      TData = GetConsultationSessionByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetConsultationSessionByFilterQueryVariables,
      options?: UseQueryOptions<GetConsultationSessionByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetConsultationSessionByFilterQuery, TError, TData>(
      ['getConsultationSessionByFilter', variables],
      fetcher<GetConsultationSessionByFilterQuery, GetConsultationSessionByFilterQueryVariables>(client, GetConsultationSessionByFilterDocument, variables, headers),
      options
    );
export const GetConsultationSessionByOrdersDocument = `
    query getConsultationSessionByOrders($input: GetConsultationByOrdersInput!) {
  getConsultationSessionByOrders(input: $input) {
    consultationSessions {
      countReminder
      createdAt
      doctor {
        active
        calendarId
        country
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            billingAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            bloodPressure
            country
            createdAt
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            orders {
              acuityAppointmentSnapshot {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            user {
              avatar
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              requireConfirmPolicy
              socialProviderType
              sysId
              userType
              utmCampaign
              utmMedium
              utmSource
            }
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
      }
      doctorChatToken
      friendlyName
      gmeetLink
      order {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        address
        affiliateCoupon {
          affiliateProductSysId
          affiliateSysId
          anonymousId
          couponId
          createdAt
          opsNote
          orderSysId
          status
          sysId
          updatedAt
          verifiedAt
          verifiedByUserSysId
        }
        approveAt
        atomePaymentAmount
        auditDoctorNotes {
          createdAt
          createdBy
          deletedBy
          isDeleted
          note
          sysId
        }
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldOrder {
          id
          isCancelled
          priceId
          status
          subId
        }
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        patientSnapshot {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          locale
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          weight
        }
        paymentProvider
        phoneNumber
        pickupLocation {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        platformType
        prescribeAfterTeleConsult
        prescribedAfterTrialOrder {
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        prescription {
          cancelled
          createdAt
          days
          doctorNotes
          endDate
          expiresAt
          isFollowUp
          notedDate
          priceIds
          startDate
          status
          sysId
          treatmentCode
          updatedAt
        }
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productGroupData {
          acuitySchedulingAppType
          amountToFreeIncludedPrice
          chargeNowProduct
          country
          crossEvaluation
          displayId
          emailOnCompleteName
          emailTemplate
          evaluationFormId
          id
          includedPriceIds
          overwriteCalendarHeaderTitleInfo
          overwriteProductSubtitleInfo
          platform
          productGroups
          requiresDelivery
          requiresEvaluation
          requiresPrescription
          sysId
          title
        }
        productInfo {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        twilioMessageHistories {
          address
          email
          fullName
          message
          phoneNumber
        }
        updatedAt
      }
      patientChatToken
      status
      sysId
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    order {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
  }
}
    `;
export const useGetConsultationSessionByOrdersQuery = <
      TData = GetConsultationSessionByOrdersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetConsultationSessionByOrdersQueryVariables,
      options?: UseQueryOptions<GetConsultationSessionByOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetConsultationSessionByOrdersQuery, TError, TData>(
      ['getConsultationSessionByOrders', variables],
      fetcher<GetConsultationSessionByOrdersQuery, GetConsultationSessionByOrdersQueryVariables>(client, GetConsultationSessionByOrdersDocument, variables, headers),
      options
    );
export const GetConsultationVideoByOrderIdDocument = `
    query getConsultationVideoByOrderId($videoLink: String!, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation1: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit: Float, $offset: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink1: String!, $previewVideoLink: String!, $limit1: Int, $offset1: Int, $order: JSON, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $platform1: String, $input8: StripeProductFilterV2, $input9: CrossSellRecordQueryInput, $orderId2: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $patientId: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit4: Int, $offset4: Int, $order3: JSON, $input10: V2ConsultationFilterInput!, $input11: ConsultationMessagesInput!, $limit5: Int, $offset5: Int, $order4: JSON, $limit6: Int, $offset6: Int, $order5: JSON, $input12: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId1: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput1: ConsultationAuditFilterInput, $inputConsultation2: V2ConsultationFilterInput, $input13: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input14: GetPatientInput, $platform2: String, $platform3: String, $input15: StripeProductFilterV2, $input16: GetByOrderSysId!) {
  getConsultationVideoByOrderId(input: $input16) {
    countReminder
    createdAt
    doctor {
      active
      calendarId
      country
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        patient {
          billingAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          bloodPressure
          country
          createdAt
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          locale
          orders {
            acuityAppointmentSnapshot {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  orders {
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          user {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            requireConfirmPolicy
            socialProviderType
            sysId
            userType
            utmCampaign
            utmMedium
            utmSource
          }
          weight
        }
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
    }
    doctorChatToken
    friendlyName
    gmeetLink
    order {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliate {
          enabled
          name
          portalUrl
          region
          slug
          sysId
        }
        affiliateProduct {
          affiliate {
            enabled
            name
            portalUrl
            region
            slug
            sysId
          }
          affiliateSysId
          couponLandingUrl
          createdAt
          discountPercentage
          displayName
          enabled
          evalFlow
          externalPortalUrl
          slug
          stripePriceId
          stripeProductId
          stripePromotionCode
          stripePromotionCodeId
          sysId
          unitAmount
          updatedAt
        }
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        doctor {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        isDeleted
        note
        order {
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldOrder {
            id
            isCancelled
            priceId
            status
            subId
          }
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          patientSnapshot {
            billingAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            bloodPressure
            country
            createdAt
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            orders {
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            user {
              avatar
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              requireConfirmPolicy
              socialProviderType
              sysId
              userType
              utmCampaign
              utmMedium
              utmSource
            }
            weight
          }
          paymentProvider
          phoneNumber
          pickupLocation {
            address
            area {
              areaChildren {
                areaChildren {
                  areaName
                  areaParent {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaType
                  pickupLocations {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  sysId
                }
                areaName
                areaType
                sysId
              }
              areaName
              areaParent {
                areaName
                areaType
                sysId
              }
              areaType
              pickupLocations {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              sysId
            }
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            orders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationAudit {
                  consultTime
                  consultType
                  createdBy
                  doctor {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  evaluationId
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  patient {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit, offset: $offset, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    userSysId
                    videoConsultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sessionType
                  status
                  sysId
                }
                consultationMessages(limit: $limit1, offset: $offset1, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input8) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input9) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input10) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input11
                    limit: $limit5
                    offset: $offset5
                    order: $order4
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input12, limit: $limit7, offset: $offset7, order: $order6) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit6, offset: $offset6, order: $order5) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink2) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input13, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input14) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input15) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform3)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productGroupData {
            acuitySchedulingAppType
            amountToFreeIncludedPrice
            chargeNowProduct
            country
            crossEvaluation
            displayId
            emailOnCompleteName
            emailTemplate
            evaluationFormId
            id
            includedPriceIds
            orders {
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            overwriteCalendarHeaderTitleInfo
            overwriteProductSubtitleInfo
            platform
            productGroups
            requiresDelivery
            requiresEvaluation
            requiresPrescription
            sysId
            title
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          twilioMessageHistories {
            address
            email
            fullName
            message
            phoneNumber
          }
          updatedAt
        }
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    patientChatToken
    status
    sysId
    textConversationId
    type
    updatedAt
    videoChannelId
    videoLink
  }
}
    `;
export const useGetConsultationVideoByOrderIdQuery = <
      TData = GetConsultationVideoByOrderIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetConsultationVideoByOrderIdQueryVariables,
      options?: UseQueryOptions<GetConsultationVideoByOrderIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetConsultationVideoByOrderIdQuery, TError, TData>(
      ['getConsultationVideoByOrderId', variables],
      fetcher<GetConsultationVideoByOrderIdQuery, GetConsultationVideoByOrderIdQueryVariables>(client, GetConsultationVideoByOrderIdDocument, variables, headers),
      options
    );
export const GetContinueTrialOrderDataDocument = `
    query getContinueTrialOrderData($input: ContinueTrialOrderInput!) {
  getContinueTrialOrderData(input: $input) {
    order {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      id
      livemode
      locale
      metadata
      nickname
      product
      recurring {
        aggregate_usage
        interval
        interval_count
        trial_period_days
        usage_type
      }
      stripeProduct
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    product {
      active
      childrenIncludedProduct {
        active
        childrenIncludedProduct {
          active
          childrenSecondIncludedProduct {
            active
            childrenIncludedProduct {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              id
              image {
                noahVertical
                noahWide
                sysId
                zoeyVertical
                zoeyWide
              }
              includedProduct {
                active
                childrenIncludedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                childrenSecondIncludedProduct {
                  active
                  childrenSecondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                country
                createdAt
                description
                displayId
                evaluationId
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
  }
}
    `;
export const useGetContinueTrialOrderDataQuery = <
      TData = GetContinueTrialOrderDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetContinueTrialOrderDataQueryVariables,
      options?: UseQueryOptions<GetContinueTrialOrderDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetContinueTrialOrderDataQuery, TError, TData>(
      ['getContinueTrialOrderData', variables],
      fetcher<GetContinueTrialOrderDataQuery, GetContinueTrialOrderDataQueryVariables>(client, GetContinueTrialOrderDataDocument, variables, headers),
      options
    );
export const GetCronjobsByFilterDocument = `
    query getCronjobsByFilter($input: GetCronjobInput!, $limit: Int, $offset: Int, $order: JSON) {
  getCronjobsByFilter(
    input: $input
    limit: $limit
    offset: $offset
    order: $order
  ) {
    count
    items {
      createdAt
      createdBy
      description
      isActive
      name
      updatedAt
      updatedBy
    }
    limit
    offset
  }
}
    `;
export const useGetCronjobsByFilterQuery = <
      TData = GetCronjobsByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCronjobsByFilterQueryVariables,
      options?: UseQueryOptions<GetCronjobsByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCronjobsByFilterQuery, TError, TData>(
      ['getCronjobsByFilter', variables],
      fetcher<GetCronjobsByFilterQuery, GetCronjobsByFilterQueryVariables>(client, GetCronjobsByFilterDocument, variables, headers),
      options
    );
export const GetCurrentPatientOnboardingDocument = `
    query getCurrentPatientOnboarding($input: GetCurrentPatientOnboardingInput!) {
  getCurrentPatientOnboarding(input: $input) {
    currentStep
    patientId
    skipGuide
    status
    sysId
    tourName
  }
}
    `;
export const useGetCurrentPatientOnboardingQuery = <
      TData = GetCurrentPatientOnboardingQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCurrentPatientOnboardingQueryVariables,
      options?: UseQueryOptions<GetCurrentPatientOnboardingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCurrentPatientOnboardingQuery, TError, TData>(
      ['getCurrentPatientOnboarding', variables],
      fetcher<GetCurrentPatientOnboardingQuery, GetCurrentPatientOnboardingQueryVariables>(client, GetCurrentPatientOnboardingDocument, variables, headers),
      options
    );
export const GetDeliveryOrderByFilterDocument = `
    query getDeliveryOrderByFilter($input: DeliveryOrderFilterInput!, $limit: Int, $offset: Int, $order: JSON) {
  getDeliveryOrderByFilter(
    input: $input
    limit: $limit
    offset: $offset
    order: $order
  ) {
    count
    items {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    limit
    offset
  }
}
    `;
export const useGetDeliveryOrderByFilterQuery = <
      TData = GetDeliveryOrderByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDeliveryOrderByFilterQueryVariables,
      options?: UseQueryOptions<GetDeliveryOrderByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDeliveryOrderByFilterQuery, TError, TData>(
      ['getDeliveryOrderByFilter', variables],
      fetcher<GetDeliveryOrderByFilterQuery, GetDeliveryOrderByFilterQueryVariables>(client, GetDeliveryOrderByFilterDocument, variables, headers),
      options
    );
export const GetDispatchJobByFilterDocument = `
    query getDispatchJobByFilter($input: DispatchJobFilterInput!) {
  getDispatchJobByFilter(input: $input) {
    collectionSnapshot
    deliverySnapshot
    orderId
    sysId
  }
}
    `;
export const useGetDispatchJobByFilterQuery = <
      TData = GetDispatchJobByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDispatchJobByFilterQueryVariables,
      options?: UseQueryOptions<GetDispatchJobByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDispatchJobByFilterQuery, TError, TData>(
      ['getDispatchJobByFilter', variables],
      fetcher<GetDispatchJobByFilterQuery, GetDispatchJobByFilterQueryVariables>(client, GetDispatchJobByFilterDocument, variables, headers),
      options
    );
export const GetDoctorDashboardOrdersByFilterDocument = `
    query getDoctorDashboardOrdersByFilter($input: OrderFilterForDoctorDashboardInput!, $limit: Int, $offset: Int, $order: JSON) {
  getDoctorDashboardOrdersByFilter(
    input: $input
    limit: $limit
    offset: $offset
    order: $order
  ) {
    consultationSessions {
      countReminder
      createdAt
      doctor {
        active
        calendarId
        country
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            billingAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            bloodPressure
            country
            createdAt
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            orders {
              acuityAppointmentSnapshot {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            user {
              avatar
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              requireConfirmPolicy
              socialProviderType
              sysId
              userType
              utmCampaign
              utmMedium
              utmSource
            }
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
      }
      doctorChatToken
      friendlyName
      gmeetLink
      order {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        address
        affiliateCoupon {
          affiliateProductSysId
          affiliateSysId
          anonymousId
          couponId
          createdAt
          opsNote
          orderSysId
          status
          sysId
          updatedAt
          verifiedAt
          verifiedByUserSysId
        }
        approveAt
        atomePaymentAmount
        auditDoctorNotes {
          createdAt
          createdBy
          deletedBy
          isDeleted
          note
          sysId
        }
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldOrder {
          id
          isCancelled
          priceId
          status
          subId
        }
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        patientSnapshot {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          locale
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          weight
        }
        paymentProvider
        phoneNumber
        pickupLocation {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        platformType
        prescribeAfterTeleConsult
        prescribedAfterTrialOrder {
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        prescription {
          cancelled
          createdAt
          days
          doctorNotes
          endDate
          expiresAt
          isFollowUp
          notedDate
          priceIds
          startDate
          status
          sysId
          treatmentCode
          updatedAt
        }
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productGroupData {
          acuitySchedulingAppType
          amountToFreeIncludedPrice
          chargeNowProduct
          country
          crossEvaluation
          displayId
          emailOnCompleteName
          emailTemplate
          evaluationFormId
          id
          includedPriceIds
          overwriteCalendarHeaderTitleInfo
          overwriteProductSubtitleInfo
          platform
          productGroups
          requiresDelivery
          requiresEvaluation
          requiresPrescription
          sysId
          title
        }
        productInfo {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        twilioMessageHistories {
          address
          email
          fullName
          message
          phoneNumber
        }
        updatedAt
      }
      patientChatToken
      status
      sysId
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    orders
  }
}
    `;
export const useGetDoctorDashboardOrdersByFilterQuery = <
      TData = GetDoctorDashboardOrdersByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDoctorDashboardOrdersByFilterQueryVariables,
      options?: UseQueryOptions<GetDoctorDashboardOrdersByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDoctorDashboardOrdersByFilterQuery, TError, TData>(
      ['getDoctorDashboardOrdersByFilter', variables],
      fetcher<GetDoctorDashboardOrdersByFilterQuery, GetDoctorDashboardOrdersByFilterQueryVariables>(client, GetDoctorDashboardOrdersByFilterDocument, variables, headers),
      options
    );
export const GetDoctorInAuthDocument = `
    query getDoctorInAuth {
  getDoctorInAuth {
    active
    calendarId
    country
    duration
    email
    firstName
    fullName
    lastName
    sysId
    textConsultPostalCodes
    trtEligible
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useGetDoctorInAuthQuery = <
      TData = GetDoctorInAuthQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetDoctorInAuthQueryVariables,
      options?: UseQueryOptions<GetDoctorInAuthQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDoctorInAuthQuery, TError, TData>(
      variables === undefined ? ['getDoctorInAuth'] : ['getDoctorInAuth', variables],
      fetcher<GetDoctorInAuthQuery, GetDoctorInAuthQueryVariables>(client, GetDoctorInAuthDocument, variables, headers),
      options
    );
export const GetDoctorOrdersDocument = `
    query getDoctorOrders($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $country: String, $dateSearch: String, $limit: Int, $offset: Int, $order: JSON, $patientIds: [String!], $statuses: [String!], $today: Boolean) {
  getDoctorOrders(
    country: $country
    dateSearch: $dateSearch
    limit: $limit
    offset: $offset
    order: $order
    patientIds: $patientIds
    statuses: $statuses
    today: $today
  ) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useGetDoctorOrdersQuery = <
      TData = GetDoctorOrdersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetDoctorOrdersQueryVariables,
      options?: UseQueryOptions<GetDoctorOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDoctorOrdersQuery, TError, TData>(
      variables === undefined ? ['getDoctorOrders'] : ['getDoctorOrders', variables],
      fetcher<GetDoctorOrdersQuery, GetDoctorOrdersQueryVariables>(client, GetDoctorOrdersDocument, variables, headers),
      options
    );
export const GetDoctorsByFilterDocument = `
    query getDoctorsByFilter($input: FilterDoctorInput!, $limit: Int, $offset: Int, $order: JSON) {
  getDoctorsByFilter(input: $input, limit: $limit, offset: $offset, order: $order) {
    active
    calendarId
    country
    duration
    email
    firstName
    fullName
    lastName
    sysId
    textConsultPostalCodes
    trtEligible
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useGetDoctorsByFilterQuery = <
      TData = GetDoctorsByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDoctorsByFilterQueryVariables,
      options?: UseQueryOptions<GetDoctorsByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDoctorsByFilterQuery, TError, TData>(
      ['getDoctorsByFilter', variables],
      fetcher<GetDoctorsByFilterQuery, GetDoctorsByFilterQueryVariables>(client, GetDoctorsByFilterDocument, variables, headers),
      options
    );
export const GetDoctorsWithAppointmentTypeDocument = `
    query getDoctorsWithAppointmentType($input: DoctorsWithAppointmentTypeInput!) {
  getDoctorsWithAppointmentType(input: $input) {
    active
    calendarId
    country
    duration
    email
    firstName
    fullName
    lastName
    sysId
    textConsultPostalCodes
    trtEligible
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
  }
}
    `;
export const useGetDoctorsWithAppointmentTypeQuery = <
      TData = GetDoctorsWithAppointmentTypeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDoctorsWithAppointmentTypeQueryVariables,
      options?: UseQueryOptions<GetDoctorsWithAppointmentTypeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDoctorsWithAppointmentTypeQuery, TError, TData>(
      ['getDoctorsWithAppointmentType', variables],
      fetcher<GetDoctorsWithAppointmentTypeQuery, GetDoctorsWithAppointmentTypeQueryVariables>(client, GetDoctorsWithAppointmentTypeDocument, variables, headers),
      options
    );
export const GetEvaluationByFilterDocument = `
    query getEvaluationByFilter($input: EvaluationInput!) {
  getEvaluationByFilter(input: $input) {
    evaluationBlocks {
      blockByQuestion {
        evaluationQuestions {
          content {
            body {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            footer {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            header {
              description
              descriptionTextKey
              title
              titleTextKey
            }
          }
          dependentEvaluationQuestions {
            dependentQuestionAnswer {
              answer {
                childrenAnswers {
                  childrenAnswers {
                    deselectAll
                    mandatory
                    name
                    order
                    parentAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  deselectAll
                  mandatory
                  name
                  order
                  placeholder
                  productUrl
                  sysId
                  textKey
                  type
                }
                deselectAll
                mandatory
                name
                order
                parentAnswer {
                  childrenAnswers {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  deselectAll
                  mandatory
                  name
                  order
                  parentAnswer {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  placeholder
                  productUrl
                  sysId
                  textKey
                  type
                }
                placeholder
                productUrl
                sysId
                textKey
                type
              }
              dependentEvaluationQuestions {
                evaluationQuestion {
                  dependentEvaluationQuestions {
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  displayPage
                  evaluation {
                    evaluationBlocks {
                      sysId
                    }
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    learnMore {
                      link
                      value
                    }
                    name
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    platform
                    status
                    sysId
                    type
                  }
                  guestOnly
                  order
                  question {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    name
                    sysId
                    textKey
                    type
                  }
                  sysId
                  validation {
                    mandatory
                    max
                    min
                    preselect
                    type
                  }
                }
                skipPage
                skipQuestionCount
                sysId
              }
              evaluationBlocks {
                content {
                  description
                  descriptionTextKey
                  title
                  titleTextKey
                }
                evaluation {
                  name
                  platform
                  status
                  sysId
                  type
                }
                patientEvaluations {
                  consultType
                  currentQuestion {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    name
                    sysId
                    textKey
                    type
                  }
                  evaluation {
                    name
                    platform
                    status
                    sysId
                    type
                  }
                  evaluationBlock {
                    blockByQuestion {
                      name
                      sysId
                      textKey
                      type
                    }
                    content {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    questionAnswer {
                      sysId
                    }
                    sysId
                  }
                  isCompleted
                  isSkipped
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  patientNote
                }
                questionAnswer {
                  answer {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  dependentEvaluationQuestions {
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  evaluationBlocks {
                    sysId
                  }
                  patientQuestionAnswers {
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    questionAnswer {
                      sysId
                    }
                    type
                    value
                  }
                  question {
                    name
                    sysId
                    textKey
                    type
                  }
                  sysId
                }
                sysId
              }
              patientQuestionAnswers {
                type
                value
              }
              question {
                name
                sysId
                textKey
                type
              }
              sysId
            }
            skipPage
            skipQuestionCount
            sysId
          }
          displayPage
          evaluation {
            name
            platform
            status
            sysId
            type
          }
          guestOnly
          order
          question {
            name
            sysId
            textKey
            type
          }
          sysId
          validation {
            mandatory
            max
            min
            preselect
            type
          }
        }
        name
        sysId
        textKey
        type
      }
      sysId
    }
    evaluationQuestions {
      displayPage
      guestOnly
      order
      sysId
    }
    learnMore {
      link
      value
    }
    name
    patientEvaluations {
      consultType
      isCompleted
      isSkipped
      patientNote
    }
    platform
    status
    sysId
    type
  }
}
    `;
export const useGetEvaluationByFilterQuery = <
      TData = GetEvaluationByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEvaluationByFilterQueryVariables,
      options?: UseQueryOptions<GetEvaluationByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEvaluationByFilterQuery, TError, TData>(
      ['getEvaluationByFilter', variables],
      fetcher<GetEvaluationByFilterQuery, GetEvaluationByFilterQueryVariables>(client, GetEvaluationByFilterDocument, variables, headers),
      options
    );
export const GetEvaluationByOrdersDocument = `
    query getEvaluationByOrders($input: GetEvaluationByOrderInput!) {
  getEvaluationByOrders(input: $input) {
    orderId
    patientNote
    patientQuestionAnswers
  }
}
    `;
export const useGetEvaluationByOrdersQuery = <
      TData = GetEvaluationByOrdersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEvaluationByOrdersQueryVariables,
      options?: UseQueryOptions<GetEvaluationByOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEvaluationByOrdersQuery, TError, TData>(
      ['getEvaluationByOrders', variables],
      fetcher<GetEvaluationByOrdersQuery, GetEvaluationByOrdersQueryVariables>(client, GetEvaluationByOrdersDocument, variables, headers),
      options
    );
export const GetEvaluationDashboardDocument = `
    query getEvaluationDashboard($input: GetEvaluationDashboardInput!) {
  getEvaluationDashboard(input: $input) {
    currentPatientEvaluation {
      consultType
      currentQuestion {
        evaluationQuestions {
          content {
            body {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            footer {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            header {
              description
              descriptionTextKey
              title
              titleTextKey
            }
          }
          dependentEvaluationQuestions {
            dependentQuestionAnswer {
              answer {
                childrenAnswers {
                  childrenAnswers {
                    deselectAll
                    mandatory
                    name
                    order
                    parentAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  deselectAll
                  mandatory
                  name
                  order
                  placeholder
                  productUrl
                  sysId
                  textKey
                  type
                }
                deselectAll
                mandatory
                name
                order
                parentAnswer {
                  childrenAnswers {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  deselectAll
                  mandatory
                  name
                  order
                  parentAnswer {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  placeholder
                  productUrl
                  sysId
                  textKey
                  type
                }
                placeholder
                productUrl
                sysId
                textKey
                type
              }
              dependentEvaluationQuestions {
                evaluationQuestion {
                  dependentEvaluationQuestions {
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  displayPage
                  evaluation {
                    evaluationBlocks {
                      sysId
                    }
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    learnMore {
                      link
                      value
                    }
                    name
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    platform
                    status
                    sysId
                    type
                  }
                  guestOnly
                  order
                  question {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    name
                    sysId
                    textKey
                    type
                  }
                  sysId
                  validation {
                    mandatory
                    max
                    min
                    preselect
                    type
                  }
                }
                skipPage
                skipQuestionCount
                sysId
              }
              evaluationBlocks {
                blockByQuestion {
                  evaluationQuestions {
                    displayPage
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    guestOnly
                    order
                    question {
                      name
                      sysId
                      textKey
                      type
                    }
                    sysId
                    validation {
                      mandatory
                      max
                      min
                      preselect
                      type
                    }
                  }
                  name
                  sysId
                  textKey
                  type
                }
                content {
                  description
                  descriptionTextKey
                  title
                  titleTextKey
                }
                evaluation {
                  name
                  platform
                  status
                  sysId
                  type
                }
                patientEvaluations {
                  consultType
                  currentQuestion {
                    name
                    sysId
                    textKey
                    type
                  }
                  evaluation {
                    name
                    platform
                    status
                    sysId
                    type
                  }
                  evaluationBlock {
                    blockByQuestion {
                      name
                      sysId
                      textKey
                      type
                    }
                    content {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    questionAnswer {
                      sysId
                    }
                    sysId
                  }
                  isCompleted
                  isSkipped
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  patientNote
                }
                questionAnswer {
                  answer {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  dependentEvaluationQuestions {
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  evaluationBlocks {
                    sysId
                  }
                  patientQuestionAnswers {
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    questionAnswer {
                      sysId
                    }
                    type
                    value
                  }
                  question {
                    name
                    sysId
                    textKey
                    type
                  }
                  sysId
                }
                sysId
              }
              patientQuestionAnswers {
                type
                value
              }
              question {
                name
                sysId
                textKey
                type
              }
              sysId
            }
            skipPage
            skipQuestionCount
            sysId
          }
          displayPage
          guestOnly
          order
          sysId
        }
        name
        sysId
        textKey
        type
      }
      evaluation {
        name
        platform
        status
        sysId
        type
      }
      evaluationBlock {
        sysId
      }
      isCompleted
      isSkipped
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      patientNote
    }
    evaluation {
      name
      platform
      status
      sysId
      type
    }
    evaluationQuestions {
      answers
      content
      dependentEvaluationQuestions
      displayPage
      evaluationBlocks
      guestOnly
      order
      question
      sysId
      validation
    }
    patientEvaluations
    patientQuestionAnswers
  }
}
    `;
export const useGetEvaluationDashboardQuery = <
      TData = GetEvaluationDashboardQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEvaluationDashboardQueryVariables,
      options?: UseQueryOptions<GetEvaluationDashboardQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEvaluationDashboardQuery, TError, TData>(
      ['getEvaluationDashboard', variables],
      fetcher<GetEvaluationDashboardQuery, GetEvaluationDashboardQueryVariables>(client, GetEvaluationDashboardDocument, variables, headers),
      options
    );
export const GetEvaluationFormByFilterDocument = `
    query getEvaluationFormByFilter($input: EvaluationFormInput!) {
  getEvaluationFormByFilter(input: $input) {
    createdAt
    customFields
    description
    disabled
    formSections
    id
    learnMoreLink
    onCompleteRedirect
    sysId
    title
    total
    updatedAt
    version
  }
}
    `;
export const useGetEvaluationFormByFilterQuery = <
      TData = GetEvaluationFormByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEvaluationFormByFilterQueryVariables,
      options?: UseQueryOptions<GetEvaluationFormByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetEvaluationFormByFilterQuery, TError, TData>(
      ['getEvaluationFormByFilter', variables],
      fetcher<GetEvaluationFormByFilterQuery, GetEvaluationFormByFilterQueryVariables>(client, GetEvaluationFormByFilterDocument, variables, headers),
      options
    );
export const GetExcludedEvalIdsForShowingTreatmentDocument = `
    query getExcludedEvalIdsForShowingTreatment($input: ExcludedEvalInput!) {
  getExcludedEvalIdsForShowingTreatment(input: $input)
}
    `;
export const useGetExcludedEvalIdsForShowingTreatmentQuery = <
      TData = GetExcludedEvalIdsForShowingTreatmentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetExcludedEvalIdsForShowingTreatmentQueryVariables,
      options?: UseQueryOptions<GetExcludedEvalIdsForShowingTreatmentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetExcludedEvalIdsForShowingTreatmentQuery, TError, TData>(
      ['getExcludedEvalIdsForShowingTreatment', variables],
      fetcher<GetExcludedEvalIdsForShowingTreatmentQuery, GetExcludedEvalIdsForShowingTreatmentQueryVariables>(client, GetExcludedEvalIdsForShowingTreatmentDocument, variables, headers),
      options
    );
export const GetExcludedEvaluationIdsDocument = `
    query getExcludedEvaluationIds($input: ExcludedEvaluationIdsInput!) {
  getExcludedEvaluationIds(input: $input)
}
    `;
export const useGetExcludedEvaluationIdsQuery = <
      TData = GetExcludedEvaluationIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetExcludedEvaluationIdsQueryVariables,
      options?: UseQueryOptions<GetExcludedEvaluationIdsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetExcludedEvaluationIdsQuery, TError, TData>(
      ['getExcludedEvaluationIds', variables],
      fetcher<GetExcludedEvaluationIdsQuery, GetExcludedEvaluationIdsQueryVariables>(client, GetExcludedEvaluationIdsDocument, variables, headers),
      options
    );
export const GetExtraInfoForEditingOrderDocument = `
    query getExtraInfoForEditingOrder($input: GetExtraInfoOrderDetailInput!) {
  getExtraInfoForEditingOrder(input: $input) {
    availableProductSelectableList {
      products {
        active
        childrenIncludedProduct {
          active
          childrenIncludedProduct {
            active
            childrenSecondIncludedProduct {
              active
              childrenIncludedProduct {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  childrenIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              country
              createdAt
              description
              displayId
              evaluationId
              id
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        childrenSecondIncludedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        image {
          noahVertical
          noahWide
          sysId
          zoeyVertical
          zoeyWide
        }
        includedProduct {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        secondIncludedProduct {
          active
          childrenIncludedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          childrenSecondIncludedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          secondIncludedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      title
    }
    checkProductsExistingOrdersForPatient {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    consultationSession {
      countReminder
      createdAt
      doctor {
        active
        calendarId
        country
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
      }
      doctorChatToken
      friendlyName
      gmeetLink
      order {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      patientChatToken
      status
      sysId
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    doctorNotes {
      approved
      approver {
        name
        role
      }
      condition
      doctor {
        active
        calendarId
        country
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      dosage
      evaluationId
      notes {
        createdAt
        createdBy
        deletedBy
        doctor {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        isDeleted
        note
        order {
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        sysId
      }
      orderSysId
      stripePrices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        id
        livemode
        locale
        metadata
        nickname
        product
        recurring {
          aggregate_usage
          interval
          interval_count
          trial_period_days
          usage_type
        }
        stripeProduct
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
    }
    evalPatientQuestionAnswers
    evaluation {
      createdAt
      customFields
      description
      disabled
      formSections
      id
      learnMoreLink
      onCompleteRedirect
      sysId
      title
      total
      updatedAt
      version
    }
    evaluationQuestions {
      content {
        body {
          description
          descriptionTextKey
          title
          titleTextKey
        }
        footer {
          description
          descriptionTextKey
          title
          titleTextKey
        }
        header {
          description
          descriptionTextKey
          title
          titleTextKey
        }
      }
      dependentEvaluationQuestions {
        dependentQuestionAnswer {
          answer {
            childrenAnswers {
              childrenAnswers {
                deselectAll
                mandatory
                name
                order
                parentAnswer {
                  childrenAnswers {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  deselectAll
                  mandatory
                  name
                  order
                  parentAnswer {
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  placeholder
                  productUrl
                  sysId
                  textKey
                  type
                }
                placeholder
                productUrl
                sysId
                textKey
                type
              }
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            parentAnswer {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          dependentEvaluationQuestions {
            evaluationQuestion {
              dependentEvaluationQuestions {
                skipPage
                skipQuestionCount
                sysId
              }
              displayPage
              evaluation {
                evaluationBlocks {
                  blockByQuestion {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    name
                    sysId
                    textKey
                    type
                  }
                  content {
                    description
                    descriptionTextKey
                    title
                    titleTextKey
                  }
                  evaluation {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    learnMore {
                      link
                      value
                    }
                    name
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    platform
                    status
                    sysId
                    type
                  }
                  patientEvaluations {
                    consultType
                    currentQuestion {
                      name
                      sysId
                      textKey
                      type
                    }
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationBlock {
                      sysId
                    }
                    isCompleted
                    isSkipped
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    patientNote
                  }
                  questionAnswer {
                    answer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    dependentEvaluationQuestions {
                      skipPage
                      skipQuestionCount
                      sysId
                    }
                    evaluationBlocks {
                      sysId
                    }
                    patientQuestionAnswers {
                      type
                      value
                    }
                    question {
                      name
                      sysId
                      textKey
                      type
                    }
                    sysId
                  }
                  sysId
                }
                name
                platform
                status
                sysId
                type
              }
              guestOnly
              order
              question {
                evaluationQuestions {
                  displayPage
                  evaluation {
                    name
                    platform
                    status
                    sysId
                    type
                  }
                  guestOnly
                  order
                  question {
                    name
                    sysId
                    textKey
                    type
                  }
                  sysId
                  validation {
                    mandatory
                    max
                    min
                    preselect
                    type
                  }
                }
                name
                sysId
                textKey
                type
              }
              sysId
              validation {
                mandatory
                max
                min
                preselect
                type
              }
            }
            skipPage
            skipQuestionCount
            sysId
          }
          evaluationBlocks {
            sysId
          }
          patientQuestionAnswers {
            patient {
              bloodPressure
              country
              createdAt
              dob
              email
              fbc
              fbp
              firstName
              fromPlatformEnv
              fullName
              gender
              height
              icNumber
              identification
              isAlreadyCheckout
              isReferredBy
              lastName
              locale
              paidCompletedEvaluationIds
              phoneNumber
              referralCode
              stripeCustomer
              stripeCustomerId
              sysId
              weight
            }
            questionAnswer {
              sysId
            }
            type
            value
          }
          question {
            name
            sysId
            textKey
            type
          }
          sysId
        }
        skipPage
        skipQuestionCount
        sysId
      }
      displayPage
      evaluation
      guestOnly
      order
      question
      sysId
    }
    orderProduct {
      active
      childrenIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    patientProduct {
      active
      childrenIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prices {
      data {
        active
        billing_scheme
        created
        currency
        id
        livemode
        lookup_key
        metadata
        nickname
        object
        product
        recurring
        tax_behavior
        tiers
        tiers_mode
        transform_quantity
        type
        unit_amount
        unit_amount_decimal
      }
    }
    stripeProducts {
      active
      childrenIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
  }
}
    `;
export const useGetExtraInfoForEditingOrderQuery = <
      TData = GetExtraInfoForEditingOrderQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetExtraInfoForEditingOrderQueryVariables,
      options?: UseQueryOptions<GetExtraInfoForEditingOrderQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetExtraInfoForEditingOrderQuery, TError, TData>(
      ['getExtraInfoForEditingOrder', variables],
      fetcher<GetExtraInfoForEditingOrderQuery, GetExtraInfoForEditingOrderQueryVariables>(client, GetExtraInfoForEditingOrderDocument, variables, headers),
      options
    );
export const GetExtraProductPriceInfoByEvaluationDocument = `
    query getExtraProductPriceInfoByEvaluation($input: GetExtraProductPriceInfoByEvaluationInput!) {
  getExtraProductPriceInfoByEvaluation(input: $input) {
    stripeProductPrices {
      active
      childrenIncludedProduct {
        active
        childrenIncludedProduct {
          active
          childrenSecondIncludedProduct {
            active
            childrenIncludedProduct {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              id
              image {
                noahVertical
                noahWide
                sysId
                zoeyVertical
                zoeyWide
              }
              includedProduct {
                active
                childrenIncludedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                childrenSecondIncludedProduct {
                  active
                  childrenSecondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                country
                createdAt
                description
                displayId
                evaluationId
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      dosageAnswer
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isConsultOnly
      isFixedDose
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      isTextConsult
      livemode
      locale
      metadata
      name
      popularPriceId
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      shouldChargeNow
      shouldHideEditFreq
      shouldShowConsultFee
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    suggestTreatments
  }
}
    `;
export const useGetExtraProductPriceInfoByEvaluationQuery = <
      TData = GetExtraProductPriceInfoByEvaluationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetExtraProductPriceInfoByEvaluationQueryVariables,
      options?: UseQueryOptions<GetExtraProductPriceInfoByEvaluationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetExtraProductPriceInfoByEvaluationQuery, TError, TData>(
      ['getExtraProductPriceInfoByEvaluation', variables],
      fetcher<GetExtraProductPriceInfoByEvaluationQuery, GetExtraProductPriceInfoByEvaluationQueryVariables>(client, GetExtraProductPriceInfoByEvaluationDocument, variables, headers),
      options
    );
export const GetGiveAwayByFilterDocument = `
    query getGiveAwayByFilter($input: GiveAwayFilterInput!) {
  getGiveAwayByFilter(input: $input) {
    address
    answer
    cartId
    choice
    createdAt
    email
    eventPeriod
    moneySpent
    orderId
    patientId
    phone
  }
}
    `;
export const useGetGiveAwayByFilterQuery = <
      TData = GetGiveAwayByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetGiveAwayByFilterQueryVariables,
      options?: UseQueryOptions<GetGiveAwayByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetGiveAwayByFilterQuery, TError, TData>(
      ['getGiveAwayByFilter', variables],
      fetcher<GetGiveAwayByFilterQuery, GetGiveAwayByFilterQueryVariables>(client, GetGiveAwayByFilterDocument, variables, headers),
      options
    );
export const GetImagesByFilterDocument = `
    query getImagesByFilter($input: ImageInput!, $limit: Int, $offset: Int, $order: JSON) {
  getImagesByFilter(input: $input, limit: $limit, offset: $offset, order: $order) {
    noahVertical
    noahWide
    sysId
    zoeyVertical
    zoeyWide
  }
}
    `;
export const useGetImagesByFilterQuery = <
      TData = GetImagesByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetImagesByFilterQueryVariables,
      options?: UseQueryOptions<GetImagesByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetImagesByFilterQuery, TError, TData>(
      ['getImagesByFilter', variables],
      fetcher<GetImagesByFilterQuery, GetImagesByFilterQueryVariables>(client, GetImagesByFilterDocument, variables, headers),
      options
    );
export const GetInvoicesBySubscriptionIdDocument = `
    query getInvoicesBySubscriptionId($subscriptionId: String!) {
  getInvoicesBySubscriptionId(subscriptionId: $subscriptionId) {
    data {
      auto_advance
      charge
      collection_method
      created
      currency
      description
      hosted_invoice_url
      id
      lines
      metadata
      next_payment_attempt
      payment_intent
      period_end
      period_start
      status
      subscription
      total
    }
    has_more
    lastResponse
    url
  }
}
    `;
export const useGetInvoicesBySubscriptionIdQuery = <
      TData = GetInvoicesBySubscriptionIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetInvoicesBySubscriptionIdQueryVariables,
      options?: UseQueryOptions<GetInvoicesBySubscriptionIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvoicesBySubscriptionIdQuery, TError, TData>(
      ['getInvoicesBySubscriptionId', variables],
      fetcher<GetInvoicesBySubscriptionIdQuery, GetInvoicesBySubscriptionIdQueryVariables>(client, GetInvoicesBySubscriptionIdDocument, variables, headers),
      options
    );
export const GetLabelFromDetrackDocument = `
    query getLabelFromDetrack($input: ExportLableInput!) {
  getLabelFromDetrack(input: $input)
}
    `;
export const useGetLabelFromDetrackQuery = <
      TData = GetLabelFromDetrackQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetLabelFromDetrackQueryVariables,
      options?: UseQueryOptions<GetLabelFromDetrackQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetLabelFromDetrackQuery, TError, TData>(
      ['getLabelFromDetrack', variables],
      fetcher<GetLabelFromDetrackQuery, GetLabelFromDetrackQueryVariables>(client, GetLabelFromDetrackDocument, variables, headers),
      options
    );
export const GetLastTreatmentOrderDocument = `
    query getLastTreatmentOrder($input: LastTreatmentOrderInput!) {
  getLastTreatmentOrder(input: $input) {
    order {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
  }
}
    `;
export const useGetLastTreatmentOrderQuery = <
      TData = GetLastTreatmentOrderQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetLastTreatmentOrderQueryVariables,
      options?: UseQueryOptions<GetLastTreatmentOrderQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetLastTreatmentOrderQuery, TError, TData>(
      ['getLastTreatmentOrder', variables],
      fetcher<GetLastTreatmentOrderQuery, GetLastTreatmentOrderQueryVariables>(client, GetLastTreatmentOrderDocument, variables, headers),
      options
    );
export const GetListOrderConsultationByFilterDocument = `
    query getListOrderConsultationByFilter($input: OrderFilterForOpsConsultationsInput!, $limit: Int, $offset: Int, $order: JSON) {
  getListOrderConsultationByFilter(
    input: $input
    limit: $limit
    offset: $offset
    order: $order
  ) {
    count
    items {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    limit
    offset
  }
}
    `;
export const useGetListOrderConsultationByFilterQuery = <
      TData = GetListOrderConsultationByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetListOrderConsultationByFilterQueryVariables,
      options?: UseQueryOptions<GetListOrderConsultationByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetListOrderConsultationByFilterQuery, TError, TData>(
      ['getListOrderConsultationByFilter', variables],
      fetcher<GetListOrderConsultationByFilterQuery, GetListOrderConsultationByFilterQueryVariables>(client, GetListOrderConsultationByFilterDocument, variables, headers),
      options
    );
export const GetListPatientSuggestionByDoctorDocument = `
    query getListPatientSuggestionByDoctor($input: DocPatientSuggestionByDoctorInput!) {
  getListPatientSuggestionByDoctor(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useGetListPatientSuggestionByDoctorQuery = <
      TData = GetListPatientSuggestionByDoctorQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetListPatientSuggestionByDoctorQueryVariables,
      options?: UseQueryOptions<GetListPatientSuggestionByDoctorQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetListPatientSuggestionByDoctorQuery, TError, TData>(
      ['getListPatientSuggestionByDoctor', variables],
      fetcher<GetListPatientSuggestionByDoctorQuery, GetListPatientSuggestionByDoctorQueryVariables>(client, GetListPatientSuggestionByDoctorDocument, variables, headers),
      options
    );
export const GetOpsConvertedOrdersDocument = `
    query getOpsConvertedOrders($filter: OpsConvertedOrdersFilterInput!) {
  getOpsConvertedOrders(filter: $filter) {
    convertedCount
    items {
      approveAt
      converted
      createdAt
      currency
      initialTotal
      lastPaymentDate
      shortId
      status
      sysId
      utmCampaign
      utmMedium
      utmSource
    }
    limit
    offset
    total
  }
}
    `;
export const useGetOpsConvertedOrdersQuery = <
      TData = GetOpsConvertedOrdersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOpsConvertedOrdersQueryVariables,
      options?: UseQueryOptions<GetOpsConvertedOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOpsConvertedOrdersQuery, TError, TData>(
      ['getOpsConvertedOrders', variables],
      fetcher<GetOpsConvertedOrdersQuery, GetOpsConvertedOrdersQueryVariables>(client, GetOpsConvertedOrdersDocument, variables, headers),
      options
    );
export const GetOpsConvertedOrdersUtmSourcesDocument = `
    query getOpsConvertedOrdersUtmSources {
  getOpsConvertedOrdersUtmSources
}
    `;
export const useGetOpsConvertedOrdersUtmSourcesQuery = <
      TData = GetOpsConvertedOrdersUtmSourcesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetOpsConvertedOrdersUtmSourcesQueryVariables,
      options?: UseQueryOptions<GetOpsConvertedOrdersUtmSourcesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOpsConvertedOrdersUtmSourcesQuery, TError, TData>(
      variables === undefined ? ['getOpsConvertedOrdersUtmSources'] : ['getOpsConvertedOrdersUtmSources', variables],
      fetcher<GetOpsConvertedOrdersUtmSourcesQuery, GetOpsConvertedOrdersUtmSourcesQueryVariables>(client, GetOpsConvertedOrdersUtmSourcesDocument, variables, headers),
      options
    );
export const GetOpsDashboardOrderListByFilterV2Document = `
    query getOpsDashboardOrderListByFilterV2($input: OrderFilterForOpsDashboardInput!, $limit: Int, $offset: Int, $order: JSON) {
  getOpsDashboardOrderListByFilterV2(
    input: $input
    limit: $limit
    offset: $offset
    order: $order
  ) {
    count
    items {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isRenewalSubscription
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isSuitableForWeightLoss
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      parentOrderShortId
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      paymentStatus
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      price {
        drDosageFrequency {
          alternativeDosage
          alternativeDosageUnit
          asNeeded
          dosage
          dosageUnit
          duration
          durationUnit
          frequency
          productId
          quantity
          quantityUnit
        }
        importPriceId
        priceActive
        priceBillingScheme
        priceCreated
        priceCurrency
        priceDisplayId
        priceFirstTimeAlternativePrice
        priceFirstTimeTryingInMonths
        priceId
        priceLivemode
        priceMetadata
        priceNickname
        priceProduct
        priceRecurring
        priceTaxBehavior
        priceType
        priceUnitAmount
        priceUnitAmountDecimal
        productActive
        productCountry
        productDescription
        productDisplayId
        productEvaluationId {
          noah
          zoey
        }
        productId
        productImage
        productIncluded
        productIsShowOnShop {
          noah
          zoey
        }
        productLivemode
        productMetadata
        productName
        productPurchaseds
        productSecondIncluded
        productStatementDescriptor
        productType
        productUniqName
        productUnitLabel
        sysId
      }
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      retentionPromo {
        code
        expiresAt
        giftDescription
        redeemedAt
        region
        status
        sysId
      }
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      subscription {
        cancel_at_period_end
        current_period_end
        current_period_start
        customer
        default_payment_method
        id
        items
        latest_invoice
        metadata
        pause_collection
        pending_setup_intent
        pending_update
        plan
        status
      }
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    limit
    offset
  }
}
    `;
export const useGetOpsDashboardOrderListByFilterV2Query = <
      TData = GetOpsDashboardOrderListByFilterV2Query,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOpsDashboardOrderListByFilterV2QueryVariables,
      options?: UseQueryOptions<GetOpsDashboardOrderListByFilterV2Query, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOpsDashboardOrderListByFilterV2Query, TError, TData>(
      ['getOpsDashboardOrderListByFilterV2', variables],
      fetcher<GetOpsDashboardOrderListByFilterV2Query, GetOpsDashboardOrderListByFilterV2QueryVariables>(client, GetOpsDashboardOrderListByFilterV2Document, variables, headers),
      options
    );
export const GetOpsOrderDetailDocument = `
    query getOpsOrderDetail($orderId: String!) {
  getOpsOrderDetail(orderId: $orderId) {
    appointmentTypeID
    atomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    doctorNotes {
      approved
      approver {
        name
        role
      }
      condition
      doctor {
        active
        calendarId
        country
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            billingAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            bloodPressure
            country
            createdAt
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            orders {
              acuityAppointmentSnapshot {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            user {
              avatar
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              requireConfirmPolicy
              socialProviderType
              sysId
              userType
              utmCampaign
              utmMedium
              utmSource
            }
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
      }
      dosage
      evaluationId
      notes {
        createdAt
        createdBy
        deletedBy
        doctor {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        isDeleted
        note
        order {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          address
          affiliateCoupon {
            affiliateProductSysId
            affiliateSysId
            anonymousId
            couponId
            createdAt
            opsNote
            orderSysId
            status
            sysId
            updatedAt
            verifiedAt
            verifiedByUserSysId
          }
          approveAt
          atomePaymentAmount
          auditDoctorNotes {
            createdAt
            createdBy
            deletedBy
            isDeleted
            note
            sysId
          }
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldOrder {
            id
            isCancelled
            priceId
            status
            subId
          }
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          patientSnapshot {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            weight
          }
          paymentProvider
          phoneNumber
          pickupLocation {
            address
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          platformType
          prescribeAfterTeleConsult
          prescribedAfterTrialOrder {
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          prescription {
            cancelled
            createdAt
            days
            doctorNotes
            endDate
            expiresAt
            isFollowUp
            notedDate
            priceIds
            startDate
            status
            sysId
            treatmentCode
            updatedAt
          }
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productGroupData {
            acuitySchedulingAppType
            amountToFreeIncludedPrice
            chargeNowProduct
            country
            crossEvaluation
            displayId
            emailOnCompleteName
            emailTemplate
            evaluationFormId
            id
            includedPriceIds
            overwriteCalendarHeaderTitleInfo
            overwriteProductSubtitleInfo
            platform
            productGroups
            requiresDelivery
            requiresEvaluation
            requiresPrescription
            sysId
            title
          }
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          twilioMessageHistories {
            address
            email
            fullName
            message
            phoneNumber
          }
          updatedAt
        }
        sysId
      }
      orderSysId
      stripePrices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        id
        livemode
        locale
        metadata
        nickname
        product
        recurring {
          aggregate_usage
          interval
          interval_count
          trial_period_days
          usage_type
        }
        stripeProduct
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
    }
    doctors {
      active
      calendarId
      country
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
    }
    invoices {
      auto_advance
      charge
      collection_method
      created
      currency
      description
      hosted_invoice_url
      id
      lines
      metadata
      next_payment_attempt
      payment_intent
      period_end
      period_start
      status
      subscription
      total
    }
    needFollowUpConsultAfterRenewing
    order
    orderStripeProductPrice {
      drDosageFrequency {
        alternativeDosage
        alternativeDosageUnit
        asNeeded
        dosage
        dosageUnit
        duration
        durationUnit
        frequency
        productId
        quantity
        quantityUnit
      }
      importPriceId
      priceActive
      priceBillingScheme
      priceCreated
      priceCurrency
      priceDisplayId
      priceFirstTimeAlternativePrice
      priceFirstTimeTryingInMonths
      priceId
      priceLivemode
      priceMetadata
      priceNickname
      priceProduct
      priceRecurring
      priceTaxBehavior
      priceType
      priceUnitAmount
      priceUnitAmountDecimal
      productActive
      productCountry
      productDescription
      productDisplayId
      productEvaluationId {
        noah
        zoey
      }
      productId
      productImage
      productIncluded
      productIsShowOnShop {
        noah
        zoey
      }
      productLivemode
      productMetadata
      productName
      productPurchaseds
      productSecondIncluded
      productStatementDescriptor
      productType
      productUniqName
      productUnitLabel
      sysId
    }
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    prescriptionPrices {
      data {
        active
        billing_scheme
        created
        currency
        id
        livemode
        lookup_key
        metadata
        nickname
        object
        product
        recurring
        tax_behavior
        tiers
        tiers_mode
        transform_quantity
        type
        unit_amount
        unit_amount_decimal
      }
    }
    prescriptionProduct {
      active
      childrenIncludedProduct {
        active
        childrenIncludedProduct {
          active
          childrenSecondIncludedProduct {
            active
            childrenIncludedProduct {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              id
              image {
                noahVertical
                noahWide
                sysId
                zoeyVertical
                zoeyWide
              }
              includedProduct {
                active
                childrenIncludedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                childrenSecondIncludedProduct {
                  active
                  childrenSecondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                country
                createdAt
                description
                displayId
                evaluationId
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    prices {
      drDosageFrequency {
        alternativeDosage
        alternativeDosageUnit
        asNeeded
        dosage
        dosageUnit
        duration
        durationUnit
        frequency
        productId
        quantity
        quantityUnit
      }
      importPriceId
      priceActive
      priceBillingScheme
      priceCreated
      priceCurrency
      priceDisplayId
      priceFirstTimeAlternativePrice
      priceFirstTimeTryingInMonths
      priceId
      priceLivemode
      priceMetadata
      priceNickname
      priceProduct
      priceRecurring
      priceTaxBehavior
      priceType
      priceUnitAmount
      priceUnitAmountDecimal
      productActive
      productCountry
      productDescription
      productDisplayId
      productEvaluationId {
        noah
        zoey
      }
      productId
      productImage
      productIncluded
      productIsShowOnShop {
        noah
        zoey
      }
      productLivemode
      productMetadata
      productName
      productPurchaseds
      productSecondIncluded
      productStatementDescriptor
      productType
      productUniqName
      productUnitLabel
      sysId
    }
    productGroup {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      orders {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    retentionPromo {
      code
      expiresAt
      giftDescription
      redeemedAt
      region
      status
      sysId
    }
    stripeProducts {
      active
      childrenIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      customer
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      plan
      status
    }
  }
}
    `;
export const useGetOpsOrderDetailQuery = <
      TData = GetOpsOrderDetailQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOpsOrderDetailQueryVariables,
      options?: UseQueryOptions<GetOpsOrderDetailQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOpsOrderDetailQuery, TError, TData>(
      ['getOpsOrderDetail', variables],
      fetcher<GetOpsOrderDetailQuery, GetOpsOrderDetailQueryVariables>(client, GetOpsOrderDetailDocument, variables, headers),
      options
    );
export const GetOrderByFilterDocument = `
    query getOrderByFilter($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: OrderFilterInput!, $limit: Int, $offset: Int, $order: JSON) {
  getOrderByFilter(input: $input, limit: $limit, offset: $offset, order: $order) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useGetOrderByFilterQuery = <
      TData = GetOrderByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrderByFilterQueryVariables,
      options?: UseQueryOptions<GetOrderByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrderByFilterQuery, TError, TData>(
      ['getOrderByFilter', variables],
      fetcher<GetOrderByFilterQuery, GetOrderByFilterQueryVariables>(client, GetOrderByFilterDocument, variables, headers),
      options
    );
export const GetOrderByIdDocument = `
    query getOrderById($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $id: String!) {
  getOrderById(id: $id) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useGetOrderByIdQuery = <
      TData = GetOrderByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrderByIdQueryVariables,
      options?: UseQueryOptions<GetOrderByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrderByIdQuery, TError, TData>(
      ['getOrderById', variables],
      fetcher<GetOrderByIdQuery, GetOrderByIdQueryVariables>(client, GetOrderByIdDocument, variables, headers),
      options
    );
export const GetOrderByIdWithDisplayIdDocument = `
    query getOrderByIdWithDisplayId($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $id: String!) {
  getOrderByIdWithDisplayId(id: $id) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useGetOrderByIdWithDisplayIdQuery = <
      TData = GetOrderByIdWithDisplayIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrderByIdWithDisplayIdQueryVariables,
      options?: UseQueryOptions<GetOrderByIdWithDisplayIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrderByIdWithDisplayIdQuery, TError, TData>(
      ['getOrderByIdWithDisplayId', variables],
      fetcher<GetOrderByIdWithDisplayIdQuery, GetOrderByIdWithDisplayIdQueryVariables>(client, GetOrderByIdWithDisplayIdDocument, variables, headers),
      options
    );
export const GetOrderByProductDocument = `
    query getOrderByProduct($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: StripeProductInput!) {
  getOrderByProduct(input: $input) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useGetOrderByProductQuery = <
      TData = GetOrderByProductQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrderByProductQueryVariables,
      options?: UseQueryOptions<GetOrderByProductQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrderByProductQuery, TError, TData>(
      ['getOrderByProduct', variables],
      fetcher<GetOrderByProductQuery, GetOrderByProductQueryVariables>(client, GetOrderByProductDocument, variables, headers),
      options
    );
export const GetOrderDetailWithPatientDocument = `
    query getOrderDetailWithPatient($input: GetOrderWithPatientDetail!) {
  getOrderDetailWithPatient(input: $input) {
    affiliateCoupon {
      affiliate {
        enabled
        name
        portalUrl
        region
        slug
        sysId
      }
      affiliateProduct {
        affiliate {
          enabled
          name
          portalUrl
          region
          slug
          sysId
        }
        affiliateSysId
        couponLandingUrl
        createdAt
        discountPercentage
        displayName
        enabled
        evalFlow
        externalPortalUrl
        slug
        stripePriceId
        stripeProductId
        stripePromotionCode
        stripePromotionCodeId
        sysId
        unitAmount
        updatedAt
      }
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    order {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
  }
}
    `;
export const useGetOrderDetailWithPatientQuery = <
      TData = GetOrderDetailWithPatientQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrderDetailWithPatientQueryVariables,
      options?: UseQueryOptions<GetOrderDetailWithPatientQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrderDetailWithPatientQuery, TError, TData>(
      ['getOrderDetailWithPatient', variables],
      fetcher<GetOrderDetailWithPatientQuery, GetOrderDetailWithPatientQueryVariables>(client, GetOrderDetailWithPatientDocument, variables, headers),
      options
    );
export const GetPatientBookingInfoDocument = `
    query getPatientBookingInfo($input: PatientBookingInput!) {
  getPatientBookingInfo(input: $input) {
    bookingOrder {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      availableSlots {
        date
        times
      }
      completedEvaluation
      consultationSession {
        countReminder
        createdAt
        doctor {
          active
          calendarId
          country
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
          user {
            avatar
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            patient {
              bloodPressure
              country
              createdAt
              dob
              email
              fbc
              fbp
              firstName
              fromPlatformEnv
              fullName
              gender
              height
              icNumber
              identification
              isAlreadyCheckout
              isReferredBy
              lastName
              locale
              paidCompletedEvaluationIds
              phoneNumber
              referralCode
              stripeCustomer
              stripeCustomerId
              sysId
              weight
            }
            requireConfirmPolicy
            socialProviderType
            sysId
            userType
            utmCampaign
            utmMedium
            utmSource
          }
        }
        doctorChatToken
        friendlyName
        gmeetLink
        order {
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patientChatToken
        status
        sysId
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderFromNewPrescriptionFlow
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      needsBooking
      needsBookingDelivery
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    cart {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      calculateOrderSummary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        discountAmountLater
        discountAmountNow
        itemList {
          consultationSessionType
          isEDBundle
          isPayNow
          isRxProduct
          isSkipMedSelecting
          isSubscriptionPrice
          isSubscriptionUpdate
          itemSubTotal
          itemSubTotalAfterDiscount
          mainProductId
          mainProductName
          name
          priceId
          priceType
          productId
          productUniqName
          quantity
          unit_amount
        }
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountBeforeTax
        paymentIntentSummary
        promotionCode
        shippingFee
        subTotal
        subTotalLater
        subTotalNow
        taxes
        taxesLater
        taxesNow
        teleConsultFee
        total
        totalLater
        totalNow
        totalNowAfterCashback
        totalTaxes
      }
      cartItems
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      paidCompletedEvaluationIds
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      platform
      promotionCode
      sysId
    }
    needsBookingOrderIds
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    totalBookingOrderIds
  }
}
    `;
export const useGetPatientBookingInfoQuery = <
      TData = GetPatientBookingInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientBookingInfoQueryVariables,
      options?: UseQueryOptions<GetPatientBookingInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientBookingInfoQuery, TError, TData>(
      ['getPatientBookingInfo', variables],
      fetcher<GetPatientBookingInfoQuery, GetPatientBookingInfoQueryVariables>(client, GetPatientBookingInfoDocument, variables, headers),
      options
    );
export const GetPatientByFilterDocument = `
    query getPatientByFilter($input: PatientFilterInput!) {
  getPatientByFilter(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useGetPatientByFilterQuery = <
      TData = GetPatientByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientByFilterQueryVariables,
      options?: UseQueryOptions<GetPatientByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientByFilterQuery, TError, TData>(
      ['getPatientByFilter', variables],
      fetcher<GetPatientByFilterQuery, GetPatientByFilterQueryVariables>(client, GetPatientByFilterDocument, variables, headers),
      options
    );
export const GetPatientByIdDocument = `
    query getPatientById($input: PatientFilterInput!) {
  getPatientById(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useGetPatientByIdQuery = <
      TData = GetPatientByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientByIdQueryVariables,
      options?: UseQueryOptions<GetPatientByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientByIdQuery, TError, TData>(
      ['getPatientById', variables],
      fetcher<GetPatientByIdQuery, GetPatientByIdQueryVariables>(client, GetPatientByIdDocument, variables, headers),
      options
    );
export const GetPatientByIdsDocument = `
    query getPatientByIds($input: PatientFilterByIdsInput!) {
  getPatientByIds(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useGetPatientByIdsQuery = <
      TData = GetPatientByIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientByIdsQueryVariables,
      options?: UseQueryOptions<GetPatientByIdsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientByIdsQuery, TError, TData>(
      ['getPatientByIds', variables],
      fetcher<GetPatientByIdsQuery, GetPatientByIdsQueryVariables>(client, GetPatientByIdsDocument, variables, headers),
      options
    );
export const GetPatientByReferralCodeDocument = `
    query getPatientByReferralCode($input: PatientByReferralCodeInput!) {
  getPatientByReferralCode(input: $input) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useGetPatientByReferralCodeQuery = <
      TData = GetPatientByReferralCodeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientByReferralCodeQueryVariables,
      options?: UseQueryOptions<GetPatientByReferralCodeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientByReferralCodeQuery, TError, TData>(
      ['getPatientByReferralCode', variables],
      fetcher<GetPatientByReferralCodeQuery, GetPatientByReferralCodeQueryVariables>(client, GetPatientByReferralCodeDocument, variables, headers),
      options
    );
export const GetPatientDataDocument = `
    query getPatientData($input: PatientDashboardInput!) {
  getPatientData(input: $input) {
    activeProductIds {
      activeProducts
      completedEvalIds
      pendingEvalIds
      skippedEvalIds
    }
    bannerProducts {
      active
      childrenIncludedProduct {
        active
        childrenIncludedProduct {
          active
          childrenSecondIncludedProduct {
            active
            childrenIncludedProduct {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              id
              image {
                noahVertical
                noahWide
                sysId
                zoeyVertical
                zoeyWide
              }
              includedProduct {
                active
                childrenIncludedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                childrenSecondIncludedProduct {
                  active
                  childrenSecondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                country
                createdAt
                description
                displayId
                evaluationId
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    cart {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      calculateOrderSummary
      calculation
      cart
      cartItems
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      errorCode
      paidCompletedEvaluationIds
      platform
      promotionCode
      status
      sysId
    }
    cashbackDashboard {
      availableBalance
      recentTransactions {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
      savingsToDateThisYear {
        amount
        cashbackType
        created
        credit_note
        currency
        customer
        description
        ending_balance
        id
        invoice
        livemode
        metadata
        object
        savingsToDate
        type
      }
    }
    completedEvals {
      evaluation {
        evaluationBlocks {
          blockByQuestion {
            evaluationQuestions {
              content {
                body {
                  description
                  descriptionTextKey
                  title
                  titleTextKey
                }
                footer {
                  description
                  descriptionTextKey
                  title
                  titleTextKey
                }
                header {
                  description
                  descriptionTextKey
                  title
                  titleTextKey
                }
              }
              dependentEvaluationQuestions {
                dependentQuestionAnswer {
                  answer {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    parentAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  dependentEvaluationQuestions {
                    evaluationQuestion {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  evaluationBlocks {
                    content {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    questionAnswer {
                      sysId
                    }
                    sysId
                  }
                  patientQuestionAnswers {
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    questionAnswer {
                      sysId
                    }
                    type
                    value
                  }
                  question {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    name
                    sysId
                    textKey
                    type
                  }
                  sysId
                }
                skipPage
                skipQuestionCount
                sysId
              }
              displayPage
              evaluation {
                evaluationQuestions {
                  displayPage
                  guestOnly
                  order
                  question {
                    name
                    sysId
                    textKey
                    type
                  }
                  sysId
                  validation {
                    mandatory
                    max
                    min
                    preselect
                    type
                  }
                }
                learnMore {
                  link
                  value
                }
                name
                patientEvaluations {
                  consultType
                  currentQuestion {
                    evaluationQuestions {
                      displayPage
                      guestOnly
                      order
                      sysId
                    }
                    name
                    sysId
                    textKey
                    type
                  }
                  evaluation {
                    name
                    platform
                    status
                    sysId
                    type
                  }
                  evaluationBlock {
                    blockByQuestion {
                      name
                      sysId
                      textKey
                      type
                    }
                    content {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    evaluation {
                      name
                      platform
                      status
                      sysId
                      type
                    }
                    patientEvaluations {
                      consultType
                      isCompleted
                      isSkipped
                      patientNote
                    }
                    questionAnswer {
                      sysId
                    }
                    sysId
                  }
                  isCompleted
                  isSkipped
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  patientNote
                }
                platform
                status
                sysId
                type
              }
              guestOnly
              order
              sysId
            }
            name
            sysId
            textKey
            type
          }
          sysId
        }
        name
        platform
        status
        sysId
        type
      }
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      patientNote
    }
    consultationSessions
    notificationOrders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      canEditDeliveryTime {
        canEdit
        isEditWithin2Hours
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    patientCodeData {
      active
      code
      coupon {
        amount_off
        applies_to
        created
        currency
        duration
        duration_in_months
        id
        livemode
        max_redemptions
        metadata
        name
        object
        percent_off
        promotionCodes {
          active
          code
          coupon {
            amount_off
            applies_to
            created
            currency
            duration
            duration_in_months
            id
            livemode
            max_redemptions
            metadata
            name
            object
            percent_off
            redeem_by
            times_redeemed
            valid
          }
          created
          customer
          expires_at
          id
          livemode
          max_redemptions
          metadata
          object
          restrictions
          times_redeemed
        }
        redeem_by
        times_redeemed
        valid
      }
      created
      customer
      expires_at
      id
      livemode
      max_redemptions
      metadata
      object
      restrictions
      times_redeemed
    }
    shoppingExcludedEvalIds
    stripeProducts {
      active
      childrenIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    suggestionProducts {
      active
      childrenIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    teleConsultOrders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    tour {
      currentStep
      patientId
      skipGuide
      status
      sysId
      tourName
    }
    treatmentExcludedEvalIds
  }
}
    `;
export const useGetPatientDataQuery = <
      TData = GetPatientDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientDataQueryVariables,
      options?: UseQueryOptions<GetPatientDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientDataQuery, TError, TData>(
      ['getPatientData', variables],
      fetcher<GetPatientDataQuery, GetPatientDataQueryVariables>(client, GetPatientDataDocument, variables, headers),
      options
    );
export const GetPatientInfoDocument = `
    query getPatientInfo {
  getPatientInfo {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useGetPatientInfoQuery = <
      TData = GetPatientInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetPatientInfoQueryVariables,
      options?: UseQueryOptions<GetPatientInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientInfoQuery, TError, TData>(
      variables === undefined ? ['getPatientInfo'] : ['getPatientInfo', variables],
      fetcher<GetPatientInfoQuery, GetPatientInfoQueryVariables>(client, GetPatientInfoDocument, variables, headers),
      options
    );
export const GetPatientListForDoctorDocument = `
    query getPatientListForDoctor($country: String!, $limit: Float!, $offset: Float!) {
  getPatientListForDoctor(country: $country, limit: $limit, offset: $offset) {
    billingAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    bloodPressure
    country
    createdAt
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    dob
    email
    fbc
    fbp
    firstName
    fromPlatformEnv
    fullName
    gender
    height
    icNumber
    identification
    isAlreadyCheckout
    isReferredBy
    lastName
    locale
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    paidCompletedEvaluationIds
    phoneNumber
    referralCode
    stripeCustomer
    stripeCustomerId
    sysId
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    weight
  }
}
    `;
export const useGetPatientListForDoctorQuery = <
      TData = GetPatientListForDoctorQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientListForDoctorQueryVariables,
      options?: UseQueryOptions<GetPatientListForDoctorQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientListForDoctorQuery, TError, TData>(
      ['getPatientListForDoctor', variables],
      fetcher<GetPatientListForDoctorQuery, GetPatientListForDoctorQueryVariables>(client, GetPatientListForDoctorDocument, variables, headers),
      options
    );
export const GetPatientPlanDetailDataDocument = `
    query getPatientPlanDetailData($input: PatientPlanDetailInput!) {
  getPatientPlanDetailData(input: $input) {
    planData {
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                phone
                sysId
                time
                timezone
                type
              }
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      continueTrial
      countTrialReminder
      evaluationId
      evaluationTitle
      isAutoRenewal
      isEDTrial
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isSubscriptionPrice
      isSubscriptionTrial
      oldPriceInfo
      oldProductInfo
      orderPriceId
      paymentProvider
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      priceInfo
      productInfo
      shortId
      status
      stripeSubscriptionId
      subscriptionId
      sysId
    }
    refCoupon {
      info
    }
  }
}
    `;
export const useGetPatientPlanDetailDataQuery = <
      TData = GetPatientPlanDetailDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientPlanDetailDataQueryVariables,
      options?: UseQueryOptions<GetPatientPlanDetailDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientPlanDetailDataQuery, TError, TData>(
      ['getPatientPlanDetailData', variables],
      fetcher<GetPatientPlanDetailDataQuery, GetPatientPlanDetailDataQueryVariables>(client, GetPatientPlanDetailDataDocument, variables, headers),
      options
    );
export const GetPatientPlansDataDocument = `
    query getPatientPlansData($input: PatientPlanInput!) {
  getPatientPlansData(input: $input) {
    refCoupon {
      info
    }
  }
}
    `;
export const useGetPatientPlansDataQuery = <
      TData = GetPatientPlansDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPatientPlansDataQueryVariables,
      options?: UseQueryOptions<GetPatientPlansDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientPlansDataQuery, TError, TData>(
      ['getPatientPlansData', variables],
      fetcher<GetPatientPlansDataQuery, GetPatientPlansDataQueryVariables>(client, GetPatientPlansDataDocument, variables, headers),
      options
    );
export const GetPatientProfileForPregnancyChecklistDocument = `
    query getPatientProfileForPregnancyChecklist {
  getPatientProfileForPregnancyChecklist {
    age
    condition
    getPreggers
    hasChildren
    height
    name
    weight
  }
}
    `;
export const useGetPatientProfileForPregnancyChecklistQuery = <
      TData = GetPatientProfileForPregnancyChecklistQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetPatientProfileForPregnancyChecklistQueryVariables,
      options?: UseQueryOptions<GetPatientProfileForPregnancyChecklistQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientProfileForPregnancyChecklistQuery, TError, TData>(
      variables === undefined ? ['getPatientProfileForPregnancyChecklist'] : ['getPatientProfileForPregnancyChecklist', variables],
      fetcher<GetPatientProfileForPregnancyChecklistQuery, GetPatientProfileForPregnancyChecklistQueryVariables>(client, GetPatientProfileForPregnancyChecklistDocument, variables, headers),
      options
    );
export const GetPatientPromotionCodesDocument = `
    query getPatientPromotionCodes {
  getPatientPromotionCodes {
    active
    code
    coupon {
      amount_off
      applies_to
      created
      currency
      duration
      duration_in_months
      id
      livemode
      max_redemptions
      metadata
      name
      object
      percent_off
      promotionCodes {
        active
        code
        coupon {
          amount_off
          applies_to
          created
          currency
          duration
          duration_in_months
          id
          livemode
          max_redemptions
          metadata
          name
          object
          percent_off
          redeem_by
          times_redeemed
          valid
        }
        created
        customer
        expires_at
        id
        livemode
        max_redemptions
        metadata
        object
        restrictions
        times_redeemed
      }
      redeem_by
      times_redeemed
      valid
    }
    created
    customer
    expires_at
    id
    livemode
    max_redemptions
    metadata
    object
    restrictions
    times_redeemed
  }
}
    `;
export const useGetPatientPromotionCodesQuery = <
      TData = GetPatientPromotionCodesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetPatientPromotionCodesQueryVariables,
      options?: UseQueryOptions<GetPatientPromotionCodesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPatientPromotionCodesQuery, TError, TData>(
      variables === undefined ? ['getPatientPromotionCodes'] : ['getPatientPromotionCodes', variables],
      fetcher<GetPatientPromotionCodesQuery, GetPatientPromotionCodesQueryVariables>(client, GetPatientPromotionCodesDocument, variables, headers),
      options
    );
export const GetPlansDocument = `
    query getPlans($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput) {
  getPlans {
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    continueTrial
    countTrialReminder
    evaluationId
    evaluationTitle
    isAutoRenewal
    isEDTrial
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isSubscriptionPrice
    isSubscriptionTrial
    oldPriceInfo
    oldProductInfo
    orderPriceId
    paymentProvider
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    priceInfo
    productInfo
    shortId
    status
    stripeSubscriptionId
    subscriptionId
    sysId
  }
}
    `;
export const useGetPlansQuery = <
      TData = GetPlansQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetPlansQueryVariables,
      options?: UseQueryOptions<GetPlansQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPlansQuery, TError, TData>(
      variables === undefined ? ['getPlans'] : ['getPlans', variables],
      fetcher<GetPlansQuery, GetPlansQueryVariables>(client, GetPlansDocument, variables, headers),
      options
    );
export const GetPreblockForGuestDocument = `
    query getPreblockForGuest($anonymousId: String!) {
  getPreblockForGuest(anonymousId: $anonymousId) {
    expiresAt
    heldAppointmentTypeId
    heldDateTime
    preblockId
    status
  }
}
    `;
export const useGetPreblockForGuestQuery = <
      TData = GetPreblockForGuestQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPreblockForGuestQueryVariables,
      options?: UseQueryOptions<GetPreblockForGuestQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPreblockForGuestQuery, TError, TData>(
      ['getPreblockForGuest', variables],
      fetcher<GetPreblockForGuestQuery, GetPreblockForGuestQueryVariables>(client, GetPreblockForGuestDocument, variables, headers),
      options
    );
export const GetPrescriptionByFilterDocument = `
    query getPrescriptionByFilter($input: PrescriptionFilterInput!) {
  getPrescriptionByFilter(input: $input) {
    approver {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    cancelled
    createdAt
    days
    doctor {
      active
      calendarId
      country
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
    }
    doctorNotes
    endDate
    expiresAt
    isFollowUp
    notedDate
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    priceIds
    products {
      active
      childrenIncludedProduct {
        active
        childrenIncludedProduct {
          active
          childrenSecondIncludedProduct {
            active
            childrenIncludedProduct {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              id
              image {
                noahVertical
                noahWide
                sysId
                zoeyVertical
                zoeyWide
              }
              includedProduct {
                active
                childrenIncludedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                childrenSecondIncludedProduct {
                  active
                  childrenSecondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                country
                createdAt
                description
                displayId
                evaluationId
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    startDate
    status
    sysId
    treatmentCode
    updatedAt
  }
}
    `;
export const useGetPrescriptionByFilterQuery = <
      TData = GetPrescriptionByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPrescriptionByFilterQueryVariables,
      options?: UseQueryOptions<GetPrescriptionByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPrescriptionByFilterQuery, TError, TData>(
      ['getPrescriptionByFilter', variables],
      fetcher<GetPrescriptionByFilterQuery, GetPrescriptionByFilterQueryVariables>(client, GetPrescriptionByFilterDocument, variables, headers),
      options
    );
export const GetPrescriptionByIdDocument = `
    query getPrescriptionById($id: String!) {
  getPrescriptionById(id: $id) {
    approver {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      requireConfirmPolicy
      socialProviderType
      sysId
      userType
      utmCampaign
      utmMedium
      utmSource
    }
    cancelled
    createdAt
    days
    doctor {
      active
      calendarId
      country
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
    }
    doctorNotes
    endDate
    expiresAt
    isFollowUp
    notedDate
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    priceIds
    products {
      active
      childrenIncludedProduct {
        active
        childrenIncludedProduct {
          active
          childrenSecondIncludedProduct {
            active
            childrenIncludedProduct {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              id
              image {
                noahVertical
                noahWide
                sysId
                zoeyVertical
                zoeyWide
              }
              includedProduct {
                active
                childrenIncludedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                childrenSecondIncludedProduct {
                  active
                  childrenSecondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                country
                createdAt
                description
                displayId
                evaluationId
                id
                image {
                  noahVertical
                  noahWide
                  sysId
                  zoeyVertical
                  zoeyWide
                }
                includedProduct {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            country
            createdAt
            description
            displayId
            evaluationId
            id
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      childrenSecondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      secondIncludedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    startDate
    status
    sysId
    treatmentCode
    updatedAt
  }
}
    `;
export const useGetPrescriptionByIdQuery = <
      TData = GetPrescriptionByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPrescriptionByIdQueryVariables,
      options?: UseQueryOptions<GetPrescriptionByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPrescriptionByIdQuery, TError, TData>(
      ['getPrescriptionById', variables],
      fetcher<GetPrescriptionByIdQuery, GetPrescriptionByIdQueryVariables>(client, GetPrescriptionByIdDocument, variables, headers),
      options
    );
export const GetPrescriptionOrderBookingResultDocument = `
    query getPrescriptionOrderBookingResult($input: GetPrescriptionOrderBookingResultInput!) {
  getPrescriptionOrderBookingResult(input: $input) {
    isBooked
    order {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    stripeProductPrice {
      drDosageFrequency {
        alternativeDosage
        alternativeDosageUnit
        asNeeded
        dosage
        dosageUnit
        duration
        durationUnit
        frequency
        productId
        quantity
        quantityUnit
      }
      importPriceId
      priceActive
      priceBillingScheme
      priceCreated
      priceCurrency
      priceDisplayId
      priceFirstTimeAlternativePrice
      priceFirstTimeTryingInMonths
      priceId
      priceLivemode
      priceMetadata
      priceNickname
      priceProduct
      priceRecurring
      priceTaxBehavior
      priceType
      priceUnitAmount
      priceUnitAmountDecimal
      productActive
      productCountry
      productDescription
      productDisplayId
      productEvaluationId {
        noah
        zoey
      }
      productId
      productImage
      productIncluded
      productIsShowOnShop {
        noah
        zoey
      }
      productLivemode
      productMetadata
      productName
      productPurchaseds
      productSecondIncluded
      productStatementDescriptor
      productType
      productUniqName
      productUnitLabel
      sysId
    }
  }
}
    `;
export const useGetPrescriptionOrderBookingResultQuery = <
      TData = GetPrescriptionOrderBookingResultQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPrescriptionOrderBookingResultQueryVariables,
      options?: UseQueryOptions<GetPrescriptionOrderBookingResultQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPrescriptionOrderBookingResultQuery, TError, TData>(
      ['getPrescriptionOrderBookingResult', variables],
      fetcher<GetPrescriptionOrderBookingResultQuery, GetPrescriptionOrderBookingResultQueryVariables>(client, GetPrescriptionOrderBookingResultDocument, variables, headers),
      options
    );
export const GetPrescriptionOrderCalculationDocument = `
    query getPrescriptionOrderCalculation($input: GetPrescriptionOrderCalculationInput!) {
  getPrescriptionOrderCalculation(input: $input) {
    cashbackEarnRate
    cashbackEarned
    cashbackRedeemed
    consultFee
    consultFeeAfterDiscount
    discountAmount
    isConsult
    minimalAmountPayment
    paymentIntentAmount
    paymentIntentAmountAfterCashback
    paymentIntentSummary
    priceId
    productPriceAmount
    productPriceAmountAfterDiscount
    promotionCode
    promotionCodeError
    shouldChargeConsultFee
    stripeProductPrice {
      drDosageFrequency {
        alternativeDosage
        alternativeDosageUnit
        asNeeded
        dosage
        dosageUnit
        duration
        durationUnit
        frequency
        productId
        quantity
        quantityUnit
      }
      importPriceId
      priceActive
      priceBillingScheme
      priceCreated
      priceCurrency
      priceDisplayId
      priceFirstTimeAlternativePrice
      priceFirstTimeTryingInMonths
      priceId
      priceLivemode
      priceMetadata
      priceNickname
      priceProduct
      priceRecurring
      priceTaxBehavior
      priceType
      priceUnitAmount
      priceUnitAmountDecimal
      productActive
      productCountry
      productDescription
      productDisplayId
      productEvaluationId {
        noah
        zoey
      }
      productId
      productImage
      productIncluded
      productIsShowOnShop {
        noah
        zoey
      }
      productLivemode
      productMetadata
      productName
      productPurchaseds
      productSecondIncluded
      productStatementDescriptor
      productType
      productUniqName
      productUnitLabel
      sysId
    }
    stripePromotionCode {
      active
      code
      coupon {
        amount_off
        applies_to
        created
        currency
        duration
        duration_in_months
        id
        livemode
        max_redemptions
        metadata
        name
        object
        percent_off
        promotionCodes {
          active
          code
          coupon {
            amount_off
            applies_to
            created
            currency
            duration
            duration_in_months
            id
            livemode
            max_redemptions
            metadata
            name
            object
            percent_off
            redeem_by
            times_redeemed
            valid
          }
          created
          customer
          expires_at
          id
          livemode
          max_redemptions
          metadata
          object
          restrictions
          times_redeemed
        }
        redeem_by
        times_redeemed
        valid
      }
      created
      customer
      expires_at
      id
      livemode
      max_redemptions
      metadata
      object
      restrictions
      times_redeemed
    }
    subTotal
    total
    totalAfterCashback
  }
}
    `;
export const useGetPrescriptionOrderCalculationQuery = <
      TData = GetPrescriptionOrderCalculationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPrescriptionOrderCalculationQueryVariables,
      options?: UseQueryOptions<GetPrescriptionOrderCalculationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPrescriptionOrderCalculationQuery, TError, TData>(
      ['getPrescriptionOrderCalculation', variables],
      fetcher<GetPrescriptionOrderCalculationQuery, GetPrescriptionOrderCalculationQueryVariables>(client, GetPrescriptionOrderCalculationDocument, variables, headers),
      options
    );
export const GetPriceByIntentIdDocument = `
    query getPriceByIntentId($input: GetPriceByIntentIdInput!) {
  getPriceByIntentId(input: $input) {
    active
    billing_scheme
    created
    createdAt
    currency
    displayId
    id
    livemode
    locale
    metadata
    nickname
    product
    recurring {
      aggregate_usage
      interval
      interval_count
      trial_period_days
      usage_type
    }
    stripeProduct
    sysId
    tax_behavior
    type
    unit_amount
    unit_amount_decimal
    updatedAt
  }
}
    `;
export const useGetPriceByIntentIdQuery = <
      TData = GetPriceByIntentIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPriceByIntentIdQueryVariables,
      options?: UseQueryOptions<GetPriceByIntentIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPriceByIntentIdQuery, TError, TData>(
      ['getPriceByIntentId', variables],
      fetcher<GetPriceByIntentIdQuery, GetPriceByIntentIdQueryVariables>(client, GetPriceByIntentIdDocument, variables, headers),
      options
    );
export const GetPriceTranslatedTextDocument = `
    query getPriceTranslatedText($input: TranslatedTextPriceQueryInput!) {
  getPriceTranslatedText(input: $input) {
    locales {
      key
      value
    }
    priceId
  }
}
    `;
export const useGetPriceTranslatedTextQuery = <
      TData = GetPriceTranslatedTextQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPriceTranslatedTextQueryVariables,
      options?: UseQueryOptions<GetPriceTranslatedTextQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPriceTranslatedTextQuery, TError, TData>(
      ['getPriceTranslatedText', variables],
      fetcher<GetPriceTranslatedTextQuery, GetPriceTranslatedTextQueryVariables>(client, GetPriceTranslatedTextDocument, variables, headers),
      options
    );
export const GetPricesByProductIdsDocument = `
    query getPricesByProductIds($input: PricesByProductIdsInput!) {
  getPricesByProductIds(input: $input) {
    data {
      active
      billing_scheme
      created
      currency
      id
      livemode
      lookup_key
      metadata
      nickname
      object
      product
      recurring
      tax_behavior
      tiers
      tiers_mode
      transform_quantity
      type
      unit_amount
      unit_amount_decimal
    }
  }
}
    `;
export const useGetPricesByProductIdsQuery = <
      TData = GetPricesByProductIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPricesByProductIdsQueryVariables,
      options?: UseQueryOptions<GetPricesByProductIdsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPricesByProductIdsQuery, TError, TData>(
      ['getPricesByProductIds', variables],
      fetcher<GetPricesByProductIdsQuery, GetPricesByProductIdsQueryVariables>(client, GetPricesByProductIdsDocument, variables, headers),
      options
    );
export const GetProductByFilterDocument = `
    query getProductByFilter($input: ProductFilterInput!) {
  getProductByFilter(input: $input) {
    acuitySchedulingAppType
    amountToFreeIncludedPrice
    chargeNowProduct
    country
    crossEvaluation
    displayId
    emailOnCompleteName
    emailTemplate
    evaluationFormId
    id
    includedPriceIds
    orders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    overwriteCalendarHeaderTitleInfo
    overwriteProductSubtitleInfo
    platform
    productGroups
    requiresDelivery
    requiresEvaluation
    requiresPrescription
    sysId
    title
  }
}
    `;
export const useGetProductByFilterQuery = <
      TData = GetProductByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetProductByFilterQueryVariables,
      options?: UseQueryOptions<GetProductByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetProductByFilterQuery, TError, TData>(
      ['getProductByFilter', variables],
      fetcher<GetProductByFilterQuery, GetProductByFilterQueryVariables>(client, GetProductByFilterDocument, variables, headers),
      options
    );
export const GetProductInfoDocument = `
    query getProductInfo($orderId: String!) {
  getProductInfo(orderId: $orderId) {
    active
    childrenIncludedProduct {
      active
      childrenIncludedProduct {
        active
        childrenSecondIncludedProduct {
          active
          childrenIncludedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            image {
              noahVertical
              noahWide
              sysId
              zoeyVertical
              zoeyWide
            }
            includedProduct {
              active
              childrenIncludedProduct {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                secondIncludedProduct {
                  active
                  childrenIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              country
              createdAt
              description
              displayId
              evaluationId
              id
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    childrenSecondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    country
    createdAt
    description
    displayId
    evaluationId
    id
    image {
      noahVertical
      noahWide
      sysId
      zoeyVertical
      zoeyWide
    }
    includedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    isShowOnShop
    livemode
    locale
    metadata
    name
    prices
    secondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    shopProductGroupIds
    statementDescriptor
    sysId
    type
    uniqName
    unitLabel
    updatedAt
  }
}
    `;
export const useGetProductInfoQuery = <
      TData = GetProductInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetProductInfoQueryVariables,
      options?: UseQueryOptions<GetProductInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetProductInfoQuery, TError, TData>(
      ['getProductInfo', variables],
      fetcher<GetProductInfoQuery, GetProductInfoQueryVariables>(client, GetProductInfoDocument, variables, headers),
      options
    );
export const GetProductTranslatedTextDocument = `
    query getProductTranslatedText($input: TranslatedTextProductQueryInput!) {
  getProductTranslatedText(input: $input) {
    locales {
      key
      value
    }
    productId
  }
}
    `;
export const useGetProductTranslatedTextQuery = <
      TData = GetProductTranslatedTextQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetProductTranslatedTextQueryVariables,
      options?: UseQueryOptions<GetProductTranslatedTextQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetProductTranslatedTextQuery, TError, TData>(
      ['getProductTranslatedText', variables],
      fetcher<GetProductTranslatedTextQuery, GetProductTranslatedTextQueryVariables>(client, GetProductTranslatedTextDocument, variables, headers),
      options
    );
export const GetReferralCouponDocument = `
    query getReferralCoupon($input: ReferralProgramFilterInput!) {
  getReferralCoupon(input: $input) {
    info
  }
}
    `;
export const useGetReferralCouponQuery = <
      TData = GetReferralCouponQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetReferralCouponQueryVariables,
      options?: UseQueryOptions<GetReferralCouponQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetReferralCouponQuery, TError, TData>(
      ['getReferralCoupon', variables],
      fetcher<GetReferralCouponQuery, GetReferralCouponQueryVariables>(client, GetReferralCouponDocument, variables, headers),
      options
    );
export const GetRenewalOrderInfoDocument = `
    query getRenewalOrderInfo($input: GetRenewalOrderInfoInput!) {
  getRenewalOrderInfo(input: $input) {
    last4
    paymentMethodId
    upcomingAmount
  }
}
    `;
export const useGetRenewalOrderInfoQuery = <
      TData = GetRenewalOrderInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRenewalOrderInfoQueryVariables,
      options?: UseQueryOptions<GetRenewalOrderInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetRenewalOrderInfoQuery, TError, TData>(
      ['getRenewalOrderInfo', variables],
      fetcher<GetRenewalOrderInfoQuery, GetRenewalOrderInfoQueryVariables>(client, GetRenewalOrderInfoDocument, variables, headers),
      options
    );
export const GetShopInfoDocument = `
    query getShopInfo($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: ShopInput!) {
  getShopInfo(input: $input) {
    activeProductIds {
      activeProducts
      completedEvalIds
      pendingEvalIds
      skippedEvalIds
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    cartData {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      calculateOrderSummary
      calculation
      cart
      cartItems
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      errorCode
      paidCompletedEvaluationIds
      platform
      promotionCode
      status
      sysId
    }
    excludedEvalIds
    teleConsultOrders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
  }
}
    `;
export const useGetShopInfoQuery = <
      TData = GetShopInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetShopInfoQueryVariables,
      options?: UseQueryOptions<GetShopInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetShopInfoQuery, TError, TData>(
      ['getShopInfo', variables],
      fetcher<GetShopInfoQuery, GetShopInfoQueryVariables>(client, GetShopInfoDocument, variables, headers),
      options
    );
export const GetStripeCouponByFilterDocument = `
    query getStripeCouponByFilter($input: StripeCouponFilterInput!) {
  getStripeCouponByFilter(input: $input) {
    amount_off
    applies_to
    created
    currency
    duration
    duration_in_months
    id
    livemode
    max_redemptions
    metadata
    name
    object
    percent_off
    promotionCodes {
      active
      code
      coupon {
        amount_off
        applies_to
        created
        currency
        duration
        duration_in_months
        id
        livemode
        max_redemptions
        metadata
        name
        object
        percent_off
        promotionCodes {
          active
          code
          created
          customer
          expires_at
          id
          livemode
          max_redemptions
          metadata
          object
          restrictions
          times_redeemed
        }
        redeem_by
        times_redeemed
        valid
      }
      created
      customer
      expires_at
      id
      livemode
      max_redemptions
      metadata
      object
      restrictions
      times_redeemed
    }
    redeem_by
    times_redeemed
    valid
  }
}
    `;
export const useGetStripeCouponByFilterQuery = <
      TData = GetStripeCouponByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStripeCouponByFilterQueryVariables,
      options?: UseQueryOptions<GetStripeCouponByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStripeCouponByFilterQuery, TError, TData>(
      ['getStripeCouponByFilter', variables],
      fetcher<GetStripeCouponByFilterQuery, GetStripeCouponByFilterQueryVariables>(client, GetStripeCouponByFilterDocument, variables, headers),
      options
    );
export const GetStripeCouponByIdDocument = `
    query getStripeCouponById($id: String!) {
  getStripeCouponById(id: $id) {
    amount_off
    applies_to
    created
    currency
    duration
    duration_in_months
    id
    livemode
    max_redemptions
    metadata
    name
    object
    percent_off
    promotionCodes {
      active
      code
      coupon {
        amount_off
        applies_to
        created
        currency
        duration
        duration_in_months
        id
        livemode
        max_redemptions
        metadata
        name
        object
        percent_off
        promotionCodes {
          active
          code
          created
          customer
          expires_at
          id
          livemode
          max_redemptions
          metadata
          object
          restrictions
          times_redeemed
        }
        redeem_by
        times_redeemed
        valid
      }
      created
      customer
      expires_at
      id
      livemode
      max_redemptions
      metadata
      object
      restrictions
      times_redeemed
    }
    redeem_by
    times_redeemed
    valid
  }
}
    `;
export const useGetStripeCouponByIdQuery = <
      TData = GetStripeCouponByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStripeCouponByIdQueryVariables,
      options?: UseQueryOptions<GetStripeCouponByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStripeCouponByIdQuery, TError, TData>(
      ['getStripeCouponById', variables],
      fetcher<GetStripeCouponByIdQuery, GetStripeCouponByIdQueryVariables>(client, GetStripeCouponByIdDocument, variables, headers),
      options
    );
export const GetStripePriceByIdDocument = `
    query getStripePriceById($input: StripePriceFilterInput!) {
  getStripePriceById(input: $input) {
    active
    billing_scheme
    created
    createdAt
    currency
    displayId
    id
    livemode
    locale
    metadata
    nickname
    product
    recurring {
      aggregate_usage
      interval
      interval_count
      trial_period_days
      usage_type
    }
    stripeProduct
    sysId
    tax_behavior
    type
    unit_amount
    unit_amount_decimal
    updatedAt
  }
}
    `;
export const useGetStripePriceByIdQuery = <
      TData = GetStripePriceByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStripePriceByIdQueryVariables,
      options?: UseQueryOptions<GetStripePriceByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStripePriceByIdQuery, TError, TData>(
      ['getStripePriceById', variables],
      fetcher<GetStripePriceByIdQuery, GetStripePriceByIdQueryVariables>(client, GetStripePriceByIdDocument, variables, headers),
      options
    );
export const GetStripeProductByFilterDocument = `
    query getStripeProductByFilter($input: StripeProductFilterInput!) {
  getStripeProductByFilter(input: $input) {
    active
    childrenIncludedProduct {
      active
      childrenIncludedProduct {
        active
        childrenSecondIncludedProduct {
          active
          childrenIncludedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            image {
              noahVertical
              noahWide
              sysId
              zoeyVertical
              zoeyWide
            }
            includedProduct {
              active
              childrenIncludedProduct {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                secondIncludedProduct {
                  active
                  childrenIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              country
              createdAt
              description
              displayId
              evaluationId
              id
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    childrenSecondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    country
    createdAt
    description
    displayId
    evaluationId
    id
    image {
      noahVertical
      noahWide
      sysId
      zoeyVertical
      zoeyWide
    }
    includedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    isShowOnShop
    livemode
    locale
    metadata
    name
    prices
    secondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    shopProductGroupIds
    statementDescriptor
    sysId
    type
    uniqName
    unitLabel
    updatedAt
  }
}
    `;
export const useGetStripeProductByFilterQuery = <
      TData = GetStripeProductByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStripeProductByFilterQueryVariables,
      options?: UseQueryOptions<GetStripeProductByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStripeProductByFilterQuery, TError, TData>(
      ['getStripeProductByFilter', variables],
      fetcher<GetStripeProductByFilterQuery, GetStripeProductByFilterQueryVariables>(client, GetStripeProductByFilterDocument, variables, headers),
      options
    );
export const GetStripeProductByIdDocument = `
    query getStripeProductById($input: StripeProductByIdInput!) {
  getStripeProductById(input: $input) {
    active
    childrenIncludedProduct {
      active
      childrenIncludedProduct {
        active
        childrenSecondIncludedProduct {
          active
          childrenIncludedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            image {
              noahVertical
              noahWide
              sysId
              zoeyVertical
              zoeyWide
            }
            includedProduct {
              active
              childrenIncludedProduct {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                secondIncludedProduct {
                  active
                  childrenIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              country
              createdAt
              description
              displayId
              evaluationId
              id
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    childrenSecondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    country
    createdAt
    description
    displayId
    evaluationId
    id
    image {
      noahVertical
      noahWide
      sysId
      zoeyVertical
      zoeyWide
    }
    includedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    isShowOnShop
    livemode
    locale
    metadata
    name
    prices
    secondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    shopProductGroupIds
    statementDescriptor
    sysId
    type
    uniqName
    unitLabel
    updatedAt
  }
}
    `;
export const useGetStripeProductByIdQuery = <
      TData = GetStripeProductByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStripeProductByIdQueryVariables,
      options?: UseQueryOptions<GetStripeProductByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStripeProductByIdQuery, TError, TData>(
      ['getStripeProductById', variables],
      fetcher<GetStripeProductByIdQuery, GetStripeProductByIdQueryVariables>(client, GetStripeProductByIdDocument, variables, headers),
      options
    );
export const GetStripeProductByIdsDocument = `
    query getStripeProductByIds($input: StripeProductByIdsInput!) {
  getStripeProductByIds(input: $input) {
    active
    childrenIncludedProduct {
      active
      childrenIncludedProduct {
        active
        childrenSecondIncludedProduct {
          active
          childrenIncludedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            image {
              noahVertical
              noahWide
              sysId
              zoeyVertical
              zoeyWide
            }
            includedProduct {
              active
              childrenIncludedProduct {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                secondIncludedProduct {
                  active
                  childrenIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              country
              createdAt
              description
              displayId
              evaluationId
              id
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    childrenSecondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    country
    createdAt
    description
    displayId
    evaluationId
    id
    image {
      noahVertical
      noahWide
      sysId
      zoeyVertical
      zoeyWide
    }
    includedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    isShowOnShop
    livemode
    locale
    metadata
    name
    prices
    secondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    shopProductGroupIds
    statementDescriptor
    sysId
    type
    uniqName
    unitLabel
    updatedAt
  }
}
    `;
export const useGetStripeProductByIdsQuery = <
      TData = GetStripeProductByIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStripeProductByIdsQueryVariables,
      options?: UseQueryOptions<GetStripeProductByIdsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStripeProductByIdsQuery, TError, TData>(
      ['getStripeProductByIds', variables],
      fetcher<GetStripeProductByIdsQuery, GetStripeProductByIdsQueryVariables>(client, GetStripeProductByIdsDocument, variables, headers),
      options
    );
export const GetStripeProductByUniqNamesDocument = `
    query getStripeProductByUniqNames($input: StripeProductByUniqNamesInput!) {
  getStripeProductByUniqNames(input: $input) {
    active
    childrenIncludedProduct {
      active
      childrenIncludedProduct {
        active
        childrenSecondIncludedProduct {
          active
          childrenIncludedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            image {
              noahVertical
              noahWide
              sysId
              zoeyVertical
              zoeyWide
            }
            includedProduct {
              active
              childrenIncludedProduct {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                secondIncludedProduct {
                  active
                  childrenIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              country
              createdAt
              description
              displayId
              evaluationId
              id
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    childrenSecondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    country
    createdAt
    description
    displayId
    evaluationId
    id
    image {
      noahVertical
      noahWide
      sysId
      zoeyVertical
      zoeyWide
    }
    includedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    isShowOnShop
    livemode
    locale
    metadata
    name
    prices
    secondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    shopProductGroupIds
    statementDescriptor
    sysId
    type
    uniqName
    unitLabel
    updatedAt
  }
}
    `;
export const useGetStripeProductByUniqNamesQuery = <
      TData = GetStripeProductByUniqNamesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStripeProductByUniqNamesQueryVariables,
      options?: UseQueryOptions<GetStripeProductByUniqNamesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStripeProductByUniqNamesQuery, TError, TData>(
      ['getStripeProductByUniqNames', variables],
      fetcher<GetStripeProductByUniqNamesQuery, GetStripeProductByUniqNamesQueryVariables>(client, GetStripeProductByUniqNamesDocument, variables, headers),
      options
    );
export const GetStripeProductPricesByFilterDocument = `
    query getStripeProductPricesByFilter($input: StripeProductPriceFilterInput!) {
  getStripeProductPricesByFilter(input: $input) {
    drDosageFrequency {
      alternativeDosage
      alternativeDosageUnit
      asNeeded
      dosage
      dosageUnit
      duration
      durationUnit
      frequency
      productId
      quantity
      quantityUnit
    }
    importPriceId
    priceActive
    priceBillingScheme
    priceCreated
    priceCurrency
    priceDisplayId
    priceFirstTimeAlternativePrice
    priceFirstTimeTryingInMonths
    priceId
    priceLivemode
    priceMetadata
    priceNickname
    priceProduct
    priceRecurring
    priceTaxBehavior
    priceType
    priceUnitAmount
    priceUnitAmountDecimal
    productActive
    productCountry
    productDescription
    productDisplayId
    productEvaluationId {
      noah
      zoey
    }
    productId
    productImage
    productIncluded
    productIsShowOnShop {
      noah
      zoey
    }
    productLivemode
    productMetadata
    productName
    productPurchaseds
    productSecondIncluded
    productStatementDescriptor
    productType
    productUniqName
    productUnitLabel
    sysId
  }
}
    `;
export const useGetStripeProductPricesByFilterQuery = <
      TData = GetStripeProductPricesByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStripeProductPricesByFilterQueryVariables,
      options?: UseQueryOptions<GetStripeProductPricesByFilterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStripeProductPricesByFilterQuery, TError, TData>(
      ['getStripeProductPricesByFilter', variables],
      fetcher<GetStripeProductPricesByFilterQuery, GetStripeProductPricesByFilterQueryVariables>(client, GetStripeProductPricesByFilterDocument, variables, headers),
      options
    );
export const GetStripePromotionCodeByIdDocument = `
    query getStripePromotionCodeById($id: String!) {
  getStripePromotionCodeById(id: $id) {
    active
    code
    coupon {
      amount_off
      applies_to
      created
      currency
      duration
      duration_in_months
      id
      livemode
      max_redemptions
      metadata
      name
      object
      percent_off
      promotionCodes {
        active
        code
        coupon {
          amount_off
          applies_to
          created
          currency
          duration
          duration_in_months
          id
          livemode
          max_redemptions
          metadata
          name
          object
          percent_off
          redeem_by
          times_redeemed
          valid
        }
        created
        customer
        expires_at
        id
        livemode
        max_redemptions
        metadata
        object
        restrictions
        times_redeemed
      }
      redeem_by
      times_redeemed
      valid
    }
    created
    customer
    expires_at
    id
    livemode
    max_redemptions
    metadata
    object
    restrictions
    times_redeemed
  }
}
    `;
export const useGetStripePromotionCodeByIdQuery = <
      TData = GetStripePromotionCodeByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStripePromotionCodeByIdQueryVariables,
      options?: UseQueryOptions<GetStripePromotionCodeByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStripePromotionCodeByIdQuery, TError, TData>(
      ['getStripePromotionCodeById', variables],
      fetcher<GetStripePromotionCodeByIdQuery, GetStripePromotionCodeByIdQueryVariables>(client, GetStripePromotionCodeByIdDocument, variables, headers),
      options
    );
export const GetSubscriptionByIdDocument = `
    query getSubscriptionById($id: String!) {
  getSubscriptionById(id: $id) {
    cancel_at_period_end
    current_period_end
    current_period_start
    customer
    default_payment_method
    id
    items
    latest_invoice
    metadata
    pause_collection
    pending_setup_intent
    pending_update
    plan
    status
  }
}
    `;
export const useGetSubscriptionByIdQuery = <
      TData = GetSubscriptionByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSubscriptionByIdQueryVariables,
      options?: UseQueryOptions<GetSubscriptionByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetSubscriptionByIdQuery, TError, TData>(
      ['getSubscriptionById', variables],
      fetcher<GetSubscriptionByIdQuery, GetSubscriptionByIdQueryVariables>(client, GetSubscriptionByIdDocument, variables, headers),
      options
    );
export const GetSuggestionsDocument = `
    query getSuggestions($input: GetSuggestionsInput!) {
  getSuggestions(input: $input) {
    active
    childrenIncludedProduct {
      active
      childrenIncludedProduct {
        active
        childrenSecondIncludedProduct {
          active
          childrenIncludedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            id
            image {
              noahVertical
              noahWide
              sysId
              zoeyVertical
              zoeyWide
            }
            includedProduct {
              active
              childrenIncludedProduct {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                secondIncludedProduct {
                  active
                  childrenIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              country
              createdAt
              description
              displayId
              evaluationId
              id
              isShowOnShop
              livemode
              locale
              metadata
              name
              prices
              shopProductGroupIds
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
            }
            isShowOnShop
            livemode
            locale
            metadata
            name
            prices
            shopProductGroupIds
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
          }
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    childrenSecondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    country
    createdAt
    description
    displayId
    evaluationId
    id
    image {
      noahVertical
      noahWide
      sysId
      zoeyVertical
      zoeyWide
    }
    includedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    isShowOnShop
    livemode
    locale
    metadata
    name
    prices
    secondIncludedProduct {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    shopProductGroupIds
    statementDescriptor
    sysId
    type
    uniqName
    unitLabel
    updatedAt
  }
}
    `;
export const useGetSuggestionsQuery = <
      TData = GetSuggestionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSuggestionsQueryVariables,
      options?: UseQueryOptions<GetSuggestionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetSuggestionsQuery, TError, TData>(
      ['getSuggestions', variables],
      fetcher<GetSuggestionsQuery, GetSuggestionsQueryVariables>(client, GetSuggestionsDocument, variables, headers),
      options
    );
export const GetSurveyListDocument = `
    query getSurveyList($input: SurveyFilterInput!) {
  getSurveyList(input: $input) {
    answers
    isSkipped
    order {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    questionAnswers
    skippedCarts
    sysId
    type
  }
}
    `;
export const useGetSurveyListQuery = <
      TData = GetSurveyListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSurveyListQueryVariables,
      options?: UseQueryOptions<GetSurveyListQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetSurveyListQuery, TError, TData>(
      ['getSurveyList', variables],
      fetcher<GetSurveyListQuery, GetSurveyListQueryVariables>(client, GetSurveyListDocument, variables, headers),
      options
    );
export const GetTeleConsultOrdersDocument = `
    query getTeleConsultOrders($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: TeleConsultOrderFilterInput!) {
  getTeleConsultOrders(input: $input) {
    acuityAppointmentSnapshot {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            address
            affiliateCoupon {
              affiliate {
                enabled
                name
                portalUrl
                region
                slug
                sysId
              }
              affiliateProduct {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateSysId
                couponLandingUrl
                createdAt
                discountPercentage
                displayName
                enabled
                evalFlow
                externalPortalUrl
                slug
                stripePriceId
                stripeProductId
                stripePromotionCode
                stripePromotionCodeId
                sysId
                unitAmount
                updatedAt
              }
              affiliateProductSysId
              affiliateSysId
              anonymousId
              couponId
              createdAt
              opsNote
              orderSysId
              status
              sysId
              updatedAt
              verifiedAt
              verifiedByUserSysId
            }
            approveAt
            atomePaymentAmount
            auditDoctorNotes {
              createdAt
              createdBy
              deletedBy
              doctor {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                patient {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                requireConfirmPolicy
                socialProviderType
                sysId
                userType
                utmCampaign
                utmMedium
                utmSource
              }
              isDeleted
              note
              order {
                acuityAppointmentSnapshot {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  doctor
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                address
                affiliateCoupon {
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  isDeleted
                  note
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                pickupLocation {
                  address
                  area {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  orders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  acuityAppointmentSnapshot {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescription {
                  approver {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  cancelled
                  createdAt
                  days
                  doctor {
                    active
                    calendarId
                    country
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                  }
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    weight
                  }
                  priceIds
                  products {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productGroupData {
                  acuitySchedulingAppType
                  amountToFreeIncludedPrice
                  chargeNowProduct
                  country
                  crossEvaluation
                  displayId
                  emailOnCompleteName
                  emailTemplate
                  evaluationFormId
                  id
                  includedPriceIds
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    platformType
                    prescribeAfterTeleConsult
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  overwriteCalendarHeaderTitleInfo
                  overwriteProductSubtitleInfo
                  platform
                  productGroups
                  requiresDelivery
                  requiresEvaluation
                  requiresPrescription
                  sysId
                  title
                }
                productInfo {
                  active
                  childrenIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  childrenSecondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  isShowOnShop
                  livemode
                  locale
                  metadata
                  name
                  prices
                  secondIncludedProduct {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  shopProductGroupIds
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                twilioMessageHistories {
                  address
                  email
                  fullName
                  message
                  phoneNumber
                }
                updatedAt
              }
              sysId
            }
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      doctor
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    address
    affiliateCoupon {
      affiliateProductSysId
      affiliateSysId
      anonymousId
      couponId
      createdAt
      opsNote
      orderSysId
      status
      sysId
      updatedAt
      verifiedAt
      verifiedByUserSysId
    }
    approveAt
    atomePaymentAmount
    auditDoctorNotes {
      createdAt
      createdBy
      deletedBy
      isDeleted
      note
      sysId
    }
    completedEvaluation
    consultationSessions
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryMethod
    deliverySnapshot
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    evaluationId
    expiredAt
    intakeInstructions
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isOrderRenew
    isPendingFollowUpConsult
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    isTestOrder
    latestInvoice
    nextReviewDate
    oldOrder {
      id
      isCancelled
      priceId
      status
      subId
    }
    oldPrice
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    patientId
    patientOrderNotes
    patientSnapshot {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      weight
    }
    paymentProvider
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation
    priceDisplayId
    priceInfo
    productGroupData {
      acuitySchedulingAppType
      amountToFreeIncludedPrice
      chargeNowProduct
      country
      crossEvaluation
      displayId
      emailOnCompleteName
      emailTemplate
      evaluationFormId
      id
      includedPriceIds
      overwriteCalendarHeaderTitleInfo
      overwriteProductSubtitleInfo
      platform
      productGroups
      requiresDelivery
      requiresEvaluation
      requiresPrescription
      sysId
      title
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      id
      isShowOnShop
      livemode
      locale
      metadata
      name
      prices
      shopProductGroupIds
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    status
    stripePaymentIntentId
    stripeSubscriptionId
    sysId
    teleConsultProduct
    twilioMessageHistories {
      address
      email
      fullName
      message
      phoneNumber
    }
    updatedAt
  }
}
    `;
export const useGetTeleConsultOrdersQuery = <
      TData = GetTeleConsultOrdersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTeleConsultOrdersQueryVariables,
      options?: UseQueryOptions<GetTeleConsultOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTeleConsultOrdersQuery, TError, TData>(
      ['getTeleConsultOrders', variables],
      fetcher<GetTeleConsultOrdersQuery, GetTeleConsultOrdersQueryVariables>(client, GetTeleConsultOrdersDocument, variables, headers),
      options
    );
export const GetTestMagicLinkDocument = `
    query getTestMagicLink($email: String!) {
  getTestMagicLink(email: $email)
}
    `;
export const useGetTestMagicLinkQuery = <
      TData = GetTestMagicLinkQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTestMagicLinkQueryVariables,
      options?: UseQueryOptions<GetTestMagicLinkQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTestMagicLinkQuery, TError, TData>(
      ['getTestMagicLink', variables],
      fetcher<GetTestMagicLinkQuery, GetTestMagicLinkQueryVariables>(client, GetTestMagicLinkDocument, variables, headers),
      options
    );
export const GetTextConversationFromOpsDocument = `
    query getTextConversationFromOps($input: GetTextConversationFromOpsInput!) {
  getTextConversationFromOps(input: $input) {
    consultationSession {
      countReminder
      createdAt
      doctor {
        active
        calendarId
        country
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            billingAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            bloodPressure
            country
            createdAt
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            orders {
              acuityAppointmentSnapshot {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            user {
              avatar
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              requireConfirmPolicy
              socialProviderType
              sysId
              userType
              utmCampaign
              utmMedium
              utmSource
            }
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
      }
      doctorChatToken
      friendlyName
      gmeetLink
      order {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        acuityAppointments {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          phone
          sysId
          time
          timezone
          type
        }
        address
        affiliateCoupon {
          affiliateProductSysId
          affiliateSysId
          anonymousId
          couponId
          createdAt
          opsNote
          orderSysId
          status
          sysId
          updatedAt
          verifiedAt
          verifiedByUserSysId
        }
        approveAt
        atomePaymentAmount
        auditDoctorNotes {
          createdAt
          createdBy
          deletedBy
          isDeleted
          note
          sysId
        }
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldOrder {
          id
          isCancelled
          priceId
          status
          subId
        }
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        patientSnapshot {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          locale
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          weight
        }
        paymentProvider
        phoneNumber
        pickupLocation {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        platformType
        prescribeAfterTeleConsult
        prescribedAfterTrialOrder {
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        prescription {
          cancelled
          createdAt
          days
          doctorNotes
          endDate
          expiresAt
          isFollowUp
          notedDate
          priceIds
          startDate
          status
          sysId
          treatmentCode
          updatedAt
        }
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productGroupData {
          acuitySchedulingAppType
          amountToFreeIncludedPrice
          chargeNowProduct
          country
          crossEvaluation
          displayId
          emailOnCompleteName
          emailTemplate
          evaluationFormId
          id
          includedPriceIds
          overwriteCalendarHeaderTitleInfo
          overwriteProductSubtitleInfo
          platform
          productGroups
          requiresDelivery
          requiresEvaluation
          requiresPrescription
          sysId
          title
        }
        productInfo {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          id
          isShowOnShop
          livemode
          locale
          metadata
          name
          prices
          shopProductGroupIds
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
        }
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        twilioMessageHistories {
          address
          email
          fullName
          message
          phoneNumber
        }
        updatedAt
      }
      patientChatToken
      status
      sysId
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    participants {
      avatar
      fullName
      identity
      locale
      role
      token
      userSysId
    }
    token
  }
}
    `;
export const useGetTextConversationFromOpsQuery = <
      TData = GetTextConversationFromOpsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTextConversationFromOpsQueryVariables,
      options?: UseQueryOptions<GetTextConversationFromOpsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTextConversationFromOpsQuery, TError, TData>(
      ['getTextConversationFromOps', variables],
      fetcher<GetTextConversationFromOpsQuery, GetTextConversationFromOpsQueryVariables>(client, GetTextConversationFromOpsDocument, variables, headers),
      options
    );
export const GetThankyouDataDocument = `
    query getThankyouData($input: GetThankyouDataInput!) {
  getThankyouData(input: $input) {
    cart {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      calculateOrderSummary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        discountAmountLater
        discountAmountNow
        itemList {
          consultationSessionType
          isEDBundle
          isPayNow
          isRxProduct
          isSkipMedSelecting
          isSubscriptionPrice
          isSubscriptionUpdate
          itemSubTotal
          itemSubTotalAfterDiscount
          mainProductId
          mainProductName
          name
          priceId
          priceType
          productId
          productUniqName
          quantity
          unit_amount
        }
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountBeforeTax
        paymentIntentSummary
        promotionCode
        shippingFee
        subTotal
        subTotalLater
        subTotalNow
        taxes
        taxesLater
        taxesNow
        teleConsultFee
        total
        totalLater
        totalNow
        totalNowAfterCashback
        totalTaxes
      }
      cartItems
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      paidCompletedEvaluationIds
      patient {
        billingAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        bloodPressure
        country
        createdAt
        deliveryAddress {
          address
          city
          country
          firstName
          lastName
          name
          note
          phoneNumber
          postal
          region
          sameAsBilling
          state
          sysId
          type
          unit
        }
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              acuityAppointments {
                appointmentTypeID
                calendar
                calendarID
                calendarJP
                canceled
                confirmationPage
                date
                dateCreated
                datetime
                doctor
                duration
                email
                endTime
                firstName
                id
                isFollowUpConsult
                lastName
                noShow
                orders {
                  address
                  affiliateCoupon {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateProduct {
                      affiliateSysId
                      couponLandingUrl
                      createdAt
                      discountPercentage
                      displayName
                      enabled
                      evalFlow
                      externalPortalUrl
                      slug
                      stripePriceId
                      stripeProductId
                      stripePromotionCode
                      stripePromotionCodeId
                      sysId
                      unitAmount
                      updatedAt
                    }
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    doctor {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    isDeleted
                    note
                    order {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                phone
                sysId
                time
                timezone
                type
              }
              address
              approveAt
              atomePaymentAmount
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              paymentProvider
              phoneNumber
              platformType
              prescribeAfterTeleConsult
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            locale
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            weight
          }
          requireConfirmPolicy
          socialProviderType
          sysId
          userType
          utmCampaign
          utmMedium
          utmSource
        }
        weight
      }
      platform
      promotionCode
      sysId
    }
    cartOrders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    consultOrderIds
    needsBookingOrderIds
    newRxOrders {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      acuityAppointments {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        phone
        sysId
        time
        timezone
        type
      }
      address
      affiliateCoupon {
        affiliateProductSysId
        affiliateSysId
        anonymousId
        couponId
        createdAt
        opsNote
        orderSysId
        status
        sysId
        updatedAt
        verifiedAt
        verifiedByUserSysId
      }
      approveAt
      atomePaymentAmount
      auditDoctorNotes {
        createdAt
        createdBy
        deletedBy
        isDeleted
        note
        sysId
      }
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldOrder {
        id
        isCancelled
        priceId
        status
        subId
      }
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      patientSnapshot {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        locale
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        weight
      }
      paymentProvider
      phoneNumber
      pickupLocation {
        address
        city
        isDisabled
        officeName
        officeNumber
        openingHours
        paymentProviders
        phone
        postalCode
        region
        state
        subRegion
        sysId
        type
        unit
      }
      platformType
      prescribeAfterTeleConsult
      prescribedAfterTrialOrder {
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      prescription {
        cancelled
        createdAt
        days
        doctorNotes
        endDate
        expiresAt
        isFollowUp
        notedDate
        priceIds
        startDate
        status
        sysId
        treatmentCode
        updatedAt
      }
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productGroupData {
        acuitySchedulingAppType
        amountToFreeIncludedPrice
        chargeNowProduct
        country
        crossEvaluation
        displayId
        emailOnCompleteName
        emailTemplate
        evaluationFormId
        id
        includedPriceIds
        overwriteCalendarHeaderTitleInfo
        overwriteProductSubtitleInfo
        platform
        productGroups
        requiresDelivery
        requiresEvaluation
        requiresPrescription
        sysId
        title
      }
      productInfo {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        id
        isShowOnShop
        livemode
        locale
        metadata
        name
        prices
        shopProductGroupIds
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
      }
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      twilioMessageHistories {
        address
        email
        fullName
        message
        phoneNumber
      }
      updatedAt
    }
    textConsultOrderIds
  }
}
    `;
export const useGetThankyouDataQuery = <
      TData = GetThankyouDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetThankyouDataQueryVariables,
      options?: UseQueryOptions<GetThankyouDataQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetThankyouDataQuery, TError, TData>(
      ['getThankyouData', variables],
      fetcher<GetThankyouDataQuery, GetThankyouDataQueryVariables>(client, GetThankyouDataDocument, variables, headers),
      options
    );
export const GetTrtAcuityCalendarIdsDocument = `
    query getTrtAcuityCalendarIds {
  getTrtAcuityCalendarIds
}
    `;
export const useGetTrtAcuityCalendarIdsQuery = <
      TData = GetTrtAcuityCalendarIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetTrtAcuityCalendarIdsQueryVariables,
      options?: UseQueryOptions<GetTrtAcuityCalendarIdsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTrtAcuityCalendarIdsQuery, TError, TData>(
      variables === undefined ? ['getTrtAcuityCalendarIds'] : ['getTrtAcuityCalendarIds', variables],
      fetcher<GetTrtAcuityCalendarIdsQuery, GetTrtAcuityCalendarIdsQueryVariables>(client, GetTrtAcuityCalendarIdsDocument, variables, headers),
      options
    );
export const GetTrtDocumentUrlDocument = `
    query getTrtDocumentUrl($documentSysId: String!) {
  getTrtDocumentUrl(documentSysId: $documentSysId)
}
    `;
export const useGetTrtDocumentUrlQuery = <
      TData = GetTrtDocumentUrlQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTrtDocumentUrlQueryVariables,
      options?: UseQueryOptions<GetTrtDocumentUrlQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTrtDocumentUrlQuery, TError, TData>(
      ['getTrtDocumentUrl', variables],
      fetcher<GetTrtDocumentUrlQuery, GetTrtDocumentUrlQueryVariables>(client, GetTrtDocumentUrlDocument, variables, headers),
      options
    );
export const GetTrtIdentificationUrlDocument = `
    query getTrtIdentificationUrl($orderSysId: String!) {
  getTrtIdentificationUrl(orderSysId: $orderSysId)
}
    `;
export const useGetTrtIdentificationUrlQuery = <
      TData = GetTrtIdentificationUrlQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTrtIdentificationUrlQueryVariables,
      options?: UseQueryOptions<GetTrtIdentificationUrlQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTrtIdentificationUrlQuery, TError, TData>(
      ['getTrtIdentificationUrl', variables],
      fetcher<GetTrtIdentificationUrlQuery, GetTrtIdentificationUrlQueryVariables>(client, GetTrtIdentificationUrlDocument, variables, headers),
      options
    );
export const GetTwilioVideoConsultDataFromDoctorDocument = `
    query getTwilioVideoConsultDataFromDoctor($input: VideoSessionInput!) {
  getTwilioVideoConsultDataFromDoctor(input: $input) {
    drFullName
    order {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    roomName
    twilioAccessToken
  }
}
    `;
export const useGetTwilioVideoConsultDataFromDoctorQuery = <
      TData = GetTwilioVideoConsultDataFromDoctorQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTwilioVideoConsultDataFromDoctorQueryVariables,
      options?: UseQueryOptions<GetTwilioVideoConsultDataFromDoctorQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTwilioVideoConsultDataFromDoctorQuery, TError, TData>(
      ['getTwilioVideoConsultDataFromDoctor', variables],
      fetcher<GetTwilioVideoConsultDataFromDoctorQuery, GetTwilioVideoConsultDataFromDoctorQueryVariables>(client, GetTwilioVideoConsultDataFromDoctorDocument, variables, headers),
      options
    );
export const GetTwilioVideoConsultDataFromPatientDocument = `
    query getTwilioVideoConsultDataFromPatient($input: GetConsultVideoInput!) {
  getTwilioVideoConsultDataFromPatient(input: $input) {
    drFullName
    order {
      acuityAppointmentSnapshot {
        appointmentTypeID
        calendar
        calendarID
        calendarJP
        canceled
        confirmationPage
        date
        dateCreated
        datetime
        doctor
        duration
        email
        endTime
        firstName
        id
        isFollowUpConsult
        lastName
        noShow
        orders {
          acuityAppointmentSnapshot {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              address
              affiliateCoupon {
                affiliate {
                  enabled
                  name
                  portalUrl
                  region
                  slug
                  sysId
                }
                affiliateProduct {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateSysId
                  couponLandingUrl
                  createdAt
                  discountPercentage
                  displayName
                  enabled
                  evalFlow
                  externalPortalUrl
                  slug
                  stripePriceId
                  stripeProductId
                  stripePromotionCode
                  stripePromotionCodeId
                  sysId
                  unitAmount
                  updatedAt
                }
                affiliateProductSysId
                affiliateSysId
                anonymousId
                couponId
                createdAt
                opsNote
                orderSysId
                status
                sysId
                updatedAt
                verifiedAt
                verifiedByUserSysId
              }
              approveAt
              atomePaymentAmount
              auditDoctorNotes {
                createdAt
                createdBy
                deletedBy
                doctor {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  patient {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  userType
                  utmCampaign
                  utmMedium
                  utmSource
                }
                isDeleted
                note
                order {
                  acuityAppointments {
                    appointmentTypeID
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  address
                  affiliateCoupon {
                    affiliateProductSysId
                    affiliateSysId
                    anonymousId
                    couponId
                    createdAt
                    opsNote
                    orderSysId
                    status
                    sysId
                    updatedAt
                    verifiedAt
                    verifiedByUserSysId
                  }
                  approveAt
                  atomePaymentAmount
                  auditDoctorNotes {
                    createdAt
                    createdBy
                    deletedBy
                    isDeleted
                    note
                    sysId
                  }
                  completedEvaluation
                  consultationSessions
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryMethod
                  deliverySnapshot
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isOrderRenew
                  isPendingFollowUpConsult
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  isTestOrder
                  latestInvoice
                  nextReviewDate
                  oldOrder {
                    id
                    isCancelled
                    priceId
                    status
                    subId
                  }
                  oldPrice
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  patientId
                  patientOrderNotes
                  patientSnapshot {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    locale
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    weight
                  }
                  paymentProvider
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      userType
                      utmCampaign
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation
                  priceDisplayId
                  priceInfo
                  productGroupData {
                    acuitySchedulingAppType
                    amountToFreeIncludedPrice
                    chargeNowProduct
                    country
                    crossEvaluation
                    displayId
                    emailOnCompleteName
                    emailTemplate
                    evaluationFormId
                    id
                    includedPriceIds
                    orders {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    overwriteCalendarHeaderTitleInfo
                    overwriteProductSubtitleInfo
                    platform
                    productGroups
                    requiresDelivery
                    requiresEvaluation
                    requiresPrescription
                    sysId
                    title
                  }
                  productInfo {
                    active
                    childrenIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    childrenSecondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    isShowOnShop
                    livemode
                    locale
                    metadata
                    name
                    prices
                    secondIncludedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    shopProductGroupIds
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  twilioMessageHistories {
                    address
                    email
                    fullName
                    message
                    phoneNumber
                  }
                  updatedAt
                }
                sysId
              }
              completedEvaluation
              consultationSessions
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryMethod
              deliverySnapshot
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              evaluationId
              expiredAt
              intakeInstructions
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isOrderRenew
              isPendingFollowUpConsult
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              isTestOrder
              latestInvoice
              nextReviewDate
              oldOrder {
                id
                isCancelled
                priceId
                status
                subId
              }
              oldPrice
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              patientId
              patientOrderNotes
              patientSnapshot {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                locale
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                weight
              }
              paymentProvider
              phoneNumber
              pickupLocation {
                address
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                address
                approveAt
                atomePaymentAmount
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescription {
                cancelled
                createdAt
                days
                doctorNotes
                endDate
                expiresAt
                isFollowUp
                notedDate
                priceIds
                startDate
                status
                sysId
                treatmentCode
                updatedAt
              }
              prescriptionDisplayPriceId
              prescriptionId
              prescriptionOrderCalculation
              priceDisplayId
              priceInfo
              productGroupData {
                acuitySchedulingAppType
                amountToFreeIncludedPrice
                chargeNowProduct
                country
                crossEvaluation
                displayId
                emailOnCompleteName
                emailTemplate
                evaluationFormId
                id
                includedPriceIds
                overwriteCalendarHeaderTitleInfo
                overwriteProductSubtitleInfo
                platform
                productGroups
                requiresDelivery
                requiresEvaluation
                requiresPrescription
                sysId
                title
              }
              productInfo {
                active
                country
                createdAt
                description
                displayId
                evaluationId
                id
                isShowOnShop
                livemode
                locale
                metadata
                name
                prices
                shopProductGroupIds
                statementDescriptor
                sysId
                type
                uniqName
                unitLabel
                updatedAt
              }
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              twilioMessageHistories {
                address
                email
                fullName
                message
                phoneNumber
              }
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          address
          approveAt
          atomePaymentAmount
          completedEvaluation
          consultationSessions
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryMethod
          deliverySnapshot
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          evaluationId
          expiredAt
          intakeInstructions
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isOrderRenew
          isPendingFollowUpConsult
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          isTestOrder
          latestInvoice
          nextReviewDate
          oldPrice
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          patientId
          patientOrderNotes
          paymentProvider
          phoneNumber
          platformType
          prescribeAfterTeleConsult
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation
          priceDisplayId
          priceInfo
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        phone
        sysId
        time
        timezone
        type
      }
      address
      approveAt
      atomePaymentAmount
      completedEvaluation
      consultationSessions
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryMethod
      deliverySnapshot
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      evaluationId
      expiredAt
      intakeInstructions
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isOrderRenew
      isPendingFollowUpConsult
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      isTestOrder
      latestInvoice
      nextReviewDate
      oldPrice
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      patientId
      patientOrderNotes
      paymentProvider
      phoneNumber
      platformType
      prescribeAfterTeleConsult
      prescriptionDisplayPriceId
      prescriptionId
      prescriptionOrderCalculation
      priceDisplayId
      priceInfo
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    roomName
    twilioAccessToken
  }
}
    `;
export const useGetTwilioVideoConsultDataFromPatientQuery = <
      TData = GetTwilioVideoConsultDataFromPatientQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTwilioVideoConsultDataFromPatientQueryVariables,
      options?: UseQueryOptions<GetTwilioVideoConsultDataFromPatientQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTwilioVideoConsultDataFromPatientQuery, TError, TData>(
      ['getTwilioVideoConsultDataFromPatient', variables],
      fetcher<GetTwilioVideoConsultDataFromPatientQuery, GetTwilioVideoConsultDataFromPatientQueryVariables>(client, GetTwilioVideoConsultDataFromPatientDocument, variables, headers),
      options
    );
export const GetUsersByRoleDocument = `
    query getUsersByRole($input: GetUsersByRoleInput!) {
  getUsersByRole(input: $input) {
    avatar
    email
    firstName
    fullName
    id
    isPharmacist
    lastName
    patient {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
      weight
    }
    requireConfirmPolicy
    socialProviderType
    sysId
    userType
    utmCampaign
    utmMedium
    utmSource
  }
}
    `;
export const useGetUsersByRoleQuery = <
      TData = GetUsersByRoleQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUsersByRoleQueryVariables,
      options?: UseQueryOptions<GetUsersByRoleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUsersByRoleQuery, TError, TData>(
      ['getUsersByRole', variables],
      fetcher<GetUsersByRoleQuery, GetUsersByRoleQueryVariables>(client, GetUsersByRoleDocument, variables, headers),
      options
    );
export const HosOpsAlertDocument = `
    query hosOpsAlert($id: ID!) {
  hosOpsAlert(id: $id) {
    id
    kind
    patientLabel
    flagId
    flagState
    flagLive
    flagOpsClearable
    ruleId
    severity
    source
    status
    summary
    classifierRationale
    instructionCopyKey
    playbookCopyKeys
    playbookSteps {
      order
      instruction
      owner
      slaMinutes
      copyKey
    }
    deliveries {
      channel
      status
      providerId
      attemptedAt
      reason
    }
    slackPosted
    freshchatConversationId
    patientChannels
    opsChannels
    patientAcknowledgedAt
    firedAt
    lastSeenAt
    recurrenceCount
    ackedAt
    ackedBy
    closedAt
    actionEntries {
      action
      note
      actor
      at
    }
  }
}
    `;
export const useHosOpsAlertQuery = <
      TData = HosOpsAlertQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: HosOpsAlertQueryVariables,
      options?: UseQueryOptions<HosOpsAlertQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<HosOpsAlertQuery, TError, TData>(
      ['hosOpsAlert', variables],
      fetcher<HosOpsAlertQuery, HosOpsAlertQueryVariables>(client, HosOpsAlertDocument, variables, headers),
      options
    );
export const HosOpsAlertsDocument = `
    query hosOpsAlerts($status: [HosOpsAlertStatus!], $severity: [HosSafetySeverity!], $limit: Int, $offset: Int) {
  hosOpsAlerts(
    status: $status
    severity: $severity
    limit: $limit
    offset: $offset
  ) {
    id
    kind
    patientLabel
    ruleId
    severity
    source
    status
    summary
    firedAt
    lastSeenAt
    recurrenceCount
  }
}
    `;
export const useHosOpsAlertsQuery = <
      TData = HosOpsAlertsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: HosOpsAlertsQueryVariables,
      options?: UseQueryOptions<HosOpsAlertsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<HosOpsAlertsQuery, TError, TData>(
      variables === undefined ? ['hosOpsAlerts'] : ['hosOpsAlerts', variables],
      fetcher<HosOpsAlertsQuery, HosOpsAlertsQueryVariables>(client, HosOpsAlertsDocument, variables, headers),
      options
    );
export const LogOutDocument = `
    query logOut {
  logOut
}
    `;
export const useLogOutQuery = <
      TData = LogOutQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: LogOutQueryVariables,
      options?: UseQueryOptions<LogOutQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LogOutQuery, TError, TData>(
      variables === undefined ? ['logOut'] : ['logOut', variables],
      fetcher<LogOutQuery, LogOutQueryVariables>(client, LogOutDocument, variables, headers),
      options
    );
export const MyBloodPressureReadingsDocument = `
    query myBloodPressureReadings {
  myBloodPressureReadings {
    diastolic
    recordedAt
    source
    sysId
    systolic
    type
  }
}
    `;
export const useMyBloodPressureReadingsQuery = <
      TData = MyBloodPressureReadingsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MyBloodPressureReadingsQueryVariables,
      options?: UseQueryOptions<MyBloodPressureReadingsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MyBloodPressureReadingsQuery, TError, TData>(
      variables === undefined ? ['myBloodPressureReadings'] : ['myBloodPressureReadings', variables],
      fetcher<MyBloodPressureReadingsQuery, MyBloodPressureReadingsQueryVariables>(client, MyBloodPressureReadingsDocument, variables, headers),
      options
    );
export const ParseAffiliateGoogleFormDocument = `
    query parseAffiliateGoogleForm($url: String!) {
  parseAffiliateGoogleForm(url: $url) {
    fields {
      entryId
      label
    }
    suggestedMap
  }
}
    `;
export const useParseAffiliateGoogleFormQuery = <
      TData = ParseAffiliateGoogleFormQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ParseAffiliateGoogleFormQueryVariables,
      options?: UseQueryOptions<ParseAffiliateGoogleFormQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ParseAffiliateGoogleFormQuery, TError, TData>(
      ['parseAffiliateGoogleForm', variables],
      fetcher<ParseAffiliateGoogleFormQuery, ParseAffiliateGoogleFormQueryVariables>(client, ParseAffiliateGoogleFormDocument, variables, headers),
      options
    );
export const PreblockAvailableDatesDocument = `
    query preblockAvailableDates($input: PreblockSlotsInput!) {
  preblockAvailableDates(input: $input) {
    slotsAvailable
    time
  }
}
    `;
export const usePreblockAvailableDatesQuery = <
      TData = PreblockAvailableDatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: PreblockAvailableDatesQueryVariables,
      options?: UseQueryOptions<PreblockAvailableDatesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PreblockAvailableDatesQuery, TError, TData>(
      ['preblockAvailableDates', variables],
      fetcher<PreblockAvailableDatesQuery, PreblockAvailableDatesQueryVariables>(client, PreblockAvailableDatesDocument, variables, headers),
      options
    );
export const PreblockAvailableTimesDocument = `
    query preblockAvailableTimes($input: PreblockTimesInput!) {
  preblockAvailableTimes(input: $input) {
    slotsAvailable
    time
  }
}
    `;
export const usePreblockAvailableTimesQuery = <
      TData = PreblockAvailableTimesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: PreblockAvailableTimesQueryVariables,
      options?: UseQueryOptions<PreblockAvailableTimesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PreblockAvailableTimesQuery, TError, TData>(
      ['preblockAvailableTimes', variables],
      fetcher<PreblockAvailableTimesQuery, PreblockAvailableTimesQueryVariables>(client, PreblockAvailableTimesDocument, variables, headers),
      options
    );
export const PrescriptionsDocument = `
    query prescriptions($videoLink: String!, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit: Float, $offset: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink1: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit1: Int, $offset1: Int, $order: JSON, $input6: ConsultationListInput!, $limit2: Int, $offset2: Int, $order1: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $limit3: Int, $offset3: Int, $order2: JSON, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $orderId2: String, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform12: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $acuityAppointmentId4: String, $date6: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date7: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input10: V2ConsultationFilterInput!, $input11: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input12: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput6: ConsultationAuditFilterInput, $inputConsultation7: V2ConsultationFilterInput, $platform13: String, $input13: OrderInput!, $pagination1: V2PaginationInput!, $date8: String, $date9: Float, $input14: GetPatientInput, $platform14: String, $platform15: String, $platform16: String, $platform17: String, $platform18: String, $input15: StripeProductFilterV2, $input16: V2ConsultationFilterInput!, $input17: ConsultationMessagesInput!, $limit8: Int, $offset8: Int, $order7: JSON, $input18: ConsultationListInput!, $limit9: Int, $offset9: Int, $order8: JSON, $doctorFilterInput4: V2DoctorInputFilter, $doctorFilterInput5: V2DoctorInputFilter, $input19: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input20: GetPatientInput, $platform19: String, $input21: StripeProductFilterV2, $consultAuditFilterInput7: ConsultationAuditFilterInput, $inputConsultation8: V2ConsultationFilterInput, $platform20: String, $input22: CrossSellRecordQueryInput, $acuityAppointmentId6: String, $date12: String, $forDelivery6: Boolean, $isReschedule6: Boolean, $orderId7: String, $acuityAppointmentId7: String, $consultDate3: Float, $date13: Float, $forDelivery7: Boolean, $isReschedule7: Boolean, $orderId8: String, $input23: V2ConsultationFilterInput!, $input24: ConsultationMessagesInput!, $limit10: Int, $offset10: Int, $order9: JSON, $input25: ConsultationListInput!, $limit11: Int, $offset11: Int, $order10: JSON, $doctorFilterInput6: V2DoctorInputFilter, $doctorFilterInput7: V2DoctorInputFilter, $input26: OrderInput!, $pagination3: V2PaginationInput!, $date14: String, $date15: Float, $input27: GetPatientInput, $platform21: String, $input28: StripeProductFilterV2, $platform22: String, $platform23: String, $input29: V2PrescriptionFilterInput!) {
  prescriptions(input: $input29) {
    approver {
      admin {
        crossSellRecords(input: $input22) {
          childOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            activeConsultation {
              consultationAudit {
                consultTime
                consultType
                createdBy
                doctor {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink) {
                    gmeetLink
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit, offset: $offset, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit1
                      offset: $offset1
                      order: $order
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit2, offset: $offset2, order: $order1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                evaluationId
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  activeConsultation {
                    consultationMessages(limit: $limit3, offset: $offset3, order: $order2) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sessionType
                status
                sysId
              }
              countReminder
              createdAt
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              orderSysId
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            acuityAppointment {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            acuityAppointments {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            additionalPrices {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            afterVideoConsultRedirecting {
              baseUrl
              path
            }
            approveAt
            atomeNextSendingInvoiceDate
            atomePayments {
              amount
              paymentUrl
              priceId
              referenceId
              status
              sysId
            }
            checkoutSession {
              checkoutData
              evaluationId
              status
              sysId
            }
            childrenOrders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            claimedRetentionOffer
            consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
              consultTime
              consultType
              createdBy
              evaluationId
              sessionType
              status
              sysId
            }
            consultations(inputConsultation: $inputConsultation5) {
              countReminder
              createdAt
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              orderSysId
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluation {
              isCompleted
              isSkipped
              name
              patientNote
              platform
              status
              sysId
              type
            }
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            latestAtomePayment {
              amount
              paymentUrl
              priceId
              referenceId
              status
              sysId
            }
            latestInvoice {
              amount_due
              hosted_invoice_url
              id
              next_payment_attempt
              paid
              paymentStatus
              period_end
              starting_balance
              status
              subtotal
              tax
              total
            }
            latestNote {
              content
              createdAt
              createdBy
              sysId
              updatedAt
            }
            nextReviewDate
            oldPrice
            oldPriceInfo {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patient {
              bloodPressure
              country
              createdAt
              dob
              email
              fbc
              fbp
              firstName
              fromPlatformEnv
              fullName
              gender
              height
              icNumber
              idVerifiedAt
              identification
              isAlreadyCheckout
              isReferredBy
              lastName
              legalName
              locale
              mounjaroTrialEligible
              paidCompletedEvaluationIds
              phoneNumber
              referralCode
              stripeCustomer
              stripeCustomerId
              sysId
              userSysId
              weight
            }
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            pickupLocation {
              address
              city
              isDisabled
              officeName
              officeNumber
              openingHours
              paymentProviders
              phone
              postalCode
              region
              state
              subRegion
              sysId
              type
              unit
            }
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribedAfterTrialOrder {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            prescribed_after_trial_order_sys_id
            prescription {
              cancelled
              createdAt
              days
              doctorNotes
              endDate
              expiresAt
              isFollowUp
              notedDate
              priceIds
              startDate
              status
              sysId
              treatmentCode
              updatedAt
            }
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation {
              cashbackEarnRate
              cashbackEarned
              cashbackRedeemed
              consultBasePrice
              consultFee
              consultFeeAfterDiscount
              consultTax
              consultTransactionFee
              discountAmount
              isConsult
              mainBasePrice
              mainTax
              mainTransactionFee
              minimalAmountPayment
              paymentIntentAmount
              paymentIntentAmountAfterCashback
              paymentIntentSummary
              priceId
              productPriceAmount
              productPriceAmountAfterDiscount
              promotionCode
              shouldChargeConsultFee
              subTotal
              total
              totalAfterCashback
            }
            price {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            priceDisplayId
            priceInfo {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform11)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            siblingCrossSellOrders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            status
            stripePaymentIntentId
            stripeSubscriptionId
            subscription {
              cancel_at_period_end
              current_period_end
              current_period_start
              default_payment_method
              id
              items
              latest_invoice
              metadata
              pause_collection
              pending_setup_intent
              pending_update
              status
            }
            sysId
            teleConsultProduct
            upcomingInvoice {
              amount_due
              hosted_invoice_url
              id
              next_payment_attempt
              paid
              paymentStatus
              period_end
              starting_balance
              status
              subtotal
              tax
              total
            }
            updatedAt
          }
          childOrderId
          createdAt
          createdBy
          creator {
            admin {
              order(orderId: $orderId2) {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                count
                items {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  activeConsultation {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientNote
                    platform
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                  }
                  latestNote {
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    cancelled
                    createdAt
                    days
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    priceIds
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform12)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                  }
                  updatedAt
                }
                limit
                offset
              }
              patient(patientId: $patientId1) {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
            }
            avatar
            calendarDates(
              acuityAppointmentId: $acuityAppointmentId2
              date: $date4
              forDelivery: $forDelivery2
              isReschedule: $isReschedule2
              orderId: $orderId3
            ) {
              date
            }
            calendarTimes(
              acuityAppointmentId: $acuityAppointmentId3
              consultDate: $consultDate1
              date: $date5
              forDelivery: $forDelivery3
              isReschedule: $isReschedule3
              orderId: $orderId4
            ) {
              time
            }
            consultation(input: $input16) {
              consultationAudit {
                consultTime
                consultType
                createdBy
                evaluationId
                sessionType
                status
                sysId
              }
              consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                count
                items {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                limit
                offset
              }
              consultationTitle {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              countReminder
              createdAt
              doctor {
                active
                calendarId
                country
                designation
                duration
                email
                firstName
                fullName
                lastName
                sysId
                textConsultPostalCodes
                trtEligible
              }
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              messages {
                automatedMessage {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                consultationSysId
                content
                createdAt
                readAt
                sysId
                updatedAt
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              orderSysId
              participants {
                avatar
                fullName
                identity
                locale
                role
                token
                userSysId
              }
              participantsV2 {
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId4
                  date: $date6
                  forDelivery: $forDelivery4
                  isReschedule: $isReschedule4
                  orderId: $orderId5
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId5
                  consultDate: $consultDate2
                  date: $date7
                  forDelivery: $forDelivery5
                  isReschedule: $isReschedule5
                  orderId: $orderId6
                ) {
                  time
                }
                consultation(input: $input10) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input11
                  limit: $limit6
                  offset: $offset6
                  order: $order5
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input12, limit: $limit7, offset: $offset7, order: $order6) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  bio {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  calendarId
                  consultation(videoLink: $videoLink2) {
                    gmeetLink
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                orders(input: $input13, pagination: $pagination1) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  activeConsultation {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput6) {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation7) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientNote
                    platform
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                  }
                  latestNote {
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    cancelled
                    createdAt
                    days
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    priceIds
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                  }
                  updatedAt
                }
                partnerConsultDates(date: $date8) {
                  date
                }
                partnerConsultTimes(date: $date9) {
                  time
                }
                patient(input: $input14) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                patientDocuments {
                  createdAt
                  orderSysId
                  ref
                  sysId
                  type
                  url
                }
                phoneNumber
                prescriptionCalculation {
                  affiliateCouponNotApplied {
                    affiliateProductDisplayName
                    reason
                  }
                  isAffiliateLocked
                  otcCalculationSummary {
                    otcOrdersCalculation {
                      basePrice
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      discountAmount
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      stripePromotionCode
                      tax
                      transactionFee
                    }
                    totalBasePrice
                    totalCashbackEarned
                    totalCashbackRedeemed
                    totalPaymentIntentAmount
                    totalTax
                    totalTransactionFee
                  }
                  promotionCodeError
                  rxCalculationSummary {
                    rxOrdersCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    total
                    totalCashbackEarned
                    totalCashbackRedeemed
                    totalDiscountAmount
                    totalMainBasePrice
                    totalPaymentIntentAmount
                    totalPaymentIntentAmountAfterCashback
                    totalTax
                    totalTransactionFee
                  }
                  stripePromotionCode
                }
                requireConfirmPolicy
                socialProviderType
                stripeProducts(input: $input15) {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform14)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform15)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredientDetails {
                    description
                    imageLink
                    locale
                    name
                    strength
                    uniqueName
                  }
                  ingredients
                  isConsultOnly(platform: $platform16)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  prices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInstructions {
                    language
                    localeKey
                    productId
                    sysId
                    translatedText
                  }
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  tempPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform18)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  texts {
                    benefits
                    category
                    display_price
                    display_price_patient
                    dosage_variant_body
                    dosage_variant_title
                    effective_in
                    for
                    frequency_variant_title
                    good_to_know
                    how_to_take
                    how_to_use
                    is_popular
                    lasts_for
                    platform
                    product_description
                    product_name
                    product_short_description
                    quantity_per_unit
                    quantity_variant_title
                    requires_prescription
                    safety_information
                    side_effects
                    strength
                    taken
                    unit
                    unit_patient
                  }
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            consultationMessages(
              input: $input17
              limit: $limit8
              offset: $offset8
              order: $order7
            ) {
              count
              limit
              offset
            }
            consultations(input: $input18, limit: $limit9, offset: $offset9, order: $order8) {
              countReminder
              createdAt
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              orderSysId
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            doctor(doctorFilterInput: $doctorFilterInput4) {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            doctors(doctorFilterInput: $doctorFilterInput5) {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            email
            firstName
            fullName
            id
            isPharmacist
            lastName
            locale
            ninjaVanToken
            orders(input: $input19, pagination: $pagination2) {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            partnerConsultDates(date: $date10) {
              date
            }
            partnerConsultTimes(date: $date11) {
              time
            }
            patient(input: $input20) {
              bloodPressure
              country
              createdAt
              dob
              email
              fbc
              fbp
              firstName
              fromPlatformEnv
              fullName
              gender
              height
              icNumber
              idVerifiedAt
              identification
              isAlreadyCheckout
              isReferredBy
              lastName
              legalName
              locale
              mounjaroTrialEligible
              paidCompletedEvaluationIds
              phoneNumber
              referralCode
              stripeCustomer
              stripeCustomerId
              sysId
              userSysId
              weight
            }
            patientDocuments {
              createdAt
              orderSysId
              ref
              sysId
              type
              url
            }
            phoneNumber
            prescriptionCalculation {
              isAffiliateLocked
              promotionCodeError
              stripePromotionCode
            }
            requireConfirmPolicy
            socialProviderType
            stripeProducts(input: $input21) {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform19)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            sysId
            tempToken
            tempTokenExpired
            userType
            utmCampaign
            utmId
            utmMedium
            utmSource
          }
          parentOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            activeConsultation {
              countReminder
              createdAt
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              orderSysId
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            acuityAppointment {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            acuityAppointments {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            additionalPrices {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            afterVideoConsultRedirecting {
              baseUrl
              path
            }
            approveAt
            atomeNextSendingInvoiceDate
            atomePayments {
              amount
              paymentUrl
              priceId
              referenceId
              status
              sysId
            }
            checkoutSession {
              checkoutData
              evaluationId
              status
              sysId
            }
            childrenOrders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            claimedRetentionOffer
            consultationAudits(consultAuditFilterInput: $consultAuditFilterInput7) {
              consultTime
              consultType
              createdBy
              evaluationId
              sessionType
              status
              sysId
            }
            consultations(inputConsultation: $inputConsultation8) {
              countReminder
              createdAt
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              orderSysId
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluation {
              isCompleted
              isSkipped
              name
              patientNote
              platform
              status
              sysId
              type
            }
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            latestAtomePayment {
              amount
              paymentUrl
              priceId
              referenceId
              status
              sysId
            }
            latestInvoice {
              amount_due
              hosted_invoice_url
              id
              next_payment_attempt
              paid
              paymentStatus
              period_end
              starting_balance
              status
              subtotal
              tax
              total
            }
            latestNote {
              content
              createdAt
              createdBy
              sysId
              updatedAt
            }
            nextReviewDate
            oldPrice
            oldPriceInfo {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patient {
              bloodPressure
              country
              createdAt
              dob
              email
              fbc
              fbp
              firstName
              fromPlatformEnv
              fullName
              gender
              height
              icNumber
              idVerifiedAt
              identification
              isAlreadyCheckout
              isReferredBy
              lastName
              legalName
              locale
              mounjaroTrialEligible
              paidCompletedEvaluationIds
              phoneNumber
              referralCode
              stripeCustomer
              stripeCustomerId
              sysId
              userSysId
              weight
            }
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            pickupLocation {
              address
              city
              isDisabled
              officeName
              officeNumber
              openingHours
              paymentProviders
              phone
              postalCode
              region
              state
              subRegion
              sysId
              type
              unit
            }
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribedAfterTrialOrder {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            prescribed_after_trial_order_sys_id
            prescription {
              cancelled
              createdAt
              days
              doctorNotes
              endDate
              expiresAt
              isFollowUp
              notedDate
              priceIds
              startDate
              status
              sysId
              treatmentCode
              updatedAt
            }
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation {
              cashbackEarnRate
              cashbackEarned
              cashbackRedeemed
              consultBasePrice
              consultFee
              consultFeeAfterDiscount
              consultTax
              consultTransactionFee
              discountAmount
              isConsult
              mainBasePrice
              mainTax
              mainTransactionFee
              minimalAmountPayment
              paymentIntentAmount
              paymentIntentAmountAfterCashback
              paymentIntentSummary
              priceId
              productPriceAmount
              productPriceAmountAfterDiscount
              promotionCode
              shouldChargeConsultFee
              subTotal
              total
              totalAfterCashback
            }
            price {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            priceDisplayId
            priceInfo {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform20)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            siblingCrossSellOrders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            status
            stripePaymentIntentId
            stripeSubscriptionId
            subscription {
              cancel_at_period_end
              current_period_end
              current_period_start
              default_payment_method
              id
              items
              latest_invoice
              metadata
              pause_collection
              pending_setup_intent
              pending_update
              status
            }
            sysId
            teleConsultProduct
            upcomingInvoice {
              amount_due
              hosted_invoice_url
              id
              next_payment_attempt
              paid
              paymentStatus
              period_end
              starting_balance
              status
              subtotal
              tax
              total
            }
            updatedAt
          }
          parentOrderId
          priceId
          selectedBy
          stripeProductPrice {
            importPriceId
            isBundle
            priceActive
            priceBillingScheme
            priceCreated
            priceCurrency
            priceDisplayId
            priceFirstTimeAlternativePrice
            priceFirstTimeTryingInMonths
            priceId
            priceLivemode
            priceNickname
            priceProduct
            priceTaxBehavior
            priceUnitAmount
            priceUnitAmountDecimal
            productActive
            productDescription
            productDisplayId
            productId
            productLivemode
            productName
            productStatementDescriptor
            productType
            productUniqName
            productUnitLabel
            sysId
          }
          sysId
        }
      }
      avatar
      calendarDates(
        acuityAppointmentId: $acuityAppointmentId6
        date: $date12
        forDelivery: $forDelivery6
        isReschedule: $isReschedule6
        orderId: $orderId7
      ) {
        date
      }
      calendarTimes(
        acuityAppointmentId: $acuityAppointmentId7
        consultDate: $consultDate3
        date: $date13
        forDelivery: $forDelivery7
        isReschedule: $isReschedule7
        orderId: $orderId8
      ) {
        time
      }
      consultation(input: $input23) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      consultationMessages(
        input: $input24
        limit: $limit10
        offset: $offset10
        order: $order9
      ) {
        count
        limit
        offset
      }
      consultations(
        input: $input25
        limit: $limit11
        offset: $offset11
        order: $order10
      ) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      doctor(doctorFilterInput: $doctorFilterInput6) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      doctors(doctorFilterInput: $doctorFilterInput7) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      orders(input: $input26, pagination: $pagination3) {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      partnerConsultDates(date: $date14) {
        date
      }
      partnerConsultTimes(date: $date15) {
        time
      }
      patient(input: $input27) {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      patientDocuments {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      phoneNumber
      prescriptionCalculation {
        isAffiliateLocked
        promotionCodeError
        stripePromotionCode
      }
      requireConfirmPolicy
      socialProviderType
      stripeProducts(input: $input28) {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        ingredients
        isConsultOnly(platform: $platform21)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    cancelled
    createdAt
    days
    doctor {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    doctorNotes
    endDate
    expiresAt
    isFollowUp
    notedDate
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    priceIds
    products {
      active
      country
      createdAt
      description
      displayId
      drDosageFrequency {
        alternativeDosage
        alternativeDosageUnit
        asNeeded
        dosage
        dosageUnit
        duration
        durationUnit
        frequency
        productId
        quantity
        quantityUnit
      }
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        ingredients
        isConsultOnly(platform: $platform22)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      ingredientDetails {
        description
        imageLink
        locale
        name
        strength
        uniqueName
      }
      ingredients
      isConsultOnly(platform: $platform23)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      prices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      productInstructions {
        language
        localeKey
        productId
        sysId
        translatedText
      }
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      tempPrices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      texts {
        benefits
        category
        display_price
        display_price_patient
        dosage_variant_body
        dosage_variant_title
        effective_in
        for
        frequency_variant_title
        good_to_know
        how_to_take
        how_to_use
        is_popular
        lasts_for
        platform
        product_description
        product_name
        product_short_description
        quantity_per_unit
        quantity_variant_title
        requires_prescription
        safety_information
        side_effects
        strength
        taken
        unit
        unit_patient
      }
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    startDate
    status
    sysId
    treatmentCode
    updatedAt
  }
}
    `;
export const usePrescriptionsQuery = <
      TData = PrescriptionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: PrescriptionsQueryVariables,
      options?: UseQueryOptions<PrescriptionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PrescriptionsQuery, TError, TData>(
      ['prescriptions', variables],
      fetcher<PrescriptionsQuery, PrescriptionsQueryVariables>(client, PrescriptionsDocument, variables, headers),
      options
    );
export const SendEmailForOldOrdersDocument = `
    query sendEmailForOldOrders {
  sendEmailForOldOrders
}
    `;
export const useSendEmailForOldOrdersQuery = <
      TData = SendEmailForOldOrdersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SendEmailForOldOrdersQueryVariables,
      options?: UseQueryOptions<SendEmailForOldOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SendEmailForOldOrdersQuery, TError, TData>(
      variables === undefined ? ['sendEmailForOldOrders'] : ['sendEmailForOldOrders', variables],
      fetcher<SendEmailForOldOrdersQuery, SendEmailForOldOrdersQueryVariables>(client, SendEmailForOldOrdersDocument, variables, headers),
      options
    );
export const SyncConversationForExistingOrdersDocument = `
    query syncConversationForExistingOrders {
  syncConversationForExistingOrders
}
    `;
export const useSyncConversationForExistingOrdersQuery = <
      TData = SyncConversationForExistingOrdersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SyncConversationForExistingOrdersQueryVariables,
      options?: UseQueryOptions<SyncConversationForExistingOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SyncConversationForExistingOrdersQuery, TError, TData>(
      variables === undefined ? ['syncConversationForExistingOrders'] : ['syncConversationForExistingOrders', variables],
      fetcher<SyncConversationForExistingOrdersQuery, SyncConversationForExistingOrdersQueryVariables>(client, SyncConversationForExistingOrdersDocument, variables, headers),
      options
    );
export const TriggerChargeConsultFeeConsumerDocument = `
    query triggerChargeConsultFeeConsumer($jobId: String!) {
  triggerChargeConsultFeeConsumer(jobId: $jobId)
}
    `;
export const useTriggerChargeConsultFeeConsumerQuery = <
      TData = TriggerChargeConsultFeeConsumerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: TriggerChargeConsultFeeConsumerQueryVariables,
      options?: UseQueryOptions<TriggerChargeConsultFeeConsumerQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TriggerChargeConsultFeeConsumerQuery, TError, TData>(
      ['triggerChargeConsultFeeConsumer', variables],
      fetcher<TriggerChargeConsultFeeConsumerQuery, TriggerChargeConsultFeeConsumerQueryVariables>(client, TriggerChargeConsultFeeConsumerDocument, variables, headers),
      options
    );
export const TrtOrdersDocument = `
    query trtOrders($filter: TrtOrdersFilterInput) {
  trtOrders(filter: $filter) {
    count
    items {
      bloodTestCards {
        documents {
          cardKind
          createdAt
          ref
          role
          series
          sysId
          type
        }
        drawConfirmedAt
        key
        kind
        orderStatus
        phase
        resultReceivedAt
        section
        sortAt
        sortIndex
      }
      createdAt
      documents {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      drawConfirmations {
        confirmedAt
        drawType
        orderSysId
        sysId
      }
      isFollowUp
      isTestOrder
      latestBloodPressure {
        diastolic
        recordedAt
        source
        sysId
        systolic
        type
      }
      orderLineage {
        bloodTestCards {
          documents {
            cardKind
            createdAt
            ref
            role
            series
            sysId
            type
          }
          drawConfirmedAt
          key
          kind
          orderStatus
          phase
          resultReceivedAt
          section
          sortAt
          sortIndex
        }
        createdAt
        followUpForOrderShortId
        followUpForOrderSysId
        isCurrent
        isFollowUp
        kind
        shortId
        status
        sysId
        documents {
          createdAt
          orderSysId
          ref
          sysId
          type
          url
        }
      }
      paid
      patient {
        dob
        email
        firstName
        gender
        hasIdentificationImage
        icNumber
        idVerifiedAt
        lastName
        legalName
        sysId
      }
      shortId
      skus {
        name
        priceId
        slot
      }
      status
      sysId
    }
  }
}
    `;
export const useTrtOrdersQuery = <
      TData = TrtOrdersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: TrtOrdersQueryVariables,
      options?: UseQueryOptions<TrtOrdersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TrtOrdersQuery, TError, TData>(
      variables === undefined ? ['trtOrders'] : ['trtOrders', variables],
      fetcher<TrtOrdersQuery, TrtOrdersQueryVariables>(client, TrtOrdersDocument, variables, headers),
      options
    );
export const UserDocument = `
    query user($email: String, $sysId: String) {
  user(email: $email, sysId: $sysId) {
    avatar
    email
    firstName
    fullName
    id
    isPharmacist
    lastName
    patient {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
      weight
    }
    requireConfirmPolicy
    socialProviderType
    sysId
    userType
    utmCampaign
    utmMedium
    utmSource
  }
}
    `;
export const useUserQuery = <
      TData = UserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: UserQueryVariables,
      options?: UseQueryOptions<UserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UserQuery, TError, TData>(
      variables === undefined ? ['user'] : ['user', variables],
      fetcher<UserQuery, UserQueryVariables>(client, UserDocument, variables, headers),
      options
    );
export const UsersDocument = `
    query users($limit: Int, $offset: Int, $order: JSON) {
  users(limit: $limit, offset: $offset, order: $order) {
    avatar
    email
    firstName
    fullName
    id
    isPharmacist
    lastName
    patient {
      billingAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      bloodPressure
      country
      createdAt
      deliveryAddress {
        address
        city
        country
        firstName
        lastName
        name
        note
        phoneNumber
        postal
        region
        sameAsBilling
        state
        sysId
        type
        unit
      }
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      locale
      orders {
        acuityAppointmentSnapshot {
          appointmentTypeID
          calendar
          calendarID
          calendarJP
          canceled
          confirmationPage
          date
          dateCreated
          datetime
          doctor
          duration
          email
          endTime
          firstName
          id
          isFollowUpConsult
          lastName
          noShow
          orders {
            acuityAppointments {
              appointmentTypeID
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              doctor
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              orders {
                address
                affiliateCoupon {
                  affiliate {
                    enabled
                    name
                    portalUrl
                    region
                    slug
                    sysId
                  }
                  affiliateProduct {
                    affiliate {
                      enabled
                      name
                      portalUrl
                      region
                      slug
                      sysId
                    }
                    affiliateSysId
                    couponLandingUrl
                    createdAt
                    discountPercentage
                    displayName
                    enabled
                    evalFlow
                    externalPortalUrl
                    slug
                    stripePriceId
                    stripeProductId
                    stripePromotionCode
                    stripePromotionCodeId
                    sysId
                    unitAmount
                    updatedAt
                  }
                  affiliateProductSysId
                  affiliateSysId
                  anonymousId
                  couponId
                  createdAt
                  opsNote
                  orderSysId
                  status
                  sysId
                  updatedAt
                  verifiedAt
                  verifiedByUserSysId
                }
                approveAt
                atomePaymentAmount
                auditDoctorNotes {
                  createdAt
                  createdBy
                  deletedBy
                  doctor {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  isDeleted
                  note
                  order {
                    acuityAppointmentSnapshot {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      doctor
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    address
                    affiliateCoupon {
                      affiliateProductSysId
                      affiliateSysId
                      anonymousId
                      couponId
                      createdAt
                      opsNote
                      orderSysId
                      status
                      sysId
                      updatedAt
                      verifiedAt
                      verifiedByUserSysId
                    }
                    approveAt
                    atomePaymentAmount
                    auditDoctorNotes {
                      createdAt
                      createdBy
                      deletedBy
                      isDeleted
                      note
                      sysId
                    }
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldOrder {
                      id
                      isCancelled
                      priceId
                      status
                      subId
                    }
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    patientSnapshot {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  sysId
                }
                completedEvaluation
                consultationSessions
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryMethod
                deliverySnapshot
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                evaluationId
                expiredAt
                intakeInstructions
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isOrderRenew
                isPendingFollowUpConsult
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                isTestOrder
                latestInvoice
                nextReviewDate
                oldOrder {
                  id
                  isCancelled
                  priceId
                  status
                  subId
                }
                oldPrice
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                patientId
                patientOrderNotes
                patientSnapshot {
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  locale
                  orders {
                    address
                    approveAt
                    atomePaymentAmount
                    completedEvaluation
                    consultationSessions
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryMethod
                    deliverySnapshot
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isOrderRenew
                    isPendingFollowUpConsult
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    isTestOrder
                    latestInvoice
                    nextReviewDate
                    oldPrice
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    patientId
                    patientOrderNotes
                    paymentProvider
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      address
                      approveAt
                      atomePaymentAmount
                      completedEvaluation
                      consultationSessions
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryMethod
                      deliverySnapshot
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isOrderRenew
                      isPendingFollowUpConsult
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      isTestOrder
                      latestInvoice
                      nextReviewDate
                      oldPrice
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      patientId
                      patientOrderNotes
                      paymentProvider
                      phoneNumber
                      platformType
                      prescribeAfterTeleConsult
                      prescriptionDisplayPriceId
                      prescriptionId
                      prescriptionOrderCalculation
                      priceDisplayId
                      priceInfo
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation
                    priceDisplayId
                    priceInfo
                    productGroupData {
                      acuitySchedulingAppType
                      amountToFreeIncludedPrice
                      chargeNowProduct
                      country
                      crossEvaluation
                      displayId
                      emailOnCompleteName
                      emailTemplate
                      evaluationFormId
                      id
                      includedPriceIds
                      overwriteCalendarHeaderTitleInfo
                      overwriteProductSubtitleInfo
                      platform
                      productGroups
                      requiresDelivery
                      requiresEvaluation
                      requiresPrescription
                      sysId
                      title
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      id
                      isShowOnShop
                      livemode
                      locale
                      metadata
                      name
                      prices
                      shopProductGroupIds
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    twilioMessageHistories {
                      address
                      email
                      fullName
                      message
                      phoneNumber
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      locale
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      weight
                    }
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    userType
                    utmCampaign
                    utmMedium
                    utmSource
                  }
                  weight
                }
                paymentProvider
                phoneNumber
                platformType
                prescribeAfterTeleConsult
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation
                priceDisplayId
                priceInfo
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              phone
              sysId
              time
              timezone
              type
            }
            address
            approveAt
            atomePaymentAmount
            completedEvaluation
            consultationSessions
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryMethod
            deliverySnapshot
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            evaluationId
            expiredAt
            intakeInstructions
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isOrderRenew
            isPendingFollowUpConsult
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            isTestOrder
            latestInvoice
            nextReviewDate
            oldPrice
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            patientId
            patientOrderNotes
            paymentProvider
            phoneNumber
            platformType
            prescribeAfterTeleConsult
            prescriptionDisplayPriceId
            prescriptionId
            prescriptionOrderCalculation
            priceDisplayId
            priceInfo
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          phone
          sysId
          time
          timezone
          type
        }
        address
        approveAt
        atomePaymentAmount
        completedEvaluation
        consultationSessions
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryMethod
        deliverySnapshot
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        evaluationId
        expiredAt
        intakeInstructions
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isOrderRenew
        isPendingFollowUpConsult
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        isTestOrder
        latestInvoice
        nextReviewDate
        oldPrice
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        patientId
        patientOrderNotes
        paymentProvider
        phoneNumber
        platformType
        prescribeAfterTeleConsult
        prescriptionDisplayPriceId
        prescriptionId
        prescriptionOrderCalculation
        priceDisplayId
        priceInfo
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      user {
        avatar
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        requireConfirmPolicy
        socialProviderType
        sysId
        userType
        utmCampaign
        utmMedium
        utmSource
      }
      weight
    }
    requireConfirmPolicy
    socialProviderType
    sysId
    userType
    utmCampaign
    utmMedium
    utmSource
  }
}
    `;
export const useUsersQuery = <
      TData = UsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: UsersQueryVariables,
      options?: UseQueryOptions<UsersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UsersQuery, TError, TData>(
      variables === undefined ? ['users'] : ['users', variables],
      fetcher<UsersQuery, UsersQueryVariables>(client, UsersDocument, variables, headers),
      options
    );
export const ViewerDocument = `
    query viewer($evalInput: V2EvaluationInput, $input: V2PaginationInput!, $limit: Int, $offset: Int, $order: JSON, $patientId: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input1: V2ConsultationFilterInput!, $input2: ConsultationMessagesInput!, $limit1: Int, $offset1: Int, $order1: JSON, $input3: ConsultationListInput!, $limit2: Int, $offset2: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input4: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input5: GetPatientInput, $platform1: String, $input6: StripeProductFilterV2, $videoLink: String!, $id: String, $platform2: String, $platform3: String, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $limit3: Int, $offset3: Int, $order3: JSON, $inputConsultation1: V2ConsultationFilterInput, $input7: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $platform10: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $inputConsultation2: V2ConsultationFilterInput, $platform11: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform12: String, $input8: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit4: Float, $offset4: Float, $sort: ShopProductSortInputV2, $input9: GetSmartMatchMetaInput!, $input10: PatientGetSurveyInput, $videoLink1: String!, $previewVideoLink: String!, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform13: String, $platform14: String, $platform15: String, $platform16: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform17: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $input11: ConsultationAuditFilterInput!, $paging: V2PaginationInput!, $videoLink2: String!, $patientId1: String, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform18: String, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId2: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input12: V2ConsultationFilterInput!, $input13: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input14: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $doctorFilterInput3: V2DoctorInputFilter, $input15: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input16: GetPatientInput, $platform19: String, $platform20: String, $input17: StripeProductFilterV2, $consultAuditFilterInput6: ConsultationAuditFilterInput, $inputConsultation7: V2ConsultationFilterInput, $platform21: String, $input18: CrossSellRecordQueryInput, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input19: V2ConsultationFilterInput!, $input20: ConsultationMessagesInput!, $limit8: Int, $offset8: Int, $order7: JSON, $input21: ConsultationListInput!, $limit9: Int, $offset9: Int, $order8: JSON, $doctorFilterInput4: V2DoctorInputFilter, $doctorFilterInput5: V2DoctorInputFilter, $input22: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input23: GetPatientInput, $platform22: String, $input24: StripeProductFilterV2, $input25: V2PickupLocationInput!, $limit10: Int, $offset10: Int, $order9: JSON, $orderId7: String!, $platform23: String, $platform24: String, $platform25: String, $acuityAppointmentId6: String, $date12: String, $forDelivery6: Boolean, $isReschedule6: Boolean, $orderId8: String, $acuityAppointmentId7: String, $consultDate3: Float, $date13: Float, $forDelivery7: Boolean, $isReschedule7: Boolean, $orderId9: String, $input26: V2ConsultationFilterInput!, $input27: ConsultationMessagesInput!, $limit11: Int, $offset11: Int, $order10: JSON, $input28: ConsultationListInput!, $limit12: Int, $offset12: Int, $order11: JSON, $doctorFilterInput6: V2DoctorInputFilter, $doctorFilterInput7: V2DoctorInputFilter, $input29: OrderInput!, $pagination3: V2PaginationInput!, $date14: String, $date15: Float, $input30: GetPatientInput, $platform26: String, $input31: StripeProductFilterV2, $input32: OrderShipmentInput!, $acuityAppointmentId8: String, $date16: String, $forDelivery8: Boolean, $isReschedule8: Boolean, $orderId10: String, $acuityAppointmentId9: String, $consultDate4: Float, $date17: Float, $forDelivery9: Boolean, $isReschedule9: Boolean, $orderId11: String, $input33: V2ConsultationFilterInput!, $input34: ConsultationMessagesInput!, $limit13: Int, $offset13: Int, $order12: JSON, $input35: ConsultationListInput!, $limit14: Int, $offset14: Int, $order13: JSON, $doctorFilterInput8: V2DoctorInputFilter, $doctorFilterInput9: V2DoctorInputFilter, $input36: OrderInput!, $pagination4: V2PaginationInput!, $date18: String, $date19: Float, $input37: GetPatientInput, $platform27: String, $input38: StripeProductFilterV2, $input39: GetPartnerInput!, $input40: PrescriptionCalculationInput, $platform28: String, $platform29: String, $platform30: String, $platform31: String, $input41: GetSmartMatchResultsInput!, $input42: GetSmartMatchAIResponseInput!, $platform32: String, $evalResultInput: EvaluationResultsInput, $input43: StripeProductFilterV2Input, $platform33: String, $platform34: String, $acuityAppointmentId10: String, $date20: String, $forDelivery10: Boolean, $isReschedule10: Boolean, $orderId12: String, $acuityAppointmentId11: String, $consultDate5: Float, $date21: Float, $forDelivery11: Boolean, $isReschedule11: Boolean, $orderId13: String, $input44: V2ConsultationFilterInput!, $input45: ConsultationMessagesInput!, $limit15: Int, $offset15: Int, $order14: JSON, $input46: ConsultationListInput!, $limit16: Int, $offset16: Int, $order15: JSON, $doctorFilterInput10: V2DoctorInputFilter, $doctorFilterInput11: V2DoctorInputFilter, $input47: OrderInput!, $pagination5: V2PaginationInput!, $date22: String, $date23: Float, $input48: GetPatientInput, $platform35: String, $input49: StripeProductFilterV2, $input50: GetUsersInput!, $input51: V2GuestVideoConsultationInput!) {
  viewer {
    appSettings {
      stripeCurrencyRatio
      systemPromotion {
        oneTimePercent
        oneTimeValue
      }
    }
    evaluations(evalInput: $evalInput) {
      isCompleted
      isSkipped
      name
      patientAnswers {
        answer {
          childrenAnswers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        question {
          answers {
            childrenAnswers {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            deselectAll
            mandatory
            name
            order
            placeholder
            productUrl
            sysId
            textKey
            type
          }
          content {
            body {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            footer {
              description
              descriptionTextKey
              title
              titleTextKey
            }
            header {
              description
              descriptionTextKey
              title
              titleTextKey
            }
          }
          dependentEvaluationQuestions {
            answer {
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            skipPage
            skipQuestionCount
            sysId
          }
          displayPage
          evaluationBlocks {
            blockAnswer {
              childrenAnswers {
                deselectAll
                mandatory
                name
                order
                placeholder
                productUrl
                sysId
                textKey
                type
              }
              deselectAll
              mandatory
              name
              order
              placeholder
              productUrl
              sysId
              textKey
              type
            }
            content {
              description
              descriptionTextKey
              sysId
              title
              titleTextKey
            }
            sysId
          }
          guestOnly
          name
          order
          sysId
          textKey
          type
          validation {
            bmi
            extra
            max
            min
            preselect
            type
          }
        }
        type
        value
      }
      patientNote
      platform
      questions {
        answers {
          deselectAll
          mandatory
          name
          order
          placeholder
          productUrl
          sysId
          textKey
          type
        }
        dependentEvaluationQuestions {
          skipPage
          skipQuestionCount
          sysId
        }
        displayPage
        evaluationBlocks {
          sysId
        }
        guestOnly
        name
        order
        sysId
        textKey
        type
        validation {
          bmi
          extra
          max
          min
          preselect
          type
        }
      }
      status
      sysId
      type
    }
    master {
      auditHistories(input: $input) {
        count
        items {
          action
          changeLog {
            columnName
            newValue
            oldValue
          }
          createdAt
          schemaType
          sysId
          targetId
          userId
        }
      }
      consultationAudits(input: $input11, paging: $paging) {
        count
        items {
          consultTime
          consultType
          createdBy
          doctor {
            active
            bio {
              createdAt
              createdBy
              remark
              sysId
              translationKey
              updatedAt
              updatedBy
              valueEn
              valueJa
              valueZh
            }
            calendarId
            consultation(videoLink: $videoLink) {
              gmeetLink
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                activeConsultation {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit, offset: $offset, order: $order) {
                    count
                    items {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input2
                      limit: $limit1
                      offset: $offset1
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input3, limit: $limit2, offset: $offset2, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input4, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input5) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input6) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              previewToken
              previewVideoLink
              status
              sysId
              token
              videoChannelId
              videoLink
              zoomJoinUrl
            }
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          evaluationId
          order {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          patient {
            atomePayment(id: $id) {
              amount
              paymentUrl
              priceId
              referenceId
              status
              summary {
                cashbackEarnRate
                cashbackEarned
                cashbackRedeemed
                consultBasePrice
                consultFee
                consultFeeAfterDiscount
                consultTax
                consultTransactionFee
                discountAmount
                isConsult
                mainBasePrice
                mainTax
                mainTransactionFee
                minimalAmountPayment
                paymentIntentAmount
                paymentIntentAmountAfterCashback
                paymentIntentSummary
                priceId
                productPriceAmount
                productPriceAmountAfterDiscount
                promotionCode
                shouldChargeConsultFee
                subTotal
                total
                totalAfterCashback
              }
              sysId
            }
            atomePayments {
              amount
              paymentUrl
              priceId
              referenceId
              status
              summary {
                cashbackEarnRate
                cashbackEarned
                cashbackRedeemed
                consultBasePrice
                consultFee
                consultFeeAfterDiscount
                consultTax
                consultTransactionFee
                discountAmount
                isConsult
                mainBasePrice
                mainTax
                mainTransactionFee
                minimalAmountPayment
                paymentIntentAmount
                paymentIntentAmountAfterCashback
                paymentIntentSummary
                priceId
                productPriceAmount
                productPriceAmountAfterDiscount
                promotionCode
                shouldChargeConsultFee
                subTotal
                total
                totalAfterCashback
              }
              sysId
            }
            billingAddress {
              address
              city
              country
              firstName
              lastName
              name
              note
              phoneNumber
              postal
              region
              sameAsBilling
              state
              sysId
              type
              unit
            }
            bloodPressure
            bypassLoginTokens {
              expiresAt
              pageName
              token
              type
            }
            cart {
              billingAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              cartItems {
                cart {
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  orderSummary {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    discountAmountLater
                    discountAmountNow
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountBeforeTax
                    paymentIntentSummary
                    promotionCode
                    shippingFee
                    subTotal
                    subTotalLater
                    subTotalNow
                    taxes
                    taxesLater
                    taxesNow
                    teleConsultFee
                    total
                    totalLater
                    totalNow
                    totalNowAfterCashback
                    totalTaxes
                  }
                  paidCompletedEvaluationIds
                  platform
                  promotionCode
                  status
                  sysId
                }
                completedEval
                consultationSessionType
                isAutoRenewal
                isSkipMedSelecting
                isSubscriptionPrice
                orderId
                patientNote
                price {
                  active
                  alternativePrice {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  metadata {
                    actual_price_display
                    boxes
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    isArchived
                    isOneTimePrice
                    price_frequency
                    price_quantity
                    price_show
                    quantity
                    quantity_display
                    strength
                  }
                  nickname
                  product
                  productId
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform4)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  shopDisplay
                  sysId
                  tax_behavior
                  texts {
                    actual_price_display
                    dosage
                    dosage_display
                    dosage_popular
                    frequency
                    frequency_actual_price_display
                    frequency_display
                    frequency_popular
                    frequency_price_display
                    frequency_quantity_display
                    frequency_quantity_display_patient
                    frequency_savings_display
                    frequency_strikeout_price_display
                    price_frequency
                    price_quantity
                    quantity
                    quantity_display
                  }
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                product {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform6)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredientDetails {
                    description
                    imageLink
                    locale
                    name
                    strength
                    uniqueName
                  }
                  ingredients
                  isConsultOnly(platform: $platform7)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  prices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInstructions {
                    language
                    localeKey
                    productId
                    sysId
                    translatedText
                  }
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  tempPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform9)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  texts {
                    benefits
                    category
                    display_price
                    display_price_patient
                    dosage_variant_body
                    dosage_variant_title
                    effective_in
                    for
                    frequency_variant_title
                    good_to_know
                    how_to_take
                    how_to_use
                    is_popular
                    lasts_for
                    platform
                    product_description
                    product_name
                    product_short_description
                    quantity_per_unit
                    quantity_variant_title
                    requires_prescription
                    safety_information
                    side_effects
                    strength
                    taken
                    unit
                    unit_patient
                  }
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                quantity
                teleConsultForSkipEval
                type
              }
              paidCompletedEvaluationIds
              platform
              promotionCode
              status
              sysId
            }
            cashback {
              availableBalance
              recentTransactions {
                amount
                cashbackType
                created
                credit_note
                currency
                customer
                description
                ending_balance
                id
                invoice
                livemode
                metadata
                object
                savingsToDate
                type
              }
              savingsToDateThisYear {
                amount
                cashbackType
                created
                credit_note
                currency
                customer
                description
                ending_balance
                id
                invoice
                livemode
                metadata
                object
                savingsToDate
                type
              }
            }
            checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
              checkoutData
              evaluationId
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              patient {
                bloodPressure
                consultations(inputConsultation: $inputConsultation1) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit3, offset: $offset3, order: $order3) {
                    count
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                  }
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                country
                createdAt
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                dob
                document(input: $input7) {
                  createdAt
                  orderSysId
                  ref
                  sysId
                  type
                  url
                }
                documents {
                  createdAt
                  orderSysId
                  ref
                  sysId
                  type
                  url
                }
                email
                evaluations(evalFilter: $evalFilter) {
                  isCompleted
                  isSkipped
                  name
                  patientNote
                  platform
                  status
                  sysId
                  type
                }
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                latestPaymentMethod {
                  card {
                    brand
                    exp_month
                    exp_year
                    last4
                  }
                  id
                }
                legalName
                locale
                mounjaroTrialEligible
                order(id: $id1) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  activeConsultation {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation3) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input8) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit4, offset: $offset4, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input9) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input10) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform13)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform14)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform15)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform16)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              status
              sysId
            }
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          sessionType
          status
          sysId
        }
        limit
        offset
      }
      doctors {
        active
        bio {
          createdAt
          createdBy
          remark
          sysId
          translationKey
          updatedAt
          updatedBy
          valueEn
          valueJa
          valueZh
        }
        calendarId
        consultation(videoLink: $videoLink2) {
          gmeetLink
          previewToken
          previewVideoLink
          status
          sysId
          token
          videoChannelId
          videoLink
          zoomJoinUrl
        }
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        patient(patientId: $patientId1) {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sysId
        textConsultPostalCodes
        trtEligible
        user {
          admin {
            crossSellRecords(input: $input18) {
              childOrder {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                activeConsultation {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                acuityAppointment {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                additionalPrices {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                afterVideoConsultRedirecting {
                  baseUrl
                  path
                }
                approveAt
                atomeNextSendingInvoiceDate
                atomePayments {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                checkoutSession {
                  checkoutData
                  evaluationId
                  status
                  sysId
                }
                childrenOrders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                claimedRetentionOffer
                consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultations(inputConsultation: $inputConsultation6) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluation {
                  isCompleted
                  isSkipped
                  name
                  patientNote
                  platform
                  status
                  sysId
                  type
                }
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                latestAtomePayment {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                latestInvoice {
                  amount_due
                  hosted_invoice_url
                  id
                  next_payment_attempt
                  paid
                  paymentStatus
                  period_end
                  starting_balance
                  status
                  subtotal
                  tax
                  total
                }
                latestNote {
                  content
                  createdAt
                  createdBy
                  sysId
                  updatedAt
                }
                nextReviewDate
                oldPrice
                oldPriceInfo {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                pickupLocation {
                  address
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescribed_after_trial_order_sys_id
                prescription {
                  cancelled
                  createdAt
                  days
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  priceIds
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation {
                  cashbackEarnRate
                  cashbackEarned
                  cashbackRedeemed
                  consultBasePrice
                  consultFee
                  consultFeeAfterDiscount
                  consultTax
                  consultTransactionFee
                  discountAmount
                  isConsult
                  mainBasePrice
                  mainTax
                  mainTransactionFee
                  minimalAmountPayment
                  paymentIntentAmount
                  paymentIntentAmountAfterCashback
                  paymentIntentSummary
                  priceId
                  productPriceAmount
                  productPriceAmountAfterDiscount
                  promotionCode
                  shouldChargeConsultFee
                  subTotal
                  total
                  totalAfterCashback
                }
                price {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                priceDisplayId
                priceInfo {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  ingredients
                  isConsultOnly(platform: $platform18)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                siblingCrossSellOrders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                status
                stripePaymentIntentId
                stripeSubscriptionId
                subscription {
                  cancel_at_period_end
                  current_period_end
                  current_period_start
                  default_payment_method
                  id
                  items
                  latest_invoice
                  metadata
                  pause_collection
                  pending_setup_intent
                  pending_update
                  status
                }
                sysId
                teleConsultProduct
                upcomingInvoice {
                  amount_due
                  hosted_invoice_url
                  id
                  next_payment_attempt
                  paid
                  paymentStatus
                  period_end
                  starting_balance
                  status
                  subtotal
                  tax
                  total
                }
                updatedAt
              }
              childOrderId
              createdAt
              createdBy
              creator {
                admin {
                  order(orderId: $orderId2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                    count
                    items {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    limit
                    offset
                  }
                  patient(patientId: $patientId2) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                }
                avatar
                calendarDates(
                  acuityAppointmentId: $acuityAppointmentId2
                  date: $date4
                  forDelivery: $forDelivery2
                  isReschedule: $isReschedule2
                  orderId: $orderId3
                ) {
                  date
                }
                calendarTimes(
                  acuityAppointmentId: $acuityAppointmentId3
                  consultDate: $consultDate1
                  date: $date5
                  forDelivery: $forDelivery3
                  isReschedule: $isReschedule3
                  orderId: $orderId4
                ) {
                  time
                }
                consultation(input: $input12) {
                  consultationAudit {
                    consultTime
                    consultType
                    createdBy
                    evaluationId
                    sessionType
                    status
                    sysId
                  }
                  consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                    count
                    limit
                    offset
                  }
                  consultationTitle {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  countReminder
                  createdAt
                  doctor {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  messages {
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                  }
                  orderSysId
                  participants {
                    avatar
                    fullName
                    identity
                    locale
                    role
                    token
                    userSysId
                  }
                  participantsV2 {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                consultationMessages(
                  input: $input13
                  limit: $limit6
                  offset: $offset6
                  order: $order5
                ) {
                  count
                  limit
                  offset
                }
                consultations(input: $input14, limit: $limit7, offset: $offset7, order: $order6) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                doctor(doctorFilterInput: $doctorFilterInput2) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctors(doctorFilterInput: $doctorFilterInput3) {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                orders(input: $input15, pagination: $pagination1) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                partnerConsultDates(date: $date6) {
                  date
                }
                partnerConsultTimes(date: $date7) {
                  time
                }
                patient(input: $input16) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                patientDocuments {
                  createdAt
                  orderSysId
                  ref
                  sysId
                  type
                  url
                }
                phoneNumber
                prescriptionCalculation {
                  affiliateCouponNotApplied {
                    affiliateProductDisplayName
                    reason
                  }
                  isAffiliateLocked
                  otcCalculationSummary {
                    otcOrdersCalculation {
                      basePrice
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      discountAmount
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      stripePromotionCode
                      tax
                      transactionFee
                    }
                    totalBasePrice
                    totalCashbackEarned
                    totalCashbackRedeemed
                    totalPaymentIntentAmount
                    totalTax
                    totalTransactionFee
                  }
                  promotionCodeError
                  rxCalculationSummary {
                    rxOrdersCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    total
                    totalCashbackEarned
                    totalCashbackRedeemed
                    totalDiscountAmount
                    totalMainBasePrice
                    totalPaymentIntentAmount
                    totalPaymentIntentAmountAfterCashback
                    totalTax
                    totalTransactionFee
                  }
                  stripePromotionCode
                }
                requireConfirmPolicy
                socialProviderType
                stripeProducts(input: $input17) {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform19)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredientDetails {
                    description
                    imageLink
                    locale
                    name
                    strength
                    uniqueName
                  }
                  ingredients
                  isConsultOnly(platform: $platform20)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  prices {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInstructions {
                    language
                    localeKey
                    productId
                    sysId
                    translatedText
                  }
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  tempPrices {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  texts {
                    benefits
                    category
                    display_price
                    display_price_patient
                    dosage_variant_body
                    dosage_variant_title
                    effective_in
                    for
                    frequency_variant_title
                    good_to_know
                    how_to_take
                    how_to_use
                    is_popular
                    lasts_for
                    platform
                    product_description
                    product_name
                    product_short_description
                    quantity_per_unit
                    quantity_variant_title
                    requires_prescription
                    safety_information
                    side_effects
                    strength
                    taken
                    unit
                    unit_patient
                  }
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
              parentOrder {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                activeConsultation {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                acuityAppointment {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                additionalPrices {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                afterVideoConsultRedirecting {
                  baseUrl
                  path
                }
                approveAt
                atomeNextSendingInvoiceDate
                atomePayments {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                checkoutSession {
                  checkoutData
                  evaluationId
                  status
                  sysId
                }
                childrenOrders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                claimedRetentionOffer
                consultationAudits(consultAuditFilterInput: $consultAuditFilterInput6) {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultations(inputConsultation: $inputConsultation7) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluation {
                  isCompleted
                  isSkipped
                  name
                  patientNote
                  platform
                  status
                  sysId
                  type
                }
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                latestAtomePayment {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                latestInvoice {
                  amount_due
                  hosted_invoice_url
                  id
                  next_payment_attempt
                  paid
                  paymentStatus
                  period_end
                  starting_balance
                  status
                  subtotal
                  tax
                  total
                }
                latestNote {
                  content
                  createdAt
                  createdBy
                  sysId
                  updatedAt
                }
                nextReviewDate
                oldPrice
                oldPriceInfo {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                pickupLocation {
                  address
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                prescribed_after_trial_order_sys_id
                prescription {
                  cancelled
                  createdAt
                  days
                  doctorNotes
                  endDate
                  expiresAt
                  isFollowUp
                  notedDate
                  priceIds
                  startDate
                  status
                  sysId
                  treatmentCode
                  updatedAt
                }
                prescriptionDisplayPriceId
                prescriptionId
                prescriptionOrderCalculation {
                  cashbackEarnRate
                  cashbackEarned
                  cashbackRedeemed
                  consultBasePrice
                  consultFee
                  consultFeeAfterDiscount
                  consultTax
                  consultTransactionFee
                  discountAmount
                  isConsult
                  mainBasePrice
                  mainTax
                  mainTransactionFee
                  minimalAmountPayment
                  paymentIntentAmount
                  paymentIntentAmountAfterCashback
                  paymentIntentSummary
                  priceId
                  productPriceAmount
                  productPriceAmountAfterDiscount
                  promotionCode
                  shouldChargeConsultFee
                  subTotal
                  total
                  totalAfterCashback
                }
                price {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                priceDisplayId
                priceInfo {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  ingredients
                  isConsultOnly(platform: $platform21)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                siblingCrossSellOrders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                status
                stripePaymentIntentId
                stripeSubscriptionId
                subscription {
                  cancel_at_period_end
                  current_period_end
                  current_period_start
                  default_payment_method
                  id
                  items
                  latest_invoice
                  metadata
                  pause_collection
                  pending_setup_intent
                  pending_update
                  status
                }
                sysId
                teleConsultProduct
                upcomingInvoice {
                  amount_due
                  hosted_invoice_url
                  id
                  next_payment_attempt
                  paid
                  paymentStatus
                  period_end
                  starting_balance
                  status
                  subtotal
                  tax
                  total
                }
                updatedAt
              }
              parentOrderId
              priceId
              selectedBy
              stripeProductPrice {
                importPriceId
                isBundle
                priceActive
                priceBillingScheme
                priceCreated
                priceCurrency
                priceDisplayId
                priceFirstTimeAlternativePrice
                priceFirstTimeTryingInMonths
                priceId
                priceLivemode
                priceNickname
                priceProduct
                priceTaxBehavior
                priceUnitAmount
                priceUnitAmountDecimal
                productActive
                productDescription
                productDisplayId
                productId
                productLivemode
                productName
                productStatementDescriptor
                productType
                productUniqName
                productUnitLabel
                sysId
              }
              sysId
            }
          }
          avatar
          calendarDates(
            acuityAppointmentId: $acuityAppointmentId4
            date: $date8
            forDelivery: $forDelivery4
            isReschedule: $isReschedule4
            orderId: $orderId5
          ) {
            date
          }
          calendarTimes(
            acuityAppointmentId: $acuityAppointmentId5
            consultDate: $consultDate2
            date: $date9
            forDelivery: $forDelivery5
            isReschedule: $isReschedule5
            orderId: $orderId6
          ) {
            time
          }
          consultation(input: $input19) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          consultationMessages(
            input: $input20
            limit: $limit8
            offset: $offset8
            order: $order7
          ) {
            count
            limit
            offset
          }
          consultations(input: $input21, limit: $limit9, offset: $offset9, order: $order8) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          doctor(doctorFilterInput: $doctorFilterInput4) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctors(doctorFilterInput: $doctorFilterInput5) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          locale
          ninjaVanToken
          orders(input: $input22, pagination: $pagination2) {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          partnerConsultDates(date: $date10) {
            date
          }
          partnerConsultTimes(date: $date11) {
            time
          }
          patient(input: $input23) {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientDocuments {
            createdAt
            orderSysId
            ref
            sysId
            type
            url
          }
          phoneNumber
          prescriptionCalculation {
            isAffiliateLocked
            promotionCodeError
            stripePromotionCode
          }
          requireConfirmPolicy
          socialProviderType
          stripeProducts(input: $input24) {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform22)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          sysId
          tempToken
          tempTokenExpired
          userType
          utmCampaign
          utmId
          utmMedium
          utmSource
        }
      }
      pickupLocations(
        input: $input25
        limit: $limit10
        offset: $offset10
        order: $order9
      ) {
        count
        items {
          address
          area {
            areaChildren {
              areaChildren {
                areaName
                areaParent {
                  areaChildren {
                    areaName
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaName
                  areaParent {
                    areaName
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaType
                  sysId
                }
                areaType
                sysId
              }
              areaName
              areaType
              sysId
            }
            areaName
            areaParent {
              areaName
              areaType
              sysId
            }
            areaType
            pickupLocations {
              address
              area {
                areaName
                areaType
                sysId
              }
              city
              isDisabled
              officeName
              officeNumber
              openingHours
              orders {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              paymentProviders
              phone
              postalCode
              region
              state
              subRegion
              sysId
              type
              unit
            }
            sysId
          }
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          orders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        limit
        offset
      }
      regionAreas {
        areaChildren {
          areaName
          areaType
          sysId
        }
        areaName
        areaParent {
          areaName
          areaType
          sysId
        }
        areaType
        pickupLocations {
          address
          city
          isDisabled
          officeName
          officeNumber
          openingHours
          paymentProviders
          phone
          postalCode
          region
          state
          subRegion
          sysId
          type
          unit
        }
        sysId
      }
    }
    orderAtomePaymentLink(orderId: $orderId7) {
      amount
      paymentUrl
      priceId
      referenceId
      status
      summary {
        cashbackEarnRate
        cashbackEarned
        cashbackRedeemed
        consultBasePrice
        consultFee
        consultFeeAfterDiscount
        consultTax
        consultTransactionFee
        discountAmount
        isConsult
        mainBasePrice
        mainTax
        mainTransactionFee
        minimalAmountPayment
        paymentIntentAmount
        paymentIntentAmountAfterCashback
        paymentIntentSummary
        priceId
        productPriceAmount
        productPriceAmountAfterDiscount
        promotionCode
        shouldChargeConsultFee
        subTotal
        total
        totalAfterCashback
      }
      sysId
    }
    orderShipments(input: $input32) {
      address
      cost
      courierName
      createdAt
      deliveryMethod
      deliveryTimestamp
      estimatedShipDate
      group {
        bookingNo
        createdAt
        name
        sysId
        updatedAt
      }
      items {
        createdAt
        dosage
        isFirstPurchase
        orderNo
        orderSysId
        paymentAmount
        paymentDate
        paymentIntentId
        paymentProvider
        price {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform23)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredientDetails {
            description
            imageLink
            locale
            name
            strength
            uniqueName
          }
          ingredients
          isConsultOnly(platform: $platform24)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          prices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInstructions {
            language
            localeKey
            productId
            sysId
            translatedText
          }
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          tempPrices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        priceId
        product {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform25)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        promotionCode
        qty
        sysId
        updatedAt
      }
      note
      parcelId
      patient {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      paused
      shipDate
      shipper {
        avatar
        calendarDates(
          acuityAppointmentId: $acuityAppointmentId6
          date: $date12
          forDelivery: $forDelivery6
          isReschedule: $isReschedule6
          orderId: $orderId8
        ) {
          date
        }
        calendarTimes(
          acuityAppointmentId: $acuityAppointmentId7
          consultDate: $consultDate3
          date: $date13
          forDelivery: $forDelivery7
          isReschedule: $isReschedule7
          orderId: $orderId9
        ) {
          time
        }
        consultation(input: $input26) {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        consultationMessages(
          input: $input27
          limit: $limit11
          offset: $offset11
          order: $order10
        ) {
          count
          limit
          offset
        }
        consultations(
          input: $input28
          limit: $limit12
          offset: $offset12
          order: $order11
        ) {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        doctor(doctorFilterInput: $doctorFilterInput6) {
          active
          calendarId
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        doctors(doctorFilterInput: $doctorFilterInput7) {
          active
          calendarId
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        locale
        ninjaVanToken
        orders(input: $input29, pagination: $pagination3) {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        partnerConsultDates(date: $date14) {
          date
        }
        partnerConsultTimes(date: $date15) {
          time
        }
        patient(input: $input30) {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        patientDocuments {
          createdAt
          orderSysId
          ref
          sysId
          type
          url
        }
        phoneNumber
        prescriptionCalculation {
          isAffiliateLocked
          promotionCodeError
          stripePromotionCode
        }
        requireConfirmPolicy
        socialProviderType
        stripeProducts(input: $input31) {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform26)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        sysId
        tempToken
        tempTokenExpired
        userType
        utmCampaign
        utmId
        utmMedium
        utmSource
      }
      status
      sysId
      trackingNo
      updatedAt
    }
    partner(input: $input39) {
      address
      consultDates {
        date
      }
      consultTimes {
        time
      }
      email
      name
      partner {
        avatar
        calendarDates(
          acuityAppointmentId: $acuityAppointmentId8
          date: $date16
          forDelivery: $forDelivery8
          isReschedule: $isReschedule8
          orderId: $orderId10
        ) {
          date
        }
        calendarTimes(
          acuityAppointmentId: $acuityAppointmentId9
          consultDate: $consultDate4
          date: $date17
          forDelivery: $forDelivery9
          isReschedule: $isReschedule9
          orderId: $orderId11
        ) {
          time
        }
        consultation(input: $input33) {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        consultationMessages(
          input: $input34
          limit: $limit13
          offset: $offset13
          order: $order12
        ) {
          count
          limit
          offset
        }
        consultations(
          input: $input35
          limit: $limit14
          offset: $offset14
          order: $order13
        ) {
          countReminder
          createdAt
          doctorChatToken
          doctorSysId
          friendlyName
          gmeetLink
          isActive
          isRead
          isVideoConsultRescheduled
          lastMsgSysId
          lastMsgUserId
          orderSysId
          patientChatToken
          patientEmail
          prescribedAt
          previewVideoLink
          progressStatus
          readAt
          reviewDate
          status
          sysId
          textConsultStatus
          textConversationId
          type
          updatedAt
          videoChannelId
          videoLink
        }
        doctor(doctorFilterInput: $doctorFilterInput8) {
          active
          calendarId
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        doctors(doctorFilterInput: $doctorFilterInput9) {
          active
          calendarId
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        email
        firstName
        fullName
        id
        isPharmacist
        lastName
        locale
        ninjaVanToken
        orders(input: $input36, pagination: $pagination4) {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        partnerConsultDates(date: $date18) {
          date
        }
        partnerConsultTimes(date: $date19) {
          time
        }
        patient(input: $input37) {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        patientDocuments {
          createdAt
          orderSysId
          ref
          sysId
          type
          url
        }
        phoneNumber
        prescriptionCalculation {
          isAffiliateLocked
          promotionCodeError
          stripePromotionCode
        }
        requireConfirmPolicy
        socialProviderType
        stripeProducts(input: $input38) {
          active
          country
          createdAt
          description
          displayId
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          ingredients
          isConsultOnly(platform: $platform27)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        sysId
        tempToken
        tempTokenExpired
        userType
        utmCampaign
        utmId
        utmMedium
        utmSource
      }
      phoneNumber
      sysId
      type
      users {
        partner {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          locale
          ninjaVanToken
          phoneNumber
          requireConfirmPolicy
          socialProviderType
          sysId
          tempToken
          tempTokenExpired
          userType
          utmCampaign
          utmId
          utmMedium
          utmSource
        }
        sysId
        user {
          avatar
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          locale
          ninjaVanToken
          phoneNumber
          requireConfirmPolicy
          socialProviderType
          sysId
          tempToken
          tempTokenExpired
          userType
          utmCampaign
          utmId
          utmMedium
          utmSource
        }
      }
    }
    prescriptionCalculation(input: $input40) {
      isAffiliateLocked
      promotionCodeError
      stripePromotionCode
    }
    smartMatch(input: $input41) {
      evalId
      smartMatchResults {
        analysis
        nextSteps {
          evidence
          text
        }
        primaryProduct {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform28)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredientDetails {
            description
            imageLink
            locale
            name
            strength
            uniqueName
          }
          ingredients
          isConsultOnly(platform: $platform29)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          prices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInstructions {
            language
            localeKey
            productId
            sysId
            translatedText
          }
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          tempPrices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          texts {
            benefits
            category
            display_price
            display_price_patient
            dosage_variant_body
            dosage_variant_title
            effective_in
            for
            frequency_variant_title
            good_to_know
            how_to_take
            how_to_use
            is_popular
            lasts_for
            platform
            product_description
            product_name
            product_short_description
            quantity_per_unit
            quantity_variant_title
            requires_prescription
            safety_information
            side_effects
            strength
            taken
            unit
            unit_patient
          }
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
        secondaryProducts {
          active
          country
          createdAt
          description
          displayId
          drDosageFrequency {
            alternativeDosage
            alternativeDosageUnit
            asNeeded
            dosage
            dosageUnit
            duration
            durationUnit
            frequency
            productId
            quantity
            quantityUnit
          }
          evaluationId
          format
          hasOneDosage
          hasOneFrequency
          id
          image {
            noahVertical
            noahWide
            sysId
            zoeyVertical
            zoeyWide
          }
          includedProduct {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform30)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          ingredientDetails {
            description
            imageLink
            locale
            name
            strength
            uniqueName
          }
          ingredients
          isConsultOnly(platform: $platform31)
          isPopular
          isRxOneTime
          isShowOnShop
          isSkipMedProduct
          livemode
          metadata
          name
          popularPriceId
          prices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInstructions {
            language
            localeKey
            productId
            sysId
            translatedText
          }
          shopProductGroupIds
          shouldChargeNow
          statementDescriptor
          sysId
          tempPrices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          texts {
            benefits
            category
            display_price
            display_price_patient
            dosage_variant_body
            dosage_variant_title
            effective_in
            for
            frequency_variant_title
            good_to_know
            how_to_take
            how_to_use
            is_popular
            lasts_for
            platform
            product_description
            product_name
            product_short_description
            quantity_per_unit
            quantity_variant_title
            requires_prescription
            safety_information
            side_effects
            strength
            taken
            unit
            unit_patient
          }
          type
          uniqName
          unitLabel
          updatedAt
          usage
        }
      }
      status
      sysId
      userId
      userType
    }
    smartMatchResponse(input: $input42) {
      response
    }
    stripeProducts(evalResultInput: $evalResultInput, input: $input43) {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform32)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    stripeProducts2 {
      active
      country
      createdAt
      description
      displayId
      drDosageFrequency {
        alternativeDosage
        alternativeDosageUnit
        asNeeded
        dosage
        dosageUnit
        duration
        durationUnit
        frequency
        productId
        quantity
        quantityUnit
      }
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      image {
        noahVertical
        noahWide
        sysId
        zoeyVertical
        zoeyWide
      }
      includedProduct {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        ingredients
        isConsultOnly(platform: $platform33)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      ingredientDetails {
        description
        imageLink
        locale
        name
        strength
        uniqueName
      }
      ingredients
      isConsultOnly(platform: $platform34)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      prices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      productInstructions {
        language
        localeKey
        productId
        sysId
        translatedText
      }
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      tempPrices {
        active
        billing_scheme
        created
        createdAt
        currency
        displayId
        firstTimeAlternativePrice
        firstTimeTryingInMonths
        id
        importPriceId
        isBundle
        livemode
        locale
        nickname
        product
        productId
        shopDisplay
        sysId
        tax_behavior
        type
        unit_amount
        unit_amount_decimal
        updatedAt
      }
      texts {
        benefits
        category
        display_price
        display_price_patient
        dosage_variant_body
        dosage_variant_title
        effective_in
        for
        frequency_variant_title
        good_to_know
        how_to_take
        how_to_use
        is_popular
        lasts_for
        platform
        product_description
        product_name
        product_short_description
        quantity_per_unit
        quantity_variant_title
        requires_prescription
        safety_information
        side_effects
        strength
        taken
        unit
        unit_patient
      }
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    user {
      avatar
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      phoneNumber
      requireConfirmPolicy
      socialProviderType
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    users(input: $input50) {
      avatar
      calendarDates(
        acuityAppointmentId: $acuityAppointmentId10
        date: $date20
        forDelivery: $forDelivery10
        isReschedule: $isReschedule10
        orderId: $orderId12
      ) {
        date
      }
      calendarTimes(
        acuityAppointmentId: $acuityAppointmentId11
        consultDate: $consultDate5
        date: $date21
        forDelivery: $forDelivery11
        isReschedule: $isReschedule11
        orderId: $orderId13
      ) {
        time
      }
      consultation(input: $input44) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      consultationMessages(
        input: $input45
        limit: $limit15
        offset: $offset15
        order: $order14
      ) {
        count
        limit
        offset
      }
      consultations(
        input: $input46
        limit: $limit16
        offset: $offset16
        order: $order15
      ) {
        countReminder
        createdAt
        doctorChatToken
        doctorSysId
        friendlyName
        gmeetLink
        isActive
        isRead
        isVideoConsultRescheduled
        lastMsgSysId
        lastMsgUserId
        orderSysId
        patientChatToken
        patientEmail
        prescribedAt
        previewVideoLink
        progressStatus
        readAt
        reviewDate
        status
        sysId
        textConsultStatus
        textConversationId
        type
        updatedAt
        videoChannelId
        videoLink
      }
      doctor(doctorFilterInput: $doctorFilterInput10) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      doctors(doctorFilterInput: $doctorFilterInput11) {
        active
        calendarId
        country
        designation
        duration
        email
        firstName
        fullName
        lastName
        sysId
        textConsultPostalCodes
        trtEligible
      }
      email
      firstName
      fullName
      id
      isPharmacist
      lastName
      locale
      ninjaVanToken
      orders(input: $input47, pagination: $pagination5) {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      partnerConsultDates(date: $date22) {
        date
      }
      partnerConsultTimes(date: $date23) {
        time
      }
      patient(input: $input48) {
        bloodPressure
        country
        createdAt
        dob
        email
        fbc
        fbp
        firstName
        fromPlatformEnv
        fullName
        gender
        height
        icNumber
        idVerifiedAt
        identification
        isAlreadyCheckout
        isReferredBy
        lastName
        legalName
        locale
        mounjaroTrialEligible
        paidCompletedEvaluationIds
        phoneNumber
        referralCode
        stripeCustomer
        stripeCustomerId
        sysId
        userSysId
        weight
      }
      patientDocuments {
        createdAt
        orderSysId
        ref
        sysId
        type
        url
      }
      phoneNumber
      prescriptionCalculation {
        isAffiliateLocked
        promotionCodeError
        stripePromotionCode
      }
      requireConfirmPolicy
      socialProviderType
      stripeProducts(input: $input49) {
        active
        country
        createdAt
        description
        displayId
        evaluationId
        format
        hasOneDosage
        hasOneFrequency
        id
        ingredients
        isConsultOnly(platform: $platform35)
        isPopular
        isRxOneTime
        isShowOnShop
        isSkipMedProduct
        livemode
        metadata
        name
        popularPriceId
        shopProductGroupIds
        shouldChargeNow
        statementDescriptor
        sysId
        type
        uniqName
        unitLabel
        updatedAt
        usage
      }
      sysId
      tempToken
      tempTokenExpired
      userType
      utmCampaign
      utmId
      utmMedium
      utmSource
    }
    videoConsultation(input: $input51) {
      gmeetLink
      order {
        ableToBookConsultSchedule
        ableToBookDeliverySchedule
        ableToChangeDeliverySchedule
        approveAt
        atomeNextSendingInvoiceDate
        claimedRetentionOffer
        continueTrial
        countTrialReminder
        country
        createFromSkipOrderId
        createdAt
        delivery
        deliveryAddressSysId
        deliveryMethod
        deliverySnapshot
        deliveryStatus
        deliveryTimestamp
        doctorNotes
        doctorPrescriptionPriceIds
        dosage
        doseStartedAt
        evaluationId
        expiredAt
        intakeInstructions
        isAtomeAutoRenewal
        isAutoRenewal
        isConsultOnly
        isEDTrial
        isEditingDeliveryWithin2Hours
        isOrderRenew
        isPacked
        isPendingFollowUpConsult
        isPrescriptionValid
        isSkipMedOrder
        isSkippedEval
        isSubscriptionPastDue
        isSubscriptionPaused
        lastPaymentDate
        lastShipmentDate
        nextReviewDate
        oldPrice
        oldStripePrescriptionId
        ops
        opsComment
        orderPrescriptionPriceId
        orderPriceId
        otherIntestedEvalIds
        partnerSysId
        patientId
        patientOrderNotes
        paymentIntentUrl
        paymentProvider
        paymentStatus
        phoneNumber
        planStatus
        platformType
        prescribeAfterTeleConsult
        prescribed_after_trial_order_sys_id
        prescriptionDisplayPriceId
        prescriptionId
        priceDisplayId
        productQuantity
        promotionCode
        rejectAt
        reorderStatus
        shortId
        showInCurrentPlans
        showInNotifications
        showInPastPlans
        status
        stripePaymentIntentId
        stripeSubscriptionId
        sysId
        teleConsultProduct
        updatedAt
      }
      previewToken
      previewVideoLink
      status
      sysId
      token
      videoChannelId
      videoLink
      zoomJoinUrl
    }
  }
}
    `;
export const useViewerQuery = <
      TData = ViewerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ViewerQueryVariables,
      options?: UseQueryOptions<ViewerQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ViewerQuery, TError, TData>(
      ['viewer', variables],
      fetcher<ViewerQuery, ViewerQueryVariables>(client, ViewerDocument, variables, headers),
      options
    );
export const SubscribeOrderDocument = `
    subscription subscribeOrder($limit: Int, $offset: Int, $order: JSON, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $inputConsultation: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $videoLink: String!, $previewVideoLink: String!, $patientId: String, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform: String, $input9: StripeProductFilterV2, $platform1: String, $consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation1: V2ConsultationFilterInput, $platform2: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $limit4: Int, $offset4: Int, $order3: JSON, $inputConsultation2: V2ConsultationFilterInput, $platform3: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $platform5: String, $platform6: String, $platform7: String, $platform8: String, $platform9: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $platform10: String, $input10: CrossSellRecordQueryInput, $orderId2: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input11: V2ConsultationFilterInput!, $input12: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input13: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink1: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform11: String, $input14: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input15: GetPatientInput, $platform12: String, $platform13: String, $input16: StripeProductFilterV2, $videoLink2: String!, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform14: String, $input17: V2OrderFilterInput!) {
  subscribeOrder(input: $input17) {
    ableToBookConsultSchedule
    ableToBookDeliverySchedule
    ableToChangeDeliverySchedule
    activeConsultation {
      consultationAudit {
        consultTime
        consultType
        createdBy
        doctor {
          active
          bio {
            createdAt
            createdBy
            remark
            sysId
            translationKey
            updatedAt
            updatedBy
            valueEn
            valueJa
            valueZh
          }
          calendarId
          consultation(videoLink: $videoLink2) {
            gmeetLink
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              activeConsultation {
                consultationMessages(limit: $limit, offset: $offset, order: $order) {
                  count
                  items {
                    automatedMessage {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    consultationSysId
                    content
                    createdAt
                    readAt
                    sysId
                    updatedAt
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  patient(patientId: $patientId) {
                    atomePayment(id: $id) {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    bloodPressure
                    bypassLoginTokens {
                      expiresAt
                      pageName
                      token
                      type
                    }
                    cart {
                      paidCompletedEvaluationIds
                      platform
                      promotionCode
                      status
                      sysId
                    }
                    cashback {
                      availableBalance
                    }
                    checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    country
                    createdAt
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    dob
                    document(input: $input) {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    email
                    evaluations(evalFilter: $evalFilter) {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    latestPaymentMethod {
                      id
                    }
                    legalName
                    locale
                    mounjaroTrialEligible
                    order(id: $id1) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paidCompletedEvaluationIds
                    phoneNumber
                    prescriptionCalculation(input: $input1) {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    referralCode
                    referrals {
                      doctorId
                      sysId
                    }
                    shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                      count
                      limit
                      offset
                    }
                    smartMatchMeta(input: $input2) {
                      evalId
                      status
                      sysId
                      userId
                      userType
                    }
                    stripeCustomer
                    stripeCustomerId
                    survey(input: $input3) {
                      answers
                      isSkipped
                      patientSysId
                      sysId
                      type
                    }
                    sysId
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    userSysId
                    videoConsultation(videoLink: $videoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    weight
                  }
                  sysId
                  textConsultPostalCodes
                  trtEligible
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  automatedMessage {
                    createdAt
                    createdBy
                    remark
                    sysId
                    translationKey
                    updatedAt
                    updatedBy
                    valueEn
                    valueJa
                    valueZh
                  }
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                  user {
                    avatar
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    phoneNumber
                    requireConfirmPolicy
                    socialProviderType
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                }
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  acuityAppointment {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  acuityAppointments {
                    appointmentTypeID
                    bookedAt
                    calendar
                    calendarID
                    calendarJP
                    canceled
                    confirmationPage
                    date
                    dateCreated
                    datetime
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    duration
                    email
                    endTime
                    firstName
                    id
                    isFollowUpConsult
                    lastName
                    noShow
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    phone
                    sysId
                    time
                    timezone
                    type
                  }
                  additionalPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  afterVideoConsultRedirecting {
                    baseUrl
                    path
                  }
                  approveAt
                  atomeNextSendingInvoiceDate
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  checkoutSession {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  childrenOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation1) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  claimedRetentionOffer
                  consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                    consultTime
                    consultType
                    createdBy
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sessionType
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation2) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluation {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  latestAtomePayment {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  latestInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  latestNote {
                    author {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    content
                    createdAt
                    createdBy
                    sysId
                    updatedAt
                  }
                  nextReviewDate
                  oldPrice
                  oldPriceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patient {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  pickupLocation {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribedAfterTrialOrder {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform6)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform8)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform9)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  admin {
                    crossSellRecords(input: $input10) {
                      childOrderId
                      createdAt
                      createdBy
                      parentOrderId
                      priceId
                      selectedBy
                      sysId
                    }
                    order(orderId: $orderId2) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                      count
                      limit
                      offset
                    }
                    patient(patientId: $patientId1) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                  }
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId2
                    date: $date4
                    forDelivery: $forDelivery2
                    isReschedule: $isReschedule2
                    orderId: $orderId3
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId3
                    consultDate: $consultDate1
                    date: $date5
                    forDelivery: $forDelivery3
                    isReschedule: $isReschedule3
                    orderId: $orderId4
                  ) {
                    time
                  }
                  consultation(input: $input11) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input12
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input13, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink1) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input14, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input15) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input16) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform12)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            previewToken
            previewVideoLink
            status
            sysId
            token
            videoChannelId
            videoLink
            zoomJoinUrl
          }
          country
          designation
          duration
          email
          firstName
          fullName
          lastName
          sysId
          textConsultPostalCodes
          trtEligible
        }
        evaluationId
        order {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          approveAt
          atomeNextSendingInvoiceDate
          claimedRetentionOffer
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          nextReviewDate
          oldPrice
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribed_after_trial_order_sys_id
          prescriptionDisplayPriceId
          prescriptionId
          priceDisplayId
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          status
          stripePaymentIntentId
          stripeSubscriptionId
          sysId
          teleConsultProduct
          updatedAt
        }
        patient {
          bloodPressure
          country
          createdAt
          dob
          email
          fbc
          fbp
          firstName
          fromPlatformEnv
          fullName
          gender
          height
          icNumber
          idVerifiedAt
          identification
          isAlreadyCheckout
          isReferredBy
          lastName
          legalName
          locale
          mounjaroTrialEligible
          paidCompletedEvaluationIds
          phoneNumber
          referralCode
          stripeCustomer
          stripeCustomerId
          sysId
          userSysId
          weight
        }
        sessionType
        status
        sysId
      }
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    acuityAppointment {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    acuityAppointments {
      appointmentTypeID
      bookedAt
      calendar
      calendarID
      calendarJP
      canceled
      confirmationPage
      date
      dateCreated
      datetime
      duration
      email
      endTime
      firstName
      id
      isFollowUpConsult
      lastName
      noShow
      phone
      sysId
      time
      timezone
      type
    }
    additionalPrices {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    afterVideoConsultRedirecting {
      baseUrl
      path
    }
    approveAt
    atomeNextSendingInvoiceDate
    atomePayments {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    checkoutSession {
      checkoutData
      evaluationId
      status
      sysId
    }
    childrenOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    claimedRetentionOffer
    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
      consultTime
      consultType
      createdBy
      evaluationId
      sessionType
      status
      sysId
    }
    consultations(inputConsultation: $inputConsultation6) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    continueTrial
    countTrialReminder
    country
    createFromSkipOrderId
    createdAt
    delivery
    deliveryAddress {
      address
      city
      country
      firstName
      lastName
      name
      note
      phoneNumber
      postal
      region
      sameAsBilling
      state
      sysId
      type
      unit
    }
    deliveryAddressSysId
    deliveryMethod
    deliverySnapshot
    deliveryStatus
    deliveryTimestamp
    doctorNotes
    doctorPrescriptionPriceIds
    dosage
    doseStartedAt
    evaluation {
      isCompleted
      isSkipped
      name
      patientNote
      platform
      status
      sysId
      type
    }
    evaluationId
    expiredAt
    intakeInstructions
    isAtomeAutoRenewal
    isAutoRenewal
    isConsultOnly
    isEDTrial
    isEditingDeliveryWithin2Hours
    isOrderRenew
    isPacked
    isPendingFollowUpConsult
    isPrescriptionValid
    isSkipMedOrder
    isSkippedEval
    isSubscriptionPastDue
    isSubscriptionPaused
    lastPaymentDate
    lastShipmentDate
    latestAtomePayment {
      amount
      paymentUrl
      priceId
      referenceId
      status
      sysId
    }
    latestInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    latestNote {
      content
      createdAt
      createdBy
      sysId
      updatedAt
    }
    nextReviewDate
    oldPrice
    oldPriceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    oldStripePrescriptionId
    ops
    opsComment
    orderPrescriptionPriceId
    orderPriceId
    otherIntestedEvalIds
    partnerSysId
    patient {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientId
    patientOrderNotes
    paymentIntentUrl
    paymentProvider
    paymentStatus
    phoneNumber
    pickupLocation {
      address
      city
      isDisabled
      officeName
      officeNumber
      openingHours
      paymentProviders
      phone
      postalCode
      region
      state
      subRegion
      sysId
      type
      unit
    }
    planStatus
    platformType
    prescribeAfterTeleConsult
    prescribedAfterTrialOrder {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    prescribed_after_trial_order_sys_id
    prescription {
      cancelled
      createdAt
      days
      doctorNotes
      endDate
      expiresAt
      isFollowUp
      notedDate
      priceIds
      startDate
      status
      sysId
      treatmentCode
      updatedAt
    }
    prescriptionDisplayPriceId
    prescriptionId
    prescriptionOrderCalculation {
      cashbackEarnRate
      cashbackEarned
      cashbackRedeemed
      consultBasePrice
      consultFee
      consultFeeAfterDiscount
      consultTax
      consultTransactionFee
      discountAmount
      isConsult
      mainBasePrice
      mainTax
      mainTransactionFee
      minimalAmountPayment
      paymentIntentAmount
      paymentIntentAmountAfterCashback
      paymentIntentSummary
      priceId
      productPriceAmount
      productPriceAmountAfterDiscount
      promotionCode
      shouldChargeConsultFee
      subTotal
      total
      totalAfterCashback
    }
    price {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    priceDisplayId
    priceInfo {
      active
      billing_scheme
      created
      createdAt
      currency
      displayId
      firstTimeAlternativePrice
      firstTimeTryingInMonths
      id
      importPriceId
      isBundle
      livemode
      locale
      nickname
      product
      productId
      shopDisplay
      sysId
      tax_behavior
      type
      unit_amount
      unit_amount_decimal
      updatedAt
    }
    productInfo {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform14)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    productQuantity
    promotionCode
    rejectAt
    reorderStatus
    shortId
    showInCurrentPlans
    showInNotifications
    showInPastPlans
    siblingCrossSellOrders {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    status
    stripePaymentIntentId
    stripeSubscriptionId
    subscription {
      cancel_at_period_end
      current_period_end
      current_period_start
      default_payment_method
      id
      items
      latest_invoice
      metadata
      pause_collection
      pending_setup_intent
      pending_update
      status
    }
    sysId
    teleConsultProduct
    upcomingInvoice {
      amount_due
      hosted_invoice_url
      id
      next_payment_attempt
      paid
      paymentStatus
      period_end
      starting_balance
      status
      subtotal
      tax
      total
    }
    updatedAt
  }
}
    `;
export const SubscribeUserDocument = `
    subscription subscribeUser($consultAuditFilterInput: ConsultationAuditFilterInput, $inputConsultation: V2ConsultationFilterInput, $platform: String, $videoLink: String!, $id: String, $checkoutSessionFilterOptions: CheckoutSessionFilterInput, $limit: Int, $offset: Int, $order: JSON, $inputConsultation1: V2ConsultationFilterInput, $input: GetPatientDocumentInput!, $evalFilter: V2PatientEvaluationFilterInput, $id1: String, $consultAuditFilterInput1: ConsultationAuditFilterInput, $inputConsultation2: V2ConsultationFilterInput, $platform1: String, $inputOrder: V2OrderFilterInput, $orderPagination: V2PaginationInput, $input1: PrescriptionCalculationInput, $platform2: String, $filter: ShopProductFilterInputV2, $limit1: Float, $offset1: Float, $sort: ShopProductSortInputV2, $input2: GetSmartMatchMetaInput!, $input3: PatientGetSurveyInput, $acuityAppointmentId: String, $date: String, $forDelivery: Boolean, $isReschedule: Boolean, $orderId: String, $acuityAppointmentId1: String, $consultDate: Float, $date1: Float, $forDelivery1: Boolean, $isReschedule1: Boolean, $orderId1: String, $input4: V2ConsultationFilterInput!, $input5: ConsultationMessagesInput!, $limit2: Int, $offset2: Int, $order1: JSON, $input6: ConsultationListInput!, $limit3: Int, $offset3: Int, $order2: JSON, $doctorFilterInput: V2DoctorInputFilter, $doctorFilterInput1: V2DoctorInputFilter, $input7: OrderInput!, $pagination: V2PaginationInput!, $date2: String, $date3: Float, $input8: GetPatientInput, $platform3: String, $input9: StripeProductFilterV2, $videoLink1: String!, $previewVideoLink: String!, $patientId: String, $limit4: Int, $offset4: Int, $order3: JSON, $orderId2: String, $consultAuditFilterInput2: ConsultationAuditFilterInput, $inputConsultation3: V2ConsultationFilterInput, $platform4: String, $inputOrder1: V2OrderFilterInput, $orderPagination1: V2PaginationInput, $patientId1: String, $acuityAppointmentId2: String, $date4: String, $forDelivery2: Boolean, $isReschedule2: Boolean, $orderId3: String, $acuityAppointmentId3: String, $consultDate1: Float, $date5: Float, $forDelivery3: Boolean, $isReschedule3: Boolean, $orderId4: String, $limit5: Int, $offset5: Int, $order4: JSON, $input10: ConsultationMessagesInput!, $limit6: Int, $offset6: Int, $order5: JSON, $input11: ConsultationListInput!, $limit7: Int, $offset7: Int, $order6: JSON, $doctorFilterInput2: V2DoctorInputFilter, $videoLink2: String!, $patientId2: String, $doctorFilterInput3: V2DoctorInputFilter, $input12: OrderInput!, $pagination1: V2PaginationInput!, $date6: String, $date7: Float, $input13: GetPatientInput, $platform5: String, $platform6: String, $input14: StripeProductFilterV2, $input15: V2ConsultationFilterInput!, $platform7: String, $platform8: String, $platform9: String, $platform10: String, $platform11: String, $platform12: String, $consultAuditFilterInput3: ConsultationAuditFilterInput, $inputConsultation4: V2ConsultationFilterInput, $acuityAppointmentId4: String, $date8: String, $forDelivery4: Boolean, $isReschedule4: Boolean, $orderId5: String, $acuityAppointmentId5: String, $consultDate2: Float, $date9: Float, $forDelivery5: Boolean, $isReschedule5: Boolean, $orderId6: String, $input16: V2ConsultationFilterInput!, $input17: ConsultationMessagesInput!, $limit8: Int, $offset8: Int, $order7: JSON, $input18: ConsultationListInput!, $limit9: Int, $offset9: Int, $order8: JSON, $doctorFilterInput4: V2DoctorInputFilter, $doctorFilterInput5: V2DoctorInputFilter, $input19: OrderInput!, $pagination2: V2PaginationInput!, $date10: String, $date11: Float, $input20: GetPatientInput, $platform13: String, $input21: StripeProductFilterV2, $platform14: String, $platform15: String, $platform16: String, $platform17: String, $platform18: String, $consultAuditFilterInput4: ConsultationAuditFilterInput, $inputConsultation5: V2ConsultationFilterInput, $platform19: String, $consultAuditFilterInput5: ConsultationAuditFilterInput, $inputConsultation6: V2ConsultationFilterInput, $platform20: String, $consultAuditFilterInput6: ConsultationAuditFilterInput, $inputConsultation7: V2ConsultationFilterInput, $platform21: String, $acuityAppointmentId6: String, $date12: String, $forDelivery6: Boolean, $isReschedule6: Boolean, $orderId7: String, $acuityAppointmentId7: String, $consultDate3: Float, $date13: Float, $forDelivery7: Boolean, $isReschedule7: Boolean, $orderId8: String, $input22: V2ConsultationFilterInput!, $input23: ConsultationMessagesInput!, $limit10: Int, $offset10: Int, $order9: JSON, $input24: ConsultationListInput!, $limit11: Int, $offset11: Int, $order10: JSON, $doctorFilterInput6: V2DoctorInputFilter, $doctorFilterInput7: V2DoctorInputFilter, $input25: OrderInput!, $pagination3: V2PaginationInput!, $date14: String, $date15: Float, $input26: GetPatientInput, $platform22: String, $input27: StripeProductFilterV2, $consultAuditFilterInput7: ConsultationAuditFilterInput, $inputConsultation8: V2ConsultationFilterInput, $platform23: String, $input28: CrossSellRecordQueryInput, $acuityAppointmentId8: String, $date16: String, $forDelivery8: Boolean, $isReschedule8: Boolean, $orderId9: String, $acuityAppointmentId9: String, $consultDate4: Float, $date17: Float, $forDelivery9: Boolean, $isReschedule9: Boolean, $orderId10: String, $input29: V2ConsultationFilterInput!, $input30: ConsultationMessagesInput!, $limit12: Int, $offset12: Int, $order11: JSON, $input31: ConsultationListInput!, $limit13: Int, $offset13: Int, $order12: JSON, $doctorFilterInput8: V2DoctorInputFilter, $doctorFilterInput9: V2DoctorInputFilter, $input32: OrderInput!, $pagination4: V2PaginationInput!, $date18: String, $date19: Float, $input33: GetPatientInput, $platform24: String, $input34: StripeProductFilterV2, $input35: V2UserFilterInput!) {
  subscribeUser(input: $input35) {
    admin {
      crossSellRecords(input: $input28) {
        childOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          activeConsultation {
            consultationAudit {
              consultTime
              consultType
              createdBy
              doctor {
                active
                bio {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                calendarId
                consultation(videoLink: $videoLink) {
                  gmeetLink
                  order {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  previewToken
                  previewVideoLink
                  status
                  sysId
                  token
                  videoChannelId
                  videoLink
                  zoomJoinUrl
                }
                country
                designation
                duration
                email
                firstName
                fullName
                lastName
                patient(patientId: $patientId) {
                  atomePayment(id: $id) {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  atomePayments {
                    amount
                    paymentUrl
                    priceId
                    referenceId
                    status
                    summary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    sysId
                  }
                  billingAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  bloodPressure
                  bypassLoginTokens {
                    expiresAt
                    pageName
                    token
                    type
                  }
                  cart {
                    billingAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    cartItems {
                      completedEval
                      consultationSessionType
                      isAutoRenewal
                      isSkipMedSelecting
                      isSubscriptionPrice
                      orderId
                      patientNote
                      quantity
                      teleConsultForSkipEval
                      type
                    }
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    orderSummary {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      discountAmountLater
                      discountAmountNow
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountBeforeTax
                      paymentIntentSummary
                      promotionCode
                      shippingFee
                      subTotal
                      subTotalLater
                      subTotalNow
                      taxes
                      taxesLater
                      taxesNow
                      teleConsultFee
                      total
                      totalLater
                      totalNow
                      totalNowAfterCashback
                      totalTaxes
                    }
                    paidCompletedEvaluationIds
                    platform
                    promotionCode
                    status
                    sysId
                  }
                  cashback {
                    availableBalance
                    recentTransactions {
                      amount
                      cashbackType
                      created
                      credit_note
                      currency
                      customer
                      description
                      ending_balance
                      id
                      invoice
                      livemode
                      metadata
                      object
                      savingsToDate
                      type
                    }
                    savingsToDateThisYear {
                      amount
                      cashbackType
                      created
                      credit_note
                      currency
                      customer
                      description
                      ending_balance
                      id
                      invoice
                      livemode
                      metadata
                      object
                      savingsToDate
                      type
                    }
                  }
                  checkoutSessions(checkoutSessionFilterOptions: $checkoutSessionFilterOptions) {
                    checkoutData
                    evaluationId
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    status
                    sysId
                  }
                  consultations(inputConsultation: $inputConsultation1) {
                    consultationAudit {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultationMessages(limit: $limit, offset: $offset, order: $order) {
                      count
                      limit
                      offset
                    }
                    consultationTitle {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    countReminder
                    createdAt
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    messages {
                      consultationSysId
                      content
                      createdAt
                      readAt
                      sysId
                      updatedAt
                    }
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    orderSysId
                    participants {
                      avatar
                      fullName
                      identity
                      locale
                      role
                      token
                      userSysId
                    }
                    participantsV2 {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  country
                  createdAt
                  deliveryAddress {
                    address
                    city
                    country
                    firstName
                    lastName
                    name
                    note
                    phoneNumber
                    postal
                    region
                    sameAsBilling
                    state
                    sysId
                    type
                    unit
                  }
                  dob
                  document(input: $input) {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  documents {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  email
                  evaluations(evalFilter: $evalFilter) {
                    isCompleted
                    isSkipped
                    name
                    patientAnswers {
                      type
                      value
                    }
                    patientNote
                    platform
                    questions {
                      displayPage
                      guestOnly
                      name
                      order
                      sysId
                      textKey
                      type
                    }
                    status
                    sysId
                    type
                  }
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  latestPaymentMethod {
                    card {
                      brand
                      exp_month
                      exp_year
                      last4
                    }
                    id
                  }
                  legalName
                  locale
                  mounjaroTrialEligible
                  order(id: $id1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  orders(inputOrder: $inputOrder, orderPagination: $orderPagination) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput1) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform1)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  paidCompletedEvaluationIds
                  phoneNumber
                  prescriptionCalculation(input: $input1) {
                    affiliateCouponNotApplied {
                      affiliateProductDisplayName
                      reason
                    }
                    isAffiliateLocked
                    otcCalculationSummary {
                      totalBasePrice
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalPaymentIntentAmount
                      totalTax
                      totalTransactionFee
                    }
                    promotionCodeError
                    rxCalculationSummary {
                      total
                      totalCashbackEarned
                      totalCashbackRedeemed
                      totalDiscountAmount
                      totalMainBasePrice
                      totalPaymentIntentAmount
                      totalPaymentIntentAmountAfterCashback
                      totalTax
                      totalTransactionFee
                    }
                    stripePromotionCode
                  }
                  referralCode
                  referrals {
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorId
                    documents {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    items {
                      orderId
                      priceId
                      referralSysId
                      sysId
                    }
                    sysId
                  }
                  shopProducts(filter: $filter, limit: $limit1, offset: $offset1, sort: $sort) {
                    count
                    items {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform2)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    limit
                    offset
                  }
                  smartMatchMeta(input: $input2) {
                    evalId
                    status
                    sysId
                    userId
                    userType
                  }
                  stripeCustomer
                  stripeCustomerId
                  survey(input: $input3) {
                    answers
                    isSkipped
                    patientSysId
                    sysId
                    type
                  }
                  sysId
                  user {
                    avatar
                    calendarDates(
                      acuityAppointmentId: $acuityAppointmentId
                      date: $date
                      forDelivery: $forDelivery
                      isReschedule: $isReschedule
                      orderId: $orderId
                    ) {
                      date
                    }
                    calendarTimes(
                      acuityAppointmentId: $acuityAppointmentId1
                      consultDate: $consultDate
                      date: $date1
                      forDelivery: $forDelivery1
                      isReschedule: $isReschedule1
                      orderId: $orderId1
                    ) {
                      time
                    }
                    consultation(input: $input4) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    consultationMessages(
                      input: $input5
                      limit: $limit2
                      offset: $offset2
                      order: $order1
                    ) {
                      count
                      limit
                      offset
                    }
                    consultations(input: $input6, limit: $limit3, offset: $offset3, order: $order2) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    doctor(doctorFilterInput: $doctorFilterInput) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctors(doctorFilterInput: $doctorFilterInput1) {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    email
                    firstName
                    fullName
                    id
                    isPharmacist
                    lastName
                    locale
                    ninjaVanToken
                    orders(input: $input7, pagination: $pagination) {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    partnerConsultDates(date: $date2) {
                      date
                    }
                    partnerConsultTimes(date: $date3) {
                      time
                    }
                    patient(input: $input8) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientDocuments {
                      createdAt
                      orderSysId
                      ref
                      sysId
                      type
                      url
                    }
                    phoneNumber
                    prescriptionCalculation {
                      isAffiliateLocked
                      promotionCodeError
                      stripePromotionCode
                    }
                    requireConfirmPolicy
                    socialProviderType
                    stripeProducts(input: $input9) {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform3)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    sysId
                    tempToken
                    tempTokenExpired
                    userType
                    utmCampaign
                    utmId
                    utmMedium
                    utmSource
                  }
                  userSysId
                  videoConsultation(videoLink: $videoLink1) {
                    gmeetLink
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  videoConsultationPreview(previewVideoLink: $previewVideoLink) {
                    gmeetLink
                    order {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    previewToken
                    previewVideoLink
                    status
                    sysId
                    token
                    videoChannelId
                    videoLink
                    zoomJoinUrl
                  }
                  weight
                }
                sysId
                textConsultPostalCodes
                trtEligible
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              evaluationId
              order {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                approveAt
                atomeNextSendingInvoiceDate
                claimedRetentionOffer
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                nextReviewDate
                oldPrice
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              patient {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              sessionType
              status
              sysId
            }
            consultationMessages(limit: $limit4, offset: $offset4, order: $order3) {
              count
              items {
                automatedMessage {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                consultationSysId
                content
                createdAt
                readAt
                sysId
                updatedAt
                user {
                  avatar
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  phoneNumber
                  requireConfirmPolicy
                  socialProviderType
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
              }
              limit
              offset
            }
            consultationTitle {
              createdAt
              createdBy
              remark
              sysId
              translationKey
              updatedAt
              updatedBy
              valueEn
              valueJa
              valueZh
            }
            countReminder
            createdAt
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            messages {
              automatedMessage {
                createdAt
                createdBy
                remark
                sysId
                translationKey
                updatedAt
                updatedBy
                valueEn
                valueJa
                valueZh
              }
              consultationSysId
              content
              createdAt
              readAt
              sysId
              updatedAt
              user {
                avatar
                email
                firstName
                fullName
                id
                isPharmacist
                lastName
                locale
                ninjaVanToken
                phoneNumber
                requireConfirmPolicy
                socialProviderType
                sysId
                tempToken
                tempTokenExpired
                userType
                utmCampaign
                utmId
                utmMedium
                utmSource
              }
            }
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            orderSysId
            participants {
              avatar
              fullName
              identity
              locale
              role
              token
              userSysId
            }
            participantsV2 {
              admin {
                order(orderId: $orderId2) {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                orders(inputOrder: $inputOrder1, orderPagination: $orderPagination1) {
                  count
                  items {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput2) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation3) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform4)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  limit
                  offset
                }
                patient(patientId: $patientId1) {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
              }
              avatar
              calendarDates(
                acuityAppointmentId: $acuityAppointmentId2
                date: $date4
                forDelivery: $forDelivery2
                isReschedule: $isReschedule2
                orderId: $orderId3
              ) {
                date
              }
              calendarTimes(
                acuityAppointmentId: $acuityAppointmentId3
                consultDate: $consultDate1
                date: $date5
                forDelivery: $forDelivery3
                isReschedule: $isReschedule3
                orderId: $orderId4
              ) {
                time
              }
              consultation(input: $input15) {
                consultationAudit {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultationMessages(limit: $limit5, offset: $offset5, order: $order4) {
                  count
                  limit
                  offset
                }
                consultationTitle {
                  createdAt
                  createdBy
                  remark
                  sysId
                  translationKey
                  updatedAt
                  updatedBy
                  valueEn
                  valueJa
                  valueZh
                }
                countReminder
                createdAt
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                messages {
                  consultationSysId
                  content
                  createdAt
                  readAt
                  sysId
                  updatedAt
                }
                orderSysId
                participants {
                  avatar
                  fullName
                  identity
                  locale
                  role
                  token
                  userSysId
                }
                participantsV2 {
                  avatar
                  consultationMessages(
                    input: $input10
                    limit: $limit6
                    offset: $offset6
                    order: $order5
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input11, limit: $limit7, offset: $offset7, order: $order6) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput2) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput3) {
                    active
                    bio {
                      createdAt
                      createdBy
                      remark
                      sysId
                      translationKey
                      updatedAt
                      updatedBy
                      valueEn
                      valueJa
                      valueZh
                    }
                    calendarId
                    consultation(videoLink: $videoLink2) {
                      gmeetLink
                      previewToken
                      previewVideoLink
                      status
                      sysId
                      token
                      videoChannelId
                      videoLink
                      zoomJoinUrl
                    }
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    patient(patientId: $patientId2) {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    sysId
                    textConsultPostalCodes
                    trtEligible
                    user {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input12, pagination: $pagination1) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date6) {
                    date
                  }
                  partnerConsultTimes(date: $date7) {
                    time
                  }
                  patient(input: $input13) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    isAffiliateLocked
                    promotionCodeError
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input14) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform5)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform6)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              email
              firstName
              fullName
              id
              isPharmacist
              lastName
              locale
              ninjaVanToken
              phoneNumber
              requireConfirmPolicy
              socialProviderType
              sysId
              tempToken
              tempTokenExpired
              userType
              utmCampaign
              utmId
              utmMedium
              utmSource
            }
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          acuityAppointment {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            doctor {
              active
              calendarId
              country
              designation
              duration
              email
              firstName
              fullName
              lastName
              sysId
              textConsultPostalCodes
              trtEligible
            }
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            orders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            phone
            sysId
            time
            timezone
            type
          }
          additionalPrices {
            active
            alternativePrice {
              active
              alternativePrice {
                active
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                metadata {
                  actual_price_display
                  boxes
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  isArchived
                  isOneTimePrice
                  price_frequency
                  price_quantity
                  price_show
                  quantity
                  quantity_display
                  strength
                }
                nickname
                product
                productId
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  drDosageFrequency {
                    alternativeDosage
                    alternativeDosageUnit
                    asNeeded
                    dosage
                    dosageUnit
                    duration
                    durationUnit
                    frequency
                    productId
                    quantity
                    quantityUnit
                  }
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  image {
                    noahVertical
                    noahWide
                    sysId
                    zoeyVertical
                    zoeyWide
                  }
                  includedProduct {
                    active
                    country
                    createdAt
                    description
                    displayId
                    drDosageFrequency {
                      alternativeDosage
                      alternativeDosageUnit
                      asNeeded
                      dosage
                      dosageUnit
                      duration
                      durationUnit
                      frequency
                      productId
                      quantity
                      quantityUnit
                    }
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    image {
                      noahVertical
                      noahWide
                      sysId
                      zoeyVertical
                      zoeyWide
                    }
                    includedProduct {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform7)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    ingredientDetails {
                      description
                      imageLink
                      locale
                      name
                      strength
                      uniqueName
                    }
                    ingredients
                    isConsultOnly(platform: $platform8)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    prices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInstructions {
                      language
                      localeKey
                      productId
                      sysId
                      translatedText
                    }
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    tempPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    texts {
                      benefits
                      category
                      display_price
                      display_price_patient
                      dosage_variant_body
                      dosage_variant_title
                      effective_in
                      for
                      frequency_variant_title
                      good_to_know
                      how_to_take
                      how_to_use
                      is_popular
                      lasts_for
                      platform
                      product_description
                      product_name
                      product_short_description
                      quantity_per_unit
                      quantity_variant_title
                      requires_prescription
                      safety_information
                      side_effects
                      strength
                      taken
                      unit
                      unit_patient
                    }
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  ingredientDetails {
                    description
                    imageLink
                    locale
                    name
                    strength
                    uniqueName
                  }
                  ingredients
                  isConsultOnly(platform: $platform9)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  prices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform10)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInstructions {
                    language
                    localeKey
                    productId
                    sysId
                    translatedText
                  }
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  tempPrices {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform11)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  texts {
                    benefits
                    category
                    display_price
                    display_price_patient
                    dosage_variant_body
                    dosage_variant_title
                    effective_in
                    for
                    frequency_variant_title
                    good_to_know
                    how_to_take
                    how_to_use
                    is_popular
                    lasts_for
                    platform
                    product_description
                    product_name
                    product_short_description
                    quantity_per_unit
                    quantity_variant_title
                    requires_prescription
                    safety_information
                    side_effects
                    strength
                    taken
                    unit
                    unit_patient
                  }
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                shopDisplay
                sysId
                tax_behavior
                texts {
                  actual_price_display
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  price_frequency
                  price_quantity
                  quantity
                  quantity_display
                }
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            metadata {
              actual_price_display
              boxes
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              isArchived
              isOneTimePrice
              price_frequency
              price_quantity
              price_show
              quantity
              quantity_display
              strength
            }
            nickname
            product
            productId
            productInfo {
              active
              country
              createdAt
              description
              displayId
              evaluationId
              format
              hasOneDosage
              hasOneFrequency
              id
              ingredients
              isConsultOnly(platform: $platform12)
              isPopular
              isRxOneTime
              isShowOnShop
              isSkipMedProduct
              livemode
              metadata
              name
              popularPriceId
              shopProductGroupIds
              shouldChargeNow
              statementDescriptor
              sysId
              type
              uniqName
              unitLabel
              updatedAt
              usage
            }
            shopDisplay
            sysId
            tax_behavior
            texts {
              actual_price_display
              dosage
              dosage_display
              dosage_popular
              frequency
              frequency_actual_price_display
              frequency_display
              frequency_popular
              frequency_price_display
              frequency_quantity_display
              frequency_quantity_display_patient
              frequency_savings_display
              frequency_strikeout_price_display
              price_frequency
              price_quantity
              quantity
              quantity_display
            }
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          afterVideoConsultRedirecting {
            baseUrl
            path
          }
          approveAt
          atomeNextSendingInvoiceDate
          atomePayments {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          checkoutSession {
            checkoutData
            evaluationId
            order {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              nextReviewDate
              oldPrice
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            patient {
              bloodPressure
              country
              createdAt
              dob
              email
              fbc
              fbp
              firstName
              fromPlatformEnv
              fullName
              gender
              height
              icNumber
              idVerifiedAt
              identification
              isAlreadyCheckout
              isReferredBy
              lastName
              legalName
              locale
              mounjaroTrialEligible
              paidCompletedEvaluationIds
              phoneNumber
              referralCode
              stripeCustomer
              stripeCustomerId
              sysId
              userSysId
              weight
            }
            status
            sysId
          }
          childrenOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            activeConsultation {
              countReminder
              createdAt
              doctorChatToken
              doctorSysId
              friendlyName
              gmeetLink
              isActive
              isRead
              isVideoConsultRescheduled
              lastMsgSysId
              lastMsgUserId
              orderSysId
              patientChatToken
              patientEmail
              prescribedAt
              previewVideoLink
              progressStatus
              readAt
              reviewDate
              status
              sysId
              textConsultStatus
              textConversationId
              type
              updatedAt
              videoChannelId
              videoLink
            }
            acuityAppointment {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            acuityAppointments {
              appointmentTypeID
              bookedAt
              calendar
              calendarID
              calendarJP
              canceled
              confirmationPage
              date
              dateCreated
              datetime
              duration
              email
              endTime
              firstName
              id
              isFollowUpConsult
              lastName
              noShow
              phone
              sysId
              time
              timezone
              type
            }
            additionalPrices {
              active
              billing_scheme
              created
              createdAt
              currency
              displayId
              firstTimeAlternativePrice
              firstTimeTryingInMonths
              id
              importPriceId
              isBundle
              livemode
              locale
              nickname
              product
              productId
              shopDisplay
              sysId
              tax_behavior
              type
              unit_amount
              unit_amount_decimal
              updatedAt
            }
            afterVideoConsultRedirecting {
              baseUrl
              path
            }
            approveAt
            atomeNextSendingInvoiceDate
            atomePayments {
              amount
              paymentUrl
              priceId
              referenceId
              status
              sysId
            }
            checkoutSession {
              checkoutData
              evaluationId
              status
              sysId
            }
            childrenOrders {
              ableToBookConsultSchedule
              ableToBookDeliverySchedule
              ableToChangeDeliverySchedule
              approveAt
              atomeNextSendingInvoiceDate
              claimedRetentionOffer
              consultationAudits(consultAuditFilterInput: $consultAuditFilterInput3) {
                consultTime
                consultType
                createdBy
                doctor {
                  active
                  calendarId
                  country
                  designation
                  duration
                  email
                  firstName
                  fullName
                  lastName
                  sysId
                  textConsultPostalCodes
                  trtEligible
                }
                evaluationId
                order {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                sessionType
                status
                sysId
              }
              consultations(inputConsultation: $inputConsultation4) {
                countReminder
                createdAt
                doctorChatToken
                doctorSysId
                friendlyName
                gmeetLink
                isActive
                isRead
                isVideoConsultRescheduled
                lastMsgSysId
                lastMsgUserId
                orderSysId
                patientChatToken
                patientEmail
                prescribedAt
                previewVideoLink
                progressStatus
                readAt
                reviewDate
                status
                sysId
                textConsultStatus
                textConversationId
                type
                updatedAt
                videoChannelId
                videoLink
              }
              continueTrial
              countTrialReminder
              country
              createFromSkipOrderId
              createdAt
              delivery
              deliveryAddress {
                address
                city
                country
                firstName
                lastName
                name
                note
                phoneNumber
                postal
                region
                sameAsBilling
                state
                sysId
                type
                unit
              }
              deliveryAddressSysId
              deliveryMethod
              deliverySnapshot
              deliveryStatus
              deliveryTimestamp
              doctorNotes
              doctorPrescriptionPriceIds
              dosage
              doseStartedAt
              evaluation {
                isCompleted
                isSkipped
                name
                patientAnswers {
                  answer {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  question {
                    answers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    dependentEvaluationQuestions {
                      skipPage
                      skipQuestionCount
                      sysId
                    }
                    displayPage
                    evaluationBlocks {
                      sysId
                    }
                    guestOnly
                    name
                    order
                    sysId
                    textKey
                    type
                    validation {
                      bmi
                      extra
                      max
                      min
                      preselect
                      type
                    }
                  }
                  type
                  value
                }
                patientNote
                platform
                questions {
                  answers {
                    childrenAnswers {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    deselectAll
                    mandatory
                    name
                    order
                    placeholder
                    productUrl
                    sysId
                    textKey
                    type
                  }
                  content {
                    body {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    footer {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                    header {
                      description
                      descriptionTextKey
                      title
                      titleTextKey
                    }
                  }
                  dependentEvaluationQuestions {
                    answer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    skipPage
                    skipQuestionCount
                    sysId
                  }
                  displayPage
                  evaluationBlocks {
                    blockAnswer {
                      deselectAll
                      mandatory
                      name
                      order
                      placeholder
                      productUrl
                      sysId
                      textKey
                      type
                    }
                    content {
                      description
                      descriptionTextKey
                      sysId
                      title
                      titleTextKey
                    }
                    sysId
                  }
                  guestOnly
                  name
                  order
                  sysId
                  textKey
                  type
                  validation {
                    bmi
                    extra
                    max
                    min
                    preselect
                    type
                  }
                }
                status
                sysId
                type
              }
              evaluationId
              expiredAt
              intakeInstructions
              isAtomeAutoRenewal
              isAutoRenewal
              isConsultOnly
              isEDTrial
              isEditingDeliveryWithin2Hours
              isOrderRenew
              isPacked
              isPendingFollowUpConsult
              isPrescriptionValid
              isSkipMedOrder
              isSkippedEval
              isSubscriptionPastDue
              isSubscriptionPaused
              lastPaymentDate
              lastShipmentDate
              latestAtomePayment {
                amount
                paymentUrl
                priceId
                referenceId
                status
                summary {
                  cashbackEarnRate
                  cashbackEarned
                  cashbackRedeemed
                  consultBasePrice
                  consultFee
                  consultFeeAfterDiscount
                  consultTax
                  consultTransactionFee
                  discountAmount
                  isConsult
                  mainBasePrice
                  mainTax
                  mainTransactionFee
                  minimalAmountPayment
                  paymentIntentAmount
                  paymentIntentAmountAfterCashback
                  paymentIntentSummary
                  priceId
                  productPriceAmount
                  productPriceAmountAfterDiscount
                  promotionCode
                  shouldChargeConsultFee
                  subTotal
                  total
                  totalAfterCashback
                }
                sysId
              }
              latestInvoice {
                amount_due
                hosted_invoice_url
                id
                lines {
                  data {
                    amount
                    discount
                    plan {
                      active
                      id
                      metadata
                    }
                  }
                }
                next_payment_attempt
                paid
                paymentStatus
                period_end
                starting_balance
                status
                subtotal
                tax
                total
                total_discount_amounts {
                  amount
                }
              }
              latestNote {
                author {
                  avatar
                  calendarDates(
                    acuityAppointmentId: $acuityAppointmentId4
                    date: $date8
                    forDelivery: $forDelivery4
                    isReschedule: $isReschedule4
                    orderId: $orderId5
                  ) {
                    date
                  }
                  calendarTimes(
                    acuityAppointmentId: $acuityAppointmentId5
                    consultDate: $consultDate2
                    date: $date9
                    forDelivery: $forDelivery5
                    isReschedule: $isReschedule5
                    orderId: $orderId6
                  ) {
                    time
                  }
                  consultation(input: $input16) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  consultationMessages(
                    input: $input17
                    limit: $limit8
                    offset: $offset8
                    order: $order7
                  ) {
                    count
                    limit
                    offset
                  }
                  consultations(input: $input18, limit: $limit9, offset: $offset9, order: $order8) {
                    countReminder
                    createdAt
                    doctorChatToken
                    doctorSysId
                    friendlyName
                    gmeetLink
                    isActive
                    isRead
                    isVideoConsultRescheduled
                    lastMsgSysId
                    lastMsgUserId
                    orderSysId
                    patientChatToken
                    patientEmail
                    prescribedAt
                    previewVideoLink
                    progressStatus
                    readAt
                    reviewDate
                    status
                    sysId
                    textConsultStatus
                    textConversationId
                    type
                    updatedAt
                    videoChannelId
                    videoLink
                  }
                  doctor(doctorFilterInput: $doctorFilterInput4) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  doctors(doctorFilterInput: $doctorFilterInput5) {
                    active
                    calendarId
                    country
                    designation
                    duration
                    email
                    firstName
                    fullName
                    lastName
                    sysId
                    textConsultPostalCodes
                    trtEligible
                  }
                  email
                  firstName
                  fullName
                  id
                  isPharmacist
                  lastName
                  locale
                  ninjaVanToken
                  orders(input: $input19, pagination: $pagination2) {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  partnerConsultDates(date: $date10) {
                    date
                  }
                  partnerConsultTimes(date: $date11) {
                    time
                  }
                  patient(input: $input20) {
                    bloodPressure
                    country
                    createdAt
                    dob
                    email
                    fbc
                    fbp
                    firstName
                    fromPlatformEnv
                    fullName
                    gender
                    height
                    icNumber
                    idVerifiedAt
                    identification
                    isAlreadyCheckout
                    isReferredBy
                    lastName
                    legalName
                    locale
                    mounjaroTrialEligible
                    paidCompletedEvaluationIds
                    phoneNumber
                    referralCode
                    stripeCustomer
                    stripeCustomerId
                    sysId
                    userSysId
                    weight
                  }
                  patientDocuments {
                    createdAt
                    orderSysId
                    ref
                    sysId
                    type
                    url
                  }
                  phoneNumber
                  prescriptionCalculation {
                    isAffiliateLocked
                    promotionCodeError
                    stripePromotionCode
                  }
                  requireConfirmPolicy
                  socialProviderType
                  stripeProducts(input: $input21) {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform13)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  sysId
                  tempToken
                  tempTokenExpired
                  userType
                  utmCampaign
                  utmId
                  utmMedium
                  utmSource
                }
                content
                createdAt
                createdBy
                sysId
                updatedAt
              }
              nextReviewDate
              oldPrice
              oldPriceInfo {
                active
                alternativePrice {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                billing_scheme
                created
                createdAt
                currency
                displayId
                firstTimeAlternativePrice
                firstTimeTryingInMonths
                id
                importPriceId
                isBundle
                livemode
                locale
                metadata {
                  actual_price_display
                  boxes
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  isArchived
                  isOneTimePrice
                  price_frequency
                  price_quantity
                  price_show
                  quantity
                  quantity_display
                  strength
                }
                nickname
                product
                productId
                productInfo {
                  active
                  country
                  createdAt
                  description
                  displayId
                  evaluationId
                  format
                  hasOneDosage
                  hasOneFrequency
                  id
                  ingredients
                  isConsultOnly(platform: $platform14)
                  isPopular
                  isRxOneTime
                  isShowOnShop
                  isSkipMedProduct
                  livemode
                  metadata
                  name
                  popularPriceId
                  shopProductGroupIds
                  shouldChargeNow
                  statementDescriptor
                  sysId
                  type
                  uniqName
                  unitLabel
                  updatedAt
                  usage
                }
                shopDisplay
                sysId
                tax_behavior
                texts {
                  actual_price_display
                  dosage
                  dosage_display
                  dosage_popular
                  frequency
                  frequency_actual_price_display
                  frequency_display
                  frequency_popular
                  frequency_price_display
                  frequency_quantity_display
                  frequency_quantity_display_patient
                  frequency_savings_display
                  frequency_strikeout_price_display
                  price_frequency
                  price_quantity
                  quantity
                  quantity_display
                }
                type
                unit_amount
                unit_amount_decimal
                updatedAt
              }
              oldStripePrescriptionId
              ops
              opsComment
              orderPrescriptionPriceId
              orderPriceId
              otherIntestedEvalIds
              partnerSysId
              patient {
                bloodPressure
                country
                createdAt
                dob
                email
                fbc
                fbp
                firstName
                fromPlatformEnv
                fullName
                gender
                height
                icNumber
                idVerifiedAt
                identification
                isAlreadyCheckout
                isReferredBy
                lastName
                legalName
                locale
                mounjaroTrialEligible
                paidCompletedEvaluationIds
                phoneNumber
                referralCode
                stripeCustomer
                stripeCustomerId
                sysId
                userSysId
                weight
              }
              patientId
              patientOrderNotes
              paymentIntentUrl
              paymentProvider
              paymentStatus
              phoneNumber
              pickupLocation {
                address
                area {
                  areaChildren {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaName
                  areaParent {
                    areaChildren {
                      areaName
                      areaType
                      sysId
                    }
                    areaName
                    areaParent {
                      areaName
                      areaType
                      sysId
                    }
                    areaType
                    pickupLocations {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    sysId
                  }
                  areaType
                  pickupLocations {
                    address
                    area {
                      areaName
                      areaType
                      sysId
                    }
                    city
                    isDisabled
                    officeName
                    officeNumber
                    openingHours
                    orders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    paymentProviders
                    phone
                    postalCode
                    region
                    state
                    subRegion
                    sysId
                    type
                    unit
                  }
                  sysId
                }
                city
                isDisabled
                officeName
                officeNumber
                openingHours
                orders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescriptionDisplayPriceId
                  prescriptionId
                  priceDisplayId
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  sysId
                  teleConsultProduct
                  updatedAt
                }
                paymentProviders
                phone
                postalCode
                region
                state
                subRegion
                sysId
                type
                unit
              }
              planStatus
              platformType
              prescribeAfterTeleConsult
              prescribedAfterTrialOrder {
                ableToBookConsultSchedule
                ableToBookDeliverySchedule
                ableToChangeDeliverySchedule
                activeConsultation {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                acuityAppointment {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                acuityAppointments {
                  appointmentTypeID
                  bookedAt
                  calendar
                  calendarID
                  calendarJP
                  canceled
                  confirmationPage
                  date
                  dateCreated
                  datetime
                  duration
                  email
                  endTime
                  firstName
                  id
                  isFollowUpConsult
                  lastName
                  noShow
                  phone
                  sysId
                  time
                  timezone
                  type
                }
                additionalPrices {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                afterVideoConsultRedirecting {
                  baseUrl
                  path
                }
                approveAt
                atomeNextSendingInvoiceDate
                atomePayments {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                checkoutSession {
                  checkoutData
                  evaluationId
                  status
                  sysId
                }
                childrenOrders {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescription {
                    approver {
                      avatar
                      email
                      firstName
                      fullName
                      id
                      isPharmacist
                      lastName
                      locale
                      ninjaVanToken
                      phoneNumber
                      requireConfirmPolicy
                      socialProviderType
                      sysId
                      tempToken
                      tempTokenExpired
                      userType
                      utmCampaign
                      utmId
                      utmMedium
                      utmSource
                    }
                    cancelled
                    createdAt
                    days
                    doctor {
                      active
                      calendarId
                      country
                      designation
                      duration
                      email
                      firstName
                      fullName
                      lastName
                      sysId
                      textConsultPostalCodes
                      trtEligible
                    }
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    priceIds
                    products {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform15)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform16)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    alternativePrice {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    metadata {
                      actual_price_display
                      boxes
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      isArchived
                      isOneTimePrice
                      price_frequency
                      price_quantity
                      price_show
                      quantity
                      quantity_display
                      strength
                    }
                    nickname
                    product
                    productId
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform17)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    shopDisplay
                    sysId
                    tax_behavior
                    texts {
                      actual_price_display
                      dosage
                      dosage_display
                      dosage_popular
                      frequency
                      frequency_actual_price_display
                      frequency_display
                      frequency_popular
                      frequency_price_display
                      frequency_quantity_display
                      frequency_quantity_display_patient
                      frequency_savings_display
                      frequency_strikeout_price_display
                      price_frequency
                      price_quantity
                      quantity
                      quantity_display
                    }
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform18)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    activeConsultation {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    acuityAppointment {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    acuityAppointments {
                      appointmentTypeID
                      bookedAt
                      calendar
                      calendarID
                      calendarJP
                      canceled
                      confirmationPage
                      date
                      dateCreated
                      datetime
                      duration
                      email
                      endTime
                      firstName
                      id
                      isFollowUpConsult
                      lastName
                      noShow
                      phone
                      sysId
                      time
                      timezone
                      type
                    }
                    additionalPrices {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    afterVideoConsultRedirecting {
                      baseUrl
                      path
                    }
                    approveAt
                    atomeNextSendingInvoiceDate
                    atomePayments {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    checkoutSession {
                      checkoutData
                      evaluationId
                      status
                      sysId
                    }
                    childrenOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    claimedRetentionOffer
                    consultationAudits(consultAuditFilterInput: $consultAuditFilterInput4) {
                      consultTime
                      consultType
                      createdBy
                      evaluationId
                      sessionType
                      status
                      sysId
                    }
                    consultations(inputConsultation: $inputConsultation5) {
                      countReminder
                      createdAt
                      doctorChatToken
                      doctorSysId
                      friendlyName
                      gmeetLink
                      isActive
                      isRead
                      isVideoConsultRescheduled
                      lastMsgSysId
                      lastMsgUserId
                      orderSysId
                      patientChatToken
                      patientEmail
                      prescribedAt
                      previewVideoLink
                      progressStatus
                      readAt
                      reviewDate
                      status
                      sysId
                      textConsultStatus
                      textConversationId
                      type
                      updatedAt
                      videoChannelId
                      videoLink
                    }
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddress {
                      address
                      city
                      country
                      firstName
                      lastName
                      name
                      note
                      phoneNumber
                      postal
                      region
                      sameAsBilling
                      state
                      sysId
                      type
                      unit
                    }
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluation {
                      isCompleted
                      isSkipped
                      name
                      patientNote
                      platform
                      status
                      sysId
                      type
                    }
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    latestAtomePayment {
                      amount
                      paymentUrl
                      priceId
                      referenceId
                      status
                      sysId
                    }
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latestNote {
                      content
                      createdAt
                      createdBy
                      sysId
                      updatedAt
                    }
                    nextReviewDate
                    oldPrice
                    oldPriceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patient {
                      bloodPressure
                      country
                      createdAt
                      dob
                      email
                      fbc
                      fbp
                      firstName
                      fromPlatformEnv
                      fullName
                      gender
                      height
                      icNumber
                      idVerifiedAt
                      identification
                      isAlreadyCheckout
                      isReferredBy
                      lastName
                      legalName
                      locale
                      mounjaroTrialEligible
                      paidCompletedEvaluationIds
                      phoneNumber
                      referralCode
                      stripeCustomer
                      stripeCustomerId
                      sysId
                      userSysId
                      weight
                    }
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    pickupLocation {
                      address
                      city
                      isDisabled
                      officeName
                      officeNumber
                      openingHours
                      paymentProviders
                      phone
                      postalCode
                      region
                      state
                      subRegion
                      sysId
                      type
                      unit
                    }
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribedAfterTrialOrder {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    prescribed_after_trial_order_sys_id
                    prescription {
                      cancelled
                      createdAt
                      days
                      doctorNotes
                      endDate
                      expiresAt
                      isFollowUp
                      notedDate
                      priceIds
                      startDate
                      status
                      sysId
                      treatmentCode
                      updatedAt
                    }
                    prescriptionDisplayPriceId
                    prescriptionId
                    prescriptionOrderCalculation {
                      cashbackEarnRate
                      cashbackEarned
                      cashbackRedeemed
                      consultBasePrice
                      consultFee
                      consultFeeAfterDiscount
                      consultTax
                      consultTransactionFee
                      discountAmount
                      isConsult
                      mainBasePrice
                      mainTax
                      mainTransactionFee
                      minimalAmountPayment
                      paymentIntentAmount
                      paymentIntentAmountAfterCashback
                      paymentIntentSummary
                      priceId
                      productPriceAmount
                      productPriceAmountAfterDiscount
                      promotionCode
                      shouldChargeConsultFee
                      subTotal
                      total
                      totalAfterCashback
                    }
                    price {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    priceDisplayId
                    priceInfo {
                      active
                      billing_scheme
                      created
                      createdAt
                      currency
                      displayId
                      firstTimeAlternativePrice
                      firstTimeTryingInMonths
                      id
                      importPriceId
                      isBundle
                      livemode
                      locale
                      nickname
                      product
                      productId
                      shopDisplay
                      sysId
                      tax_behavior
                      type
                      unit_amount
                      unit_amount_decimal
                      updatedAt
                    }
                    productInfo {
                      active
                      country
                      createdAt
                      description
                      displayId
                      evaluationId
                      format
                      hasOneDosage
                      hasOneFrequency
                      id
                      ingredients
                      isConsultOnly(platform: $platform19)
                      isPopular
                      isRxOneTime
                      isShowOnShop
                      isSkipMedProduct
                      livemode
                      metadata
                      name
                      popularPriceId
                      shopProductGroupIds
                      shouldChargeNow
                      statementDescriptor
                      sysId
                      type
                      uniqName
                      unitLabel
                      updatedAt
                      usage
                    }
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    siblingCrossSellOrders {
                      ableToBookConsultSchedule
                      ableToBookDeliverySchedule
                      ableToChangeDeliverySchedule
                      approveAt
                      atomeNextSendingInvoiceDate
                      claimedRetentionOffer
                      continueTrial
                      countTrialReminder
                      country
                      createFromSkipOrderId
                      createdAt
                      delivery
                      deliveryAddressSysId
                      deliveryMethod
                      deliverySnapshot
                      deliveryStatus
                      deliveryTimestamp
                      doctorNotes
                      doctorPrescriptionPriceIds
                      dosage
                      doseStartedAt
                      evaluationId
                      expiredAt
                      intakeInstructions
                      isAtomeAutoRenewal
                      isAutoRenewal
                      isConsultOnly
                      isEDTrial
                      isEditingDeliveryWithin2Hours
                      isOrderRenew
                      isPacked
                      isPendingFollowUpConsult
                      isPrescriptionValid
                      isSkipMedOrder
                      isSkippedEval
                      isSubscriptionPastDue
                      isSubscriptionPaused
                      lastPaymentDate
                      lastShipmentDate
                      nextReviewDate
                      oldPrice
                      oldStripePrescriptionId
                      ops
                      opsComment
                      orderPrescriptionPriceId
                      orderPriceId
                      otherIntestedEvalIds
                      partnerSysId
                      patientId
                      patientOrderNotes
                      paymentIntentUrl
                      paymentProvider
                      paymentStatus
                      phoneNumber
                      planStatus
                      platformType
                      prescribeAfterTeleConsult
                      prescribed_after_trial_order_sys_id
                      prescriptionDisplayPriceId
                      prescriptionId
                      priceDisplayId
                      productQuantity
                      promotionCode
                      rejectAt
                      reorderStatus
                      shortId
                      showInCurrentPlans
                      showInNotifications
                      showInPastPlans
                      status
                      stripePaymentIntentId
                      stripeSubscriptionId
                      sysId
                      teleConsultProduct
                      updatedAt
                    }
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    subscription {
                      cancel_at_period_end
                      current_period_end
                      current_period_start
                      default_payment_method
                      id
                      items
                      latest_invoice
                      metadata
                      pause_collection
                      pending_setup_intent
                      pending_update
                      status
                    }
                    sysId
                    teleConsultProduct
                    upcomingInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latestInvoice {
                      amount_due
                      hosted_invoice_url
                      id
                      next_payment_attempt
                      paid
                      paymentStatus
                      period_end
                      starting_balance
                      status
                      subtotal
                      tax
                      total
                    }
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                    total_discount_amounts {
                      amount
                    }
                  }
                  updatedAt
                }
                claimedRetentionOffer
                consultationAudits(consultAuditFilterInput: $consultAuditFilterInput5) {
                  consultTime
                  consultType
                  createdBy
                  evaluationId
                  sessionType
                  status
                  sysId
                }
                consultations(inputConsultation: $inputConsultation6) {
                  countReminder
                  createdAt
                  doctorChatToken
                  doctorSysId
                  friendlyName
                  gmeetLink
                  isActive
                  isRead
                  isVideoConsultRescheduled
                  lastMsgSysId
                  lastMsgUserId
                  orderSysId
                  patientChatToken
                  patientEmail
                  prescribedAt
                  previewVideoLink
                  progressStatus
                  readAt
                  reviewDate
                  status
                  sysId
                  textConsultStatus
                  textConversationId
                  type
                  updatedAt
                  videoChannelId
                  videoLink
                }
                continueTrial
                countTrialReminder
                country
                createFromSkipOrderId
                createdAt
                delivery
                deliveryAddress {
                  address
                  city
                  country
                  firstName
                  lastName
                  name
                  note
                  phoneNumber
                  postal
                  region
                  sameAsBilling
                  state
                  sysId
                  type
                  unit
                }
                deliveryAddressSysId
                deliveryMethod
                deliverySnapshot
                deliveryStatus
                deliveryTimestamp
                doctorNotes
                doctorPrescriptionPriceIds
                dosage
                doseStartedAt
                evaluation {
                  isCompleted
                  isSkipped
                  name
                  patientNote
                  platform
                  status
                  sysId
                  type
                }
                evaluationId
                expiredAt
                intakeInstructions
                isAtomeAutoRenewal
                isAutoRenewal
                isConsultOnly
                isEDTrial
                isEditingDeliveryWithin2Hours
                isOrderRenew
                isPacked
                isPendingFollowUpConsult
                isPrescriptionValid
                isSkipMedOrder
                isSkippedEval
                isSubscriptionPastDue
                isSubscriptionPaused
                lastPaymentDate
                lastShipmentDate
                latestAtomePayment {
                  amount
                  paymentUrl
                  priceId
                  referenceId
                  status
                  sysId
                }
                latestInvoice {
                  amount_due
                  hosted_invoice_url
                  id
                  next_payment_attempt
                  paid
                  paymentStatus
                  period_end
                  starting_balance
                  status
                  subtotal
                  tax
                  total
                }
                latestNote {
                  content
                  createdAt
                  createdBy
                  sysId
                  updatedAt
                }
                nextReviewDate
                oldPrice
                oldPriceInfo {
                  active
                  billing_scheme
                  created
                  createdAt
                  currency
                  displayId
                  firstTimeAlternativePrice
                  firstTimeTryingInMonths
                  id
                  importPriceId
                  isBundle
                  livemode
                  locale
                  nickname
                  product
                  productId
                  shopDisplay
                  sysId
                  tax_behavior
                  type
                  unit_amount
                  unit_amount_decimal
                  updatedAt
                }
                oldStripePrescriptionId
                ops
                opsComment
                orderPrescriptionPriceId
                orderPriceId
                otherIntestedEvalIds
                partnerSysId
                patient {
                  bloodPressure
                  country
                  createdAt
                  dob
                  email
                  fbc
                  fbp
                  firstName
                  fromPlatformEnv
                  fullName
                  gender
                  height
                  icNumber
                  idVerifiedAt
                  identification
                  isAlreadyCheckout
                  isReferredBy
                  lastName
                  legalName
                  locale
                  mounjaroTrialEligible
                  paidCompletedEvaluationIds
                  phoneNumber
                  referralCode
                  stripeCustomer
                  stripeCustomerId
                  sysId
                  userSysId
                  weight
                }
                patientId
                patientOrderNotes
                paymentIntentUrl
                paymentProvider
                paymentStatus
                phoneNumber
                pickupLocation {
                  address
                  city
                  isDisabled
                  officeName
                  officeNumber
                  openingHours
                  paymentProviders
                  phone
                  postalCode
                  region
                  state
                  subRegion
                  sysId
                  type
                  unit
                }
                planStatus
                platformType
                prescribeAfterTeleConsult
                prescribedAfterTrialOrder {
                  ableToBookConsultSchedule
                  ableToBookDeliverySchedule
                  ableToChangeDeliverySchedule
                  approveAt
                  atomeNextSendingInvoiceDate
                  claimedRetentionOffer
                  continueTrial
                  countTrialReminder
                  country
                  createFromSkipOrderId
                  createdAt
                  delivery
                  deliveryAddressSysId
                  deliveryMethod
                  deliverySnapshot
                  deliveryStatus
                  deliveryTimestamp
                  doctorNotes
                  doctorPrescriptionPriceIds
                  dosage
                  doseStartedAt
                  evaluationId
                  expiredAt
                  intakeInstructions
                  isAtomeAutoRenewal
                  isAutoRenewal
                  isConsultOnly
                  isEDTrial
                  isEditingDeliveryWithin2Hours
                  isOrderRenew
                  isPacked
                  isPendingFollowUpConsult
                  isPrescriptionValid
                  isSkipMedOrder
                  isSkippedEval
                  isSubscriptionPastDue
                  isSubscriptionPaused
                  lastPaymentDate
                  lastShipmentDate
                  nextReviewDate
                  oldPrice
                  oldStripePrescriptionId
                  ops
                  opsComment
                  orderPrescriptionPriceId
                  orderPriceId
                  otherIntestedEvalIds
                  partnerSysId
                  patientId
                  patientOrderNotes
                  paymentIntentUrl
                  paymentProvider
                  paymentStatus
                  phoneNumber
                  planStatus
                  platformType
                  prescribeAfterTeleConsult
                  prescribed_after_trial_order_sys_id
                  prescription {
                    cancelled
                    createdAt
                    days
                    doctorNotes
                    endDate
                    expiresAt
                    isFollowUp
                    notedDate
                    priceIds
                    startDate
                    status
                    sysId
                    treatmentCode
                    updatedAt
                  }
                  prescriptionDisplayPriceId
                  prescriptionId
                  prescriptionOrderCalculation {
                    cashbackEarnRate
                    cashbackEarned
                    cashbackRedeemed
                    consultBasePrice
                    consultFee
                    consultFeeAfterDiscount
                    consultTax
                    consultTransactionFee
                    discountAmount
                    isConsult
                    mainBasePrice
                    mainTax
                    mainTransactionFee
                    minimalAmountPayment
                    paymentIntentAmount
                    paymentIntentAmountAfterCashback
                    paymentIntentSummary
                    priceId
                    productPriceAmount
                    productPriceAmountAfterDiscount
                    promotionCode
                    shouldChargeConsultFee
                    subTotal
                    total
                    totalAfterCashback
                  }
                  price {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  priceDisplayId
                  priceInfo {
                    active
                    billing_scheme
                    created
                    createdAt
                    currency
                    displayId
                    firstTimeAlternativePrice
                    firstTimeTryingInMonths
                    id
                    importPriceId
                    isBundle
                    livemode
                    locale
                    nickname
                    product
                    productId
                    shopDisplay
                    sysId
                    tax_behavior
                    type
                    unit_amount
                    unit_amount_decimal
                    updatedAt
                  }
                  productInfo {
                    active
                    country
                    createdAt
                    description
                    displayId
                    evaluationId
                    format
                    hasOneDosage
                    hasOneFrequency
                    id
                    ingredients
                    isConsultOnly(platform: $platform20)
                    isPopular
                    isRxOneTime
                    isShowOnShop
                    isSkipMedProduct
                    livemode
                    metadata
                    name
                    popularPriceId
                    shopProductGroupIds
                    shouldChargeNow
                    statementDescriptor
                    sysId
                    type
                    uniqName
                    unitLabel
                    updatedAt
                    usage
                  }
                  productQuantity
                  promotionCode
                  rejectAt
                  reorderStatus
                  shortId
                  showInCurrentPlans
                  showInNotifications
                  showInPastPlans
                  siblingCrossSellOrders {
                    ableToBookConsultSchedule
                    ableToBookDeliverySchedule
                    ableToChangeDeliverySchedule
                    approveAt
                    atomeNextSendingInvoiceDate
                    claimedRetentionOffer
                    continueTrial
                    countTrialReminder
                    country
                    createFromSkipOrderId
                    createdAt
                    delivery
                    deliveryAddressSysId
                    deliveryMethod
                    deliverySnapshot
                    deliveryStatus
                    deliveryTimestamp
                    doctorNotes
                    doctorPrescriptionPriceIds
                    dosage
                    doseStartedAt
                    evaluationId
                    expiredAt
                    intakeInstructions
                    isAtomeAutoRenewal
                    isAutoRenewal
                    isConsultOnly
                    isEDTrial
                    isEditingDeliveryWithin2Hours
                    isOrderRenew
                    isPacked
                    isPendingFollowUpConsult
                    isPrescriptionValid
                    isSkipMedOrder
                    isSkippedEval
                    isSubscriptionPastDue
                    isSubscriptionPaused
                    lastPaymentDate
                    lastShipmentDate
                    nextReviewDate
                    oldPrice
                    oldStripePrescriptionId
                    ops
                    opsComment
                    orderPrescriptionPriceId
                    orderPriceId
                    otherIntestedEvalIds
                    partnerSysId
                    patientId
                    patientOrderNotes
                    paymentIntentUrl
                    paymentProvider
                    paymentStatus
                    phoneNumber
                    planStatus
                    platformType
                    prescribeAfterTeleConsult
                    prescribed_after_trial_order_sys_id
                    prescriptionDisplayPriceId
                    prescriptionId
                    priceDisplayId
                    productQuantity
                    promotionCode
                    rejectAt
                    reorderStatus
                    shortId
                    showInCurrentPlans
                    showInNotifications
                    showInPastPlans
                    status
                    stripePaymentIntentId
                    stripeSubscriptionId
                    sysId
                    teleConsultProduct
                    updatedAt
                  }
                  status
                  stripePaymentIntentId
                  stripeSubscriptionId
                  subscription {
                    cancel_at_period_end
                    current_period_end
                    current_period_start
                    default_payment_method
                    id
                    items
                    latest_invoice
                    metadata
                    pause_collection
                    pending_setup_intent
                    pending_update
                    status
                  }
                  sysId
                  teleConsultProduct
                  upcomingInvoice {
                    amount_due
                    hosted_invoice_url
                    id
                    next_payment_attempt
                    paid
                    paymentStatus
                    period_end
                    starting_balance
                    status
                    subtotal
                    tax
                    total
                  }
                  updatedAt
                }
                prescribed_after_trial_order_sys_id
                prescriptionDisplayPriceId
                prescriptionId
                priceDisplayId
                productQuantity
                promotionCode
                rejectAt
                reorderStatus
                shortId
                showInCurrentPlans
                showInNotifications
                showInPastPlans
                status
                stripePaymentIntentId
                stripeSubscriptionId
                sysId
                teleConsultProduct
                updatedAt
              }
              prescribed_after_trial_order_sys_id
              prescriptionDisplayPriceId
              prescriptionId
              priceDisplayId
              productQuantity
              promotionCode
              rejectAt
              reorderStatus
              shortId
              showInCurrentPlans
              showInNotifications
              showInPastPlans
              status
              stripePaymentIntentId
              stripeSubscriptionId
              sysId
              teleConsultProduct
              updatedAt
            }
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          claimedRetentionOffer
          consultationAudits(consultAuditFilterInput: $consultAuditFilterInput6) {
            consultTime
            consultType
            createdBy
            evaluationId
            sessionType
            status
            sysId
          }
          consultations(inputConsultation: $inputConsultation7) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluation {
            isCompleted
            isSkipped
            name
            patientNote
            platform
            status
            sysId
            type
          }
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          latestAtomePayment {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          latestInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          latestNote {
            content
            createdAt
            createdBy
            sysId
            updatedAt
          }
          nextReviewDate
          oldPrice
          oldPriceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          pickupLocation {
            address
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribedAfterTrialOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          prescribed_after_trial_order_sys_id
          prescription {
            cancelled
            createdAt
            days
            doctorNotes
            endDate
            expiresAt
            isFollowUp
            notedDate
            priceIds
            startDate
            status
            sysId
            treatmentCode
            updatedAt
          }
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          price {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          priceDisplayId
          priceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform21)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          siblingCrossSellOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          status
          stripePaymentIntentId
          stripeSubscriptionId
          subscription {
            cancel_at_period_end
            current_period_end
            current_period_start
            default_payment_method
            id
            items
            latest_invoice
            metadata
            pause_collection
            pending_setup_intent
            pending_update
            status
          }
          sysId
          teleConsultProduct
          upcomingInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          updatedAt
        }
        childOrderId
        createdAt
        createdBy
        creator {
          avatar
          calendarDates(
            acuityAppointmentId: $acuityAppointmentId6
            date: $date12
            forDelivery: $forDelivery6
            isReschedule: $isReschedule6
            orderId: $orderId7
          ) {
            date
          }
          calendarTimes(
            acuityAppointmentId: $acuityAppointmentId7
            consultDate: $consultDate3
            date: $date13
            forDelivery: $forDelivery7
            isReschedule: $isReschedule7
            orderId: $orderId8
          ) {
            time
          }
          consultation(input: $input22) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          consultationMessages(
            input: $input23
            limit: $limit10
            offset: $offset10
            order: $order9
          ) {
            count
            limit
            offset
          }
          consultations(
            input: $input24
            limit: $limit11
            offset: $offset11
            order: $order10
          ) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          doctor(doctorFilterInput: $doctorFilterInput6) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          doctors(doctorFilterInput: $doctorFilterInput7) {
            active
            calendarId
            country
            designation
            duration
            email
            firstName
            fullName
            lastName
            sysId
            textConsultPostalCodes
            trtEligible
          }
          email
          firstName
          fullName
          id
          isPharmacist
          lastName
          locale
          ninjaVanToken
          orders(input: $input25, pagination: $pagination3) {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          partnerConsultDates(date: $date14) {
            date
          }
          partnerConsultTimes(date: $date15) {
            time
          }
          patient(input: $input26) {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientDocuments {
            createdAt
            orderSysId
            ref
            sysId
            type
            url
          }
          phoneNumber
          prescriptionCalculation {
            isAffiliateLocked
            promotionCodeError
            stripePromotionCode
          }
          requireConfirmPolicy
          socialProviderType
          stripeProducts(input: $input27) {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform22)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          sysId
          tempToken
          tempTokenExpired
          userType
          utmCampaign
          utmId
          utmMedium
          utmSource
        }
        parentOrder {
          ableToBookConsultSchedule
          ableToBookDeliverySchedule
          ableToChangeDeliverySchedule
          activeConsultation {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          acuityAppointment {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          acuityAppointments {
            appointmentTypeID
            bookedAt
            calendar
            calendarID
            calendarJP
            canceled
            confirmationPage
            date
            dateCreated
            datetime
            duration
            email
            endTime
            firstName
            id
            isFollowUpConsult
            lastName
            noShow
            phone
            sysId
            time
            timezone
            type
          }
          additionalPrices {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          afterVideoConsultRedirecting {
            baseUrl
            path
          }
          approveAt
          atomeNextSendingInvoiceDate
          atomePayments {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          checkoutSession {
            checkoutData
            evaluationId
            status
            sysId
          }
          childrenOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          claimedRetentionOffer
          consultationAudits(consultAuditFilterInput: $consultAuditFilterInput7) {
            consultTime
            consultType
            createdBy
            evaluationId
            sessionType
            status
            sysId
          }
          consultations(inputConsultation: $inputConsultation8) {
            countReminder
            createdAt
            doctorChatToken
            doctorSysId
            friendlyName
            gmeetLink
            isActive
            isRead
            isVideoConsultRescheduled
            lastMsgSysId
            lastMsgUserId
            orderSysId
            patientChatToken
            patientEmail
            prescribedAt
            previewVideoLink
            progressStatus
            readAt
            reviewDate
            status
            sysId
            textConsultStatus
            textConversationId
            type
            updatedAt
            videoChannelId
            videoLink
          }
          continueTrial
          countTrialReminder
          country
          createFromSkipOrderId
          createdAt
          delivery
          deliveryAddress {
            address
            city
            country
            firstName
            lastName
            name
            note
            phoneNumber
            postal
            region
            sameAsBilling
            state
            sysId
            type
            unit
          }
          deliveryAddressSysId
          deliveryMethod
          deliverySnapshot
          deliveryStatus
          deliveryTimestamp
          doctorNotes
          doctorPrescriptionPriceIds
          dosage
          doseStartedAt
          evaluation {
            isCompleted
            isSkipped
            name
            patientNote
            platform
            status
            sysId
            type
          }
          evaluationId
          expiredAt
          intakeInstructions
          isAtomeAutoRenewal
          isAutoRenewal
          isConsultOnly
          isEDTrial
          isEditingDeliveryWithin2Hours
          isOrderRenew
          isPacked
          isPendingFollowUpConsult
          isPrescriptionValid
          isSkipMedOrder
          isSkippedEval
          isSubscriptionPastDue
          isSubscriptionPaused
          lastPaymentDate
          lastShipmentDate
          latestAtomePayment {
            amount
            paymentUrl
            priceId
            referenceId
            status
            sysId
          }
          latestInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          latestNote {
            content
            createdAt
            createdBy
            sysId
            updatedAt
          }
          nextReviewDate
          oldPrice
          oldPriceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          oldStripePrescriptionId
          ops
          opsComment
          orderPrescriptionPriceId
          orderPriceId
          otherIntestedEvalIds
          partnerSysId
          patient {
            bloodPressure
            country
            createdAt
            dob
            email
            fbc
            fbp
            firstName
            fromPlatformEnv
            fullName
            gender
            height
            icNumber
            idVerifiedAt
            identification
            isAlreadyCheckout
            isReferredBy
            lastName
            legalName
            locale
            mounjaroTrialEligible
            paidCompletedEvaluationIds
            phoneNumber
            referralCode
            stripeCustomer
            stripeCustomerId
            sysId
            userSysId
            weight
          }
          patientId
          patientOrderNotes
          paymentIntentUrl
          paymentProvider
          paymentStatus
          phoneNumber
          pickupLocation {
            address
            city
            isDisabled
            officeName
            officeNumber
            openingHours
            paymentProviders
            phone
            postalCode
            region
            state
            subRegion
            sysId
            type
            unit
          }
          planStatus
          platformType
          prescribeAfterTeleConsult
          prescribedAfterTrialOrder {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          prescribed_after_trial_order_sys_id
          prescription {
            cancelled
            createdAt
            days
            doctorNotes
            endDate
            expiresAt
            isFollowUp
            notedDate
            priceIds
            startDate
            status
            sysId
            treatmentCode
            updatedAt
          }
          prescriptionDisplayPriceId
          prescriptionId
          prescriptionOrderCalculation {
            cashbackEarnRate
            cashbackEarned
            cashbackRedeemed
            consultBasePrice
            consultFee
            consultFeeAfterDiscount
            consultTax
            consultTransactionFee
            discountAmount
            isConsult
            mainBasePrice
            mainTax
            mainTransactionFee
            minimalAmountPayment
            paymentIntentAmount
            paymentIntentAmountAfterCashback
            paymentIntentSummary
            priceId
            productPriceAmount
            productPriceAmountAfterDiscount
            promotionCode
            shouldChargeConsultFee
            subTotal
            total
            totalAfterCashback
          }
          price {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          priceDisplayId
          priceInfo {
            active
            billing_scheme
            created
            createdAt
            currency
            displayId
            firstTimeAlternativePrice
            firstTimeTryingInMonths
            id
            importPriceId
            isBundle
            livemode
            locale
            nickname
            product
            productId
            shopDisplay
            sysId
            tax_behavior
            type
            unit_amount
            unit_amount_decimal
            updatedAt
          }
          productInfo {
            active
            country
            createdAt
            description
            displayId
            evaluationId
            format
            hasOneDosage
            hasOneFrequency
            id
            ingredients
            isConsultOnly(platform: $platform23)
            isPopular
            isRxOneTime
            isShowOnShop
            isSkipMedProduct
            livemode
            metadata
            name
            popularPriceId
            shopProductGroupIds
            shouldChargeNow
            statementDescriptor
            sysId
            type
            uniqName
            unitLabel
            updatedAt
            usage
          }
          productQuantity
          promotionCode
          rejectAt
          reorderStatus
          shortId
          showInCurrentPlans
          showInNotifications
          showInPastPlans
          siblingCrossSellOrders {
            ableToBookConsultSchedule
            ableToBookDeliverySchedule
            ableToChangeDeliverySchedule
            approveAt
            atomeNextSendingInvoiceDate
            claimedRetentionOffer
            continueTrial
            countTrialReminder
            country
            createFromSkipOrderId
            createdAt
            delivery
            deliveryAddressSysId
            deliveryMethod
            deliverySnapshot
            deliveryStatus
            deliveryTimestamp
            doctorNotes
            doctorPrescriptionPriceIds
            dosage
            doseStartedAt
            evaluationId
            expiredAt
            intakeInstructions
            isAtomeAutoRenewal
            isAutoRenewal
            isConsultOnly
            isEDTrial
            isEditingDeliveryWithin2Hours
            isOrderRenew
            isPacked
            isPendingFollowUpConsult
            isPrescriptionValid
            isSkipMedOrder
            isSkippedEval
            isSubscriptionPastDue
            isSubscriptionPaused
            lastPaymentDate
            lastShipmentDate
            nextReviewDate
            oldPrice
            oldStripePrescriptionId
            ops
            opsComment
            orderPrescriptionPriceId
            orderPriceId
            otherIntestedEvalIds
            partnerSysId
            patientId
            patientOrderNotes
            paymentIntentUrl
            paymentProvider
            paymentStatus
            phoneNumber
            planStatus
            platformType
            prescribeAfterTeleConsult
            prescribed_after_trial_order_sys_id
            prescriptionDisplayPriceId
            prescriptionId
            priceDisplayId
            productQuantity
            promotionCode
            rejectAt
            reorderStatus
            shortId
            showInCurrentPlans
            showInNotifications
            showInPastPlans
            status
            stripePaymentIntentId
            stripeSubscriptionId
            sysId
            teleConsultProduct
            updatedAt
          }
          status
          stripePaymentIntentId
          stripeSubscriptionId
          subscription {
            cancel_at_period_end
            current_period_end
            current_period_start
            default_payment_method
            id
            items
            latest_invoice
            metadata
            pause_collection
            pending_setup_intent
            pending_update
            status
          }
          sysId
          teleConsultProduct
          upcomingInvoice {
            amount_due
            hosted_invoice_url
            id
            next_payment_attempt
            paid
            paymentStatus
            period_end
            starting_balance
            status
            subtotal
            tax
            total
          }
          updatedAt
        }
        parentOrderId
        priceId
        selectedBy
        stripeProductPrice {
          importPriceId
          isBundle
          priceActive
          priceBillingScheme
          priceCreated
          priceCurrency
          priceDisplayId
          priceFirstTimeAlternativePrice
          priceFirstTimeTryingInMonths
          priceId
          priceLivemode
          priceNickname
          priceProduct
          priceTaxBehavior
          priceUnitAmount
          priceUnitAmountDecimal
          productActive
          productDescription
          productDisplayId
          productId
          productLivemode
          productName
          productStatementDescriptor
          productType
          productUniqName
          productUnitLabel
          sysId
        }
        sysId
      }
    }
    avatar
    calendarDates(
      acuityAppointmentId: $acuityAppointmentId8
      date: $date16
      forDelivery: $forDelivery8
      isReschedule: $isReschedule8
      orderId: $orderId9
    ) {
      date
    }
    calendarTimes(
      acuityAppointmentId: $acuityAppointmentId9
      consultDate: $consultDate4
      date: $date17
      forDelivery: $forDelivery9
      isReschedule: $isReschedule9
      orderId: $orderId10
    ) {
      time
    }
    consultation(input: $input29) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    consultationMessages(
      input: $input30
      limit: $limit12
      offset: $offset12
      order: $order11
    ) {
      count
      limit
      offset
    }
    consultations(
      input: $input31
      limit: $limit13
      offset: $offset13
      order: $order12
    ) {
      countReminder
      createdAt
      doctorChatToken
      doctorSysId
      friendlyName
      gmeetLink
      isActive
      isRead
      isVideoConsultRescheduled
      lastMsgSysId
      lastMsgUserId
      orderSysId
      patientChatToken
      patientEmail
      prescribedAt
      previewVideoLink
      progressStatus
      readAt
      reviewDate
      status
      sysId
      textConsultStatus
      textConversationId
      type
      updatedAt
      videoChannelId
      videoLink
    }
    doctor(doctorFilterInput: $doctorFilterInput8) {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    doctors(doctorFilterInput: $doctorFilterInput9) {
      active
      calendarId
      country
      designation
      duration
      email
      firstName
      fullName
      lastName
      sysId
      textConsultPostalCodes
      trtEligible
    }
    email
    firstName
    fullName
    id
    isPharmacist
    lastName
    locale
    ninjaVanToken
    orders(input: $input32, pagination: $pagination4) {
      ableToBookConsultSchedule
      ableToBookDeliverySchedule
      ableToChangeDeliverySchedule
      approveAt
      atomeNextSendingInvoiceDate
      claimedRetentionOffer
      continueTrial
      countTrialReminder
      country
      createFromSkipOrderId
      createdAt
      delivery
      deliveryAddressSysId
      deliveryMethod
      deliverySnapshot
      deliveryStatus
      deliveryTimestamp
      doctorNotes
      doctorPrescriptionPriceIds
      dosage
      doseStartedAt
      evaluationId
      expiredAt
      intakeInstructions
      isAtomeAutoRenewal
      isAutoRenewal
      isConsultOnly
      isEDTrial
      isEditingDeliveryWithin2Hours
      isOrderRenew
      isPacked
      isPendingFollowUpConsult
      isPrescriptionValid
      isSkipMedOrder
      isSkippedEval
      isSubscriptionPastDue
      isSubscriptionPaused
      lastPaymentDate
      lastShipmentDate
      nextReviewDate
      oldPrice
      oldStripePrescriptionId
      ops
      opsComment
      orderPrescriptionPriceId
      orderPriceId
      otherIntestedEvalIds
      partnerSysId
      patientId
      patientOrderNotes
      paymentIntentUrl
      paymentProvider
      paymentStatus
      phoneNumber
      planStatus
      platformType
      prescribeAfterTeleConsult
      prescribed_after_trial_order_sys_id
      prescriptionDisplayPriceId
      prescriptionId
      priceDisplayId
      productQuantity
      promotionCode
      rejectAt
      reorderStatus
      shortId
      showInCurrentPlans
      showInNotifications
      showInPastPlans
      status
      stripePaymentIntentId
      stripeSubscriptionId
      sysId
      teleConsultProduct
      updatedAt
    }
    partnerConsultDates(date: $date18) {
      date
    }
    partnerConsultTimes(date: $date19) {
      time
    }
    patient(input: $input33) {
      bloodPressure
      country
      createdAt
      dob
      email
      fbc
      fbp
      firstName
      fromPlatformEnv
      fullName
      gender
      height
      icNumber
      idVerifiedAt
      identification
      isAlreadyCheckout
      isReferredBy
      lastName
      legalName
      locale
      mounjaroTrialEligible
      paidCompletedEvaluationIds
      phoneNumber
      referralCode
      stripeCustomer
      stripeCustomerId
      sysId
      userSysId
      weight
    }
    patientDocuments {
      createdAt
      orderSysId
      ref
      sysId
      type
      url
    }
    phoneNumber
    prescriptionCalculation {
      isAffiliateLocked
      promotionCodeError
      stripePromotionCode
    }
    requireConfirmPolicy
    socialProviderType
    stripeProducts(input: $input34) {
      active
      country
      createdAt
      description
      displayId
      evaluationId
      format
      hasOneDosage
      hasOneFrequency
      id
      ingredients
      isConsultOnly(platform: $platform24)
      isPopular
      isRxOneTime
      isShowOnShop
      isSkipMedProduct
      livemode
      metadata
      name
      popularPriceId
      shopProductGroupIds
      shouldChargeNow
      statementDescriptor
      sysId
      type
      uniqName
      unitLabel
      updatedAt
      usage
    }
    sysId
    tempToken
    tempTokenExpired
    userType
    utmCampaign
    utmId
    utmMedium
    utmSource
  }
}
    `;